import * as React from 'react';
import React__default, { useContext, useState, useRef, useEffect, useMemo, useCallback, createContext, forwardRef, createElement, Fragment as Fragment$1, memo, Children, useLayoutEffect, Suspense, isValidElement, cloneElement } from 'react';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import require$$1$1 from 'react-dom';
import { ComparisonDateUtils, LogicalConditions } from '@ac/library-utils/dist/utils/date';
import { isDefined, getSafeExternalContent } from '@ac/library-utils/dist/utils';
import { startsWithMatchNormalizedText, stringNormalize } from '@ac/library-utils/dist/utils/string';

function _typeof$2(obj) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$2(obj);
}

function _toPrimitive(input, hint) {
  if (_typeof$2(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof$2(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof$2(key) === "symbol" ? key : String(key);
}

function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _objectSpread$c(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    });
  }
  return target;
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck$1(this, Logger);

    this.init(concreteLogger, options);
  }

  _createClass(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread$c({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck$1(this, EventEmitter);

    this.observers = {};
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;
      if (typeof mix === 'string') return mix;
      if (p && typeof mix[p] === 'string') return mix[p];
      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  _inherits$1(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    _classCallCheck$1(this, ResourceStore);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf(ResourceStore).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  _createClass(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$c({}, pack, resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$c({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  _inherits$1(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck$1(this, Translator);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf(Translator).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  _createClass(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if (_typeof$2(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$c({}, options, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$c({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$c({}, options, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, fallbackValue) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$c({}, options, {
          interpolation: _objectSpread$c({}, this.options.interpolation, options.interpolation)
        }));
        var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$c({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$c({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck$1(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.supportedLngs || false;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  _createClass(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
      return this.isSupportedCode(code);
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck$1(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  _createClass(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      return this.getSuffixes(code).map(function (suffix) {
        return key + suffix;
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var rule = this.getRule(code);

      if (!rule) {
        return [];
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx];

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        };

        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck$1(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  _createClass(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$c({}, options, data, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$c({}, options, data, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          value = handleFormat(match[1].trim());

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += safeValue.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$c({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$c({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$c({}, options, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits$1(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck$1(this, Connector);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf(Connector).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  _createClass(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$c({}, options, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    whitelist: false,
    nonExplicitWhitelist: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (_typeof$2(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (_typeof$2(args[2]) === 'object' || _typeof$2(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: false
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.whitelist) {
    if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
      options.whitelist = options.whitelist.concat(['cimode']);
    }

    options.supportedLngs = options.whitelist;
  }

  if (options.nonExplicitWhitelist) {
    options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
  }

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function noop$1() {}

var I18n = function (_EventEmitter) {
  _inherits$1(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck$1(this, I18n);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf(I18n).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return _possibleConstructorReturn$1(_this, _assertThisInitialized(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  _createClass(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (options.whitelist && !options.supportedLngs) {
        this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
      }

      if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) {
        this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
      }

      this.options = _objectSpread$c({}, get(), this.options, transformOptions(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop$1;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop$1;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            _this4.language = l;
            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (_typeof$2(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$c({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        return _this5.t(key, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;

      var mergedOptions = _objectSpread$c({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$c({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages
      };
    }
  }]);

  return I18n;
}(EventEmitter);

var i18next = new I18n();

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$b(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true
};
var i18nInstance;
var I18nContext = React__default.createContext();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread$b(_objectSpread$b({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    _classCallCheck$1(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  _createClass(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};

function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest();
}

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$a(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = useContext(I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = _objectSpread$a(_objectSpread$a(_objectSpread$a({}, getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = useState(getT),
      _useState2 = _slicedToArray$1(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var isMounted = useRef(true);
  useEffect(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, namespaces.join()]);
  var isInitial = useRef(true);
  useEffect(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}

var sharableTranslations$c = {
	CANCEL: "Abbrechen",
	CONTINUE: "Fortsetzen",
	CONFIRM: "Bestätigen",
	ERROR_MESSAGE: "Irgendetwas ist schief gelaufen",
	CLEAR: "Löschen",
	PAGE_COUNTER: "Seite {{page}} von {{numberOfPages}}",
	SAVE: "Speichern"
};
var DatePickerField$d = {
	SELECT_DATE: "Auswahldatum",
	JAN: "Jan",
	FEB: "Feb",
	MAR: "Mär",
	APR: "Apr",
	MAY: "Mai",
	JUN: "Jun",
	JUL: "Juli",
	AUG: "Auc",
	SEP: "Sep",
	OCT: "Okt",
	NOV: "Nov",
	DEC: "Dez"
};
var SelectField$d = {
	START_SEARCHING: "Suche starten",
	NO_RESULTS: "Es gibt keine Ergebnisse",
	ALL: "Alle",
	SUGGESTED: "Vorgeschlagen"
};
var TimePickerField$d = {
	SELECT_TIME: "Uhrzeit auswählen",
	HOUR: "Stunde",
	MINUTE: "Minute"
};
var ErrorView$d = {
	CRITICAL_ERROR: "Kritischer Fehler!",
	REPORT_PROBLEM: "Bitte melden Sie das Problem"
};
var Footer$d = {
	BACK: "Zurück"
};
var TestEnvironmentBar$d = {
	TRAINING_ENVIRONMENT: "Training Environment"
};
var ConnectionModal$d = {
	WAKE_UP_YOUR_CONNECTION: "Reaktivieren Sie die Verbindung",
	NETWORK_UNREACHABLE: "Netzwerk nicht verfügbar"
};
var ErrorModal$d = {
	TRY_AGAIN: "Nochmals versuchen"
};
var InactivityModal$d = {
	YES: "Ja",
	ARE_YOU_THERE: "Sind Sie noch da?"
};
var LoadingModal$d = {
	LOADING: "Laden...",
	PLEASE_WAIT: "Bitte warten"
};
var FieldWrapper$d = {
	OPTIONAL: "Wahlfrei"
};
var LogsModal$d = {
	EXPORT: "Exportieren",
	LOG_MODAL_HEADER: "Log-Meldungen",
	NO_LOGS: "Es gibt keine Protokolle, die angezeigt werden können"
};
var ServiceModal$d = {
	HEADER: "Settings",
	USER_NAME: "User",
	PROPERTY_NAME: "Hotel",
	KPE_VERSION: "KPE-Version: {{version}}",
	OS_VERSION: "Betriebssystemversion: {{version}}",
	CLEAR_DATA: "Klare Daten",
	SHOW_ERROR_LOGS: "Fehlerprotokolle anzeigen",
	SHOW_AUTH_LOGS: "Authentifizierungsprotokolle anzeigen",
	DEBUG_MODE: "Debug",
	LOGOUT: "Logout"
};
var LanguageButtonGroup$d = {
	TITLE: "Language"
};
var LanguageSelector$d = {
	TITLE: "Sprache wählen"
};
var deTranslation = {
	sharableTranslations: sharableTranslations$c,
	DatePickerField: DatePickerField$d,
	SelectField: SelectField$d,
	TimePickerField: TimePickerField$d,
	ErrorView: ErrorView$d,
	Footer: Footer$d,
	TestEnvironmentBar: TestEnvironmentBar$d,
	ConnectionModal: ConnectionModal$d,
	ErrorModal: ErrorModal$d,
	InactivityModal: InactivityModal$d,
	LoadingModal: LoadingModal$d,
	FieldWrapper: FieldWrapper$d,
	LogsModal: LogsModal$d,
	ServiceModal: ServiceModal$d,
	LanguageButtonGroup: LanguageButtonGroup$d,
	LanguageSelector: LanguageSelector$d
};

var sharableTranslations$b = {
	CANCEL: "Cancelar",
	CONTINUE: "Continuar",
	CONFIRM: "Confirme",
	ERROR_MESSAGE: "Algo salió mal",
	CLEAR: "Borrar",
	PAGE_COUNTER: "Página {{page}} de {{numberOfPages}}",
	SAVE: "Guardar"
};
var DatePickerField$c = {
	SELECT_DATE: "Seleccione Fecha",
	JAN: "Ene",
	FEB: "Febrero",
	MAR: "Mar",
	APR: "Abr",
	MAY: "Mayo",
	JUN: "Jun",
	JUL: "Jul",
	AUG: "Ago",
	SEP: "Sep",
	OCT: "Oct",
	NOV: "Nov",
	DEC: "Dic"
};
var SelectField$c = {
	START_SEARCHING: "Inicie la búsqueda",
	NO_RESULTS: "No hay resultados",
	ALL: "Todo",
	SUGGESTED: "Sugerido"
};
var TimePickerField$c = {
	SELECT_TIME: "Seleccione Hora",
	HOUR: "Hora",
	MINUTE: "Minuto"
};
var ErrorView$c = {
	CRITICAL_ERROR: "Error crítico!",
	REPORT_PROBLEM: "Informe del problema"
};
var Footer$c = {
	BACK: "Atrás"
};
var TestEnvironmentBar$c = {
	TRAINING_ENVIRONMENT: "Training Environment"
};
var ConnectionModal$c = {
	WAKE_UP_YOUR_CONNECTION: "Activa tu conexión",
	NETWORK_UNREACHABLE: "No se puede acceder a la red"
};
var ErrorModal$c = {
	TRY_AGAIN: "Inténtelo de nuevo"
};
var InactivityModal$c = {
	YES: "Sí",
	ARE_YOU_THERE: "¿Todavía estás aquí?"
};
var LoadingModal$c = {
	LOADING: "Cargando...",
	PLEASE_WAIT: "Espere"
};
var FieldWrapper$c = {
	OPTIONAL: "Opcional"
};
var LogsModal$c = {
	EXPORT: "Exportar",
	LOG_MODAL_HEADER: "Registrar mensajes",
	NO_LOGS: "No hay registros para mostrar"
};
var ServiceModal$c = {
	HEADER: "Settings",
	USER_NAME: "User",
	PROPERTY_NAME: "Property",
	KPE_VERSION: "Versión de KPE: {{version}}",
	OS_VERSION: "Versión del sistema operativo: {{version}}",
	CLEAR_DATA: "Borrar datos",
	SHOW_ERROR_LOGS: "Mostrar registros de errores",
	SHOW_AUTH_LOGS: "Mostrar registros de autorización",
	DEBUG_MODE: "Debug",
	LOGOUT: "Logout"
};
var LanguageButtonGroup$c = {
	TITLE: "Language"
};
var LanguageSelector$c = {
	TITLE: "Choose language"
};
var esTranslation = {
	sharableTranslations: sharableTranslations$b,
	DatePickerField: DatePickerField$c,
	SelectField: SelectField$c,
	TimePickerField: TimePickerField$c,
	ErrorView: ErrorView$c,
	Footer: Footer$c,
	TestEnvironmentBar: TestEnvironmentBar$c,
	ConnectionModal: ConnectionModal$c,
	ErrorModal: ErrorModal$c,
	InactivityModal: InactivityModal$c,
	LoadingModal: LoadingModal$c,
	FieldWrapper: FieldWrapper$c,
	LogsModal: LogsModal$c,
	ServiceModal: ServiceModal$c,
	LanguageButtonGroup: LanguageButtonGroup$c,
	LanguageSelector: LanguageSelector$c
};

var sharableTranslations$a = {
	CANCEL: "Annuler",
	CONTINUE: "Continuer",
	CONFIRM: "Confirmer",
	ERROR_MESSAGE: "Quelque chose s’est mal passé",
	CLEAR: "Clair",
	PAGE_COUNTER: "page {{page}} de {{numberOfPages}}",
	SAVE: "Sauvegarder"
};
var DatePickerField$b = {
	SELECT_DATE: "Sélectionnez la date",
	JAN: "Avril",
	FEB: "Fév",
	MAR: "Mars",
	APR: "Avr",
	MAY: "Mai",
	JUN: "Juin",
	JUL: "Juil",
	AUG: "Août",
	SEP: "sept",
	OCT: "Opo",
	NOV: "Novembre",
	DEC: "Dec"
};
var SelectField$b = {
	START_SEARCHING: "Commencer la recherche",
	NO_RESULTS: "Il n’y a pas de résultats",
	ALL: "Tout",
	SUGGESTED: "Suggéré"
};
var TimePickerField$b = {
	SELECT_TIME: "Sélectionnez l’heure",
	HOUR: "Heure",
	MINUTE: "Minute"
};
var ErrorView$b = {
	CRITICAL_ERROR: "Erreur critique!",
	REPORT_PROBLEM: "Veuillez signaler le problème"
};
var Footer$b = {
	BACK: "Précédent"
};
var TestEnvironmentBar$b = {
	TRAINING_ENVIRONMENT: "Training Environment"
};
var ConnectionModal$b = {
	WAKE_UP_YOUR_CONNECTION: "Réveillez votre connexion",
	NETWORK_UNREACHABLE: "Réseau inaccessible"
};
var ErrorModal$b = {
	TRY_AGAIN: "Réessayez"
};
var InactivityModal$b = {
	YES: "Oui",
	ARE_YOU_THERE: "Êtes-vous toujours là?"
};
var LoadingModal$b = {
	LOADING: "Chargement...",
	PLEASE_WAIT: "Veuillez patienter"
};
var FieldWrapper$b = {
	OPTIONAL: "Optionnel"
};
var LogsModal$b = {
	EXPORT: "Exportation",
	LOG_MODAL_HEADER: "Messages de journal",
	NO_LOGS: "Il n’y a pas de journaux à afficher"
};
var ServiceModal$b = {
	HEADER: "Settings",
	USER_NAME: "User",
	PROPERTY_NAME: "Property",
	KPE_VERSION: "Version KPE : {{version}}",
	OS_VERSION: "Version du système d’exploitation : {{version}}",
	CLEAR_DATA: "Des données claires",
	SHOW_ERROR_LOGS: "Afficher les journaux d’erreurs",
	SHOW_AUTH_LOGS: "Afficher les journaux d’authentification",
	DEBUG_MODE: "Debug",
	LOGOUT: "Logout"
};
var LanguageButtonGroup$b = {
	TITLE: "Language"
};
var LanguageSelector$b = {
	TITLE: "Choose language"
};
var frTranslation = {
	sharableTranslations: sharableTranslations$a,
	DatePickerField: DatePickerField$b,
	SelectField: SelectField$b,
	TimePickerField: TimePickerField$b,
	ErrorView: ErrorView$b,
	Footer: Footer$b,
	TestEnvironmentBar: TestEnvironmentBar$b,
	ConnectionModal: ConnectionModal$b,
	ErrorModal: ErrorModal$b,
	InactivityModal: InactivityModal$b,
	LoadingModal: LoadingModal$b,
	FieldWrapper: FieldWrapper$b,
	LogsModal: LogsModal$b,
	ServiceModal: ServiceModal$b,
	LanguageButtonGroup: LanguageButtonGroup$b,
	LanguageSelector: LanguageSelector$b
};

var sharableTranslations$9 = {
	CANCEL: "Cancel",
	CONTINUE: "Continue",
	CONFIRM: "Confirm",
	ERROR_MESSAGE: "Something went wrong",
	CLEAR: "Clear",
	PAGE_COUNTER: "page {{page}} of {{numberOfPages}}",
	SAVE: "Save"
};
var DatePickerField$a = {
	SELECT_DATE: "Select Date",
	JAN: "Jan",
	FEB: "Feb",
	MAR: "Mar",
	APR: "Apr",
	MAY: "May",
	JUN: "Jun",
	JUL: "Jul",
	AUG: "Aug",
	SEP: "Sep",
	OCT: "Oct",
	NOV: "Nov",
	DEC: "Dec"
};
var SelectField$a = {
	START_SEARCHING: "Start searching",
	NO_RESULTS: "There are no results",
	ALL: "All",
	SUGGESTED: "Suggested"
};
var TimePickerField$a = {
	SELECT_TIME: "Select Time",
	HOUR: "Hour",
	MINUTE: "Minute"
};
var ErrorView$a = {
	CRITICAL_ERROR: "Critical Error!",
	REPORT_PROBLEM: "Please report the problem"
};
var Footer$a = {
	BACK: "Back"
};
var TestEnvironmentBar$a = {
	TRAINING_ENVIRONMENT: "Training Environment"
};
var ConnectionModal$a = {
	WAKE_UP_YOUR_CONNECTION: "Wake up your connection",
	NETWORK_UNREACHABLE: "Network unreachable"
};
var ErrorModal$a = {
	TRY_AGAIN: "Try again"
};
var InactivityModal$a = {
	YES: "Yes",
	ARE_YOU_THERE: "Are you still here?"
};
var LoadingModal$a = {
	LOADING: "Loading...",
	PLEASE_WAIT: "Please Wait"
};
var FieldWrapper$a = {
	OPTIONAL: "Optional"
};
var LogsModal$a = {
	EXPORT: "Export",
	LOG_MODAL_HEADER: "Log Messages",
	NO_LOGS: "There are no logs to display"
};
var ServiceModal$a = {
	HEADER: "Settings",
	USER_NAME: "User",
	PROPERTY_NAME: "Property",
	KPE_VERSION: "KPE version: {{version}}",
	OS_VERSION: "OS version: {{version}}",
	CLEAR_DATA: "Clear data",
	SHOW_ERROR_LOGS: "Show Error Logs",
	SHOW_AUTH_LOGS: "Show Auth Logs",
	DEBUG_MODE: "Debug",
	LOGOUT: "Logout"
};
var LanguageButtonGroup$a = {
	TITLE: "Language"
};
var LanguageSelector$a = {
	TITLE: "Choose language"
};
var itTranslation = {
	sharableTranslations: sharableTranslations$9,
	DatePickerField: DatePickerField$a,
	SelectField: SelectField$a,
	TimePickerField: TimePickerField$a,
	ErrorView: ErrorView$a,
	Footer: Footer$a,
	TestEnvironmentBar: TestEnvironmentBar$a,
	ConnectionModal: ConnectionModal$a,
	ErrorModal: ErrorModal$a,
	InactivityModal: InactivityModal$a,
	LoadingModal: LoadingModal$a,
	FieldWrapper: FieldWrapper$a,
	LogsModal: LogsModal$a,
	ServiceModal: ServiceModal$a,
	LanguageButtonGroup: LanguageButtonGroup$a,
	LanguageSelector: LanguageSelector$a
};

var sharableTranslations$8 = {
	CANCEL: "キャンセル",
	CONTINUE: "続行する",
	CONFIRM: "確認する",
	ERROR_MESSAGE: "なにか間違っています",
	CLEAR: "クリア",
	PAGE_COUNTER: "{{page}}ページ中の {{numberOfPages}}",
	SAVE: "保存"
};
var DatePickerField$9 = {
	SELECT_DATE: "日付選択",
	JAN: "1月",
	FEB: "2月",
	MAR: "3月",
	APR: "4月",
	MAY: "5月",
	JUN: "6月",
	JUL: "7月",
	AUG: "8月",
	SEP: "9月",
	OCT: "10月",
	NOV: "11月",
	DEC: "12月"
};
var SelectField$9 = {
	START_SEARCHING: "検索開始",
	NO_RESULTS: "結果はありません",
	ALL: "全て",
	SUGGESTED: "提案する"
};
var TimePickerField$9 = {
	SELECT_TIME: "タイプ選択",
	HOUR: "時",
	MINUTE: "分"
};
var ErrorView$9 = {
	CRITICAL_ERROR: "重大エラー!",
	REPORT_PROBLEM: "不具合を報告してください"
};
var Footer$9 = {
	BACK: "戻る"
};
var TestEnvironmentBar$9 = {
	TRAINING_ENVIRONMENT: "Training Environment"
};
var ConnectionModal$9 = {
	WAKE_UP_YOUR_CONNECTION: "接続を起動してください",
	NETWORK_UNREACHABLE: "ネットワークに接続できません"
};
var ErrorModal$9 = {
	TRY_AGAIN: "再試行"
};
var InactivityModal$9 = {
	YES: "はい",
	ARE_YOU_THERE: "まだここにいますか？"
};
var LoadingModal$9 = {
	LOADING: "ロード中...",
	PLEASE_WAIT: "お待ちください"
};
var FieldWrapper$9 = {
	OPTIONAL: "任意"
};
var LogsModal$9 = {
	EXPORT: "エクスポート",
	LOG_MODAL_HEADER: "メッセージを記入する",
	NO_LOGS: "表示するログがありません"
};
var ServiceModal$9 = {
	HEADER: "Settings",
	USER_NAME: "User",
	PROPERTY_NAME: "Property",
	KPE_VERSION: "KPE version: {{version}}",
	OS_VERSION: "OS version: {{version}}",
	CLEAR_DATA: "データクリア",
	SHOW_ERROR_LOGS: "エラーログを表示",
	SHOW_AUTH_LOGS: "Auth Logs表示",
	DEBUG_MODE: "Debug",
	LOGOUT: "ログアウト"
};
var LanguageButtonGroup$9 = {
	TITLE: "Language"
};
var LanguageSelector$9 = {
	TITLE: "言語選択"
};
var jaTranslation = {
	sharableTranslations: sharableTranslations$8,
	DatePickerField: DatePickerField$9,
	SelectField: SelectField$9,
	TimePickerField: TimePickerField$9,
	ErrorView: ErrorView$9,
	Footer: Footer$9,
	TestEnvironmentBar: TestEnvironmentBar$9,
	ConnectionModal: ConnectionModal$9,
	ErrorModal: ErrorModal$9,
	InactivityModal: InactivityModal$9,
	LoadingModal: LoadingModal$9,
	FieldWrapper: FieldWrapper$9,
	LogsModal: LogsModal$9,
	ServiceModal: ServiceModal$9,
	LanguageButtonGroup: LanguageButtonGroup$9,
	LanguageSelector: LanguageSelector$9
};

var sharableTranslations$7 = {
	CANCEL: "Cancel",
	CONTINUE: "Continue",
	CONFIRM: "Confirm",
	ERROR_MESSAGE: "Something went wrong",
	CLEAR: "Clear",
	PAGE_COUNTER: "page {{page}} of {{numberOfPages}}",
	SAVE: "Save"
};
var DatePickerField$8 = {
	SELECT_DATE: "Select Date",
	JAN: "Jan",
	FEB: "Feb",
	MAR: "Mar",
	APR: "Apr",
	MAY: "May",
	JUN: "Jun",
	JUL: "Jul",
	AUG: "Aug",
	SEP: "Sep",
	OCT: "Oct",
	NOV: "Nov",
	DEC: "Dec"
};
var SelectField$8 = {
	START_SEARCHING: "Start searching",
	NO_RESULTS: "There are no results",
	ALL: "All",
	SUGGESTED: "Suggested"
};
var TimePickerField$8 = {
	SELECT_TIME: "Select Time",
	HOUR: "Hour",
	MINUTE: "Minute"
};
var ErrorView$8 = {
	CRITICAL_ERROR: "Critical Error!",
	REPORT_PROBLEM: "Please report the problem"
};
var Footer$8 = {
	BACK: "Back"
};
var TestEnvironmentBar$8 = {
	TRAINING_ENVIRONMENT: "Training Environment"
};
var ConnectionModal$8 = {
	WAKE_UP_YOUR_CONNECTION: "Wake up your connection",
	NETWORK_UNREACHABLE: "Network unreachable"
};
var ErrorModal$8 = {
	TRY_AGAIN: "Try again"
};
var InactivityModal$8 = {
	YES: "Yes",
	ARE_YOU_THERE: "Are you still here?"
};
var LoadingModal$8 = {
	LOADING: "Loading...",
	PLEASE_WAIT: "Please Wait"
};
var FieldWrapper$8 = {
	OPTIONAL: "Optional"
};
var LogsModal$8 = {
	EXPORT: "Export",
	LOG_MODAL_HEADER: "Log Messages",
	NO_LOGS: "There are no logs to display"
};
var ServiceModal$8 = {
	HEADER: "Settings",
	USER_NAME: "User",
	PROPERTY_NAME: "Property",
	KPE_VERSION: "KPE version: {{version}}",
	OS_VERSION: "OS version: {{version}}",
	CLEAR_DATA: "Clear data",
	SHOW_ERROR_LOGS: "Show Error Logs",
	SHOW_AUTH_LOGS: "Show Auth Logs",
	DEBUG_MODE: "Debug",
	LOGOUT: "Logout"
};
var LanguageButtonGroup$8 = {
	TITLE: "Language"
};
var LanguageSelector$8 = {
	TITLE: "Choose language"
};
var enTranslation = {
	sharableTranslations: sharableTranslations$7,
	DatePickerField: DatePickerField$8,
	SelectField: SelectField$8,
	TimePickerField: TimePickerField$8,
	ErrorView: ErrorView$8,
	Footer: Footer$8,
	TestEnvironmentBar: TestEnvironmentBar$8,
	ConnectionModal: ConnectionModal$8,
	ErrorModal: ErrorModal$8,
	InactivityModal: InactivityModal$8,
	LoadingModal: LoadingModal$8,
	FieldWrapper: FieldWrapper$8,
	LogsModal: LogsModal$8,
	ServiceModal: ServiceModal$8,
	LanguageButtonGroup: LanguageButtonGroup$8,
	LanguageSelector: LanguageSelector$8
};

var sharableTranslations$6 = {
	CANCEL: "취소",
	CONTINUE: "계속",
	CONFIRM: "확인",
	ERROR_MESSAGE: "문제가 발생했습니다.",
	CLEAR: "초기화",
	PAGE_COUNTER: "{{numberOfPages}}페이지 중 {{page}}",
	SAVE: "저장"
};
var DatePickerField$7 = {
	SELECT_DATE: "날짜 선택",
	JAN: "1월",
	FEB: "2월",
	MAR: "3월",
	APR: "4월",
	MAY: "5월",
	JUN: "6월",
	JUL: "7월",
	AUG: "8월",
	SEP: "9월",
	OCT: "10월",
	NOV: "11월",
	DEC: "12월"
};
var SelectField$7 = {
	START_SEARCHING: "검색 시작",
	NO_RESULTS: "결과가 없습니다.",
	ALL: "모든",
	SUGGESTED: "제안"
};
var TimePickerField$7 = {
	SELECT_TIME: "시간 선택",
	HOUR: "시간",
	MINUTE: "분"
};
var ErrorView$7 = {
	CRITICAL_ERROR: "치명적 오류!",
	REPORT_PROBLEM: "문제를 보고하십시오"
};
var Footer$7 = {
	BACK: "뒤"
};
var TestEnvironmentBar$7 = {
	TRAINING_ENVIRONMENT: "Training Environment"
};
var ConnectionModal$7 = {
	WAKE_UP_YOUR_CONNECTION: "연결 상태를 해제하십시오.",
	NETWORK_UNREACHABLE: "네트워크에 연결할 수 없음"
};
var ErrorModal$7 = {
	TRY_AGAIN: "다시 시도"
};
var InactivityModal$7 = {
	YES: "예",
	ARE_YOU_THERE: "아직 계신가요?"
};
var LoadingModal$7 = {
	LOADING: "로딩중...",
	PLEASE_WAIT: "기다려주세요"
};
var FieldWrapper$7 = {
	OPTIONAL: "선택지"
};
var LogsModal$7 = {
	EXPORT: "내보내기",
	LOG_MODAL_HEADER: "로그 메시지",
	NO_LOGS: "표시할 로그가 없습니다."
};
var ServiceModal$7 = {
	HEADER: "설정",
	USER_NAME: "사용자",
	PROPERTY_NAME: "Property",
	KPE_VERSION: "KPE 버전: {{version}}",
	OS_VERSION: "OS 버전: {{version}}",
	CLEAR_DATA: "데이터 초기화",
	SHOW_ERROR_LOGS: "오류 로그 표시",
	SHOW_AUTH_LOGS: "인증 로그 표시",
	DEBUG_MODE: "디버그",
	LOGOUT: "Logout"
};
var LanguageButtonGroup$7 = {
	TITLE: "Language"
};
var LanguageSelector$7 = {
	TITLE: "언어 선택"
};
var koTranslation = {
	sharableTranslations: sharableTranslations$6,
	DatePickerField: DatePickerField$7,
	SelectField: SelectField$7,
	TimePickerField: TimePickerField$7,
	ErrorView: ErrorView$7,
	Footer: Footer$7,
	TestEnvironmentBar: TestEnvironmentBar$7,
	ConnectionModal: ConnectionModal$7,
	ErrorModal: ErrorModal$7,
	InactivityModal: InactivityModal$7,
	LoadingModal: LoadingModal$7,
	FieldWrapper: FieldWrapper$7,
	LogsModal: LogsModal$7,
	ServiceModal: ServiceModal$7,
	LanguageButtonGroup: LanguageButtonGroup$7,
	LanguageSelector: LanguageSelector$7
};

var sharableTranslations$5 = {
	CANCEL: "Annuleren",
	CONTINUE: "Doorgaan",
	CONFIRM: "Bevestigen",
	ERROR_MESSAGE: "Er is iets misgegaan",
	CLEAR: "Wissen",
	PAGE_COUNTER: "pagina {{page}} van {{numberOfPages}}",
	SAVE: "Opslaan"
};
var DatePickerField$6 = {
	SELECT_DATE: "Datum selecteren",
	JAN: "Jan",
	FEB: "Feb",
	MAR: "Maa",
	APR: "Apr",
	MAY: "Mei",
	JUN: "Jun",
	JUL: "Jul",
	AUG: "Aug",
	SEP: "Sep",
	OCT: "Okt",
	NOV: "Nov",
	DEC: "Dec"
};
var SelectField$6 = {
	START_SEARCHING: "Zoeken starten",
	NO_RESULTS: "Er zijn geen resultaten",
	ALL: "Alle",
	SUGGESTED: "Voorgesteld"
};
var TimePickerField$6 = {
	SELECT_TIME: "Tijd selecteren",
	HOUR: "Uur",
	MINUTE: "Minuut"
};
var ErrorView$6 = {
	CRITICAL_ERROR: "Kritieke fout!",
	REPORT_PROBLEM: "Rapporteer het probleem"
};
var Footer$6 = {
	BACK: "Terug"
};
var TestEnvironmentBar$6 = {
	TRAINING_ENVIRONMENT: "Training Environment"
};
var ConnectionModal$6 = {
	WAKE_UP_YOUR_CONNECTION: "Uw verbinding activeren",
	NETWORK_UNREACHABLE: "Netwerk onbereikbaar"
};
var ErrorModal$6 = {
	TRY_AGAIN: "Opnieuw proberen"
};
var InactivityModal$6 = {
	YES: "Ja",
	ARE_YOU_THERE: "Bent u nog steeds hier?"
};
var LoadingModal$6 = {
	LOADING: "Laden...",
	PLEASE_WAIT: "Een ogenblik geduld"
};
var FieldWrapper$6 = {
	OPTIONAL: "Optioneel"
};
var LogsModal$6 = {
	EXPORT: "Exporteren",
	LOG_MODAL_HEADER: "Logberichten",
	NO_LOGS: "Er zijn geen logs om weer te geven"
};
var ServiceModal$6 = {
	HEADER: "Instellingen",
	USER_NAME: "Gebruiker",
	PROPERTY_NAME: "Eigendom",
	KPE_VERSION: "KPE-versie: {{version}}",
	OS_VERSION: "Besturingssysteemversie: {{version}}",
	CLEAR_DATA: "Gegevens wissen",
	SHOW_ERROR_LOGS: "Foutenlogs weergeven",
	SHOW_AUTH_LOGS: "Autorisatielogs weergeven",
	DEBUG_MODE: "Foutopsporing",
	LOGOUT: "Uitloggen"
};
var LanguageButtonGroup$6 = {
	TITLE: "Language"
};
var LanguageSelector$6 = {
	TITLE: "Taal kiezen"
};
var nlTranslation = {
	sharableTranslations: sharableTranslations$5,
	DatePickerField: DatePickerField$6,
	SelectField: SelectField$6,
	TimePickerField: TimePickerField$6,
	ErrorView: ErrorView$6,
	Footer: Footer$6,
	TestEnvironmentBar: TestEnvironmentBar$6,
	ConnectionModal: ConnectionModal$6,
	ErrorModal: ErrorModal$6,
	InactivityModal: InactivityModal$6,
	LoadingModal: LoadingModal$6,
	FieldWrapper: FieldWrapper$6,
	LogsModal: LogsModal$6,
	ServiceModal: ServiceModal$6,
	LanguageButtonGroup: LanguageButtonGroup$6,
	LanguageSelector: LanguageSelector$6
};

var sharableTranslations$4 = {
	CANCEL: "Anuluj",
	CONTINUE: "Kontynuować",
	CONFIRM: "Potwierdzić",
	ERROR_MESSAGE: "Coś poszło nie tak",
	CLEAR: "Jasny",
	PAGE_COUNTER: "strona {{page}} z {{numberOfPages}}",
	SAVE: "Zapisać"
};
var DatePickerField$5 = {
	SELECT_DATE: "Wybierz datę",
	JAN: "Jan",
	FEB: "Lut",
	MAR: "Marzec",
	APR: "Kwiecień",
	MAY: "Maj",
	JUN: "Cze",
	JUL: "Lip",
	AUG: "Sie",
	SEP: "Września",
	OCT: "Paź",
	NOV: "Lis",
	DEC: "Grudzień"
};
var SelectField$5 = {
	START_SEARCHING: "Rozpocznij wyszukiwanie",
	NO_RESULTS: "Brak wyników",
	ALL: "Cały",
	SUGGESTED: "Sugerowane"
};
var TimePickerField$5 = {
	SELECT_TIME: "Wybierz czas",
	HOUR: "Godzina",
	MINUTE: "Minuta"
};
var ErrorView$5 = {
	CRITICAL_ERROR: "Błąd krytyczny!",
	REPORT_PROBLEM: "Zgłoś problem"
};
var Footer$5 = {
	BACK: "Wstecz"
};
var TestEnvironmentBar$5 = {
	TRAINING_ENVIRONMENT: "Training Environment"
};
var ConnectionModal$5 = {
	WAKE_UP_YOUR_CONNECTION: "Wybudzanie połączenia",
	NETWORK_UNREACHABLE: "Sieć nieosiągalna"
};
var ErrorModal$5 = {
	TRY_AGAIN: "Spróbuj ponownie"
};
var InactivityModal$5 = {
	YES: "Tak",
	ARE_YOU_THERE: "Czy nadal tu jesteś?"
};
var LoadingModal$5 = {
	LOADING: "Ładowania...",
	PLEASE_WAIT: "Czekaj"
};
var FieldWrapper$5 = {
	OPTIONAL: "Fakultatywny"
};
var LogsModal$5 = {
	EXPORT: "Eksport",
	LOG_MODAL_HEADER: "Komunikaty dziennika",
	NO_LOGS: "Nie ma żadnych dzienników do wyświetlenia"
};
var ServiceModal$5 = {
	HEADER: "Settings",
	USER_NAME: "User",
	PROPERTY_NAME: "Property",
	KPE_VERSION: "Wersja KPE: {{version}}",
	OS_VERSION: "Wersja systemu operacyjnego: {{version}}",
	CLEAR_DATA: "Wyczyść dane",
	SHOW_ERROR_LOGS: "Pokaż dzienniki błędów",
	SHOW_AUTH_LOGS: "Pokaż dzienniki uwierzytelniania",
	DEBUG_MODE: "Debug",
	LOGOUT: "Logout"
};
var LanguageButtonGroup$5 = {
	TITLE: "Language"
};
var LanguageSelector$5 = {
	TITLE: "Choose language"
};
var plTranslation = {
	sharableTranslations: sharableTranslations$4,
	DatePickerField: DatePickerField$5,
	SelectField: SelectField$5,
	TimePickerField: TimePickerField$5,
	ErrorView: ErrorView$5,
	Footer: Footer$5,
	TestEnvironmentBar: TestEnvironmentBar$5,
	ConnectionModal: ConnectionModal$5,
	ErrorModal: ErrorModal$5,
	InactivityModal: InactivityModal$5,
	LoadingModal: LoadingModal$5,
	FieldWrapper: FieldWrapper$5,
	LogsModal: LogsModal$5,
	ServiceModal: ServiceModal$5,
	LanguageButtonGroup: LanguageButtonGroup$5,
	LanguageSelector: LanguageSelector$5
};

var sharableTranslations$3 = {
	CANCEL: "Cancel",
	CONTINUE: "Continue",
	CONFIRM: "Confirm",
	ERROR_MESSAGE: "Something went wrong",
	CLEAR: "Clear",
	PAGE_COUNTER: "page {{page}} of {{numberOfPages}}",
	SAVE: "Save"
};
var DatePickerField$4 = {
	SELECT_DATE: "Select Date",
	JAN: "Jan",
	FEB: "Feb",
	MAR: "Mar",
	APR: "Apr",
	MAY: "May",
	JUN: "Jun",
	JUL: "Jul",
	AUG: "Aug",
	SEP: "Sep",
	OCT: "Oct",
	NOV: "Nov",
	DEC: "Dec"
};
var SelectField$4 = {
	START_SEARCHING: "Start searching",
	NO_RESULTS: "There are no results",
	ALL: "All",
	SUGGESTED: "Suggested"
};
var TimePickerField$4 = {
	SELECT_TIME: "Select Time",
	HOUR: "Hour",
	MINUTE: "Minute"
};
var ErrorView$4 = {
	CRITICAL_ERROR: "Critical Error!",
	REPORT_PROBLEM: "Please report the problem"
};
var Footer$4 = {
	BACK: "Back"
};
var TestEnvironmentBar$4 = {
	TRAINING_ENVIRONMENT: "Training Environment"
};
var ConnectionModal$4 = {
	WAKE_UP_YOUR_CONNECTION: "Wake up your connection",
	NETWORK_UNREACHABLE: "Network unreachable"
};
var ErrorModal$4 = {
	TRY_AGAIN: "Try again"
};
var InactivityModal$4 = {
	YES: "Yes",
	ARE_YOU_THERE: "Are you still here?"
};
var LoadingModal$4 = {
	LOADING: "Loading...",
	PLEASE_WAIT: "Please Wait"
};
var FieldWrapper$4 = {
	OPTIONAL: "Optional"
};
var LogsModal$4 = {
	EXPORT: "Export",
	LOG_MODAL_HEADER: "Log Messages",
	NO_LOGS: "There are no logs to display"
};
var ServiceModal$4 = {
	HEADER: "Settings",
	USER_NAME: "User",
	PROPERTY_NAME: "Property",
	KPE_VERSION: "KPE version: {{version}}",
	OS_VERSION: "OS version: {{version}}",
	CLEAR_DATA: "Clear data",
	SHOW_ERROR_LOGS: "Show Error Logs",
	SHOW_AUTH_LOGS: "Show Auth Logs",
	DEBUG_MODE: "Debug",
	LOGOUT: "Logout"
};
var LanguageButtonGroup$4 = {
	TITLE: "Language"
};
var LanguageSelector$4 = {
	TITLE: "Choose language"
};
var thTranslation = {
	sharableTranslations: sharableTranslations$3,
	DatePickerField: DatePickerField$4,
	SelectField: SelectField$4,
	TimePickerField: TimePickerField$4,
	ErrorView: ErrorView$4,
	Footer: Footer$4,
	TestEnvironmentBar: TestEnvironmentBar$4,
	ConnectionModal: ConnectionModal$4,
	ErrorModal: ErrorModal$4,
	InactivityModal: InactivityModal$4,
	LoadingModal: LoadingModal$4,
	FieldWrapper: FieldWrapper$4,
	LogsModal: LogsModal$4,
	ServiceModal: ServiceModal$4,
	LanguageButtonGroup: LanguageButtonGroup$4,
	LanguageSelector: LanguageSelector$4
};

var sharableTranslations$2 = {
	CANCEL: "İptal",
	CONTINUE: "Devam",
	CONFIRM: "Onayla",
	ERROR_MESSAGE: "Bir sorun oluştu",
	CLEAR: "Temizle",
	PAGE_COUNTER: "sayfa {{page}}/{{numberOfPages}}",
	SAVE: "Kaydet"
};
var DatePickerField$3 = {
	SELECT_DATE: "Tarih seçin",
	JAN: "Oca",
	FEB: "Şub",
	MAR: "Mar",
	APR: "Nis",
	MAY: "May",
	JUN: "Haz",
	JUL: "Tem",
	AUG: "Ağu",
	SEP: "Eyl",
	OCT: "Eki",
	NOV: "Kas",
	DEC: "Ara"
};
var SelectField$3 = {
	START_SEARCHING: "Aramayı başlat",
	NO_RESULTS: "Herhangi bir sonuç yok",
	ALL: "Tümü",
	SUGGESTED: "Önerilenler"
};
var TimePickerField$3 = {
	SELECT_TIME: "Zaman seçin",
	HOUR: "Saat",
	MINUTE: "Dakika"
};
var ErrorView$3 = {
	CRITICAL_ERROR: "Kritik hata!",
	REPORT_PROBLEM: "Lütfen sorunu bildirin"
};
var Footer$3 = {
	BACK: "Geri"
};
var TestEnvironmentBar$3 = {
	TRAINING_ENVIRONMENT: "Training Environment"
};
var ConnectionModal$3 = {
	WAKE_UP_YOUR_CONNECTION: "Bağlantınızı uyandırın",
	NETWORK_UNREACHABLE: "Ağa ulaşılamıyor"
};
var ErrorModal$3 = {
	TRY_AGAIN: "Tekrar deneyin"
};
var InactivityModal$3 = {
	YES: "Evet",
	ARE_YOU_THERE: "Hâlâ burada mısınız?"
};
var LoadingModal$3 = {
	LOADING: "Yükleniyor…",
	PLEASE_WAIT: "Lütfen bekleyin"
};
var FieldWrapper$3 = {
	OPTIONAL: "İsteğe bağlı"
};
var LogsModal$3 = {
	EXPORT: "Dışa aktar",
	LOG_MODAL_HEADER: "Günlük mesajları",
	NO_LOGS: "Görüntülenecek günlük yok"
};
var ServiceModal$3 = {
	HEADER: "Settings",
	USER_NAME: "User",
	PROPERTY_NAME: "Property",
	KPE_VERSION: "KPE sürümü: {{version}}",
	OS_VERSION: "İşletim sistemi sürümü: {{version}}",
	CLEAR_DATA: "Verileri temizle",
	SHOW_ERROR_LOGS: "Hata günlüklerini göster",
	SHOW_AUTH_LOGS: "Kimlik doğrulama günlüklerini göster",
	DEBUG_MODE: "Debug",
	LOGOUT: "Logout"
};
var LanguageButtonGroup$3 = {
	TITLE: "Language"
};
var LanguageSelector$3 = {
	TITLE: "Choose language"
};
var trTranslation = {
	sharableTranslations: sharableTranslations$2,
	DatePickerField: DatePickerField$3,
	SelectField: SelectField$3,
	TimePickerField: TimePickerField$3,
	ErrorView: ErrorView$3,
	Footer: Footer$3,
	TestEnvironmentBar: TestEnvironmentBar$3,
	ConnectionModal: ConnectionModal$3,
	ErrorModal: ErrorModal$3,
	InactivityModal: InactivityModal$3,
	LoadingModal: LoadingModal$3,
	FieldWrapper: FieldWrapper$3,
	LogsModal: LogsModal$3,
	ServiceModal: ServiceModal$3,
	LanguageButtonGroup: LanguageButtonGroup$3,
	LanguageSelector: LanguageSelector$3
};

var sharableTranslations$1 = {
	CANCEL: "取消",
	CONTINUE: "继续",
	CONFIRM: "确认",
	ERROR_MESSAGE: "未知错误",
	CLEAR: "清除",
	PAGE_COUNTER: "第 {{page}} 页，共 {{numberOfPages}} 页",
	SAVE: "保存"
};
var DatePickerField$2 = {
	SELECT_DATE: "选择日期",
	JAN: "一月",
	FEB: "二月",
	MAR: "三月",
	APR: "四月",
	MAY: "五月",
	JUN: "六月",
	JUL: "七月",
	AUG: "八月",
	SEP: "九月",
	OCT: "十月",
	NOV: "十一月",
	DEC: "十二月"
};
var SelectField$2 = {
	START_SEARCHING: "开始查询",
	NO_RESULTS: "未找到结果",
	ALL: "全部",
	SUGGESTED: "建议"
};
var TimePickerField$2 = {
	SELECT_TIME: "选择时间",
	HOUR: "小时",
	MINUTE: "分钟"
};
var ErrorView$2 = {
	CRITICAL_ERROR: "严重错误！",
	REPORT_PROBLEM: "请报告问题"
};
var Footer$2 = {
	BACK: "返回"
};
var TestEnvironmentBar$2 = {
	TRAINING_ENVIRONMENT: "培训环境"
};
var ConnectionModal$2 = {
	WAKE_UP_YOUR_CONNECTION: "唤醒您的链接",
	NETWORK_UNREACHABLE: "网络无法访问"
};
var ErrorModal$2 = {
	TRY_AGAIN: "请重试"
};
var InactivityModal$2 = {
	YES: "是",
	ARE_YOU_THERE: "您是否仍然在线？"
};
var LoadingModal$2 = {
	LOADING: "载入中 ...",
	PLEASE_WAIT: "请稍候"
};
var FieldWrapper$2 = {
	OPTIONAL: "可选项"
};
var LogsModal$2 = {
	EXPORT: "导出",
	LOG_MODAL_HEADER: "日志消息",
	NO_LOGS: "没有可显示的日志"
};
var ServiceModal$2 = {
	HEADER: "设置",
	USER_NAME: "用户",
	PROPERTY_NAME: "酒店",
	KPE_VERSION: "KPE 版本： {{version}}",
	OS_VERSION: "OS 版本： {{version}}",
	CLEAR_DATA: "清除数据",
	SHOW_ERROR_LOGS: "显示错误日志",
	SHOW_AUTH_LOGS: "显示授权日志",
	DEBUG_MODE: "调试",
	LOGOUT: "注销"
};
var LanguageButtonGroup$2 = {
	TITLE: "语言"
};
var LanguageSelector$2 = {
	TITLE: "选择语言"
};
var zhHansTranslation = {
	sharableTranslations: sharableTranslations$1,
	DatePickerField: DatePickerField$2,
	SelectField: SelectField$2,
	TimePickerField: TimePickerField$2,
	ErrorView: ErrorView$2,
	Footer: Footer$2,
	TestEnvironmentBar: TestEnvironmentBar$2,
	ConnectionModal: ConnectionModal$2,
	ErrorModal: ErrorModal$2,
	InactivityModal: InactivityModal$2,
	LoadingModal: LoadingModal$2,
	FieldWrapper: FieldWrapper$2,
	LogsModal: LogsModal$2,
	ServiceModal: ServiceModal$2,
	LanguageButtonGroup: LanguageButtonGroup$2,
	LanguageSelector: LanguageSelector$2
};

var sharableTranslations = {
	CANCEL: "取消",
	CONTINUE: "繼續",
	CONFIRM: "確認",
	ERROR_MESSAGE: "發生錯誤",
	CLEAR: "清除",
	PAGE_COUNTER: "第 {{page}} 頁，共 {{numberOfPages}} 頁",
	SAVE: "儲存"
};
var DatePickerField$1 = {
	SELECT_DATE: "選取日期",
	JAN: "1 月",
	FEB: "2 月",
	MAR: "3 月",
	APR: "4 月",
	MAY: "5 月",
	JUN: "6 月",
	JUL: "7 月",
	AUG: "8 月",
	SEP: "9 月",
	OCT: "10 月",
	NOV: "11 月",
	DEC: "12 月"
};
var SelectField$1 = {
	START_SEARCHING: "開始搜尋",
	NO_RESULTS: "沒有相關結果",
	ALL: "全部",
	SUGGESTED: "建議"
};
var TimePickerField$1 = {
	SELECT_TIME: "選擇時間",
	HOUR: "時",
	MINUTE: "分"
};
var ErrorView$1 = {
	CRITICAL_ERROR: "嚴重錯誤!",
	REPORT_PROBLEM: "請回報錯誤"
};
var Footer$1 = {
	BACK: "返回"
};
var TestEnvironmentBar$1 = {
	TRAINING_ENVIRONMENT: "Training Environment"
};
var ConnectionModal$1 = {
	WAKE_UP_YOUR_CONNECTION: "喚醒您的連線",
	NETWORK_UNREACHABLE: "網路無法連線"
};
var ErrorModal$1 = {
	TRY_AGAIN: "重試"
};
var InactivityModal$1 = {
	YES: "是",
	ARE_YOU_THERE: "您還在嗎?"
};
var LoadingModal$1 = {
	LOADING: "正在載入...",
	PLEASE_WAIT: "請稍候"
};
var FieldWrapper$1 = {
	OPTIONAL: "可選"
};
var LogsModal$1 = {
	EXPORT: "匯出",
	LOG_MODAL_HEADER: "系統紀錄",
	NO_LOGS: "沒有可檢視的系統紀錄"
};
var ServiceModal$1 = {
	HEADER: "Settings",
	USER_NAME: "User",
	PROPERTY_NAME: "Property",
	KPE_VERSION: "KPE 版本: {{version}}",
	OS_VERSION: "OS 版本: {{version}}",
	CLEAR_DATA: "清楚資料",
	SHOW_ERROR_LOGS: "檢視錯誤記錄",
	SHOW_AUTH_LOGS: "檢視授權記錄",
	DEBUG_MODE: "Debug",
	LOGOUT: "Logout"
};
var LanguageButtonGroup$1 = {
	TITLE: "Language"
};
var LanguageSelector$1 = {
	TITLE: "Choose language"
};
var zhHantTranslation = {
	sharableTranslations: sharableTranslations,
	DatePickerField: DatePickerField$1,
	SelectField: SelectField$1,
	TimePickerField: TimePickerField$1,
	ErrorView: ErrorView$1,
	Footer: Footer$1,
	TestEnvironmentBar: TestEnvironmentBar$1,
	ConnectionModal: ConnectionModal$1,
	ErrorModal: ErrorModal$1,
	InactivityModal: InactivityModal$1,
	LoadingModal: LoadingModal$1,
	FieldWrapper: FieldWrapper$1,
	LogsModal: LogsModal$1,
	ServiceModal: ServiceModal$1,
	LanguageButtonGroup: LanguageButtonGroup$1,
	LanguageSelector: LanguageSelector$1
};

const DEFAULT_LANGUAGE = 'en';
var Languages;
(function (Languages) {
    Languages["en"] = "en";
    Languages["zhHans"] = "zh-hans";
    Languages["zhHant"] = "zh-hant";
    Languages["ko"] = "ko";
    Languages["fr"] = "fr";
    Languages["pl"] = "pl";
    Languages["ja"] = "ja";
    Languages["es"] = "es";
    Languages["nl"] = "nl";
    Languages["tr"] = "tr";
    Languages["th"] = "th";
    Languages["de"] = "de";
    Languages["it"] = "it";
})(Languages || (Languages = {}));
const resources = {
    [Languages.en]: enTranslation,
    [Languages.ko]: koTranslation,
    [Languages.zhHans]: zhHansTranslation,
    [Languages.zhHant]: zhHantTranslation,
    [Languages.fr]: frTranslation,
    [Languages.ja]: jaTranslation,
    [Languages.pl]: plTranslation,
    [Languages.es]: esTranslation,
    [Languages.nl]: nlTranslation,
    [Languages.tr]: trTranslation,
    [Languages.th]: thTranslation,
    [Languages.de]: deTranslation,
    [Languages.it]: itTranslation,
};
function initI18nTranslations() {
    i18next.use(initReactI18next).init({
        resources,
        fallbackLng: DEFAULT_LANGUAGE,
        lng: DEFAULT_LANGUAGE,
        interpolation: { escapeValue: false },
        ns: Object.keys(enTranslation),
        fallbackNS: 'sharableTranslations',
        lowerCaseLng: true,
    });
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$Y = "/* stylelint-disable selector-max-universal */\n:root {\n  --spacing-none: 0;\n  --spacing-xxs: 2px;\n  --spacing-xs: 4px;\n  --spacing-s: 6px;\n  --spacing-sm: 8px;\n  --spacing-md: 12px;\n  --spacing-lg: 16px;\n  --spacing-xlg: 24px;\n  --spacing-xxlg: 32px;\n  --font-size-xxs: 11px;\n  --font-size-xs: 14px;\n  --font-size-sm: 16px;\n  --font-size-md: 18px;\n  --font-size-lg: 20px;\n  --font-size-xlg: 24px;\n  --font-weight-bold: 600;\n  --font-weight-regular: 400;\n  --font-weight-light: 300;\n  --footer-height: 64px;\n  --header-height: 62px;\n  --console-simulator-nav-height: 0px;\n  --test-environment-bar-height: 40px;\n  --test-environment-bar-color: #c30f98;\n  --white-color: #ffffff;\n  --black-color: #000000;\n  --gray-color-1: #919191;\n  --gray-color-2: #bdbdbd;\n  --gray-color-3: #dfdfdf;\n  --success-state-color: #109128;\n  --success-dark-state-color: #095f1a;\n  --error-state-color: #d2000d;\n  --warning-state-color: #fcb53b;\n  --active-state-color: #126aba;\n  --primary-contrast-text-color: #ffffff;\n}\n\n[class*=-kiosk-components-theme],\n:root {\n  --primary-color: #0c3c6b;\n  --main-font: \"Open Sans\", Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Helvetica Neue\", sans-serif, Arial, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  --body-background-color: #ffffff;\n  --body-font-color: #000000;\n  --footer-background-color: #ffffff;\n  --footer-font-color: #000000;\n  --header-background-color: var(--primary-color);\n  --header-font-color: var(--primary-contrast-text-color);\n  --primary-button-active-background-color: var(--primary-color);\n  --primary-button-active-border-color: var(--primary-color);\n  --primary-button-active-text-color: var(--primary-contrast-text-color);\n  --primary-button-clicked-background-color: var(--primary-color);\n  --primary-button-clicked-border-color: var(--primary-color);\n  --primary-button-clicked-text-color: var(--primary-contrast-text-color);\n  --primary-button-disabled-background-color: #919191;\n  --primary-button-disabled-border-color: #919191;\n  --primary-button-disabled-text-color: #ffffff;\n  --secondary-button-clicked-border-color: var(--primary-color);\n  --secondary-button-clicked-background-color: #ffffff;\n  --secondary-button-clicked-text-color: var(--primary-color);\n  --secondary-button-disabled-border-color: #919191;\n  --secondary-button-disabled-background-color: #ffffff;\n  --secondary-button-disabled-text-color: #919191;\n  --secondary-button-active-border-color: var(--primary-color);\n  --secondary-button-active-background-color: #ffffff;\n  --secondary-button-active-text-color: var(--primary-color);\n  --tertiary-button-clicked-text-color: var(--primary-color);\n  --tertiary-button-disabled-text-color: #919191;\n  --tertiary-button-active-text-color: var(--primary-color);\n  --hint-font-color: #757575;\n}\n\n:root .spacing-none {\n  margin: var(--spacing-none);\n}\n:root .spacing-vertical-none {\n  margin-top: var(--spacing-none);\n  margin-bottom: var(--spacing-none);\n}\n:root .spacing-horizontal-none {\n  margin-right: var(--spacing-none);\n  margin-left: var(--spacing-none);\n}\n:root .spacing-auto {\n  margin: auto;\n}\n:root .spacing-vertical-auto {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n:root .spacing-horizontal-auto {\n  margin-right: auto;\n  margin-left: auto;\n}\n:root .spacing-xxs {\n  margin: var(--spacing-xxs);\n}\n:root .spacing-vertical-xxs {\n  margin-top: var(--spacing-xxs);\n  margin-bottom: var(--spacing-xxs);\n}\n:root .spacing-horizontal-xxs {\n  margin-right: var(--spacing-xxs);\n  margin-left: var(--spacing-xxs);\n}\n:root .spacing-xs {\n  margin: var(--spacing-xs);\n}\n:root .spacing-vertical-xs {\n  margin-top: var(--spacing-xs);\n  margin-bottom: var(--spacing-xs);\n}\n:root .spacing-horizontal-xs {\n  margin-right: var(--spacing-xs);\n  margin-left: var(--spacing-xs);\n}\n:root .spacing-s {\n  margin: var(--spacing-s);\n}\n:root .spacing-vertical-s {\n  margin-top: var(--spacing-s);\n  margin-bottom: var(--spacing-s);\n}\n:root .spacing-horizontal-s {\n  margin-right: var(--spacing-s);\n  margin-left: var(--spacing-s);\n}\n:root .spacing-sm {\n  margin: var(--spacing-sm);\n}\n:root .spacing-vertical-sm {\n  margin-top: var(--spacing-sm);\n  margin-bottom: var(--spacing-sm);\n}\n:root .spacing-horizontal-sm {\n  margin-right: var(--spacing-sm);\n  margin-left: var(--spacing-sm);\n}\n:root .spacing-md {\n  margin: var(--spacing-md);\n}\n:root .spacing-vertical-md {\n  margin-top: var(--spacing-md);\n  margin-bottom: var(--spacing-md);\n}\n:root .spacing-horizontal-md {\n  margin-right: var(--spacing-md);\n  margin-left: var(--spacing-md);\n}\n:root .spacing-lg {\n  margin: var(--spacing-lg);\n}\n:root .spacing-vertical-lg {\n  margin-top: var(--spacing-lg);\n  margin-bottom: var(--spacing-lg);\n}\n:root .spacing-horizontal-lg {\n  margin-right: var(--spacing-lg);\n  margin-left: var(--spacing-lg);\n}\n:root .spacing-xlg {\n  margin: var(--spacing-xlg);\n}\n:root .spacing-vertical-xlg {\n  margin-top: var(--spacing-xlg);\n  margin-bottom: var(--spacing-xlg);\n}\n:root .spacing-horizontal-xlg {\n  margin-right: var(--spacing-xlg);\n  margin-left: var(--spacing-xlg);\n}\n:root .spacing-xxlg {\n  margin: var(--spacing-xxlg);\n}\n:root .spacing-vertical-xxlg {\n  margin-top: var(--spacing-xxlg);\n  margin-bottom: var(--spacing-xxlg);\n}\n:root .spacing-horizontal-xxlg {\n  margin-right: var(--spacing-xxlg);\n  margin-left: var(--spacing-xxlg);\n}\n:root .spacing-top-none {\n  margin-top: var(--spacing-none);\n}\n:root .spacing-top-auto {\n  margin-top: auto;\n}\n:root .spacing-top-xxs {\n  margin-top: var(--spacing-xxs);\n}\n:root .spacing-top-xs {\n  margin-top: var(--spacing-xs);\n}\n:root .spacing-top-s {\n  margin-top: var(--spacing-s);\n}\n:root .spacing-top-sm {\n  margin-top: var(--spacing-sm);\n}\n:root .spacing-top-md {\n  margin-top: var(--spacing-md);\n}\n:root .spacing-top-lg {\n  margin-top: var(--spacing-lg);\n}\n:root .spacing-top-xlg {\n  margin-top: var(--spacing-xlg);\n}\n:root .spacing-top-xxlg {\n  margin-top: var(--spacing-xxlg);\n}\n:root .spacing-right-none {\n  margin-right: var(--spacing-none);\n}\n:root .spacing-right-auto {\n  margin-right: auto;\n}\n:root .spacing-right-xxs {\n  margin-right: var(--spacing-xxs);\n}\n:root .spacing-right-xs {\n  margin-right: var(--spacing-xs);\n}\n:root .spacing-right-s {\n  margin-right: var(--spacing-s);\n}\n:root .spacing-right-sm {\n  margin-right: var(--spacing-sm);\n}\n:root .spacing-right-md {\n  margin-right: var(--spacing-md);\n}\n:root .spacing-right-lg {\n  margin-right: var(--spacing-lg);\n}\n:root .spacing-right-xlg {\n  margin-right: var(--spacing-xlg);\n}\n:root .spacing-right-xxlg {\n  margin-right: var(--spacing-xxlg);\n}\n:root .spacing-bottom-none {\n  margin-bottom: var(--spacing-none);\n}\n:root .spacing-bottom-auto {\n  margin-bottom: auto;\n}\n:root .spacing-bottom-xxs {\n  margin-bottom: var(--spacing-xxs);\n}\n:root .spacing-bottom-xs {\n  margin-bottom: var(--spacing-xs);\n}\n:root .spacing-bottom-s {\n  margin-bottom: var(--spacing-s);\n}\n:root .spacing-bottom-sm {\n  margin-bottom: var(--spacing-sm);\n}\n:root .spacing-bottom-md {\n  margin-bottom: var(--spacing-md);\n}\n:root .spacing-bottom-lg {\n  margin-bottom: var(--spacing-lg);\n}\n:root .spacing-bottom-xlg {\n  margin-bottom: var(--spacing-xlg);\n}\n:root .spacing-bottom-xxlg {\n  margin-bottom: var(--spacing-xxlg);\n}\n:root .spacing-left-none {\n  margin-left: var(--spacing-none);\n}\n:root .spacing-left-auto {\n  margin-left: auto;\n}\n:root .spacing-left-xxs {\n  margin-left: var(--spacing-xxs);\n}\n:root .spacing-left-xs {\n  margin-left: var(--spacing-xs);\n}\n:root .spacing-left-s {\n  margin-left: var(--spacing-s);\n}\n:root .spacing-left-sm {\n  margin-left: var(--spacing-sm);\n}\n:root .spacing-left-md {\n  margin-left: var(--spacing-md);\n}\n:root .spacing-left-lg {\n  margin-left: var(--spacing-lg);\n}\n:root .spacing-left-xlg {\n  margin-left: var(--spacing-xlg);\n}\n:root .spacing-left-xxlg {\n  margin-left: var(--spacing-xxlg);\n}\n:root .padding-none {\n  padding: var(--spacing-none);\n}\n:root .padding-vertical-none {\n  padding-top: var(--spacing-none);\n  padding-bottom: var(--spacing-none);\n}\n:root .padding-horizontal-none {\n  padding-right: var(--spacing-none);\n  padding-left: var(--spacing-none);\n}\n:root .padding-auto {\n  padding: auto;\n}\n:root .padding-vertical-auto {\n  padding-top: auto;\n  padding-bottom: auto;\n}\n:root .padding-horizontal-auto {\n  padding-right: auto;\n  padding-left: auto;\n}\n:root .padding-xxs {\n  padding: var(--spacing-xxs);\n}\n:root .padding-vertical-xxs {\n  padding-top: var(--spacing-xxs);\n  padding-bottom: var(--spacing-xxs);\n}\n:root .padding-horizontal-xxs {\n  padding-right: var(--spacing-xxs);\n  padding-left: var(--spacing-xxs);\n}\n:root .padding-xs {\n  padding: var(--spacing-xs);\n}\n:root .padding-vertical-xs {\n  padding-top: var(--spacing-xs);\n  padding-bottom: var(--spacing-xs);\n}\n:root .padding-horizontal-xs {\n  padding-right: var(--spacing-xs);\n  padding-left: var(--spacing-xs);\n}\n:root .padding-s {\n  padding: var(--spacing-s);\n}\n:root .padding-vertical-s {\n  padding-top: var(--spacing-s);\n  padding-bottom: var(--spacing-s);\n}\n:root .padding-horizontal-s {\n  padding-right: var(--spacing-s);\n  padding-left: var(--spacing-s);\n}\n:root .padding-sm {\n  padding: var(--spacing-sm);\n}\n:root .padding-vertical-sm {\n  padding-top: var(--spacing-sm);\n  padding-bottom: var(--spacing-sm);\n}\n:root .padding-horizontal-sm {\n  padding-right: var(--spacing-sm);\n  padding-left: var(--spacing-sm);\n}\n:root .padding-md {\n  padding: var(--spacing-md);\n}\n:root .padding-vertical-md {\n  padding-top: var(--spacing-md);\n  padding-bottom: var(--spacing-md);\n}\n:root .padding-horizontal-md {\n  padding-right: var(--spacing-md);\n  padding-left: var(--spacing-md);\n}\n:root .padding-lg {\n  padding: var(--spacing-lg);\n}\n:root .padding-vertical-lg {\n  padding-top: var(--spacing-lg);\n  padding-bottom: var(--spacing-lg);\n}\n:root .padding-horizontal-lg {\n  padding-right: var(--spacing-lg);\n  padding-left: var(--spacing-lg);\n}\n:root .padding-xlg {\n  padding: var(--spacing-xlg);\n}\n:root .padding-vertical-xlg {\n  padding-top: var(--spacing-xlg);\n  padding-bottom: var(--spacing-xlg);\n}\n:root .padding-horizontal-xlg {\n  padding-right: var(--spacing-xlg);\n  padding-left: var(--spacing-xlg);\n}\n:root .padding-xxlg {\n  padding: var(--spacing-xxlg);\n}\n:root .padding-vertical-xxlg {\n  padding-top: var(--spacing-xxlg);\n  padding-bottom: var(--spacing-xxlg);\n}\n:root .padding-horizontal-xxlg {\n  padding-right: var(--spacing-xxlg);\n  padding-left: var(--spacing-xxlg);\n}\n:root .padding-top-none {\n  padding-top: var(--spacing-none);\n}\n:root .padding-top-xxs {\n  padding-top: var(--spacing-xxs);\n}\n:root .padding-top-xs {\n  padding-top: var(--spacing-xs);\n}\n:root .padding-top-s {\n  padding-top: var(--spacing-s);\n}\n:root .padding-top-sm {\n  padding-top: var(--spacing-sm);\n}\n:root .padding-top-md {\n  padding-top: var(--spacing-md);\n}\n:root .padding-top-lg {\n  padding-top: var(--spacing-lg);\n}\n:root .padding-top-xlg {\n  padding-top: var(--spacing-xlg);\n}\n:root .padding-top-xxlg {\n  padding-top: var(--spacing-xxlg);\n}\n:root .padding-right-none {\n  padding-right: var(--spacing-none);\n}\n:root .padding-right-xxs {\n  padding-right: var(--spacing-xxs);\n}\n:root .padding-right-xs {\n  padding-right: var(--spacing-xs);\n}\n:root .padding-right-s {\n  padding-right: var(--spacing-s);\n}\n:root .padding-right-sm {\n  padding-right: var(--spacing-sm);\n}\n:root .padding-right-md {\n  padding-right: var(--spacing-md);\n}\n:root .padding-right-lg {\n  padding-right: var(--spacing-lg);\n}\n:root .padding-right-xlg {\n  padding-right: var(--spacing-xlg);\n}\n:root .padding-right-xxlg {\n  padding-right: var(--spacing-xxlg);\n}\n:root .padding-bottom-none {\n  padding-bottom: var(--spacing-none);\n}\n:root .padding-bottom-xxs {\n  padding-bottom: var(--spacing-xxs);\n}\n:root .padding-bottom-xs {\n  padding-bottom: var(--spacing-xs);\n}\n:root .padding-bottom-s {\n  padding-bottom: var(--spacing-s);\n}\n:root .padding-bottom-sm {\n  padding-bottom: var(--spacing-sm);\n}\n:root .padding-bottom-md {\n  padding-bottom: var(--spacing-md);\n}\n:root .padding-bottom-lg {\n  padding-bottom: var(--spacing-lg);\n}\n:root .padding-bottom-xlg {\n  padding-bottom: var(--spacing-xlg);\n}\n:root .padding-bottom-xxlg {\n  padding-bottom: var(--spacing-xxlg);\n}\n:root .padding-left-none {\n  padding-left: var(--spacing-none);\n}\n:root .padding-left-xxs {\n  padding-left: var(--spacing-xxs);\n}\n:root .padding-left-xs {\n  padding-left: var(--spacing-xs);\n}\n:root .padding-left-s {\n  padding-left: var(--spacing-s);\n}\n:root .padding-left-sm {\n  padding-left: var(--spacing-sm);\n}\n:root .padding-left-md {\n  padding-left: var(--spacing-md);\n}\n:root .padding-left-lg {\n  padding-left: var(--spacing-lg);\n}\n:root .padding-left-xlg {\n  padding-left: var(--spacing-xlg);\n}\n:root .padding-left-xxlg {\n  padding-left: var(--spacing-xxlg);\n}\n:root .gap-none {\n  gap: var(--spacing-none);\n}\n:root .row-gap-none {\n  row-gap: var(--spacing-none);\n}\n:root .column-gap-none {\n  -moz-column-gap: var(--spacing-none);\n       column-gap: var(--spacing-none);\n}\n:root .gap-auto {\n  gap: auto;\n}\n:root .row-gap-auto {\n  row-gap: auto;\n}\n:root .column-gap-auto {\n  -moz-column-gap: auto;\n       column-gap: auto;\n}\n:root .gap-xxs {\n  gap: var(--spacing-xxs);\n}\n:root .row-gap-xxs {\n  row-gap: var(--spacing-xxs);\n}\n:root .column-gap-xxs {\n  -moz-column-gap: var(--spacing-xxs);\n       column-gap: var(--spacing-xxs);\n}\n:root .gap-xs {\n  gap: var(--spacing-xs);\n}\n:root .row-gap-xs {\n  row-gap: var(--spacing-xs);\n}\n:root .column-gap-xs {\n  -moz-column-gap: var(--spacing-xs);\n       column-gap: var(--spacing-xs);\n}\n:root .gap-s {\n  gap: var(--spacing-s);\n}\n:root .row-gap-s {\n  row-gap: var(--spacing-s);\n}\n:root .column-gap-s {\n  -moz-column-gap: var(--spacing-s);\n       column-gap: var(--spacing-s);\n}\n:root .gap-sm {\n  gap: var(--spacing-sm);\n}\n:root .row-gap-sm {\n  row-gap: var(--spacing-sm);\n}\n:root .column-gap-sm {\n  -moz-column-gap: var(--spacing-sm);\n       column-gap: var(--spacing-sm);\n}\n:root .gap-md {\n  gap: var(--spacing-md);\n}\n:root .row-gap-md {\n  row-gap: var(--spacing-md);\n}\n:root .column-gap-md {\n  -moz-column-gap: var(--spacing-md);\n       column-gap: var(--spacing-md);\n}\n:root .gap-lg {\n  gap: var(--spacing-lg);\n}\n:root .row-gap-lg {\n  row-gap: var(--spacing-lg);\n}\n:root .column-gap-lg {\n  -moz-column-gap: var(--spacing-lg);\n       column-gap: var(--spacing-lg);\n}\n:root .gap-xlg {\n  gap: var(--spacing-xlg);\n}\n:root .row-gap-xlg {\n  row-gap: var(--spacing-xlg);\n}\n:root .column-gap-xlg {\n  -moz-column-gap: var(--spacing-xlg);\n       column-gap: var(--spacing-xlg);\n}\n:root .gap-xxlg {\n  gap: var(--spacing-xxlg);\n}\n:root .row-gap-xxlg {\n  row-gap: var(--spacing-xxlg);\n}\n:root .column-gap-xxlg {\n  -moz-column-gap: var(--spacing-xxlg);\n       column-gap: var(--spacing-xxlg);\n}\n:root .overflow-hidden {\n  overflow: hidden;\n}\n:root .overflow-auto {\n  overflow: auto;\n}\n:root .overflow-visible {\n  overflow: visible;\n}\n:root .overflow-y-hidden {\n  overflow-y: hidden;\n}\n:root .overflow-y-auto {\n  overflow-y: auto;\n}\n:root .overflow-x-hidden {\n  overflow-x: hidden;\n}\n:root .overflow-x-auto {\n  overflow-x: auto;\n}\n:root .overflow-x-visible {\n  overflow-x: visible;\n}\n:root .overflow-y-visible {\n  overflow-y: visible;\n}\n:root .pointer {\n  cursor: pointer;\n}\n:root .relative {\n  position: relative;\n}\n:root .no-wrap {\n  white-space: nowrap;\n}\n:root .ellipsis {\n  overflow-y: hidden;\n  text-overflow: ellipsis;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}";
styleInject(css_248z$Y);

var classnames = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var classNames = classnames.exports;

const blobToBinaryString = (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            resolve(reader.result);
        };
        reader.onerror = (error) => {
            reject(error);
        };
        reader.readAsBinaryString(blob);
    });
};

var moment$1 = {exports: {}};

(function (module, exports) {
(function (global, factory) {
    module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
}(moment$1));

var moment = moment$1.exports;

function getFormattedDate(date, format, inputFormat, skipYearIfNotExists = true) {
    const formatWithoutYear = format.replace(/[^\w]?[yY]+[^\w]?/g, '');
    const isDataObjectMissingYear = typeof date === 'object' && !date.year;
    const isDataStringMissingYear = typeof date === 'string' && date.length < format.length;
    if (skipYearIfNotExists &&
        date &&
        (isDataObjectMissingYear || isDataStringMissingYear)) {
        return moment(date, inputFormat).format(formatWithoutYear);
    }
    return moment(date, inputFormat).format(format);
}

var TimeFormats;
(function (TimeFormats) {
    TimeFormats["H12"] = "H12";
    TimeFormats["H24"] = "H24";
})(TimeFormats || (TimeFormats = {}));

const predefinedTimeFormats = {
    [TimeFormats.H12]: 'h:mm A',
    [TimeFormats.H24]: 'HH:mm',
};
function getFormattedTime(date, format, inputFormat) {
    const predefinedInputFormat = inputFormat && (predefinedTimeFormats[inputFormat] || inputFormat);
    return moment(date, predefinedInputFormat).format(predefinedTimeFormats[format] || format);
}

function generateRandomString() {
    var _a;
    if (((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.NODE_ENV) === 'test')
        return 'test-generated-string';
    return Math.random().toString(36).substring(2);
}

function useDebounce(value, timeout) {
    const [state, setState] = useState(value);
    useEffect(() => {
        const handler = setTimeout(() => setState(value), timeout);
        return () => clearTimeout(handler);
    }, [value, timeout]);
    return state;
}

var css_248z$X = ".checkbox-button-wrapper {\n  display: flex;\n  align-items: flex-start;\n}\n.checkbox-button-wrapper.checkbox-button-wrapper-reverse-order {\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n}\n.checkbox-button-wrapper .checkbox-button-input-wrapper {\n  position: relative;\n  width: 44px;\n  min-width: 44px;\n  height: 44px;\n}\n.checkbox-button-wrapper .checkbox-button-input-wrapper .checkbox-button-input-box {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 24px;\n  height: 24px;\n  pointer-events: none;\n  background-color: var(--white-color);\n  border: 1px solid var(--gray-color-1);\n  border-radius: 3px;\n  transform: translate(-50%, -50%);\n}\n.checkbox-button-wrapper .checkbox-button-input:disabled ~ .checkbox-button-input-box {\n  border-color: var(--gray-color-3);\n}\n.checkbox-button-wrapper .checkbox-button-input:checked:disabled ~ .checkbox-button-input-box {\n  background-color: var(--gray-color-1);\n  border-color: var(--gray-color-1);\n}\n.checkbox-button-wrapper .checkbox-button-input {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  border-radius: 50%;\n  outline: none;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n.checkbox-button-wrapper .checkbox-button-input::after {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  display: block;\n  width: 15px;\n  height: 7.5px;\n  visibility: hidden;\n  content: \"\";\n  background-color: transparent;\n  border: solid 3px var(--white-color);\n  border-top: none;\n  border-right: none;\n  transform: translate(-50%, -75%) rotate(-45deg);\n}\n.checkbox-button-wrapper .checkbox-button-input:checked::after {\n  visibility: visible;\n}\n.checkbox-button-wrapper .checkbox-button-input:not(:disabled):hover::before {\n  position: absolute;\n  display: block;\n  width: 100%;\n  height: 100%;\n  content: \"\";\n  background-color: var(--primary-color);\n  opacity: 0.1;\n}\n.checkbox-button-wrapper .checkbox-button-input-active-state {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  display: block;\n  width: 0;\n  height: 0;\n  content: \"\";\n  background-color: transparent;\n  border-radius: 50%;\n  opacity: 0;\n  transition: width 300ms cubic-bezier(0.22, 0.61, 0.36, 1), height 300ms cubic-bezier(0.22, 0.61, 0.36, 1);\n  transform: translate(-50%, -50%);\n}\n.checkbox-button-wrapper .checkbox-button-input-wrapper:active > .checkbox-button-input-active-state {\n  width: 100%;\n  height: 100%;\n  background-color: var(--gray-color-1);\n  opacity: 0.4;\n}\n.checkbox-button-wrapper .checkbox-button-input-wrapper:active > .checkbox-button-input:checked + .checkbox-button-input-active-state {\n  width: 100%;\n  height: 100%;\n  background-color: var(--primary-color);\n  opacity: 0.4;\n}\n.checkbox-button-wrapper .checkbox-button-input-wrapper:active > .checkbox-button-input:disabled + .checkbox-button-input-active-state {\n  background-color: transparent;\n}\n.checkbox-button-wrapper .checkbox-button-input:checked:not(:disabled) ~ .checkbox-button-input-box {\n  background-color: var(--primary-color);\n  border-color: var(--primary-color);\n}\n.checkbox-button-wrapper .checkbox-button-label {\n  margin: 10px var(--spacing-md) 10px var(--spacing-xs);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n.checkbox-button-wrapper .checkbox-button-label.checkbox-button-label-start {\n  margin-right: var(--spacing-xs);\n  margin-left: var(--spacing-md);\n}\n.checkbox-button-wrapper .checkbox-button-label.checkbox-button-label-disabled {\n  color: var(--gray-color-1);\n}";
styleInject(css_248z$X);

var CheckboxButtonLabelPosition;
(function (CheckboxButtonLabelPosition) {
    CheckboxButtonLabelPosition["start"] = "start";
    CheckboxButtonLabelPosition["end"] = "end";
})(CheckboxButtonLabelPosition || (CheckboxButtonLabelPosition = {}));
const Checkbox = ({ className, checked, label, disabled, id, dataTestSelector, name, value, labelPosition, onChange, onFocus, onBlur, }) => {
    const componentId = useMemo(() => id || generateRandomString(), [id]);
    return (jsxs("div", Object.assign({ "data-test-selector": dataTestSelector || 'checkbox-wrapper', className: classNames('checkbox-button-wrapper', {
            'checkbox-button-wrapper-reverse-order': labelPosition === CheckboxButtonLabelPosition.start,
        }, className) }, { children: [jsxs("div", Object.assign({ className: "checkbox-button-input-wrapper" }, { children: [jsx("input", { "data-test-selector": "checkbox-input", type: "checkbox", id: componentId, name: name, className: "checkbox-button-input", checked: checked, value: value, onChange: onChange, onFocus: onFocus, onBlur: onBlur, disabled: disabled }, void 0), jsx("span", { className: "checkbox-button-input-active-state" }, void 0), jsx("span", { className: "checkbox-button-input-box" }, void 0)] }), void 0), label && (jsx("label", Object.assign({ htmlFor: componentId, "data-test-selector": "checkbox-label", className: classNames('checkbox-button-label', {
                    'checkbox-button-label-start': labelPosition === CheckboxButtonLabelPosition.start,
                    'checkbox-button-label-disabled': disabled,
                }) }, { children: label }), void 0))] }), void 0));
};

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/*!
 * content-type
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * RegExp to match *( ";" parameter ) in RFC 7231 sec 3.1.1.1
 *
 * parameter     = token "=" ( token / quoted-string )
 * token         = 1*tchar
 * tchar         = "!" / "#" / "$" / "%" / "&" / "'" / "*"
 *               / "+" / "-" / "." / "^" / "_" / "`" / "|" / "~"
 *               / DIGIT / ALPHA
 *               ; any VCHAR, except delimiters
 * quoted-string = DQUOTE *( qdtext / quoted-pair ) DQUOTE
 * qdtext        = HTAB / SP / %x21 / %x23-5B / %x5D-7E / obs-text
 * obs-text      = %x80-FF
 * quoted-pair   = "\" ( HTAB / SP / VCHAR / obs-text )
 */
var PARAM_REGEXP = /; *([!#$%&'*+.^_`|~0-9A-Za-z-]+) *= *("(?:[\u000b\u0020\u0021\u0023-\u005b\u005d-\u007e\u0080-\u00ff]|\\[\u000b\u0020-\u00ff])*"|[!#$%&'*+.^_`|~0-9A-Za-z-]+) */g; // eslint-disable-line no-control-regex

/**
 * RegExp to match quoted-pair in RFC 7230 sec 3.2.6
 *
 * quoted-pair = "\" ( HTAB / SP / VCHAR / obs-text )
 * obs-text    = %x80-FF
 */
var QESC_REGEXP = /\\([\u000b\u0020-\u00ff])/g; // eslint-disable-line no-control-regex

/**
 * RegExp to match type in RFC 7231 sec 3.1.1.1
 *
 * media-type = type "/" subtype
 * type       = token
 * subtype    = token
 */
var TYPE_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+\/[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;
var parse_1 = parse$1;

/**
 * Parse media type to object.
 *
 * @param {string|object} string
 * @return {Object}
 * @public
 */

function parse$1 (string) {
  if (!string) {
    throw new TypeError('argument string is required')
  }

  // support req/res-like objects as argument
  var header = typeof string === 'object'
    ? getcontenttype(string)
    : string;

  if (typeof header !== 'string') {
    throw new TypeError('argument string is required to be a string')
  }

  var index = header.indexOf(';');
  var type = index !== -1
    ? header.slice(0, index).trim()
    : header.trim();

  if (!TYPE_REGEXP.test(type)) {
    throw new TypeError('invalid media type')
  }

  var obj = new ContentType(type.toLowerCase());

  // parse parameters
  if (index !== -1) {
    var key;
    var match;
    var value;

    PARAM_REGEXP.lastIndex = index;

    while ((match = PARAM_REGEXP.exec(header))) {
      if (match.index !== index) {
        throw new TypeError('invalid parameter format')
      }

      index += match[0].length;
      key = match[1].toLowerCase();
      value = match[2];

      if (value.charCodeAt(0) === 0x22 /* " */) {
        // remove quotes
        value = value.slice(1, -1);

        // remove escapes
        if (value.indexOf('\\') !== -1) {
          value = value.replace(QESC_REGEXP, '$1');
        }
      }

      obj.parameters[key] = value;
    }

    if (index !== header.length) {
      throw new TypeError('invalid parameter format')
    }
  }

  return obj
}

/**
 * Get content-type from req/res objects.
 *
 * @param {object}
 * @return {Object}
 * @private
 */

function getcontenttype (obj) {
  var header;

  if (typeof obj.getHeader === 'function') {
    // res-like
    header = obj.getHeader('content-type');
  } else if (typeof obj.headers === 'object') {
    // req-like
    header = obj.headers && obj.headers['content-type'];
  }

  if (typeof header !== 'string') {
    throw new TypeError('content-type header is missing from object')
  }

  return header
}

/**
 * Class to represent a content type.
 * @private
 */
function ContentType (type) {
  this.parameters = Object.create(null);
  this.type = type;
}

var cache = new Map();

var cloneSvg = function cloneSvg(sourceSvg) {
  return sourceSvg.cloneNode(true);
};

var isLocal = function isLocal() {
  return window.location.protocol === 'file:';
};

var makeAjaxRequest = function makeAjaxRequest(url, httpRequestWithCredentials, callback) {
  var httpRequest = new XMLHttpRequest();
  httpRequest.onreadystatechange = function () {
    try {
      if (!/\.svg/i.test(url) && httpRequest.readyState === 2) {
        var contentType = httpRequest.getResponseHeader('Content-Type');
        if (!contentType) {
          throw new Error('Content type not found');
        }
        var type = parse_1(contentType).type;
        if (!(type === 'image/svg+xml' || type === 'text/plain')) {
          throw new Error("Invalid content type: ".concat(type));
        }
      }
      if (httpRequest.readyState === 4) {
        if (httpRequest.status === 404 || httpRequest.responseXML === null) {
          throw new Error(isLocal() ? 'Note: SVG injection ajax calls do not work locally without ' + 'adjusting security settings in your browser. Or consider ' + 'using a local webserver.' : 'Unable to load SVG file: ' + url);
        }
        if (httpRequest.status === 200 || isLocal() && httpRequest.status === 0) {
          callback(null, httpRequest);
        } else {
          throw new Error('There was a problem injecting the SVG: ' + httpRequest.status + ' ' + httpRequest.statusText);
        }
      }
    } catch (error) {
      httpRequest.abort();
      if (error instanceof Error) {
        callback(error, httpRequest);
      } else {
        throw error;
      }
    }
  };
  httpRequest.open('GET', url);
  httpRequest.withCredentials = httpRequestWithCredentials;
  if (httpRequest.overrideMimeType) {
    httpRequest.overrideMimeType('text/xml');
  }
  httpRequest.send();
};

var requestQueue = {};
var queueRequest = function queueRequest(url, callback) {
  requestQueue[url] = requestQueue[url] || [];
  requestQueue[url].push(callback);
};
var processRequestQueue = function processRequestQueue(url) {
  var _loop_1 = function _loop_1(i, len) {
    setTimeout(function () {
      if (Array.isArray(requestQueue[url])) {
        var cacheValue = cache.get(url);
        var callback = requestQueue[url][i];
        if (cacheValue instanceof SVGSVGElement) {
          callback(null, cloneSvg(cacheValue));
        }
        if (cacheValue instanceof Error) {
          callback(cacheValue);
        }
        if (i === requestQueue[url].length - 1) {
          delete requestQueue[url];
        }
      }
    }, 0);
  };
  for (var i = 0, len = requestQueue[url].length; i < len; i++) {
    _loop_1(i);
  }
};

var loadSvgCached = function loadSvgCached(url, httpRequestWithCredentials, callback) {
  if (cache.has(url)) {
    var cacheValue = cache.get(url);
    if (cacheValue === undefined) {
      queueRequest(url, callback);
      return;
    }
    if (cacheValue instanceof SVGSVGElement) {
      callback(null, cloneSvg(cacheValue));
      return;
    }
  }
  cache.set(url, undefined);
  queueRequest(url, callback);
  makeAjaxRequest(url, httpRequestWithCredentials, function (error, httpRequest) {
    var _a;
    if (error) {
      cache.set(url, error);
    } else if (((_a = httpRequest.responseXML) === null || _a === void 0 ? void 0 : _a.documentElement) instanceof SVGSVGElement) {
      cache.set(url, httpRequest.responseXML.documentElement);
    }
    processRequestQueue(url);
  });
};

var loadSvgUncached = function loadSvgUncached(url, httpRequestWithCredentials, callback) {
  makeAjaxRequest(url, httpRequestWithCredentials, function (error, httpRequest) {
    var _a;
    if (error) {
      callback(error);
    } else if (((_a = httpRequest.responseXML) === null || _a === void 0 ? void 0 : _a.documentElement) instanceof SVGSVGElement) {
      callback(null, httpRequest.responseXML.documentElement);
    }
  });
};

var idCounter = 0;
var uniqueId = function uniqueId() {
  return ++idCounter;
};

var injectedElements = [];
var ranScripts = {};
var svgNamespace$1 = 'http://www.w3.org/2000/svg';
var xlinkNamespace$1 = 'http://www.w3.org/1999/xlink';
var injectElement = function injectElement(el, evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, callback) {
  var elUrl = el.getAttribute('data-src') || el.getAttribute('src');
  if (!elUrl) {
    callback(new Error('Invalid data-src or src attribute'));
    return;
  }
  if (injectedElements.indexOf(el) !== -1) {
    injectedElements.splice(injectedElements.indexOf(el), 1);
    el = null;
    return;
  }
  injectedElements.push(el);
  el.setAttribute('src', '');
  var loadSvg = cacheRequests ? loadSvgCached : loadSvgUncached;
  loadSvg(elUrl, httpRequestWithCredentials, function (error, svg) {
    if (!svg) {
      injectedElements.splice(injectedElements.indexOf(el), 1);
      el = null;
      callback(error);
      return;
    }
    var elId = el.getAttribute('id');
    if (elId) {
      svg.setAttribute('id', elId);
    }
    var elTitle = el.getAttribute('title');
    if (elTitle) {
      svg.setAttribute('title', elTitle);
    }
    var elWidth = el.getAttribute('width');
    if (elWidth) {
      svg.setAttribute('width', elWidth);
    }
    var elHeight = el.getAttribute('height');
    if (elHeight) {
      svg.setAttribute('height', elHeight);
    }
    var mergedClasses = Array.from(new Set(__spreadArray(__spreadArray(__spreadArray([], (svg.getAttribute('class') || '').split(' '), true), ['injected-svg'], false), (el.getAttribute('class') || '').split(' '), true))).join(' ').trim();
    svg.setAttribute('class', mergedClasses);
    var elStyle = el.getAttribute('style');
    if (elStyle) {
      svg.setAttribute('style', elStyle);
    }
    svg.setAttribute('data-src', elUrl);
    var elData = [].filter.call(el.attributes, function (at) {
      return /^data-\w[\w-]*$/.test(at.name);
    });
    Array.prototype.forEach.call(elData, function (dataAttr) {
      if (dataAttr.name && dataAttr.value) {
        svg.setAttribute(dataAttr.name, dataAttr.value);
      }
    });
    if (renumerateIRIElements) {
      var iriElementsAndProperties_1 = {
        clipPath: ['clip-path'],
        'color-profile': ['color-profile'],
        cursor: ['cursor'],
        filter: ['filter'],
        linearGradient: ['fill', 'stroke'],
        marker: ['marker', 'marker-start', 'marker-mid', 'marker-end'],
        mask: ['mask'],
        path: [],
        pattern: ['fill', 'stroke'],
        radialGradient: ['fill', 'stroke']
      };
      var element_1;
      var elements_1;
      var properties_1;
      var currentId_1;
      var newId_1;
      Object.keys(iriElementsAndProperties_1).forEach(function (key) {
        element_1 = key;
        properties_1 = iriElementsAndProperties_1[key];
        elements_1 = svg.querySelectorAll(element_1 + '[id]');
        var _loop_1 = function _loop_1(a, elementsLen) {
          currentId_1 = elements_1[a].id;
          newId_1 = currentId_1 + '-' + uniqueId();
          var referencingElements;
          Array.prototype.forEach.call(properties_1, function (property) {
            referencingElements = svg.querySelectorAll('[' + property + '*="' + currentId_1 + '"]');
            for (var b = 0, referencingElementLen = referencingElements.length; b < referencingElementLen; b++) {
              var attrValue = referencingElements[b].getAttribute(property);
              if (attrValue && !attrValue.match(new RegExp('url\\("?#' + currentId_1 + '"?\\)'))) {
                continue;
              }
              referencingElements[b].setAttribute(property, 'url(#' + newId_1 + ')');
            }
          });
          var allLinks = svg.querySelectorAll('[*|href]');
          var links = [];
          for (var c = 0, allLinksLen = allLinks.length; c < allLinksLen; c++) {
            var href = allLinks[c].getAttributeNS(xlinkNamespace$1, 'href');
            if (href && href.toString() === '#' + elements_1[a].id) {
              links.push(allLinks[c]);
            }
          }
          for (var d = 0, linksLen = links.length; d < linksLen; d++) {
            links[d].setAttributeNS(xlinkNamespace$1, 'href', '#' + newId_1);
          }
          elements_1[a].id = newId_1;
        };
        for (var a = 0, elementsLen = elements_1.length; a < elementsLen; a++) {
          _loop_1(a);
        }
      });
    }
    svg.removeAttribute('xmlns:a');
    var scripts = svg.querySelectorAll('script');
    var scriptsToEval = [];
    var script;
    var scriptType;
    for (var i = 0, scriptsLen = scripts.length; i < scriptsLen; i++) {
      scriptType = scripts[i].getAttribute('type');
      if (!scriptType || scriptType === 'application/ecmascript' || scriptType === 'application/javascript' || scriptType === 'text/javascript') {
        script = scripts[i].innerText || scripts[i].textContent;
        if (script) {
          scriptsToEval.push(script);
        }
        svg.removeChild(scripts[i]);
      }
    }
    if (scriptsToEval.length > 0 && (evalScripts === 'always' || evalScripts === 'once' && !ranScripts[elUrl])) {
      for (var l = 0, scriptsToEvalLen = scriptsToEval.length; l < scriptsToEvalLen; l++) {
        new Function(scriptsToEval[l])(window);
      }
      ranScripts[elUrl] = true;
    }
    var styleTags = svg.querySelectorAll('style');
    Array.prototype.forEach.call(styleTags, function (styleTag) {
      styleTag.textContent += '';
    });
    svg.setAttribute('xmlns', svgNamespace$1);
    svg.setAttribute('xmlns:xlink', xlinkNamespace$1);
    beforeEach(svg);
    if (!el.parentNode) {
      injectedElements.splice(injectedElements.indexOf(el), 1);
      el = null;
      callback(new Error('Parent node is null'));
      return;
    }
    el.parentNode.replaceChild(svg, el);
    injectedElements.splice(injectedElements.indexOf(el), 1);
    el = null;
    callback(null, svg);
  });
};

var SVGInjector = function SVGInjector(elements, _a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.afterAll,
    afterAll = _c === void 0 ? function () {
      return undefined;
    } : _c,
    _d = _b.afterEach,
    afterEach = _d === void 0 ? function () {
      return undefined;
    } : _d,
    _e = _b.beforeEach,
    beforeEach = _e === void 0 ? function () {
      return undefined;
    } : _e,
    _f = _b.cacheRequests,
    cacheRequests = _f === void 0 ? true : _f,
    _g = _b.evalScripts,
    evalScripts = _g === void 0 ? 'never' : _g,
    _h = _b.httpRequestWithCredentials,
    httpRequestWithCredentials = _h === void 0 ? false : _h,
    _j = _b.renumerateIRIElements,
    renumerateIRIElements = _j === void 0 ? true : _j;
  if (elements && 'length' in elements) {
    var elementsLoaded_1 = 0;
    for (var i = 0, j = elements.length; i < j; i++) {
      injectElement(elements[i], evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, function (error, svg) {
        afterEach(error, svg);
        if (elements && 'length' in elements && elements.length === ++elementsLoaded_1) {
          afterAll(elementsLoaded_1);
        }
      });
    }
  } else if (elements) {
    injectElement(elements, evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, function (error, svg) {
      afterEach(error, svg);
      afterAll(1);
      elements = null;
    });
  } else {
    afterAll(0);
  }
};

var propTypes = {exports: {}};

var reactIs$2 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$2="function"===typeof Symbol&&Symbol.for,c$2=b$2?Symbol.for("react.element"):60103,d$2=b$2?Symbol.for("react.portal"):60106,e$1=b$2?Symbol.for("react.fragment"):60107,f$2=b$2?Symbol.for("react.strict_mode"):60108,g$2=b$2?Symbol.for("react.profiler"):60114,h$2=b$2?Symbol.for("react.provider"):60109,k$2=b$2?Symbol.for("react.context"):60110,l$2=b$2?Symbol.for("react.async_mode"):60111,m$2=b$2?Symbol.for("react.concurrent_mode"):60111,n$2=b$2?Symbol.for("react.forward_ref"):60112,p$2=b$2?Symbol.for("react.suspense"):60113,q$2=b$2?
Symbol.for("react.suspense_list"):60120,r$1=b$2?Symbol.for("react.memo"):60115,t$1=b$2?Symbol.for("react.lazy"):60116,v$2=b$2?Symbol.for("react.block"):60121,w$2=b$2?Symbol.for("react.fundamental"):60117,x$3=b$2?Symbol.for("react.responder"):60118,y$2=b$2?Symbol.for("react.scope"):60119;
function z$2(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$2:switch(a=a.type,a){case l$2:case m$2:case e$1:case g$2:case f$2:case p$2:return a;default:switch(a=a&&a.$$typeof,a){case k$2:case n$2:case t$1:case r$1:case h$2:return a;default:return u}}case d$2:return u}}}function A$2(a){return z$2(a)===m$2}reactIs_production_min$1.AsyncMode=l$2;reactIs_production_min$1.ConcurrentMode=m$2;reactIs_production_min$1.ContextConsumer=k$2;reactIs_production_min$1.ContextProvider=h$2;reactIs_production_min$1.Element=c$2;reactIs_production_min$1.ForwardRef=n$2;reactIs_production_min$1.Fragment=e$1;reactIs_production_min$1.Lazy=t$1;reactIs_production_min$1.Memo=r$1;reactIs_production_min$1.Portal=d$2;
reactIs_production_min$1.Profiler=g$2;reactIs_production_min$1.StrictMode=f$2;reactIs_production_min$1.Suspense=p$2;reactIs_production_min$1.isAsyncMode=function(a){return A$2(a)||z$2(a)===l$2};reactIs_production_min$1.isConcurrentMode=A$2;reactIs_production_min$1.isContextConsumer=function(a){return z$2(a)===k$2};reactIs_production_min$1.isContextProvider=function(a){return z$2(a)===h$2};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$2};reactIs_production_min$1.isForwardRef=function(a){return z$2(a)===n$2};reactIs_production_min$1.isFragment=function(a){return z$2(a)===e$1};reactIs_production_min$1.isLazy=function(a){return z$2(a)===t$1};
reactIs_production_min$1.isMemo=function(a){return z$2(a)===r$1};reactIs_production_min$1.isPortal=function(a){return z$2(a)===d$2};reactIs_production_min$1.isProfiler=function(a){return z$2(a)===g$2};reactIs_production_min$1.isStrictMode=function(a){return z$2(a)===f$2};reactIs_production_min$1.isSuspense=function(a){return z$2(a)===p$2};
reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$1||a===m$2||a===g$2||a===f$2||a===p$2||a===q$2||"object"===typeof a&&null!==a&&(a.$$typeof===t$1||a.$$typeof===r$1||a.$$typeof===h$2||a.$$typeof===k$2||a.$$typeof===n$2||a.$$typeof===w$2||a.$$typeof===x$3||a.$$typeof===y$2||a.$$typeof===v$2)};reactIs_production_min$1.typeOf=z$2;

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$1.AsyncMode = AsyncMode;
reactIs_development$1.ConcurrentMode = ConcurrentMode;
reactIs_development$1.ContextConsumer = ContextConsumer;
reactIs_development$1.ContextProvider = ContextProvider;
reactIs_development$1.Element = Element;
reactIs_development$1.ForwardRef = ForwardRef;
reactIs_development$1.Fragment = Fragment;
reactIs_development$1.Lazy = Lazy;
reactIs_development$1.Memo = Memo;
reactIs_development$1.Portal = Portal;
reactIs_development$1.Profiler = Profiler;
reactIs_development$1.StrictMode = StrictMode;
reactIs_development$1.Suspense = Suspense;
reactIs_development$1.isAsyncMode = isAsyncMode;
reactIs_development$1.isConcurrentMode = isConcurrentMode;
reactIs_development$1.isContextConsumer = isContextConsumer;
reactIs_development$1.isContextProvider = isContextProvider;
reactIs_development$1.isElement = isElement;
reactIs_development$1.isForwardRef = isForwardRef;
reactIs_development$1.isFragment = isFragment;
reactIs_development$1.isLazy = isLazy;
reactIs_development$1.isMemo = isMemo;
reactIs_development$1.isPortal = isPortal;
reactIs_development$1.isProfiler = isProfiler;
reactIs_development$1.isStrictMode = isStrictMode;
reactIs_development$1.isSuspense = isSuspense;
reactIs_development$1.isValidElementType = isValidElementType;
reactIs_development$1.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$2.exports = reactIs_production_min$1;
} else {
  reactIs$2.exports = reactIs_development$1;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$2.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols$1) {
			symbols = getOwnPropertySymbols$1(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs$2.exports;
var assign = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$2.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

// Hat-tip: https://github.com/developit/preact-compat/blob/master/src/index.js#L402.
var shallowDiffers = function shallowDiffers(a, b) {
  for (var i in a) {
    if (!(i in b)) {
      return true;
    }
  }

  for (var _i in b) {
    if (a[_i] !== b[_i]) {
      return true;
    }
  }

  return false;
};

var _excluded = ["afterInjection", "beforeInjection", "evalScripts", "fallback", "loading", "renumerateIRIElements", "src", "useRequestCache", "wrapper"];
var svgNamespace = 'http://www.w3.org/2000/svg';
var xlinkNamespace = 'http://www.w3.org/1999/xlink';
var ReactSVG = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReactSVG, _React$Component);

  function ReactSVG() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.initialState = {
      hasError: false,
      isLoading: true
    };
    _this.state = _this.initialState;
    _this._isMounted = false;
    _this.reactWrapper = void 0;
    _this.nonReactWrapper = void 0;

    _this.refCallback = function (reactWrapper) {
      _this.reactWrapper = reactWrapper;
    };

    return _this;
  }

  var _proto = ReactSVG.prototype;

  _proto.renderSVG = function renderSVG() {
    var _this2 = this;

    /* istanbul ignore else */
    if (this.reactWrapper instanceof Node) {
      var _this$props = this.props,
          beforeInjection = _this$props.beforeInjection,
          evalScripts = _this$props.evalScripts,
          renumerateIRIElements = _this$props.renumerateIRIElements,
          src = _this$props.src,
          useRequestCache = _this$props.useRequestCache;
      /* eslint-disable @typescript-eslint/no-non-null-assertion */

      var afterInjection = this.props.afterInjection;
      var wrapper = this.props.wrapper;
      /* eslint-enable @typescript-eslint/no-non-null-assertion */

      var nonReactWrapper;
      var nonReactTarget;

      if (wrapper === 'svg') {
        nonReactWrapper = document.createElementNS(svgNamespace, wrapper);
        nonReactWrapper.setAttribute('xmlns', svgNamespace);
        nonReactWrapper.setAttribute('xmlns:xlink', xlinkNamespace);
        nonReactTarget = document.createElementNS(svgNamespace, wrapper);
      } else {
        nonReactWrapper = document.createElement(wrapper);
        nonReactTarget = document.createElement(wrapper);
      }

      nonReactWrapper.appendChild(nonReactTarget);
      nonReactTarget.dataset.src = src;
      this.nonReactWrapper = this.reactWrapper.appendChild(nonReactWrapper);

      var afterEach = function afterEach(error, svg) {
        if (error) {
          _this2.removeSVG();

          if (!_this2._isMounted) {
            afterInjection(error);
            return;
          }
        } // TODO (Tane): It'd be better to cleanly unsubscribe from SVGInjector
        // callbacks instead of tracking a property like this.


        if (_this2._isMounted) {
          _this2.setState(function () {
            return {
              hasError: !!error,
              isLoading: false
            };
          }, function () {
            afterInjection(error, svg);
          });
        }
      };

      SVGInjector(nonReactTarget, {
        afterEach: afterEach,
        beforeEach: beforeInjection,
        cacheRequests: useRequestCache,
        evalScripts: evalScripts,
        renumerateIRIElements: renumerateIRIElements
      });
    }
  };

  _proto.removeSVG = function removeSVG() {
    var _this$nonReactWrapper;

    if ((_this$nonReactWrapper = this.nonReactWrapper) != null && _this$nonReactWrapper.parentNode) {
      this.nonReactWrapper.parentNode.removeChild(this.nonReactWrapper);
      this.nonReactWrapper = null;
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this.renderSVG();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this3 = this;

    if (shallowDiffers(prevProps, this.props)) {
      this.setState(function () {
        return _this3.initialState;
      }, function () {
        _this3.removeSVG();

        _this3.renderSVG();
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this.removeSVG();
  };

  _proto.render = function render() {
    /* eslint-disable @typescript-eslint/no-unused-vars */
    var _this$props2 = this.props;
        _this$props2.afterInjection;
        _this$props2.beforeInjection;
        _this$props2.evalScripts;
        var Fallback = _this$props2.fallback,
        Loading = _this$props2.loading;
        _this$props2.renumerateIRIElements;
        _this$props2.src;
        _this$props2.useRequestCache;
        var wrapper = _this$props2.wrapper,
        rest = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion


    var Wrapper = wrapper;
    return /*#__PURE__*/React.createElement(Wrapper, _extends$1({}, rest, {
      ref: this.refCallback
    }, wrapper === 'svg' ? {
      xmlns: svgNamespace,
      xmlnsXlink: xlinkNamespace
    } : {}), this.state.isLoading && Loading && /*#__PURE__*/React.createElement(Loading, null), this.state.hasError && Fallback && /*#__PURE__*/React.createElement(Fallback, null));
  };

  return ReactSVG;
}(React.Component);
ReactSVG.defaultProps = {
  afterInjection: function afterInjection() {
    return undefined;
  },
  beforeInjection: function beforeInjection() {
    return undefined;
  },
  evalScripts: 'never',
  fallback: null,
  loading: null,
  renumerateIRIElements: true,
  useRequestCache: true,
  wrapper: 'div'
};
ReactSVG.propTypes = {
  afterInjection: propTypes.exports.func,
  beforeInjection: propTypes.exports.func,
  evalScripts: propTypes.exports.oneOf(['always', 'once', 'never']),
  fallback: propTypes.exports.oneOfType([propTypes.exports.func, propTypes.exports.object, propTypes.exports.string]),
  loading: propTypes.exports.oneOfType([propTypes.exports.func, propTypes.exports.object, propTypes.exports.string]),
  renumerateIRIElements: propTypes.exports.bool,
  src: propTypes.exports.string.isRequired,
  useRequestCache: propTypes.exports.bool,
  wrapper: propTypes.exports.oneOf(['div', 'span', 'svg'])
} ;

var img$O = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='iso-8859-1'%3f%3e%3c!-- Generator: Adobe Illustrator 16.0.0%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='430.114px' height='430.114px' viewBox='0 0 430.114 430.114' style='enable-background:new 0 0 430.114 430.114%3b' xml:space='preserve'%3e%3cg%3e %3cpath id='Facebook_Places' d='M356.208%2c107.051c-1.531-5.738-4.64-11.852-6.94-17.205C321.746%2c23.704%2c261.611%2c0%2c213.055%2c0 C148.054%2c0%2c76.463%2c43.586%2c66.905%2c133.427v18.355c0%2c0.766%2c0.264%2c7.647%2c0.639%2c11.089c5.358%2c42.816%2c39.143%2c88.32%2c64.375%2c131.136 c27.146%2c45.873%2c55.314%2c90.999%2c83.221%2c136.106c17.208-29.436%2c34.354-59.259%2c51.17-87.933c4.583-8.415%2c9.903-16.825%2c14.491-24.857 c3.058-5.348%2c8.9-10.696%2c11.569-15.672c27.145-49.699%2c70.838-99.782%2c70.838-149.104v-20.262 C363.209%2c126.938%2c356.581%2c108.204%2c356.208%2c107.051z M214.245%2c199.193c-19.107%2c0-40.021-9.554-50.344-35.939 c-1.538-4.2-1.414-12.617-1.414-13.388v-11.852c0-33.636%2c28.56-48.932%2c53.406-48.932c30.588%2c0%2c54.245%2c24.472%2c54.245%2c55.06 C270.138%2c174.729%2c244.833%2c199.193%2c214.245%2c199.193z'/%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3c/svg%3e";

var img$N = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' focusable='false' viewBox='0 0 13 13' xml:space='preserve' aria-hidden='true' role='presentation'%3e %3cpath d='M1.5 4l5 5 5-5z'%3e%3c/path%3e %3cpath fill='none' d='M0 0h13v13H0z'%3e%3c/path%3e%3c/svg%3e";

var img$M = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 24.0.3%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 13.4 11.6' style='enable-background:new 0 0 13.4 11.6%3b' xml:space='preserve'%3e%3ctitle%3e%c7%a8%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cg id='Check-Out-Horizontal'%3e %3cpath id='%c7%a8' d='M8.6%2c4.9l1.6-0.7c0.3%2c0.1%2c0.5%2c0.1%2c0.8%2c0.1c1.4%2c0%2c2.4-1%2c2.4-2.1C13.4%2c1%2c12.3%2c0%2c11%2c0C9.7%2c0%2c8.6%2c1%2c8.6%2c2.1 c0%2c0.5%2c0.2%2c0.9%2c0.5%2c1.3L8.6%2c4.9z M10%2c11.6v-1c0-1.5-1.5-2-3.5-3c-0.4-0.2-0.5-0.5%2c0-1c0.5-0.5%2c1-2.5%2c1-3.5c0-1.4-1.2-2.5-2.5-2.5 c-1.4%2c0-2.5%2c1.1-2.5%2c2.5c0%2c1%2c0.5%2c3%2c1%2c3.5c0.5%2c0.5%2c0.4%2c0.8%2c0%2c1c-2%2c1-3.5%2c1.5-3.5%2c3v1H10z'/%3e%3c/g%3e%3c/svg%3e";

var img$L = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' x='0px' y='0px' viewBox='0 0 440 440' style='enable-background:new 0 0 22 22%3b' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bdisplay:none%3b%7d .st1%7bdisplay:inline%3b%7d .st2%7bfill:%230c3c6b%3bstroke:grey%3bstroke-miterlimit:10%3b%7d .st3%7bfill:%230c3c6b%3bstroke:%23C1272D%3bstroke-miterlimit:10%3b%7d .st4%7bdisplay:inline%3bfill:none%3bstroke:%23C1272D%3bstroke-miterlimit:10%3b%7d .st5%7bfill:white%3b%7d%3c/style%3e %3cmetadata%3e%3c%3fxpacket begin=' ' id='W5M0MpCehiHzreSzNTczkc9d'%3f%3e %3cx:xmpmeta xmlns:x='adobe:ns:meta/' x:xmptk='Adobe XMP Core 5.6-c145 79.163499%2c 2018/08/13-16:40:22 '%3e %3crdf:RDF xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%3e %3crdf:Description xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:xmp='http://ns.adobe.com/xap/1.0/' xmlns:xmpGImg='http://ns.adobe.com/xap/1.0/g/img/' xmlns:xmpMM='http://ns.adobe.com/xap/1.0/mm/' xmlns:stRef='http://ns.adobe.com/xap/1.0/sType/ResourceRef%23' xmlns:stEvt='http://ns.adobe.com/xap/1.0/sType/ResourceEvent%23' xmlns:illustrator='http://ns.adobe.com/illustrator/1.0/' xmlns:xmpTPg='http://ns.adobe.com/xap/1.0/t/pg/' xmlns:stDim='http://ns.adobe.com/xap/1.0/sType/Dimensions%23' xmlns:xmpG='http://ns.adobe.com/xap/1.0/g/' xmlns:pdf='http://ns.adobe.com/pdf/1.3/' rdf:about=''%3e %3cdc:format%3eimage/svg%2bxml%3c/dc:format%3e %3cdc:title%3e %3crdf:Alt%3e %3crdf:li xml:lang='x-default'%3eIcons%3c/rdf:li%3e %3c/rdf:Alt%3e %3c/dc:title%3e %3cxmp:CreatorTool%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/xmp:CreatorTool%3e %3cxmp:CreateDate%3e2019-08-21T23:41:29%2b02:00%3c/xmp:CreateDate%3e %3cxmp:ModifyDate%3e2019-08-21T23:41:29%2b02:00%3c/xmp:ModifyDate%3e %3cxmp:MetadataDate%3e2019-08-21T23:41:29%2b02:00%3c/xmp:MetadataDate%3e %3cxmp:Thumbnails%3e %3crdf:Alt%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpGImg:width%3e22%3c/xmpGImg:width%3e %3cxmpGImg:height%3e22%3c/xmpGImg:height%3e %3cxmpGImg:format%3eJPEG%3c/xmpGImg:format%3e %3cxmpGImg:image%3e/9j/4AAQSkZJRgABAgEAYABgAAD/7QAsUGhvdG9zaG9wIDMuMAA4QklNA%2b0AAAAAABAAYAAAAAEAAQBgAAAAAQAB/%2b4ADkFkb2JlAGTAAAAAAf/bAIQABgQEBAUEBgUFBgkGBQYJCwgGBggLDAoKCwoKDBAMDAwMDAwQDA4PEA8ODBMTFBQTExwbGxscHx8fHx8fHx8fHwEHBwcNDA0YEBAYGhURFRofHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8f/8AAEQgBAAC8AwERAAIRAQMRAf/EAaIAAAAHAQEBAQEAAAAAAAAAAAQFAwIGAQAHCAkKCwEAAgIDAQEBAQEAAAAAAAAAAQACAwQFBgcICQoLEAACAQMDAgQCBgcDBAIGAnMBAgMRBAAFIRIxQVEGE2EicYEUMpGhBxWxQiPBUtHhMxZi8CRygvElQzRTkqKyY3PCNUQnk6OzNhdUZHTD0uIIJoMJChgZhJRFRqS0VtNVKBry4/PE1OT0ZXWFlaW1xdXl9WZ2hpamtsbW5vY3R1dnd4eXp7fH1%2bf3OEhYaHiImKi4yNjo%2bCk5SVlpeYmZqbnJ2en5KjpKWmp6ipqqusra6voRAAICAQIDBQUEBQYECAMDbQEAAhEDBCESMUEFURNhIgZxgZEyobHwFMHR4SNCFVJicvEzJDRDghaSUyWiY7LCB3PSNeJEgxdUkwgJChgZJjZFGidkdFU38qOzwygp0%2bPzhJSktMTU5PRldYWVpbXF1eX1RlZmdoaWprbG1ub2R1dnd4eXp7fH1%2bf3OEhYaHiImKi4yNjo%2bDlJWWl5iZmpucnZ6fkqOkpaanqKmqq6ytrq%2bv/aAAwDAQACEQMRAD8A9BfmJ5k8vaL5YvU1jUrXTjqFvcW1mbqZIRJK0TAIpcqO%2bKvJfyd078iPNkUnl0%2bXdGuPMGiW1qLuRY4JxdA28fqzxyJyWTjMzJJQnff9oYqzT8q9E0jRPPX5jaXo9nFYadb32m%2bhaW6CONOemQu3FRsKuxJ98VTz81fzM0X8u/Kc%2buajSWc/utOsAwV7i4IqqDrRR1dqbD3oCq8//K/yz%2bSXma1uLe7tNB1vzRJeape3Sqba7uGt5dRmeCRmQvUejLF32qAaHbFWTeWfKflry1%2bb97aaBpltpdtN5fgllhtY1iVn%2buyryIUDegAxV6XirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVeTfnf%2bSui%2bfEGt6xqt/DFollM1tp9q0KxEgGSRqvHIQ0nFVJ8ANsVYj/zjz%2bQNjoGuHz1cPKYJbeFvLltLIGkSO6tkeaWZo1jVjWRo0HEbAsRuKKvSPIn/kzPzM/5jtL/AO6Tb4qkH/ORv5Mv%2bYfliO60uv8AiXRlkfToy1EnR6GSA1PEM3AFG8RQ7HFWMfkn/wA4/eWNNvrDzxpOq6nbXlle39r9UkkgkjkS0up7FxIRDGSsqxcqfs161FcVeoR/%2bTpuP/Abg/6jpsVZrirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVUru1gu7Wa0uF529xG0UyVI5I4KsKggioPbFWGQ/kx5Cghjggj1OKGJQkUSa1rCqqqKKqqLugAHQYqnflfyR5b8rm9bRoJYpNRkSW9muLq5u5JXjQRoWkupJn%2bFAFG/TFU9xVhR/J3yH6s0kcGoQevLLcSR2%2br6rBH6k8jSyMscV0iLydyxCgCpxVMvLn5feVvLuoT6jpcNyL64hW3luLq9vb1jErFwg%2btzT8RyNfhpirI8VdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirHPP8A51tPJnlqXXbq0nvo45oIFtbXh6rvcSrEgXmyL9px3xV5Z%2bZv/OQHnPy55Z/Sln5I1LSpI7iJWudYjhNqUYkNGfQm9QM37JGKp1%2bSH/OQmn/mbc3OmNpMumavZW/1mcB1mt2j5rHVH%2bBw3J/slPpxV6freqw6Ro1/qs6NJDp9tNdSxpTkywxmRgtaCpC7Yq8n1f8APnzC/kq917SfIutxQtpst9p%2bp3Eds1qqmAyxTyBZuRiAo7UFeOKpD%2bTn/OViec/MFh5X1vRTZ6xflkgvLJ%2bdszJG0h5xyH1IxRDSjPir13z7%2bY3lLyHpkGpeZbtrS0uZhbQskUkxaQqz04xqxHwodzirBv8AobD8kv8Aq7z/APSHc/8ANGKu/wChsPyS/wCrvP8A9Idz/wA0YqzryH%2bYvlPz3pc2p%2bWrtru0t5jbzF45IWWQKr0KyKp%2by4NcVYn52/ON9C823fl%2bGXQrI2UFvNJNrupS2LSm4DGkCRW1zyVAg5EkbnpiqTf8r4vP%2brt5G/7j91/2QYqj/Ln53Sah5n0jRp5/Lt%2bur3DWqjQ9VmvbiJhBJOJXiltbcel%2b54k86gsNsVet4q%2bdfP3/ADmT5c0PWZ9L8t6SdeW2cxzai1wLe3ZlNG9GkcrSL25bDwqN8VROg/8AOU0/nTT10jyf5bnPnu7cRW1jOwlsYYyPju5rhRGfSi/aBVSTQDFXu/1sWenJcatPBA8aJ9bn5enAJDQNxMh2UufhqcVYh56/Or8u/Jmlx3%2bp6pHc%2btJ6cFpYNHczuerEIrABVG5ZiB9JAxVj3k//AJyg/KrzRrcWj29zcadczqTBLqMaQQuy78PUEjgMR05Ur060GKvRNB82%2bWPMAnOh6ra6kLZzHcfVZUlKOtKhgpNOoxVinmr829LsfMuoeR9OhupvOC6ZcX2nokIkhaSO2eaNdm5sxKU4hdztirD7D/nIqHyl5L8uy/mfY6ha%2baNWiupp7aKz9EosN3JFHzileJkJjVCNtxviqqv5yeaPK2u%2bd77z9p15B5Q0m9itvL9xFYtGZllllUFJJDGkw4ou4bFXp/8AjLSP8Df414y/of8ARf6Z48R631b6v9ZpwrTn6fbl174q%2bf8A/nJX8%2bbGw1x/IsGmpqUFm1pd6hces0TJdxSrcRxLxVwQoVOXzI2pirzjUPzV8xecP%2bcf9Z0fWoJZ20W/sjbasalWilkfhbyMeskdPhPdeu4qVU6/5wl/5T/Xf%2b2Uf%2bomLFWVf85OfnV5h0LzfbeVLexlj0WK3eXUObGIagt3A8IVHXl%2b6i9Q/wDPQbj4Riqr%2bXv5zWXnH8lfOnlV7NNOu/Lvle5isIVkMhmsobB4A5LBauhVee37QxV4j/zjd/5O3yt/xnm/6hpcVfTv/OVXmuPy35O0i6fQ9L10TaiIvq%2bsQPcRJ%2b4kbmipJEQ%2b1K16Yq8B/wAUedv/ACy2h/8AcA1D/qtiqZWF554u7OS5b8pvKFkVWVre2vrCS0ubo26CWZbW3nuklmMcZ5NwU/ftir2b/nGPzkNd8g6/qMOh6VobWl46rbaTA9vDIVtkcPIrSSktvStRtir5b1j85vMmt67da5rWm6Rql/dpFGz3djHMESAEKIw1eNeW/jiqIvPN/miytYLq88kaJb210VFvLJosaq5cckAJHVl%2bJfEbjbFXqf5FajY69ceXdZk0TS9P1O180x2aXWnWiWrtBLpF9I0b8Oo5xg4qn/8Azl3%2bbPmzy/qGneUNBupNNhvbM3uoXkB4yyJJJJCsKyDdFHpMW47mo%2blV8w%2bUPKGv%2bbtfttC0K2Nzf3J2HRI0H2pZW6IiDqf44q9ftPzR8r/lJqen%2bXfJPHVVtbqKXzl5jQL6momJqvaWjNyCW6bgH9o%2b1Syr3b8/PMem6/8A843ar5g0tvVsdQh026tjIorxbULY8XQ1FR0YYq%2bU/LN5aXtt5r89ajpVhd32kQ2a2Wlpaww6es11ItuLiS0hWOJkjVPs8eLSMC1e6qra6sPPXlvzINbsrKHVNCsP0pYaxZWlvYtxS5hge1nS1SGKRJBP8BK8g4G5BIxV6b/zhD/ylXmX/mBh/wCT2Kq/54p5a/5Xnrk2trq/KDQ4X06TRB%2b9S440VpiN1ioTyxV5Y6eStR0zydPqq%2bY7zULi6MfmCVwZYpLf1D8OnM9S0nGm3jiqJ1Wfyhd2PnOGeTzRcLaSRny1HclniiFDX9IhqhWr9mmKvq3/ANdY/wDBG/7tGKpx%2bd1x5ltvIUtx5dj1CbUobyxk9HSVla7eFbqMzKiw0cgxhgw6U67Yq%2be/za8x6FafkqfKOi%2bSPM%2bgWwvYbmXUtZ00WsMsxctI80wkaskh6bdAAKAAYqif%2bcLfLmv23mfV9audOuINJuNO9G3v5InSGSQzxvxjdgA/wiu2Kvof8zPKNnrGjSavDBKfMehW17PoV1a8hcpPJayRcIynxnnyFAN%2bQUjcYq8m1b83tV/5UveeXtX8lecv0t/hyXT9Q1e70x/q/wBY%2bomGW5muJJefp86u8jLWm5GKvEf%2bcY/LfmC9/NnQdWtdOuZtKsJpTeX6ROYIq28igPLTgCSwoK1xV9Jf85R/l35v88eT9KsPK9iNQvLXUBPND60MJEXoyJy5TvGp%2bJhtWuKvDdZ/Kn/nLXWXL6hbXcjGee5%2bDUdPhHqXJVpaCK4SikqKL9lf2QMVRWkflv8A85ZaXpVxpsGlGWOf1DFcXV3plxc2xnj9GZrWeWd5ITJH8LcD%2bO%2bKvXv%2bcc/y683eRvy58wWPmiyFhe3dzNcQwCWKY%2bn9WRORaFpE3ZTtyrir5P8AKv5r%2bZ/LOkLpWnH07dZHl5Q3Wo2TMZKV9T6hdWiyUps0gZgNq0AAVX6j%2bYVpLfXuqWVhJFqWrX8Wp6kJ5xLAJY5vrDLCoRJArS9ObsVX4akksVX0F/ziTp%2bleZrzzL501Wwt319NS9W3mjT044GuImMnpRKfTX7ZFacqHrucVZN/zlB5EsPN1voOnWOlXV75zvJmg0i7twUt4YFo1wb2YqyCJQeSj7Vfs/tVVROlf841QaP%2bXj%2bVtE15tKv9UA/xJrcVuJLi7Wn%2b88bGRDDACT8I3YdTu1VWHR/84O6OJFMnmy4aMEc1WzRWK13AYytQ%2b9Dir1nz9%2bVK6t%2bTc/5deXJI7KMQWltZS3RYqFtbiKYmQopYswiNSB9o4q8Q8sf84nfmr5a1Fr7Ttf0ZvVja3u7W4Sea2uLeSnOGeF4SsiNQbHuARQgHFU01/wD5xo/M7VNKl0iyuvLOgaVcyLNe2ekxXkS3EkZJT1nlE8rqhJKpz4A7hemKsu/5x7/ITzH%2bWes6tfatqFnex6hbxwRLa%2bryVkfkS3qIm2KsI/Nu/wBQs/zw8zmy822vlJpfLsSSy3cMMwu0I3tUE32XfqCu%2bKvM9O1bV18vflxGv5g2NvHaagXs7Bre2L6K3qsfrFwx%2bKVf2qSbb4qrX2r6y1n%2bZYb8xbCZbySI3kS21sDrhCmjW5A/dcen7vFX0z/66x/4I3/doxV6riqG1DS9M1KFYNRtIb2FHWVIriNJVEiGqOFcEBlPQ9sVRIAAoNgOgxV2KqV1a2t5azWl3Clxa3CNFcW8qh45I3BV0dGBVlZTQg9cVbtrW2tbeO3tYkgt4hxihiUIiqOyqtABiqpirsVdirsVSo%2bU/KxNTo1iSep%2brQ/804q7/CflX/qzWP8A0jQ/804qjLHTNNsEaOxtIbRHPJ0gjWME9KkKBiqJxV2KuxV2KuxV2KuxVItY8heRtavTfaz5d0zUr1lCG6vLK3nlKr9leciM1B23xVBf8qn/ACs/6k3Q/wDuG2f/AFTxV3/Kp/ys/wCpN0P/ALhtn/1TxVkH6J0r9Ffoj6nB%2bifQ%2bqfo/wBJPq/1fh6fo%2blTh6fD4eFKU2xVFYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FWJeevMPmTTr7y7pfl9bP69rt7Na%2brfrK8Uaw2c92TSFkap%2br8fpxV4l%2bYH/OUPmrydrN7obppWo6rYSejcxwWt1HEr0rTnLcqx%2baoRir3T8tPNN55r8h6L5ivIo4LrU7cTyww8vTViSKLyLGm3c4qq/mD5ivfLnkzVdbsY45ruyiDwxz8vTLF1X4uJVqfF2OKvJ/zQ/PHzp%2bXF1b2OtTaNcahdQG5gtrS0vGJjBZal5LiJB8SEUrX2xVkP8Azj5%2bb%2bt/mZo%2br32q2dtZvp9zHBEtqJAGV05Vb1Gff5Yq9YxV5/r/AJr87/4r1vS9EOlW%2bn6Dp1pqF3PqEdzLI31o3NQogdBRFtPDvirxJf8AnMDzHLr%2bn6bY2enX0F3cRQSXP1e4gHGSQISga4kav%2bsoxV9W4qxb8wPMOu6NaaRHoaWrahq2pw6cjXokaFBLHI5ciJkbb0/HFXi35lf85K%2bbPImuXfl%2b7Gk3%2btWYj9aC2tLtYlMsazIGlkuE6pID8Ktir2D8nvO2oeePy50jzRqEEVteah9Y9WC35emvoXUsC8eZZt1iBO/XFWZYq7FXYq7FXYq7FXYq7FXYq7FXYq8O/PH83dH8rebPLUqWd1qE/ly9e81FYoXEPp3NlPaems5Hp%2bqv1gPx6dia7Yq%2bVfzuu0vvzT8w38aPHFeXAnjjmUxyqskasFkjb4o3Fd1YVGKvtz8gf/JNeU/%2bYFf%2bJNirHf8AnJH8wLXQfLUPltrG5urrzJzijniidoolhpIxJUHm5IA4LvSrHoKqvAP%2bcrfM%2bmeafMHlzW9MEqW0ulBWgukMFxG4uZqpJE/xAj2qOhrQjFXpn/OEP/KLeZf%2bY6H/AJM4q%2bk3dERndgqKCWYmgAG5JJxV8tXP/OQvl/UPzV1%2b10e3nu9L8w6cNGe49MH97ZLdGG5iKsxaFzcHlyUUX4u1MVfNHlZSvmzR1NKi/tgaEEf3y9xUYq/T3FXzx%2bev56aX5b/MTRPL97Y3LWehz2%2br3U8cYLTSlWCJF6jxqUEcjcnFfi%2bH9k4q%2be/%2bci9X07Wfzh1vVtNnW5sL6LTp7WdejRyabbMp9vcdsVfW3/OLn/kifLP/AEff91C4xV6rirsVdirsVdirsVdirsVdirsVdirBfzAtba685fl5DcxJPF%2bl7t/TkUMvKPSLx0ah7qyhh74q%2bMf%2bch9H1e0/NrzLeXVjcW9pdXrNbXEsTpHIpRaFHYBWHyxV9k/kD/5Jryn/AMwK/wDEmxVW/O62t5vyx1tpYkkaCNJIWZQSj%2boq8lJ6HixFR2JxV89/85p6LrM/m/RtSgsLiXTotM9OW8SJ2hVxPIxVpAOIPEg0rirKf%2bcIf%2bUW8y/8x0P/ACZxV9KYq8t1LRbXUPzH883TWxudRsvLdjFpuxdo2uxqCy%2bkgr8cnpqtQK027nFXw3oemajp3nLR7bULWazuVvrblDcRtE4/fL1VwDir9NsVYD%2bZenWQ13yXqqxBdRXW7ez%2bsrUObeSOWRo2p1XnGDQ4q%2bSv%2bcqNH1eL85vMGpS2NxHp1z9S%2br3rROsMnGxgRuEhHBqMpU0PXFX09/zi5/5Inyz/ANH3/dQuMVeq4q7FXYq7FXYq7FXYq7FXYq7FXYqlHmTyj5b8y28FvrthHfw20nrQJJyHCTiU5AqVNeLEYqwvzL%2bXX5FaBp31vzDp2n2NlIwiVrqV1EjnoiqXq7H%2bUAnFWTeRNa8hXujpp/k28tJtO0wCEWlq9TAKkhWjPxpXenIb4qnWr6RpusabcaZqdut1YXS%2bncW8leLrWtDSnhirDr78pfyisLOa9vtHtLWzt1Mk9zNLJHGiL1Z3aQAAe%2bKqP5cat%2bStncTaP5FutOguL3/SHs7Zyrz8RTmiybyUXutdsVehYqwP8wtI/J6G6TWvPA0%2bC6mRYIri7mMUkixklURQys/HmdlB64qx7QtD/wCcbNb1aC10uPSrrVYWWa1tmldZ%2bSmoaOOVlZqU/ZGKvXcVSvzF5Y0DzHYpYa5ZR31okizpDJWgkQEKw4kGoDHFWKv%2bUf5PNcGxk0aya4dTytWlcuVI3qhkrSh8MVT/AEkeTPKv6M8n6c9rpjTrO%2blaOrhXdVZppzEhPI0LMx%2bnFU/xV2KuxV2KuxV2KuxV2KuxV2KuxVgn5y2Vpf8AljTLG9hS4s7vX9DgubeQBkkik1OBXRlPUMpIIxV5pqFl%2bXXkH84buW50WLR7FrTT1sdRskWBbKB2nM92RGrEq9wkdvLJtwVgD8LYqmsXnDy1rn5weX5/KZe8ufrVxBda2jlorywktJ5buBTxXnBZzxWpVuRUO/Fd%2bWKvXPNn/KK6z/zA3P8AyZbFXz95h8n%2bR/L2gfll5hTylaXkLQrcX8UEMaS3l6NNMtrC78TzMsoZgh%2b24Ub1xVMvzS/MHyFqvle2tfLt5Nrur21ssmm30LF5dOvbejWMj1TktzcXRjgKbMwJqKA4q9l84%2bZ38s%2bTr7XZoPXurWBfStENBLdSlYoYQT2eZ1WvvirHNA8k6l5dex1qaxi8zectUuYl8ya5cSpFJbQSA%2bqbPmrcYINlSFOPIbnfFU681eXbXzNfJoetaBBf%2bXpLV5W1WSVRNBdK6iOOFAvqoxWriVHFKYql/wCXGp6xbXuteS9cu3v9Q8uPC1nqUtPVutNu1ZrWSU0XlKhjeKRgNyvLviqA8yeZdV83ak3lHyebuC2ivPqvmbzTAqxw2kUSlp7a1mc1e6YhY6xowj5VJBGyrHfzI8u/k75O0WDS4PJ9nrPmjV2MOiaakYfUrq4P%2b7WvD/pKKh%2bJ5fU28a4qq/kp5Nh0LzJqkPmWebV/zDtbCxkvdUupDMkVpc%2bqsdrZvIzvwi9AiRzuzYqwv/nIi5/OXVfzA/Q/kfUbmx0zSdNtrm8FtqEWmL6l3LMqtJLJNb8%2bXpcQKmlOm%2bKvM5fKn/OVcVvDcy69qUdvccvQmbzPbBJOBo3BjfUah60xVW/wb/zlpHfJZnWNUF8aFLVvMlv6hqKj92b2pqPbFX1v%2bV%2bs6jrf5deW9X1KT1tQvtOtprqagXnI0YLNQUA5HfbFWT4q7FXYq7FXYq7FXYq8t/O/zfoen2WnaXPLMNQh1DTtWKRW11Oohsb2O4cM9vFKEd1iIQNTfrQb4qlFtq3lT8zPySm80iyuor/RrO%2blsrqeWdby0vYIWZmgvUMbyJyp8SmjUowqCoVZv%2bW3kny7omkWurWcEkmr6nZWzX%2bp3c813dSD01bh607yOqAnZFIX2xVJfzr/ADU0rydY2eiXNtPPeeZfUtIXSORooo2HCSRiiOzsvMUjQFj%2btVU/LuHyb5u/L5NFuEk1W0gtrWx1Oyv4biONZbeBE5QxXKROqFk5I6qN99mGKpR%2bT3kXy7PPq%2bsX0dxqV/ovmDVbHSJNQurm8W1htbpoofRS4kkRXVFA9SnP3xVlv5v2t5P%2bXupSWcRnnsJLPU/QUVaRNNvIb2RFHdmS3IHviqTTatqH5heY5tK0DW5dM8paba2tzqGo6awS7vJr6P14IYZiG9GJYOLuy/GSwApviqj5o0rWfy7sW826Nrep6lo%2bnFJNe0PVbqTUFks%2bQWaa2mnLzRSwqTJTmValKYqmvlS5Gs/mh5u1m2o2nadbWGgJOu6yXVq9xdXIB/4qN4qH/Kr4YqwrT/zE/wCVZ6LL5Fn0e7vvOgvLr/D1nHGzR6st5dSTx3KzqCihRJ%2b/DHkpB7Yq15A1LyZ5e1W%2b8yec9ZfVfzCvyYtQvY7K9kt7SNT/ALx2RWFkEKdOSn4%2buKppq%2bt%2bW/MvnzyzqPk2G7m8yw3caapqMVtc2sQ0hAxuI7t50ijkU8h6a7tzpSmKsT/OmXTIvN/muS/0y81eOPTtAljstPZUn5pd3lH%2bOK4UqpPxVQ4qwrz1aeS5/wAuPIUl35J8wzQsmqNbWsFwI5rfnelpPXb6qyt6rn1EpGlFPcYqyzzHaeUf%2bhidGnuPK%2btS6ij6c0erxz8bGLhAnB5I/QPwxAD1P3o6HFXr35Kf%2bSj8of8AbKtf%2bTQxVmuKuxV2KuxV2KuxV2Ksa/MHQNa1zQI7TRpoYb6G9s7xfrLyJDIlrcpM8UjRBn4yKhU0HfFWMXflz81ZPKlz5Zs7Lyzp%2bmzWUthFHbyXqrDFJGY/gX0afCGxV6BotjJYaNYWMjB5LS3igdlrxLRoFJFe22KobzP5ftNd0iaznhiknUGSxllFfQuVU%2blMjD4lZGPVd8VYno1n%2bdOmaPY6bw8vXH1K3it/rEk99zk9JAnNv3XVuNTiqa/lt5X1ny7pGoxaxJbyX%2bparfarL9TLmFDfTGbgpkVGPHlTcYqyzFWAL5B8y%2bWrq4m8galbWmm3UjTS%2bWtTieWwjlkPJ3tJIWSW2DNuUoyVJIUYq3daH%2bbeuA2Wp61p2gaZIONxJokc0186nZljuLnikFR%2b0ImYdqYqy3y95e0fy9o1ro2j2y2un2i8IYVqepqzMx3ZmYlmY7k7nFUl0P8ALjRNL836v5uklm1HXdVbil3eMHNrbAClrbABRHEDU%2bJ7k4qyvFXYqxjzL%2bXHljzDq9trV4t1a6zaQm1h1LT7u5sbgQMxYxGS2kjLJyNaHFUD/wAqn0X/AKvfmP8A7j%2bq/wDZRiqldfk55ZvLaS0vtS1%2b7s51Mdxaz65qkkUiNsyOhuKMrDYjFWZafp9lp1hb6fYQpbWVpGkFtbxjikccahUVR4ADFURirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirzXyt5n/N3zL5c03zBZWPl%2bC01S3juoIZp70yIkq8lVysXGoB3piqY3N7%2bcFrby3NynlmC2gRpZ55bm9RERByZ3ZogFVQKknFUl8vfmb5rvbvQp7iPR7vRtY1WbRZJLCS8W4huYYLiZucdzFHShtSKHehBxVB69%2bdN5Zeadc0cal5a0mPSLpbSOLWbyeG5lBt4ZjMEjRl4EzFR/qnFUJ/yvC9/wCpn8jf9xG6/wCqeKoXVPz%2bvtP0y7v11zyZfNaQyTiyttQuTPOY0L%2blEDHTm9OK%2b%2bKp3%2bamqa7qs0ekacty1lBoV35hu9OspZIbi/khMcdtY%2brDxlWNnkLSemeT0CjrirzvyD5v8/6ZcaJq2k%2bVruOw1e8n0e60ua%2bmjsr24W3kuILmzi1J5bi1YLAwcklGAI%2b1irFvMWvfmDqfnG%2b1HWo57KC01KS21a4ivZ%2bWkxJchEC%2bhNbx20cdsRLHM8bCd6/a5cQq9mTWvOPmLy35A0PULm50u88waXPqfmG4s6xXskNhFBWCFgA0L3L3SFitGUVApiry/wAs/mRdx6dc%2bZvKflnV9OudAuoBrEEeoSXmlT2cp/eW93%2bkZUdLqNSV5RRkh%2bvwtTFUJ%2bZ/mn8ztZ886pBcaJcwSaYkci6O13Iy2tm8CskoWynt0Kyz8xNd82EY4j4KfEq%2bhPyZ1bVdU8hWt1qNxJehbi8hsNRnPKW6sobmSO1nkNF5F4lX4qfF9rvirxzUfzD86zeYfMCHSfPGpR2ur6jZ29zoKqLD0bW6khiSOlrLuiIFc8t2riql/jvzl/1LX5nfcP8AsixVmP5M%2bc/M%2bp%2be73SdRtPMWn2P6LN2tt5nVfWaVLhIxJAfRgPDjIQ3XfFWS635y84jVvNT2epaJougeVZIYbq51S1ubl29SzhvGk5Q3Vsqj/SAgTiSSOu9MVePadFBd/l3f%2bf4NU03zTZ6YXm1aOUaxaahK3qVkSRl1Jo4XYNVW9ErShocVTD8v7b9HfmZfC0uLpFtfO0mjwI1zcSILA6bfSmArI7Ky%2bpCjfECagb4q9f/ADu8%2bav5E/Lu/wDMukQ2899ayW6Rx3au8RE0yxtURvE3RtvixV4Wfzo0yLX5/wAx4/NVhJqsvliOFfKpS/8ATXVzFG7p6fER8BKrL/e1/wArviqCj/O8fmFpGgX/AJn8y6d5V1bQ9eFzPZ26X8aXOnxpC42j%2btcmZ/UWjMBt0xV6/wDkT%2bcmsfmNrPnGC6isxpmh3MCaRcWkc0bTQTvchXl9WSSpKQIdlXqdvBV67irxHyXbfnTL%2bW/k1vJV7oMGljRbLnHqkd005m4fGeUPJePHjx28cVSLzfof53Qaf5gufNl59d0oW8chls5U%2boiZbuCSGSK2EccsENrEsv1kzMyuu55Yqkv5Qw3ay6FIFdNNPmuyjtkc7rJH5fvQyn/LjgMEb9wykHcHFWUeYL3yBoV55v17zJ5Oh81Xl15sXS7VFsba8ugDo1tcBVM4rwX03NAep%2beKoHTvNn5canpsWp6Z%2bRN1eWNwnqW9zFomntG6%2bKsoNRtirEfL3mjyp518vefLd/IflqwFl5Zv9V0%2b90ywQTWMqI8aW1zLJDH/AKSD%2b8VowooNvZV7rbzi3/MqwnI5CLyjI5UdSFuoTTFUpTzxa%2bedF/LDzTaW0lnb6j5jk4W0rBnX0LHU4DUrtuYq4qwbz27X/wCYHnGS%2b4vLZ6l5VsLVGVYSbRtQjmI9GjNKvqOf3zNQ/ZAAGKvXte/8m55P/wC2Vrv/ACd07FXfnR/5K/zB/wAYF/5OpirzH88buebzf5mtbggwWnke/ksAwWGjXEqifgSGe5J9FK0KiPwJOKvT/wA3We2/LfUo7Z2t1Y2lsfRYxkQzXcMMiKUKlQ0bldu2KvIdSuv%2bca9PivJLPypq2o21tLJELuxi1FrSadZDGVjuDMsR5S/Dy5Uriq1pPyM0u8%2boebPKMmg3yX1rY3CDUZryKIXsdw0UjywTkAK9o0ci0qpod13xVkv5KS/WPNKw24uJbfQrDV9LlmlWZkipr0ptIBPKKPxtogFAY0ApiqK8zT65b2f5t3OiyzQ3VvqWnTTy2rKlytnHpmnteGB2ICy/VhJwPWvTemKsNe%2bvr38k/wAypbe61G78rJBFFo76wzm7FwgreikzyzLFyaPirt9rlTY4qu8o/wDkzNX/APNjt/3SdRxV6J/zklo13rn5XTaLZFBeapqOmWVsZCVT1bi9iiTkQDQcmFdsVfL8X/OK35nSeZLny8sum/X7Wzg1CUm4k9P0bmWaFKN6VeXK2eop4Yq9P0TT/MkP5Y%2bQ4/8AB%2bjzwpqenxw6g16BNdOLhgEmj%2bpNwWQ7Meb0HY4q9U/LWLUY/wAyPOK6ho1noU/6O0Qiy0%2bf6zCV9TUKPz9C1%2bI9xw7dcVenYq8x0P8ALH8xtC0ez0bSvzBaHTdPiW3s4n0i0kZYoxRFLs9WIHfFUcfJf5rsCD%2bYtQdiDotnQj/gsVQfl/8AKPXtOv8ARWvvNC3mk6Jey6nb6VBpltZI1zLFPGzmSJi2/wBadj44qjLn8vPOUGuaxqHl3zk2j2ms3Yvp7FtOt7rjP9Xit2IlkYNQrbrtTFXf4M/Nn/y43/cms/8AmvFUuvvyp8%2bX2malpdx56QWOsRSwamkGi2ULzRzoY5aujV5FWPxdcVVvM8t3oXn20vU0vU77T28vzaalzp1rJdNHMbiNk5%2bnSh4pXFWL%2bUIdeXTvy98t3Npruo3uh6zNe6lrmp2Fxbo0L21%2bFLSTNIfhN1HGKtiqr5j/AC186S/mFqQtLaKTQvNGqaVqVxqMUnGOzXR2Eria3cNI803pKisj8DXcLTFU7/Ojyt561i/0e68pC4jngs7%2b1mv7K4ht7i3a4uLGZGT1ni5B1tHRqHocVefah%2bX35630TQXUurXtrLZpZy2V3f2TW7uFCmeQC4Y8qjn064qyv82/y8866l5pv9R0GzivLTzLo3%2bG7opMIDaiWXkbu5WQP60cak09Iq3ajdcVegfmhpGpav5H1Gy0yA3V6Wt5orZWVWk%2br3Mc7IpcqvJljIXkQK98VYVqth5O1ZrqTUPyYvp7i95m6ujY6Gtw7SV5P663olDmteYblXeuKqWladoOnTJc/wDKtPM9/ex3UN6t7qM1jfXHr20Tw27ercanIxEKTP6a9FJqBXfFWb/lZpmqab5Mgg1O0exvJbzUrtrSUo0kaXmo3FzErmNpE5enMvIBjQ4qxLVp7nT9a/MPTL7RtYmtfM7xfUr/AE6xe8i9J9Jt7N2qhpySSN/hNOnvirDFtddX8l9Z8kx6HrV75i1ozN6w0ue1tBNcyKQvOY/AihRVnOKsu8pfkv5n0zzdLrmra7ZXNvcay/mG4trSzlhc3jW09sqI8lxMFiC3TGhUtUD4sVZJ%2bc2mTaj5Pghjs7q/ij1XS57u2sBKbk20N9FJOYvRKyhljViCjAjsRirzODQfK6%2bd72/fyv5z/Q0mmWkFuwk1z1/rUdxcvMGcXPqlPTkj4gtxBrQAk1VYX5j8n6mfyo07T9A8tea4POtrNFKZGOqfV04SMxaNHmaBWCkUKoDXFWbf84n6B%2bYem3Pm26862mpQXN2unJaz6p6peRYfrRZUaWpIT1Bt2rir6ExV2KuxV2KuxVh/mP8ANnyJ5d826Z5T1bUPQ1rVvT%2bqwiN2Qes5ji9SRQVTm4oKn50GKswxV2KsQ/ML81vJf5fx6e/ma7e2/Scjx2qxxPKSIuPqOQgNFT1Fr89sVZZBPDPBHPC4khlUPFIpqrKwqpB8CMVX4q7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXiH50y%2bfpdTuhq3mSHyN%2bWFpHEZdXtHL6jfSyD4reNVAlV/hYcU/Z3%2bPcKq8MvLPy1c/mB%2bXOoeW7bVptAtg7RfpFAb66/R15NqE0i8QVk9UTfB922Ks9/Lm41%2bK6S9/JrzLda3YW80cWs%2bQfM7iK5tY3fg0iPXiqpXdoulN%2bZ%2bHFX1KK0FRQ9wNxXFXzf8A85paDNqGjeUbmFayrqMthGd/tXkaso%2bk2%2bKvoy1t4ra2itohSKBFjjHgqDiOnsMVVMVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdiqC1jQ9H1qyNjq9lDqFkXSQ29yiyxl42Do3FgRswxV4B500Z4vzJ0ew1v8wIofOxk1JvKsCWEw9CHVIBZ2MYMKNEvpSQs3xuNzy3ruq9v8seWI9LiW%2bv1tbrzRdW8MWta1BbpbvdPEDRmCdgTtiqe4q8n/5yE1jyJZab5Zi82amdNSHWbbVLQLbyXJmGnsDNHxjBK8km48u1e%2bKvWMVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdiqTah5M8p6jrdrrt/pFpc61ZcBaajLEjTxiNi6cJCOQ4sxIxVOcVdiqTeZPJnlPzMkCeYdItNVW1LG2F3Ekvpl6c%2bHIGnLiK/LFU5xV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Kvnaw8zfmJ5g8qHUvOmp3lh5LuNMtr%2b8v9OtLeJrz6wIf9x9s8czXKvK8xirwHKhAIqMVY%2bPNX5WzTtbT%2bVP8Pw1YpremalLLqFiYXA%2bshPTSJ/q7jlL6E03AA8hQHFXrUy/mN5c8x%2bV31DzeuuaXrWoLpk9idOtrZeJsri5E6zRsz8i1sNq8d8Ven4q7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq8W0bTTrv8Azjv5YsNNu7VdYs7LS7%2bxhnlVI3nsZIrlYZDWqiT0uFe1a4q83g03z/rmgaL5D%2bpG207RhcQWd1e28dsYhPBLZ%2bpdXKzyQSpDDdOVWBSZiByVRXFXtvm06dBeflxp1ncpOtprsUS8XVm4RaRfICeJxV6JirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirFf8AlU/5Wf8AUm6H/wBw2z/6p4q7/lU/5Wf9Sbof/cNs/wDqniqJ038uvy%2b0u%2biv9M8saTY30BJgu7axtoZUJBUlJERWXYkbHFWQ4q7FXYq7FXYq7FXYq7FUnj/xh/iST1P0f/hrj%2b6K%2bv8AXuXBdmr%2b5p6nPp2p3xVOMVdirsVdirsVdirsVdirsVdirsVdir5uu/z68z%2bfPLWl6l5OVfL91b69Fa6pbTXloXksvS5u3%2bkCL4asBRRXbFUfL/zkpN5mvPN3lPQLAaXq%2bn2d9%2biNXe8gKS3Fs/pR8FlRIxzJ5LVyMVTTyT%2beN9b615I8ia7ANS8wa5py3OoaxFdQOkczG4%2bBlgV42aluD8LD7QxV7dirsVYb%2bYvmrWNJS20nR7J7jUtatdTWyuI3AeG4tLGS4h4xFH9RnkUKBtT36YqwC61j87/0beGO1vVueOomErEjMrL5dhktlUen8X%2b5PmFPd6jtTFWtY1j88PVvfqtpexqU1hoRHEkgR10C2kslU%2bn8dNRMgQ/tPUdqYq9I/LzzZqnmKx1JNW0z9F6lo17%2bjrqD1xcc3FrBc%2bpyVIgKi5pxptTrirKsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVfHmleTvy5fyX5DuZfIGqTXt9c2S6pfqjGO%2bV4JGkSE/WRUyMAy0VenbFU6tPIv5WHzL5qhb8tdYe2trazaytAjl7V3ilMjyD63sJCoK7np2xVW8heWfJVnJ%2bVOp6b5Pv9L1q5ubP69rk6sLa6L6TcSSGMmeQH1JVEo/dj4R26Yq%2bo8Vdirz/APMW6ubTzd5Pu7WFbi6t/wBLywQO6xLJImmyMqNI1FQMRQsdhirzrzPpeoeZdUvtc1TylbtqGoeVTBciPXrNELG4B%2bqijUC7cvrH2e2KoLU/JSyeXvMEP%2bE4pPrHl7y9beh%2bn7RBL9WNr%2b4MhakQg4bTN8MvH4ftDFXq35WJwvPOyceHHXwOFQ1KaRp%2b3IdaeOKs8xV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV8maT5k0ZPI35eQN%2bZ/oS2t1YNPpnHS/wDcaFt5QZPitzJ%2b6J4/vWYb71OKp7aea9BHmnzdKfzd9NJ7WyWK94aP/phWGYGPe14fuq8f3YB%2bLftirXknXNMuYPylsofPn6ZuYLmxEvlvjYD6lx0i5QisMKXH7pj6P7xz9rf4qHFX0virsVeUfndq2k6bqvlh9SuLSCKaPWYUGoSelbO8umvEiSuGQhHeRVNGB364q8l/TPlb6tw4%2bSOX%2bGf0Zx/SFxx%2bs%2bvz%2bqf71/7zcfi5fbr%2b1irPtKv/APnHK68tRW%2bvahoCX%2boaXp1jrttb3z%2bgfqCRGOGMmZm9OGSEcDyqQBUnFWYfk/qej6nJ51vtGuYrzTJfMLC1uIGDxsiaXYJ8LCtaFaYq9DxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV//9k=%3c/xmpGImg:image%3e %3c/rdf:li%3e %3c/rdf:Alt%3e %3c/xmp:Thumbnails%3e %3cxmpMM:OriginalDocumentID%3euuid:9E3E5C9A8C81DB118734DB58FDDE4BA7%3c/xmpMM:OriginalDocumentID%3e %3cxmpMM:DocumentID%3exmp.did:7b8d981d-9085-4910-a90d-3efae6a6e475%3c/xmpMM:DocumentID%3e %3cxmpMM:InstanceID%3exmp.iid:7b8d981d-9085-4910-a90d-3efae6a6e475%3c/xmpMM:InstanceID%3e %3cxmpMM:RenditionClass%3eproof:pdf%3c/xmpMM:RenditionClass%3e %3cxmpMM:DerivedFrom rdf:parseType='Resource'%3e %3cstRef:instanceID%3euuid:645d8762-dffe-ce4b-898d-515dcd4a37d7%3c/stRef:instanceID%3e %3cstRef:documentID%3exmp.did:525ac691-adef-4d04-bc72-b632c8732463%3c/stRef:documentID%3e %3cstRef:originalDocumentID%3euuid:9E3E5C9A8C81DB118734DB58FDDE4BA7%3c/stRef:originalDocumentID%3e %3cstRef:renditionClass%3eproof:pdf%3c/stRef:renditionClass%3e %3c/xmpMM:DerivedFrom%3e %3cxmpMM:History%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cstEvt:action%3esaved%3c/stEvt:action%3e %3cstEvt:instanceID%3exmp.iid:78fa4c27-1810-4112-abf8-25d31ae36cdc%3c/stEvt:instanceID%3e %3cstEvt:when%3e2019-06-10T14:32:07%2b02:00%3c/stEvt:when%3e %3cstEvt:softwareAgent%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/stEvt:softwareAgent%3e %3cstEvt:changed%3e/%3c/stEvt:changed%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cstEvt:action%3esaved%3c/stEvt:action%3e %3cstEvt:instanceID%3exmp.iid:7b8d981d-9085-4910-a90d-3efae6a6e475%3c/stEvt:instanceID%3e %3cstEvt:when%3e2019-08-21T23:41:29%2b02:00%3c/stEvt:when%3e %3cstEvt:softwareAgent%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/stEvt:softwareAgent%3e %3cstEvt:changed%3e/%3c/stEvt:changed%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpMM:History%3e %3cillustrator:StartupProfile%3eBasic RGB%3c/illustrator:StartupProfile%3e %3cxmpTPg:NPages%3e1%3c/xmpTPg:NPages%3e %3cxmpTPg:HasVisibleTransparency%3eFalse%3c/xmpTPg:HasVisibleTransparency%3e %3cxmpTPg:HasVisibleOverprint%3eFalse%3c/xmpTPg:HasVisibleOverprint%3e %3cxmpTPg:MaxPageSize rdf:parseType='Resource'%3e %3cstDim:w%3e440.000000%3c/stDim:w%3e %3cstDim:h%3e440.000000%3c/stDim:h%3e %3cstDim:unit%3ePixels%3c/stDim:unit%3e %3c/xmpTPg:MaxPageSize%3e %3cxmpTPg:PlateNames%3e %3crdf:Seq%3e %3crdf:li%3eCyan%3c/rdf:li%3e %3crdf:li%3eMagenta%3c/rdf:li%3e %3crdf:li%3eYellow%3c/rdf:li%3e %3crdf:li%3eBlack%3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpTPg:PlateNames%3e %3cxmpTPg:SwatchGroups%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eDomy%c5%9blna grupa pr%c3%b3bek%3c/xmpG:groupName%3e %3cxmpG:groupType%3e0%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eBia%c5%82y%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eCzarny%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eCzerwony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3e%c5%bb%c3%b3%c5%82ty RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eZielony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eNiebieskozielony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eNiebieski RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eKarmazynowy RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=193 G=39 B=45%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e193%3c/xmpG:red%3e %3cxmpG:green%3e39%3c/xmpG:green%3e %3cxmpG:blue%3e45%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=237 G=28 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e237%3c/xmpG:red%3e %3cxmpG:green%3e28%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=241 G=90 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e241%3c/xmpG:red%3e %3cxmpG:green%3e90%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=247 G=147 B=30%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e247%3c/xmpG:red%3e %3cxmpG:green%3e147%3c/xmpG:green%3e %3cxmpG:blue%3e30%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=251 G=176 B=59%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e251%3c/xmpG:red%3e %3cxmpG:green%3e176%3c/xmpG:green%3e %3cxmpG:blue%3e59%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=252 G=238 B=33%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e252%3c/xmpG:red%3e %3cxmpG:green%3e238%3c/xmpG:green%3e %3cxmpG:blue%3e33%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=217 G=224 B=33%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e217%3c/xmpG:red%3e %3cxmpG:green%3e224%3c/xmpG:green%3e %3cxmpG:blue%3e33%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=140 G=198 B=63%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e140%3c/xmpG:red%3e %3cxmpG:green%3e198%3c/xmpG:green%3e %3cxmpG:blue%3e63%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=57 G=181 B=74%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e57%3c/xmpG:red%3e %3cxmpG:green%3e181%3c/xmpG:green%3e %3cxmpG:blue%3e74%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=146 B=69%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e146%3c/xmpG:green%3e %3cxmpG:blue%3e69%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=104 B=55%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e104%3c/xmpG:green%3e %3cxmpG:blue%3e55%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=34 G=181 B=115%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e34%3c/xmpG:red%3e %3cxmpG:green%3e181%3c/xmpG:green%3e %3cxmpG:blue%3e115%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=169 B=157%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e169%3c/xmpG:green%3e %3cxmpG:blue%3e157%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=41 G=171 B=226%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e41%3c/xmpG:red%3e %3cxmpG:green%3e171%3c/xmpG:green%3e %3cxmpG:blue%3e226%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=113 B=188%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e113%3c/xmpG:green%3e %3cxmpG:blue%3e188%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=46 G=49 B=146%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e46%3c/xmpG:red%3e %3cxmpG:green%3e49%3c/xmpG:green%3e %3cxmpG:blue%3e146%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=27 G=20 B=100%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e27%3c/xmpG:red%3e %3cxmpG:green%3e20%3c/xmpG:green%3e %3cxmpG:blue%3e100%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=102 G=45 B=145%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e102%3c/xmpG:red%3e %3cxmpG:green%3e45%3c/xmpG:green%3e %3cxmpG:blue%3e145%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=147 G=39 B=143%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e147%3c/xmpG:red%3e %3cxmpG:green%3e39%3c/xmpG:green%3e %3cxmpG:blue%3e143%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=158 G=0 B=93%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e158%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e93%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=212 G=20 B=90%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e212%3c/xmpG:red%3e %3cxmpG:green%3e20%3c/xmpG:green%3e %3cxmpG:blue%3e90%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=237 G=30 B=121%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e237%3c/xmpG:red%3e %3cxmpG:green%3e30%3c/xmpG:green%3e %3cxmpG:blue%3e121%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=199 G=178 B=153%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e199%3c/xmpG:red%3e %3cxmpG:green%3e178%3c/xmpG:green%3e %3cxmpG:blue%3e153%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=153 G=134 B=117%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e153%3c/xmpG:red%3e %3cxmpG:green%3e134%3c/xmpG:green%3e %3cxmpG:blue%3e117%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=115 G=99 B=87%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e115%3c/xmpG:red%3e %3cxmpG:green%3e99%3c/xmpG:green%3e %3cxmpG:blue%3e87%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=83 G=71 B=65%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e83%3c/xmpG:red%3e %3cxmpG:green%3e71%3c/xmpG:green%3e %3cxmpG:blue%3e65%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=198 G=156 B=109%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e198%3c/xmpG:red%3e %3cxmpG:green%3e156%3c/xmpG:green%3e %3cxmpG:blue%3e109%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=166 G=124 B=82%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e166%3c/xmpG:red%3e %3cxmpG:green%3e124%3c/xmpG:green%3e %3cxmpG:blue%3e82%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=140 G=98 B=57%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e140%3c/xmpG:red%3e %3cxmpG:green%3e98%3c/xmpG:green%3e %3cxmpG:blue%3e57%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=117 G=76 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e117%3c/xmpG:red%3e %3cxmpG:green%3e76%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=96 G=56 B=19%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e96%3c/xmpG:red%3e %3cxmpG:green%3e56%3c/xmpG:green%3e %3cxmpG:blue%3e19%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=66 G=33 B=11%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e66%3c/xmpG:red%3e %3cxmpG:green%3e33%3c/xmpG:green%3e %3cxmpG:blue%3e11%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eZimne%3c/xmpG:groupName%3e %3cxmpG:groupType%3e1%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=56 M=0 Y=20 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e101%3c/xmpG:red%3e %3cxmpG:green%3e200%3c/xmpG:green%3e %3cxmpG:blue%3e208%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=51 M=43 Y=0 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e131%3c/xmpG:red%3e %3cxmpG:green%3e139%3c/xmpG:green%3e %3cxmpG:blue%3e197%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=26 M=41 Y=0 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e186%3c/xmpG:red%3e %3cxmpG:green%3e155%3c/xmpG:green%3e %3cxmpG:blue%3e201%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eSzaro%c5%9bci%3c/xmpG:groupName%3e %3cxmpG:groupType%3e1%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=0 B=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=26 G=26 B=26%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e26%3c/xmpG:red%3e %3cxmpG:green%3e26%3c/xmpG:green%3e %3cxmpG:blue%3e26%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=51 G=51 B=51%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e51%3c/xmpG:red%3e %3cxmpG:green%3e51%3c/xmpG:green%3e %3cxmpG:blue%3e51%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=77 G=77 B=77%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e77%3c/xmpG:red%3e %3cxmpG:green%3e77%3c/xmpG:green%3e %3cxmpG:blue%3e77%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=102 G=102 B=102%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e102%3c/xmpG:red%3e %3cxmpG:green%3e102%3c/xmpG:green%3e %3cxmpG:blue%3e102%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=128 G=128 B=128%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e128%3c/xmpG:red%3e %3cxmpG:green%3e128%3c/xmpG:green%3e %3cxmpG:blue%3e128%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=153 G=153 B=153%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e153%3c/xmpG:red%3e %3cxmpG:green%3e153%3c/xmpG:green%3e %3cxmpG:blue%3e153%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=179 G=179 B=179%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e179%3c/xmpG:red%3e %3cxmpG:green%3e179%3c/xmpG:green%3e %3cxmpG:blue%3e179%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=204 G=204 B=204%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e204%3c/xmpG:red%3e %3cxmpG:green%3e204%3c/xmpG:green%3e %3cxmpG:blue%3e204%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=230 G=230 B=230%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e230%3c/xmpG:red%3e %3cxmpG:green%3e230%3c/xmpG:green%3e %3cxmpG:blue%3e230%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=242 G=242 B=242%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e242%3c/xmpG:red%3e %3cxmpG:green%3e242%3c/xmpG:green%3e %3cxmpG:blue%3e242%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpTPg:SwatchGroups%3e %3cpdf:Producer%3eAdobe PDF library 15.00%3c/pdf:Producer%3e %3c/rdf:Description%3e %3c/rdf:RDF%3e%3c/x:xmpmeta%3e %3c%3fxpacket end='w'%3f%3e %3c/metadata%3e %3cg id='Warstwa_1' class='st0'%3e %3cg class='st1'%3e %3cline class='st2' x1='0' y1='0' x2='0' y2='440'%3e%3c/line%3e %3cline class='st2' x1='10' y1='0' x2='10' y2='440'%3e%3c/line%3e %3cline class='st2' x1='20' y1='0' x2='20' y2='440'%3e%3c/line%3e %3cline class='st2' x1='30' y1='0' x2='30' y2='440'%3e%3c/line%3e %3cline class='st2' x1='40' y1='0' x2='40' y2='440'%3e%3c/line%3e %3cline class='st2' x1='50' y1='0' x2='50' y2='440'%3e%3c/line%3e %3cline class='st3' x1='60' y1='0' x2='60' y2='440'%3e%3c/line%3e %3cline class='st2' x1='70' y1='0' x2='70' y2='440'%3e%3c/line%3e %3cline class='st2' x1='80' y1='0' x2='80' y2='440'%3e%3c/line%3e %3cline class='st2' x1='90' y1='0' x2='90' y2='440'%3e%3c/line%3e %3cline class='st2' x1='100' y1='0' x2='100' y2='440'%3e%3c/line%3e %3cline class='st2' x1='110' y1='0' x2='110' y2='440'%3e%3c/line%3e %3cline class='st2' x1='120' y1='0' x2='120' y2='440'%3e%3c/line%3e %3cline class='st2' x1='130' y1='0' x2='130' y2='440'%3e%3c/line%3e %3cline class='st2' x1='140' y1='0' x2='140' y2='440'%3e%3c/line%3e %3cline class='st2' x1='150' y1='0' x2='150' y2='440'%3e%3c/line%3e %3cline class='st2' x1='160' y1='0' x2='160' y2='440'%3e%3c/line%3e %3cline class='st2' x1='170' y1='0' x2='170' y2='440'%3e%3c/line%3e %3cline class='st2' x1='180' y1='0' x2='180' y2='440'%3e%3c/line%3e %3cline class='st2' x1='190' y1='0' x2='190' y2='440'%3e%3c/line%3e %3cline class='st2' x1='200' y1='0' x2='200' y2='440'%3e%3c/line%3e %3cline class='st2' x1='210' y1='0' x2='210' y2='440'%3e%3c/line%3e %3cline class='st3' x1='220' y1='0' x2='220' y2='440'%3e%3c/line%3e %3cline class='st2' x1='230' y1='0' x2='230' y2='440'%3e%3c/line%3e %3cline class='st2' x1='240' y1='0' x2='240' y2='440'%3e%3c/line%3e %3cline class='st2' x1='250' y1='0' x2='250' y2='440'%3e%3c/line%3e %3cline class='st2' x1='260' y1='0' x2='260' y2='440'%3e%3c/line%3e %3cline class='st2' x1='270' y1='0' x2='270' y2='440'%3e%3c/line%3e %3cline class='st2' x1='280' y1='0' x2='280' y2='440'%3e%3c/line%3e %3cline class='st2' x1='290' y1='0' x2='290' y2='440'%3e%3c/line%3e %3cline class='st2' x1='300' y1='0' x2='300' y2='440'%3e%3c/line%3e %3cline class='st2' x1='310' y1='0' x2='310' y2='440'%3e%3c/line%3e %3cline class='st2' x1='320' y1='0' x2='320' y2='440'%3e%3c/line%3e %3cline class='st2' x1='330' y1='0' x2='330' y2='440'%3e%3c/line%3e %3cline class='st2' x1='340' y1='0' x2='340' y2='440'%3e%3c/line%3e %3cline class='st2' x1='350' y1='0' x2='350' y2='440'%3e%3c/line%3e %3cline class='st2' x1='360' y1='0' x2='360' y2='440'%3e%3c/line%3e %3cline class='st2' x1='370' y1='0' x2='370' y2='440'%3e%3c/line%3e %3cline class='st3' x1='380' y1='0' x2='380' y2='440'%3e%3c/line%3e %3cline class='st2' x1='390' y1='0' x2='390' y2='440'%3e%3c/line%3e %3cline class='st2' x1='400' y1='0' x2='400' y2='440'%3e%3c/line%3e %3cline class='st2' x1='410' y1='0' x2='410' y2='440'%3e%3c/line%3e %3cline class='st2' x1='420' y1='0' x2='420' y2='440'%3e%3c/line%3e %3cline class='st2' x1='430' y1='0' x2='430' y2='440'%3e%3c/line%3e %3cline class='st2' x1='440' y1='0' x2='440' y2='440'%3e%3c/line%3e %3c/g%3e %3cg class='st1'%3e %3cline class='st2' x1='440' y1='0' x2='0' y2='0'%3e%3c/line%3e %3cline class='st2' x1='440' y1='10' x2='0' y2='10'%3e%3c/line%3e %3cline class='st2' x1='440' y1='20' x2='0' y2='20'%3e%3c/line%3e %3cline class='st2' x1='440' y1='30' x2='0' y2='30'%3e%3c/line%3e %3cline class='st2' x1='440' y1='40' x2='0' y2='40'%3e%3c/line%3e %3cline class='st2' x1='440' y1='50' x2='0' y2='50'%3e%3c/line%3e %3cline class='st3' x1='440' y1='60' x2='0' y2='60'%3e%3c/line%3e %3cline class='st2' x1='440' y1='70' x2='0' y2='70'%3e%3c/line%3e %3cline class='st2' x1='440' y1='80' x2='0' y2='80'%3e%3c/line%3e %3cline class='st2' x1='440' y1='90' x2='0' y2='90'%3e%3c/line%3e %3cline class='st2' x1='440' y1='100' x2='0' y2='100'%3e%3c/line%3e %3cline class='st2' x1='440' y1='110' x2='0' y2='110'%3e%3c/line%3e %3cline class='st2' x1='440' y1='120' x2='0' y2='120'%3e%3c/line%3e %3cline class='st2' x1='440' y1='130' x2='0' y2='130'%3e%3c/line%3e %3cline class='st2' x1='440' y1='140' x2='0' y2='140'%3e%3c/line%3e %3cline class='st2' x1='440' y1='150' x2='0' y2='150'%3e%3c/line%3e %3cline class='st2' x1='440' y1='160' x2='0' y2='160'%3e%3c/line%3e %3cline class='st2' x1='440' y1='170' x2='0' y2='170'%3e%3c/line%3e %3cline class='st2' x1='440' y1='180' x2='0' y2='180'%3e%3c/line%3e %3cline class='st2' x1='440' y1='190' x2='0' y2='190'%3e%3c/line%3e %3cline class='st2' x1='440' y1='200' x2='0' y2='200'%3e%3c/line%3e %3cline class='st2' x1='440' y1='210' x2='0' y2='210'%3e%3c/line%3e %3cline class='st3' x1='440' y1='220' x2='0' y2='220'%3e%3c/line%3e %3cline class='st2' x1='440' y1='230' x2='0' y2='230'%3e%3c/line%3e %3cline class='st2' x1='440' y1='240' x2='0' y2='240'%3e%3c/line%3e %3cline class='st2' x1='440' y1='250' x2='0' y2='250'%3e%3c/line%3e %3cline class='st2' x1='440' y1='260' x2='0' y2='260'%3e%3c/line%3e %3cline class='st2' x1='440' y1='270' x2='0' y2='270'%3e%3c/line%3e %3cline class='st2' x1='440' y1='280' x2='0' y2='280'%3e%3c/line%3e %3cline class='st2' x1='440' y1='290' x2='0' y2='290'%3e%3c/line%3e %3cline class='st2' x1='440' y1='300' x2='0' y2='300'%3e%3c/line%3e %3cline class='st2' x1='440' y1='310' x2='0' y2='310'%3e%3c/line%3e %3cline class='st2' x1='440' y1='320' x2='0' y2='320'%3e%3c/line%3e %3cline class='st2' x1='440' y1='330' x2='0' y2='330'%3e%3c/line%3e %3cline class='st2' x1='440' y1='340' x2='0' y2='340'%3e%3c/line%3e %3cline class='st2' x1='440' y1='350' x2='0' y2='350'%3e%3c/line%3e %3cline class='st2' x1='440' y1='360' x2='0' y2='360'%3e%3c/line%3e %3cline class='st2' x1='440' y1='370' x2='0' y2='370'%3e%3c/line%3e %3cline class='st3' x1='440' y1='380' x2='0' y2='380'%3e%3c/line%3e %3cline class='st2' x1='440' y1='390' x2='0' y2='390'%3e%3c/line%3e %3cline class='st2' x1='440' y1='400' x2='0' y2='400'%3e%3c/line%3e %3cline class='st2' x1='440' y1='410' x2='0' y2='410'%3e%3c/line%3e %3cline class='st2' x1='440' y1='420' x2='0' y2='420'%3e%3c/line%3e %3cline class='st2' x1='440' y1='430' x2='0' y2='430'%3e%3c/line%3e %3cline class='st2' x1='440' y1='440' x2='0' y2='440'%3e%3c/line%3e %3c/g%3e%3c/g%3e %3cg id='Warstwa_2' class='st0'%3e %3ccircle class='st4' cx='220' cy='220' r='100'%3e%3c/circle%3e %3ccircle class='st4' cx='220' cy='220' r='40'%3e%3c/circle%3e %3ccircle class='st4' cx='220' cy='220' r='160'%3e%3c/circle%3e %3ccircle class='st4' cx='220' cy='220' r='220'%3e%3c/circle%3e%3c/g%3e %3cg id='Warstwa_3'%3e %3cg%3e %3crect x='100' y='10' width='50' height='80'%3e%3c/rect%3e %3crect x='290' y='10' width='50' height='80'%3e%3c/rect%3e %3cpath d='M370%2c60v60H260V60h-80v60H70V60H10v370h420V60H370z M200%2c210.03h-55V160h55V210.03z M240%2c160h55v50.03h-55V160z M105%2c210.03H50V160h55V210.03z M105%2c250.03V300H50v-49.97H105z M145%2c250.03h55V300h-55V250.03z M200%2c340v50h-55v-50H200z M240%2c340h55v50h-55V340z M240%2c300v-49.97h55V300H240z M335%2c250.03h55V300h-55V250.03z M335%2c210.03V160h55v50.03H335z M50%2c340h55 v50H50V340z M335%2c390v-50h55v50H335z'%3e%3c/path%3e %3c/g%3e%3c/g%3e%3c/svg%3e";

var img$K = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 23.0.4%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 440 440' style='enable-background:new 0 0 440 440%3b' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bdisplay:none%3b%7d .st1%7bdisplay:inline%3b%7d .st2%7bfill:none%3bstroke:grey%3bstroke-miterlimit:10%3b%7d .st3%7bfill:none%3bstroke:%23C1272D%3bstroke-miterlimit:10%3b%7d .st4%7bdisplay:inline%3bfill:none%3bstroke:%23C1272D%3bstroke-miterlimit:10%3b%7d%3c/style%3e%3cmetadata%3e%3c%3fxpacket begin=' ' id='W5M0MpCehiHzreSzNTczkc9d'%3f%3e%3cx:xmpmeta xmlns:x='adobe:ns:meta/' x:xmptk='Adobe XMP Core 5.6-c145 79.163499%2c 2018/08/13-16:40:22 '%3e %3crdf:RDF xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%3e %3crdf:Description rdf:about='' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:xmp='http://ns.adobe.com/xap/1.0/' xmlns:xmpGImg='http://ns.adobe.com/xap/1.0/g/img/' xmlns:xmpMM='http://ns.adobe.com/xap/1.0/mm/' xmlns:stRef='http://ns.adobe.com/xap/1.0/sType/ResourceRef%23' xmlns:stEvt='http://ns.adobe.com/xap/1.0/sType/ResourceEvent%23' xmlns:illustrator='http://ns.adobe.com/illustrator/1.0/' xmlns:xmpTPg='http://ns.adobe.com/xap/1.0/t/pg/' xmlns:stDim='http://ns.adobe.com/xap/1.0/sType/Dimensions%23' xmlns:xmpG='http://ns.adobe.com/xap/1.0/g/' xmlns:pdf='http://ns.adobe.com/pdf/1.3/'%3e %3cdc:format%3eimage/svg%2bxml%3c/dc:format%3e %3cdc:title%3e %3crdf:Alt%3e %3crdf:li xml:lang='x-default'%3eIcons%3c/rdf:li%3e %3c/rdf:Alt%3e %3c/dc:title%3e %3cxmp:CreatorTool%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/xmp:CreatorTool%3e %3cxmp:CreateDate%3e2019-06-14T11:08:35%2b02:00%3c/xmp:CreateDate%3e %3cxmp:ModifyDate%3e2019-06-14T11:08:35%2b02:00%3c/xmp:ModifyDate%3e %3cxmp:MetadataDate%3e2019-06-14T11:08:35%2b02:00%3c/xmp:MetadataDate%3e %3cxmp:Thumbnails%3e %3crdf:Alt%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpGImg:width%3e180%3c/xmpGImg:width%3e %3cxmpGImg:height%3e256%3c/xmpGImg:height%3e %3cxmpGImg:format%3eJPEG%3c/xmpGImg:format%3e %3cxmpGImg:image%3e/9j/4AAQSkZJRgABAgEASABIAAD/7QAsUGhvdG9zaG9wIDMuMAA4QklNA%2b0AAAAAABAASAAAAAEA%26%23xA%3bAQBIAAAAAQAB/%2b4ADkFkb2JlAGTAAAAAAf/bAIQABgQEBAUEBgUFBgkGBQYJCwgGBggLDAoKCwoK%26%23xA%3bDBAMDAwMDAwQDA4PEA8ODBMTFBQTExwbGxscHx8fHx8fHx8fHwEHBwcNDA0YEBAYGhURFRofHx8f%26%23xA%3bHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8f/8AAEQgBAAC0AwER%26%23xA%3bAAIRAQMRAf/EAaIAAAAHAQEBAQEAAAAAAAAAAAQFAwIGAQAHCAkKCwEAAgIDAQEBAQEAAAAAAAAA%26%23xA%3bAQACAwQFBgcICQoLEAACAQMDAgQCBgcDBAIGAnMBAgMRBAAFIRIxQVEGE2EicYEUMpGhBxWxQiPB%26%23xA%3bUtHhMxZi8CRygvElQzRTkqKyY3PCNUQnk6OzNhdUZHTD0uIIJoMJChgZhJRFRqS0VtNVKBry4/PE%26%23xA%3b1OT0ZXWFlaW1xdXl9WZ2hpamtsbW5vY3R1dnd4eXp7fH1%2bf3OEhYaHiImKi4yNjo%2bCk5SVlpeYmZ%26%23xA%3bqbnJ2en5KjpKWmp6ipqqusra6voRAAICAQIDBQUEBQYECAMDbQEAAhEDBCESMUEFURNhIgZxgZEy%26%23xA%3bobHwFMHR4SNCFVJicvEzJDRDghaSUyWiY7LCB3PSNeJEgxdUkwgJChgZJjZFGidkdFU38qOzwygp%26%23xA%3b0%2bPzhJSktMTU5PRldYWVpbXF1eX1RlZmdoaWprbG1ub2R1dnd4eXp7fH1%2bf3OEhYaHiImKi4yNjo%26%23xA%3b%2bDlJWWl5iZmpucnZ6fkqOkpaanqKmqq6ytrq%2bv/aAAwDAQACEQMRAD8A9TTTwQJ6k0ixJ05OQoqf%26%23xA%3bc4q%2bevyy0P8AKe41O38n%2ba/LVg3m%2b9jvtVinvYI2kuY31W9VY6sK80ghR1Fd0NRsuKs01T8v/JHl%26%23xA%3br8wfIF1oGh2Wl3M2pXsUs1rCkTMn6HvG4kqBtUA4q9UxV4x%2baHmPy55y8xWHkeCBdUTQtb0q48xK%26%23xA%3bwV4EikM6yRuD19NR%2b87CoHWtFWYRfkz%2bT0qCSLynpEkbfZdbaIg/IgYql35IadY6bY%2bbrCwgS1sr%26%23xA%3bXzPqUVvbxKFSNFEQVVUbAAYq9IxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KvIv%2bcgvyp87%26%23xA%3bfmTY6ZpOjalZ6fpNpI1zeR3Jl5zT04x7Ro44opbv1Ptir50/Ln8hPMl9%2bY%2bjw6bqwbTbZBql1r9i%26%23xA%3bJYvq6297PaemnrIjeu09k4TalPi3AOKvrPzt/wApv%2bXn/bVvf%2b6Ne4qzG5hM9vLCsrwmVGQTREB0%26%23xA%3bLCnJCwYch1FRir4R1j/nHXzTbee7/QdS1WG3aS7totN1S7WdxfnUXlELgxrKVasLCTkfhbudiVX1%26%23xA%3bL%2bQv5decvy%2b8sXPl3X9QtNQsknM%2bltamUmIS1M0bCRE%2bHn8a07s2Ko38of8Aptf/AAK9T/5lYq9A%26%23xA%3bxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV5l5V8ofmp5W0kaPpl5oM1nHPdTQy3MF4Zi%26%23xA%3bt1dS3XFykir8LTkCgxVMI/LX5i6j5p8vap5gu9I%2bo6Fc3F16VhFcpLI01lPaAVmd1oPrHL6MVZ7i%26%23xA%3brEvzG8p6v5istIOkXFtb6ho%2bqW2qQvdo7xN9WDfu2EZVviLDocVQ/p/nT/y0eW/%2bRF9/1WxVE/lz%26%23xA%3b5U1jy7Y6uNYuLe5v9X1W51WVrRXSFDchPgUSFm2KdzirLMVdirsVdirsVdirsVdirsVdirsVdirs%26%23xA%3bVdirsVdirsVU7q5gtbaW5uH9OCBGllc1IVEHJjt4AYqgtB8yeX/MFiL7Q9RttTszt69rKkqg%2bDcS%26%23xA%3beJ9jviqY4q7FUr1vzV5c0KS0j1rUrfTjfuYrRrqRYkkdRUqHei1oeld8VTNHR0V0YMjAFWBqCDuC%26%23xA%3bCMVbxV2KuxV2KrJpoYInmmkWKGNS0kjkKqqBUlidgBiqW/4s8q/9Xmx/6SYf%2basVd/izyr/1ebH/%26%23xA%3bAKSYf%2basVRljqem36NJY3cN2iHi7wSLIAetCVJxVE4qsmnggT1JpFiTpychRU%2b5xVsTRGL1Q6mKn%26%23xA%3bL1ARx49a16UxVBaHr%2bia9p66jot9DqFg7Oi3Nu4kjLRsVYcl8CMVR%2bKuxV2KuxVhP51SapH%2bVXmW%26%23xA%3bTSmnTUFs2Ns1qXEwfkv2DH8VfliryzSfy28oa75T1ma383eZ5NX0W2dNXsJdUkHp3H1b1aPEVNYp%26%23xA%3bP2fHcdQQFXyr5A1fVdL84aRPpl5PZTNeW8byW8jRMyNKoZWKkVUjqDtir9M8VeDeZprX8zPzU0Ox%26%23xA%3b0nWNWg8rx2mowXd9pNxJbRPdWkijaROSMKkgEjfttvirzT/nKf8ALPTvKGgaHc2us6xqbXV3LG0e%26%23xA%3bq3rXaIFj5VjVlXiffFUx/wCcJtY1abWPMGmTXs8mm29pFJBZvI7QxuZSCyRk8VJrvQYq9l/OyL88%26%23xA%3bZF0YflbNHCQbk6w0gsyT/dfVwPrauP8AfleP04q8u%2bp/85x/8t8H/A6L/wBUsVd9T/5zj/5b4P8A%26%23xA%3bgdF/6pYqzP8AKWD/AJybj83IfzEuYpvLhglDqo04MJtvTI%2bqokn8MVTz/nIjW9Otfy4v9PNxYvqt%26%23xA%3bxPpr2ulXs0SC4Uanb8ldHZeUJCsJD041rtirxr9Ka1/5b78sf%2bR%2blf8AZRirv0prX/lvvyx/5H6V%26%23xA%3b/wBlGKs8/JCLXYPzN1ddV0DSPLX1nQLO4t7HQPSFlPEbucR3R9BnRnb4l5V%2byBir0X8zfza8n/l7%26%23xA%3bpT3OtXiDUJYnfTtLSrT3DqDxAVQ3BCwpzaijxxV%2bf/nXz55q86azLq3mG/ku55GJiiLEQwqekcMf%26%23xA%3b2UUe3XqanfFWcfk1oPm7V9L1gXHmC58uflnDHTzVf%2boywNHUMbeFDUNPJsvwitDQ15BWVfdHljy/%26%23xA%3boXl/QrPSNBto7XSrWMLbRR9OJ35FurM1asx3J3xV4J5o/wCcq9b0aLUriPRNJmistRuNMjtjqq/X%26%23xA%3biYJHQTPZiP1RGeFa9PfFXmX6Z/5yC1nhrOo%2beIfLTaz/AKTpum3uqLpzSxSH4DBbVrHEeiF%2bNetT%26%23xA%3b1xVMrL/nKL82PIdlN5U8z6THqGv2EnEX2oO/qem1GUSemaTAg1SQPuKdeuKvYv8Alf2o/wDKhv8A%26%23xA%3blZn6Hh%2bu%2bt9X/R3rN6XL6z9X5c%2bPKn7VPor3xVif/OSnk783dd1t9Z0%2b9h0jydolsFjna%2bNvUvRp%26%23xA%3bppVTcfFRB7KD3xV59%2bSPkP8AMa182%2batSkvDHpul6fd2%2bu3RczxXrS2xeOBHb7bfEsnL9kD/ACgC%26%23xA%3bq8V8p/8AKU6N/wAx1t/yeXFX6I/mxoXmjXvy%2b1nSvLF59R1m6gKwSdC69XhD1HAyrVOXauKvibyV%26%23xA%3b%2bWH5pav6OnaLqI0%2b6me5WPSZb17WblaPwuD6I6cG2OKvVf8AnKQeaV/KfyNF5rRE8wwzyxag0biV%26%23xA%3bJJI4uHqhh3kUBz4EkYqgv%2bcIf%2bUq8y/8wMP/ACexVOf%2bc34TPceRIQQplfUkDHoCxsxU4q8k1P8A%26%23xA%3bJLStLhM175/0GONZmtmK/XZKSoWDIRHbsQRwPX%2bIxVOvy/8AyV8natJfS/ppfOktoIAuh%2bXna1uu%26%23xA%3bE8oie4Zr%2bKIFIQa0TvTkVHVVPvyD8u6f5b/5ya1HQdOvRqFlp0d/bwXexLKgGzFduSfZam1QcVVv%26%23xA%3b%2bcttA1HXfzl0mwsFT1f8PpNLJKwjiihguLySWWR22VERSx/DfFXkEf5fWcFhc6rqXmGx/RNm0UVw%26%23xA%3b%2bmN9fufUn5emiQlrdSWEbt8UiiinetAVW5/ys8wvHq9xpfHUbLSLGDVZZFDRyGynr%2b89Jt1aIgiV%26%23xA%3ba/DQ05AVxV9P/wDONEh1C60/ULWKZrGw8qWOl3N08MsUf1xL%2b6naJHkVBJSORWLJVd%2buKvEf%2bctI%26%23xA%3bNWT86dSkvQ/1SW2tDpbP9n0BAivw9vXEtffFWM/ld%2bVz%2ba3utZ1m6/Q3kjRv3mt63JsABQ%2bhBUHn%26%23xA%3bM9QAADSo2JKqyqp%2baP5op5kS18u%2bXbX9DeQ9G%2bDSNITYuRUG5uSCecz1J3JpXuSzFV9Uf84pefPM%26%23xA%3b3m38v7ka87XMmk3X1K1vmUKZIREjKjUADNHypXwIrvvir4688PDH%2bZHmCSdPUhTWbxpY/wCZRdOW%26%23xA%3bH0jFWY/nD5O8463%2bYF/5h0nTrvW9D1%2bVbnQtSsYZLiGS3dF9GFTGrcXhQemYzQrx6Yql35xUtP8A%26%23xA%3bCmg3brLr%2bhaLFZ62yuJDFMZpZY7V2BIL28Mio1Dt9ntir1D/ANcl/wCj7/u54q%2bk/wA1/Lmp%2bZfy%26%23xA%3b617QdLVG1DULUw2yyNwQuWB3Y9OmKvOJZvz70vydd6YvlDQ4rRLKWO5livW9Rv3JV5eIX4nYCvvi%26%23xA%3br52/Kz8g/wA0fMGsaZqsOjvYaVDcQ3DX2oE2yMkbq/wIwMr1A2KoR74q%2b/MVeTfmB5R8%2bwfmVo3n%26%23xA%3bHyTpNhem0srq3vIbqYWweW5ZaueIqzcVG%2bKvIf8AnI%2b3/OnzLpugafrfle3jc3chsotHllvppJDH%26%23xA%3b8QZAtQAu9cVZd/zit%2bTvnnyTe6trHma1jsE1K2jht7QyrJcArJz5OsfJFFP8qvtirMPz6/I65/NJ%26%23xA%3bdD9DV00ptHN1XnAZhILr0fB4%2bPH0PxxV5J/0I5qv/U3Qf9IT/wDVbFV8P/OEetwSCSHzlFFIKgOl%26%23xA%3bpIpoRQ7ibFWbfk1/zjHefl551TzJP5gj1FY7eaAW0ds0RJlAFeRkfp8sVYF/zlnofneb81tG1jy3%26%23xA%3bp%2bpSPa6RAsOoadFOximS6uWossIqrqHU9a74q8vXUvz8lVodWste16xkFJNO1m2vdQtmINQ3p3Ac%26%23xA%3bK6kbOlGHStCcVS2%2b0384Lw34fRdWih1JIYbu3t9PmghaG2p6EIjjjVVjjoKINtgeuKvuL8kNPvtO%26%23xA%3b/KbyvZX9vJa3cNigmt5lKSISS1GVqFTQ9DirF/zp/LfzL%2bZHmLRPLhsra08o2oN7qXmI%2bnJeh%2bXE%26%23xA%3b2lsrAvGXABZvsnv9niyrMLz8ofy7vPLGn%2bV7rR0k0HTPitLASTRxh6UMjiN09RzUnk9TUnxOKpL/%26%23xA%3bANC3fkl/1K0H/I65/wCquKs50Dy7ofl7S4dK0Oxh0/ToK%2blbQKFUE7knuWJ6k7nFXjus/wDOH35a%26%23xA%3batq99qtzqetJcahcS3UyRz2oQPM5kYKDasaVbapOKorSv%2bcV/K%2bkWstppPm7zXp1pPUzW9pqMMEb%26%23xA%3bk7Hkkduqt9OKpSf%2bcK/ytJJOq66SdyTcWla/9ImKs4/5UP5Q/wCVW/8AKtvrmofoL1fX%2bs%2bpD9b5%26%23xA%3bev8AWKc/R9OnPb%2b76Yq9HxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Ku%26%23xA%3bxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Kux%26%23xA%3bV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV%26%23xA%3b2KuxV2KuxV2KuxV2KuxV2Kpbr/mXy/5dsRf67qEGmWRcRC4uXWNObAlV5NtUhTirHP8Aldf5R/8A%26%23xA%3bU36V/wBJUX9cVTvy3528o%2bZ/rH%2bHtYtNV%2bqcPrX1SVZfT9Xlw58SacuDU%2bWKp1irHNf/ADG8h%2bXb%26%23xA%3b4WGu6/Y6ZelBKLe5nSN%2bDEhW4sa0JU4qlv8Ayuv8o/8Aqb9K/wCkqL%2buKsr0vVNO1XT4NR025jvL%26%23xA%3bC5Xnb3MLB43XpVWGxGKorFWOa/8AmN5D8u3wsNd1%2bx0y9KCUW9zOkb8GJCtxY1oSpxVLf%2bV1/lH/%26%23xA%3bANTfpX/SVF/XFWV6Xqmnarp8Go6bcx3lhcrzt7mFg8br0qrDYjFUVirEb783vyvsL24sb3zTplve%26%23xA%3bWkjwXNvJcxq8csbFXRlJ2KsCCMVUk/Oj8ppHVE83aUzuQqqLqOpJ2A64qzPFXYq7FXYq7FXYq7FX%26%23xA%3bYq7FXn35xIkieS0kUOjeatMDKwqCP3uxBxV87f8AOWvmnX9J/MOPRdMvZbLSW02GV7O2YwI0kjyq%26%23xA%3bWb0uBboOpptirIf%2bcGSSfO5JqT%2bjCSetf9MxV9U4q870y1tbj88PMwnhSYLoek8RIoalZ7zpUYq%2b%26%23xA%3bE/OHnHzPreoXcWq6lcXcSTvwieRhEoViAFiBEY%2bhcVfeP5A/%2bSa8p/8AMCv/ABJsVZ/irzjTobGb%26%23xA%3b89PMkVykUjnQtKMSSBWO093yKhvorir4W84ecfM%2bt6hdxarqVxdxJO/CJ5GEShWIAWIERj6FxV94%26%23xA%3b/kD/AOSa8p/8wK/8SbFWfkgCp2A6nFXz9e3VxZfkx%2bZetaQ8cWpW/mDWpba/VUZlX9JblGIbqhNM%26%23xA%3bVfIn6c1nV9ds7nVb6e%2bnM8f7y4kaQj4xsORNB7DFX6eYq7FXYq7FXYq7FXYq7FXYq8F/5yY038yd%26%23xA%3bQs7SDTbixj0Se5jtdNsUV3v59RmikEbCQqiQn7SJRtiak/yqvn3/AJyIsfMen%2bYtFsfNl0NR80Q6%26%23xA%3bNaC9v4yBGw9Sf4GXjV3UcQZOQ5UJ474q9S/5wY/6bb/t1/8AY5ir6muFna3lW3dY7gowhkdS6K5H%26%23xA%3bwllBQsAeo5D54q%2bb/wAsdE/PSw/NHWV1HVdOuNUi9GfXI7xXP1uxlmnEHoTxo3BRR2jWg4bAinw4%26%23xA%3bq%2bTdbMJ1a79FGRfVcMHYOS4Y8iCFSgJ6Dt4nrir9B/yB/wDJNeU/%2bYFf%2bJNirPLh5UgkeKP1pVVm%26%23xA%3bjiqF5sBULyOwqdq4q%2bQjoP593v59adLe3dvBry3EV7MLeksNnp7mYBZGVU5wiMSxqhepJpsWrir5%26%23xA%3b61xrc6tdeijoBI4cO4erhjyYUVKAnoN6eJxV%2bg35A/8AkmvKf/MCv/EmxVE/nRpnnDU/yz1yy8oy%26%23xA%3b%2blrMsBCqoPqSwg1mhhYH4ZJI6qp%2bjavIKvmny1bfmpZ/k/55Gpvb3vlKe3uoZirKk1tqMEo9VvT4%26%23xA%3bRs/N6rId6mjV61VeBaT/AMdWz/4zx/8AExir9ScVdirsVdirsVdirsVdirsVeb/nfqNjptj5Rv7%2b%26%23xA%3bdLWytfM%2bmy3FxKwVI0USlmZjsABir5v/AOcnI9J83%2bdo/MXlzXtH1GxSxhtnjTUbaOYPG8jN8Erp%26%23xA%3bUUcdCcVZf/zg0pVvO6mlQdMBoQRt9c7jbFX1Tirye685eVPLP53eYZPMOrWulJdaJpa27XcqxByk%26%23xA%3b92WC8iK05DFXxN5u8sXGmX9zONQ03ULaSV3jmsL62uKhmJ/u1f1R17pir7y/IH/yTXlP/mBX/iTY%26%23xA%3bqz/FXk915y8qeWfzu8wyeYdWtdKS60TS1t2u5ViDlJ7ssF5EVpyGKvibzd5YuNMv7mcahpuoW0kr%26%23xA%3bvHNYX1tcVDMT/dq/qjr3TFX3l%2bQP/kmvKf8AzAr/AMSbFWf4q%2bcL/wAzeUpvy5/MnyhceYNN0/Xr%26%23xA%3b7XtdWC0vblID8d%2bzKW5dA1Njir5UOjXOl65ZwzzWs59ePi9pdW90hHMb8oHkp9OKv06xV2KuxV2K%26%23xA%3buxV2KuxV2KuxVQvjYLbPJf8ApC1j%2bJ3n4iNadyX2GKsfv/Mn5a2FnNeXeo6TFbQKXlkMluaKPYEk%26%23xA%3b/IYqk%2bjfnB%2bWM17BaW88mmnUGCWVzeWF1YW9y3VRHPPFFGxNfhBaprtirP8AFUu1W48uWzxvq0ln%26%23xA%3bC8gIia6aJCwWlQpkpWnLFWN6958/K7RFhFzc2dxcXJK2tlYQ/XrmUqKtwgtllkIHc0piqP8AKH5g%26%23xA%3beTvMjzWWi3JS9s1BuNLuIZbO6iQ9GNvOkT8P8oCmKsmxVjHnDzh5A8uNC3mW8tYLm4FLa3eMz3Uo%26%23xA%3bqf7qCNZJnFf5VOKscj/N38plkjXUEl0hJSFjuNU0u6soCSabzzQJEvX9phir0W0e0ktYpLNo3tXU%26%23xA%3bNA8JUxsjCoKFfhII6UxVVxVLtSXy5YwSXupiztYAay3Nz6UaVPdneg3%2beKoTRr/yRrSs%2bi3Omaks%26%23xA%3bdC7Wb284WvSpjLUxVU0fzf5a1nVdV0nS9Qiu9Q0SRItUgjJPovICVUtTiT8JBoTQgg74qnGKuxV2%26%23xA%3bKuxV2KuxV2KuxVgH5/f%2bSa82f8wLf8SXFWCfm15e8jeT/Nvk7VrLyhYG0tV1O7e0sbS3tWubu2hi%26%23xA%3be2jLxx/EyoZpEQ/aZfHFU287%2bePypvvLWnad%2bkx5ktNXgkspbVL71mispVE1xqNzGS3x2iQ81ZwG%26%23xA%3bU1CkE4qzn8qLvVrz8s/K91q5ZtRm0y1e4dyS7ExLR3rvyZaM3virHfzC0PRda/NjyDY6zp9tqVk1%26%23xA%3bnrrm1vIY54iyrZcW4SBlqO22KsH8qah5A8ofmV5j0%2b%2bsofL732uegmo2zJp9vaw2ltbXFhbOIxGi%26%23xA%3bxXtZWNSFkKlWDbHFUd5j82%2bWtT/M3y7H5ake/wBRsNcto/07DcfWUkW/jma/0%2bI1YGCG3jWV%2bLFY%26%23xA%3b2KigJxV6p%2bYXmw%2bVfKN/rMUP1q9jCQadaDrNeXDrDbRbb0aV1r7VxVjWk%2bUNR8l6WuuxaV/i7z7q%26%23xA%3blxbrr2ptJHDMwmcLKYXl2jggQ0SJABQCvc4qy3zNeanE2m2drof6astSultNV5SRoltaujF53SQH%26%23xA%3b1VFACg64qwqysB%2bW3nnTdM06sfkbzbNLb2%2bnkkxabqoR7hRb1rxhu1R/3Y2VxUUBpirNPN3nLRPK%26%23xA%3bmnR3uqPIzXEq29lZW0bT3VzO/wBmKCFPidz%2bHU4qwzyt5E/xbdS%2bcfzC003F/PNL%2bhPL2oKHg02y%26%23xA%3bRysINu3KI3MgX1JJDU7gClMVYT%2bYmnaN5u89W/lL8s9Og0/zRpciya/5109TbDTIdw0BktzH68ri%26%23xA%3bq%2bmxIG468iir0r8lNM8oWP5e2B8q2stvp8zz%2bs90B9amuIZngmluSOsheI%2bw6DYYqzvFXYq7FXYq%26%23xA%3b7FXYq7FXYq8%2b/PiS2l/K7XtKN1bQX%2bpWrw2EFzcQ2/rSBlJVGmaNTQe%2bKqGkXvkH80tK17RpdUOu%26%23xA%3bLp%2bqTAr%2b7guLGSGQrbyWktuEPAcC0M4JLAkEndcVYd%2bXP5SaJrt75gm12/vNSs9J1y605NPf6vDF%26%23xA%3bdR2jI8b37W8MMt03JqkSPxJ6g4q93JihiJJWOKNakmiqqqPuAAxV4lqXn/yv5x/MPQr/AEHzDb6f%26%23xA%3bZ6F%2bmdLuNWea0QiaaOxeOSCK5ZvVjkIeNX4EEqadiVU5/PLyRpcvk7VvNqSzW/mLR9MkYX0Hphbt%26%23xA%3bIF9RYbyB0eGeLmOXFk2/Zpiqc/l5%2bVfl/wAutb62ZrjU9Ze2CQ3d4YwttFLR3itIIEhggVmNW4JU%26%23xA%3b9ziqz865FtPLek6xMCbHRde0nUNQIFeNvFdoryEUr%2b75h9vDwriq/wA2eZvNWo%2baE8l%2bS5ILS/jt%26%23xA%3b0vdc164j%2bsR2NvMzJAkUNVWS4mKMVDniFFTWuKoS/wDLX5s6Bbtqmi%2bapPM81uDLcaDq1taxLdBd%26%23xA%3b2jt57WOFoJCKhOXJa0rtiqA82eadM836V%2bW9xpHJpNc16yv7WFgBLHFYCS4vOY3p6QjMT%2b5xVFee%26%23xA%3briy0b82fKHmPXn9LQEs7/TrW%2bkIW3tNSuWiKNM5%2bFPXhR41Y99sVSrz9%2bY2seZtal/L/APLq8jiu%26%23xA%3bgB/iXzYGBttMgfbhFICA1y/RQDt23qUVZt5D8s%2bSfJHl6HRNEmgSFPjuLh5Uaa4mb7c0z1%2bJ2/Do%26%23xA%3bKAYqxfyRFp2hfmvqflfyzfyXPluXS21W%2b04zNdRWGoS3YCrFIzOYvrKSSSNFXqvLvir1TFXYq7FX%26%23xA%3bYq7FXYq7FXYq84/PHyrpV/5J1fW10G21jzHp9mRpTTWq3kinmDxSNlfl9omlMVYv5B1n8n/I0mpT%26%23xA%3baFomsxXWqXM1xcXH6D1AMsckpkjto6QfBDECFVR4VO%2bKsr/JaWS507zPqBtri1g1HzHqF3aJdwSW%26%23xA%3b0rQyiMo/pyqjgH3GKvQZoYZ4ZIJ41lhlUpLE4DKysKMrKdiCOoxV8%2b%2bYfyv/AC38g%2bbNIV/LB1Xy%26%23xA%3bxrEmqXWoKNNfU5LZ1itFtYEeOOWVIg/qsoJ7nwxVO/zD/Mny1qf5aa55c0TSta%2bsXOmy2Wn236H1%26%23xA%3bBEBMXCNOTQgKOg3xV7DpasumWisCrLDGGU7EEINjirtT02x1TTrrTb%2bFbixvYnt7qB/svFIpV1Pz%26%23xA%3bBxV5ToNl5k/K%2b/vYZ9Cu/NGhXYhSDzBplbnU1gtkMdvBe2hYGUwoeCywDdacl5Yqnkv5y2Vwpi0L%26%23xA%3byz5g1fUG2jthptxZxhjsPVuLtYYo18WJxVS/LP8ALa80m%2bbzH5git7fVnSaLTNGs2eW00u3uZ2uJ%26%23xA%3bo4pJCTJNNK/KaXbf4VogGKpl%2bbeg%2bc/MfllfL3lprOBNWlFtrF9eD1Db2TAmR4YSCrvtQVO3b%2bZV%26%23xA%3bWtC/Jn8utI8oWvlT9DwX2l27ieRbxFlaa548TcS1FGkI26bDYUGKrv8AlSn5R/8AUoaV/wBIsX9M%26%23xA%3bVZD5f8reW/Llo1noOl2ul2ztzkitIkhDP/M3ADke1TiqaYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXY%26%23xA%3bq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FWK%2bc/zC0/y1cW%26%23xA%3bmnR2VzrGvagryWWkWQQyNHFT1JpZJGjihhSoq7sB4VxVL/K35qQ6prFtous6Pc6BqV%2bjyaUZpbe6%26%23xA%3btbwRCsiW93aSSxNIgFWjrUDfFUH59/OvRvKuqy6TDZNqV7aCI6g7XVpYW1sZxyhikub2WGMyyJ8a%26%23xA%3bxrU8fi6YqyLyb5%2b0TzVotxqlsJLE2MjwanaXoWKW1ljUOwlozJx4MHV1YqVNa4qxyH83dT1WOS/8%26%23xA%3bq%2bTNV17QI2YDWI3tLVJ1QkM9rFcyxyzrseJCip2xVPtN/Mvyjf8Ak%2b882C5a20vTRN%2bk0uEaO4tZ%26%23xA%3bbf8AvYJ4d2WVTtw77UrUYqw7TP8AnInQ59XFpqOj3WlWTSJE93NcWUstsZWCRm/s4JpLm0VnZVrI%26%23xA%3bnwsQDTFXq9xPDbwSXE7iOGFWklkbYKqirE/IDFWE235w%2bWru3iurPTNfurS4RZbe5g0PVJIpY3HJ%26%23xA%3bJI3WCjKymoI6jFVT/lbGi/8AVk8x/wDcA1X/ALJ8VROk/mb5d1HWbTRjb6np9/f%2bp9RTUtNvbFZm%26%23xA%3bhQySJG9xFGrMsalqV6DFWSX2o6fYRLLfXUNpEzcVknkWNS1K0BYgVoMVYH5q/OTT9K1230TRLFfM%26%23xA%3bN7JatezNBf2FrDFEJPSAMtzNGrOW/ZG9N8VSHzF%2bf2seXdAfzBqvki5j0eOVbd7yDU9MulEr/ZSl%26%23xA%3bvNK1foxV6B5K83S%2bZLO/a50ybR9R0u8aw1DT55IZmjmWKOccZIGkjcGKdDUHrt2xVkWKvFfyq/Jf%26%23xA%3b8rNX/Lby1qmp%2bW7S71G9063nu7mQMXkldAWdjy6k4qmep/lj/wA45aZqcGlX%2bj6RBqt0pa105n/0%26%23xA%3bmWnaOHnzcnooAqT0xV5f5Kh/J/zH%2bYyaWPJmnJ5d1JTb6Y3F/VSZY5LmCZ2qNrqFJFKHeOSIr81U%26%23xA%3bx1c3lz/zjb%2bXEMen/pyW41DTYTpEknBbxR63G3dydlbio36Yqlf%2bE9d/9h8sf%2b4jH/XFXf4T13/2%26%23xA%3bHyx/7iMf9cVbsND1aw81eVbif8prbybH%2bnLBTrUF4szrylp6XBTWknQ4q9P8z%2bTE85ecfzB0U3TW%26%23xA%3bdzd%2bXdIsba9A5GJJ7i%2bkdeNR8DvCvNQRUYqwDVPyKbyj5f0P67rt2b2%2b83aewg0maaxsbZb64SBz%26%23xA%3bbQqx4yrGSFkrUVoPdVLfzK/I%2bztvPZs21a6FrrUVzqWn3txO2o3KPZWR%2buxXFvcyD1vVRAY5%2bXwn%26%23xA%3b4WBFMVT2z0HUNH/5xv8ANmvsfq3%2bIdJtZNPtlf1Hi02GyhtLUTScV5TSQLykoKCtAABTFWQfmj%2bR%26%23xA%3bfmrzL5y0LVPLmr2%2bk6XpNva21uGedJ7AW0pZpLKNFeFy8ZCnnxPwgcqVGKpBcfk1c655o/Mfy3B5%26%23xA%3bo1iS4FppN5BLdXSrFPeTpMVa8S2jhWRR9VjUELUDfcgYqwTy5%2bWSavPptrp07rcecpNYtJ4p2jmS%26%23xA%3bwis7mBdSk%2btjlLel%2bIFuDxAryJJqSq%2bm/wAzPNWm6J5dmtJ4rm61DWYriy0zT7G3kurmeYwO7BIo%26%23xA%3bgzURFLMewxV806D5f/My20LTrc%2bbvPemGG1hjOmweW9SkituEaj0I3FwgZI6cVPEVA6DFUd%2bh/zL%26%23xA%3b/wCp8/MD/wAJnUv%2byrFU58gaRrq/mV5G1W%2b876n5nh/SOq2EumatZzWM9ldQ6VM7iSKaaZlco6ml%26%23xA%3bBsRir1D8wtF0fWvzW8hafrFjb6lYPZ65I1peRJPCXRbPixjkDLVamhpirzS2fyq/51toL%2bXvJJ8t%26%23xA%3btOdMTTVsY/XE6k1f639T%2brtc%2bNv6vT4ftfEVUq/P/RdH0Xy5590/R7G302wS68vyLaWcSQQh3S45%26%23xA%3bMI4wq1agqaYq93/Lr/jtefv/AAI2/wC6Vp%2bKs1xV4h5W/Jvyn58/LHyPfa1NfxT2miW9vF9TunhT%26%23xA%3biycqmP4k5AnrTfvUAYqiLf8A5xi8t6frdpe6Vqt3Fp1vdW2oy6bcBJ2lu7Fna3b62w9eNBz4sqdR%26%23xA%3b774qwn8uPIPmi0/New0jVrch9ElGqXtzGCIvSjF8Y5EcE1W5vdUm9JCQ/pRVZR0xVPvL/wD5Jr8n%26%23xA%3bv%2b27pX/Ep8VTLUP%2bhq7nzXeQ6adJsfL0l9dpYXVysMjR2aPIbaSVY2eQ%2boioNgWq3xAb0VSX8x/L%26%23xA%3bX/OT0/laZLnVrLVbISRtfadoAktNQmgDfvEilaPuOoFSfA9Cq15G0nz1pn5faBD5sW7hD%2bcbCTRr%26%23xA%3bTUZfWvILEzLwjmeimvLlsQPkBQYq9GW4uLf8wvzAuLZlS5h0HSJIHcqFDqdTKli9FpUd9sVYNa%2bY%26%23xA%3bvM3mH8qvI%2bqeZbm3u9Xl836Us09o9vJEVTVAqUa1Z4dlArQ/PFUT5%2bLf8r0b0VBJ8n6j9aNqKyCP%26%23xA%3b4uH10y/AIuf916Px8/tfBiqI8zf%2bsjw/%2bArp/wD1DQ4q9iOo6epcNcxAx7SAuvwmtPi3232xV5lD%26%23xA%3bJay%2be/zVd5IDatoekl5J2cW/D6vf8jK8R5iOn2ihrTpvirC/ydjnQ/k8swlA/RnmMxeqIwDGXtSh%26%23xA%3bi4Ub0yN19T4/HFWffmneXVj538gXlpZvqF1bXGsSwWETKrzumj3DLErPRQXIpU4qwDVPz5/MoaTb%26%23xA%3byz2Wn6ELyS3guryWy1svpqXMio8831qyt7NvQ5Vb98QT05Yqsuvzl/MLQNQvNNsLlfPa2eo6dDHd%26%23xA%3bRw2qSTre/WUe0rYloeTLAs0TUDKD8Y7Yqm3kXQ/Mmr/mrqOppZRW%2biaD5o1O9urqScGc3F3o8Fr9%26%23xA%3bWWBFYfB6iuZPUodx23VZx5r/APJy%2bQP%2bYHXv%2bI2WKvKbLRNSH5ir%2bW4Sw/Q1hr63P6c9E/pRolX/%26%23xA%3bABClsT9igkl4epWtP2cVQv8Azkt/xy/P/wDxn8u/8QucVe1fl1/x2vP3/gRt/wB0rT8VZrirBLL8%26%23xA%3bmvLFjaRWdjqWv2lnbqI7e1g1zU44o0XZURFnCqo7AYqrf8qn0X/q9%2bY/%2b4/qv/ZRirv%2bVT6L/wBX%26%23xA%3bvzH/ANx/Vf8AsoxVF3H5ZeUZvKmmeVxBPBpWjvFNpn1e5nhnhlgr6ciTxusvIcjvyxVCf8qn0X/q%26%23xA%3b9%2bY/%2b4/qv/ZRirv%2bVT6L/wBXvzH/ANx/Vf8AsoxVdB%2bVHlyO%2bs7ye%2b1m%2bawuI7u2hvtX1C6hE0J5%26%23xA%3bRuYppnRip6VGKpH5ltvOdj518x3Wn%2bVLnXtJ8waVYWJubW9sbVo2tzeCUcbqRGrxuloeNMVYfovk%26%23xA%3b3znp/lzyt5N0zyVqVlpGk%2bYLDVZ9S1HU9KuHSGG9FzOWW2kQtQE0CpX54qy780/y483azr1r5l8s%26%23xA%3bXtq%2bow2NxpAsNTQmC3hv/wB3NeWzR8Ss6qfiD8gyim3Qqp15n/LuS9/KGbyBpVyqsulw6XaXVzWl%26%23xA%3bLdEjV5OAPUR70GKvL73/AJx782Xt1rt1cab5aabzHI0urMLnWB6jvcC6JUB/g/eqD8PyxVmn5Xfl%26%23xA%3bX5h8sr5gj1G4s7KLU7Cx07Tho7zu1slmtyvqB7xXJf8A0kFSeQqNxiqE/LD8ofMXljX7BdUubWXQ%26%23xA%3b/K1tdW/lyS0Rkmum1OQSXM96HL0kURItFND126Yqyrz95e8x3mteVvMGg29te3Xl26uZpNPup2tF%26%23xA%3bmS6s5bU8ZliuOJQyBqcN/bFVO41f81biCS3uPJejzQSqUlik1uRkZWFCrKdNIII7YqhdNb8wdLt1%26%23xA%3bt9M/L/QbG3VzKsNtq5hQOw4lwqaYo5EGlcVTL8tvLuvaRBr93rkVvb32vaxPqps7WZrhIEkghgWP%26%23xA%3b1mjg5n/R%2bVeA64qgPzB03zVF5v8AKvmnQtHbXV0eLUra70%2bK4gtpqX6wcJFa5aOMqptyG%2bKu4oOt%26%23xA%3bFWFRaR54j/Mybz4PIOrm4mQE6Z%2bldH%2bri5%2brraG4/v8AlX6ugTj06nFVa/8Aye1H8y9U17UfOseq%26%23xA%3beVdPv/qSQaLa3ljKZjZo/wC%2bmKR3SbGSiUYHrUdMVeo%2bUPKFl5Ysbm2gu7rULi%2buWvL/AFC/kWW4%26%23xA%3bnnZEi5uUWJNo4kQBUGw8anFU9xV2KuxV2KuxVbLLHFE8srBI41LO7GgCgVJJ9sVYj5F/NryD56ub%26%23xA%3b618s6mL2fT6G4jMcsLcGJUSIJVTktR1H09RirMMVdirFvzA/Mzyf5B063v8AzLeG2iupPRto40aW%26%23xA%3bSRgKtxRATRR1PT6SMVT3RtY03WtKtNW0ydbnT76JJ7WdagPG4qpoaEfI4qjMVdirsVdirsVdirsV%26%23xA%3bdirsVdirsVdirsVdirsVdirG/wAxPM%2bq%2bWPKF/rWlaPPrt/bKPQ0%2b2FWZmIXkwFXKJWrcATT7wq8%26%23xA%3bKMfm%2bTXdK1f84/P6eX5L2aM6f5GsCx5rK3BY7iKEkcSW4lnD/wCU43GKvJPyb0rRbfTvNSa95on8%26%23xA%3bl3H1mx02y1m3WXmtzyuJmjLR8GVP9GBYl17b4q%2bgvy88yfnR5e81aX5Y80Rr5z8s6upOlecNOKuE%26%23xA%3bjVeXOeQUUrxpXnuf2Wfpir3LFXzp/wA5s6YZfImhakFqbTUzASB0W4gdvDpWAYq9j/K3TBpf5a%2bV%26%23xA%3brDjxaDSrMSD/AIsMCtIfpcnFWUYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq8X/MX8sb%26%23xA%3bLQNS1P8AMDy15T/xl5y1K5gEVpqMvrW9oSOJnihcgtRgu3L4OqlFBxVh%2bifl15j0vU9V0nUPIMPm%26%23xA%3bDy75o803/wBc%2btMiPZ2PGM2t1FKp%2bD4ZpviUDdKAqWWqr3L8vPy%2b0LyF5dGgaI9w9iJ5bgG6lMrh%26%23xA%3bpmrxHRVUAAAKB4n4iSVWTYq8y/5yL8l6p5v/ACwu9K0m3a61Jbq0mtoUALEidY3IrT7McjMdxsMV%26%23xA%3belQQxwQRwxDjHEoRB4KooMVX4q7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYqsuI3lgkjSR%26%23xA%3bondWVZVpyQkUDCtRUdd8VeZ/kn%2bS93%2bWh1o3HmKTXzq/1biZIGg9H6t6taVmuOXP1vbp3xV6firs%26%23xA%3bVed/nR%2bU11%2bZGkafp8GvzaD9RuGuGaOH11l5IUAZRJAarXY8u528FWa6BpbaToWm6U0xuWsLWG1a%26%23xA%3b4I4mQwxrHzK1anLjWlTiqPxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2K%26%23xA%3buxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KpXqfmny5pen3Go3%2bp21vZWsbS3EzSrRUUVJ2JJ9gN%26%23xA%3bzirD7f8AOe2uoI7m18n%2baZ7aZRJBMmmHi6MKq61kBow3GKp1pH5o%2bQ9T0S21gaza2NtcTfVfS1CW%26%23xA%3bO0mjuhUNayxyspWZSp%2bDr3FRvirKI5I5EEkbB0bdWUggj2IxVdirsVdirsVdirsVdirsVdirsVdi%26%23xA%3brsVdirsVdirsVdirsVdir5r8n%2bRNF8v/AJdad%2bZOpw6Tf6JZeX4bw%2bX30TTzPJdrbrxlOpFGuCzz%26%23xA%3bfFuO/tiqHuvMX5zT2OseapdT1JbPQLiWDVp7CWxitreW2I%2btLBpc1vK9zFZtyV2kuVaSlRSmKvTP%26%23xA%3by%2b0nyV580WfWPMflTRLrzJbXc9hrV39Qt5VmubYhfWSSVGdkkjKOOR2rTtiqY/kD/wCSa8p/8wK/%26%23xA%3b8SbFWf4q7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq8K8meefyi1L8j9J8o6/5n06%26%23xA%3b2NzosdjfwPcxpNEzQ8Tsx2dG3Fe4xV5ZcXSwtqeijzXpV9p2sTevqdxBr0Fnpt9KaVnvLQwSXcbS%26%23xA%3b8QbhIJaSGoBXrir278vfPX5R%2bU/Lo0%2bbzxpV7qN1PNf6rei4hjWa7uX5ysqA0RBsqL2UDFU7/IH/%26%23xA%3bAMk15T/5gV/4k2Ks/wAVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVf/Z%3c/xmpGImg:image%3e %3c/rdf:li%3e %3c/rdf:Alt%3e %3c/xmp:Thumbnails%3e %3cxmpMM:OriginalDocumentID%3euuid:9E3E5C9A8C81DB118734DB58FDDE4BA7%3c/xmpMM:OriginalDocumentID%3e %3cxmpMM:DocumentID%3exmp.did:9bb40803-0a68-4b6d-b079-70a423632dc7%3c/xmpMM:DocumentID%3e %3cxmpMM:InstanceID%3exmp.iid:9bb40803-0a68-4b6d-b079-70a423632dc7%3c/xmpMM:InstanceID%3e %3cxmpMM:RenditionClass%3eproof:pdf%3c/xmpMM:RenditionClass%3e %3cxmpMM:DerivedFrom rdf:parseType='Resource'%3e %3cstRef:instanceID%3euuid:3790e011-2e1b-2f40-a3d6-4e538a02edb2%3c/stRef:instanceID%3e %3cstRef:documentID%3exmp.did:525ac691-adef-4d04-bc72-b632c8732463%3c/stRef:documentID%3e %3cstRef:originalDocumentID%3euuid:9E3E5C9A8C81DB118734DB58FDDE4BA7%3c/stRef:originalDocumentID%3e %3cstRef:renditionClass%3eproof:pdf%3c/stRef:renditionClass%3e %3c/xmpMM:DerivedFrom%3e %3cxmpMM:History%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cstEvt:action%3esaved%3c/stEvt:action%3e %3cstEvt:instanceID%3exmp.iid:78fa4c27-1810-4112-abf8-25d31ae36cdc%3c/stEvt:instanceID%3e %3cstEvt:when%3e2019-06-10T14:32:07%2b02:00%3c/stEvt:when%3e %3cstEvt:softwareAgent%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/stEvt:softwareAgent%3e %3cstEvt:changed%3e/%3c/stEvt:changed%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cstEvt:action%3esaved%3c/stEvt:action%3e %3cstEvt:instanceID%3exmp.iid:9bb40803-0a68-4b6d-b079-70a423632dc7%3c/stEvt:instanceID%3e %3cstEvt:when%3e2019-06-14T11:08:35%2b02:00%3c/stEvt:when%3e %3cstEvt:softwareAgent%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/stEvt:softwareAgent%3e %3cstEvt:changed%3e/%3c/stEvt:changed%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpMM:History%3e %3cillustrator:StartupProfile%3eBasic RGB%3c/illustrator:StartupProfile%3e %3cxmpTPg:NPages%3e1%3c/xmpTPg:NPages%3e %3cxmpTPg:HasVisibleTransparency%3eFalse%3c/xmpTPg:HasVisibleTransparency%3e %3cxmpTPg:HasVisibleOverprint%3eFalse%3c/xmpTPg:HasVisibleOverprint%3e %3cxmpTPg:MaxPageSize rdf:parseType='Resource'%3e %3cstDim:w%3e440.000000%3c/stDim:w%3e %3cstDim:h%3e440.000000%3c/stDim:h%3e %3cstDim:unit%3ePixels%3c/stDim:unit%3e %3c/xmpTPg:MaxPageSize%3e %3cxmpTPg:PlateNames%3e %3crdf:Seq%3e %3crdf:li%3eCyan%3c/rdf:li%3e %3crdf:li%3eMagenta%3c/rdf:li%3e %3crdf:li%3eYellow%3c/rdf:li%3e %3crdf:li%3eBlack%3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpTPg:PlateNames%3e %3cxmpTPg:SwatchGroups%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eDomy%c5%9blna grupa pr%c3%b3bek%3c/xmpG:groupName%3e %3cxmpG:groupType%3e0%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eBia%c5%82y%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eCzarny%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eCzerwony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3e%c5%bb%c3%b3%c5%82ty RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eZielony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eNiebieskozielony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eNiebieski RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eKarmazynowy RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=193 G=39 B=45%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e193%3c/xmpG:red%3e %3cxmpG:green%3e39%3c/xmpG:green%3e %3cxmpG:blue%3e45%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=237 G=28 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e237%3c/xmpG:red%3e %3cxmpG:green%3e28%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=241 G=90 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e241%3c/xmpG:red%3e %3cxmpG:green%3e90%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=247 G=147 B=30%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e247%3c/xmpG:red%3e %3cxmpG:green%3e147%3c/xmpG:green%3e %3cxmpG:blue%3e30%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=251 G=176 B=59%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e251%3c/xmpG:red%3e %3cxmpG:green%3e176%3c/xmpG:green%3e %3cxmpG:blue%3e59%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=252 G=238 B=33%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e252%3c/xmpG:red%3e %3cxmpG:green%3e238%3c/xmpG:green%3e %3cxmpG:blue%3e33%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=217 G=224 B=33%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e217%3c/xmpG:red%3e %3cxmpG:green%3e224%3c/xmpG:green%3e %3cxmpG:blue%3e33%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=140 G=198 B=63%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e140%3c/xmpG:red%3e %3cxmpG:green%3e198%3c/xmpG:green%3e %3cxmpG:blue%3e63%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=57 G=181 B=74%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e57%3c/xmpG:red%3e %3cxmpG:green%3e181%3c/xmpG:green%3e %3cxmpG:blue%3e74%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=146 B=69%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e146%3c/xmpG:green%3e %3cxmpG:blue%3e69%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=104 B=55%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e104%3c/xmpG:green%3e %3cxmpG:blue%3e55%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=34 G=181 B=115%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e34%3c/xmpG:red%3e %3cxmpG:green%3e181%3c/xmpG:green%3e %3cxmpG:blue%3e115%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=169 B=157%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e169%3c/xmpG:green%3e %3cxmpG:blue%3e157%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=41 G=171 B=226%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e41%3c/xmpG:red%3e %3cxmpG:green%3e171%3c/xmpG:green%3e %3cxmpG:blue%3e226%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=113 B=188%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e113%3c/xmpG:green%3e %3cxmpG:blue%3e188%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=46 G=49 B=146%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e46%3c/xmpG:red%3e %3cxmpG:green%3e49%3c/xmpG:green%3e %3cxmpG:blue%3e146%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=27 G=20 B=100%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e27%3c/xmpG:red%3e %3cxmpG:green%3e20%3c/xmpG:green%3e %3cxmpG:blue%3e100%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=102 G=45 B=145%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e102%3c/xmpG:red%3e %3cxmpG:green%3e45%3c/xmpG:green%3e %3cxmpG:blue%3e145%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=147 G=39 B=143%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e147%3c/xmpG:red%3e %3cxmpG:green%3e39%3c/xmpG:green%3e %3cxmpG:blue%3e143%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=158 G=0 B=93%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e158%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e93%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=212 G=20 B=90%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e212%3c/xmpG:red%3e %3cxmpG:green%3e20%3c/xmpG:green%3e %3cxmpG:blue%3e90%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=237 G=30 B=121%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e237%3c/xmpG:red%3e %3cxmpG:green%3e30%3c/xmpG:green%3e %3cxmpG:blue%3e121%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=199 G=178 B=153%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e199%3c/xmpG:red%3e %3cxmpG:green%3e178%3c/xmpG:green%3e %3cxmpG:blue%3e153%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=153 G=134 B=117%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e153%3c/xmpG:red%3e %3cxmpG:green%3e134%3c/xmpG:green%3e %3cxmpG:blue%3e117%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=115 G=99 B=87%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e115%3c/xmpG:red%3e %3cxmpG:green%3e99%3c/xmpG:green%3e %3cxmpG:blue%3e87%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=83 G=71 B=65%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e83%3c/xmpG:red%3e %3cxmpG:green%3e71%3c/xmpG:green%3e %3cxmpG:blue%3e65%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=198 G=156 B=109%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e198%3c/xmpG:red%3e %3cxmpG:green%3e156%3c/xmpG:green%3e %3cxmpG:blue%3e109%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=166 G=124 B=82%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e166%3c/xmpG:red%3e %3cxmpG:green%3e124%3c/xmpG:green%3e %3cxmpG:blue%3e82%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=140 G=98 B=57%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e140%3c/xmpG:red%3e %3cxmpG:green%3e98%3c/xmpG:green%3e %3cxmpG:blue%3e57%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=117 G=76 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e117%3c/xmpG:red%3e %3cxmpG:green%3e76%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=96 G=56 B=19%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e96%3c/xmpG:red%3e %3cxmpG:green%3e56%3c/xmpG:green%3e %3cxmpG:blue%3e19%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=66 G=33 B=11%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e66%3c/xmpG:red%3e %3cxmpG:green%3e33%3c/xmpG:green%3e %3cxmpG:blue%3e11%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eZimne%3c/xmpG:groupName%3e %3cxmpG:groupType%3e1%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=56 M=0 Y=20 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e101%3c/xmpG:red%3e %3cxmpG:green%3e200%3c/xmpG:green%3e %3cxmpG:blue%3e208%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=51 M=43 Y=0 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e131%3c/xmpG:red%3e %3cxmpG:green%3e139%3c/xmpG:green%3e %3cxmpG:blue%3e197%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=26 M=41 Y=0 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e186%3c/xmpG:red%3e %3cxmpG:green%3e155%3c/xmpG:green%3e %3cxmpG:blue%3e201%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eSzaro%c5%9bci%3c/xmpG:groupName%3e %3cxmpG:groupType%3e1%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=0 B=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=26 G=26 B=26%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e26%3c/xmpG:red%3e %3cxmpG:green%3e26%3c/xmpG:green%3e %3cxmpG:blue%3e26%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=51 G=51 B=51%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e51%3c/xmpG:red%3e %3cxmpG:green%3e51%3c/xmpG:green%3e %3cxmpG:blue%3e51%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=77 G=77 B=77%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e77%3c/xmpG:red%3e %3cxmpG:green%3e77%3c/xmpG:green%3e %3cxmpG:blue%3e77%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=102 G=102 B=102%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e102%3c/xmpG:red%3e %3cxmpG:green%3e102%3c/xmpG:green%3e %3cxmpG:blue%3e102%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=128 G=128 B=128%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e128%3c/xmpG:red%3e %3cxmpG:green%3e128%3c/xmpG:green%3e %3cxmpG:blue%3e128%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=153 G=153 B=153%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e153%3c/xmpG:red%3e %3cxmpG:green%3e153%3c/xmpG:green%3e %3cxmpG:blue%3e153%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=179 G=179 B=179%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e179%3c/xmpG:red%3e %3cxmpG:green%3e179%3c/xmpG:green%3e %3cxmpG:blue%3e179%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=204 G=204 B=204%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e204%3c/xmpG:red%3e %3cxmpG:green%3e204%3c/xmpG:green%3e %3cxmpG:blue%3e204%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=230 G=230 B=230%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e230%3c/xmpG:red%3e %3cxmpG:green%3e230%3c/xmpG:green%3e %3cxmpG:blue%3e230%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=242 G=242 B=242%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e242%3c/xmpG:red%3e %3cxmpG:green%3e242%3c/xmpG:green%3e %3cxmpG:blue%3e242%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpTPg:SwatchGroups%3e %3cpdf:Producer%3eAdobe PDF library 15.00%3c/pdf:Producer%3e %3c/rdf:Description%3e %3c/rdf:RDF%3e%3c/x:xmpmeta%3e %3c%3fxpacket end='w'%3f%3e %3c/metadata%3e%3cg id='Warstwa_1' class='st0'%3e %3cg class='st1'%3e %3cline class='st2' x1='0' y1='0' x2='0' y2='440'/%3e %3cline class='st2' x1='10' y1='0' x2='10' y2='440'/%3e %3cline class='st2' x1='20' y1='0' x2='20' y2='440'/%3e %3cline class='st2' x1='30' y1='0' x2='30' y2='440'/%3e %3cline class='st2' x1='40' y1='0' x2='40' y2='440'/%3e %3cline class='st2' x1='50' y1='0' x2='50' y2='440'/%3e %3cline class='st3' x1='60' y1='0' x2='60' y2='440'/%3e %3cline class='st2' x1='70' y1='0' x2='70' y2='440'/%3e %3cline class='st2' x1='80' y1='0' x2='80' y2='440'/%3e %3cline class='st2' x1='90' y1='0' x2='90' y2='440'/%3e %3cline class='st2' x1='100' y1='0' x2='100' y2='440'/%3e %3cline class='st2' x1='110' y1='0' x2='110' y2='440'/%3e %3cline class='st2' x1='120' y1='0' x2='120' y2='440'/%3e %3cline class='st2' x1='130' y1='0' x2='130' y2='440'/%3e %3cline class='st2' x1='140' y1='0' x2='140' y2='440'/%3e %3cline class='st2' x1='150' y1='0' x2='150' y2='440'/%3e %3cline class='st2' x1='160' y1='0' x2='160' y2='440'/%3e %3cline class='st2' x1='170' y1='0' x2='170' y2='440'/%3e %3cline class='st2' x1='180' y1='0' x2='180' y2='440'/%3e %3cline class='st2' x1='190' y1='0' x2='190' y2='440'/%3e %3cline class='st2' x1='200' y1='0' x2='200' y2='440'/%3e %3cline class='st2' x1='210' y1='0' x2='210' y2='440'/%3e %3cline class='st3' x1='220' y1='0' x2='220' y2='440'/%3e %3cline class='st2' x1='230' y1='0' x2='230' y2='440'/%3e %3cline class='st2' x1='240' y1='0' x2='240' y2='440'/%3e %3cline class='st2' x1='250' y1='0' x2='250' y2='440'/%3e %3cline class='st2' x1='260' y1='0' x2='260' y2='440'/%3e %3cline class='st2' x1='270' y1='0' x2='270' y2='440'/%3e %3cline class='st2' x1='280' y1='0' x2='280' y2='440'/%3e %3cline class='st2' x1='290' y1='0' x2='290' y2='440'/%3e %3cline class='st2' x1='300' y1='0' x2='300' y2='440'/%3e %3cline class='st2' x1='310' y1='0' x2='310' y2='440'/%3e %3cline class='st2' x1='320' y1='0' x2='320' y2='440'/%3e %3cline class='st2' x1='330' y1='0' x2='330' y2='440'/%3e %3cline class='st2' x1='340' y1='0' x2='340' y2='440'/%3e %3cline class='st2' x1='350' y1='0' x2='350' y2='440'/%3e %3cline class='st2' x1='360' y1='0' x2='360' y2='440'/%3e %3cline class='st2' x1='370' y1='0' x2='370' y2='440'/%3e %3cline class='st3' x1='380' y1='0' x2='380' y2='440'/%3e %3cline class='st2' x1='390' y1='0' x2='390' y2='440'/%3e %3cline class='st2' x1='400' y1='0' x2='400' y2='440'/%3e %3cline class='st2' x1='410' y1='0' x2='410' y2='440'/%3e %3cline class='st2' x1='420' y1='0' x2='420' y2='440'/%3e %3cline class='st2' x1='430' y1='0' x2='430' y2='440'/%3e %3cline class='st2' x1='440' y1='0' x2='440' y2='440'/%3e %3c/g%3e %3cg class='st1'%3e %3cline class='st2' x1='440' y1='0' x2='0' y2='0'/%3e %3cline class='st2' x1='440' y1='10' x2='0' y2='10'/%3e %3cline class='st2' x1='440' y1='20' x2='0' y2='20'/%3e %3cline class='st2' x1='440' y1='30' x2='0' y2='30'/%3e %3cline class='st2' x1='440' y1='40' x2='0' y2='40'/%3e %3cline class='st2' x1='440' y1='50' x2='0' y2='50'/%3e %3cline class='st3' x1='440' y1='60' x2='0' y2='60'/%3e %3cline class='st2' x1='440' y1='70' x2='0' y2='70'/%3e %3cline class='st2' x1='440' y1='80' x2='0' y2='80'/%3e %3cline class='st2' x1='440' y1='90' x2='0' y2='90'/%3e %3cline class='st2' x1='440' y1='100' x2='0' y2='100'/%3e %3cline class='st2' x1='440' y1='110' x2='0' y2='110'/%3e %3cline class='st2' x1='440' y1='120' x2='0' y2='120'/%3e %3cline class='st2' x1='440' y1='130' x2='0' y2='130'/%3e %3cline class='st2' x1='440' y1='140' x2='0' y2='140'/%3e %3cline class='st2' x1='440' y1='150' x2='0' y2='150'/%3e %3cline class='st2' x1='440' y1='160' x2='0' y2='160'/%3e %3cline class='st2' x1='440' y1='170' x2='0' y2='170'/%3e %3cline class='st2' x1='440' y1='180' x2='0' y2='180'/%3e %3cline class='st2' x1='440' y1='190' x2='0' y2='190'/%3e %3cline class='st2' x1='440' y1='200' x2='0' y2='200'/%3e %3cline class='st2' x1='440' y1='210' x2='0' y2='210'/%3e %3cline class='st3' x1='440' y1='220' x2='0' y2='220'/%3e %3cline class='st2' x1='440' y1='230' x2='0' y2='230'/%3e %3cline class='st2' x1='440' y1='240' x2='0' y2='240'/%3e %3cline class='st2' x1='440' y1='250' x2='0' y2='250'/%3e %3cline class='st2' x1='440' y1='260' x2='0' y2='260'/%3e %3cline class='st2' x1='440' y1='270' x2='0' y2='270'/%3e %3cline class='st2' x1='440' y1='280' x2='0' y2='280'/%3e %3cline class='st2' x1='440' y1='290' x2='0' y2='290'/%3e %3cline class='st2' x1='440' y1='300' x2='0' y2='300'/%3e %3cline class='st2' x1='440' y1='310' x2='0' y2='310'/%3e %3cline class='st2' x1='440' y1='320' x2='0' y2='320'/%3e %3cline class='st2' x1='440' y1='330' x2='0' y2='330'/%3e %3cline class='st2' x1='440' y1='340' x2='0' y2='340'/%3e %3cline class='st2' x1='440' y1='350' x2='0' y2='350'/%3e %3cline class='st2' x1='440' y1='360' x2='0' y2='360'/%3e %3cline class='st2' x1='440' y1='370' x2='0' y2='370'/%3e %3cline class='st3' x1='440' y1='380' x2='0' y2='380'/%3e %3cline class='st2' x1='440' y1='390' x2='0' y2='390'/%3e %3cline class='st2' x1='440' y1='400' x2='0' y2='400'/%3e %3cline class='st2' x1='440' y1='410' x2='0' y2='410'/%3e %3cline class='st2' x1='440' y1='420' x2='0' y2='420'/%3e %3cline class='st2' x1='440' y1='430' x2='0' y2='430'/%3e %3cline class='st2' x1='440' y1='440' x2='0' y2='440'/%3e %3c/g%3e%3c/g%3e%3cg id='Warstwa_2' class='st0'%3e %3ccircle class='st4' cx='220' cy='220' r='100'/%3e %3ccircle class='st4' cx='220' cy='220' r='40'/%3e %3ccircle class='st4' cx='220' cy='220' r='160'/%3e %3ccircle class='st4' cx='220' cy='220' r='220'/%3e%3c/g%3e%3cg id='Warstwa_3'%3e %3cg%3e %3cg%3e %3cpath d='M220%2c150c-38.6%2c0-70%2c31.4-70%2c70c0%2c23.75%2c11.9%2c45.7%2c31.84%2c58.7c11.34%2c7.4%2c24.54%2c11.3%2c38.16%2c11.3c38.6%2c0%2c70-31.4%2c70-70 S258.6%2c150%2c220%2c150z'/%3e %3c/g%3e %3cg%3e %3cpath d='M400%2c100.28V90h-40v10.28h-40l-40-40.56H159.72l-39.44%2c40.56H10V350h420V100.28H400z M85%2c155H35v-30h50V155z M220%2c320 c-20.12%2c0-38.86-5.94-54.55-16.17C138.09%2c285.98%2c120%2c255.1%2c120%2c220c0-55.23%2c44.77-100%2c100-100s100%2c44.77%2c100%2c100 C320%2c275.23%2c275.23%2c320%2c220%2c320z'/%3e %3c/g%3e %3c/g%3e%3c/g%3e%3c/svg%3e";

var img$J = "data:image/svg+xml,%3c%3fxml version='1.0'%3f%3e%3csvg enable-background='new 0 0 32 32' version='1.1' viewBox='2 2 28 28' xml:space='preserve' xmlns='http://www.w3.org/2000/svg'%3e %3cg%3e %3cpolygon points='2%2c26 6%2c30 16%2c20 26%2c30 30%2c26 20%2c16 30%2c6 26%2c2 16%2c12 6%2c2 2%2c6 12%2c16 ' /%3e %3c/g%3e%3c/svg%3e";

var img$I = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 32 32' style='enable-background:new 0 0 32 32%3b' xml:space='preserve'%3e%3ccircle class='circle' cx='16' cy='16' r='16'/%3e%3cpolygon style='fill:white%3b' points='25.9%2c9.9 22.1%2c6.1 16%2c12.2 9.9%2c6.1 6.1%2c9.9 12.2%2c16 6.1%2c22.1 9.9%2c25.9 16%2c19.8 22.1%2c25.9 25.9%2c22.1 19.9%2c16 '/%3e%3c/svg%3e";

var img$H = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 23.0.4%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 440 440' style='enable-background:new 0 0 440 440%3b' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bdisplay:none%3b%7d .st1%7bdisplay:inline%3b%7d .st2%7bfill:none%3bstroke:grey%3bstroke-miterlimit:10%3b%7d .st3%7bfill:none%3bstroke:%23C1272D%3bstroke-miterlimit:10%3b%7d .st4%7bdisplay:inline%3bfill:none%3bstroke:%23C1272D%3bstroke-miterlimit:10%3b%7d%3c/style%3e%3cmetadata%3e%3c%3fxpacket begin=' ' id='W5M0MpCehiHzreSzNTczkc9d'%3f%3e%3cx:xmpmeta xmlns:x='adobe:ns:meta/' x:xmptk='Adobe XMP Core 5.6-c145 79.163499%2c 2018/08/13-16:40:22 '%3e %3crdf:RDF xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%3e %3crdf:Description rdf:about='' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:xmp='http://ns.adobe.com/xap/1.0/' xmlns:xmpGImg='http://ns.adobe.com/xap/1.0/g/img/' xmlns:xmpMM='http://ns.adobe.com/xap/1.0/mm/' xmlns:stRef='http://ns.adobe.com/xap/1.0/sType/ResourceRef%23' xmlns:stEvt='http://ns.adobe.com/xap/1.0/sType/ResourceEvent%23' xmlns:illustrator='http://ns.adobe.com/illustrator/1.0/' xmlns:xmpTPg='http://ns.adobe.com/xap/1.0/t/pg/' xmlns:stDim='http://ns.adobe.com/xap/1.0/sType/Dimensions%23' xmlns:xmpG='http://ns.adobe.com/xap/1.0/g/' xmlns:pdf='http://ns.adobe.com/pdf/1.3/'%3e %3cdc:format%3eimage/svg%2bxml%3c/dc:format%3e %3cdc:title%3e %3crdf:Alt%3e %3crdf:li xml:lang='x-default'%3eIcons%3c/rdf:li%3e %3c/rdf:Alt%3e %3c/dc:title%3e %3cxmp:CreatorTool%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/xmp:CreatorTool%3e %3cxmp:CreateDate%3e2019-06-14T11:08:35%2b02:00%3c/xmp:CreateDate%3e %3cxmp:ModifyDate%3e2019-06-14T11:08:35%2b02:00%3c/xmp:ModifyDate%3e %3cxmp:MetadataDate%3e2019-06-14T11:08:35%2b02:00%3c/xmp:MetadataDate%3e %3cxmp:Thumbnails%3e %3crdf:Alt%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpGImg:width%3e180%3c/xmpGImg:width%3e %3cxmpGImg:height%3e256%3c/xmpGImg:height%3e %3cxmpGImg:format%3eJPEG%3c/xmpGImg:format%3e %3cxmpGImg:image%3e/9j/4AAQSkZJRgABAgEASABIAAD/7QAsUGhvdG9zaG9wIDMuMAA4QklNA%2b0AAAAAABAASAAAAAEA%26%23xA%3bAQBIAAAAAQAB/%2b4ADkFkb2JlAGTAAAAAAf/bAIQABgQEBAUEBgUFBgkGBQYJCwgGBggLDAoKCwoK%26%23xA%3bDBAMDAwMDAwQDA4PEA8ODBMTFBQTExwbGxscHx8fHx8fHx8fHwEHBwcNDA0YEBAYGhURFRofHx8f%26%23xA%3bHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8f/8AAEQgBAAC0AwER%26%23xA%3bAAIRAQMRAf/EAaIAAAAHAQEBAQEAAAAAAAAAAAQFAwIGAQAHCAkKCwEAAgIDAQEBAQEAAAAAAAAA%26%23xA%3bAQACAwQFBgcICQoLEAACAQMDAgQCBgcDBAIGAnMBAgMRBAAFIRIxQVEGE2EicYEUMpGhBxWxQiPB%26%23xA%3bUtHhMxZi8CRygvElQzRTkqKyY3PCNUQnk6OzNhdUZHTD0uIIJoMJChgZhJRFRqS0VtNVKBry4/PE%26%23xA%3b1OT0ZXWFlaW1xdXl9WZ2hpamtsbW5vY3R1dnd4eXp7fH1%2bf3OEhYaHiImKi4yNjo%2bCk5SVlpeYmZ%26%23xA%3bqbnJ2en5KjpKWmp6ipqqusra6voRAAICAQIDBQUEBQYECAMDbQEAAhEDBCESMUEFURNhIgZxgZEy%26%23xA%3bobHwFMHR4SNCFVJicvEzJDRDghaSUyWiY7LCB3PSNeJEgxdUkwgJChgZJjZFGidkdFU38qOzwygp%26%23xA%3b0%2bPzhJSktMTU5PRldYWVpbXF1eX1RlZmdoaWprbG1ub2R1dnd4eXp7fH1%2bf3OEhYaHiImKi4yNjo%26%23xA%3b%2bDlJWWl5iZmpucnZ6fkqOkpaanqKmqq6ytrq%2bv/aAAwDAQACEQMRAD8A9TTTwQJ6k0ixJ05OQoqf%26%23xA%3bc4q%2bevyy0P8AKe41O38n%2ba/LVg3m%2b9jvtVinvYI2kuY31W9VY6sK80ghR1Fd0NRsuKs01T8v/JHl%26%23xA%3br8wfIF1oGh2Wl3M2pXsUs1rCkTMn6HvG4kqBtUA4q9UxV4x%2baHmPy55y8xWHkeCBdUTQtb0q48xK%26%23xA%3bwV4EikM6yRuD19NR%2b87CoHWtFWYRfkz%2bT0qCSLynpEkbfZdbaIg/IgYql35IadY6bY%2bbrCwgS1sr%26%23xA%3bXzPqUVvbxKFSNFEQVVUbAAYq9IxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KvIv%2bcgvyp87%26%23xA%3bfmTY6ZpOjalZ6fpNpI1zeR3Jl5zT04x7Ro44opbv1Ptir50/Ln8hPMl9%2bY%2bjw6bqwbTbZBql1r9i%26%23xA%3bJYvq6297PaemnrIjeu09k4TalPi3AOKvrPzt/wApv%2bXn/bVvf%2b6Ne4qzG5hM9vLCsrwmVGQTREB0%26%23xA%3bLCnJCwYch1FRir4R1j/nHXzTbee7/QdS1WG3aS7totN1S7WdxfnUXlELgxrKVasLCTkfhbudiVX1%26%23xA%3bL%2bQv5decvy%2b8sXPl3X9QtNQsknM%2bltamUmIS1M0bCRE%2bHn8a07s2Ko38of8Aptf/AAK9T/5lYq9A%26%23xA%3bxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV5l5V8ofmp5W0kaPpl5oM1nHPdTQy3MF4Zi%26%23xA%3bt1dS3XFykir8LTkCgxVMI/LX5i6j5p8vap5gu9I%2bo6Fc3F16VhFcpLI01lPaAVmd1oPrHL6MVZ7i%26%23xA%3brEvzG8p6v5istIOkXFtb6ho%2bqW2qQvdo7xN9WDfu2EZVviLDocVQ/p/nT/y0eW/%2bRF9/1WxVE/lz%26%23xA%3b5U1jy7Y6uNYuLe5v9X1W51WVrRXSFDchPgUSFm2KdzirLMVdirsVdirsVdirsVdirsVdirsVdirs%26%23xA%3bVdirsVdirsVU7q5gtbaW5uH9OCBGllc1IVEHJjt4AYqgtB8yeX/MFiL7Q9RttTszt69rKkqg%2bDcS%26%23xA%3beJ9jviqY4q7FUr1vzV5c0KS0j1rUrfTjfuYrRrqRYkkdRUqHei1oeld8VTNHR0V0YMjAFWBqCDuC%26%23xA%3bCMVbxV2KuxV2KrJpoYInmmkWKGNS0kjkKqqBUlidgBiqW/4s8q/9Xmx/6SYf%2basVd/izyr/1ebH/%26%23xA%3bAKSYf%2basVRljqem36NJY3cN2iHi7wSLIAetCVJxVE4qsmnggT1JpFiTpychRU%2b5xVsTRGL1Q6mKn%26%23xA%3bL1ARx49a16UxVBaHr%2bia9p66jot9DqFg7Oi3Nu4kjLRsVYcl8CMVR%2bKuxV2KuxVhP51SapH%2bVXmW%26%23xA%3bTSmnTUFs2Ns1qXEwfkv2DH8VfliryzSfy28oa75T1ma383eZ5NX0W2dNXsJdUkHp3H1b1aPEVNYp%26%23xA%3bP2fHcdQQFXyr5A1fVdL84aRPpl5PZTNeW8byW8jRMyNKoZWKkVUjqDtir9M8VeDeZprX8zPzU0Ox%26%23xA%3b0nWNWg8rx2mowXd9pNxJbRPdWkijaROSMKkgEjfttvirzT/nKf8ALPTvKGgaHc2us6xqbXV3LG0e%26%23xA%3bq3rXaIFj5VjVlXiffFUx/wCcJtY1abWPMGmTXs8mm29pFJBZvI7QxuZSCyRk8VJrvQYq9l/OyL88%26%23xA%3bZF0YflbNHCQbk6w0gsyT/dfVwPrauP8AfleP04q8u%2bp/85x/8t8H/A6L/wBUsVd9T/5zj/5b4P8A%26%23xA%3bgdF/6pYqzP8AKWD/AJybj83IfzEuYpvLhglDqo04MJtvTI%2bqokn8MVTz/nIjW9Otfy4v9PNxYvqt%26%23xA%3bxPpr2ulXs0SC4Uanb8ldHZeUJCsJD041rtirxr9Ka1/5b78sf%2bR%2blf8AZRirv0prX/lvvyx/5H6V%26%23xA%3b/wBlGKs8/JCLXYPzN1ddV0DSPLX1nQLO4t7HQPSFlPEbucR3R9BnRnb4l5V%2byBir0X8zfza8n/l7%26%23xA%3bpT3OtXiDUJYnfTtLSrT3DqDxAVQ3BCwpzaijxxV%2bf/nXz55q86azLq3mG/ku55GJiiLEQwqekcMf%26%23xA%3b2UUe3XqanfFWcfk1oPm7V9L1gXHmC58uflnDHTzVf%2boywNHUMbeFDUNPJsvwitDQ15BWVfdHljy/%26%23xA%3boXl/QrPSNBto7XSrWMLbRR9OJ35FurM1asx3J3xV4J5o/wCcq9b0aLUriPRNJmistRuNMjtjqq/X%26%23xA%3biYJHQTPZiP1RGeFa9PfFXmX6Z/5yC1nhrOo%2beIfLTaz/AKTpum3uqLpzSxSH4DBbVrHEeiF%2bNetT%26%23xA%3b1xVMrL/nKL82PIdlN5U8z6THqGv2EnEX2oO/qem1GUSemaTAg1SQPuKdeuKvYv8Alf2o/wDKhv8A%26%23xA%3blZn6Hh%2bu%2bt9X/R3rN6XL6z9X5c%2bPKn7VPor3xVif/OSnk783dd1t9Z0%2b9h0jydolsFjna%2bNvUvRp%26%23xA%3bppVTcfFRB7KD3xV59%2bSPkP8AMa182%2batSkvDHpul6fd2%2bu3RczxXrS2xeOBHb7bfEsnL9kD/ACgC%26%23xA%3bq8V8p/8AKU6N/wAx1t/yeXFX6I/mxoXmjXvy%2b1nSvLF59R1m6gKwSdC69XhD1HAyrVOXauKvibyV%26%23xA%3b%2bWH5pav6OnaLqI0%2b6me5WPSZb17WblaPwuD6I6cG2OKvVf8AnKQeaV/KfyNF5rRE8wwzyxag0biV%26%23xA%3bJJI4uHqhh3kUBz4EkYqgv%2bcIf%2bUq8y/8wMP/ACexVOf%2bc34TPceRIQQplfUkDHoCxsxU4q8k1P8A%26%23xA%3bJLStLhM175/0GONZmtmK/XZKSoWDIRHbsQRwPX%2bIxVOvy/8AyV8natJfS/ppfOktoIAuh%2bXna1uu%26%23xA%3bE8oie4Zr%2bKIFIQa0TvTkVHVVPvyD8u6f5b/5ya1HQdOvRqFlp0d/bwXexLKgGzFduSfZam1QcVVv%26%23xA%3b%2bcttA1HXfzl0mwsFT1f8PpNLJKwjiihguLySWWR22VERSx/DfFXkEf5fWcFhc6rqXmGx/RNm0UVw%26%23xA%3b%2bmN9fufUn5emiQlrdSWEbt8UiiinetAVW5/ys8wvHq9xpfHUbLSLGDVZZFDRyGynr%2b89Jt1aIgiV%26%23xA%3ba/DQ05AVxV9P/wDONEh1C60/ULWKZrGw8qWOl3N08MsUf1xL%2b6naJHkVBJSORWLJVd%2buKvEf%2bctI%26%23xA%3bNWT86dSkvQ/1SW2tDpbP9n0BAivw9vXEtffFWM/ld%2bVz%2ba3utZ1m6/Q3kjRv3mt63JsABQ%2bhBUHn%26%23xA%3bM9QAADSo2JKqyqp%2baP5op5kS18u%2bXbX9DeQ9G%2bDSNITYuRUG5uSCecz1J3JpXuSzFV9Uf84pefPM%26%23xA%3b3m38v7ka87XMmk3X1K1vmUKZIREjKjUADNHypXwIrvvir4688PDH%2bZHmCSdPUhTWbxpY/wCZRdOW%26%23xA%3bH0jFWY/nD5O8463%2bYF/5h0nTrvW9D1%2bVbnQtSsYZLiGS3dF9GFTGrcXhQemYzQrx6Yql35xUtP8A%26%23xA%3bCmg3brLr%2bhaLFZ62yuJDFMZpZY7V2BIL28Mio1Dt9ntir1D/ANcl/wCj7/u54q%2bk/wA1/Lmp%2bZfy%26%23xA%3b617QdLVG1DULUw2yyNwQuWB3Y9OmKvOJZvz70vydd6YvlDQ4rRLKWO5livW9Rv3JV5eIX4nYCvvi%26%23xA%3br52/Kz8g/wA0fMGsaZqsOjvYaVDcQ3DX2oE2yMkbq/wIwMr1A2KoR74q%2b/MVeTfmB5R8%2bwfmVo3n%26%23xA%3bHyTpNhem0srq3vIbqYWweW5ZaueIqzcVG%2bKvIf8AnI%2b3/OnzLpugafrfle3jc3chsotHllvppJDH%26%23xA%3b8QZAtQAu9cVZd/zit%2bTvnnyTe6trHma1jsE1K2jht7QyrJcArJz5OsfJFFP8qvtirMPz6/I65/NJ%26%23xA%3bdD9DV00ptHN1XnAZhILr0fB4%2bPH0PxxV5J/0I5qv/U3Qf9IT/wDVbFV8P/OEetwSCSHzlFFIKgOl%26%23xA%3bpIpoRQ7ibFWbfk1/zjHefl551TzJP5gj1FY7eaAW0ds0RJlAFeRkfp8sVYF/zlnofneb81tG1jy3%26%23xA%3bp%2bpSPa6RAsOoadFOximS6uWossIqrqHU9a74q8vXUvz8lVodWste16xkFJNO1m2vdQtmINQ3p3Ac%26%23xA%3bK6kbOlGHStCcVS2%2b0384Lw34fRdWih1JIYbu3t9PmghaG2p6EIjjjVVjjoKINtgeuKvuL8kNPvtO%26%23xA%3b/KbyvZX9vJa3cNigmt5lKSISS1GVqFTQ9DirF/zp/LfzL%2bZHmLRPLhsra08o2oN7qXmI%2bnJeh%2bXE%26%23xA%3b2lsrAvGXABZvsnv9niyrMLz8ofy7vPLGn%2bV7rR0k0HTPitLASTRxh6UMjiN09RzUnk9TUnxOKpL/%26%23xA%3bANC3fkl/1K0H/I65/wCquKs50Dy7ofl7S4dK0Oxh0/ToK%2blbQKFUE7knuWJ6k7nFXjus/wDOH35a%26%23xA%3batq99qtzqetJcahcS3UyRz2oQPM5kYKDasaVbapOKorSv%2bcV/K%2bkWstppPm7zXp1pPUzW9pqMMEb%26%23xA%3bk7Hkkduqt9OKpSf%2bcK/ytJJOq66SdyTcWla/9ImKs4/5UP5Q/wCVW/8AKtvrmofoL1fX%2bs%2bpD9b5%26%23xA%3bev8AWKc/R9OnPb%2b76Yq9HxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Ku%26%23xA%3bxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Kux%26%23xA%3bV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV%26%23xA%3b2KuxV2KuxV2KuxV2KuxV2Kpbr/mXy/5dsRf67qEGmWRcRC4uXWNObAlV5NtUhTirHP8Aldf5R/8A%26%23xA%3bU36V/wBJUX9cVTvy3528o%2bZ/rH%2bHtYtNV%2bqcPrX1SVZfT9Xlw58SacuDU%2bWKp1irHNf/ADG8h%2bXb%26%23xA%3b4WGu6/Y6ZelBKLe5nSN%2bDEhW4sa0JU4qlv8Ayuv8o/8Aqb9K/wCkqL%2buKsr0vVNO1XT4NR025jvL%26%23xA%3bC5Xnb3MLB43XpVWGxGKorFWOa/8AmN5D8u3wsNd1%2bx0y9KCUW9zOkb8GJCtxY1oSpxVLf%2bV1/lH/%26%23xA%3bANTfpX/SVF/XFWV6Xqmnarp8Go6bcx3lhcrzt7mFg8br0qrDYjFUVirEb783vyvsL24sb3zTplve%26%23xA%3bWkjwXNvJcxq8csbFXRlJ2KsCCMVUk/Oj8ppHVE83aUzuQqqLqOpJ2A64qzPFXYq7FXYq7FXYq7FX%26%23xA%3bYq7FXn35xIkieS0kUOjeatMDKwqCP3uxBxV87f8AOWvmnX9J/MOPRdMvZbLSW02GV7O2YwI0kjyq%26%23xA%3bWb0uBboOpptirIf%2bcGSSfO5JqT%2bjCSetf9MxV9U4q870y1tbj88PMwnhSYLoek8RIoalZ7zpUYq%2b%26%23xA%3bE/OHnHzPreoXcWq6lcXcSTvwieRhEoViAFiBEY%2bhcVfeP5A/%2bSa8p/8AMCv/ABJsVZ/irzjTobGb%26%23xA%3b89PMkVykUjnQtKMSSBWO093yKhvorir4W84ecfM%2bt6hdxarqVxdxJO/CJ5GEShWIAWIERj6FxV94%26%23xA%3b/kD/AOSa8p/8wK/8SbFWfkgCp2A6nFXz9e3VxZfkx%2bZetaQ8cWpW/mDWpba/VUZlX9JblGIbqhNM%26%23xA%3bVfIn6c1nV9ds7nVb6e%2bnM8f7y4kaQj4xsORNB7DFX6eYq7FXYq7FXYq7FXYq7FXYq8F/5yY038yd%26%23xA%3bQs7SDTbixj0Se5jtdNsUV3v59RmikEbCQqiQn7SJRtiak/yqvn3/AJyIsfMen%2bYtFsfNl0NR80Q6%26%23xA%3bNaC9v4yBGw9Sf4GXjV3UcQZOQ5UJ474q9S/5wY/6bb/t1/8AY5ir6muFna3lW3dY7gowhkdS6K5H%26%23xA%3bwllBQsAeo5D54q%2bb/wAsdE/PSw/NHWV1HVdOuNUi9GfXI7xXP1uxlmnEHoTxo3BRR2jWg4bAinw4%26%23xA%3bq%2bTdbMJ1a79FGRfVcMHYOS4Y8iCFSgJ6Dt4nrir9B/yB/wDJNeU/%2bYFf%2bJNirPLh5UgkeKP1pVVm%26%23xA%3bjiqF5sBULyOwqdq4q%2bQjoP593v59adLe3dvBry3EV7MLeksNnp7mYBZGVU5wiMSxqhepJpsWrir5%26%23xA%3b61xrc6tdeijoBI4cO4erhjyYUVKAnoN6eJxV%2bg35A/8AkmvKf/MCv/EmxVE/nRpnnDU/yz1yy8oy%26%23xA%3b%2blrMsBCqoPqSwg1mhhYH4ZJI6qp%2bjavIKvmny1bfmpZ/k/55Gpvb3vlKe3uoZirKk1tqMEo9VvT4%26%23xA%3bRs/N6rId6mjV61VeBaT/AMdWz/4zx/8AExir9ScVdirsVdirsVdirsVdirsVeb/nfqNjptj5Rv7%2b%26%23xA%3bdLWytfM%2bmy3FxKwVI0USlmZjsABir5v/AOcnI9J83%2bdo/MXlzXtH1GxSxhtnjTUbaOYPG8jN8Erp%26%23xA%3bUUcdCcVZf/zg0pVvO6mlQdMBoQRt9c7jbFX1Tirye685eVPLP53eYZPMOrWulJdaJpa27XcqxByk%26%23xA%3b92WC8iK05DFXxN5u8sXGmX9zONQ03ULaSV3jmsL62uKhmJ/u1f1R17pir7y/IH/yTXlP/mBX/iTY%26%23xA%3bqz/FXk915y8qeWfzu8wyeYdWtdKS60TS1t2u5ViDlJ7ssF5EVpyGKvibzd5YuNMv7mcahpuoW0kr%26%23xA%3bvHNYX1tcVDMT/dq/qjr3TFX3l%2bQP/kmvKf8AzAr/AMSbFWf4q%2bcL/wAzeUpvy5/MnyhceYNN0/Xr%26%23xA%3b7XtdWC0vblID8d%2bzKW5dA1Njir5UOjXOl65ZwzzWs59ePi9pdW90hHMb8oHkp9OKv06xV2KuxV2K%26%23xA%3buxV2KuxV2KuxVQvjYLbPJf8ApC1j%2bJ3n4iNadyX2GKsfv/Mn5a2FnNeXeo6TFbQKXlkMluaKPYEk%26%23xA%3b/IYqk%2bjfnB%2bWM17BaW88mmnUGCWVzeWF1YW9y3VRHPPFFGxNfhBaprtirP8AFUu1W48uWzxvq0ln%26%23xA%3bC8gIia6aJCwWlQpkpWnLFWN6958/K7RFhFzc2dxcXJK2tlYQ/XrmUqKtwgtllkIHc0piqP8AKH5g%26%23xA%3beTvMjzWWi3JS9s1BuNLuIZbO6iQ9GNvOkT8P8oCmKsmxVjHnDzh5A8uNC3mW8tYLm4FLa3eMz3Uo%26%23xA%3bqf7qCNZJnFf5VOKscj/N38plkjXUEl0hJSFjuNU0u6soCSabzzQJEvX9phir0W0e0ktYpLNo3tXU%26%23xA%3bNA8JUxsjCoKFfhII6UxVVxVLtSXy5YwSXupiztYAay3Nz6UaVPdneg3%2beKoTRr/yRrSs%2bi3Omaks%26%23xA%3bdC7Wb284WvSpjLUxVU0fzf5a1nVdV0nS9Qiu9Q0SRItUgjJPovICVUtTiT8JBoTQgg74qnGKuxV2%26%23xA%3bKuxV2KuxV2KuxVgH5/f%2bSa82f8wLf8SXFWCfm15e8jeT/Nvk7VrLyhYG0tV1O7e0sbS3tWubu2hi%26%23xA%3be2jLxx/EyoZpEQ/aZfHFU287%2bePypvvLWnad%2bkx5ktNXgkspbVL71mispVE1xqNzGS3x2iQ81ZwG%26%23xA%3bU1CkE4qzn8qLvVrz8s/K91q5ZtRm0y1e4dyS7ExLR3rvyZaM3virHfzC0PRda/NjyDY6zp9tqVk1%26%23xA%3bnrrm1vIY54iyrZcW4SBlqO22KsH8qah5A8ofmV5j0%2b%2bsofL732uegmo2zJp9vaw2ltbXFhbOIxGi%26%23xA%3bxXtZWNSFkKlWDbHFUd5j82%2bWtT/M3y7H5ake/wBRsNcto/07DcfWUkW/jma/0%2bI1YGCG3jWV%2bLFY%26%23xA%3b2KigJxV6p%2bYXmw%2bVfKN/rMUP1q9jCQadaDrNeXDrDbRbb0aV1r7VxVjWk%2bUNR8l6WuuxaV/i7z7q%26%23xA%3blxbrr2ptJHDMwmcLKYXl2jggQ0SJABQCvc4qy3zNeanE2m2drof6astSultNV5SRoltaujF53SQH%26%23xA%3b1VFACg64qwqysB%2bW3nnTdM06sfkbzbNLb2%2bnkkxabqoR7hRb1rxhu1R/3Y2VxUUBpirNPN3nLRPK%26%23xA%3bmnR3uqPIzXEq29lZW0bT3VzO/wBmKCFPidz%2bHU4qwzyt5E/xbdS%2bcfzC003F/PNL%2bhPL2oKHg02y%26%23xA%3bRysINu3KI3MgX1JJDU7gClMVYT%2bYmnaN5u89W/lL8s9Og0/zRpciya/5109TbDTIdw0BktzH68ri%26%23xA%3bq%2bmxIG468iir0r8lNM8oWP5e2B8q2stvp8zz%2bs90B9amuIZngmluSOsheI%2bw6DYYqzvFXYq7FXYq%26%23xA%3b7FXYq7FXYq8%2b/PiS2l/K7XtKN1bQX%2bpWrw2EFzcQ2/rSBlJVGmaNTQe%2bKqGkXvkH80tK17RpdUOu%26%23xA%3bLp%2bqTAr%2b7guLGSGQrbyWktuEPAcC0M4JLAkEndcVYd%2bXP5SaJrt75gm12/vNSs9J1y605NPf6vDF%26%23xA%3bdR2jI8b37W8MMt03JqkSPxJ6g4q93JihiJJWOKNakmiqqqPuAAxV4lqXn/yv5x/MPQr/AEHzDb6f%26%23xA%3bZ6F%2bmdLuNWea0QiaaOxeOSCK5ZvVjkIeNX4EEqadiVU5/PLyRpcvk7VvNqSzW/mLR9MkYX0Hphbt%26%23xA%3bIF9RYbyB0eGeLmOXFk2/Zpiqc/l5%2bVfl/wAutb62ZrjU9Ze2CQ3d4YwttFLR3itIIEhggVmNW4JU%26%23xA%3b9ziqz865FtPLek6xMCbHRde0nUNQIFeNvFdoryEUr%2b75h9vDwriq/wA2eZvNWo%2baE8l%2bS5ILS/jt%26%23xA%3b0vdc164j%2bsR2NvMzJAkUNVWS4mKMVDniFFTWuKoS/wDLX5s6Bbtqmi%2bapPM81uDLcaDq1taxLdBd%26%23xA%3b2jt57WOFoJCKhOXJa0rtiqA82eadM836V%2bW9xpHJpNc16yv7WFgBLHFYCS4vOY3p6QjMT%2b5xVFee%26%23xA%3briy0b82fKHmPXn9LQEs7/TrW%2bkIW3tNSuWiKNM5%2bFPXhR41Y99sVSrz9%2bY2seZtal/L/APLq8jiu%26%23xA%3bgB/iXzYGBttMgfbhFICA1y/RQDt23qUVZt5D8s%2bSfJHl6HRNEmgSFPjuLh5Uaa4mb7c0z1%2bJ2/Do%26%23xA%3bKAYqxfyRFp2hfmvqflfyzfyXPluXS21W%2b04zNdRWGoS3YCrFIzOYvrKSSSNFXqvLvir1TFXYq7FX%26%23xA%3bYq7FXYq7FXYq84/PHyrpV/5J1fW10G21jzHp9mRpTTWq3kinmDxSNlfl9omlMVYv5B1n8n/I0mpT%26%23xA%3baFomsxXWqXM1xcXH6D1AMsckpkjto6QfBDECFVR4VO%2bKsr/JaWS507zPqBtri1g1HzHqF3aJdwSW%26%23xA%3b0rQyiMo/pyqjgH3GKvQZoYZ4ZIJ41lhlUpLE4DKysKMrKdiCOoxV8%2b%2bYfyv/AC38g%2bbNIV/LB1Xy%26%23xA%3bxrEmqXWoKNNfU5LZ1itFtYEeOOWVIg/qsoJ7nwxVO/zD/Mny1qf5aa55c0TSta%2bsXOmy2Wn236H1%26%23xA%3bBEBMXCNOTQgKOg3xV7DpasumWisCrLDGGU7EEINjirtT02x1TTrrTb%2bFbixvYnt7qB/svFIpV1Pz%26%23xA%3bBxV5ToNl5k/K%2b/vYZ9Cu/NGhXYhSDzBplbnU1gtkMdvBe2hYGUwoeCywDdacl5Yqnkv5y2Vwpi0L%26%23xA%3byz5g1fUG2jthptxZxhjsPVuLtYYo18WJxVS/LP8ALa80m%2bbzH5git7fVnSaLTNGs2eW00u3uZ2uJ%26%23xA%3bo4pJCTJNNK/KaXbf4VogGKpl%2bbeg%2bc/MfllfL3lprOBNWlFtrF9eD1Db2TAmR4YSCrvtQVO3b%2bZV%26%23xA%3bWtC/Jn8utI8oWvlT9DwX2l27ieRbxFlaa548TcS1FGkI26bDYUGKrv8AlSn5R/8AUoaV/wBIsX9M%26%23xA%3bVZD5f8reW/Llo1noOl2ul2ztzkitIkhDP/M3ADke1TiqaYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXY%26%23xA%3bq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FWK%2bc/zC0/y1cW%26%23xA%3bmnR2VzrGvagryWWkWQQyNHFT1JpZJGjihhSoq7sB4VxVL/K35qQ6prFtous6Pc6BqV%2bjyaUZpbe6%26%23xA%3btbwRCsiW93aSSxNIgFWjrUDfFUH59/OvRvKuqy6TDZNqV7aCI6g7XVpYW1sZxyhikub2WGMyyJ8a%26%23xA%3bxrU8fi6YqyLyb5%2b0TzVotxqlsJLE2MjwanaXoWKW1ljUOwlozJx4MHV1YqVNa4qxyH83dT1WOS/8%26%23xA%3bq%2bTNV17QI2YDWI3tLVJ1QkM9rFcyxyzrseJCip2xVPtN/Mvyjf8Ak%2b882C5a20vTRN%2bk0uEaO4tZ%26%23xA%3bbf8AvYJ4d2WVTtw77UrUYqw7TP8AnInQ59XFpqOj3WlWTSJE93NcWUstsZWCRm/s4JpLm0VnZVrI%26%23xA%3bnwsQDTFXq9xPDbwSXE7iOGFWklkbYKqirE/IDFWE235w%2bWru3iurPTNfurS4RZbe5g0PVJIpY3HJ%26%23xA%3bJI3WCjKymoI6jFVT/lbGi/8AVk8x/wDcA1X/ALJ8VROk/mb5d1HWbTRjb6np9/f%2bp9RTUtNvbFZm%26%23xA%3bhQySJG9xFGrMsalqV6DFWSX2o6fYRLLfXUNpEzcVknkWNS1K0BYgVoMVYH5q/OTT9K1230TRLFfM%26%23xA%3bN7JatezNBf2FrDFEJPSAMtzNGrOW/ZG9N8VSHzF%2bf2seXdAfzBqvki5j0eOVbd7yDU9MulEr/ZSl%26%23xA%3bvNK1foxV6B5K83S%2bZLO/a50ybR9R0u8aw1DT55IZmjmWKOccZIGkjcGKdDUHrt2xVkWKvFfyq/Jf%26%23xA%3b8rNX/Lby1qmp%2bW7S71G9063nu7mQMXkldAWdjy6k4qmep/lj/wA45aZqcGlX%2bj6RBqt0pa105n/0%26%23xA%3bmWnaOHnzcnooAqT0xV5f5Kh/J/zH%2bYyaWPJmnJ5d1JTb6Y3F/VSZY5LmCZ2qNrqFJFKHeOSIr81U%26%23xA%3bx1c3lz/zjb%2bXEMen/pyW41DTYTpEknBbxR63G3dydlbio36Yqlf%2bE9d/9h8sf%2b4jH/XFXf4T13/2%26%23xA%3bHyx/7iMf9cVbsND1aw81eVbif8prbybH%2bnLBTrUF4szrylp6XBTWknQ4q9P8z%2bTE85ecfzB0U3TW%26%23xA%3bdzd%2bXdIsba9A5GJJ7i%2bkdeNR8DvCvNQRUYqwDVPyKbyj5f0P67rt2b2%2b83aewg0maaxsbZb64SBz%26%23xA%3bbQqx4yrGSFkrUVoPdVLfzK/I%2bztvPZs21a6FrrUVzqWn3txO2o3KPZWR%2buxXFvcyD1vVRAY5%2bXwn%26%23xA%3b4WBFMVT2z0HUNH/5xv8ANmvsfq3%2bIdJtZNPtlf1Hi02GyhtLUTScV5TSQLykoKCtAABTFWQfmj%2bR%26%23xA%3bfmrzL5y0LVPLmr2%2bk6XpNva21uGedJ7AW0pZpLKNFeFy8ZCnnxPwgcqVGKpBcfk1c655o/Mfy3B5%26%23xA%3bo1iS4FppN5BLdXSrFPeTpMVa8S2jhWRR9VjUELUDfcgYqwTy5%2bWSavPptrp07rcecpNYtJ4p2jmS%26%23xA%3bwis7mBdSk%2btjlLel%2bIFuDxAryJJqSq%2bm/wAzPNWm6J5dmtJ4rm61DWYriy0zT7G3kurmeYwO7BIo%26%23xA%3bgzURFLMewxV806D5f/My20LTrc%2bbvPemGG1hjOmweW9SkituEaj0I3FwgZI6cVPEVA6DFUd%2bh/zL%26%23xA%3b/wCp8/MD/wAJnUv%2byrFU58gaRrq/mV5G1W%2b876n5nh/SOq2EumatZzWM9ldQ6VM7iSKaaZlco6ml%26%23xA%3bBsRir1D8wtF0fWvzW8hafrFjb6lYPZ65I1peRJPCXRbPixjkDLVamhpirzS2fyq/51toL%2bXvJJ8t%26%23xA%3btOdMTTVsY/XE6k1f639T%2brtc%2bNv6vT4ftfEVUq/P/RdH0Xy5590/R7G302wS68vyLaWcSQQh3S45%26%23xA%3bMI4wq1agqaYq93/Lr/jtefv/AAI2/wC6Vp%2bKs1xV4h5W/Jvyn58/LHyPfa1NfxT2miW9vF9TunhT%26%23xA%3biycqmP4k5AnrTfvUAYqiLf8A5xi8t6frdpe6Vqt3Fp1vdW2oy6bcBJ2lu7Fna3b62w9eNBz4sqdR%26%23xA%3b774qwn8uPIPmi0/New0jVrch9ElGqXtzGCIvSjF8Y5EcE1W5vdUm9JCQ/pRVZR0xVPvL/wD5Jr8n%26%23xA%3bv%2b27pX/Ep8VTLUP%2bhq7nzXeQ6adJsfL0l9dpYXVysMjR2aPIbaSVY2eQ%2boioNgWq3xAb0VSX8x/L%26%23xA%3bX/OT0/laZLnVrLVbISRtfadoAktNQmgDfvEilaPuOoFSfA9Cq15G0nz1pn5faBD5sW7hD%2bcbCTRr%26%23xA%3bTUZfWvILEzLwjmeimvLlsQPkBQYq9GW4uLf8wvzAuLZlS5h0HSJIHcqFDqdTKli9FpUd9sVYNa%2bY%26%23xA%3bvM3mH8qvI%2bqeZbm3u9Xl836Us09o9vJEVTVAqUa1Z4dlArQ/PFUT5%2bLf8r0b0VBJ8n6j9aNqKyCP%26%23xA%3b4uH10y/AIuf916Px8/tfBiqI8zf%2bsjw/%2bArp/wD1DQ4q9iOo6epcNcxAx7SAuvwmtPi3232xV5lD%26%23xA%3bJay%2be/zVd5IDatoekl5J2cW/D6vf8jK8R5iOn2ihrTpvirC/ydjnQ/k8swlA/RnmMxeqIwDGXtSh%26%23xA%3bi4Ub0yN19T4/HFWffmneXVj538gXlpZvqF1bXGsSwWETKrzumj3DLErPRQXIpU4qwDVPz5/MoaTb%26%23xA%3byz2Wn6ELyS3guryWy1svpqXMio8831qyt7NvQ5Vb98QT05Yqsuvzl/MLQNQvNNsLlfPa2eo6dDHd%26%23xA%3bRw2qSTre/WUe0rYloeTLAs0TUDKD8Y7Yqm3kXQ/Mmr/mrqOppZRW%2biaD5o1O9urqScGc3F3o8Fr9%26%23xA%3bWWBFYfB6iuZPUodx23VZx5r/APJy%2bQP%2bYHXv%2bI2WKvKbLRNSH5ir%2bW4Sw/Q1hr63P6c9E/pRolX/%26%23xA%3bABClsT9igkl4epWtP2cVQv8Azkt/xy/P/wDxn8u/8QucVe1fl1/x2vP3/gRt/wB0rT8VZrirBLL8%26%23xA%3bmvLFjaRWdjqWv2lnbqI7e1g1zU44o0XZURFnCqo7AYqrf8qn0X/q9%2bY/%2b4/qv/ZRirv%2bVT6L/wBX%26%23xA%3bvzH/ANx/Vf8AsoxVF3H5ZeUZvKmmeVxBPBpWjvFNpn1e5nhnhlgr6ciTxusvIcjvyxVCf8qn0X/q%26%23xA%3b9%2bY/%2b4/qv/ZRirv%2bVT6L/wBXvzH/ANx/Vf8AsoxVdB%2bVHlyO%2bs7ye%2b1m%2bawuI7u2hvtX1C6hE0J5%26%23xA%3bRuYppnRip6VGKpH5ltvOdj518x3Wn%2bVLnXtJ8waVYWJubW9sbVo2tzeCUcbqRGrxuloeNMVYfovk%26%23xA%3b3znp/lzyt5N0zyVqVlpGk%2bYLDVZ9S1HU9KuHSGG9FzOWW2kQtQE0CpX54qy780/y483azr1r5l8s%26%23xA%3bXtq%2bow2NxpAsNTQmC3hv/wB3NeWzR8Ss6qfiD8gyim3Qqp15n/LuS9/KGbyBpVyqsulw6XaXVzWl%26%23xA%3bLdEjV5OAPUR70GKvL73/AJx782Xt1rt1cab5aabzHI0urMLnWB6jvcC6JUB/g/eqD8PyxVmn5Xfl%26%23xA%3bX5h8sr5gj1G4s7KLU7Cx07Tho7zu1slmtyvqB7xXJf8A0kFSeQqNxiqE/LD8ofMXljX7BdUubWXQ%26%23xA%3b/K1tdW/lyS0Rkmum1OQSXM96HL0kURItFND126Yqyrz95e8x3mteVvMGg29te3Xl26uZpNPup2tF%26%23xA%3bmS6s5bU8ZliuOJQyBqcN/bFVO41f81biCS3uPJejzQSqUlik1uRkZWFCrKdNIII7YqhdNb8wdLt1%26%23xA%3bt9M/L/QbG3VzKsNtq5hQOw4lwqaYo5EGlcVTL8tvLuvaRBr93rkVvb32vaxPqps7WZrhIEkghgWP%26%23xA%3b1mjg5n/R%2bVeA64qgPzB03zVF5v8AKvmnQtHbXV0eLUra70%2bK4gtpqX6wcJFa5aOMqptyG%2bKu4oOt%26%23xA%3bFWFRaR54j/Mybz4PIOrm4mQE6Z%2bldH%2bri5%2brraG4/v8AlX6ugTj06nFVa/8Aye1H8y9U17UfOseq%26%23xA%3beVdPv/qSQaLa3ljKZjZo/wC%2bmKR3SbGSiUYHrUdMVeo%2bUPKFl5Ysbm2gu7rULi%2buWvL/AFC/kWW4%26%23xA%3bnnZEi5uUWJNo4kQBUGw8anFU9xV2KuxV2KuxVbLLHFE8srBI41LO7GgCgVJJ9sVYj5F/NryD56ub%26%23xA%3b618s6mL2fT6G4jMcsLcGJUSIJVTktR1H09RirMMVdirFvzA/Mzyf5B063v8AzLeG2iupPRto40aW%26%23xA%3bSRgKtxRATRR1PT6SMVT3RtY03WtKtNW0ydbnT76JJ7WdagPG4qpoaEfI4qjMVdirsVdirsVdirsV%26%23xA%3bdirsVdirsVdirsVdirsVdirG/wAxPM%2bq%2bWPKF/rWlaPPrt/bKPQ0%2b2FWZmIXkwFXKJWrcATT7wq8%26%23xA%3bKMfm%2bTXdK1f84/P6eX5L2aM6f5GsCx5rK3BY7iKEkcSW4lnD/wCU43GKvJPyb0rRbfTvNSa95on8%26%23xA%3bl3H1mx02y1m3WXmtzyuJmjLR8GVP9GBYl17b4q%2bgvy88yfnR5e81aX5Y80Rr5z8s6upOlecNOKuE%26%23xA%3bjVeXOeQUUrxpXnuf2Wfpir3LFXzp/wA5s6YZfImhakFqbTUzASB0W4gdvDpWAYq9j/K3TBpf5a%2bV%26%23xA%3brDjxaDSrMSD/AIsMCtIfpcnFWUYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq8X/MX8sb%26%23xA%3bLQNS1P8AMDy15T/xl5y1K5gEVpqMvrW9oSOJnihcgtRgu3L4OqlFBxVh%2bifl15j0vU9V0nUPIMPm%26%23xA%3bDy75o803/wBc%2btMiPZ2PGM2t1FKp%2bD4ZpviUDdKAqWWqr3L8vPy%2b0LyF5dGgaI9w9iJ5bgG6lMrh%26%23xA%3bpmrxHRVUAAAKB4n4iSVWTYq8y/5yL8l6p5v/ACwu9K0m3a61Jbq0mtoUALEidY3IrT7McjMdxsMV%26%23xA%3belQQxwQRwxDjHEoRB4KooMVX4q7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYqsuI3lgkjSR%26%23xA%3bondWVZVpyQkUDCtRUdd8VeZ/kn%2bS93%2bWh1o3HmKTXzq/1biZIGg9H6t6taVmuOXP1vbp3xV6firs%26%23xA%3bVed/nR%2bU11%2bZGkafp8GvzaD9RuGuGaOH11l5IUAZRJAarXY8u528FWa6BpbaToWm6U0xuWsLWG1a%26%23xA%3b4I4mQwxrHzK1anLjWlTiqPxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2K%26%23xA%3buxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KpXqfmny5pen3Go3%2bp21vZWsbS3EzSrRUUVJ2JJ9gN%26%23xA%3bzirD7f8AOe2uoI7m18n%2baZ7aZRJBMmmHi6MKq61kBow3GKp1pH5o%2bQ9T0S21gaza2NtcTfVfS1CW%26%23xA%3bO0mjuhUNayxyspWZSp%2bDr3FRvirKI5I5EEkbB0bdWUggj2IxVdirsVdirsVdirsVdirsVdirsVdi%26%23xA%3brsVdirsVdirsVdirsVdir5r8n%2bRNF8v/AJdad%2bZOpw6Tf6JZeX4bw%2bX30TTzPJdrbrxlOpFGuCzz%26%23xA%3bfFuO/tiqHuvMX5zT2OseapdT1JbPQLiWDVp7CWxitreW2I%2btLBpc1vK9zFZtyV2kuVaSlRSmKvTP%26%23xA%3by%2b0nyV580WfWPMflTRLrzJbXc9hrV39Qt5VmubYhfWSSVGdkkjKOOR2rTtiqY/kD/wCSa8p/8wK/%26%23xA%3b8SbFWf4q7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq8K8meefyi1L8j9J8o6/5n06%26%23xA%3b2NzosdjfwPcxpNEzQ8Tsx2dG3Fe4xV5ZcXSwtqeijzXpV9p2sTevqdxBr0Fnpt9KaVnvLQwSXcbS%26%23xA%3b8QbhIJaSGoBXrir278vfPX5R%2bU/Lo0%2bbzxpV7qN1PNf6rei4hjWa7uX5ysqA0RBsqL2UDFU7/IH/%26%23xA%3bAMk15T/5gV/4k2Ks/wAVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVf/Z%3c/xmpGImg:image%3e %3c/rdf:li%3e %3c/rdf:Alt%3e %3c/xmp:Thumbnails%3e %3cxmpMM:OriginalDocumentID%3euuid:9E3E5C9A8C81DB118734DB58FDDE4BA7%3c/xmpMM:OriginalDocumentID%3e %3cxmpMM:DocumentID%3exmp.did:9bb40803-0a68-4b6d-b079-70a423632dc7%3c/xmpMM:DocumentID%3e %3cxmpMM:InstanceID%3exmp.iid:9bb40803-0a68-4b6d-b079-70a423632dc7%3c/xmpMM:InstanceID%3e %3cxmpMM:RenditionClass%3eproof:pdf%3c/xmpMM:RenditionClass%3e %3cxmpMM:DerivedFrom rdf:parseType='Resource'%3e %3cstRef:instanceID%3euuid:3790e011-2e1b-2f40-a3d6-4e538a02edb2%3c/stRef:instanceID%3e %3cstRef:documentID%3exmp.did:525ac691-adef-4d04-bc72-b632c8732463%3c/stRef:documentID%3e %3cstRef:originalDocumentID%3euuid:9E3E5C9A8C81DB118734DB58FDDE4BA7%3c/stRef:originalDocumentID%3e %3cstRef:renditionClass%3eproof:pdf%3c/stRef:renditionClass%3e %3c/xmpMM:DerivedFrom%3e %3cxmpMM:History%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cstEvt:action%3esaved%3c/stEvt:action%3e %3cstEvt:instanceID%3exmp.iid:78fa4c27-1810-4112-abf8-25d31ae36cdc%3c/stEvt:instanceID%3e %3cstEvt:when%3e2019-06-10T14:32:07%2b02:00%3c/stEvt:when%3e %3cstEvt:softwareAgent%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/stEvt:softwareAgent%3e %3cstEvt:changed%3e/%3c/stEvt:changed%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cstEvt:action%3esaved%3c/stEvt:action%3e %3cstEvt:instanceID%3exmp.iid:9bb40803-0a68-4b6d-b079-70a423632dc7%3c/stEvt:instanceID%3e %3cstEvt:when%3e2019-06-14T11:08:35%2b02:00%3c/stEvt:when%3e %3cstEvt:softwareAgent%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/stEvt:softwareAgent%3e %3cstEvt:changed%3e/%3c/stEvt:changed%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpMM:History%3e %3cillustrator:StartupProfile%3eBasic RGB%3c/illustrator:StartupProfile%3e %3cxmpTPg:NPages%3e1%3c/xmpTPg:NPages%3e %3cxmpTPg:HasVisibleTransparency%3eFalse%3c/xmpTPg:HasVisibleTransparency%3e %3cxmpTPg:HasVisibleOverprint%3eFalse%3c/xmpTPg:HasVisibleOverprint%3e %3cxmpTPg:MaxPageSize rdf:parseType='Resource'%3e %3cstDim:w%3e440.000000%3c/stDim:w%3e %3cstDim:h%3e440.000000%3c/stDim:h%3e %3cstDim:unit%3ePixels%3c/stDim:unit%3e %3c/xmpTPg:MaxPageSize%3e %3cxmpTPg:PlateNames%3e %3crdf:Seq%3e %3crdf:li%3eCyan%3c/rdf:li%3e %3crdf:li%3eMagenta%3c/rdf:li%3e %3crdf:li%3eYellow%3c/rdf:li%3e %3crdf:li%3eBlack%3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpTPg:PlateNames%3e %3cxmpTPg:SwatchGroups%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eDomy%c5%9blna grupa pr%c3%b3bek%3c/xmpG:groupName%3e %3cxmpG:groupType%3e0%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eBia%c5%82y%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eCzarny%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eCzerwony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3e%c5%bb%c3%b3%c5%82ty RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eZielony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eNiebieskozielony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eNiebieski RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eKarmazynowy RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=193 G=39 B=45%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e193%3c/xmpG:red%3e %3cxmpG:green%3e39%3c/xmpG:green%3e %3cxmpG:blue%3e45%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=237 G=28 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e237%3c/xmpG:red%3e %3cxmpG:green%3e28%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=241 G=90 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e241%3c/xmpG:red%3e %3cxmpG:green%3e90%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=247 G=147 B=30%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e247%3c/xmpG:red%3e %3cxmpG:green%3e147%3c/xmpG:green%3e %3cxmpG:blue%3e30%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=251 G=176 B=59%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e251%3c/xmpG:red%3e %3cxmpG:green%3e176%3c/xmpG:green%3e %3cxmpG:blue%3e59%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=252 G=238 B=33%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e252%3c/xmpG:red%3e %3cxmpG:green%3e238%3c/xmpG:green%3e %3cxmpG:blue%3e33%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=217 G=224 B=33%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e217%3c/xmpG:red%3e %3cxmpG:green%3e224%3c/xmpG:green%3e %3cxmpG:blue%3e33%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=140 G=198 B=63%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e140%3c/xmpG:red%3e %3cxmpG:green%3e198%3c/xmpG:green%3e %3cxmpG:blue%3e63%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=57 G=181 B=74%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e57%3c/xmpG:red%3e %3cxmpG:green%3e181%3c/xmpG:green%3e %3cxmpG:blue%3e74%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=146 B=69%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e146%3c/xmpG:green%3e %3cxmpG:blue%3e69%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=104 B=55%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e104%3c/xmpG:green%3e %3cxmpG:blue%3e55%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=34 G=181 B=115%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e34%3c/xmpG:red%3e %3cxmpG:green%3e181%3c/xmpG:green%3e %3cxmpG:blue%3e115%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=169 B=157%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e169%3c/xmpG:green%3e %3cxmpG:blue%3e157%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=41 G=171 B=226%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e41%3c/xmpG:red%3e %3cxmpG:green%3e171%3c/xmpG:green%3e %3cxmpG:blue%3e226%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=113 B=188%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e113%3c/xmpG:green%3e %3cxmpG:blue%3e188%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=46 G=49 B=146%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e46%3c/xmpG:red%3e %3cxmpG:green%3e49%3c/xmpG:green%3e %3cxmpG:blue%3e146%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=27 G=20 B=100%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e27%3c/xmpG:red%3e %3cxmpG:green%3e20%3c/xmpG:green%3e %3cxmpG:blue%3e100%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=102 G=45 B=145%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e102%3c/xmpG:red%3e %3cxmpG:green%3e45%3c/xmpG:green%3e %3cxmpG:blue%3e145%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=147 G=39 B=143%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e147%3c/xmpG:red%3e %3cxmpG:green%3e39%3c/xmpG:green%3e %3cxmpG:blue%3e143%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=158 G=0 B=93%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e158%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e93%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=212 G=20 B=90%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e212%3c/xmpG:red%3e %3cxmpG:green%3e20%3c/xmpG:green%3e %3cxmpG:blue%3e90%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=237 G=30 B=121%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e237%3c/xmpG:red%3e %3cxmpG:green%3e30%3c/xmpG:green%3e %3cxmpG:blue%3e121%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=199 G=178 B=153%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e199%3c/xmpG:red%3e %3cxmpG:green%3e178%3c/xmpG:green%3e %3cxmpG:blue%3e153%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=153 G=134 B=117%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e153%3c/xmpG:red%3e %3cxmpG:green%3e134%3c/xmpG:green%3e %3cxmpG:blue%3e117%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=115 G=99 B=87%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e115%3c/xmpG:red%3e %3cxmpG:green%3e99%3c/xmpG:green%3e %3cxmpG:blue%3e87%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=83 G=71 B=65%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e83%3c/xmpG:red%3e %3cxmpG:green%3e71%3c/xmpG:green%3e %3cxmpG:blue%3e65%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=198 G=156 B=109%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e198%3c/xmpG:red%3e %3cxmpG:green%3e156%3c/xmpG:green%3e %3cxmpG:blue%3e109%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=166 G=124 B=82%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e166%3c/xmpG:red%3e %3cxmpG:green%3e124%3c/xmpG:green%3e %3cxmpG:blue%3e82%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=140 G=98 B=57%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e140%3c/xmpG:red%3e %3cxmpG:green%3e98%3c/xmpG:green%3e %3cxmpG:blue%3e57%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=117 G=76 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e117%3c/xmpG:red%3e %3cxmpG:green%3e76%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=96 G=56 B=19%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e96%3c/xmpG:red%3e %3cxmpG:green%3e56%3c/xmpG:green%3e %3cxmpG:blue%3e19%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=66 G=33 B=11%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e66%3c/xmpG:red%3e %3cxmpG:green%3e33%3c/xmpG:green%3e %3cxmpG:blue%3e11%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eZimne%3c/xmpG:groupName%3e %3cxmpG:groupType%3e1%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=56 M=0 Y=20 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e101%3c/xmpG:red%3e %3cxmpG:green%3e200%3c/xmpG:green%3e %3cxmpG:blue%3e208%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=51 M=43 Y=0 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e131%3c/xmpG:red%3e %3cxmpG:green%3e139%3c/xmpG:green%3e %3cxmpG:blue%3e197%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=26 M=41 Y=0 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e186%3c/xmpG:red%3e %3cxmpG:green%3e155%3c/xmpG:green%3e %3cxmpG:blue%3e201%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eSzaro%c5%9bci%3c/xmpG:groupName%3e %3cxmpG:groupType%3e1%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=0 B=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=26 G=26 B=26%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e26%3c/xmpG:red%3e %3cxmpG:green%3e26%3c/xmpG:green%3e %3cxmpG:blue%3e26%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=51 G=51 B=51%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e51%3c/xmpG:red%3e %3cxmpG:green%3e51%3c/xmpG:green%3e %3cxmpG:blue%3e51%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=77 G=77 B=77%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e77%3c/xmpG:red%3e %3cxmpG:green%3e77%3c/xmpG:green%3e %3cxmpG:blue%3e77%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=102 G=102 B=102%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e102%3c/xmpG:red%3e %3cxmpG:green%3e102%3c/xmpG:green%3e %3cxmpG:blue%3e102%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=128 G=128 B=128%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e128%3c/xmpG:red%3e %3cxmpG:green%3e128%3c/xmpG:green%3e %3cxmpG:blue%3e128%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=153 G=153 B=153%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e153%3c/xmpG:red%3e %3cxmpG:green%3e153%3c/xmpG:green%3e %3cxmpG:blue%3e153%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=179 G=179 B=179%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e179%3c/xmpG:red%3e %3cxmpG:green%3e179%3c/xmpG:green%3e %3cxmpG:blue%3e179%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=204 G=204 B=204%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e204%3c/xmpG:red%3e %3cxmpG:green%3e204%3c/xmpG:green%3e %3cxmpG:blue%3e204%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=230 G=230 B=230%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e230%3c/xmpG:red%3e %3cxmpG:green%3e230%3c/xmpG:green%3e %3cxmpG:blue%3e230%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=242 G=242 B=242%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e242%3c/xmpG:red%3e %3cxmpG:green%3e242%3c/xmpG:green%3e %3cxmpG:blue%3e242%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpTPg:SwatchGroups%3e %3cpdf:Producer%3eAdobe PDF library 15.00%3c/pdf:Producer%3e %3c/rdf:Description%3e %3c/rdf:RDF%3e%3c/x:xmpmeta%3e %3c%3fxpacket end='w'%3f%3e %3c/metadata%3e%3cg id='Warstwa_1' class='st0'%3e %3cg class='st1'%3e %3cline class='st2' x1='0' y1='0' x2='0' y2='440'/%3e %3cline class='st2' x1='10' y1='0' x2='10' y2='440'/%3e %3cline class='st2' x1='20' y1='0' x2='20' y2='440'/%3e %3cline class='st2' x1='30' y1='0' x2='30' y2='440'/%3e %3cline class='st2' x1='40' y1='0' x2='40' y2='440'/%3e %3cline class='st2' x1='50' y1='0' x2='50' y2='440'/%3e %3cline class='st3' x1='60' y1='0' x2='60' y2='440'/%3e %3cline class='st2' x1='70' y1='0' x2='70' y2='440'/%3e %3cline class='st2' x1='80' y1='0' x2='80' y2='440'/%3e %3cline class='st2' x1='90' y1='0' x2='90' y2='440'/%3e %3cline class='st2' x1='100' y1='0' x2='100' y2='440'/%3e %3cline class='st2' x1='110' y1='0' x2='110' y2='440'/%3e %3cline class='st2' x1='120' y1='0' x2='120' y2='440'/%3e %3cline class='st2' x1='130' y1='0' x2='130' y2='440'/%3e %3cline class='st2' x1='140' y1='0' x2='140' y2='440'/%3e %3cline class='st2' x1='150' y1='0' x2='150' y2='440'/%3e %3cline class='st2' x1='160' y1='0' x2='160' y2='440'/%3e %3cline class='st2' x1='170' y1='0' x2='170' y2='440'/%3e %3cline class='st2' x1='180' y1='0' x2='180' y2='440'/%3e %3cline class='st2' x1='190' y1='0' x2='190' y2='440'/%3e %3cline class='st2' x1='200' y1='0' x2='200' y2='440'/%3e %3cline class='st2' x1='210' y1='0' x2='210' y2='440'/%3e %3cline class='st3' x1='220' y1='0' x2='220' y2='440'/%3e %3cline class='st2' x1='230' y1='0' x2='230' y2='440'/%3e %3cline class='st2' x1='240' y1='0' x2='240' y2='440'/%3e %3cline class='st2' x1='250' y1='0' x2='250' y2='440'/%3e %3cline class='st2' x1='260' y1='0' x2='260' y2='440'/%3e %3cline class='st2' x1='270' y1='0' x2='270' y2='440'/%3e %3cline class='st2' x1='280' y1='0' x2='280' y2='440'/%3e %3cline class='st2' x1='290' y1='0' x2='290' y2='440'/%3e %3cline class='st2' x1='300' y1='0' x2='300' y2='440'/%3e %3cline class='st2' x1='310' y1='0' x2='310' y2='440'/%3e %3cline class='st2' x1='320' y1='0' x2='320' y2='440'/%3e %3cline class='st2' x1='330' y1='0' x2='330' y2='440'/%3e %3cline class='st2' x1='340' y1='0' x2='340' y2='440'/%3e %3cline class='st2' x1='350' y1='0' x2='350' y2='440'/%3e %3cline class='st2' x1='360' y1='0' x2='360' y2='440'/%3e %3cline class='st2' x1='370' y1='0' x2='370' y2='440'/%3e %3cline class='st3' x1='380' y1='0' x2='380' y2='440'/%3e %3cline class='st2' x1='390' y1='0' x2='390' y2='440'/%3e %3cline class='st2' x1='400' y1='0' x2='400' y2='440'/%3e %3cline class='st2' x1='410' y1='0' x2='410' y2='440'/%3e %3cline class='st2' x1='420' y1='0' x2='420' y2='440'/%3e %3cline class='st2' x1='430' y1='0' x2='430' y2='440'/%3e %3cline class='st2' x1='440' y1='0' x2='440' y2='440'/%3e %3c/g%3e %3cg class='st1'%3e %3cline class='st2' x1='440' y1='0' x2='0' y2='0'/%3e %3cline class='st2' x1='440' y1='10' x2='0' y2='10'/%3e %3cline class='st2' x1='440' y1='20' x2='0' y2='20'/%3e %3cline class='st2' x1='440' y1='30' x2='0' y2='30'/%3e %3cline class='st2' x1='440' y1='40' x2='0' y2='40'/%3e %3cline class='st2' x1='440' y1='50' x2='0' y2='50'/%3e %3cline class='st3' x1='440' y1='60' x2='0' y2='60'/%3e %3cline class='st2' x1='440' y1='70' x2='0' y2='70'/%3e %3cline class='st2' x1='440' y1='80' x2='0' y2='80'/%3e %3cline class='st2' x1='440' y1='90' x2='0' y2='90'/%3e %3cline class='st2' x1='440' y1='100' x2='0' y2='100'/%3e %3cline class='st2' x1='440' y1='110' x2='0' y2='110'/%3e %3cline class='st2' x1='440' y1='120' x2='0' y2='120'/%3e %3cline class='st2' x1='440' y1='130' x2='0' y2='130'/%3e %3cline class='st2' x1='440' y1='140' x2='0' y2='140'/%3e %3cline class='st2' x1='440' y1='150' x2='0' y2='150'/%3e %3cline class='st2' x1='440' y1='160' x2='0' y2='160'/%3e %3cline class='st2' x1='440' y1='170' x2='0' y2='170'/%3e %3cline class='st2' x1='440' y1='180' x2='0' y2='180'/%3e %3cline class='st2' x1='440' y1='190' x2='0' y2='190'/%3e %3cline class='st2' x1='440' y1='200' x2='0' y2='200'/%3e %3cline class='st2' x1='440' y1='210' x2='0' y2='210'/%3e %3cline class='st3' x1='440' y1='220' x2='0' y2='220'/%3e %3cline class='st2' x1='440' y1='230' x2='0' y2='230'/%3e %3cline class='st2' x1='440' y1='240' x2='0' y2='240'/%3e %3cline class='st2' x1='440' y1='250' x2='0' y2='250'/%3e %3cline class='st2' x1='440' y1='260' x2='0' y2='260'/%3e %3cline class='st2' x1='440' y1='270' x2='0' y2='270'/%3e %3cline class='st2' x1='440' y1='280' x2='0' y2='280'/%3e %3cline class='st2' x1='440' y1='290' x2='0' y2='290'/%3e %3cline class='st2' x1='440' y1='300' x2='0' y2='300'/%3e %3cline class='st2' x1='440' y1='310' x2='0' y2='310'/%3e %3cline class='st2' x1='440' y1='320' x2='0' y2='320'/%3e %3cline class='st2' x1='440' y1='330' x2='0' y2='330'/%3e %3cline class='st2' x1='440' y1='340' x2='0' y2='340'/%3e %3cline class='st2' x1='440' y1='350' x2='0' y2='350'/%3e %3cline class='st2' x1='440' y1='360' x2='0' y2='360'/%3e %3cline class='st2' x1='440' y1='370' x2='0' y2='370'/%3e %3cline class='st3' x1='440' y1='380' x2='0' y2='380'/%3e %3cline class='st2' x1='440' y1='390' x2='0' y2='390'/%3e %3cline class='st2' x1='440' y1='400' x2='0' y2='400'/%3e %3cline class='st2' x1='440' y1='410' x2='0' y2='410'/%3e %3cline class='st2' x1='440' y1='420' x2='0' y2='420'/%3e %3cline class='st2' x1='440' y1='430' x2='0' y2='430'/%3e %3cline class='st2' x1='440' y1='440' x2='0' y2='440'/%3e %3c/g%3e%3c/g%3e%3cg id='Warstwa_2' class='st0'%3e %3ccircle class='st4' cx='220' cy='220' r='100'/%3e %3ccircle class='st4' cx='220' cy='220' r='40'/%3e %3ccircle class='st4' cx='220' cy='220' r='160'/%3e %3ccircle class='st4' cx='220' cy='220' r='220'/%3e%3c/g%3e%3cg id='Warstwa_3'%3e %3cg%3e %3cpath d='M320%2c280c11.03%2c0%2c20-8.97%2c20-20s-8.97-20-20-20c-6.79%2c0-13.06%2c3.41-16.78%2c9.11c-2.1%2c3.23-3.22%2c6.99-3.22%2c10.89 C300%2c271.03%2c308.97%2c280%2c320%2c280z'/%3e %3cpath d='M418%2c70H22c-6.6%2c0-12%2c5.4-12%2c12v47.39h420V82C430%2c75.4%2c424.6%2c70%2c418%2c70z'/%3e %3cpath d='M10%2c358c0%2c6.6%2c5.4%2c12%2c12%2c12h396c6.6%2c0%2c12-5.4%2c12-12V169.45H10V358z M69.41%2c275v-7.05V245H272.3 c1.38-4.38%2c3.33-8.51%2c5.79-12.27C287.01%2c219.04%2c302.45%2c210%2c320%2c210c27.61%2c0%2c50%2c22.39%2c50%2c50s-22.39%2c50-50%2c50 c-22.39%2c0-41.34-14.72-47.71-35h-122v24.55H129.7V275h-9.07v15h-20.59v-15H90v24.55H69.41V275z'/%3e %3c/g%3e%3c/g%3e%3c/svg%3e";

var img$G = "data:image/svg+xml,%3csvg id='Layer_3' data-name='Layer 3' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 440 440'%3e %3ctitle%3e Icons %3c/title%3e %3cpolygon points='376.02 56.15 159.61 272.56 63.98 176.94 10 230.92 105.62 326.55 159.61 380.53 430 110.14 376.02 56.15' /%3e%3c/svg%3e";

var img$F = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 22.1 22.1' style='enable-background:new 0 0 22.1 22.1%3b' xml:space='preserve'%3e%3cpath d='M22.1%2c11.1c0%2c6.1-4.9%2c11-11.1%2c11c-6.1%2c0-11-4.9-11-11C0%2c4.9%2c4.9%2c0%2c11%2c0C17.1%2c0%2c22.1%2c4.9%2c22.1%2c11.1z M15.4%2c5.2 l-6.6%2c6.6L5.7%2c8.7L3%2c11.3l5.8%2c5.8l9.3-9.3L15.4%2c5.2z'/%3e%3c/svg%3e";

var img$E = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 23.0.4%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 440 440' style='enable-background:new 0 0 440 440%3b' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bdisplay:none%3b%7d .st1%7bdisplay:inline%3b%7d .st2%7bfill:none%3bstroke:grey%3bstroke-miterlimit:10%3b%7d .st3%7bfill:none%3bstroke:%23C1272D%3bstroke-miterlimit:10%3b%7d .st4%7bdisplay:inline%3bfill:none%3bstroke:%23C1272D%3bstroke-miterlimit:10%3b%7d%3c/style%3e%3cmetadata%3e%3c%3fxpacket begin=' ' id='W5M0MpCehiHzreSzNTczkc9d'%3f%3e%3cx:xmpmeta xmlns:x='adobe:ns:meta/' x:xmptk='Adobe XMP Core 5.6-c145 79.163499%2c 2018/08/13-16:40:22 '%3e %3crdf:RDF xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%3e %3crdf:Description rdf:about='' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:xmp='http://ns.adobe.com/xap/1.0/' xmlns:xmpGImg='http://ns.adobe.com/xap/1.0/g/img/' xmlns:xmpMM='http://ns.adobe.com/xap/1.0/mm/' xmlns:stRef='http://ns.adobe.com/xap/1.0/sType/ResourceRef%23' xmlns:stEvt='http://ns.adobe.com/xap/1.0/sType/ResourceEvent%23' xmlns:illustrator='http://ns.adobe.com/illustrator/1.0/' xmlns:xmpTPg='http://ns.adobe.com/xap/1.0/t/pg/' xmlns:stDim='http://ns.adobe.com/xap/1.0/sType/Dimensions%23' xmlns:xmpG='http://ns.adobe.com/xap/1.0/g/' xmlns:pdf='http://ns.adobe.com/pdf/1.3/'%3e %3cdc:format%3eimage/svg%2bxml%3c/dc:format%3e %3cdc:title%3e %3crdf:Alt%3e %3crdf:li xml:lang='x-default'%3eIcons%3c/rdf:li%3e %3c/rdf:Alt%3e %3c/dc:title%3e %3cxmp:CreatorTool%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/xmp:CreatorTool%3e %3cxmp:CreateDate%3e2019-06-14T11:08:35%2b02:00%3c/xmp:CreateDate%3e %3cxmp:ModifyDate%3e2019-06-14T11:08:35%2b02:00%3c/xmp:ModifyDate%3e %3cxmp:MetadataDate%3e2019-06-14T11:08:35%2b02:00%3c/xmp:MetadataDate%3e %3cxmp:Thumbnails%3e %3crdf:Alt%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpGImg:width%3e180%3c/xmpGImg:width%3e %3cxmpGImg:height%3e256%3c/xmpGImg:height%3e %3cxmpGImg:format%3eJPEG%3c/xmpGImg:format%3e %3cxmpGImg:image%3e/9j/4AAQSkZJRgABAgEASABIAAD/7QAsUGhvdG9zaG9wIDMuMAA4QklNA%2b0AAAAAABAASAAAAAEA%26%23xA%3bAQBIAAAAAQAB/%2b4ADkFkb2JlAGTAAAAAAf/bAIQABgQEBAUEBgUFBgkGBQYJCwgGBggLDAoKCwoK%26%23xA%3bDBAMDAwMDAwQDA4PEA8ODBMTFBQTExwbGxscHx8fHx8fHx8fHwEHBwcNDA0YEBAYGhURFRofHx8f%26%23xA%3bHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8f/8AAEQgBAAC0AwER%26%23xA%3bAAIRAQMRAf/EAaIAAAAHAQEBAQEAAAAAAAAAAAQFAwIGAQAHCAkKCwEAAgIDAQEBAQEAAAAAAAAA%26%23xA%3bAQACAwQFBgcICQoLEAACAQMDAgQCBgcDBAIGAnMBAgMRBAAFIRIxQVEGE2EicYEUMpGhBxWxQiPB%26%23xA%3bUtHhMxZi8CRygvElQzRTkqKyY3PCNUQnk6OzNhdUZHTD0uIIJoMJChgZhJRFRqS0VtNVKBry4/PE%26%23xA%3b1OT0ZXWFlaW1xdXl9WZ2hpamtsbW5vY3R1dnd4eXp7fH1%2bf3OEhYaHiImKi4yNjo%2bCk5SVlpeYmZ%26%23xA%3bqbnJ2en5KjpKWmp6ipqqusra6voRAAICAQIDBQUEBQYECAMDbQEAAhEDBCESMUEFURNhIgZxgZEy%26%23xA%3bobHwFMHR4SNCFVJicvEzJDRDghaSUyWiY7LCB3PSNeJEgxdUkwgJChgZJjZFGidkdFU38qOzwygp%26%23xA%3b0%2bPzhJSktMTU5PRldYWVpbXF1eX1RlZmdoaWprbG1ub2R1dnd4eXp7fH1%2bf3OEhYaHiImKi4yNjo%26%23xA%3b%2bDlJWWl5iZmpucnZ6fkqOkpaanqKmqq6ytrq%2bv/aAAwDAQACEQMRAD8A9TTTwQJ6k0ixJ05OQoqf%26%23xA%3bc4q%2bevyy0P8AKe41O38n%2ba/LVg3m%2b9jvtVinvYI2kuY31W9VY6sK80ghR1Fd0NRsuKs01T8v/JHl%26%23xA%3br8wfIF1oGh2Wl3M2pXsUs1rCkTMn6HvG4kqBtUA4q9UxV4x%2baHmPy55y8xWHkeCBdUTQtb0q48xK%26%23xA%3bwV4EikM6yRuD19NR%2b87CoHWtFWYRfkz%2bT0qCSLynpEkbfZdbaIg/IgYql35IadY6bY%2bbrCwgS1sr%26%23xA%3bXzPqUVvbxKFSNFEQVVUbAAYq9IxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KvIv%2bcgvyp87%26%23xA%3bfmTY6ZpOjalZ6fpNpI1zeR3Jl5zT04x7Ro44opbv1Ptir50/Ln8hPMl9%2bY%2bjw6bqwbTbZBql1r9i%26%23xA%3bJYvq6297PaemnrIjeu09k4TalPi3AOKvrPzt/wApv%2bXn/bVvf%2b6Ne4qzG5hM9vLCsrwmVGQTREB0%26%23xA%3bLCnJCwYch1FRir4R1j/nHXzTbee7/QdS1WG3aS7totN1S7WdxfnUXlELgxrKVasLCTkfhbudiVX1%26%23xA%3bL%2bQv5decvy%2b8sXPl3X9QtNQsknM%2bltamUmIS1M0bCRE%2bHn8a07s2Ko38of8Aptf/AAK9T/5lYq9A%26%23xA%3bxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV5l5V8ofmp5W0kaPpl5oM1nHPdTQy3MF4Zi%26%23xA%3bt1dS3XFykir8LTkCgxVMI/LX5i6j5p8vap5gu9I%2bo6Fc3F16VhFcpLI01lPaAVmd1oPrHL6MVZ7i%26%23xA%3brEvzG8p6v5istIOkXFtb6ho%2bqW2qQvdo7xN9WDfu2EZVviLDocVQ/p/nT/y0eW/%2bRF9/1WxVE/lz%26%23xA%3b5U1jy7Y6uNYuLe5v9X1W51WVrRXSFDchPgUSFm2KdzirLMVdirsVdirsVdirsVdirsVdirsVdirs%26%23xA%3bVdirsVdirsVU7q5gtbaW5uH9OCBGllc1IVEHJjt4AYqgtB8yeX/MFiL7Q9RttTszt69rKkqg%2bDcS%26%23xA%3beJ9jviqY4q7FUr1vzV5c0KS0j1rUrfTjfuYrRrqRYkkdRUqHei1oeld8VTNHR0V0YMjAFWBqCDuC%26%23xA%3bCMVbxV2KuxV2KrJpoYInmmkWKGNS0kjkKqqBUlidgBiqW/4s8q/9Xmx/6SYf%2basVd/izyr/1ebH/%26%23xA%3bAKSYf%2basVRljqem36NJY3cN2iHi7wSLIAetCVJxVE4qsmnggT1JpFiTpychRU%2b5xVsTRGL1Q6mKn%26%23xA%3bL1ARx49a16UxVBaHr%2bia9p66jot9DqFg7Oi3Nu4kjLRsVYcl8CMVR%2bKuxV2KuxVhP51SapH%2bVXmW%26%23xA%3bTSmnTUFs2Ns1qXEwfkv2DH8VfliryzSfy28oa75T1ma383eZ5NX0W2dNXsJdUkHp3H1b1aPEVNYp%26%23xA%3bP2fHcdQQFXyr5A1fVdL84aRPpl5PZTNeW8byW8jRMyNKoZWKkVUjqDtir9M8VeDeZprX8zPzU0Ox%26%23xA%3b0nWNWg8rx2mowXd9pNxJbRPdWkijaROSMKkgEjfttvirzT/nKf8ALPTvKGgaHc2us6xqbXV3LG0e%26%23xA%3bq3rXaIFj5VjVlXiffFUx/wCcJtY1abWPMGmTXs8mm29pFJBZvI7QxuZSCyRk8VJrvQYq9l/OyL88%26%23xA%3bZF0YflbNHCQbk6w0gsyT/dfVwPrauP8AfleP04q8u%2bp/85x/8t8H/A6L/wBUsVd9T/5zj/5b4P8A%26%23xA%3bgdF/6pYqzP8AKWD/AJybj83IfzEuYpvLhglDqo04MJtvTI%2bqokn8MVTz/nIjW9Otfy4v9PNxYvqt%26%23xA%3bxPpr2ulXs0SC4Uanb8ldHZeUJCsJD041rtirxr9Ka1/5b78sf%2bR%2blf8AZRirv0prX/lvvyx/5H6V%26%23xA%3b/wBlGKs8/JCLXYPzN1ddV0DSPLX1nQLO4t7HQPSFlPEbucR3R9BnRnb4l5V%2byBir0X8zfza8n/l7%26%23xA%3bpT3OtXiDUJYnfTtLSrT3DqDxAVQ3BCwpzaijxxV%2bf/nXz55q86azLq3mG/ku55GJiiLEQwqekcMf%26%23xA%3b2UUe3XqanfFWcfk1oPm7V9L1gXHmC58uflnDHTzVf%2boywNHUMbeFDUNPJsvwitDQ15BWVfdHljy/%26%23xA%3boXl/QrPSNBto7XSrWMLbRR9OJ35FurM1asx3J3xV4J5o/wCcq9b0aLUriPRNJmistRuNMjtjqq/X%26%23xA%3biYJHQTPZiP1RGeFa9PfFXmX6Z/5yC1nhrOo%2beIfLTaz/AKTpum3uqLpzSxSH4DBbVrHEeiF%2bNetT%26%23xA%3b1xVMrL/nKL82PIdlN5U8z6THqGv2EnEX2oO/qem1GUSemaTAg1SQPuKdeuKvYv8Alf2o/wDKhv8A%26%23xA%3blZn6Hh%2bu%2bt9X/R3rN6XL6z9X5c%2bPKn7VPor3xVif/OSnk783dd1t9Z0%2b9h0jydolsFjna%2bNvUvRp%26%23xA%3bppVTcfFRB7KD3xV59%2bSPkP8AMa182%2batSkvDHpul6fd2%2bu3RczxXrS2xeOBHb7bfEsnL9kD/ACgC%26%23xA%3bq8V8p/8AKU6N/wAx1t/yeXFX6I/mxoXmjXvy%2b1nSvLF59R1m6gKwSdC69XhD1HAyrVOXauKvibyV%26%23xA%3b%2bWH5pav6OnaLqI0%2b6me5WPSZb17WblaPwuD6I6cG2OKvVf8AnKQeaV/KfyNF5rRE8wwzyxag0biV%26%23xA%3bJJI4uHqhh3kUBz4EkYqgv%2bcIf%2bUq8y/8wMP/ACexVOf%2bc34TPceRIQQplfUkDHoCxsxU4q8k1P8A%26%23xA%3bJLStLhM175/0GONZmtmK/XZKSoWDIRHbsQRwPX%2bIxVOvy/8AyV8natJfS/ppfOktoIAuh%2bXna1uu%26%23xA%3bE8oie4Zr%2bKIFIQa0TvTkVHVVPvyD8u6f5b/5ya1HQdOvRqFlp0d/bwXexLKgGzFduSfZam1QcVVv%26%23xA%3b%2bcttA1HXfzl0mwsFT1f8PpNLJKwjiihguLySWWR22VERSx/DfFXkEf5fWcFhc6rqXmGx/RNm0UVw%26%23xA%3b%2bmN9fufUn5emiQlrdSWEbt8UiiinetAVW5/ys8wvHq9xpfHUbLSLGDVZZFDRyGynr%2b89Jt1aIgiV%26%23xA%3ba/DQ05AVxV9P/wDONEh1C60/ULWKZrGw8qWOl3N08MsUf1xL%2b6naJHkVBJSORWLJVd%2buKvEf%2bctI%26%23xA%3bNWT86dSkvQ/1SW2tDpbP9n0BAivw9vXEtffFWM/ld%2bVz%2ba3utZ1m6/Q3kjRv3mt63JsABQ%2bhBUHn%26%23xA%3bM9QAADSo2JKqyqp%2baP5op5kS18u%2bXbX9DeQ9G%2bDSNITYuRUG5uSCecz1J3JpXuSzFV9Uf84pefPM%26%23xA%3b3m38v7ka87XMmk3X1K1vmUKZIREjKjUADNHypXwIrvvir4688PDH%2bZHmCSdPUhTWbxpY/wCZRdOW%26%23xA%3bH0jFWY/nD5O8463%2bYF/5h0nTrvW9D1%2bVbnQtSsYZLiGS3dF9GFTGrcXhQemYzQrx6Yql35xUtP8A%26%23xA%3bCmg3brLr%2bhaLFZ62yuJDFMZpZY7V2BIL28Mio1Dt9ntir1D/ANcl/wCj7/u54q%2bk/wA1/Lmp%2bZfy%26%23xA%3b617QdLVG1DULUw2yyNwQuWB3Y9OmKvOJZvz70vydd6YvlDQ4rRLKWO5livW9Rv3JV5eIX4nYCvvi%26%23xA%3br52/Kz8g/wA0fMGsaZqsOjvYaVDcQ3DX2oE2yMkbq/wIwMr1A2KoR74q%2b/MVeTfmB5R8%2bwfmVo3n%26%23xA%3bHyTpNhem0srq3vIbqYWweW5ZaueIqzcVG%2bKvIf8AnI%2b3/OnzLpugafrfle3jc3chsotHllvppJDH%26%23xA%3b8QZAtQAu9cVZd/zit%2bTvnnyTe6trHma1jsE1K2jht7QyrJcArJz5OsfJFFP8qvtirMPz6/I65/NJ%26%23xA%3bdD9DV00ptHN1XnAZhILr0fB4%2bPH0PxxV5J/0I5qv/U3Qf9IT/wDVbFV8P/OEetwSCSHzlFFIKgOl%26%23xA%3bpIpoRQ7ibFWbfk1/zjHefl551TzJP5gj1FY7eaAW0ds0RJlAFeRkfp8sVYF/zlnofneb81tG1jy3%26%23xA%3bp%2bpSPa6RAsOoadFOximS6uWossIqrqHU9a74q8vXUvz8lVodWste16xkFJNO1m2vdQtmINQ3p3Ac%26%23xA%3bK6kbOlGHStCcVS2%2b0384Lw34fRdWih1JIYbu3t9PmghaG2p6EIjjjVVjjoKINtgeuKvuL8kNPvtO%26%23xA%3b/KbyvZX9vJa3cNigmt5lKSISS1GVqFTQ9DirF/zp/LfzL%2bZHmLRPLhsra08o2oN7qXmI%2bnJeh%2bXE%26%23xA%3b2lsrAvGXABZvsnv9niyrMLz8ofy7vPLGn%2bV7rR0k0HTPitLASTRxh6UMjiN09RzUnk9TUnxOKpL/%26%23xA%3bANC3fkl/1K0H/I65/wCquKs50Dy7ofl7S4dK0Oxh0/ToK%2blbQKFUE7knuWJ6k7nFXjus/wDOH35a%26%23xA%3batq99qtzqetJcahcS3UyRz2oQPM5kYKDasaVbapOKorSv%2bcV/K%2bkWstppPm7zXp1pPUzW9pqMMEb%26%23xA%3bk7Hkkduqt9OKpSf%2bcK/ytJJOq66SdyTcWla/9ImKs4/5UP5Q/wCVW/8AKtvrmofoL1fX%2bs%2bpD9b5%26%23xA%3bev8AWKc/R9OnPb%2b76Yq9HxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Ku%26%23xA%3bxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Kux%26%23xA%3bV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV%26%23xA%3b2KuxV2KuxV2KuxV2KuxV2Kpbr/mXy/5dsRf67qEGmWRcRC4uXWNObAlV5NtUhTirHP8Aldf5R/8A%26%23xA%3bU36V/wBJUX9cVTvy3528o%2bZ/rH%2bHtYtNV%2bqcPrX1SVZfT9Xlw58SacuDU%2bWKp1irHNf/ADG8h%2bXb%26%23xA%3b4WGu6/Y6ZelBKLe5nSN%2bDEhW4sa0JU4qlv8Ayuv8o/8Aqb9K/wCkqL%2buKsr0vVNO1XT4NR025jvL%26%23xA%3bC5Xnb3MLB43XpVWGxGKorFWOa/8AmN5D8u3wsNd1%2bx0y9KCUW9zOkb8GJCtxY1oSpxVLf%2bV1/lH/%26%23xA%3bANTfpX/SVF/XFWV6Xqmnarp8Go6bcx3lhcrzt7mFg8br0qrDYjFUVirEb783vyvsL24sb3zTplve%26%23xA%3bWkjwXNvJcxq8csbFXRlJ2KsCCMVUk/Oj8ppHVE83aUzuQqqLqOpJ2A64qzPFXYq7FXYq7FXYq7FX%26%23xA%3bYq7FXn35xIkieS0kUOjeatMDKwqCP3uxBxV87f8AOWvmnX9J/MOPRdMvZbLSW02GV7O2YwI0kjyq%26%23xA%3bWb0uBboOpptirIf%2bcGSSfO5JqT%2bjCSetf9MxV9U4q870y1tbj88PMwnhSYLoek8RIoalZ7zpUYq%2b%26%23xA%3bE/OHnHzPreoXcWq6lcXcSTvwieRhEoViAFiBEY%2bhcVfeP5A/%2bSa8p/8AMCv/ABJsVZ/irzjTobGb%26%23xA%3b89PMkVykUjnQtKMSSBWO093yKhvorir4W84ecfM%2bt6hdxarqVxdxJO/CJ5GEShWIAWIERj6FxV94%26%23xA%3b/kD/AOSa8p/8wK/8SbFWfkgCp2A6nFXz9e3VxZfkx%2bZetaQ8cWpW/mDWpba/VUZlX9JblGIbqhNM%26%23xA%3bVfIn6c1nV9ds7nVb6e%2bnM8f7y4kaQj4xsORNB7DFX6eYq7FXYq7FXYq7FXYq7FXYq8F/5yY038yd%26%23xA%3bQs7SDTbixj0Se5jtdNsUV3v59RmikEbCQqiQn7SJRtiak/yqvn3/AJyIsfMen%2bYtFsfNl0NR80Q6%26%23xA%3bNaC9v4yBGw9Sf4GXjV3UcQZOQ5UJ474q9S/5wY/6bb/t1/8AY5ir6muFna3lW3dY7gowhkdS6K5H%26%23xA%3bwllBQsAeo5D54q%2bb/wAsdE/PSw/NHWV1HVdOuNUi9GfXI7xXP1uxlmnEHoTxo3BRR2jWg4bAinw4%26%23xA%3bq%2bTdbMJ1a79FGRfVcMHYOS4Y8iCFSgJ6Dt4nrir9B/yB/wDJNeU/%2bYFf%2bJNirPLh5UgkeKP1pVVm%26%23xA%3bjiqF5sBULyOwqdq4q%2bQjoP593v59adLe3dvBry3EV7MLeksNnp7mYBZGVU5wiMSxqhepJpsWrir5%26%23xA%3b61xrc6tdeijoBI4cO4erhjyYUVKAnoN6eJxV%2bg35A/8AkmvKf/MCv/EmxVE/nRpnnDU/yz1yy8oy%26%23xA%3b%2blrMsBCqoPqSwg1mhhYH4ZJI6qp%2bjavIKvmny1bfmpZ/k/55Gpvb3vlKe3uoZirKk1tqMEo9VvT4%26%23xA%3bRs/N6rId6mjV61VeBaT/AMdWz/4zx/8AExir9ScVdirsVdirsVdirsVdirsVeb/nfqNjptj5Rv7%2b%26%23xA%3bdLWytfM%2bmy3FxKwVI0USlmZjsABir5v/AOcnI9J83%2bdo/MXlzXtH1GxSxhtnjTUbaOYPG8jN8Erp%26%23xA%3bUUcdCcVZf/zg0pVvO6mlQdMBoQRt9c7jbFX1Tirye685eVPLP53eYZPMOrWulJdaJpa27XcqxByk%26%23xA%3b92WC8iK05DFXxN5u8sXGmX9zONQ03ULaSV3jmsL62uKhmJ/u1f1R17pir7y/IH/yTXlP/mBX/iTY%26%23xA%3bqz/FXk915y8qeWfzu8wyeYdWtdKS60TS1t2u5ViDlJ7ssF5EVpyGKvibzd5YuNMv7mcahpuoW0kr%26%23xA%3bvHNYX1tcVDMT/dq/qjr3TFX3l%2bQP/kmvKf8AzAr/AMSbFWf4q%2bcL/wAzeUpvy5/MnyhceYNN0/Xr%26%23xA%3b7XtdWC0vblID8d%2bzKW5dA1Njir5UOjXOl65ZwzzWs59ePi9pdW90hHMb8oHkp9OKv06xV2KuxV2K%26%23xA%3buxV2KuxV2KuxVQvjYLbPJf8ApC1j%2bJ3n4iNadyX2GKsfv/Mn5a2FnNeXeo6TFbQKXlkMluaKPYEk%26%23xA%3b/IYqk%2bjfnB%2bWM17BaW88mmnUGCWVzeWF1YW9y3VRHPPFFGxNfhBaprtirP8AFUu1W48uWzxvq0ln%26%23xA%3bC8gIia6aJCwWlQpkpWnLFWN6958/K7RFhFzc2dxcXJK2tlYQ/XrmUqKtwgtllkIHc0piqP8AKH5g%26%23xA%3beTvMjzWWi3JS9s1BuNLuIZbO6iQ9GNvOkT8P8oCmKsmxVjHnDzh5A8uNC3mW8tYLm4FLa3eMz3Uo%26%23xA%3bqf7qCNZJnFf5VOKscj/N38plkjXUEl0hJSFjuNU0u6soCSabzzQJEvX9phir0W0e0ktYpLNo3tXU%26%23xA%3bNA8JUxsjCoKFfhII6UxVVxVLtSXy5YwSXupiztYAay3Nz6UaVPdneg3%2beKoTRr/yRrSs%2bi3Omaks%26%23xA%3bdC7Wb284WvSpjLUxVU0fzf5a1nVdV0nS9Qiu9Q0SRItUgjJPovICVUtTiT8JBoTQgg74qnGKuxV2%26%23xA%3bKuxV2KuxV2KuxVgH5/f%2bSa82f8wLf8SXFWCfm15e8jeT/Nvk7VrLyhYG0tV1O7e0sbS3tWubu2hi%26%23xA%3be2jLxx/EyoZpEQ/aZfHFU287%2bePypvvLWnad%2bkx5ktNXgkspbVL71mispVE1xqNzGS3x2iQ81ZwG%26%23xA%3bU1CkE4qzn8qLvVrz8s/K91q5ZtRm0y1e4dyS7ExLR3rvyZaM3virHfzC0PRda/NjyDY6zp9tqVk1%26%23xA%3bnrrm1vIY54iyrZcW4SBlqO22KsH8qah5A8ofmV5j0%2b%2bsofL732uegmo2zJp9vaw2ltbXFhbOIxGi%26%23xA%3bxXtZWNSFkKlWDbHFUd5j82%2bWtT/M3y7H5ake/wBRsNcto/07DcfWUkW/jma/0%2bI1YGCG3jWV%2bLFY%26%23xA%3b2KigJxV6p%2bYXmw%2bVfKN/rMUP1q9jCQadaDrNeXDrDbRbb0aV1r7VxVjWk%2bUNR8l6WuuxaV/i7z7q%26%23xA%3blxbrr2ptJHDMwmcLKYXl2jggQ0SJABQCvc4qy3zNeanE2m2drof6astSultNV5SRoltaujF53SQH%26%23xA%3b1VFACg64qwqysB%2bW3nnTdM06sfkbzbNLb2%2bnkkxabqoR7hRb1rxhu1R/3Y2VxUUBpirNPN3nLRPK%26%23xA%3bmnR3uqPIzXEq29lZW0bT3VzO/wBmKCFPidz%2bHU4qwzyt5E/xbdS%2bcfzC003F/PNL%2bhPL2oKHg02y%26%23xA%3bRysINu3KI3MgX1JJDU7gClMVYT%2bYmnaN5u89W/lL8s9Og0/zRpciya/5109TbDTIdw0BktzH68ri%26%23xA%3bq%2bmxIG468iir0r8lNM8oWP5e2B8q2stvp8zz%2bs90B9amuIZngmluSOsheI%2bw6DYYqzvFXYq7FXYq%26%23xA%3b7FXYq7FXYq8%2b/PiS2l/K7XtKN1bQX%2bpWrw2EFzcQ2/rSBlJVGmaNTQe%2bKqGkXvkH80tK17RpdUOu%26%23xA%3bLp%2bqTAr%2b7guLGSGQrbyWktuEPAcC0M4JLAkEndcVYd%2bXP5SaJrt75gm12/vNSs9J1y605NPf6vDF%26%23xA%3bdR2jI8b37W8MMt03JqkSPxJ6g4q93JihiJJWOKNakmiqqqPuAAxV4lqXn/yv5x/MPQr/AEHzDb6f%26%23xA%3bZ6F%2bmdLuNWea0QiaaOxeOSCK5ZvVjkIeNX4EEqadiVU5/PLyRpcvk7VvNqSzW/mLR9MkYX0Hphbt%26%23xA%3bIF9RYbyB0eGeLmOXFk2/Zpiqc/l5%2bVfl/wAutb62ZrjU9Ze2CQ3d4YwttFLR3itIIEhggVmNW4JU%26%23xA%3b9ziqz865FtPLek6xMCbHRde0nUNQIFeNvFdoryEUr%2b75h9vDwriq/wA2eZvNWo%2baE8l%2bS5ILS/jt%26%23xA%3b0vdc164j%2bsR2NvMzJAkUNVWS4mKMVDniFFTWuKoS/wDLX5s6Bbtqmi%2bapPM81uDLcaDq1taxLdBd%26%23xA%3b2jt57WOFoJCKhOXJa0rtiqA82eadM836V%2bW9xpHJpNc16yv7WFgBLHFYCS4vOY3p6QjMT%2b5xVFee%26%23xA%3briy0b82fKHmPXn9LQEs7/TrW%2bkIW3tNSuWiKNM5%2bFPXhR41Y99sVSrz9%2bY2seZtal/L/APLq8jiu%26%23xA%3bgB/iXzYGBttMgfbhFICA1y/RQDt23qUVZt5D8s%2bSfJHl6HRNEmgSFPjuLh5Uaa4mb7c0z1%2bJ2/Do%26%23xA%3bKAYqxfyRFp2hfmvqflfyzfyXPluXS21W%2b04zNdRWGoS3YCrFIzOYvrKSSSNFXqvLvir1TFXYq7FX%26%23xA%3bYq7FXYq7FXYq84/PHyrpV/5J1fW10G21jzHp9mRpTTWq3kinmDxSNlfl9omlMVYv5B1n8n/I0mpT%26%23xA%3baFomsxXWqXM1xcXH6D1AMsckpkjto6QfBDECFVR4VO%2bKsr/JaWS507zPqBtri1g1HzHqF3aJdwSW%26%23xA%3b0rQyiMo/pyqjgH3GKvQZoYZ4ZIJ41lhlUpLE4DKysKMrKdiCOoxV8%2b%2bYfyv/AC38g%2bbNIV/LB1Xy%26%23xA%3bxrEmqXWoKNNfU5LZ1itFtYEeOOWVIg/qsoJ7nwxVO/zD/Mny1qf5aa55c0TSta%2bsXOmy2Wn236H1%26%23xA%3bBEBMXCNOTQgKOg3xV7DpasumWisCrLDGGU7EEINjirtT02x1TTrrTb%2bFbixvYnt7qB/svFIpV1Pz%26%23xA%3bBxV5ToNl5k/K%2b/vYZ9Cu/NGhXYhSDzBplbnU1gtkMdvBe2hYGUwoeCywDdacl5Yqnkv5y2Vwpi0L%26%23xA%3byz5g1fUG2jthptxZxhjsPVuLtYYo18WJxVS/LP8ALa80m%2bbzH5git7fVnSaLTNGs2eW00u3uZ2uJ%26%23xA%3bo4pJCTJNNK/KaXbf4VogGKpl%2bbeg%2bc/MfllfL3lprOBNWlFtrF9eD1Db2TAmR4YSCrvtQVO3b%2bZV%26%23xA%3bWtC/Jn8utI8oWvlT9DwX2l27ieRbxFlaa548TcS1FGkI26bDYUGKrv8AlSn5R/8AUoaV/wBIsX9M%26%23xA%3bVZD5f8reW/Llo1noOl2ul2ztzkitIkhDP/M3ADke1TiqaYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXY%26%23xA%3bq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FWK%2bc/zC0/y1cW%26%23xA%3bmnR2VzrGvagryWWkWQQyNHFT1JpZJGjihhSoq7sB4VxVL/K35qQ6prFtous6Pc6BqV%2bjyaUZpbe6%26%23xA%3btbwRCsiW93aSSxNIgFWjrUDfFUH59/OvRvKuqy6TDZNqV7aCI6g7XVpYW1sZxyhikub2WGMyyJ8a%26%23xA%3bxrU8fi6YqyLyb5%2b0TzVotxqlsJLE2MjwanaXoWKW1ljUOwlozJx4MHV1YqVNa4qxyH83dT1WOS/8%26%23xA%3bq%2bTNV17QI2YDWI3tLVJ1QkM9rFcyxyzrseJCip2xVPtN/Mvyjf8Ak%2b882C5a20vTRN%2bk0uEaO4tZ%26%23xA%3bbf8AvYJ4d2WVTtw77UrUYqw7TP8AnInQ59XFpqOj3WlWTSJE93NcWUstsZWCRm/s4JpLm0VnZVrI%26%23xA%3bnwsQDTFXq9xPDbwSXE7iOGFWklkbYKqirE/IDFWE235w%2bWru3iurPTNfurS4RZbe5g0PVJIpY3HJ%26%23xA%3bJI3WCjKymoI6jFVT/lbGi/8AVk8x/wDcA1X/ALJ8VROk/mb5d1HWbTRjb6np9/f%2bp9RTUtNvbFZm%26%23xA%3bhQySJG9xFGrMsalqV6DFWSX2o6fYRLLfXUNpEzcVknkWNS1K0BYgVoMVYH5q/OTT9K1230TRLFfM%26%23xA%3bN7JatezNBf2FrDFEJPSAMtzNGrOW/ZG9N8VSHzF%2bf2seXdAfzBqvki5j0eOVbd7yDU9MulEr/ZSl%26%23xA%3bvNK1foxV6B5K83S%2bZLO/a50ybR9R0u8aw1DT55IZmjmWKOccZIGkjcGKdDUHrt2xVkWKvFfyq/Jf%26%23xA%3b8rNX/Lby1qmp%2bW7S71G9063nu7mQMXkldAWdjy6k4qmep/lj/wA45aZqcGlX%2bj6RBqt0pa105n/0%26%23xA%3bmWnaOHnzcnooAqT0xV5f5Kh/J/zH%2bYyaWPJmnJ5d1JTb6Y3F/VSZY5LmCZ2qNrqFJFKHeOSIr81U%26%23xA%3bx1c3lz/zjb%2bXEMen/pyW41DTYTpEknBbxR63G3dydlbio36Yqlf%2bE9d/9h8sf%2b4jH/XFXf4T13/2%26%23xA%3bHyx/7iMf9cVbsND1aw81eVbif8prbybH%2bnLBTrUF4szrylp6XBTWknQ4q9P8z%2bTE85ecfzB0U3TW%26%23xA%3bdzd%2bXdIsba9A5GJJ7i%2bkdeNR8DvCvNQRUYqwDVPyKbyj5f0P67rt2b2%2b83aewg0maaxsbZb64SBz%26%23xA%3bbQqx4yrGSFkrUVoPdVLfzK/I%2bztvPZs21a6FrrUVzqWn3txO2o3KPZWR%2buxXFvcyD1vVRAY5%2bXwn%26%23xA%3b4WBFMVT2z0HUNH/5xv8ANmvsfq3%2bIdJtZNPtlf1Hi02GyhtLUTScV5TSQLykoKCtAABTFWQfmj%2bR%26%23xA%3bfmrzL5y0LVPLmr2%2bk6XpNva21uGedJ7AW0pZpLKNFeFy8ZCnnxPwgcqVGKpBcfk1c655o/Mfy3B5%26%23xA%3bo1iS4FppN5BLdXSrFPeTpMVa8S2jhWRR9VjUELUDfcgYqwTy5%2bWSavPptrp07rcecpNYtJ4p2jmS%26%23xA%3bwis7mBdSk%2btjlLel%2bIFuDxAryJJqSq%2bm/wAzPNWm6J5dmtJ4rm61DWYriy0zT7G3kurmeYwO7BIo%26%23xA%3bgzURFLMewxV806D5f/My20LTrc%2bbvPemGG1hjOmweW9SkituEaj0I3FwgZI6cVPEVA6DFUd%2bh/zL%26%23xA%3b/wCp8/MD/wAJnUv%2byrFU58gaRrq/mV5G1W%2b876n5nh/SOq2EumatZzWM9ldQ6VM7iSKaaZlco6ml%26%23xA%3bBsRir1D8wtF0fWvzW8hafrFjb6lYPZ65I1peRJPCXRbPixjkDLVamhpirzS2fyq/51toL%2bXvJJ8t%26%23xA%3btOdMTTVsY/XE6k1f639T%2brtc%2bNv6vT4ftfEVUq/P/RdH0Xy5590/R7G302wS68vyLaWcSQQh3S45%26%23xA%3bMI4wq1agqaYq93/Lr/jtefv/AAI2/wC6Vp%2bKs1xV4h5W/Jvyn58/LHyPfa1NfxT2miW9vF9TunhT%26%23xA%3biycqmP4k5AnrTfvUAYqiLf8A5xi8t6frdpe6Vqt3Fp1vdW2oy6bcBJ2lu7Fna3b62w9eNBz4sqdR%26%23xA%3b774qwn8uPIPmi0/New0jVrch9ElGqXtzGCIvSjF8Y5EcE1W5vdUm9JCQ/pRVZR0xVPvL/wD5Jr8n%26%23xA%3bv%2b27pX/Ep8VTLUP%2bhq7nzXeQ6adJsfL0l9dpYXVysMjR2aPIbaSVY2eQ%2boioNgWq3xAb0VSX8x/L%26%23xA%3bX/OT0/laZLnVrLVbISRtfadoAktNQmgDfvEilaPuOoFSfA9Cq15G0nz1pn5faBD5sW7hD%2bcbCTRr%26%23xA%3bTUZfWvILEzLwjmeimvLlsQPkBQYq9GW4uLf8wvzAuLZlS5h0HSJIHcqFDqdTKli9FpUd9sVYNa%2bY%26%23xA%3bvM3mH8qvI%2bqeZbm3u9Xl836Us09o9vJEVTVAqUa1Z4dlArQ/PFUT5%2bLf8r0b0VBJ8n6j9aNqKyCP%26%23xA%3b4uH10y/AIuf916Px8/tfBiqI8zf%2bsjw/%2bArp/wD1DQ4q9iOo6epcNcxAx7SAuvwmtPi3232xV5lD%26%23xA%3bJay%2be/zVd5IDatoekl5J2cW/D6vf8jK8R5iOn2ihrTpvirC/ydjnQ/k8swlA/RnmMxeqIwDGXtSh%26%23xA%3bi4Ub0yN19T4/HFWffmneXVj538gXlpZvqF1bXGsSwWETKrzumj3DLErPRQXIpU4qwDVPz5/MoaTb%26%23xA%3byz2Wn6ELyS3guryWy1svpqXMio8831qyt7NvQ5Vb98QT05Yqsuvzl/MLQNQvNNsLlfPa2eo6dDHd%26%23xA%3bRw2qSTre/WUe0rYloeTLAs0TUDKD8Y7Yqm3kXQ/Mmr/mrqOppZRW%2biaD5o1O9urqScGc3F3o8Fr9%26%23xA%3bWWBFYfB6iuZPUodx23VZx5r/APJy%2bQP%2bYHXv%2bI2WKvKbLRNSH5ir%2bW4Sw/Q1hr63P6c9E/pRolX/%26%23xA%3bABClsT9igkl4epWtP2cVQv8Azkt/xy/P/wDxn8u/8QucVe1fl1/x2vP3/gRt/wB0rT8VZrirBLL8%26%23xA%3bmvLFjaRWdjqWv2lnbqI7e1g1zU44o0XZURFnCqo7AYqrf8qn0X/q9%2bY/%2b4/qv/ZRirv%2bVT6L/wBX%26%23xA%3bvzH/ANx/Vf8AsoxVF3H5ZeUZvKmmeVxBPBpWjvFNpn1e5nhnhlgr6ciTxusvIcjvyxVCf8qn0X/q%26%23xA%3b9%2bY/%2b4/qv/ZRirv%2bVT6L/wBXvzH/ANx/Vf8AsoxVdB%2bVHlyO%2bs7ye%2b1m%2bawuI7u2hvtX1C6hE0J5%26%23xA%3bRuYppnRip6VGKpH5ltvOdj518x3Wn%2bVLnXtJ8waVYWJubW9sbVo2tzeCUcbqRGrxuloeNMVYfovk%26%23xA%3b3znp/lzyt5N0zyVqVlpGk%2bYLDVZ9S1HU9KuHSGG9FzOWW2kQtQE0CpX54qy780/y483azr1r5l8s%26%23xA%3bXtq%2bow2NxpAsNTQmC3hv/wB3NeWzR8Ss6qfiD8gyim3Qqp15n/LuS9/KGbyBpVyqsulw6XaXVzWl%26%23xA%3bLdEjV5OAPUR70GKvL73/AJx782Xt1rt1cab5aabzHI0urMLnWB6jvcC6JUB/g/eqD8PyxVmn5Xfl%26%23xA%3bX5h8sr5gj1G4s7KLU7Cx07Tho7zu1slmtyvqB7xXJf8A0kFSeQqNxiqE/LD8ofMXljX7BdUubWXQ%26%23xA%3b/K1tdW/lyS0Rkmum1OQSXM96HL0kURItFND126Yqyrz95e8x3mteVvMGg29te3Xl26uZpNPup2tF%26%23xA%3bmS6s5bU8ZliuOJQyBqcN/bFVO41f81biCS3uPJejzQSqUlik1uRkZWFCrKdNIII7YqhdNb8wdLt1%26%23xA%3bt9M/L/QbG3VzKsNtq5hQOw4lwqaYo5EGlcVTL8tvLuvaRBr93rkVvb32vaxPqps7WZrhIEkghgWP%26%23xA%3b1mjg5n/R%2bVeA64qgPzB03zVF5v8AKvmnQtHbXV0eLUra70%2bK4gtpqX6wcJFa5aOMqptyG%2bKu4oOt%26%23xA%3bFWFRaR54j/Mybz4PIOrm4mQE6Z%2bldH%2bri5%2brraG4/v8AlX6ugTj06nFVa/8Aye1H8y9U17UfOseq%26%23xA%3beVdPv/qSQaLa3ljKZjZo/wC%2bmKR3SbGSiUYHrUdMVeo%2bUPKFl5Ysbm2gu7rULi%2buWvL/AFC/kWW4%26%23xA%3bnnZEi5uUWJNo4kQBUGw8anFU9xV2KuxV2KuxVbLLHFE8srBI41LO7GgCgVJJ9sVYj5F/NryD56ub%26%23xA%3b618s6mL2fT6G4jMcsLcGJUSIJVTktR1H09RirMMVdirFvzA/Mzyf5B063v8AzLeG2iupPRto40aW%26%23xA%3bSRgKtxRATRR1PT6SMVT3RtY03WtKtNW0ydbnT76JJ7WdagPG4qpoaEfI4qjMVdirsVdirsVdirsV%26%23xA%3bdirsVdirsVdirsVdirsVdirG/wAxPM%2bq%2bWPKF/rWlaPPrt/bKPQ0%2b2FWZmIXkwFXKJWrcATT7wq8%26%23xA%3bKMfm%2bTXdK1f84/P6eX5L2aM6f5GsCx5rK3BY7iKEkcSW4lnD/wCU43GKvJPyb0rRbfTvNSa95on8%26%23xA%3bl3H1mx02y1m3WXmtzyuJmjLR8GVP9GBYl17b4q%2bgvy88yfnR5e81aX5Y80Rr5z8s6upOlecNOKuE%26%23xA%3bjVeXOeQUUrxpXnuf2Wfpir3LFXzp/wA5s6YZfImhakFqbTUzASB0W4gdvDpWAYq9j/K3TBpf5a%2bV%26%23xA%3brDjxaDSrMSD/AIsMCtIfpcnFWUYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq8X/MX8sb%26%23xA%3bLQNS1P8AMDy15T/xl5y1K5gEVpqMvrW9oSOJnihcgtRgu3L4OqlFBxVh%2bifl15j0vU9V0nUPIMPm%26%23xA%3bDy75o803/wBc%2btMiPZ2PGM2t1FKp%2bD4ZpviUDdKAqWWqr3L8vPy%2b0LyF5dGgaI9w9iJ5bgG6lMrh%26%23xA%3bpmrxHRVUAAAKB4n4iSVWTYq8y/5yL8l6p5v/ACwu9K0m3a61Jbq0mtoUALEidY3IrT7McjMdxsMV%26%23xA%3belQQxwQRwxDjHEoRB4KooMVX4q7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYqsuI3lgkjSR%26%23xA%3bondWVZVpyQkUDCtRUdd8VeZ/kn%2bS93%2bWh1o3HmKTXzq/1biZIGg9H6t6taVmuOXP1vbp3xV6firs%26%23xA%3bVed/nR%2bU11%2bZGkafp8GvzaD9RuGuGaOH11l5IUAZRJAarXY8u528FWa6BpbaToWm6U0xuWsLWG1a%26%23xA%3b4I4mQwxrHzK1anLjWlTiqPxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2K%26%23xA%3buxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KpXqfmny5pen3Go3%2bp21vZWsbS3EzSrRUUVJ2JJ9gN%26%23xA%3bzirD7f8AOe2uoI7m18n%2baZ7aZRJBMmmHi6MKq61kBow3GKp1pH5o%2bQ9T0S21gaza2NtcTfVfS1CW%26%23xA%3bO0mjuhUNayxyspWZSp%2bDr3FRvirKI5I5EEkbB0bdWUggj2IxVdirsVdirsVdirsVdirsVdirsVdi%26%23xA%3brsVdirsVdirsVdirsVdir5r8n%2bRNF8v/AJdad%2bZOpw6Tf6JZeX4bw%2bX30TTzPJdrbrxlOpFGuCzz%26%23xA%3bfFuO/tiqHuvMX5zT2OseapdT1JbPQLiWDVp7CWxitreW2I%2btLBpc1vK9zFZtyV2kuVaSlRSmKvTP%26%23xA%3by%2b0nyV580WfWPMflTRLrzJbXc9hrV39Qt5VmubYhfWSSVGdkkjKOOR2rTtiqY/kD/wCSa8p/8wK/%26%23xA%3b8SbFWf4q7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq8K8meefyi1L8j9J8o6/5n06%26%23xA%3b2NzosdjfwPcxpNEzQ8Tsx2dG3Fe4xV5ZcXSwtqeijzXpV9p2sTevqdxBr0Fnpt9KaVnvLQwSXcbS%26%23xA%3b8QbhIJaSGoBXrir278vfPX5R%2bU/Lo0%2bbzxpV7qN1PNf6rei4hjWa7uX5ysqA0RBsqL2UDFU7/IH/%26%23xA%3bAMk15T/5gV/4k2Ks/wAVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVf/Z%3c/xmpGImg:image%3e %3c/rdf:li%3e %3c/rdf:Alt%3e %3c/xmp:Thumbnails%3e %3cxmpMM:OriginalDocumentID%3euuid:9E3E5C9A8C81DB118734DB58FDDE4BA7%3c/xmpMM:OriginalDocumentID%3e %3cxmpMM:DocumentID%3exmp.did:9bb40803-0a68-4b6d-b079-70a423632dc7%3c/xmpMM:DocumentID%3e %3cxmpMM:InstanceID%3exmp.iid:9bb40803-0a68-4b6d-b079-70a423632dc7%3c/xmpMM:InstanceID%3e %3cxmpMM:RenditionClass%3eproof:pdf%3c/xmpMM:RenditionClass%3e %3cxmpMM:DerivedFrom rdf:parseType='Resource'%3e %3cstRef:instanceID%3euuid:3790e011-2e1b-2f40-a3d6-4e538a02edb2%3c/stRef:instanceID%3e %3cstRef:documentID%3exmp.did:525ac691-adef-4d04-bc72-b632c8732463%3c/stRef:documentID%3e %3cstRef:originalDocumentID%3euuid:9E3E5C9A8C81DB118734DB58FDDE4BA7%3c/stRef:originalDocumentID%3e %3cstRef:renditionClass%3eproof:pdf%3c/stRef:renditionClass%3e %3c/xmpMM:DerivedFrom%3e %3cxmpMM:History%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cstEvt:action%3esaved%3c/stEvt:action%3e %3cstEvt:instanceID%3exmp.iid:78fa4c27-1810-4112-abf8-25d31ae36cdc%3c/stEvt:instanceID%3e %3cstEvt:when%3e2019-06-10T14:32:07%2b02:00%3c/stEvt:when%3e %3cstEvt:softwareAgent%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/stEvt:softwareAgent%3e %3cstEvt:changed%3e/%3c/stEvt:changed%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cstEvt:action%3esaved%3c/stEvt:action%3e %3cstEvt:instanceID%3exmp.iid:9bb40803-0a68-4b6d-b079-70a423632dc7%3c/stEvt:instanceID%3e %3cstEvt:when%3e2019-06-14T11:08:35%2b02:00%3c/stEvt:when%3e %3cstEvt:softwareAgent%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/stEvt:softwareAgent%3e %3cstEvt:changed%3e/%3c/stEvt:changed%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpMM:History%3e %3cillustrator:StartupProfile%3eBasic RGB%3c/illustrator:StartupProfile%3e %3cxmpTPg:NPages%3e1%3c/xmpTPg:NPages%3e %3cxmpTPg:HasVisibleTransparency%3eFalse%3c/xmpTPg:HasVisibleTransparency%3e %3cxmpTPg:HasVisibleOverprint%3eFalse%3c/xmpTPg:HasVisibleOverprint%3e %3cxmpTPg:MaxPageSize rdf:parseType='Resource'%3e %3cstDim:w%3e440.000000%3c/stDim:w%3e %3cstDim:h%3e440.000000%3c/stDim:h%3e %3cstDim:unit%3ePixels%3c/stDim:unit%3e %3c/xmpTPg:MaxPageSize%3e %3cxmpTPg:PlateNames%3e %3crdf:Seq%3e %3crdf:li%3eCyan%3c/rdf:li%3e %3crdf:li%3eMagenta%3c/rdf:li%3e %3crdf:li%3eYellow%3c/rdf:li%3e %3crdf:li%3eBlack%3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpTPg:PlateNames%3e %3cxmpTPg:SwatchGroups%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eDomy%c5%9blna grupa pr%c3%b3bek%3c/xmpG:groupName%3e %3cxmpG:groupType%3e0%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eBia%c5%82y%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eCzarny%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eCzerwony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3e%c5%bb%c3%b3%c5%82ty RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eZielony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eNiebieskozielony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eNiebieski RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eKarmazynowy RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=193 G=39 B=45%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e193%3c/xmpG:red%3e %3cxmpG:green%3e39%3c/xmpG:green%3e %3cxmpG:blue%3e45%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=237 G=28 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e237%3c/xmpG:red%3e %3cxmpG:green%3e28%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=241 G=90 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e241%3c/xmpG:red%3e %3cxmpG:green%3e90%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=247 G=147 B=30%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e247%3c/xmpG:red%3e %3cxmpG:green%3e147%3c/xmpG:green%3e %3cxmpG:blue%3e30%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=251 G=176 B=59%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e251%3c/xmpG:red%3e %3cxmpG:green%3e176%3c/xmpG:green%3e %3cxmpG:blue%3e59%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=252 G=238 B=33%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e252%3c/xmpG:red%3e %3cxmpG:green%3e238%3c/xmpG:green%3e %3cxmpG:blue%3e33%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=217 G=224 B=33%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e217%3c/xmpG:red%3e %3cxmpG:green%3e224%3c/xmpG:green%3e %3cxmpG:blue%3e33%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=140 G=198 B=63%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e140%3c/xmpG:red%3e %3cxmpG:green%3e198%3c/xmpG:green%3e %3cxmpG:blue%3e63%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=57 G=181 B=74%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e57%3c/xmpG:red%3e %3cxmpG:green%3e181%3c/xmpG:green%3e %3cxmpG:blue%3e74%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=146 B=69%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e146%3c/xmpG:green%3e %3cxmpG:blue%3e69%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=104 B=55%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e104%3c/xmpG:green%3e %3cxmpG:blue%3e55%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=34 G=181 B=115%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e34%3c/xmpG:red%3e %3cxmpG:green%3e181%3c/xmpG:green%3e %3cxmpG:blue%3e115%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=169 B=157%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e169%3c/xmpG:green%3e %3cxmpG:blue%3e157%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=41 G=171 B=226%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e41%3c/xmpG:red%3e %3cxmpG:green%3e171%3c/xmpG:green%3e %3cxmpG:blue%3e226%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=113 B=188%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e113%3c/xmpG:green%3e %3cxmpG:blue%3e188%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=46 G=49 B=146%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e46%3c/xmpG:red%3e %3cxmpG:green%3e49%3c/xmpG:green%3e %3cxmpG:blue%3e146%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=27 G=20 B=100%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e27%3c/xmpG:red%3e %3cxmpG:green%3e20%3c/xmpG:green%3e %3cxmpG:blue%3e100%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=102 G=45 B=145%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e102%3c/xmpG:red%3e %3cxmpG:green%3e45%3c/xmpG:green%3e %3cxmpG:blue%3e145%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=147 G=39 B=143%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e147%3c/xmpG:red%3e %3cxmpG:green%3e39%3c/xmpG:green%3e %3cxmpG:blue%3e143%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=158 G=0 B=93%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e158%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e93%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=212 G=20 B=90%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e212%3c/xmpG:red%3e %3cxmpG:green%3e20%3c/xmpG:green%3e %3cxmpG:blue%3e90%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=237 G=30 B=121%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e237%3c/xmpG:red%3e %3cxmpG:green%3e30%3c/xmpG:green%3e %3cxmpG:blue%3e121%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=199 G=178 B=153%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e199%3c/xmpG:red%3e %3cxmpG:green%3e178%3c/xmpG:green%3e %3cxmpG:blue%3e153%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=153 G=134 B=117%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e153%3c/xmpG:red%3e %3cxmpG:green%3e134%3c/xmpG:green%3e %3cxmpG:blue%3e117%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=115 G=99 B=87%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e115%3c/xmpG:red%3e %3cxmpG:green%3e99%3c/xmpG:green%3e %3cxmpG:blue%3e87%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=83 G=71 B=65%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e83%3c/xmpG:red%3e %3cxmpG:green%3e71%3c/xmpG:green%3e %3cxmpG:blue%3e65%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=198 G=156 B=109%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e198%3c/xmpG:red%3e %3cxmpG:green%3e156%3c/xmpG:green%3e %3cxmpG:blue%3e109%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=166 G=124 B=82%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e166%3c/xmpG:red%3e %3cxmpG:green%3e124%3c/xmpG:green%3e %3cxmpG:blue%3e82%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=140 G=98 B=57%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e140%3c/xmpG:red%3e %3cxmpG:green%3e98%3c/xmpG:green%3e %3cxmpG:blue%3e57%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=117 G=76 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e117%3c/xmpG:red%3e %3cxmpG:green%3e76%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=96 G=56 B=19%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e96%3c/xmpG:red%3e %3cxmpG:green%3e56%3c/xmpG:green%3e %3cxmpG:blue%3e19%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=66 G=33 B=11%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e66%3c/xmpG:red%3e %3cxmpG:green%3e33%3c/xmpG:green%3e %3cxmpG:blue%3e11%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eZimne%3c/xmpG:groupName%3e %3cxmpG:groupType%3e1%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=56 M=0 Y=20 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e101%3c/xmpG:red%3e %3cxmpG:green%3e200%3c/xmpG:green%3e %3cxmpG:blue%3e208%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=51 M=43 Y=0 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e131%3c/xmpG:red%3e %3cxmpG:green%3e139%3c/xmpG:green%3e %3cxmpG:blue%3e197%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=26 M=41 Y=0 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e186%3c/xmpG:red%3e %3cxmpG:green%3e155%3c/xmpG:green%3e %3cxmpG:blue%3e201%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eSzaro%c5%9bci%3c/xmpG:groupName%3e %3cxmpG:groupType%3e1%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=0 B=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=26 G=26 B=26%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e26%3c/xmpG:red%3e %3cxmpG:green%3e26%3c/xmpG:green%3e %3cxmpG:blue%3e26%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=51 G=51 B=51%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e51%3c/xmpG:red%3e %3cxmpG:green%3e51%3c/xmpG:green%3e %3cxmpG:blue%3e51%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=77 G=77 B=77%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e77%3c/xmpG:red%3e %3cxmpG:green%3e77%3c/xmpG:green%3e %3cxmpG:blue%3e77%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=102 G=102 B=102%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e102%3c/xmpG:red%3e %3cxmpG:green%3e102%3c/xmpG:green%3e %3cxmpG:blue%3e102%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=128 G=128 B=128%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e128%3c/xmpG:red%3e %3cxmpG:green%3e128%3c/xmpG:green%3e %3cxmpG:blue%3e128%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=153 G=153 B=153%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e153%3c/xmpG:red%3e %3cxmpG:green%3e153%3c/xmpG:green%3e %3cxmpG:blue%3e153%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=179 G=179 B=179%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e179%3c/xmpG:red%3e %3cxmpG:green%3e179%3c/xmpG:green%3e %3cxmpG:blue%3e179%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=204 G=204 B=204%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e204%3c/xmpG:red%3e %3cxmpG:green%3e204%3c/xmpG:green%3e %3cxmpG:blue%3e204%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=230 G=230 B=230%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e230%3c/xmpG:red%3e %3cxmpG:green%3e230%3c/xmpG:green%3e %3cxmpG:blue%3e230%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=242 G=242 B=242%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e242%3c/xmpG:red%3e %3cxmpG:green%3e242%3c/xmpG:green%3e %3cxmpG:blue%3e242%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpTPg:SwatchGroups%3e %3cpdf:Producer%3eAdobe PDF library 15.00%3c/pdf:Producer%3e %3c/rdf:Description%3e %3c/rdf:RDF%3e%3c/x:xmpmeta%3e %3c%3fxpacket end='w'%3f%3e %3c/metadata%3e%3cg id='Warstwa_1' class='st0'%3e %3cg class='st1'%3e %3cline class='st2' x1='0' y1='0' x2='0' y2='440'/%3e %3cline class='st2' x1='10' y1='0' x2='10' y2='440'/%3e %3cline class='st2' x1='20' y1='0' x2='20' y2='440'/%3e %3cline class='st2' x1='30' y1='0' x2='30' y2='440'/%3e %3cline class='st2' x1='40' y1='0' x2='40' y2='440'/%3e %3cline class='st2' x1='50' y1='0' x2='50' y2='440'/%3e %3cline class='st3' x1='60' y1='0' x2='60' y2='440'/%3e %3cline class='st2' x1='70' y1='0' x2='70' y2='440'/%3e %3cline class='st2' x1='80' y1='0' x2='80' y2='440'/%3e %3cline class='st2' x1='90' y1='0' x2='90' y2='440'/%3e %3cline class='st2' x1='100' y1='0' x2='100' y2='440'/%3e %3cline class='st2' x1='110' y1='0' x2='110' y2='440'/%3e %3cline class='st2' x1='120' y1='0' x2='120' y2='440'/%3e %3cline class='st2' x1='130' y1='0' x2='130' y2='440'/%3e %3cline class='st2' x1='140' y1='0' x2='140' y2='440'/%3e %3cline class='st2' x1='150' y1='0' x2='150' y2='440'/%3e %3cline class='st2' x1='160' y1='0' x2='160' y2='440'/%3e %3cline class='st2' x1='170' y1='0' x2='170' y2='440'/%3e %3cline class='st2' x1='180' y1='0' x2='180' y2='440'/%3e %3cline class='st2' x1='190' y1='0' x2='190' y2='440'/%3e %3cline class='st2' x1='200' y1='0' x2='200' y2='440'/%3e %3cline class='st2' x1='210' y1='0' x2='210' y2='440'/%3e %3cline class='st3' x1='220' y1='0' x2='220' y2='440'/%3e %3cline class='st2' x1='230' y1='0' x2='230' y2='440'/%3e %3cline class='st2' x1='240' y1='0' x2='240' y2='440'/%3e %3cline class='st2' x1='250' y1='0' x2='250' y2='440'/%3e %3cline class='st2' x1='260' y1='0' x2='260' y2='440'/%3e %3cline class='st2' x1='270' y1='0' x2='270' y2='440'/%3e %3cline class='st2' x1='280' y1='0' x2='280' y2='440'/%3e %3cline class='st2' x1='290' y1='0' x2='290' y2='440'/%3e %3cline class='st2' x1='300' y1='0' x2='300' y2='440'/%3e %3cline class='st2' x1='310' y1='0' x2='310' y2='440'/%3e %3cline class='st2' x1='320' y1='0' x2='320' y2='440'/%3e %3cline class='st2' x1='330' y1='0' x2='330' y2='440'/%3e %3cline class='st2' x1='340' y1='0' x2='340' y2='440'/%3e %3cline class='st2' x1='350' y1='0' x2='350' y2='440'/%3e %3cline class='st2' x1='360' y1='0' x2='360' y2='440'/%3e %3cline class='st2' x1='370' y1='0' x2='370' y2='440'/%3e %3cline class='st3' x1='380' y1='0' x2='380' y2='440'/%3e %3cline class='st2' x1='390' y1='0' x2='390' y2='440'/%3e %3cline class='st2' x1='400' y1='0' x2='400' y2='440'/%3e %3cline class='st2' x1='410' y1='0' x2='410' y2='440'/%3e %3cline class='st2' x1='420' y1='0' x2='420' y2='440'/%3e %3cline class='st2' x1='430' y1='0' x2='430' y2='440'/%3e %3cline class='st2' x1='440' y1='0' x2='440' y2='440'/%3e %3c/g%3e %3cg class='st1'%3e %3cline class='st2' x1='440' y1='0' x2='0' y2='0'/%3e %3cline class='st2' x1='440' y1='10' x2='0' y2='10'/%3e %3cline class='st2' x1='440' y1='20' x2='0' y2='20'/%3e %3cline class='st2' x1='440' y1='30' x2='0' y2='30'/%3e %3cline class='st2' x1='440' y1='40' x2='0' y2='40'/%3e %3cline class='st2' x1='440' y1='50' x2='0' y2='50'/%3e %3cline class='st3' x1='440' y1='60' x2='0' y2='60'/%3e %3cline class='st2' x1='440' y1='70' x2='0' y2='70'/%3e %3cline class='st2' x1='440' y1='80' x2='0' y2='80'/%3e %3cline class='st2' x1='440' y1='90' x2='0' y2='90'/%3e %3cline class='st2' x1='440' y1='100' x2='0' y2='100'/%3e %3cline class='st2' x1='440' y1='110' x2='0' y2='110'/%3e %3cline class='st2' x1='440' y1='120' x2='0' y2='120'/%3e %3cline class='st2' x1='440' y1='130' x2='0' y2='130'/%3e %3cline class='st2' x1='440' y1='140' x2='0' y2='140'/%3e %3cline class='st2' x1='440' y1='150' x2='0' y2='150'/%3e %3cline class='st2' x1='440' y1='160' x2='0' y2='160'/%3e %3cline class='st2' x1='440' y1='170' x2='0' y2='170'/%3e %3cline class='st2' x1='440' y1='180' x2='0' y2='180'/%3e %3cline class='st2' x1='440' y1='190' x2='0' y2='190'/%3e %3cline class='st2' x1='440' y1='200' x2='0' y2='200'/%3e %3cline class='st2' x1='440' y1='210' x2='0' y2='210'/%3e %3cline class='st3' x1='440' y1='220' x2='0' y2='220'/%3e %3cline class='st2' x1='440' y1='230' x2='0' y2='230'/%3e %3cline class='st2' x1='440' y1='240' x2='0' y2='240'/%3e %3cline class='st2' x1='440' y1='250' x2='0' y2='250'/%3e %3cline class='st2' x1='440' y1='260' x2='0' y2='260'/%3e %3cline class='st2' x1='440' y1='270' x2='0' y2='270'/%3e %3cline class='st2' x1='440' y1='280' x2='0' y2='280'/%3e %3cline class='st2' x1='440' y1='290' x2='0' y2='290'/%3e %3cline class='st2' x1='440' y1='300' x2='0' y2='300'/%3e %3cline class='st2' x1='440' y1='310' x2='0' y2='310'/%3e %3cline class='st2' x1='440' y1='320' x2='0' y2='320'/%3e %3cline class='st2' x1='440' y1='330' x2='0' y2='330'/%3e %3cline class='st2' x1='440' y1='340' x2='0' y2='340'/%3e %3cline class='st2' x1='440' y1='350' x2='0' y2='350'/%3e %3cline class='st2' x1='440' y1='360' x2='0' y2='360'/%3e %3cline class='st2' x1='440' y1='370' x2='0' y2='370'/%3e %3cline class='st3' x1='440' y1='380' x2='0' y2='380'/%3e %3cline class='st2' x1='440' y1='390' x2='0' y2='390'/%3e %3cline class='st2' x1='440' y1='400' x2='0' y2='400'/%3e %3cline class='st2' x1='440' y1='410' x2='0' y2='410'/%3e %3cline class='st2' x1='440' y1='420' x2='0' y2='420'/%3e %3cline class='st2' x1='440' y1='430' x2='0' y2='430'/%3e %3cline class='st2' x1='440' y1='440' x2='0' y2='440'/%3e %3c/g%3e%3c/g%3e%3cg id='Warstwa_2' class='st0'%3e %3ccircle class='st4' cx='220' cy='220' r='100'/%3e %3ccircle class='st4' cx='220' cy='220' r='40'/%3e %3ccircle class='st4' cx='220' cy='220' r='160'/%3e %3ccircle class='st4' cx='220' cy='220' r='220'/%3e%3c/g%3e%3cg id='Warstwa_3'%3e %3cg%3e %3cpolygon points='270%2c10 270%2c50 120%2c50 120%2c160 150%2c160 150%2c80 270%2c80 270%2c360 150%2c360 150%2c280 120%2c280 120%2c390 270%2c390 270%2c430.31 399.27%2c380 400%2c60 '/%3e %3cpolygon points='170%2c320 250%2c220 170%2c120 170%2c180 80%2c180 40%2c260 170%2c260 '/%3e %3c/g%3e%3c/g%3e%3c/svg%3e";

var img$D = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 23.0.4%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 440 440' style='enable-background:new 0 0 440 440%3b' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bdisplay:none%3b%7d .st1%7bdisplay:inline%3b%7d .st2%7bfill:none%3bstroke:grey%3bstroke-miterlimit:10%3b%7d .st3%7bfill:none%3bstroke:%23C1272D%3bstroke-miterlimit:10%3b%7d .st4%7bdisplay:inline%3bfill:none%3bstroke:%23C1272D%3bstroke-miterlimit:10%3b%7d%3c/style%3e%3cmetadata%3e%3c%3fxpacket begin=' ' id='W5M0MpCehiHzreSzNTczkc9d'%3f%3e%3cx:xmpmeta xmlns:x='adobe:ns:meta/' x:xmptk='Adobe XMP Core 5.6-c145 79.163499%2c 2018/08/13-16:40:22 '%3e %3crdf:RDF xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%3e %3crdf:Description rdf:about='' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:xmp='http://ns.adobe.com/xap/1.0/' xmlns:xmpGImg='http://ns.adobe.com/xap/1.0/g/img/' xmlns:xmpMM='http://ns.adobe.com/xap/1.0/mm/' xmlns:stRef='http://ns.adobe.com/xap/1.0/sType/ResourceRef%23' xmlns:stEvt='http://ns.adobe.com/xap/1.0/sType/ResourceEvent%23' xmlns:illustrator='http://ns.adobe.com/illustrator/1.0/' xmlns:xmpTPg='http://ns.adobe.com/xap/1.0/t/pg/' xmlns:stDim='http://ns.adobe.com/xap/1.0/sType/Dimensions%23' xmlns:xmpG='http://ns.adobe.com/xap/1.0/g/' xmlns:pdf='http://ns.adobe.com/pdf/1.3/'%3e %3cdc:format%3eimage/svg%2bxml%3c/dc:format%3e %3cdc:title%3e %3crdf:Alt%3e %3crdf:li xml:lang='x-default'%3eIcons%3c/rdf:li%3e %3c/rdf:Alt%3e %3c/dc:title%3e %3cxmp:CreatorTool%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/xmp:CreatorTool%3e %3cxmp:CreateDate%3e2019-06-14T11:08:35%2b02:00%3c/xmp:CreateDate%3e %3cxmp:ModifyDate%3e2019-06-14T11:08:35%2b02:00%3c/xmp:ModifyDate%3e %3cxmp:MetadataDate%3e2019-06-14T11:08:35%2b02:00%3c/xmp:MetadataDate%3e %3cxmp:Thumbnails%3e %3crdf:Alt%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpGImg:width%3e180%3c/xmpGImg:width%3e %3cxmpGImg:height%3e256%3c/xmpGImg:height%3e %3cxmpGImg:format%3eJPEG%3c/xmpGImg:format%3e %3cxmpGImg:image%3e/9j/4AAQSkZJRgABAgEASABIAAD/7QAsUGhvdG9zaG9wIDMuMAA4QklNA%2b0AAAAAABAASAAAAAEA%26%23xA%3bAQBIAAAAAQAB/%2b4ADkFkb2JlAGTAAAAAAf/bAIQABgQEBAUEBgUFBgkGBQYJCwgGBggLDAoKCwoK%26%23xA%3bDBAMDAwMDAwQDA4PEA8ODBMTFBQTExwbGxscHx8fHx8fHx8fHwEHBwcNDA0YEBAYGhURFRofHx8f%26%23xA%3bHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8f/8AAEQgBAAC0AwER%26%23xA%3bAAIRAQMRAf/EAaIAAAAHAQEBAQEAAAAAAAAAAAQFAwIGAQAHCAkKCwEAAgIDAQEBAQEAAAAAAAAA%26%23xA%3bAQACAwQFBgcICQoLEAACAQMDAgQCBgcDBAIGAnMBAgMRBAAFIRIxQVEGE2EicYEUMpGhBxWxQiPB%26%23xA%3bUtHhMxZi8CRygvElQzRTkqKyY3PCNUQnk6OzNhdUZHTD0uIIJoMJChgZhJRFRqS0VtNVKBry4/PE%26%23xA%3b1OT0ZXWFlaW1xdXl9WZ2hpamtsbW5vY3R1dnd4eXp7fH1%2bf3OEhYaHiImKi4yNjo%2bCk5SVlpeYmZ%26%23xA%3bqbnJ2en5KjpKWmp6ipqqusra6voRAAICAQIDBQUEBQYECAMDbQEAAhEDBCESMUEFURNhIgZxgZEy%26%23xA%3bobHwFMHR4SNCFVJicvEzJDRDghaSUyWiY7LCB3PSNeJEgxdUkwgJChgZJjZFGidkdFU38qOzwygp%26%23xA%3b0%2bPzhJSktMTU5PRldYWVpbXF1eX1RlZmdoaWprbG1ub2R1dnd4eXp7fH1%2bf3OEhYaHiImKi4yNjo%26%23xA%3b%2bDlJWWl5iZmpucnZ6fkqOkpaanqKmqq6ytrq%2bv/aAAwDAQACEQMRAD8A9TTTwQJ6k0ixJ05OQoqf%26%23xA%3bc4q%2bevyy0P8AKe41O38n%2ba/LVg3m%2b9jvtVinvYI2kuY31W9VY6sK80ghR1Fd0NRsuKs01T8v/JHl%26%23xA%3br8wfIF1oGh2Wl3M2pXsUs1rCkTMn6HvG4kqBtUA4q9UxV4x%2baHmPy55y8xWHkeCBdUTQtb0q48xK%26%23xA%3bwV4EikM6yRuD19NR%2b87CoHWtFWYRfkz%2bT0qCSLynpEkbfZdbaIg/IgYql35IadY6bY%2bbrCwgS1sr%26%23xA%3bXzPqUVvbxKFSNFEQVVUbAAYq9IxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KvIv%2bcgvyp87%26%23xA%3bfmTY6ZpOjalZ6fpNpI1zeR3Jl5zT04x7Ro44opbv1Ptir50/Ln8hPMl9%2bY%2bjw6bqwbTbZBql1r9i%26%23xA%3bJYvq6297PaemnrIjeu09k4TalPi3AOKvrPzt/wApv%2bXn/bVvf%2b6Ne4qzG5hM9vLCsrwmVGQTREB0%26%23xA%3bLCnJCwYch1FRir4R1j/nHXzTbee7/QdS1WG3aS7totN1S7WdxfnUXlELgxrKVasLCTkfhbudiVX1%26%23xA%3bL%2bQv5decvy%2b8sXPl3X9QtNQsknM%2bltamUmIS1M0bCRE%2bHn8a07s2Ko38of8Aptf/AAK9T/5lYq9A%26%23xA%3bxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV5l5V8ofmp5W0kaPpl5oM1nHPdTQy3MF4Zi%26%23xA%3bt1dS3XFykir8LTkCgxVMI/LX5i6j5p8vap5gu9I%2bo6Fc3F16VhFcpLI01lPaAVmd1oPrHL6MVZ7i%26%23xA%3brEvzG8p6v5istIOkXFtb6ho%2bqW2qQvdo7xN9WDfu2EZVviLDocVQ/p/nT/y0eW/%2bRF9/1WxVE/lz%26%23xA%3b5U1jy7Y6uNYuLe5v9X1W51WVrRXSFDchPgUSFm2KdzirLMVdirsVdirsVdirsVdirsVdirsVdirs%26%23xA%3bVdirsVdirsVU7q5gtbaW5uH9OCBGllc1IVEHJjt4AYqgtB8yeX/MFiL7Q9RttTszt69rKkqg%2bDcS%26%23xA%3beJ9jviqY4q7FUr1vzV5c0KS0j1rUrfTjfuYrRrqRYkkdRUqHei1oeld8VTNHR0V0YMjAFWBqCDuC%26%23xA%3bCMVbxV2KuxV2KrJpoYInmmkWKGNS0kjkKqqBUlidgBiqW/4s8q/9Xmx/6SYf%2basVd/izyr/1ebH/%26%23xA%3bAKSYf%2basVRljqem36NJY3cN2iHi7wSLIAetCVJxVE4qsmnggT1JpFiTpychRU%2b5xVsTRGL1Q6mKn%26%23xA%3bL1ARx49a16UxVBaHr%2bia9p66jot9DqFg7Oi3Nu4kjLRsVYcl8CMVR%2bKuxV2KuxVhP51SapH%2bVXmW%26%23xA%3bTSmnTUFs2Ns1qXEwfkv2DH8VfliryzSfy28oa75T1ma383eZ5NX0W2dNXsJdUkHp3H1b1aPEVNYp%26%23xA%3bP2fHcdQQFXyr5A1fVdL84aRPpl5PZTNeW8byW8jRMyNKoZWKkVUjqDtir9M8VeDeZprX8zPzU0Ox%26%23xA%3b0nWNWg8rx2mowXd9pNxJbRPdWkijaROSMKkgEjfttvirzT/nKf8ALPTvKGgaHc2us6xqbXV3LG0e%26%23xA%3bq3rXaIFj5VjVlXiffFUx/wCcJtY1abWPMGmTXs8mm29pFJBZvI7QxuZSCyRk8VJrvQYq9l/OyL88%26%23xA%3bZF0YflbNHCQbk6w0gsyT/dfVwPrauP8AfleP04q8u%2bp/85x/8t8H/A6L/wBUsVd9T/5zj/5b4P8A%26%23xA%3bgdF/6pYqzP8AKWD/AJybj83IfzEuYpvLhglDqo04MJtvTI%2bqokn8MVTz/nIjW9Otfy4v9PNxYvqt%26%23xA%3bxPpr2ulXs0SC4Uanb8ldHZeUJCsJD041rtirxr9Ka1/5b78sf%2bR%2blf8AZRirv0prX/lvvyx/5H6V%26%23xA%3b/wBlGKs8/JCLXYPzN1ddV0DSPLX1nQLO4t7HQPSFlPEbucR3R9BnRnb4l5V%2byBir0X8zfza8n/l7%26%23xA%3bpT3OtXiDUJYnfTtLSrT3DqDxAVQ3BCwpzaijxxV%2bf/nXz55q86azLq3mG/ku55GJiiLEQwqekcMf%26%23xA%3b2UUe3XqanfFWcfk1oPm7V9L1gXHmC58uflnDHTzVf%2boywNHUMbeFDUNPJsvwitDQ15BWVfdHljy/%26%23xA%3boXl/QrPSNBto7XSrWMLbRR9OJ35FurM1asx3J3xV4J5o/wCcq9b0aLUriPRNJmistRuNMjtjqq/X%26%23xA%3biYJHQTPZiP1RGeFa9PfFXmX6Z/5yC1nhrOo%2beIfLTaz/AKTpum3uqLpzSxSH4DBbVrHEeiF%2bNetT%26%23xA%3b1xVMrL/nKL82PIdlN5U8z6THqGv2EnEX2oO/qem1GUSemaTAg1SQPuKdeuKvYv8Alf2o/wDKhv8A%26%23xA%3blZn6Hh%2bu%2bt9X/R3rN6XL6z9X5c%2bPKn7VPor3xVif/OSnk783dd1t9Z0%2b9h0jydolsFjna%2bNvUvRp%26%23xA%3bppVTcfFRB7KD3xV59%2bSPkP8AMa182%2batSkvDHpul6fd2%2bu3RczxXrS2xeOBHb7bfEsnL9kD/ACgC%26%23xA%3bq8V8p/8AKU6N/wAx1t/yeXFX6I/mxoXmjXvy%2b1nSvLF59R1m6gKwSdC69XhD1HAyrVOXauKvibyV%26%23xA%3b%2bWH5pav6OnaLqI0%2b6me5WPSZb17WblaPwuD6I6cG2OKvVf8AnKQeaV/KfyNF5rRE8wwzyxag0biV%26%23xA%3bJJI4uHqhh3kUBz4EkYqgv%2bcIf%2bUq8y/8wMP/ACexVOf%2bc34TPceRIQQplfUkDHoCxsxU4q8k1P8A%26%23xA%3bJLStLhM175/0GONZmtmK/XZKSoWDIRHbsQRwPX%2bIxVOvy/8AyV8natJfS/ppfOktoIAuh%2bXna1uu%26%23xA%3bE8oie4Zr%2bKIFIQa0TvTkVHVVPvyD8u6f5b/5ya1HQdOvRqFlp0d/bwXexLKgGzFduSfZam1QcVVv%26%23xA%3b%2bcttA1HXfzl0mwsFT1f8PpNLJKwjiihguLySWWR22VERSx/DfFXkEf5fWcFhc6rqXmGx/RNm0UVw%26%23xA%3b%2bmN9fufUn5emiQlrdSWEbt8UiiinetAVW5/ys8wvHq9xpfHUbLSLGDVZZFDRyGynr%2b89Jt1aIgiV%26%23xA%3ba/DQ05AVxV9P/wDONEh1C60/ULWKZrGw8qWOl3N08MsUf1xL%2b6naJHkVBJSORWLJVd%2buKvEf%2bctI%26%23xA%3bNWT86dSkvQ/1SW2tDpbP9n0BAivw9vXEtffFWM/ld%2bVz%2ba3utZ1m6/Q3kjRv3mt63JsABQ%2bhBUHn%26%23xA%3bM9QAADSo2JKqyqp%2baP5op5kS18u%2bXbX9DeQ9G%2bDSNITYuRUG5uSCecz1J3JpXuSzFV9Uf84pefPM%26%23xA%3b3m38v7ka87XMmk3X1K1vmUKZIREjKjUADNHypXwIrvvir4688PDH%2bZHmCSdPUhTWbxpY/wCZRdOW%26%23xA%3bH0jFWY/nD5O8463%2bYF/5h0nTrvW9D1%2bVbnQtSsYZLiGS3dF9GFTGrcXhQemYzQrx6Yql35xUtP8A%26%23xA%3bCmg3brLr%2bhaLFZ62yuJDFMZpZY7V2BIL28Mio1Dt9ntir1D/ANcl/wCj7/u54q%2bk/wA1/Lmp%2bZfy%26%23xA%3b617QdLVG1DULUw2yyNwQuWB3Y9OmKvOJZvz70vydd6YvlDQ4rRLKWO5livW9Rv3JV5eIX4nYCvvi%26%23xA%3br52/Kz8g/wA0fMGsaZqsOjvYaVDcQ3DX2oE2yMkbq/wIwMr1A2KoR74q%2b/MVeTfmB5R8%2bwfmVo3n%26%23xA%3bHyTpNhem0srq3vIbqYWweW5ZaueIqzcVG%2bKvIf8AnI%2b3/OnzLpugafrfle3jc3chsotHllvppJDH%26%23xA%3b8QZAtQAu9cVZd/zit%2bTvnnyTe6trHma1jsE1K2jht7QyrJcArJz5OsfJFFP8qvtirMPz6/I65/NJ%26%23xA%3bdD9DV00ptHN1XnAZhILr0fB4%2bPH0PxxV5J/0I5qv/U3Qf9IT/wDVbFV8P/OEetwSCSHzlFFIKgOl%26%23xA%3bpIpoRQ7ibFWbfk1/zjHefl551TzJP5gj1FY7eaAW0ds0RJlAFeRkfp8sVYF/zlnofneb81tG1jy3%26%23xA%3bp%2bpSPa6RAsOoadFOximS6uWossIqrqHU9a74q8vXUvz8lVodWste16xkFJNO1m2vdQtmINQ3p3Ac%26%23xA%3bK6kbOlGHStCcVS2%2b0384Lw34fRdWih1JIYbu3t9PmghaG2p6EIjjjVVjjoKINtgeuKvuL8kNPvtO%26%23xA%3b/KbyvZX9vJa3cNigmt5lKSISS1GVqFTQ9DirF/zp/LfzL%2bZHmLRPLhsra08o2oN7qXmI%2bnJeh%2bXE%26%23xA%3b2lsrAvGXABZvsnv9niyrMLz8ofy7vPLGn%2bV7rR0k0HTPitLASTRxh6UMjiN09RzUnk9TUnxOKpL/%26%23xA%3bANC3fkl/1K0H/I65/wCquKs50Dy7ofl7S4dK0Oxh0/ToK%2blbQKFUE7knuWJ6k7nFXjus/wDOH35a%26%23xA%3batq99qtzqetJcahcS3UyRz2oQPM5kYKDasaVbapOKorSv%2bcV/K%2bkWstppPm7zXp1pPUzW9pqMMEb%26%23xA%3bk7Hkkduqt9OKpSf%2bcK/ytJJOq66SdyTcWla/9ImKs4/5UP5Q/wCVW/8AKtvrmofoL1fX%2bs%2bpD9b5%26%23xA%3bev8AWKc/R9OnPb%2b76Yq9HxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Ku%26%23xA%3bxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Kux%26%23xA%3bV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV%26%23xA%3b2KuxV2KuxV2KuxV2KuxV2Kpbr/mXy/5dsRf67qEGmWRcRC4uXWNObAlV5NtUhTirHP8Aldf5R/8A%26%23xA%3bU36V/wBJUX9cVTvy3528o%2bZ/rH%2bHtYtNV%2bqcPrX1SVZfT9Xlw58SacuDU%2bWKp1irHNf/ADG8h%2bXb%26%23xA%3b4WGu6/Y6ZelBKLe5nSN%2bDEhW4sa0JU4qlv8Ayuv8o/8Aqb9K/wCkqL%2buKsr0vVNO1XT4NR025jvL%26%23xA%3bC5Xnb3MLB43XpVWGxGKorFWOa/8AmN5D8u3wsNd1%2bx0y9KCUW9zOkb8GJCtxY1oSpxVLf%2bV1/lH/%26%23xA%3bANTfpX/SVF/XFWV6Xqmnarp8Go6bcx3lhcrzt7mFg8br0qrDYjFUVirEb783vyvsL24sb3zTplve%26%23xA%3bWkjwXNvJcxq8csbFXRlJ2KsCCMVUk/Oj8ppHVE83aUzuQqqLqOpJ2A64qzPFXYq7FXYq7FXYq7FX%26%23xA%3bYq7FXn35xIkieS0kUOjeatMDKwqCP3uxBxV87f8AOWvmnX9J/MOPRdMvZbLSW02GV7O2YwI0kjyq%26%23xA%3bWb0uBboOpptirIf%2bcGSSfO5JqT%2bjCSetf9MxV9U4q870y1tbj88PMwnhSYLoek8RIoalZ7zpUYq%2b%26%23xA%3bE/OHnHzPreoXcWq6lcXcSTvwieRhEoViAFiBEY%2bhcVfeP5A/%2bSa8p/8AMCv/ABJsVZ/irzjTobGb%26%23xA%3b89PMkVykUjnQtKMSSBWO093yKhvorir4W84ecfM%2bt6hdxarqVxdxJO/CJ5GEShWIAWIERj6FxV94%26%23xA%3b/kD/AOSa8p/8wK/8SbFWfkgCp2A6nFXz9e3VxZfkx%2bZetaQ8cWpW/mDWpba/VUZlX9JblGIbqhNM%26%23xA%3bVfIn6c1nV9ds7nVb6e%2bnM8f7y4kaQj4xsORNB7DFX6eYq7FXYq7FXYq7FXYq7FXYq8F/5yY038yd%26%23xA%3bQs7SDTbixj0Se5jtdNsUV3v59RmikEbCQqiQn7SJRtiak/yqvn3/AJyIsfMen%2bYtFsfNl0NR80Q6%26%23xA%3bNaC9v4yBGw9Sf4GXjV3UcQZOQ5UJ474q9S/5wY/6bb/t1/8AY5ir6muFna3lW3dY7gowhkdS6K5H%26%23xA%3bwllBQsAeo5D54q%2bb/wAsdE/PSw/NHWV1HVdOuNUi9GfXI7xXP1uxlmnEHoTxo3BRR2jWg4bAinw4%26%23xA%3bq%2bTdbMJ1a79FGRfVcMHYOS4Y8iCFSgJ6Dt4nrir9B/yB/wDJNeU/%2bYFf%2bJNirPLh5UgkeKP1pVVm%26%23xA%3bjiqF5sBULyOwqdq4q%2bQjoP593v59adLe3dvBry3EV7MLeksNnp7mYBZGVU5wiMSxqhepJpsWrir5%26%23xA%3b61xrc6tdeijoBI4cO4erhjyYUVKAnoN6eJxV%2bg35A/8AkmvKf/MCv/EmxVE/nRpnnDU/yz1yy8oy%26%23xA%3b%2blrMsBCqoPqSwg1mhhYH4ZJI6qp%2bjavIKvmny1bfmpZ/k/55Gpvb3vlKe3uoZirKk1tqMEo9VvT4%26%23xA%3bRs/N6rId6mjV61VeBaT/AMdWz/4zx/8AExir9ScVdirsVdirsVdirsVdirsVeb/nfqNjptj5Rv7%2b%26%23xA%3bdLWytfM%2bmy3FxKwVI0USlmZjsABir5v/AOcnI9J83%2bdo/MXlzXtH1GxSxhtnjTUbaOYPG8jN8Erp%26%23xA%3bUUcdCcVZf/zg0pVvO6mlQdMBoQRt9c7jbFX1Tirye685eVPLP53eYZPMOrWulJdaJpa27XcqxByk%26%23xA%3b92WC8iK05DFXxN5u8sXGmX9zONQ03ULaSV3jmsL62uKhmJ/u1f1R17pir7y/IH/yTXlP/mBX/iTY%26%23xA%3bqz/FXk915y8qeWfzu8wyeYdWtdKS60TS1t2u5ViDlJ7ssF5EVpyGKvibzd5YuNMv7mcahpuoW0kr%26%23xA%3bvHNYX1tcVDMT/dq/qjr3TFX3l%2bQP/kmvKf8AzAr/AMSbFWf4q%2bcL/wAzeUpvy5/MnyhceYNN0/Xr%26%23xA%3b7XtdWC0vblID8d%2bzKW5dA1Njir5UOjXOl65ZwzzWs59ePi9pdW90hHMb8oHkp9OKv06xV2KuxV2K%26%23xA%3buxV2KuxV2KuxVQvjYLbPJf8ApC1j%2bJ3n4iNadyX2GKsfv/Mn5a2FnNeXeo6TFbQKXlkMluaKPYEk%26%23xA%3b/IYqk%2bjfnB%2bWM17BaW88mmnUGCWVzeWF1YW9y3VRHPPFFGxNfhBaprtirP8AFUu1W48uWzxvq0ln%26%23xA%3bC8gIia6aJCwWlQpkpWnLFWN6958/K7RFhFzc2dxcXJK2tlYQ/XrmUqKtwgtllkIHc0piqP8AKH5g%26%23xA%3beTvMjzWWi3JS9s1BuNLuIZbO6iQ9GNvOkT8P8oCmKsmxVjHnDzh5A8uNC3mW8tYLm4FLa3eMz3Uo%26%23xA%3bqf7qCNZJnFf5VOKscj/N38plkjXUEl0hJSFjuNU0u6soCSabzzQJEvX9phir0W0e0ktYpLNo3tXU%26%23xA%3bNA8JUxsjCoKFfhII6UxVVxVLtSXy5YwSXupiztYAay3Nz6UaVPdneg3%2beKoTRr/yRrSs%2bi3Omaks%26%23xA%3bdC7Wb284WvSpjLUxVU0fzf5a1nVdV0nS9Qiu9Q0SRItUgjJPovICVUtTiT8JBoTQgg74qnGKuxV2%26%23xA%3bKuxV2KuxV2KuxVgH5/f%2bSa82f8wLf8SXFWCfm15e8jeT/Nvk7VrLyhYG0tV1O7e0sbS3tWubu2hi%26%23xA%3be2jLxx/EyoZpEQ/aZfHFU287%2bePypvvLWnad%2bkx5ktNXgkspbVL71mispVE1xqNzGS3x2iQ81ZwG%26%23xA%3bU1CkE4qzn8qLvVrz8s/K91q5ZtRm0y1e4dyS7ExLR3rvyZaM3virHfzC0PRda/NjyDY6zp9tqVk1%26%23xA%3bnrrm1vIY54iyrZcW4SBlqO22KsH8qah5A8ofmV5j0%2b%2bsofL732uegmo2zJp9vaw2ltbXFhbOIxGi%26%23xA%3bxXtZWNSFkKlWDbHFUd5j82%2bWtT/M3y7H5ake/wBRsNcto/07DcfWUkW/jma/0%2bI1YGCG3jWV%2bLFY%26%23xA%3b2KigJxV6p%2bYXmw%2bVfKN/rMUP1q9jCQadaDrNeXDrDbRbb0aV1r7VxVjWk%2bUNR8l6WuuxaV/i7z7q%26%23xA%3blxbrr2ptJHDMwmcLKYXl2jggQ0SJABQCvc4qy3zNeanE2m2drof6astSultNV5SRoltaujF53SQH%26%23xA%3b1VFACg64qwqysB%2bW3nnTdM06sfkbzbNLb2%2bnkkxabqoR7hRb1rxhu1R/3Y2VxUUBpirNPN3nLRPK%26%23xA%3bmnR3uqPIzXEq29lZW0bT3VzO/wBmKCFPidz%2bHU4qwzyt5E/xbdS%2bcfzC003F/PNL%2bhPL2oKHg02y%26%23xA%3bRysINu3KI3MgX1JJDU7gClMVYT%2bYmnaN5u89W/lL8s9Og0/zRpciya/5109TbDTIdw0BktzH68ri%26%23xA%3bq%2bmxIG468iir0r8lNM8oWP5e2B8q2stvp8zz%2bs90B9amuIZngmluSOsheI%2bw6DYYqzvFXYq7FXYq%26%23xA%3b7FXYq7FXYq8%2b/PiS2l/K7XtKN1bQX%2bpWrw2EFzcQ2/rSBlJVGmaNTQe%2bKqGkXvkH80tK17RpdUOu%26%23xA%3bLp%2bqTAr%2b7guLGSGQrbyWktuEPAcC0M4JLAkEndcVYd%2bXP5SaJrt75gm12/vNSs9J1y605NPf6vDF%26%23xA%3bdR2jI8b37W8MMt03JqkSPxJ6g4q93JihiJJWOKNakmiqqqPuAAxV4lqXn/yv5x/MPQr/AEHzDb6f%26%23xA%3bZ6F%2bmdLuNWea0QiaaOxeOSCK5ZvVjkIeNX4EEqadiVU5/PLyRpcvk7VvNqSzW/mLR9MkYX0Hphbt%26%23xA%3bIF9RYbyB0eGeLmOXFk2/Zpiqc/l5%2bVfl/wAutb62ZrjU9Ze2CQ3d4YwttFLR3itIIEhggVmNW4JU%26%23xA%3b9ziqz865FtPLek6xMCbHRde0nUNQIFeNvFdoryEUr%2b75h9vDwriq/wA2eZvNWo%2baE8l%2bS5ILS/jt%26%23xA%3b0vdc164j%2bsR2NvMzJAkUNVWS4mKMVDniFFTWuKoS/wDLX5s6Bbtqmi%2bapPM81uDLcaDq1taxLdBd%26%23xA%3b2jt57WOFoJCKhOXJa0rtiqA82eadM836V%2bW9xpHJpNc16yv7WFgBLHFYCS4vOY3p6QjMT%2b5xVFee%26%23xA%3briy0b82fKHmPXn9LQEs7/TrW%2bkIW3tNSuWiKNM5%2bFPXhR41Y99sVSrz9%2bY2seZtal/L/APLq8jiu%26%23xA%3bgB/iXzYGBttMgfbhFICA1y/RQDt23qUVZt5D8s%2bSfJHl6HRNEmgSFPjuLh5Uaa4mb7c0z1%2bJ2/Do%26%23xA%3bKAYqxfyRFp2hfmvqflfyzfyXPluXS21W%2b04zNdRWGoS3YCrFIzOYvrKSSSNFXqvLvir1TFXYq7FX%26%23xA%3bYq7FXYq7FXYq84/PHyrpV/5J1fW10G21jzHp9mRpTTWq3kinmDxSNlfl9omlMVYv5B1n8n/I0mpT%26%23xA%3baFomsxXWqXM1xcXH6D1AMsckpkjto6QfBDECFVR4VO%2bKsr/JaWS507zPqBtri1g1HzHqF3aJdwSW%26%23xA%3b0rQyiMo/pyqjgH3GKvQZoYZ4ZIJ41lhlUpLE4DKysKMrKdiCOoxV8%2b%2bYfyv/AC38g%2bbNIV/LB1Xy%26%23xA%3bxrEmqXWoKNNfU5LZ1itFtYEeOOWVIg/qsoJ7nwxVO/zD/Mny1qf5aa55c0TSta%2bsXOmy2Wn236H1%26%23xA%3bBEBMXCNOTQgKOg3xV7DpasumWisCrLDGGU7EEINjirtT02x1TTrrTb%2bFbixvYnt7qB/svFIpV1Pz%26%23xA%3bBxV5ToNl5k/K%2b/vYZ9Cu/NGhXYhSDzBplbnU1gtkMdvBe2hYGUwoeCywDdacl5Yqnkv5y2Vwpi0L%26%23xA%3byz5g1fUG2jthptxZxhjsPVuLtYYo18WJxVS/LP8ALa80m%2bbzH5git7fVnSaLTNGs2eW00u3uZ2uJ%26%23xA%3bo4pJCTJNNK/KaXbf4VogGKpl%2bbeg%2bc/MfllfL3lprOBNWlFtrF9eD1Db2TAmR4YSCrvtQVO3b%2bZV%26%23xA%3bWtC/Jn8utI8oWvlT9DwX2l27ieRbxFlaa548TcS1FGkI26bDYUGKrv8AlSn5R/8AUoaV/wBIsX9M%26%23xA%3bVZD5f8reW/Llo1noOl2ul2ztzkitIkhDP/M3ADke1TiqaYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXY%26%23xA%3bq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FWK%2bc/zC0/y1cW%26%23xA%3bmnR2VzrGvagryWWkWQQyNHFT1JpZJGjihhSoq7sB4VxVL/K35qQ6prFtous6Pc6BqV%2bjyaUZpbe6%26%23xA%3btbwRCsiW93aSSxNIgFWjrUDfFUH59/OvRvKuqy6TDZNqV7aCI6g7XVpYW1sZxyhikub2WGMyyJ8a%26%23xA%3bxrU8fi6YqyLyb5%2b0TzVotxqlsJLE2MjwanaXoWKW1ljUOwlozJx4MHV1YqVNa4qxyH83dT1WOS/8%26%23xA%3bq%2bTNV17QI2YDWI3tLVJ1QkM9rFcyxyzrseJCip2xVPtN/Mvyjf8Ak%2b882C5a20vTRN%2bk0uEaO4tZ%26%23xA%3bbf8AvYJ4d2WVTtw77UrUYqw7TP8AnInQ59XFpqOj3WlWTSJE93NcWUstsZWCRm/s4JpLm0VnZVrI%26%23xA%3bnwsQDTFXq9xPDbwSXE7iOGFWklkbYKqirE/IDFWE235w%2bWru3iurPTNfurS4RZbe5g0PVJIpY3HJ%26%23xA%3bJI3WCjKymoI6jFVT/lbGi/8AVk8x/wDcA1X/ALJ8VROk/mb5d1HWbTRjb6np9/f%2bp9RTUtNvbFZm%26%23xA%3bhQySJG9xFGrMsalqV6DFWSX2o6fYRLLfXUNpEzcVknkWNS1K0BYgVoMVYH5q/OTT9K1230TRLFfM%26%23xA%3bN7JatezNBf2FrDFEJPSAMtzNGrOW/ZG9N8VSHzF%2bf2seXdAfzBqvki5j0eOVbd7yDU9MulEr/ZSl%26%23xA%3bvNK1foxV6B5K83S%2bZLO/a50ybR9R0u8aw1DT55IZmjmWKOccZIGkjcGKdDUHrt2xVkWKvFfyq/Jf%26%23xA%3b8rNX/Lby1qmp%2bW7S71G9063nu7mQMXkldAWdjy6k4qmep/lj/wA45aZqcGlX%2bj6RBqt0pa105n/0%26%23xA%3bmWnaOHnzcnooAqT0xV5f5Kh/J/zH%2bYyaWPJmnJ5d1JTb6Y3F/VSZY5LmCZ2qNrqFJFKHeOSIr81U%26%23xA%3bx1c3lz/zjb%2bXEMen/pyW41DTYTpEknBbxR63G3dydlbio36Yqlf%2bE9d/9h8sf%2b4jH/XFXf4T13/2%26%23xA%3bHyx/7iMf9cVbsND1aw81eVbif8prbybH%2bnLBTrUF4szrylp6XBTWknQ4q9P8z%2bTE85ecfzB0U3TW%26%23xA%3bdzd%2bXdIsba9A5GJJ7i%2bkdeNR8DvCvNQRUYqwDVPyKbyj5f0P67rt2b2%2b83aewg0maaxsbZb64SBz%26%23xA%3bbQqx4yrGSFkrUVoPdVLfzK/I%2bztvPZs21a6FrrUVzqWn3txO2o3KPZWR%2buxXFvcyD1vVRAY5%2bXwn%26%23xA%3b4WBFMVT2z0HUNH/5xv8ANmvsfq3%2bIdJtZNPtlf1Hi02GyhtLUTScV5TSQLykoKCtAABTFWQfmj%2bR%26%23xA%3bfmrzL5y0LVPLmr2%2bk6XpNva21uGedJ7AW0pZpLKNFeFy8ZCnnxPwgcqVGKpBcfk1c655o/Mfy3B5%26%23xA%3bo1iS4FppN5BLdXSrFPeTpMVa8S2jhWRR9VjUELUDfcgYqwTy5%2bWSavPptrp07rcecpNYtJ4p2jmS%26%23xA%3bwis7mBdSk%2btjlLel%2bIFuDxAryJJqSq%2bm/wAzPNWm6J5dmtJ4rm61DWYriy0zT7G3kurmeYwO7BIo%26%23xA%3bgzURFLMewxV806D5f/My20LTrc%2bbvPemGG1hjOmweW9SkituEaj0I3FwgZI6cVPEVA6DFUd%2bh/zL%26%23xA%3b/wCp8/MD/wAJnUv%2byrFU58gaRrq/mV5G1W%2b876n5nh/SOq2EumatZzWM9ldQ6VM7iSKaaZlco6ml%26%23xA%3bBsRir1D8wtF0fWvzW8hafrFjb6lYPZ65I1peRJPCXRbPixjkDLVamhpirzS2fyq/51toL%2bXvJJ8t%26%23xA%3btOdMTTVsY/XE6k1f639T%2brtc%2bNv6vT4ftfEVUq/P/RdH0Xy5590/R7G302wS68vyLaWcSQQh3S45%26%23xA%3bMI4wq1agqaYq93/Lr/jtefv/AAI2/wC6Vp%2bKs1xV4h5W/Jvyn58/LHyPfa1NfxT2miW9vF9TunhT%26%23xA%3biycqmP4k5AnrTfvUAYqiLf8A5xi8t6frdpe6Vqt3Fp1vdW2oy6bcBJ2lu7Fna3b62w9eNBz4sqdR%26%23xA%3b774qwn8uPIPmi0/New0jVrch9ElGqXtzGCIvSjF8Y5EcE1W5vdUm9JCQ/pRVZR0xVPvL/wD5Jr8n%26%23xA%3bv%2b27pX/Ep8VTLUP%2bhq7nzXeQ6adJsfL0l9dpYXVysMjR2aPIbaSVY2eQ%2boioNgWq3xAb0VSX8x/L%26%23xA%3bX/OT0/laZLnVrLVbISRtfadoAktNQmgDfvEilaPuOoFSfA9Cq15G0nz1pn5faBD5sW7hD%2bcbCTRr%26%23xA%3bTUZfWvILEzLwjmeimvLlsQPkBQYq9GW4uLf8wvzAuLZlS5h0HSJIHcqFDqdTKli9FpUd9sVYNa%2bY%26%23xA%3bvM3mH8qvI%2bqeZbm3u9Xl836Us09o9vJEVTVAqUa1Z4dlArQ/PFUT5%2bLf8r0b0VBJ8n6j9aNqKyCP%26%23xA%3b4uH10y/AIuf916Px8/tfBiqI8zf%2bsjw/%2bArp/wD1DQ4q9iOo6epcNcxAx7SAuvwmtPi3232xV5lD%26%23xA%3bJay%2be/zVd5IDatoekl5J2cW/D6vf8jK8R5iOn2ihrTpvirC/ydjnQ/k8swlA/RnmMxeqIwDGXtSh%26%23xA%3bi4Ub0yN19T4/HFWffmneXVj538gXlpZvqF1bXGsSwWETKrzumj3DLErPRQXIpU4qwDVPz5/MoaTb%26%23xA%3byz2Wn6ELyS3guryWy1svpqXMio8831qyt7NvQ5Vb98QT05Yqsuvzl/MLQNQvNNsLlfPa2eo6dDHd%26%23xA%3bRw2qSTre/WUe0rYloeTLAs0TUDKD8Y7Yqm3kXQ/Mmr/mrqOppZRW%2biaD5o1O9urqScGc3F3o8Fr9%26%23xA%3bWWBFYfB6iuZPUodx23VZx5r/APJy%2bQP%2bYHXv%2bI2WKvKbLRNSH5ir%2bW4Sw/Q1hr63P6c9E/pRolX/%26%23xA%3bABClsT9igkl4epWtP2cVQv8Azkt/xy/P/wDxn8u/8QucVe1fl1/x2vP3/gRt/wB0rT8VZrirBLL8%26%23xA%3bmvLFjaRWdjqWv2lnbqI7e1g1zU44o0XZURFnCqo7AYqrf8qn0X/q9%2bY/%2b4/qv/ZRirv%2bVT6L/wBX%26%23xA%3bvzH/ANx/Vf8AsoxVF3H5ZeUZvKmmeVxBPBpWjvFNpn1e5nhnhlgr6ciTxusvIcjvyxVCf8qn0X/q%26%23xA%3b9%2bY/%2b4/qv/ZRirv%2bVT6L/wBXvzH/ANx/Vf8AsoxVdB%2bVHlyO%2bs7ye%2b1m%2bawuI7u2hvtX1C6hE0J5%26%23xA%3bRuYppnRip6VGKpH5ltvOdj518x3Wn%2bVLnXtJ8waVYWJubW9sbVo2tzeCUcbqRGrxuloeNMVYfovk%26%23xA%3b3znp/lzyt5N0zyVqVlpGk%2bYLDVZ9S1HU9KuHSGG9FzOWW2kQtQE0CpX54qy780/y483azr1r5l8s%26%23xA%3bXtq%2bow2NxpAsNTQmC3hv/wB3NeWzR8Ss6qfiD8gyim3Qqp15n/LuS9/KGbyBpVyqsulw6XaXVzWl%26%23xA%3bLdEjV5OAPUR70GKvL73/AJx782Xt1rt1cab5aabzHI0urMLnWB6jvcC6JUB/g/eqD8PyxVmn5Xfl%26%23xA%3bX5h8sr5gj1G4s7KLU7Cx07Tho7zu1slmtyvqB7xXJf8A0kFSeQqNxiqE/LD8ofMXljX7BdUubWXQ%26%23xA%3b/K1tdW/lyS0Rkmum1OQSXM96HL0kURItFND126Yqyrz95e8x3mteVvMGg29te3Xl26uZpNPup2tF%26%23xA%3bmS6s5bU8ZliuOJQyBqcN/bFVO41f81biCS3uPJejzQSqUlik1uRkZWFCrKdNIII7YqhdNb8wdLt1%26%23xA%3bt9M/L/QbG3VzKsNtq5hQOw4lwqaYo5EGlcVTL8tvLuvaRBr93rkVvb32vaxPqps7WZrhIEkghgWP%26%23xA%3b1mjg5n/R%2bVeA64qgPzB03zVF5v8AKvmnQtHbXV0eLUra70%2bK4gtpqX6wcJFa5aOMqptyG%2bKu4oOt%26%23xA%3bFWFRaR54j/Mybz4PIOrm4mQE6Z%2bldH%2bri5%2brraG4/v8AlX6ugTj06nFVa/8Aye1H8y9U17UfOseq%26%23xA%3beVdPv/qSQaLa3ljKZjZo/wC%2bmKR3SbGSiUYHrUdMVeo%2bUPKFl5Ysbm2gu7rULi%2buWvL/AFC/kWW4%26%23xA%3bnnZEi5uUWJNo4kQBUGw8anFU9xV2KuxV2KuxVbLLHFE8srBI41LO7GgCgVJJ9sVYj5F/NryD56ub%26%23xA%3b618s6mL2fT6G4jMcsLcGJUSIJVTktR1H09RirMMVdirFvzA/Mzyf5B063v8AzLeG2iupPRto40aW%26%23xA%3bSRgKtxRATRR1PT6SMVT3RtY03WtKtNW0ydbnT76JJ7WdagPG4qpoaEfI4qjMVdirsVdirsVdirsV%26%23xA%3bdirsVdirsVdirsVdirsVdirG/wAxPM%2bq%2bWPKF/rWlaPPrt/bKPQ0%2b2FWZmIXkwFXKJWrcATT7wq8%26%23xA%3bKMfm%2bTXdK1f84/P6eX5L2aM6f5GsCx5rK3BY7iKEkcSW4lnD/wCU43GKvJPyb0rRbfTvNSa95on8%26%23xA%3bl3H1mx02y1m3WXmtzyuJmjLR8GVP9GBYl17b4q%2bgvy88yfnR5e81aX5Y80Rr5z8s6upOlecNOKuE%26%23xA%3bjVeXOeQUUrxpXnuf2Wfpir3LFXzp/wA5s6YZfImhakFqbTUzASB0W4gdvDpWAYq9j/K3TBpf5a%2bV%26%23xA%3brDjxaDSrMSD/AIsMCtIfpcnFWUYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq8X/MX8sb%26%23xA%3bLQNS1P8AMDy15T/xl5y1K5gEVpqMvrW9oSOJnihcgtRgu3L4OqlFBxVh%2bifl15j0vU9V0nUPIMPm%26%23xA%3bDy75o803/wBc%2btMiPZ2PGM2t1FKp%2bD4ZpviUDdKAqWWqr3L8vPy%2b0LyF5dGgaI9w9iJ5bgG6lMrh%26%23xA%3bpmrxHRVUAAAKB4n4iSVWTYq8y/5yL8l6p5v/ACwu9K0m3a61Jbq0mtoUALEidY3IrT7McjMdxsMV%26%23xA%3belQQxwQRwxDjHEoRB4KooMVX4q7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYqsuI3lgkjSR%26%23xA%3bondWVZVpyQkUDCtRUdd8VeZ/kn%2bS93%2bWh1o3HmKTXzq/1biZIGg9H6t6taVmuOXP1vbp3xV6firs%26%23xA%3bVed/nR%2bU11%2bZGkafp8GvzaD9RuGuGaOH11l5IUAZRJAarXY8u528FWa6BpbaToWm6U0xuWsLWG1a%26%23xA%3b4I4mQwxrHzK1anLjWlTiqPxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2K%26%23xA%3buxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KpXqfmny5pen3Go3%2bp21vZWsbS3EzSrRUUVJ2JJ9gN%26%23xA%3bzirD7f8AOe2uoI7m18n%2baZ7aZRJBMmmHi6MKq61kBow3GKp1pH5o%2bQ9T0S21gaza2NtcTfVfS1CW%26%23xA%3bO0mjuhUNayxyspWZSp%2bDr3FRvirKI5I5EEkbB0bdWUggj2IxVdirsVdirsVdirsVdirsVdirsVdi%26%23xA%3brsVdirsVdirsVdirsVdir5r8n%2bRNF8v/AJdad%2bZOpw6Tf6JZeX4bw%2bX30TTzPJdrbrxlOpFGuCzz%26%23xA%3bfFuO/tiqHuvMX5zT2OseapdT1JbPQLiWDVp7CWxitreW2I%2btLBpc1vK9zFZtyV2kuVaSlRSmKvTP%26%23xA%3by%2b0nyV580WfWPMflTRLrzJbXc9hrV39Qt5VmubYhfWSSVGdkkjKOOR2rTtiqY/kD/wCSa8p/8wK/%26%23xA%3b8SbFWf4q7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq8K8meefyi1L8j9J8o6/5n06%26%23xA%3b2NzosdjfwPcxpNEzQ8Tsx2dG3Fe4xV5ZcXSwtqeijzXpV9p2sTevqdxBr0Fnpt9KaVnvLQwSXcbS%26%23xA%3b8QbhIJaSGoBXrir278vfPX5R%2bU/Lo0%2bbzxpV7qN1PNf6rei4hjWa7uX5ysqA0RBsqL2UDFU7/IH/%26%23xA%3bAMk15T/5gV/4k2Ks/wAVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVf/Z%3c/xmpGImg:image%3e %3c/rdf:li%3e %3c/rdf:Alt%3e %3c/xmp:Thumbnails%3e %3cxmpMM:OriginalDocumentID%3euuid:9E3E5C9A8C81DB118734DB58FDDE4BA7%3c/xmpMM:OriginalDocumentID%3e %3cxmpMM:DocumentID%3exmp.did:9bb40803-0a68-4b6d-b079-70a423632dc7%3c/xmpMM:DocumentID%3e %3cxmpMM:InstanceID%3exmp.iid:9bb40803-0a68-4b6d-b079-70a423632dc7%3c/xmpMM:InstanceID%3e %3cxmpMM:RenditionClass%3eproof:pdf%3c/xmpMM:RenditionClass%3e %3cxmpMM:DerivedFrom rdf:parseType='Resource'%3e %3cstRef:instanceID%3euuid:3790e011-2e1b-2f40-a3d6-4e538a02edb2%3c/stRef:instanceID%3e %3cstRef:documentID%3exmp.did:525ac691-adef-4d04-bc72-b632c8732463%3c/stRef:documentID%3e %3cstRef:originalDocumentID%3euuid:9E3E5C9A8C81DB118734DB58FDDE4BA7%3c/stRef:originalDocumentID%3e %3cstRef:renditionClass%3eproof:pdf%3c/stRef:renditionClass%3e %3c/xmpMM:DerivedFrom%3e %3cxmpMM:History%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cstEvt:action%3esaved%3c/stEvt:action%3e %3cstEvt:instanceID%3exmp.iid:78fa4c27-1810-4112-abf8-25d31ae36cdc%3c/stEvt:instanceID%3e %3cstEvt:when%3e2019-06-10T14:32:07%2b02:00%3c/stEvt:when%3e %3cstEvt:softwareAgent%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/stEvt:softwareAgent%3e %3cstEvt:changed%3e/%3c/stEvt:changed%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cstEvt:action%3esaved%3c/stEvt:action%3e %3cstEvt:instanceID%3exmp.iid:9bb40803-0a68-4b6d-b079-70a423632dc7%3c/stEvt:instanceID%3e %3cstEvt:when%3e2019-06-14T11:08:35%2b02:00%3c/stEvt:when%3e %3cstEvt:softwareAgent%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/stEvt:softwareAgent%3e %3cstEvt:changed%3e/%3c/stEvt:changed%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpMM:History%3e %3cillustrator:StartupProfile%3eBasic RGB%3c/illustrator:StartupProfile%3e %3cxmpTPg:NPages%3e1%3c/xmpTPg:NPages%3e %3cxmpTPg:HasVisibleTransparency%3eFalse%3c/xmpTPg:HasVisibleTransparency%3e %3cxmpTPg:HasVisibleOverprint%3eFalse%3c/xmpTPg:HasVisibleOverprint%3e %3cxmpTPg:MaxPageSize rdf:parseType='Resource'%3e %3cstDim:w%3e440.000000%3c/stDim:w%3e %3cstDim:h%3e440.000000%3c/stDim:h%3e %3cstDim:unit%3ePixels%3c/stDim:unit%3e %3c/xmpTPg:MaxPageSize%3e %3cxmpTPg:PlateNames%3e %3crdf:Seq%3e %3crdf:li%3eCyan%3c/rdf:li%3e %3crdf:li%3eMagenta%3c/rdf:li%3e %3crdf:li%3eYellow%3c/rdf:li%3e %3crdf:li%3eBlack%3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpTPg:PlateNames%3e %3cxmpTPg:SwatchGroups%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eDomy%c5%9blna grupa pr%c3%b3bek%3c/xmpG:groupName%3e %3cxmpG:groupType%3e0%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eBia%c5%82y%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eCzarny%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eCzerwony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3e%c5%bb%c3%b3%c5%82ty RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eZielony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eNiebieskozielony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eNiebieski RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eKarmazynowy RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=193 G=39 B=45%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e193%3c/xmpG:red%3e %3cxmpG:green%3e39%3c/xmpG:green%3e %3cxmpG:blue%3e45%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=237 G=28 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e237%3c/xmpG:red%3e %3cxmpG:green%3e28%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=241 G=90 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e241%3c/xmpG:red%3e %3cxmpG:green%3e90%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=247 G=147 B=30%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e247%3c/xmpG:red%3e %3cxmpG:green%3e147%3c/xmpG:green%3e %3cxmpG:blue%3e30%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=251 G=176 B=59%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e251%3c/xmpG:red%3e %3cxmpG:green%3e176%3c/xmpG:green%3e %3cxmpG:blue%3e59%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=252 G=238 B=33%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e252%3c/xmpG:red%3e %3cxmpG:green%3e238%3c/xmpG:green%3e %3cxmpG:blue%3e33%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=217 G=224 B=33%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e217%3c/xmpG:red%3e %3cxmpG:green%3e224%3c/xmpG:green%3e %3cxmpG:blue%3e33%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=140 G=198 B=63%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e140%3c/xmpG:red%3e %3cxmpG:green%3e198%3c/xmpG:green%3e %3cxmpG:blue%3e63%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=57 G=181 B=74%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e57%3c/xmpG:red%3e %3cxmpG:green%3e181%3c/xmpG:green%3e %3cxmpG:blue%3e74%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=146 B=69%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e146%3c/xmpG:green%3e %3cxmpG:blue%3e69%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=104 B=55%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e104%3c/xmpG:green%3e %3cxmpG:blue%3e55%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=34 G=181 B=115%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e34%3c/xmpG:red%3e %3cxmpG:green%3e181%3c/xmpG:green%3e %3cxmpG:blue%3e115%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=169 B=157%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e169%3c/xmpG:green%3e %3cxmpG:blue%3e157%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=41 G=171 B=226%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e41%3c/xmpG:red%3e %3cxmpG:green%3e171%3c/xmpG:green%3e %3cxmpG:blue%3e226%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=113 B=188%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e113%3c/xmpG:green%3e %3cxmpG:blue%3e188%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=46 G=49 B=146%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e46%3c/xmpG:red%3e %3cxmpG:green%3e49%3c/xmpG:green%3e %3cxmpG:blue%3e146%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=27 G=20 B=100%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e27%3c/xmpG:red%3e %3cxmpG:green%3e20%3c/xmpG:green%3e %3cxmpG:blue%3e100%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=102 G=45 B=145%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e102%3c/xmpG:red%3e %3cxmpG:green%3e45%3c/xmpG:green%3e %3cxmpG:blue%3e145%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=147 G=39 B=143%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e147%3c/xmpG:red%3e %3cxmpG:green%3e39%3c/xmpG:green%3e %3cxmpG:blue%3e143%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=158 G=0 B=93%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e158%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e93%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=212 G=20 B=90%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e212%3c/xmpG:red%3e %3cxmpG:green%3e20%3c/xmpG:green%3e %3cxmpG:blue%3e90%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=237 G=30 B=121%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e237%3c/xmpG:red%3e %3cxmpG:green%3e30%3c/xmpG:green%3e %3cxmpG:blue%3e121%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=199 G=178 B=153%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e199%3c/xmpG:red%3e %3cxmpG:green%3e178%3c/xmpG:green%3e %3cxmpG:blue%3e153%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=153 G=134 B=117%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e153%3c/xmpG:red%3e %3cxmpG:green%3e134%3c/xmpG:green%3e %3cxmpG:blue%3e117%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=115 G=99 B=87%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e115%3c/xmpG:red%3e %3cxmpG:green%3e99%3c/xmpG:green%3e %3cxmpG:blue%3e87%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=83 G=71 B=65%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e83%3c/xmpG:red%3e %3cxmpG:green%3e71%3c/xmpG:green%3e %3cxmpG:blue%3e65%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=198 G=156 B=109%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e198%3c/xmpG:red%3e %3cxmpG:green%3e156%3c/xmpG:green%3e %3cxmpG:blue%3e109%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=166 G=124 B=82%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e166%3c/xmpG:red%3e %3cxmpG:green%3e124%3c/xmpG:green%3e %3cxmpG:blue%3e82%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=140 G=98 B=57%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e140%3c/xmpG:red%3e %3cxmpG:green%3e98%3c/xmpG:green%3e %3cxmpG:blue%3e57%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=117 G=76 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e117%3c/xmpG:red%3e %3cxmpG:green%3e76%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=96 G=56 B=19%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e96%3c/xmpG:red%3e %3cxmpG:green%3e56%3c/xmpG:green%3e %3cxmpG:blue%3e19%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=66 G=33 B=11%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e66%3c/xmpG:red%3e %3cxmpG:green%3e33%3c/xmpG:green%3e %3cxmpG:blue%3e11%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eZimne%3c/xmpG:groupName%3e %3cxmpG:groupType%3e1%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=56 M=0 Y=20 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e101%3c/xmpG:red%3e %3cxmpG:green%3e200%3c/xmpG:green%3e %3cxmpG:blue%3e208%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=51 M=43 Y=0 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e131%3c/xmpG:red%3e %3cxmpG:green%3e139%3c/xmpG:green%3e %3cxmpG:blue%3e197%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=26 M=41 Y=0 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e186%3c/xmpG:red%3e %3cxmpG:green%3e155%3c/xmpG:green%3e %3cxmpG:blue%3e201%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eSzaro%c5%9bci%3c/xmpG:groupName%3e %3cxmpG:groupType%3e1%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=0 B=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=26 G=26 B=26%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e26%3c/xmpG:red%3e %3cxmpG:green%3e26%3c/xmpG:green%3e %3cxmpG:blue%3e26%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=51 G=51 B=51%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e51%3c/xmpG:red%3e %3cxmpG:green%3e51%3c/xmpG:green%3e %3cxmpG:blue%3e51%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=77 G=77 B=77%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e77%3c/xmpG:red%3e %3cxmpG:green%3e77%3c/xmpG:green%3e %3cxmpG:blue%3e77%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=102 G=102 B=102%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e102%3c/xmpG:red%3e %3cxmpG:green%3e102%3c/xmpG:green%3e %3cxmpG:blue%3e102%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=128 G=128 B=128%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e128%3c/xmpG:red%3e %3cxmpG:green%3e128%3c/xmpG:green%3e %3cxmpG:blue%3e128%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=153 G=153 B=153%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e153%3c/xmpG:red%3e %3cxmpG:green%3e153%3c/xmpG:green%3e %3cxmpG:blue%3e153%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=179 G=179 B=179%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e179%3c/xmpG:red%3e %3cxmpG:green%3e179%3c/xmpG:green%3e %3cxmpG:blue%3e179%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=204 G=204 B=204%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e204%3c/xmpG:red%3e %3cxmpG:green%3e204%3c/xmpG:green%3e %3cxmpG:blue%3e204%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=230 G=230 B=230%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e230%3c/xmpG:red%3e %3cxmpG:green%3e230%3c/xmpG:green%3e %3cxmpG:blue%3e230%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=242 G=242 B=242%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e242%3c/xmpG:red%3e %3cxmpG:green%3e242%3c/xmpG:green%3e %3cxmpG:blue%3e242%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpTPg:SwatchGroups%3e %3cpdf:Producer%3eAdobe PDF library 15.00%3c/pdf:Producer%3e %3c/rdf:Description%3e %3c/rdf:RDF%3e%3c/x:xmpmeta%3e %3c%3fxpacket end='w'%3f%3e %3c/metadata%3e%3cg id='Warstwa_1' class='st0'%3e %3cg class='st1'%3e %3cline class='st2' x1='0' y1='0' x2='0' y2='440'/%3e %3cline class='st2' x1='10' y1='0' x2='10' y2='440'/%3e %3cline class='st2' x1='20' y1='0' x2='20' y2='440'/%3e %3cline class='st2' x1='30' y1='0' x2='30' y2='440'/%3e %3cline class='st2' x1='40' y1='0' x2='40' y2='440'/%3e %3cline class='st2' x1='50' y1='0' x2='50' y2='440'/%3e %3cline class='st3' x1='60' y1='0' x2='60' y2='440'/%3e %3cline class='st2' x1='70' y1='0' x2='70' y2='440'/%3e %3cline class='st2' x1='80' y1='0' x2='80' y2='440'/%3e %3cline class='st2' x1='90' y1='0' x2='90' y2='440'/%3e %3cline class='st2' x1='100' y1='0' x2='100' y2='440'/%3e %3cline class='st2' x1='110' y1='0' x2='110' y2='440'/%3e %3cline class='st2' x1='120' y1='0' x2='120' y2='440'/%3e %3cline class='st2' x1='130' y1='0' x2='130' y2='440'/%3e %3cline class='st2' x1='140' y1='0' x2='140' y2='440'/%3e %3cline class='st2' x1='150' y1='0' x2='150' y2='440'/%3e %3cline class='st2' x1='160' y1='0' x2='160' y2='440'/%3e %3cline class='st2' x1='170' y1='0' x2='170' y2='440'/%3e %3cline class='st2' x1='180' y1='0' x2='180' y2='440'/%3e %3cline class='st2' x1='190' y1='0' x2='190' y2='440'/%3e %3cline class='st2' x1='200' y1='0' x2='200' y2='440'/%3e %3cline class='st2' x1='210' y1='0' x2='210' y2='440'/%3e %3cline class='st3' x1='220' y1='0' x2='220' y2='440'/%3e %3cline class='st2' x1='230' y1='0' x2='230' y2='440'/%3e %3cline class='st2' x1='240' y1='0' x2='240' y2='440'/%3e %3cline class='st2' x1='250' y1='0' x2='250' y2='440'/%3e %3cline class='st2' x1='260' y1='0' x2='260' y2='440'/%3e %3cline class='st2' x1='270' y1='0' x2='270' y2='440'/%3e %3cline class='st2' x1='280' y1='0' x2='280' y2='440'/%3e %3cline class='st2' x1='290' y1='0' x2='290' y2='440'/%3e %3cline class='st2' x1='300' y1='0' x2='300' y2='440'/%3e %3cline class='st2' x1='310' y1='0' x2='310' y2='440'/%3e %3cline class='st2' x1='320' y1='0' x2='320' y2='440'/%3e %3cline class='st2' x1='330' y1='0' x2='330' y2='440'/%3e %3cline class='st2' x1='340' y1='0' x2='340' y2='440'/%3e %3cline class='st2' x1='350' y1='0' x2='350' y2='440'/%3e %3cline class='st2' x1='360' y1='0' x2='360' y2='440'/%3e %3cline class='st2' x1='370' y1='0' x2='370' y2='440'/%3e %3cline class='st3' x1='380' y1='0' x2='380' y2='440'/%3e %3cline class='st2' x1='390' y1='0' x2='390' y2='440'/%3e %3cline class='st2' x1='400' y1='0' x2='400' y2='440'/%3e %3cline class='st2' x1='410' y1='0' x2='410' y2='440'/%3e %3cline class='st2' x1='420' y1='0' x2='420' y2='440'/%3e %3cline class='st2' x1='430' y1='0' x2='430' y2='440'/%3e %3cline class='st2' x1='440' y1='0' x2='440' y2='440'/%3e %3c/g%3e %3cg class='st1'%3e %3cline class='st2' x1='440' y1='0' x2='0' y2='0'/%3e %3cline class='st2' x1='440' y1='10' x2='0' y2='10'/%3e %3cline class='st2' x1='440' y1='20' x2='0' y2='20'/%3e %3cline class='st2' x1='440' y1='30' x2='0' y2='30'/%3e %3cline class='st2' x1='440' y1='40' x2='0' y2='40'/%3e %3cline class='st2' x1='440' y1='50' x2='0' y2='50'/%3e %3cline class='st3' x1='440' y1='60' x2='0' y2='60'/%3e %3cline class='st2' x1='440' y1='70' x2='0' y2='70'/%3e %3cline class='st2' x1='440' y1='80' x2='0' y2='80'/%3e %3cline class='st2' x1='440' y1='90' x2='0' y2='90'/%3e %3cline class='st2' x1='440' y1='100' x2='0' y2='100'/%3e %3cline class='st2' x1='440' y1='110' x2='0' y2='110'/%3e %3cline class='st2' x1='440' y1='120' x2='0' y2='120'/%3e %3cline class='st2' x1='440' y1='130' x2='0' y2='130'/%3e %3cline class='st2' x1='440' y1='140' x2='0' y2='140'/%3e %3cline class='st2' x1='440' y1='150' x2='0' y2='150'/%3e %3cline class='st2' x1='440' y1='160' x2='0' y2='160'/%3e %3cline class='st2' x1='440' y1='170' x2='0' y2='170'/%3e %3cline class='st2' x1='440' y1='180' x2='0' y2='180'/%3e %3cline class='st2' x1='440' y1='190' x2='0' y2='190'/%3e %3cline class='st2' x1='440' y1='200' x2='0' y2='200'/%3e %3cline class='st2' x1='440' y1='210' x2='0' y2='210'/%3e %3cline class='st3' x1='440' y1='220' x2='0' y2='220'/%3e %3cline class='st2' x1='440' y1='230' x2='0' y2='230'/%3e %3cline class='st2' x1='440' y1='240' x2='0' y2='240'/%3e %3cline class='st2' x1='440' y1='250' x2='0' y2='250'/%3e %3cline class='st2' x1='440' y1='260' x2='0' y2='260'/%3e %3cline class='st2' x1='440' y1='270' x2='0' y2='270'/%3e %3cline class='st2' x1='440' y1='280' x2='0' y2='280'/%3e %3cline class='st2' x1='440' y1='290' x2='0' y2='290'/%3e %3cline class='st2' x1='440' y1='300' x2='0' y2='300'/%3e %3cline class='st2' x1='440' y1='310' x2='0' y2='310'/%3e %3cline class='st2' x1='440' y1='320' x2='0' y2='320'/%3e %3cline class='st2' x1='440' y1='330' x2='0' y2='330'/%3e %3cline class='st2' x1='440' y1='340' x2='0' y2='340'/%3e %3cline class='st2' x1='440' y1='350' x2='0' y2='350'/%3e %3cline class='st2' x1='440' y1='360' x2='0' y2='360'/%3e %3cline class='st2' x1='440' y1='370' x2='0' y2='370'/%3e %3cline class='st3' x1='440' y1='380' x2='0' y2='380'/%3e %3cline class='st2' x1='440' y1='390' x2='0' y2='390'/%3e %3cline class='st2' x1='440' y1='400' x2='0' y2='400'/%3e %3cline class='st2' x1='440' y1='410' x2='0' y2='410'/%3e %3cline class='st2' x1='440' y1='420' x2='0' y2='420'/%3e %3cline class='st2' x1='440' y1='430' x2='0' y2='430'/%3e %3cline class='st2' x1='440' y1='440' x2='0' y2='440'/%3e %3c/g%3e%3c/g%3e%3cg id='Warstwa_2' class='st0'%3e %3ccircle class='st4' cx='220' cy='220' r='100'/%3e %3ccircle class='st4' cx='220' cy='220' r='40'/%3e %3ccircle class='st4' cx='220' cy='220' r='160'/%3e %3ccircle class='st4' cx='220' cy='220' r='220'/%3e%3c/g%3e%3cg id='Warstwa_3'%3e %3cg%3e %3cpolygon points='280%2c10 280%2c50 130%2c50 130%2c160 160%2c160 160%2c80 280%2c80 280%2c360 160%2c360 160%2c280 130%2c280 130%2c390 280%2c390 280%2c430.31 409.27%2c380 410%2c60 '/%3e %3cpolygon points='200%2c180 110%2c180 110%2c120 30%2c220 110%2c320 110%2c260 240%2c260 '/%3e %3c/g%3e%3c/g%3e%3c/svg%3e";

var img$C = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='2 2 12 12' style='transform: rotate(180deg)%3b'%3e %3cpath d='M 16 16 H 0 V 0 h 16 v 16 z' fill='none'/%3e %3cpath d='M 12.6 4.6 L 8 9.2 L 3.4 4.6 L 2 6 l 6 6 l 6 -6 l -1.4 -1.4 z' /%3e%3c/svg%3e";

var img$B = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 24.0.3%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 13.4 13.4' style='enable-background:new 0 0 13.4 13.4%3b' xml:space='preserve'%3e%3ctitle%3eF%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cg id='Check-Out-Horizontal'%3e %3cpath id='F' d='M13.4%2c13.4v-1.3l0%2c0h-1.3V0H3.6l0%2c0v3.6h1.3l0%2c0V1.3h6.2l0%2c0v10.9H9.8l0%2c0V4.9H1.3l0%2c0v7.3H0l0%2c0v1.3l0%2c0H13.4z M7.3%2c3.6V2.4H6.2l0%2c0v1.3H7.3L7.3%2c3.6z M9.8%2c3.6V2.4H8.5l0%2c0v1.3H9.8L9.8%2c3.6z M3.6%2c12.2H2.4v-6l0%2c0h6.2v6l0%2c0H4.9V9.8l0%2c0H3.6 V12.2L3.6%2c12.2z M4.9%2c8.5V7.3H3.6l0%2c0v1.3H4.9L4.9%2c8.5z M7.3%2c8.5V7.3H6.2l0%2c0v1.3H7.3L7.3%2c8.5z M7.3%2c11.1V9.8H6.2l0%2c0v1.3H7.3 L7.3%2c11.1z'/%3e%3c/g%3e%3c/svg%3e";

var img$A = "data:image/svg+xml,%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 440 440'%3e %3cg id='Warstwa_3'%3e %3cg%3e %3cg%3e %3cpath d='M352.55%2c96.2L352.55%2c96.2l64.18-64.18l-21.21-21.21l-62.67%2c62.67c-26.64-25.12-62.53-40.52-102.04-40.52 c-52.23%2c0-98.17%2c26.91-124.71%2c67.62c-6.36%2c9.75-11.58%2c20.3-15.54%2c31.45c-26.99%2c5.29-50.11%2c21.41-64.61%2c43.66 c-10.25%2c15.71-16.2%2c34.48-16.2%2c54.64c0%2c45.01%2c29.68%2c83.07%2c70.54%2c95.71l-56.97%2c56.97l21.21%2c21.21l192.14-192.14L352.55%2c96.2z'%3e %3c/path%3e %3c/g%3e %3cg%3e %3cpath d='M379.19%2c192.67c0.26-3.62%2c0.4-7.27%2c0.4-10.95c0-15.51-2.38-30.47-6.78-44.53L179.5%2c330.5h184.34v-0.11 c37.01-1.99%2c66.41-32.63%2c66.41-70.14C430.25%2c228.11%2c408.65%2c201.03%2c379.19%2c192.67z'%3e %3c/path%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$z = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 23.1.1%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 22 22' style='enable-background:new 0 0 22 22%3b' xml:space='preserve'%3e%3cg%3e %3cpath d='M13.4%2c5.7c1.5%2c1.5%2c2.5%2c2.5%2c3%2c3C10.2%2c14.8%2c6.1%2c19%2c4%2c21c-2%2c0.5-3.4%2c0.9-4%2c1l1-4C7.2%2c11.8%2c11.3%2c7.7%2c13.4%2c5.7z M19.2%2c5.9c1.4-1.4%2c2.4-2.4%2c2.9-2.9c-1.5-1.5-2.5-2.5-3-3c-1.4%2c1.4-2.4%2c2.4-2.9%2c2.9L19.2%2c5.9z'/%3e%3c/g%3e%3c/svg%3e";

var img$y = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='iso-8859-1'%3f%3e%3c!-- Generator: Adobe Illustrator 19.1.0%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 483.3 483.3' style='enable-background:new 0 0 483.3 483.3%3b' xml:space='preserve'%3e%3cg%3e %3cg%3e %3cpath d='M424.3%2c57.75H59.1c-32.6%2c0-59.1%2c26.5-59.1%2c59.1v249.6c0%2c32.6%2c26.5%2c59.1%2c59.1%2c59.1h365.1c32.6%2c0%2c59.1-26.5%2c59.1-59.1 v-249.5C483.4%2c84.35%2c456.9%2c57.75%2c424.3%2c57.75z M456.4%2c366.45c0%2c17.7-14.4%2c32.1-32.1%2c32.1H59.1c-17.7%2c0-32.1-14.4-32.1-32.1v-249.5 c0-17.7%2c14.4-32.1%2c32.1-32.1h365.1c17.7%2c0%2c32.1%2c14.4%2c32.1%2c32.1v249.5H456.4z'/%3e %3cpath d='M304.8%2c238.55l118.2-106c5.5-5%2c6-13.5%2c1-19.1c-5-5.5-13.5-6-19.1-1l-163%2c146.3l-31.8-28.4c-0.1-0.1-0.2-0.2-0.2-0.3 c-0.7-0.7-1.4-1.3-2.2-1.9L78.3%2c112.35c-5.6-5-14.1-4.5-19.1%2c1.1c-5%2c5.6-4.5%2c14.1%2c1.1%2c19.1l119.6%2c106.9L60.8%2c350.95 c-5.4%2c5.1-5.7%2c13.6-0.6%2c19.1c2.7%2c2.8%2c6.3%2c4.3%2c9.9%2c4.3c3.3%2c0%2c6.6-1.2%2c9.2-3.6l120.9-113.1l32.8%2c29.3c2.6%2c2.3%2c5.8%2c3.4%2c9%2c3.4 c3.2%2c0%2c6.5-1.2%2c9-3.5l33.7-30.2l120.2%2c114.2c2.6%2c2.5%2c6%2c3.7%2c9.3%2c3.7c3.6%2c0%2c7.1-1.4%2c9.8-4.2c5.1-5.4%2c4.9-14-0.5-19.1L304.8%2c238.55z' /%3e %3c/g%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3c/svg%3e";

var img$x = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 23.0.4%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 440 440' style='enable-background:new 0 0 440 440%3b' xml:space='preserve'%3e%3cstyle type='text/css'%3e .st0%7bdisplay:none%3b%7d .st1%7bdisplay:inline%3b%7d .st2%7bfill:none%3bstroke:grey%3bstroke-miterlimit:10%3b%7d .st3%7bfill:none%3bstroke:%23C1272D%3bstroke-miterlimit:10%3b%7d .st4%7bdisplay:inline%3bfill:none%3bstroke:%23C1272D%3bstroke-miterlimit:10%3b%7d%3c/style%3e%3cmetadata%3e%3c%3fxpacket begin=' ' id='W5M0MpCehiHzreSzNTczkc9d'%3f%3e%3cx:xmpmeta xmlns:x='adobe:ns:meta/' x:xmptk='Adobe XMP Core 5.6-c145 79.163499%2c 2018/08/13-16:40:22 '%3e %3crdf:RDF xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%3e %3crdf:Description rdf:about='' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:xmp='http://ns.adobe.com/xap/1.0/' xmlns:xmpGImg='http://ns.adobe.com/xap/1.0/g/img/' xmlns:xmpMM='http://ns.adobe.com/xap/1.0/mm/' xmlns:stRef='http://ns.adobe.com/xap/1.0/sType/ResourceRef%23' xmlns:stEvt='http://ns.adobe.com/xap/1.0/sType/ResourceEvent%23' xmlns:illustrator='http://ns.adobe.com/illustrator/1.0/' xmlns:xmpTPg='http://ns.adobe.com/xap/1.0/t/pg/' xmlns:stDim='http://ns.adobe.com/xap/1.0/sType/Dimensions%23' xmlns:xmpG='http://ns.adobe.com/xap/1.0/g/' xmlns:pdf='http://ns.adobe.com/pdf/1.3/'%3e %3cdc:format%3eimage/svg%2bxml%3c/dc:format%3e %3cdc:title%3e %3crdf:Alt%3e %3crdf:li xml:lang='x-default'%3eIcons%3c/rdf:li%3e %3c/rdf:Alt%3e %3c/dc:title%3e %3cxmp:CreatorTool%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/xmp:CreatorTool%3e %3cxmp:CreateDate%3e2019-06-14T11:08:35%2b02:00%3c/xmp:CreateDate%3e %3cxmp:ModifyDate%3e2019-06-14T11:08:35%2b02:00%3c/xmp:ModifyDate%3e %3cxmp:MetadataDate%3e2019-06-14T11:08:35%2b02:00%3c/xmp:MetadataDate%3e %3cxmp:Thumbnails%3e %3crdf:Alt%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpGImg:width%3e180%3c/xmpGImg:width%3e %3cxmpGImg:height%3e256%3c/xmpGImg:height%3e %3cxmpGImg:format%3eJPEG%3c/xmpGImg:format%3e %3cxmpGImg:image%3e/9j/4AAQSkZJRgABAgEASABIAAD/7QAsUGhvdG9zaG9wIDMuMAA4QklNA%2b0AAAAAABAASAAAAAEA%26%23xA%3bAQBIAAAAAQAB/%2b4ADkFkb2JlAGTAAAAAAf/bAIQABgQEBAUEBgUFBgkGBQYJCwgGBggLDAoKCwoK%26%23xA%3bDBAMDAwMDAwQDA4PEA8ODBMTFBQTExwbGxscHx8fHx8fHx8fHwEHBwcNDA0YEBAYGhURFRofHx8f%26%23xA%3bHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8f/8AAEQgBAAC0AwER%26%23xA%3bAAIRAQMRAf/EAaIAAAAHAQEBAQEAAAAAAAAAAAQFAwIGAQAHCAkKCwEAAgIDAQEBAQEAAAAAAAAA%26%23xA%3bAQACAwQFBgcICQoLEAACAQMDAgQCBgcDBAIGAnMBAgMRBAAFIRIxQVEGE2EicYEUMpGhBxWxQiPB%26%23xA%3bUtHhMxZi8CRygvElQzRTkqKyY3PCNUQnk6OzNhdUZHTD0uIIJoMJChgZhJRFRqS0VtNVKBry4/PE%26%23xA%3b1OT0ZXWFlaW1xdXl9WZ2hpamtsbW5vY3R1dnd4eXp7fH1%2bf3OEhYaHiImKi4yNjo%2bCk5SVlpeYmZ%26%23xA%3bqbnJ2en5KjpKWmp6ipqqusra6voRAAICAQIDBQUEBQYECAMDbQEAAhEDBCESMUEFURNhIgZxgZEy%26%23xA%3bobHwFMHR4SNCFVJicvEzJDRDghaSUyWiY7LCB3PSNeJEgxdUkwgJChgZJjZFGidkdFU38qOzwygp%26%23xA%3b0%2bPzhJSktMTU5PRldYWVpbXF1eX1RlZmdoaWprbG1ub2R1dnd4eXp7fH1%2bf3OEhYaHiImKi4yNjo%26%23xA%3b%2bDlJWWl5iZmpucnZ6fkqOkpaanqKmqq6ytrq%2bv/aAAwDAQACEQMRAD8A9TTTwQJ6k0ixJ05OQoqf%26%23xA%3bc4q%2bevyy0P8AKe41O38n%2ba/LVg3m%2b9jvtVinvYI2kuY31W9VY6sK80ghR1Fd0NRsuKs01T8v/JHl%26%23xA%3br8wfIF1oGh2Wl3M2pXsUs1rCkTMn6HvG4kqBtUA4q9UxV4x%2baHmPy55y8xWHkeCBdUTQtb0q48xK%26%23xA%3bwV4EikM6yRuD19NR%2b87CoHWtFWYRfkz%2bT0qCSLynpEkbfZdbaIg/IgYql35IadY6bY%2bbrCwgS1sr%26%23xA%3bXzPqUVvbxKFSNFEQVVUbAAYq9IxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KvIv%2bcgvyp87%26%23xA%3bfmTY6ZpOjalZ6fpNpI1zeR3Jl5zT04x7Ro44opbv1Ptir50/Ln8hPMl9%2bY%2bjw6bqwbTbZBql1r9i%26%23xA%3bJYvq6297PaemnrIjeu09k4TalPi3AOKvrPzt/wApv%2bXn/bVvf%2b6Ne4qzG5hM9vLCsrwmVGQTREB0%26%23xA%3bLCnJCwYch1FRir4R1j/nHXzTbee7/QdS1WG3aS7totN1S7WdxfnUXlELgxrKVasLCTkfhbudiVX1%26%23xA%3bL%2bQv5decvy%2b8sXPl3X9QtNQsknM%2bltamUmIS1M0bCRE%2bHn8a07s2Ko38of8Aptf/AAK9T/5lYq9A%26%23xA%3bxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV5l5V8ofmp5W0kaPpl5oM1nHPdTQy3MF4Zi%26%23xA%3bt1dS3XFykir8LTkCgxVMI/LX5i6j5p8vap5gu9I%2bo6Fc3F16VhFcpLI01lPaAVmd1oPrHL6MVZ7i%26%23xA%3brEvzG8p6v5istIOkXFtb6ho%2bqW2qQvdo7xN9WDfu2EZVviLDocVQ/p/nT/y0eW/%2bRF9/1WxVE/lz%26%23xA%3b5U1jy7Y6uNYuLe5v9X1W51WVrRXSFDchPgUSFm2KdzirLMVdirsVdirsVdirsVdirsVdirsVdirs%26%23xA%3bVdirsVdirsVU7q5gtbaW5uH9OCBGllc1IVEHJjt4AYqgtB8yeX/MFiL7Q9RttTszt69rKkqg%2bDcS%26%23xA%3beJ9jviqY4q7FUr1vzV5c0KS0j1rUrfTjfuYrRrqRYkkdRUqHei1oeld8VTNHR0V0YMjAFWBqCDuC%26%23xA%3bCMVbxV2KuxV2KrJpoYInmmkWKGNS0kjkKqqBUlidgBiqW/4s8q/9Xmx/6SYf%2basVd/izyr/1ebH/%26%23xA%3bAKSYf%2basVRljqem36NJY3cN2iHi7wSLIAetCVJxVE4qsmnggT1JpFiTpychRU%2b5xVsTRGL1Q6mKn%26%23xA%3bL1ARx49a16UxVBaHr%2bia9p66jot9DqFg7Oi3Nu4kjLRsVYcl8CMVR%2bKuxV2KuxVhP51SapH%2bVXmW%26%23xA%3bTSmnTUFs2Ns1qXEwfkv2DH8VfliryzSfy28oa75T1ma383eZ5NX0W2dNXsJdUkHp3H1b1aPEVNYp%26%23xA%3bP2fHcdQQFXyr5A1fVdL84aRPpl5PZTNeW8byW8jRMyNKoZWKkVUjqDtir9M8VeDeZprX8zPzU0Ox%26%23xA%3b0nWNWg8rx2mowXd9pNxJbRPdWkijaROSMKkgEjfttvirzT/nKf8ALPTvKGgaHc2us6xqbXV3LG0e%26%23xA%3bq3rXaIFj5VjVlXiffFUx/wCcJtY1abWPMGmTXs8mm29pFJBZvI7QxuZSCyRk8VJrvQYq9l/OyL88%26%23xA%3bZF0YflbNHCQbk6w0gsyT/dfVwPrauP8AfleP04q8u%2bp/85x/8t8H/A6L/wBUsVd9T/5zj/5b4P8A%26%23xA%3bgdF/6pYqzP8AKWD/AJybj83IfzEuYpvLhglDqo04MJtvTI%2bqokn8MVTz/nIjW9Otfy4v9PNxYvqt%26%23xA%3bxPpr2ulXs0SC4Uanb8ldHZeUJCsJD041rtirxr9Ka1/5b78sf%2bR%2blf8AZRirv0prX/lvvyx/5H6V%26%23xA%3b/wBlGKs8/JCLXYPzN1ddV0DSPLX1nQLO4t7HQPSFlPEbucR3R9BnRnb4l5V%2byBir0X8zfza8n/l7%26%23xA%3bpT3OtXiDUJYnfTtLSrT3DqDxAVQ3BCwpzaijxxV%2bf/nXz55q86azLq3mG/ku55GJiiLEQwqekcMf%26%23xA%3b2UUe3XqanfFWcfk1oPm7V9L1gXHmC58uflnDHTzVf%2boywNHUMbeFDUNPJsvwitDQ15BWVfdHljy/%26%23xA%3boXl/QrPSNBto7XSrWMLbRR9OJ35FurM1asx3J3xV4J5o/wCcq9b0aLUriPRNJmistRuNMjtjqq/X%26%23xA%3biYJHQTPZiP1RGeFa9PfFXmX6Z/5yC1nhrOo%2beIfLTaz/AKTpum3uqLpzSxSH4DBbVrHEeiF%2bNetT%26%23xA%3b1xVMrL/nKL82PIdlN5U8z6THqGv2EnEX2oO/qem1GUSemaTAg1SQPuKdeuKvYv8Alf2o/wDKhv8A%26%23xA%3blZn6Hh%2bu%2bt9X/R3rN6XL6z9X5c%2bPKn7VPor3xVif/OSnk783dd1t9Z0%2b9h0jydolsFjna%2bNvUvRp%26%23xA%3bppVTcfFRB7KD3xV59%2bSPkP8AMa182%2batSkvDHpul6fd2%2bu3RczxXrS2xeOBHb7bfEsnL9kD/ACgC%26%23xA%3bq8V8p/8AKU6N/wAx1t/yeXFX6I/mxoXmjXvy%2b1nSvLF59R1m6gKwSdC69XhD1HAyrVOXauKvibyV%26%23xA%3b%2bWH5pav6OnaLqI0%2b6me5WPSZb17WblaPwuD6I6cG2OKvVf8AnKQeaV/KfyNF5rRE8wwzyxag0biV%26%23xA%3bJJI4uHqhh3kUBz4EkYqgv%2bcIf%2bUq8y/8wMP/ACexVOf%2bc34TPceRIQQplfUkDHoCxsxU4q8k1P8A%26%23xA%3bJLStLhM175/0GONZmtmK/XZKSoWDIRHbsQRwPX%2bIxVOvy/8AyV8natJfS/ppfOktoIAuh%2bXna1uu%26%23xA%3bE8oie4Zr%2bKIFIQa0TvTkVHVVPvyD8u6f5b/5ya1HQdOvRqFlp0d/bwXexLKgGzFduSfZam1QcVVv%26%23xA%3b%2bcttA1HXfzl0mwsFT1f8PpNLJKwjiihguLySWWR22VERSx/DfFXkEf5fWcFhc6rqXmGx/RNm0UVw%26%23xA%3b%2bmN9fufUn5emiQlrdSWEbt8UiiinetAVW5/ys8wvHq9xpfHUbLSLGDVZZFDRyGynr%2b89Jt1aIgiV%26%23xA%3ba/DQ05AVxV9P/wDONEh1C60/ULWKZrGw8qWOl3N08MsUf1xL%2b6naJHkVBJSORWLJVd%2buKvEf%2bctI%26%23xA%3bNWT86dSkvQ/1SW2tDpbP9n0BAivw9vXEtffFWM/ld%2bVz%2ba3utZ1m6/Q3kjRv3mt63JsABQ%2bhBUHn%26%23xA%3bM9QAADSo2JKqyqp%2baP5op5kS18u%2bXbX9DeQ9G%2bDSNITYuRUG5uSCecz1J3JpXuSzFV9Uf84pefPM%26%23xA%3b3m38v7ka87XMmk3X1K1vmUKZIREjKjUADNHypXwIrvvir4688PDH%2bZHmCSdPUhTWbxpY/wCZRdOW%26%23xA%3bH0jFWY/nD5O8463%2bYF/5h0nTrvW9D1%2bVbnQtSsYZLiGS3dF9GFTGrcXhQemYzQrx6Yql35xUtP8A%26%23xA%3bCmg3brLr%2bhaLFZ62yuJDFMZpZY7V2BIL28Mio1Dt9ntir1D/ANcl/wCj7/u54q%2bk/wA1/Lmp%2bZfy%26%23xA%3b617QdLVG1DULUw2yyNwQuWB3Y9OmKvOJZvz70vydd6YvlDQ4rRLKWO5livW9Rv3JV5eIX4nYCvvi%26%23xA%3br52/Kz8g/wA0fMGsaZqsOjvYaVDcQ3DX2oE2yMkbq/wIwMr1A2KoR74q%2b/MVeTfmB5R8%2bwfmVo3n%26%23xA%3bHyTpNhem0srq3vIbqYWweW5ZaueIqzcVG%2bKvIf8AnI%2b3/OnzLpugafrfle3jc3chsotHllvppJDH%26%23xA%3b8QZAtQAu9cVZd/zit%2bTvnnyTe6trHma1jsE1K2jht7QyrJcArJz5OsfJFFP8qvtirMPz6/I65/NJ%26%23xA%3bdD9DV00ptHN1XnAZhILr0fB4%2bPH0PxxV5J/0I5qv/U3Qf9IT/wDVbFV8P/OEetwSCSHzlFFIKgOl%26%23xA%3bpIpoRQ7ibFWbfk1/zjHefl551TzJP5gj1FY7eaAW0ds0RJlAFeRkfp8sVYF/zlnofneb81tG1jy3%26%23xA%3bp%2bpSPa6RAsOoadFOximS6uWossIqrqHU9a74q8vXUvz8lVodWste16xkFJNO1m2vdQtmINQ3p3Ac%26%23xA%3bK6kbOlGHStCcVS2%2b0384Lw34fRdWih1JIYbu3t9PmghaG2p6EIjjjVVjjoKINtgeuKvuL8kNPvtO%26%23xA%3b/KbyvZX9vJa3cNigmt5lKSISS1GVqFTQ9DirF/zp/LfzL%2bZHmLRPLhsra08o2oN7qXmI%2bnJeh%2bXE%26%23xA%3b2lsrAvGXABZvsnv9niyrMLz8ofy7vPLGn%2bV7rR0k0HTPitLASTRxh6UMjiN09RzUnk9TUnxOKpL/%26%23xA%3bANC3fkl/1K0H/I65/wCquKs50Dy7ofl7S4dK0Oxh0/ToK%2blbQKFUE7knuWJ6k7nFXjus/wDOH35a%26%23xA%3batq99qtzqetJcahcS3UyRz2oQPM5kYKDasaVbapOKorSv%2bcV/K%2bkWstppPm7zXp1pPUzW9pqMMEb%26%23xA%3bk7Hkkduqt9OKpSf%2bcK/ytJJOq66SdyTcWla/9ImKs4/5UP5Q/wCVW/8AKtvrmofoL1fX%2bs%2bpD9b5%26%23xA%3bev8AWKc/R9OnPb%2b76Yq9HxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Ku%26%23xA%3bxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Kux%26%23xA%3bV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV%26%23xA%3b2KuxV2KuxV2KuxV2KuxV2Kpbr/mXy/5dsRf67qEGmWRcRC4uXWNObAlV5NtUhTirHP8Aldf5R/8A%26%23xA%3bU36V/wBJUX9cVTvy3528o%2bZ/rH%2bHtYtNV%2bqcPrX1SVZfT9Xlw58SacuDU%2bWKp1irHNf/ADG8h%2bXb%26%23xA%3b4WGu6/Y6ZelBKLe5nSN%2bDEhW4sa0JU4qlv8Ayuv8o/8Aqb9K/wCkqL%2buKsr0vVNO1XT4NR025jvL%26%23xA%3bC5Xnb3MLB43XpVWGxGKorFWOa/8AmN5D8u3wsNd1%2bx0y9KCUW9zOkb8GJCtxY1oSpxVLf%2bV1/lH/%26%23xA%3bANTfpX/SVF/XFWV6Xqmnarp8Go6bcx3lhcrzt7mFg8br0qrDYjFUVirEb783vyvsL24sb3zTplve%26%23xA%3bWkjwXNvJcxq8csbFXRlJ2KsCCMVUk/Oj8ppHVE83aUzuQqqLqOpJ2A64qzPFXYq7FXYq7FXYq7FX%26%23xA%3bYq7FXn35xIkieS0kUOjeatMDKwqCP3uxBxV87f8AOWvmnX9J/MOPRdMvZbLSW02GV7O2YwI0kjyq%26%23xA%3bWb0uBboOpptirIf%2bcGSSfO5JqT%2bjCSetf9MxV9U4q870y1tbj88PMwnhSYLoek8RIoalZ7zpUYq%2b%26%23xA%3bE/OHnHzPreoXcWq6lcXcSTvwieRhEoViAFiBEY%2bhcVfeP5A/%2bSa8p/8AMCv/ABJsVZ/irzjTobGb%26%23xA%3b89PMkVykUjnQtKMSSBWO093yKhvorir4W84ecfM%2bt6hdxarqVxdxJO/CJ5GEShWIAWIERj6FxV94%26%23xA%3b/kD/AOSa8p/8wK/8SbFWfkgCp2A6nFXz9e3VxZfkx%2bZetaQ8cWpW/mDWpba/VUZlX9JblGIbqhNM%26%23xA%3bVfIn6c1nV9ds7nVb6e%2bnM8f7y4kaQj4xsORNB7DFX6eYq7FXYq7FXYq7FXYq7FXYq8F/5yY038yd%26%23xA%3bQs7SDTbixj0Se5jtdNsUV3v59RmikEbCQqiQn7SJRtiak/yqvn3/AJyIsfMen%2bYtFsfNl0NR80Q6%26%23xA%3bNaC9v4yBGw9Sf4GXjV3UcQZOQ5UJ474q9S/5wY/6bb/t1/8AY5ir6muFna3lW3dY7gowhkdS6K5H%26%23xA%3bwllBQsAeo5D54q%2bb/wAsdE/PSw/NHWV1HVdOuNUi9GfXI7xXP1uxlmnEHoTxo3BRR2jWg4bAinw4%26%23xA%3bq%2bTdbMJ1a79FGRfVcMHYOS4Y8iCFSgJ6Dt4nrir9B/yB/wDJNeU/%2bYFf%2bJNirPLh5UgkeKP1pVVm%26%23xA%3bjiqF5sBULyOwqdq4q%2bQjoP593v59adLe3dvBry3EV7MLeksNnp7mYBZGVU5wiMSxqhepJpsWrir5%26%23xA%3b61xrc6tdeijoBI4cO4erhjyYUVKAnoN6eJxV%2bg35A/8AkmvKf/MCv/EmxVE/nRpnnDU/yz1yy8oy%26%23xA%3b%2blrMsBCqoPqSwg1mhhYH4ZJI6qp%2bjavIKvmny1bfmpZ/k/55Gpvb3vlKe3uoZirKk1tqMEo9VvT4%26%23xA%3bRs/N6rId6mjV61VeBaT/AMdWz/4zx/8AExir9ScVdirsVdirsVdirsVdirsVeb/nfqNjptj5Rv7%2b%26%23xA%3bdLWytfM%2bmy3FxKwVI0USlmZjsABir5v/AOcnI9J83%2bdo/MXlzXtH1GxSxhtnjTUbaOYPG8jN8Erp%26%23xA%3bUUcdCcVZf/zg0pVvO6mlQdMBoQRt9c7jbFX1Tirye685eVPLP53eYZPMOrWulJdaJpa27XcqxByk%26%23xA%3b92WC8iK05DFXxN5u8sXGmX9zONQ03ULaSV3jmsL62uKhmJ/u1f1R17pir7y/IH/yTXlP/mBX/iTY%26%23xA%3bqz/FXk915y8qeWfzu8wyeYdWtdKS60TS1t2u5ViDlJ7ssF5EVpyGKvibzd5YuNMv7mcahpuoW0kr%26%23xA%3bvHNYX1tcVDMT/dq/qjr3TFX3l%2bQP/kmvKf8AzAr/AMSbFWf4q%2bcL/wAzeUpvy5/MnyhceYNN0/Xr%26%23xA%3b7XtdWC0vblID8d%2bzKW5dA1Njir5UOjXOl65ZwzzWs59ePi9pdW90hHMb8oHkp9OKv06xV2KuxV2K%26%23xA%3buxV2KuxV2KuxVQvjYLbPJf8ApC1j%2bJ3n4iNadyX2GKsfv/Mn5a2FnNeXeo6TFbQKXlkMluaKPYEk%26%23xA%3b/IYqk%2bjfnB%2bWM17BaW88mmnUGCWVzeWF1YW9y3VRHPPFFGxNfhBaprtirP8AFUu1W48uWzxvq0ln%26%23xA%3bC8gIia6aJCwWlQpkpWnLFWN6958/K7RFhFzc2dxcXJK2tlYQ/XrmUqKtwgtllkIHc0piqP8AKH5g%26%23xA%3beTvMjzWWi3JS9s1BuNLuIZbO6iQ9GNvOkT8P8oCmKsmxVjHnDzh5A8uNC3mW8tYLm4FLa3eMz3Uo%26%23xA%3bqf7qCNZJnFf5VOKscj/N38plkjXUEl0hJSFjuNU0u6soCSabzzQJEvX9phir0W0e0ktYpLNo3tXU%26%23xA%3bNA8JUxsjCoKFfhII6UxVVxVLtSXy5YwSXupiztYAay3Nz6UaVPdneg3%2beKoTRr/yRrSs%2bi3Omaks%26%23xA%3bdC7Wb284WvSpjLUxVU0fzf5a1nVdV0nS9Qiu9Q0SRItUgjJPovICVUtTiT8JBoTQgg74qnGKuxV2%26%23xA%3bKuxV2KuxV2KuxVgH5/f%2bSa82f8wLf8SXFWCfm15e8jeT/Nvk7VrLyhYG0tV1O7e0sbS3tWubu2hi%26%23xA%3be2jLxx/EyoZpEQ/aZfHFU287%2bePypvvLWnad%2bkx5ktNXgkspbVL71mispVE1xqNzGS3x2iQ81ZwG%26%23xA%3bU1CkE4qzn8qLvVrz8s/K91q5ZtRm0y1e4dyS7ExLR3rvyZaM3virHfzC0PRda/NjyDY6zp9tqVk1%26%23xA%3bnrrm1vIY54iyrZcW4SBlqO22KsH8qah5A8ofmV5j0%2b%2bsofL732uegmo2zJp9vaw2ltbXFhbOIxGi%26%23xA%3bxXtZWNSFkKlWDbHFUd5j82%2bWtT/M3y7H5ake/wBRsNcto/07DcfWUkW/jma/0%2bI1YGCG3jWV%2bLFY%26%23xA%3b2KigJxV6p%2bYXmw%2bVfKN/rMUP1q9jCQadaDrNeXDrDbRbb0aV1r7VxVjWk%2bUNR8l6WuuxaV/i7z7q%26%23xA%3blxbrr2ptJHDMwmcLKYXl2jggQ0SJABQCvc4qy3zNeanE2m2drof6astSultNV5SRoltaujF53SQH%26%23xA%3b1VFACg64qwqysB%2bW3nnTdM06sfkbzbNLb2%2bnkkxabqoR7hRb1rxhu1R/3Y2VxUUBpirNPN3nLRPK%26%23xA%3bmnR3uqPIzXEq29lZW0bT3VzO/wBmKCFPidz%2bHU4qwzyt5E/xbdS%2bcfzC003F/PNL%2bhPL2oKHg02y%26%23xA%3bRysINu3KI3MgX1JJDU7gClMVYT%2bYmnaN5u89W/lL8s9Og0/zRpciya/5109TbDTIdw0BktzH68ri%26%23xA%3bq%2bmxIG468iir0r8lNM8oWP5e2B8q2stvp8zz%2bs90B9amuIZngmluSOsheI%2bw6DYYqzvFXYq7FXYq%26%23xA%3b7FXYq7FXYq8%2b/PiS2l/K7XtKN1bQX%2bpWrw2EFzcQ2/rSBlJVGmaNTQe%2bKqGkXvkH80tK17RpdUOu%26%23xA%3bLp%2bqTAr%2b7guLGSGQrbyWktuEPAcC0M4JLAkEndcVYd%2bXP5SaJrt75gm12/vNSs9J1y605NPf6vDF%26%23xA%3bdR2jI8b37W8MMt03JqkSPxJ6g4q93JihiJJWOKNakmiqqqPuAAxV4lqXn/yv5x/MPQr/AEHzDb6f%26%23xA%3bZ6F%2bmdLuNWea0QiaaOxeOSCK5ZvVjkIeNX4EEqadiVU5/PLyRpcvk7VvNqSzW/mLR9MkYX0Hphbt%26%23xA%3bIF9RYbyB0eGeLmOXFk2/Zpiqc/l5%2bVfl/wAutb62ZrjU9Ze2CQ3d4YwttFLR3itIIEhggVmNW4JU%26%23xA%3b9ziqz865FtPLek6xMCbHRde0nUNQIFeNvFdoryEUr%2b75h9vDwriq/wA2eZvNWo%2baE8l%2bS5ILS/jt%26%23xA%3b0vdc164j%2bsR2NvMzJAkUNVWS4mKMVDniFFTWuKoS/wDLX5s6Bbtqmi%2bapPM81uDLcaDq1taxLdBd%26%23xA%3b2jt57WOFoJCKhOXJa0rtiqA82eadM836V%2bW9xpHJpNc16yv7WFgBLHFYCS4vOY3p6QjMT%2b5xVFee%26%23xA%3briy0b82fKHmPXn9LQEs7/TrW%2bkIW3tNSuWiKNM5%2bFPXhR41Y99sVSrz9%2bY2seZtal/L/APLq8jiu%26%23xA%3bgB/iXzYGBttMgfbhFICA1y/RQDt23qUVZt5D8s%2bSfJHl6HRNEmgSFPjuLh5Uaa4mb7c0z1%2bJ2/Do%26%23xA%3bKAYqxfyRFp2hfmvqflfyzfyXPluXS21W%2b04zNdRWGoS3YCrFIzOYvrKSSSNFXqvLvir1TFXYq7FX%26%23xA%3bYq7FXYq7FXYq84/PHyrpV/5J1fW10G21jzHp9mRpTTWq3kinmDxSNlfl9omlMVYv5B1n8n/I0mpT%26%23xA%3baFomsxXWqXM1xcXH6D1AMsckpkjto6QfBDECFVR4VO%2bKsr/JaWS507zPqBtri1g1HzHqF3aJdwSW%26%23xA%3b0rQyiMo/pyqjgH3GKvQZoYZ4ZIJ41lhlUpLE4DKysKMrKdiCOoxV8%2b%2bYfyv/AC38g%2bbNIV/LB1Xy%26%23xA%3bxrEmqXWoKNNfU5LZ1itFtYEeOOWVIg/qsoJ7nwxVO/zD/Mny1qf5aa55c0TSta%2bsXOmy2Wn236H1%26%23xA%3bBEBMXCNOTQgKOg3xV7DpasumWisCrLDGGU7EEINjirtT02x1TTrrTb%2bFbixvYnt7qB/svFIpV1Pz%26%23xA%3bBxV5ToNl5k/K%2b/vYZ9Cu/NGhXYhSDzBplbnU1gtkMdvBe2hYGUwoeCywDdacl5Yqnkv5y2Vwpi0L%26%23xA%3byz5g1fUG2jthptxZxhjsPVuLtYYo18WJxVS/LP8ALa80m%2bbzH5git7fVnSaLTNGs2eW00u3uZ2uJ%26%23xA%3bo4pJCTJNNK/KaXbf4VogGKpl%2bbeg%2bc/MfllfL3lprOBNWlFtrF9eD1Db2TAmR4YSCrvtQVO3b%2bZV%26%23xA%3bWtC/Jn8utI8oWvlT9DwX2l27ieRbxFlaa548TcS1FGkI26bDYUGKrv8AlSn5R/8AUoaV/wBIsX9M%26%23xA%3bVZD5f8reW/Llo1noOl2ul2ztzkitIkhDP/M3ADke1TiqaYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXY%26%23xA%3bq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FWK%2bc/zC0/y1cW%26%23xA%3bmnR2VzrGvagryWWkWQQyNHFT1JpZJGjihhSoq7sB4VxVL/K35qQ6prFtous6Pc6BqV%2bjyaUZpbe6%26%23xA%3btbwRCsiW93aSSxNIgFWjrUDfFUH59/OvRvKuqy6TDZNqV7aCI6g7XVpYW1sZxyhikub2WGMyyJ8a%26%23xA%3bxrU8fi6YqyLyb5%2b0TzVotxqlsJLE2MjwanaXoWKW1ljUOwlozJx4MHV1YqVNa4qxyH83dT1WOS/8%26%23xA%3bq%2bTNV17QI2YDWI3tLVJ1QkM9rFcyxyzrseJCip2xVPtN/Mvyjf8Ak%2b882C5a20vTRN%2bk0uEaO4tZ%26%23xA%3bbf8AvYJ4d2WVTtw77UrUYqw7TP8AnInQ59XFpqOj3WlWTSJE93NcWUstsZWCRm/s4JpLm0VnZVrI%26%23xA%3bnwsQDTFXq9xPDbwSXE7iOGFWklkbYKqirE/IDFWE235w%2bWru3iurPTNfurS4RZbe5g0PVJIpY3HJ%26%23xA%3bJI3WCjKymoI6jFVT/lbGi/8AVk8x/wDcA1X/ALJ8VROk/mb5d1HWbTRjb6np9/f%2bp9RTUtNvbFZm%26%23xA%3bhQySJG9xFGrMsalqV6DFWSX2o6fYRLLfXUNpEzcVknkWNS1K0BYgVoMVYH5q/OTT9K1230TRLFfM%26%23xA%3bN7JatezNBf2FrDFEJPSAMtzNGrOW/ZG9N8VSHzF%2bf2seXdAfzBqvki5j0eOVbd7yDU9MulEr/ZSl%26%23xA%3bvNK1foxV6B5K83S%2bZLO/a50ybR9R0u8aw1DT55IZmjmWKOccZIGkjcGKdDUHrt2xVkWKvFfyq/Jf%26%23xA%3b8rNX/Lby1qmp%2bW7S71G9063nu7mQMXkldAWdjy6k4qmep/lj/wA45aZqcGlX%2bj6RBqt0pa105n/0%26%23xA%3bmWnaOHnzcnooAqT0xV5f5Kh/J/zH%2bYyaWPJmnJ5d1JTb6Y3F/VSZY5LmCZ2qNrqFJFKHeOSIr81U%26%23xA%3bx1c3lz/zjb%2bXEMen/pyW41DTYTpEknBbxR63G3dydlbio36Yqlf%2bE9d/9h8sf%2b4jH/XFXf4T13/2%26%23xA%3bHyx/7iMf9cVbsND1aw81eVbif8prbybH%2bnLBTrUF4szrylp6XBTWknQ4q9P8z%2bTE85ecfzB0U3TW%26%23xA%3bdzd%2bXdIsba9A5GJJ7i%2bkdeNR8DvCvNQRUYqwDVPyKbyj5f0P67rt2b2%2b83aewg0maaxsbZb64SBz%26%23xA%3bbQqx4yrGSFkrUVoPdVLfzK/I%2bztvPZs21a6FrrUVzqWn3txO2o3KPZWR%2buxXFvcyD1vVRAY5%2bXwn%26%23xA%3b4WBFMVT2z0HUNH/5xv8ANmvsfq3%2bIdJtZNPtlf1Hi02GyhtLUTScV5TSQLykoKCtAABTFWQfmj%2bR%26%23xA%3bfmrzL5y0LVPLmr2%2bk6XpNva21uGedJ7AW0pZpLKNFeFy8ZCnnxPwgcqVGKpBcfk1c655o/Mfy3B5%26%23xA%3bo1iS4FppN5BLdXSrFPeTpMVa8S2jhWRR9VjUELUDfcgYqwTy5%2bWSavPptrp07rcecpNYtJ4p2jmS%26%23xA%3bwis7mBdSk%2btjlLel%2bIFuDxAryJJqSq%2bm/wAzPNWm6J5dmtJ4rm61DWYriy0zT7G3kurmeYwO7BIo%26%23xA%3bgzURFLMewxV806D5f/My20LTrc%2bbvPemGG1hjOmweW9SkituEaj0I3FwgZI6cVPEVA6DFUd%2bh/zL%26%23xA%3b/wCp8/MD/wAJnUv%2byrFU58gaRrq/mV5G1W%2b876n5nh/SOq2EumatZzWM9ldQ6VM7iSKaaZlco6ml%26%23xA%3bBsRir1D8wtF0fWvzW8hafrFjb6lYPZ65I1peRJPCXRbPixjkDLVamhpirzS2fyq/51toL%2bXvJJ8t%26%23xA%3btOdMTTVsY/XE6k1f639T%2brtc%2bNv6vT4ftfEVUq/P/RdH0Xy5590/R7G302wS68vyLaWcSQQh3S45%26%23xA%3bMI4wq1agqaYq93/Lr/jtefv/AAI2/wC6Vp%2bKs1xV4h5W/Jvyn58/LHyPfa1NfxT2miW9vF9TunhT%26%23xA%3biycqmP4k5AnrTfvUAYqiLf8A5xi8t6frdpe6Vqt3Fp1vdW2oy6bcBJ2lu7Fna3b62w9eNBz4sqdR%26%23xA%3b774qwn8uPIPmi0/New0jVrch9ElGqXtzGCIvSjF8Y5EcE1W5vdUm9JCQ/pRVZR0xVPvL/wD5Jr8n%26%23xA%3bv%2b27pX/Ep8VTLUP%2bhq7nzXeQ6adJsfL0l9dpYXVysMjR2aPIbaSVY2eQ%2boioNgWq3xAb0VSX8x/L%26%23xA%3bX/OT0/laZLnVrLVbISRtfadoAktNQmgDfvEilaPuOoFSfA9Cq15G0nz1pn5faBD5sW7hD%2bcbCTRr%26%23xA%3bTUZfWvILEzLwjmeimvLlsQPkBQYq9GW4uLf8wvzAuLZlS5h0HSJIHcqFDqdTKli9FpUd9sVYNa%2bY%26%23xA%3bvM3mH8qvI%2bqeZbm3u9Xl836Us09o9vJEVTVAqUa1Z4dlArQ/PFUT5%2bLf8r0b0VBJ8n6j9aNqKyCP%26%23xA%3b4uH10y/AIuf916Px8/tfBiqI8zf%2bsjw/%2bArp/wD1DQ4q9iOo6epcNcxAx7SAuvwmtPi3232xV5lD%26%23xA%3bJay%2be/zVd5IDatoekl5J2cW/D6vf8jK8R5iOn2ihrTpvirC/ydjnQ/k8swlA/RnmMxeqIwDGXtSh%26%23xA%3bi4Ub0yN19T4/HFWffmneXVj538gXlpZvqF1bXGsSwWETKrzumj3DLErPRQXIpU4qwDVPz5/MoaTb%26%23xA%3byz2Wn6ELyS3guryWy1svpqXMio8831qyt7NvQ5Vb98QT05Yqsuvzl/MLQNQvNNsLlfPa2eo6dDHd%26%23xA%3bRw2qSTre/WUe0rYloeTLAs0TUDKD8Y7Yqm3kXQ/Mmr/mrqOppZRW%2biaD5o1O9urqScGc3F3o8Fr9%26%23xA%3bWWBFYfB6iuZPUodx23VZx5r/APJy%2bQP%2bYHXv%2bI2WKvKbLRNSH5ir%2bW4Sw/Q1hr63P6c9E/pRolX/%26%23xA%3bABClsT9igkl4epWtP2cVQv8Azkt/xy/P/wDxn8u/8QucVe1fl1/x2vP3/gRt/wB0rT8VZrirBLL8%26%23xA%3bmvLFjaRWdjqWv2lnbqI7e1g1zU44o0XZURFnCqo7AYqrf8qn0X/q9%2bY/%2b4/qv/ZRirv%2bVT6L/wBX%26%23xA%3bvzH/ANx/Vf8AsoxVF3H5ZeUZvKmmeVxBPBpWjvFNpn1e5nhnhlgr6ciTxusvIcjvyxVCf8qn0X/q%26%23xA%3b9%2bY/%2b4/qv/ZRirv%2bVT6L/wBXvzH/ANx/Vf8AsoxVdB%2bVHlyO%2bs7ye%2b1m%2bawuI7u2hvtX1C6hE0J5%26%23xA%3bRuYppnRip6VGKpH5ltvOdj518x3Wn%2bVLnXtJ8waVYWJubW9sbVo2tzeCUcbqRGrxuloeNMVYfovk%26%23xA%3b3znp/lzyt5N0zyVqVlpGk%2bYLDVZ9S1HU9KuHSGG9FzOWW2kQtQE0CpX54qy780/y483azr1r5l8s%26%23xA%3bXtq%2bow2NxpAsNTQmC3hv/wB3NeWzR8Ss6qfiD8gyim3Qqp15n/LuS9/KGbyBpVyqsulw6XaXVzWl%26%23xA%3bLdEjV5OAPUR70GKvL73/AJx782Xt1rt1cab5aabzHI0urMLnWB6jvcC6JUB/g/eqD8PyxVmn5Xfl%26%23xA%3bX5h8sr5gj1G4s7KLU7Cx07Tho7zu1slmtyvqB7xXJf8A0kFSeQqNxiqE/LD8ofMXljX7BdUubWXQ%26%23xA%3b/K1tdW/lyS0Rkmum1OQSXM96HL0kURItFND126Yqyrz95e8x3mteVvMGg29te3Xl26uZpNPup2tF%26%23xA%3bmS6s5bU8ZliuOJQyBqcN/bFVO41f81biCS3uPJejzQSqUlik1uRkZWFCrKdNIII7YqhdNb8wdLt1%26%23xA%3bt9M/L/QbG3VzKsNtq5hQOw4lwqaYo5EGlcVTL8tvLuvaRBr93rkVvb32vaxPqps7WZrhIEkghgWP%26%23xA%3b1mjg5n/R%2bVeA64qgPzB03zVF5v8AKvmnQtHbXV0eLUra70%2bK4gtpqX6wcJFa5aOMqptyG%2bKu4oOt%26%23xA%3bFWFRaR54j/Mybz4PIOrm4mQE6Z%2bldH%2bri5%2brraG4/v8AlX6ugTj06nFVa/8Aye1H8y9U17UfOseq%26%23xA%3beVdPv/qSQaLa3ljKZjZo/wC%2bmKR3SbGSiUYHrUdMVeo%2bUPKFl5Ysbm2gu7rULi%2buWvL/AFC/kWW4%26%23xA%3bnnZEi5uUWJNo4kQBUGw8anFU9xV2KuxV2KuxVbLLHFE8srBI41LO7GgCgVJJ9sVYj5F/NryD56ub%26%23xA%3b618s6mL2fT6G4jMcsLcGJUSIJVTktR1H09RirMMVdirFvzA/Mzyf5B063v8AzLeG2iupPRto40aW%26%23xA%3bSRgKtxRATRR1PT6SMVT3RtY03WtKtNW0ydbnT76JJ7WdagPG4qpoaEfI4qjMVdirsVdirsVdirsV%26%23xA%3bdirsVdirsVdirsVdirsVdirG/wAxPM%2bq%2bWPKF/rWlaPPrt/bKPQ0%2b2FWZmIXkwFXKJWrcATT7wq8%26%23xA%3bKMfm%2bTXdK1f84/P6eX5L2aM6f5GsCx5rK3BY7iKEkcSW4lnD/wCU43GKvJPyb0rRbfTvNSa95on8%26%23xA%3bl3H1mx02y1m3WXmtzyuJmjLR8GVP9GBYl17b4q%2bgvy88yfnR5e81aX5Y80Rr5z8s6upOlecNOKuE%26%23xA%3bjVeXOeQUUrxpXnuf2Wfpir3LFXzp/wA5s6YZfImhakFqbTUzASB0W4gdvDpWAYq9j/K3TBpf5a%2bV%26%23xA%3brDjxaDSrMSD/AIsMCtIfpcnFWUYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq8X/MX8sb%26%23xA%3bLQNS1P8AMDy15T/xl5y1K5gEVpqMvrW9oSOJnihcgtRgu3L4OqlFBxVh%2bifl15j0vU9V0nUPIMPm%26%23xA%3bDy75o803/wBc%2btMiPZ2PGM2t1FKp%2bD4ZpviUDdKAqWWqr3L8vPy%2b0LyF5dGgaI9w9iJ5bgG6lMrh%26%23xA%3bpmrxHRVUAAAKB4n4iSVWTYq8y/5yL8l6p5v/ACwu9K0m3a61Jbq0mtoUALEidY3IrT7McjMdxsMV%26%23xA%3belQQxwQRwxDjHEoRB4KooMVX4q7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYqsuI3lgkjSR%26%23xA%3bondWVZVpyQkUDCtRUdd8VeZ/kn%2bS93%2bWh1o3HmKTXzq/1biZIGg9H6t6taVmuOXP1vbp3xV6firs%26%23xA%3bVed/nR%2bU11%2bZGkafp8GvzaD9RuGuGaOH11l5IUAZRJAarXY8u528FWa6BpbaToWm6U0xuWsLWG1a%26%23xA%3b4I4mQwxrHzK1anLjWlTiqPxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2K%26%23xA%3buxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KpXqfmny5pen3Go3%2bp21vZWsbS3EzSrRUUVJ2JJ9gN%26%23xA%3bzirD7f8AOe2uoI7m18n%2baZ7aZRJBMmmHi6MKq61kBow3GKp1pH5o%2bQ9T0S21gaza2NtcTfVfS1CW%26%23xA%3bO0mjuhUNayxyspWZSp%2bDr3FRvirKI5I5EEkbB0bdWUggj2IxVdirsVdirsVdirsVdirsVdirsVdi%26%23xA%3brsVdirsVdirsVdirsVdir5r8n%2bRNF8v/AJdad%2bZOpw6Tf6JZeX4bw%2bX30TTzPJdrbrxlOpFGuCzz%26%23xA%3bfFuO/tiqHuvMX5zT2OseapdT1JbPQLiWDVp7CWxitreW2I%2btLBpc1vK9zFZtyV2kuVaSlRSmKvTP%26%23xA%3by%2b0nyV580WfWPMflTRLrzJbXc9hrV39Qt5VmubYhfWSSVGdkkjKOOR2rTtiqY/kD/wCSa8p/8wK/%26%23xA%3b8SbFWf4q7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq8K8meefyi1L8j9J8o6/5n06%26%23xA%3b2NzosdjfwPcxpNEzQ8Tsx2dG3Fe4xV5ZcXSwtqeijzXpV9p2sTevqdxBr0Fnpt9KaVnvLQwSXcbS%26%23xA%3b8QbhIJaSGoBXrir278vfPX5R%2bU/Lo0%2bbzxpV7qN1PNf6rei4hjWa7uX5ysqA0RBsqL2UDFU7/IH/%26%23xA%3bAMk15T/5gV/4k2Ks/wAVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVf/Z%3c/xmpGImg:image%3e %3c/rdf:li%3e %3c/rdf:Alt%3e %3c/xmp:Thumbnails%3e %3cxmpMM:OriginalDocumentID%3euuid:9E3E5C9A8C81DB118734DB58FDDE4BA7%3c/xmpMM:OriginalDocumentID%3e %3cxmpMM:DocumentID%3exmp.did:9bb40803-0a68-4b6d-b079-70a423632dc7%3c/xmpMM:DocumentID%3e %3cxmpMM:InstanceID%3exmp.iid:9bb40803-0a68-4b6d-b079-70a423632dc7%3c/xmpMM:InstanceID%3e %3cxmpMM:RenditionClass%3eproof:pdf%3c/xmpMM:RenditionClass%3e %3cxmpMM:DerivedFrom rdf:parseType='Resource'%3e %3cstRef:instanceID%3euuid:3790e011-2e1b-2f40-a3d6-4e538a02edb2%3c/stRef:instanceID%3e %3cstRef:documentID%3exmp.did:525ac691-adef-4d04-bc72-b632c8732463%3c/stRef:documentID%3e %3cstRef:originalDocumentID%3euuid:9E3E5C9A8C81DB118734DB58FDDE4BA7%3c/stRef:originalDocumentID%3e %3cstRef:renditionClass%3eproof:pdf%3c/stRef:renditionClass%3e %3c/xmpMM:DerivedFrom%3e %3cxmpMM:History%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cstEvt:action%3esaved%3c/stEvt:action%3e %3cstEvt:instanceID%3exmp.iid:78fa4c27-1810-4112-abf8-25d31ae36cdc%3c/stEvt:instanceID%3e %3cstEvt:when%3e2019-06-10T14:32:07%2b02:00%3c/stEvt:when%3e %3cstEvt:softwareAgent%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/stEvt:softwareAgent%3e %3cstEvt:changed%3e/%3c/stEvt:changed%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cstEvt:action%3esaved%3c/stEvt:action%3e %3cstEvt:instanceID%3exmp.iid:9bb40803-0a68-4b6d-b079-70a423632dc7%3c/stEvt:instanceID%3e %3cstEvt:when%3e2019-06-14T11:08:35%2b02:00%3c/stEvt:when%3e %3cstEvt:softwareAgent%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/stEvt:softwareAgent%3e %3cstEvt:changed%3e/%3c/stEvt:changed%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpMM:History%3e %3cillustrator:StartupProfile%3eBasic RGB%3c/illustrator:StartupProfile%3e %3cxmpTPg:NPages%3e1%3c/xmpTPg:NPages%3e %3cxmpTPg:HasVisibleTransparency%3eFalse%3c/xmpTPg:HasVisibleTransparency%3e %3cxmpTPg:HasVisibleOverprint%3eFalse%3c/xmpTPg:HasVisibleOverprint%3e %3cxmpTPg:MaxPageSize rdf:parseType='Resource'%3e %3cstDim:w%3e440.000000%3c/stDim:w%3e %3cstDim:h%3e440.000000%3c/stDim:h%3e %3cstDim:unit%3ePixels%3c/stDim:unit%3e %3c/xmpTPg:MaxPageSize%3e %3cxmpTPg:PlateNames%3e %3crdf:Seq%3e %3crdf:li%3eCyan%3c/rdf:li%3e %3crdf:li%3eMagenta%3c/rdf:li%3e %3crdf:li%3eYellow%3c/rdf:li%3e %3crdf:li%3eBlack%3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpTPg:PlateNames%3e %3cxmpTPg:SwatchGroups%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eDomy%c5%9blna grupa pr%c3%b3bek%3c/xmpG:groupName%3e %3cxmpG:groupType%3e0%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eBia%c5%82y%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eCzarny%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eCzerwony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3e%c5%bb%c3%b3%c5%82ty RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eZielony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eNiebieskozielony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eNiebieski RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eKarmazynowy RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=193 G=39 B=45%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e193%3c/xmpG:red%3e %3cxmpG:green%3e39%3c/xmpG:green%3e %3cxmpG:blue%3e45%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=237 G=28 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e237%3c/xmpG:red%3e %3cxmpG:green%3e28%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=241 G=90 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e241%3c/xmpG:red%3e %3cxmpG:green%3e90%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=247 G=147 B=30%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e247%3c/xmpG:red%3e %3cxmpG:green%3e147%3c/xmpG:green%3e %3cxmpG:blue%3e30%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=251 G=176 B=59%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e251%3c/xmpG:red%3e %3cxmpG:green%3e176%3c/xmpG:green%3e %3cxmpG:blue%3e59%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=252 G=238 B=33%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e252%3c/xmpG:red%3e %3cxmpG:green%3e238%3c/xmpG:green%3e %3cxmpG:blue%3e33%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=217 G=224 B=33%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e217%3c/xmpG:red%3e %3cxmpG:green%3e224%3c/xmpG:green%3e %3cxmpG:blue%3e33%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=140 G=198 B=63%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e140%3c/xmpG:red%3e %3cxmpG:green%3e198%3c/xmpG:green%3e %3cxmpG:blue%3e63%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=57 G=181 B=74%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e57%3c/xmpG:red%3e %3cxmpG:green%3e181%3c/xmpG:green%3e %3cxmpG:blue%3e74%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=146 B=69%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e146%3c/xmpG:green%3e %3cxmpG:blue%3e69%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=104 B=55%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e104%3c/xmpG:green%3e %3cxmpG:blue%3e55%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=34 G=181 B=115%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e34%3c/xmpG:red%3e %3cxmpG:green%3e181%3c/xmpG:green%3e %3cxmpG:blue%3e115%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=169 B=157%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e169%3c/xmpG:green%3e %3cxmpG:blue%3e157%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=41 G=171 B=226%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e41%3c/xmpG:red%3e %3cxmpG:green%3e171%3c/xmpG:green%3e %3cxmpG:blue%3e226%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=113 B=188%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e113%3c/xmpG:green%3e %3cxmpG:blue%3e188%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=46 G=49 B=146%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e46%3c/xmpG:red%3e %3cxmpG:green%3e49%3c/xmpG:green%3e %3cxmpG:blue%3e146%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=27 G=20 B=100%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e27%3c/xmpG:red%3e %3cxmpG:green%3e20%3c/xmpG:green%3e %3cxmpG:blue%3e100%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=102 G=45 B=145%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e102%3c/xmpG:red%3e %3cxmpG:green%3e45%3c/xmpG:green%3e %3cxmpG:blue%3e145%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=147 G=39 B=143%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e147%3c/xmpG:red%3e %3cxmpG:green%3e39%3c/xmpG:green%3e %3cxmpG:blue%3e143%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=158 G=0 B=93%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e158%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e93%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=212 G=20 B=90%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e212%3c/xmpG:red%3e %3cxmpG:green%3e20%3c/xmpG:green%3e %3cxmpG:blue%3e90%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=237 G=30 B=121%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e237%3c/xmpG:red%3e %3cxmpG:green%3e30%3c/xmpG:green%3e %3cxmpG:blue%3e121%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=199 G=178 B=153%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e199%3c/xmpG:red%3e %3cxmpG:green%3e178%3c/xmpG:green%3e %3cxmpG:blue%3e153%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=153 G=134 B=117%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e153%3c/xmpG:red%3e %3cxmpG:green%3e134%3c/xmpG:green%3e %3cxmpG:blue%3e117%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=115 G=99 B=87%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e115%3c/xmpG:red%3e %3cxmpG:green%3e99%3c/xmpG:green%3e %3cxmpG:blue%3e87%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=83 G=71 B=65%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e83%3c/xmpG:red%3e %3cxmpG:green%3e71%3c/xmpG:green%3e %3cxmpG:blue%3e65%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=198 G=156 B=109%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e198%3c/xmpG:red%3e %3cxmpG:green%3e156%3c/xmpG:green%3e %3cxmpG:blue%3e109%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=166 G=124 B=82%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e166%3c/xmpG:red%3e %3cxmpG:green%3e124%3c/xmpG:green%3e %3cxmpG:blue%3e82%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=140 G=98 B=57%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e140%3c/xmpG:red%3e %3cxmpG:green%3e98%3c/xmpG:green%3e %3cxmpG:blue%3e57%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=117 G=76 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e117%3c/xmpG:red%3e %3cxmpG:green%3e76%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=96 G=56 B=19%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e96%3c/xmpG:red%3e %3cxmpG:green%3e56%3c/xmpG:green%3e %3cxmpG:blue%3e19%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=66 G=33 B=11%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e66%3c/xmpG:red%3e %3cxmpG:green%3e33%3c/xmpG:green%3e %3cxmpG:blue%3e11%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eZimne%3c/xmpG:groupName%3e %3cxmpG:groupType%3e1%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=56 M=0 Y=20 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e101%3c/xmpG:red%3e %3cxmpG:green%3e200%3c/xmpG:green%3e %3cxmpG:blue%3e208%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=51 M=43 Y=0 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e131%3c/xmpG:red%3e %3cxmpG:green%3e139%3c/xmpG:green%3e %3cxmpG:blue%3e197%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=26 M=41 Y=0 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e186%3c/xmpG:red%3e %3cxmpG:green%3e155%3c/xmpG:green%3e %3cxmpG:blue%3e201%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eSzaro%c5%9bci%3c/xmpG:groupName%3e %3cxmpG:groupType%3e1%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=0 B=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=26 G=26 B=26%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e26%3c/xmpG:red%3e %3cxmpG:green%3e26%3c/xmpG:green%3e %3cxmpG:blue%3e26%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=51 G=51 B=51%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e51%3c/xmpG:red%3e %3cxmpG:green%3e51%3c/xmpG:green%3e %3cxmpG:blue%3e51%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=77 G=77 B=77%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e77%3c/xmpG:red%3e %3cxmpG:green%3e77%3c/xmpG:green%3e %3cxmpG:blue%3e77%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=102 G=102 B=102%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e102%3c/xmpG:red%3e %3cxmpG:green%3e102%3c/xmpG:green%3e %3cxmpG:blue%3e102%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=128 G=128 B=128%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e128%3c/xmpG:red%3e %3cxmpG:green%3e128%3c/xmpG:green%3e %3cxmpG:blue%3e128%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=153 G=153 B=153%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e153%3c/xmpG:red%3e %3cxmpG:green%3e153%3c/xmpG:green%3e %3cxmpG:blue%3e153%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=179 G=179 B=179%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e179%3c/xmpG:red%3e %3cxmpG:green%3e179%3c/xmpG:green%3e %3cxmpG:blue%3e179%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=204 G=204 B=204%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e204%3c/xmpG:red%3e %3cxmpG:green%3e204%3c/xmpG:green%3e %3cxmpG:blue%3e204%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=230 G=230 B=230%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e230%3c/xmpG:red%3e %3cxmpG:green%3e230%3c/xmpG:green%3e %3cxmpG:blue%3e230%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=242 G=242 B=242%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e242%3c/xmpG:red%3e %3cxmpG:green%3e242%3c/xmpG:green%3e %3cxmpG:blue%3e242%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpTPg:SwatchGroups%3e %3cpdf:Producer%3eAdobe PDF library 15.00%3c/pdf:Producer%3e %3c/rdf:Description%3e %3c/rdf:RDF%3e%3c/x:xmpmeta%3e%3c%3fxpacket end='w'%3f%3e %3c/metadata%3e%3cg id='Warstwa_1' class='st0'%3e %3cg class='st1'%3e %3cline class='st2' x1='0' y1='0' x2='0' y2='440'/%3e %3cline class='st2' x1='10' y1='0' x2='10' y2='440'/%3e %3cline class='st2' x1='20' y1='0' x2='20' y2='440'/%3e %3cline class='st2' x1='30' y1='0' x2='30' y2='440'/%3e %3cline class='st2' x1='40' y1='0' x2='40' y2='440'/%3e %3cline class='st2' x1='50' y1='0' x2='50' y2='440'/%3e %3cline class='st3' x1='60' y1='0' x2='60' y2='440'/%3e %3cline class='st2' x1='70' y1='0' x2='70' y2='440'/%3e %3cline class='st2' x1='80' y1='0' x2='80' y2='440'/%3e %3cline class='st2' x1='90' y1='0' x2='90' y2='440'/%3e %3cline class='st2' x1='100' y1='0' x2='100' y2='440'/%3e %3cline class='st2' x1='110' y1='0' x2='110' y2='440'/%3e %3cline class='st2' x1='120' y1='0' x2='120' y2='440'/%3e %3cline class='st2' x1='130' y1='0' x2='130' y2='440'/%3e %3cline class='st2' x1='140' y1='0' x2='140' y2='440'/%3e %3cline class='st2' x1='150' y1='0' x2='150' y2='440'/%3e %3cline class='st2' x1='160' y1='0' x2='160' y2='440'/%3e %3cline class='st2' x1='170' y1='0' x2='170' y2='440'/%3e %3cline class='st2' x1='180' y1='0' x2='180' y2='440'/%3e %3cline class='st2' x1='190' y1='0' x2='190' y2='440'/%3e %3cline class='st2' x1='200' y1='0' x2='200' y2='440'/%3e %3cline class='st2' x1='210' y1='0' x2='210' y2='440'/%3e %3cline class='st3' x1='220' y1='0' x2='220' y2='440'/%3e %3cline class='st2' x1='230' y1='0' x2='230' y2='440'/%3e %3cline class='st2' x1='240' y1='0' x2='240' y2='440'/%3e %3cline class='st2' x1='250' y1='0' x2='250' y2='440'/%3e %3cline class='st2' x1='260' y1='0' x2='260' y2='440'/%3e %3cline class='st2' x1='270' y1='0' x2='270' y2='440'/%3e %3cline class='st2' x1='280' y1='0' x2='280' y2='440'/%3e %3cline class='st2' x1='290' y1='0' x2='290' y2='440'/%3e %3cline class='st2' x1='300' y1='0' x2='300' y2='440'/%3e %3cline class='st2' x1='310' y1='0' x2='310' y2='440'/%3e %3cline class='st2' x1='320' y1='0' x2='320' y2='440'/%3e %3cline class='st2' x1='330' y1='0' x2='330' y2='440'/%3e %3cline class='st2' x1='340' y1='0' x2='340' y2='440'/%3e %3cline class='st2' x1='350' y1='0' x2='350' y2='440'/%3e %3cline class='st2' x1='360' y1='0' x2='360' y2='440'/%3e %3cline class='st2' x1='370' y1='0' x2='370' y2='440'/%3e %3cline class='st3' x1='380' y1='0' x2='380' y2='440'/%3e %3cline class='st2' x1='390' y1='0' x2='390' y2='440'/%3e %3cline class='st2' x1='400' y1='0' x2='400' y2='440'/%3e %3cline class='st2' x1='410' y1='0' x2='410' y2='440'/%3e %3cline class='st2' x1='420' y1='0' x2='420' y2='440'/%3e %3cline class='st2' x1='430' y1='0' x2='430' y2='440'/%3e %3cline class='st2' x1='440' y1='0' x2='440' y2='440'/%3e %3c/g%3e %3cg class='st1'%3e %3cline class='st2' x1='440' y1='0' x2='0' y2='0'/%3e %3cline class='st2' x1='440' y1='10' x2='0' y2='10'/%3e %3cline class='st2' x1='440' y1='20' x2='0' y2='20'/%3e %3cline class='st2' x1='440' y1='30' x2='0' y2='30'/%3e %3cline class='st2' x1='440' y1='40' x2='0' y2='40'/%3e %3cline class='st2' x1='440' y1='50' x2='0' y2='50'/%3e %3cline class='st3' x1='440' y1='60' x2='0' y2='60'/%3e %3cline class='st2' x1='440' y1='70' x2='0' y2='70'/%3e %3cline class='st2' x1='440' y1='80' x2='0' y2='80'/%3e %3cline class='st2' x1='440' y1='90' x2='0' y2='90'/%3e %3cline class='st2' x1='440' y1='100' x2='0' y2='100'/%3e %3cline class='st2' x1='440' y1='110' x2='0' y2='110'/%3e %3cline class='st2' x1='440' y1='120' x2='0' y2='120'/%3e %3cline class='st2' x1='440' y1='130' x2='0' y2='130'/%3e %3cline class='st2' x1='440' y1='140' x2='0' y2='140'/%3e %3cline class='st2' x1='440' y1='150' x2='0' y2='150'/%3e %3cline class='st2' x1='440' y1='160' x2='0' y2='160'/%3e %3cline class='st2' x1='440' y1='170' x2='0' y2='170'/%3e %3cline class='st2' x1='440' y1='180' x2='0' y2='180'/%3e %3cline class='st2' x1='440' y1='190' x2='0' y2='190'/%3e %3cline class='st2' x1='440' y1='200' x2='0' y2='200'/%3e %3cline class='st2' x1='440' y1='210' x2='0' y2='210'/%3e %3cline class='st3' x1='440' y1='220' x2='0' y2='220'/%3e %3cline class='st2' x1='440' y1='230' x2='0' y2='230'/%3e %3cline class='st2' x1='440' y1='240' x2='0' y2='240'/%3e %3cline class='st2' x1='440' y1='250' x2='0' y2='250'/%3e %3cline class='st2' x1='440' y1='260' x2='0' y2='260'/%3e %3cline class='st2' x1='440' y1='270' x2='0' y2='270'/%3e %3cline class='st2' x1='440' y1='280' x2='0' y2='280'/%3e %3cline class='st2' x1='440' y1='290' x2='0' y2='290'/%3e %3cline class='st2' x1='440' y1='300' x2='0' y2='300'/%3e %3cline class='st2' x1='440' y1='310' x2='0' y2='310'/%3e %3cline class='st2' x1='440' y1='320' x2='0' y2='320'/%3e %3cline class='st2' x1='440' y1='330' x2='0' y2='330'/%3e %3cline class='st2' x1='440' y1='340' x2='0' y2='340'/%3e %3cline class='st2' x1='440' y1='350' x2='0' y2='350'/%3e %3cline class='st2' x1='440' y1='360' x2='0' y2='360'/%3e %3cline class='st2' x1='440' y1='370' x2='0' y2='370'/%3e %3cline class='st3' x1='440' y1='380' x2='0' y2='380'/%3e %3cline class='st2' x1='440' y1='390' x2='0' y2='390'/%3e %3cline class='st2' x1='440' y1='400' x2='0' y2='400'/%3e %3cline class='st2' x1='440' y1='410' x2='0' y2='410'/%3e %3cline class='st2' x1='440' y1='420' x2='0' y2='420'/%3e %3cline class='st2' x1='440' y1='430' x2='0' y2='430'/%3e %3cline class='st2' x1='440' y1='440' x2='0' y2='440'/%3e %3c/g%3e%3c/g%3e%3cg id='Warstwa_2' class='st0'%3e %3ccircle class='st4' cx='220' cy='220' r='100'/%3e %3ccircle class='st4' cx='220' cy='220' r='40'/%3e %3ccircle class='st4' cx='220' cy='220' r='160'/%3e %3ccircle class='st4' cx='220' cy='220' r='220'/%3e%3c/g%3e%3cg id='Warstwa_3'%3e %3cpath d='M220%2c430c-115.79%2c0-210-94.21-210-210S104.21%2c10%2c220%2c10s210%2c94.21%2c210%2c210S335.79%2c430%2c220%2c430z M220%2c30 C115.23%2c30%2c30%2c115.23%2c30%2c220s85.23%2c190%2c190%2c190s190-85.23%2c190-190S324.77%2c30%2c220%2c30z'/%3e %3cpath d='M350%2c340h-20c0-60.65-49.35-110-110-110s-110%2c49.35-110%2c110H90c0-71.68%2c58.32-130%2c130-130S350%2c268.32%2c350%2c340z'/%3e %3ccircle cx='160' cy='130' r='20'/%3e %3ccircle cx='280' cy='130' r='20'/%3e%3c/g%3e%3c/svg%3e";

var img$w = "data:image/svg+xml,%3csvg viewBox='0 0 12 43' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M2.27344 29.5078H9.96484C10.9531 15.1562 11.5547 5.57422 11.8555 0.761719H0.382812C1.28516 15.1562 1.92969 24.7383 2.27344 29.5078ZM2.27344 43C6.14062 43 8.67578 43 9.96484 43V35.2656C6.14062 35.2656 3.5625 35.2656 2.27344 35.2656V43Z' /%3e%3c/svg%3e";

var img$v = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='2 2 12 12'%3e %3cpath d='M 16 16 H 0 V 0 h 16 v 16 z' fill='none'/%3e %3cpath d='M 12.6 4.6 L 8 9.2 L 3.4 4.6 L 2 6 l 6 6 l 6 -6 l -1.4 -1.4 z' /%3e%3c/svg%3e";

var img$u = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 24.0.2%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 22.1 22.1' style='enable-background:new 0 0 22.1 22.1%3b' xml:space='preserve'%3e%3ctitle%3ebtn.icon%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cg%3e %3cpath d='M22.1%2c10H0V0L22.1%2c10z M0%2c22.1v-10h22.1L0%2c22.1z M12.8%2c14.1H2V19L12.8%2c14.1z'/%3e%3c/g%3e%3c/svg%3e";

var img$t = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 24.0.2%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 22.1 22.1' style='enable-background:new 0 0 22.1 22.1%3b' xml:space='preserve'%3e%3ctitle%3ebtn.icon%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cg%3e %3cpath d='M0%2c22.1L10%2c0v22.1H0z M12%2c22.1V0l10%2c22.1H12z M19%2c20.1L14%2c9.3v10.8H19z'/%3e%3c/g%3e%3c/svg%3e";

var img$s = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 24.0.3%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 12.2 13.4' style='enable-background:new 0 0 12.2 13.4%3b' xml:space='preserve'%3e%3ctitle%3e%26gt%3b%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cg id='Check-Out-Horizontal'%3e %3cpath id='_x3E_' d='M12.2%2c13.4v-1.2c0-0.3-0.1-0.6-0.2-0.9s-0.3-0.5-0.5-0.7c-0.4-0.4-0.9-0.7-1.5-1.1C9.4%2c9.3%2c8.7%2c9%2c7.9%2c8.6 C7.7%2c8.4%2c7.6%2c8.2%2c7.5%2c8.1c0-0.2%2c0.1-0.4%2c0.4-0.7C8%2c7.2%2c8.1%2c7.1%2c8.3%2c6.9c0.1-0.2%2c0.2-0.4%2c0.3-0.7c0.2-0.5%2c0.3-1%2c0.4-1.6 C9.1%2c4%2c9.2%2c3.5%2c9.2%2c3.1C9.2%2c2.5%2c9%2c2%2c8.7%2c1.6C8.5%2c1.1%2c8.1%2c0.7%2c7.7%2c0.5C7.5%2c0.3%2c7.2%2c0.2%2c6.9%2c0.1C6.7%2c0.1%2c6.4%2c0%2c6.1%2c0 C5.2%2c0%2c4.5%2c0.3%2c3.9%2c0.9S3%2c2.2%2c3%2c3c0%2c0.2%2c0%2c0.5%2c0.1%2c0.8c0%2c0.3%2c0.1%2c0.6%2c0.2%2c0.9c0.1%2c0.6%2c0.3%2c1.1%2c0.5%2c1.6c0.2%2c0.5%2c0.4%2c0.9%2c0.6%2c1.1 C4.6%2c7.6%2c4.7%2c7.9%2c4.7%2c8c0%2c0.2-0.2%2c0.4-0.4%2c0.5C3.5%2c8.9%2c2.8%2c9.3%2c2.1%2c9.6S1%2c10.3%2c0.6%2c10.7c-0.2%2c0.2-0.3%2c0.4-0.5%2c0.7S0%2c11.9%2c0%2c12.2 v1.2H12.2L12.2%2c13.4z'/%3e%3c/g%3e%3c/svg%3e";

var img$r = "data:image/svg+xml,%3csvg id='Warstwa_3' data-name='Warstwa 3' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 440 440'%3e%3ctitle%3eIcons%3c/title%3e%3ccircle cx='117.77' cy='117.77' r='23.98'/%3e%3cpath d='M272.31%2c170.58A132.72%2c132.72%2c0%2c0%2c0%2c236.47%2c48.8C184.73-2.93%2c100.54-2.93%2c48.8%2c48.8s-51.73%2c135.93%2c0%2c187.66a133%2c133%2c0%2c0%2c0%2c121.78%2c35.85L328.26%2c430H430V328.27Zm-189.59%2c32a84.73%2c84.73%2c0%2c1%2c1%2c119.83%2c0A84.82%2c84.82%2c0%2c0%2c1%2c82.72%2c202.55ZM382%2c382H348.13L218%2c251.88A133.08%2c133.08%2c0%2c0%2c0%2c251.88%2c218L382%2c348.13Z'/%3e%3c/svg%3e";

var img$q = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 23.1.1%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 12.7 17.3' style='enable-background:new 0 0 12.7 17.3%3b' xml:space='preserve'%3e%3cpath d='M12.7%2c7.3c0%2c2.2%2c0%2c5.6%2c0%2c10H0c0-1.1%2c0-2.8%2c0-5v-5c0.4%2c0%2c1%2c0%2c1.8%2c0V4.6c0-0.4%2c0.1-0.9%2c0.2-1.3s0.3-0.8%2c0.5-1.1 C2.9%2c1.5%2c3.4%2c1%2c4.1%2c0.6S5.6%2c0%2c6.4%2c0c0.8%2c0%2c1.5%2c0.2%2c2.2%2c0.6s1.2%2c0.9%2c1.6%2c1.5c0.2%2c0.4%2c0.4%2c0.7%2c0.5%2c1.1s0.2%2c0.8%2c0.2%2c1.3v2.7H12.7z M3.6%2c7.3c1.2%2c0%2c3%2c0%2c5.5%2c0V4.6c0-0.8-0.2-1.4-0.8-1.9S7.1%2c1.8%2c6.4%2c1.8S5%2c2.1%2c4.4%2c2.6S3.6%2c3.8%2c3.6%2c4.6V7.3z'/%3e%3c/svg%3e";

var img$p = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='iso-8859-1'%3f%3e%3c!-- Generator: Adobe Illustrator 18.1.1%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 578.106 578.106' style='enable-background:new 0 0 578.106 578.106%3b' xml:space='preserve'%3e%3cg%3e %3cg%3e %3cpath d='M577.83%2c456.128c1.225%2c9.385-1.635%2c17.545-8.568%2c24.48l-81.396%2c80.781 c-3.672%2c4.08-8.465%2c7.551-14.381%2c10.404c-5.916%2c2.857-11.729%2c4.693-17.439%2c5.508c-0.408%2c0-1.635%2c0.105-3.676%2c0.309 c-2.037%2c0.203-4.689%2c0.307-7.953%2c0.307c-7.754%2c0-20.301-1.326-37.641-3.979s-38.555-9.182-63.645-19.584 c-25.096-10.404-53.553-26.012-85.376-46.818c-31.823-20.805-65.688-49.367-101.592-85.68 c-28.56-28.152-52.224-55.08-70.992-80.783c-18.768-25.705-33.864-49.471-45.288-71.299 c-11.425-21.828-19.993-41.616-25.705-59.364S4.59%2c177.362%2c2.55%2c164.51s-2.856-22.95-2.448-30.294 c0.408-7.344%2c0.612-11.424%2c0.612-12.24c0.816-5.712%2c2.652-11.526%2c5.508-17.442s6.324-10.71%2c10.404-14.382L98.022%2c8.756 c5.712-5.712%2c12.24-8.568%2c19.584-8.568c5.304%2c0%2c9.996%2c1.53%2c14.076%2c4.59s7.548%2c6.834%2c10.404%2c11.322l65.484%2c124.236 c3.672%2c6.528%2c4.692%2c13.668%2c3.06%2c21.42c-1.632%2c7.752-5.1%2c14.28-10.404%2c19.584l-29.988%2c29.988c-0.816%2c0.816-1.53%2c2.142-2.142%2c3.978 s-0.918%2c3.366-0.918%2c4.59c1.632%2c8.568%2c5.304%2c18.36%2c11.016%2c29.376c4.896%2c9.792%2c12.444%2c21.726%2c22.644%2c35.802 s24.684%2c30.293%2c43.452%2c48.653c18.36%2c18.77%2c34.68%2c33.354%2c48.96%2c43.76c14.277%2c10.4%2c26.215%2c18.053%2c35.803%2c22.949 c9.588%2c4.896%2c16.932%2c7.854%2c22.031%2c8.871l7.648%2c1.531c0.816%2c0%2c2.145-0.307%2c3.979-0.918c1.836-0.613%2c3.162-1.326%2c3.979-2.143 l34.883-35.496c7.348-6.527%2c15.912-9.791%2c25.705-9.791c6.938%2c0%2c12.443%2c1.223%2c16.523%2c3.672h0.611l118.115%2c69.768 C571.098%2c441.238%2c576.197%2c447.968%2c577.83%2c456.128z'/%3e %3c/g%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3c/svg%3e";

var img$o = "data:image/svg+xml,%3c%3fxml version='1.0' %3f%3e%3csvg enable-background='new 0 0 50 50' version='1.1' viewBox='9 9 32 32' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3crect fill='none' /%3e %3cline fill='none' stroke='currentColor' stroke-miterlimit='10' stroke-width='6' x1='9' x2='41' y1='25' y2='25'/%3e %3cline fill='none' stroke='currentColor' stroke-miterlimit='10' stroke-width='6' x1='25' x2='25' y1='9' y2='41'/%3e%3c/svg%3e";

var img$n = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 23.0.4%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 440 440' style='enable-background:new 0 0 440 440%3b' xml:space='preserve'%3e%3cmetadata%3e%3c%3fxpacket begin=' ' id='W5M0MpCehiHzreSzNTczkc9d'%3f%3e%3cx:xmpmeta xmlns:x='adobe:ns:meta/' x:xmptk='Adobe XMP Core 5.6-c145 79.163499%2c 2018/08/13-16:40:22 '%3e %3crdf:RDF xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%3e %3crdf:Description rdf:about='' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:xmp='http://ns.adobe.com/xap/1.0/' xmlns:xmpGImg='http://ns.adobe.com/xap/1.0/g/img/' xmlns:xmpMM='http://ns.adobe.com/xap/1.0/mm/' xmlns:stRef='http://ns.adobe.com/xap/1.0/sType/ResourceRef%23' xmlns:stEvt='http://ns.adobe.com/xap/1.0/sType/ResourceEvent%23' xmlns:illustrator='http://ns.adobe.com/illustrator/1.0/' xmlns:xmpTPg='http://ns.adobe.com/xap/1.0/t/pg/' xmlns:stDim='http://ns.adobe.com/xap/1.0/sType/Dimensions%23' xmlns:xmpG='http://ns.adobe.com/xap/1.0/g/' xmlns:pdf='http://ns.adobe.com/pdf/1.3/'%3e %3cdc:format%3eimage/svg%2bxml%3c/dc:format%3e %3cdc:title%3e %3crdf:Alt%3e %3crdf:li xml:lang='x-default'%3eIcons%3c/rdf:li%3e %3c/rdf:Alt%3e %3c/dc:title%3e %3cxmp:CreatorTool%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/xmp:CreatorTool%3e %3cxmp:CreateDate%3e2019-08-26T23:17:08%2b02:00%3c/xmp:CreateDate%3e %3cxmp:ModifyDate%3e2019-08-26T23:17:08%2b02:00%3c/xmp:ModifyDate%3e %3cxmp:MetadataDate%3e2019-08-26T23:17:08%2b02:00%3c/xmp:MetadataDate%3e %3cxmp:Thumbnails%3e %3crdf:Alt%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpGImg:width%3e168%3c/xmpGImg:width%3e %3cxmpGImg:height%3e256%3c/xmpGImg:height%3e %3cxmpGImg:format%3eJPEG%3c/xmpGImg:format%3e %3cxmpGImg:image%3e/9j/4AAQSkZJRgABAgEAYABgAAD/7QAsUGhvdG9zaG9wIDMuMAA4QklNA%2b0AAAAAABAAYAAAAAEA%26%23xA%3bAQBgAAAAAQAB/%2b4ADkFkb2JlAGTAAAAAAf/bAIQABgQEBAUEBgUFBgkGBQYJCwgGBggLDAoKCwoK%26%23xA%3bDBAMDAwMDAwQDA4PEA8ODBMTFBQTExwbGxscHx8fHx8fHx8fHwEHBwcNDA0YEBAYGhURFRofHx8f%26%23xA%3bHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8f/8AAEQgBAACoAwER%26%23xA%3bAAIRAQMRAf/EAaIAAAAHAQEBAQEAAAAAAAAAAAQFAwIGAQAHCAkKCwEAAgIDAQEBAQEAAAAAAAAA%26%23xA%3bAQACAwQFBgcICQoLEAACAQMDAgQCBgcDBAIGAnMBAgMRBAAFIRIxQVEGE2EicYEUMpGhBxWxQiPB%26%23xA%3bUtHhMxZi8CRygvElQzRTkqKyY3PCNUQnk6OzNhdUZHTD0uIIJoMJChgZhJRFRqS0VtNVKBry4/PE%26%23xA%3b1OT0ZXWFlaW1xdXl9WZ2hpamtsbW5vY3R1dnd4eXp7fH1%2bf3OEhYaHiImKi4yNjo%2bCk5SVlpeYmZ%26%23xA%3bqbnJ2en5KjpKWmp6ipqqusra6voRAAICAQIDBQUEBQYECAMDbQEAAhEDBCESMUEFURNhIgZxgZEy%26%23xA%3bobHwFMHR4SNCFVJicvEzJDRDghaSUyWiY7LCB3PSNeJEgxdUkwgJChgZJjZFGidkdFU38qOzwygp%26%23xA%3b0%2bPzhJSktMTU5PRldYWVpbXF1eX1RlZmdoaWprbG1ub2R1dnd4eXp7fH1%2bf3OEhYaHiImKi4yNjo%26%23xA%3b%2bDlJWWl5iZmpucnZ6fkqOkpaanqKmqq6ytrq%2bv/aAAwDAQACEQMRAD8A63%2bf/nXyfo/kXU/L%2btav%26%23xA%3bFpuo%2bYbC6t9MWWO4lDNwCln%2brxTsiguNyPliqTflPcfkR%2bY1lfvpvlHQUvdNuJIp7Y6bagtDzYQX%26%23xA%3bCB4lbhKgB3FVaqn3VZj%2bSiIn5WeXkRQqLbsFUCgAEr0AGKvN/wA1vzs/LS585Q%2bStbmtX0fSLmC6%26%23xA%3b1m4uYZbuCSeKSjWixRRThiiEl%2bQpy%2bHqDiqf%2bbvKP5Pap%2bTvmHzN5b8uaI9vLod/dabqNvp1vE6s%26%23xA%3bltIVdCYkkjdHX2ZSPHFXr%2bKuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV5N%2bfX5beQ9T8sa5%26%23xA%3b5y1fR11LXNI0yVrOSa5vEiUQK0iJ6UE8K8eTEmlK4qlv5R2n5FflzaagbHzdoD6hqVxJJNcfpK1Y%26%23xA%3bpb%2boxgtkZ5S/CNCKkmrNue1FWa/ko6P%2bVnl50YMjW7FWBqCDK9CDirzP80vyQ/LWz86RedNahtU0%26%23xA%3bLWLmG21i2up5bSGG4mkq92ssUsAXmgPLk1OW%2b9dlU417W/yT8t/k75q8teUvMWkR28ulamLPTo9W%26%23xA%3bju3aee2kHCISzzSVd%2biL3OwqcVe1Yq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FWnRJEKSKH%26%23xA%3bRhRlYVBHgQcVQ36J0r/lig/5FJ/TFURHHHGgjjUIi7KqgAAewGKtTQQTp6c0ayp14uAwqPY4qofo%26%23xA%3bnSv%2bWKD/AJFJ/TFUVirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVec/nhqXmqx0LQz5dvbvT%26%23xA%3bjcazBDqt9YwJcSxWBt53mcrIroFDIpqaCtN8VfPn/OQU/mXSdF8m%2bZ9N8/3%2bvw6gbiXS75VitGiX%26%23xA%3bhESyPbLE9WrRlboRTrir2/8A5xi85%2bZfNv5Z/pHzFetqF9BfTWqXLqiuYo0jKhigXkRzPxHc98VW%26%23xA%3b%2bdPMWv8Amjz/AKH5a8l6/d6ZY20up2vmbUrG3juI4rm3t7eeCJ3lR0B/eMvUb1HUbKvn7/nIe68%2b%26%23xA%3beQvzP06SDzhqN9qjaTBKupHhayCP6zcqIStuER0BDH4gftHFX1B%2bXfmXzHq/5M6Z5hnlju/ME%2blv%26%23xA%3bcCWcJFFJcKr8DJx9NFUso5dMVeT/APKxv%2bcn/wDfXlX/AKTLT/ssxV3/ACsb/nJ//fXlX/pMtP8A%26%23xA%3bssxV6p%2bT/mH8w9X0rUJfPK6Yl1BMotW0uaOZPSKVb1DHLOAQ3iRirx7zn5/tNR/MPzK9rPp2u6VD%26%23xA%3bNaxabct5wbRYkj%2bowNIkMUNzCkq%2bu0hZ6H4qrXbFUs/xVbf9WvSv/Pjz/wDZbir1L8hb/Wpdc8zW%26%23xA%3bt7bGxsBaaVeadZpq0uuQlbo3itcRXcskxpKIFHENT4ffFUg/5yG/5yQtfK9rN5a8m30c3mn1DDqF%26%23xA%3byq%2botiqj4gCwMbTEnjTfhvWhpirwT8uPzK/PzWPOVtaeXvMOoajqNwxZ4L2d7izWMGsjzJMXjjiU%26%23xA%3bHdgBTtvTFX2H%2bT%2biaTZeWZNVs9abzLfa3cSXOra%2bWJS6uomMEnor9lIozEY0CinEYq8q82f85V6q%26%23xA%3bIBpXlnQIpvMGpXFxYaYq3iXMsU8M/oBprRY1ZS5%2bKNWah69MVYjafnv%2be2jXH6U1DUdI8yadphEm%26%23xA%3buaRYS2Uk8cJIV2Y2w5gKWp6kfNFanLbqq9Z/JL/nIdfzN1/UtJ/Qh0v6lAbuKb6x63KP1EjCsPTS%26%23xA%3bjfHWoxV5/wDnJ%2bZGsXPnb8wPIeu3F2nkmLT7RYp9P09Lx7S4kWzuhJMQ8B4NSUfFIOvtirF4vzk8%26%23xA%3b5Q6na%2bTIDqTfl8ugw2aodIUXz2a6WLR7wQ8i/pm5BcfvqU25Yqnn5O/mNrel%2bafy%2b8i%2bXbq7l8j3%26%23xA%3bEN2kt3f6clmby4M93dSNCS9weMYkiQ8ZTuO1cVTD/nJH8mLrVvM1r5p1HzHNI%2bs3kGi6NpNvp4l9%26%23xA%3bEtDLJEhdrpCVZomLEJXk2y4q82/OP8t9V8g/lT5K0rVruSbULq7v7y4tS3KK1aWOD9xFTwpV6bFq%26%23xA%3b0xV7h/ziBB9Y/Jq8g9R4vV1K7T1YjxkXlDEOSN2YdQcVeQSf84wXsX5hQeWNW16ezuNYuL5tG1Bb%26%23xA%3bQXST29nDFcNNK5uIGV29bgVCn4lO9CDiqF/5y5s9QsvPXl2z1K9/SN/beXLSK5v/AE/R9d0urpTK%26%23xA%3bY%2bUnEvSpHI74q%2bg/In/rLkP/AIDl5/yZlxV8eaBb/lMNA9bzBc6w2uDk31Ww9BYSPVCKgeWNzy4E%26%23xA%3buT02p1xVknk9/wDnH/6xK%2boJexhGiLJrTSyxPbkkXK250xYnW54U9Iy1jr1pscVex/8AOH5gPkjz%26%23xA%3bubcMLf61%2b5D058Pq7ceVNq064q%2be/Kvkby3rFpZT33mSPT2uZOFyp%2bogWy%2bpxrILu%2bspm%2bD4/wB3%26%23xA%3bEwoaAlqqFUw1n8v/ACvbtZhtQl0Iz2%2bpSOupSwXPL6iAbWZDagfu70kogAbdeSNIpGKvqb/nGLRN%26%23xA%3bYi8qQ69ewxwWeoaVptlYIsnqO6WMl27TOAqhOZuwAtSfhPtir5c8y/lB%2bYMv5t3vk/6m93rd9cy3%26%23xA%3bMVwf7qW3lkZvrjPuFjI3YncH4ftbYqn/AJvN75S0K58g%2bQtOvp0n%2bDzV5pS1mWTUZF2a3tzxqloh%26%23xA%3bqNvt/KvJV67/AM4caf8AmFYaVrVvrdvdWvloGJtKhvFeOk7F2mNurgEIQQWpty6b8sVfOWl69Y6F%26%23xA%3b%2ba17qN%2bG%2bpfXNRtrmSMcpIo7tZrZpo1qKvEJvUUV6jFUZodroPk6S/1t/MOn6yJdPvrHTrCx%2bsNJ%26%23xA%3bcPf2slpynjmih9KOITF2D0YlQFB6hV6P/wA4S/8AKf67/wBso/8AUTFiql%2beOoW9t%2bZ35pwS61ea%26%23xA%3bbJdWmmJFY20JlhvSLGE%2bncOFb01XqCSMVY1F5g04eY7Gb/GmsKieVBaNeizb1Y5Kt/uOROG9t/xZ%26%23xA%3bSnviqdfkzqFvced/ymtY9avNQltJNTE2l3EJjt7HnExAtpCoEglpyehNCMVfXXnXyJ5d86abbadr%26%23xA%3b0UstvaXKXtuYJpLd0njR41cPEyNssrd8VeZebf8AnFHyRr9xp3palqNlaWrSNdxtczXckwfjxEb3%26%23xA%3bTyrDTiakIa/Rir03yN5E8t%2bSNBTQvL1u1vYq7TMHdpXeVwAzszE7niOlB7YqhfO35Z%2bVPOk%2bnXGu%26%23xA%3bRXDT6V6wsZba5mtXQXIQS/FCyE8vSXrirzXXP%2bcR/IuseZodSn1HUE0qG2SI6d67zSvKskjM5ubh%26%23xA%3bpmVCHUcFUdCa74q9g0fyxoWj%2bXYPLljaKui28BtY7OQtKphIIZGMhcsCCa8jirHv%2bVKflH/1KGlf%26%23xA%3b9IsX9MVd/wAqU/KP/qUNK/6RYv6YqnejeS/K2haddafoOmW2k215yNwlnEkQZmXhyPEbkDxxV89H%26%23xA%3b/nBzSq7ebp6dv9CT/qtirv8AoRzSv%2bpun/6Qk/6rYq%2bgvI3lWHyn5R0ry3DcNdR6XAsAuXUIz0qS%26%23xA%3b3EE03PSuKrfLnkby/oGp6vq1lE8mqa5cNc6hfXDmaZq/YhV23WKMbIg2AxVP8VdiqFOlaWxJNnAS%26%23xA%3bdyTGlSfuxV36J0r/AJYoP%2bRSf0xVUgsrO3YtBBHExFCyIqkjw2GKvHvPP5AeYfMPmfzVq2mec/0N%26%23xA%3bYeborW31XTf0ZFdco7SBIVX1nmRhUoWqgU703xVLF/5x0/MJdSg1JfzMpe22lDQIZf0HbfDpoqRB%26%23xA%3bx9fiftH4yOf%2bViqN8mf848eYdB1vyneah51/S2l%2bTmuTpOl/oyK24i8UiUeuk7uatRvj5dNqYq9t%26%23xA%3bxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Kux%26%23xA%3bV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV%26%23xA%3b2KuxViPnC/8ANZ8waJonl7ULXTHv4b24uLq7tGvRS19AKqxrPa0r6535Yq%2bbta/5yu8/WXmH9F6f%26%23xA%3bdWd8kV2bWd7jTDaN8EnBmUJe3QoT03xV9f4qwjzXqfnF/NI0rQtUtNLtoNMfUbmS5sWvncrN6fFA%26%23xA%3bLm0C7e5xV4D5b/5yp876v5%2b8u6HbTWl3peq6laWd1JNp5tJxHcXKRNxVbu6UNxaoPI0xV9a4qw/z%26%23xA%3b7rHmW21LyzpGgXdtYXOu309tLeXVs12saQWM93tEstvUsbcL9vvir5089f8AOUv5geXPMGo6JYXt%26%23xA%3blqNzpd3NY3Tz6UbVTJbyNE7R8b65qpZfhrQ07DFX1pYTPPY28705yxI7U6VZQTTFWKeetX80Q635%26%23xA%3bb0Ty/e22nzazNdJPd3Vq14qrbW5nAWJZrbditPtYq%2bcPOX/OVv5gaHrd5pOm3VnqEthcS2txJcaW%26%23xA%3bbRS8LmNinC%2buqjku1aYq%2burCZ57G3nenOWJHanSrKCaYqr4q7FXYq7FXYq7FXYq7FXYq8U/Mfzd%2b%26%23xA%3bZ9l%2baPl5NC8mm6toWntrS5lvLf8A0uCZoPrb%2blGzyQpHxTjI/Tqy02xV8b6xx/x9ecST/uUkrUU3%26%23xA%3b%2bsGvc4q/TPFXhUnm780H/NvXbe78nGTTIbSSyiuYry3Rk04kMt2FmMfr1karcCOIqtCymqr5M/Kk%26%23xA%3bIPzV8ncCSv6c02hIof8AeuLtU4q/SjFXzt/zkd55/MHSvN3lmPy7ok3p6Zfwy6fqjUIu764jeJrS%26%23xA%3bKOpMiNBKyNSjVJpTjuq%2bW/zPeZ/zI81STx%2bjcvrGoNcQAhhHIbqQsiuPtBT%2b1QVxV%2bkek/8AHKsv%26%23xA%3b%2bMEX/EBirwH8zPPH5m6d%2bfGkW1j5bbVNK0tEl0u2iZQ9ylxDIt5KjHjWQJzUJX4eAY7HdV8o%2bf35%26%23xA%3b%2be/Mb0K8tUvTxYUIrcPsR44q/SzSf%2bOVZf8AGCL/AIgMVRWKuxV2KuxV2KuxV2KuxV2KsI87am2j%26%23xA%3b%2bcPLery2GoXtlDbalBM2nWVzfMjzG1MfNLZJGUN6bUJHbFXxr5g/KPz2vm99Q0/RNU1G0ur9rhWj%26%23xA%3b0nVIWRHl5/vBcW0SigO9GOKv0BxV575v1T9EedzdXGnandWl5oklmlxp2n3d%2bqym4LcX%2brRy8fhN%26%23xA%3bd8VfJfkf8ovPmjfmh5UuP0NqN1p9vrNhNPfJpmpQRRxR3UbM8huraDgFUVY9B44q%2b9sVYH%2bZU8tj%26%23xA%3br3krVzYXt/ZabqdzLejT7Se9kjSTTLqFHMVukj09WVRWmKvkD8zvyr876h5y1zXtH0XVdQtNX1G6%26%23xA%3bvYYU0jVYpo0uZmlCyCa1jSo50%2bFzir7y0xHTTbRHUq6wxhlIoQQgBBBxVhf5iXUum%2ba/Jusmwvr6%26%23xA%3bysJ7762dOs7i9kjE1m0aFo7dJHALkCtMVfHX5hflN55ufNGq6rpOiarqVrqV7cXUSR6RqsUqLNK0%26%23xA%3bgEiz2sa1Ab9ljir750xHTTbRHUq6wxhlIoQQgBBBxVE4q7FXYq7FXYq7FXYq7FXYqkHm7zX/AIeT%26%23xA%3bS1j0%2bbU7vV74afaWtu0UbGQwTXFWaZ40ChLdu%2bKsSj/MLz5rmp3ljoOhQ6XFpc7Wd/e6r6l4DdLC%26%23xA%3bLhoYo9OMgokZHKR5AORCKC2Ksi8jecb7XWv9O1ew/RmvaUYTeWys7RPDdIXt7iEyLFIEkCMOMiK6%26%23xA%3bsrKw2xVX8z%2bb5dF1TStKtdKuNWv9XFw1vDbyQRcVtVRpCzTvEvSQU3xViNt%2bYv5ga8Ly70LRLfTd%26%23xA%3bLsGu4jJqS3N7LczWEnpXCwrpolQBZPgT42aQhuCEKcVZh5K81TeYLK8S%2bsjpmtaVdNY6vp5cSiOd%26%23xA%3bUWRWjkovOKWKVJEbiNj0qDiqC8w%2bdr6LWj5b8r6aNa8wpGst76kv1eysYpP7t7ucLIQz9UiRWdhv%26%23xA%3bsN8VQsl5%2bctipupdP0PWIU%2bKTT7Oa5tLkjwiluBJC7ez8AfEYqyDyn5r0rzPpA1LTvUQLI9vd2lw%26%23xA%3bhiuLa4iNJYJ4zukiHqPpGxBxVrzV5s0vy1p8d3fLNPJcSrbWNjaxma5ubhwSsMEYI5MQpO5AABJI%26%23xA%3bAxVjGpfmdrugWTax5q8pXWleXo%2bJudQiura8ktlZgoe4t4m5catv6RkOKpp%2bXfm7WvNmn3WtXOkt%26%23xA%3bpWi3EwPl/wBdiLq4tOI/0iaKlIxI26Cv2foLKsJ1D/nLH8mrK%2bntPr9zcmBzGZ4LZ3iYqaEox48h%26%23xA%3bXv37Yqh/%2bhvfyb/5ab7/AKRG/rirOvy6/NnyT%2bYVvdy%2bWrt5nsWVbu3mjaKVBJXg3FuqtxNCD2xV%26%23xA%3bmGKuxV2KuxV2KuxVgf5qXiWV35KvJF5Jba%2bZnUNGhIj0jUGI5StHGvTq7BfEgYqwfzlov5j%2bVfNb%26%23xA%3beaPK87/UNfnSNrKQQTvDc35ij%2bryW8s8ELj11DpNHOOBZwwdaHFWZflF5G8weX4dS1XzJcGbXNYM%26%23xA%3bYnjMgmMccMk0w5ygIrO813K54KFUEIuy1KrfnHUkh/M7ygttG1/e21rqrvp9u8In4yRwhDSWSJF5%26%23xA%3bcWoWYVoaYqwTXfL/AOanknzTJB5VvGn0/wAz3U8GmikE5SWT61qPpNHdSwLC8K%2bvxmVnVkCq0fJR%26%23xA%3bVV6L%2bU3kfUfKmgTrq0/r6vqMqXF5%2b8acRiKCO2ii9VghlZYoVLvxXk5YgAUxVj/ly%2b8r235V6jqX%26%23xA%3bmQvOnmfUNSTUooBK1zd3FxeTWy2sCw0maQRxrEipuAvgK4qi7nzTo0d1od35q8o6p5f0/Sph%2bhtY%26%23xA%3bvHt5La3eWM2ym6%2bqXM7Qhkk41nXiCdyDiqa6dDFY/nDrENrRY9W0a0vr%2bEDb6xBcS26TH3ki%2bD39%26%23xA%3bMYqk3k%2bbTLnTH/NXzbqjFojfPZpPJxs9MtBO0AjjhWi%2bv6cQWRyC5YlR4YqgdI0jVPzY1S28y%2bZb%26%23xA%3baSy8gWUgn8ueXJxxe/dfsX9%2bn8neKI7U3O32lWT/AJf6lrFjf6h5O19S2qWBl1GzvhMZ0utPvLuc%26%23xA%3bwHkwV0khp6Tow7AgkHZV86eRvyw8n6jf%2bTdPufJdvfWmsWFlcahqLXt7HMxmt2knlHC8jReDqPgE%26%23xA%3bO/bFUJpPkDTrryr5o1O6/K2wi1HR2tFsLddWvyj%2bvMY5hIfr5rwUVFCuKvVv%2bcevL2naN5hu2s9G%26%23xA%3bj0GbUvL%2bn3t/p0E81zGs7X%2boQ8leeW4b4o4U250xV7virsVdirsVdirsVeM/85B%2bV0vLSzu7jXdZ%26%23xA%3bsrXVJX0meGznm%2bo28ctlcuJ5bS2jZpg0qKjhjurFagUxV1pr3k2Hyz5T8m6DqV9q09hqelJHLd21%26%23xA%3b4JWjhvEd2eSWFEVVUGgrRVAA6Yq9mxV8%2b%2bafy%2bsfKX5mnX73zPr9rpnmaea7luLCe45W01sqlIpV%26%23xA%3bijnE0bc%2bMYdaKo47jFWcXfnjy35k81%2bSrPRrie7ntdVnuLgvaXUIWIaPqERdnliiT7cqj5nFXpWK%26%23xA%3bvJtV8qah5U86wa/HY3mt%2bU47u71SKwsFWa40%2b/vo/TuJRbU5zxOWZ19L40Z3%2bEg7Kprrn5j%2bUtf0%26%23xA%3bW%2b0Wx0/Vddm1G3ktZNNt9Nu4m4zIUYSy3kUNvCPi3Mrj6cVR/wCWXkzVdCsptQ1%2bcXHmDUIraCej%26%23xA%3beotva2cfp21qslF5lOTPI/EcpGYgUpirELf8nrrzD591jVfMFs2leUYrwz6f5aiuDNb396la6pcw%26%23xA%3b8ngXmWqIwvxHeQHfmqy//lWlx/1OXmMewu4AP%2bofFU28s%2bTNN0Ce7vI7m71HU74Rpd6lqExnuHjh%26%23xA%3b5elEDRVRE5sQqKBUk9cVeMaL%2bQPnPR/Mei66bbSNT1Dy5HHa6ZdvqV3aJJBbBkt2mtlsbikgjYcu%26%23xA%3bMtCcVQmnf842a3p%2bga1odvo%2bl/UtdNubstrl6XT6pIZYxGf0XQfEd%2bQOKvQ/yf8Ayy13yhcXUuqP%26%23xA%3bZx26WNtpelWNnLLc%2bnb281xcs81xLFbF3ea8f7MYAWnXFXp2KuxV2KuxV2KuxV2KuxV2KuxV2Kux%26%23xA%3bV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KsJ0f8AMDzDrGkWOr6f5Nv5LDUbeK7tJGutOQtD%26%23xA%3bOgkjYq1xVaqw2OKt6r5/13SdOuNS1Lynd2ljaoZbi4lvdNVERRUkn6ziqtZ/mGGh1x9R0i50%2bTQt%26%23xA%3bNi1eWNpbaf1rWcXPBonglkSp%2bpP9ojtiqWRfm28sSSLoZ4uoZa6ppANCK7g3eKrv%2bVry/wDVj/7m%26%23xA%3buj/9leKtXP5r8vKHmLWLTTjHqOiSR2sdrLPBNFJc3KxfV6zWskqcOVwvOhqN8VeWXH5wecfL/mDX%26%23xA%3b45b3WNbu/K8gbW7Z7K1OlywKwWYp9XiSexovJoWklk5gVbFWvzK/PHzuPM91p%2bk2es6NDp6Wzx2S%26%23xA%3bW9qlw7SqzmW4aWLUPhZlEUUaKFZvtONhirOrT8yvMus%2bS/LA0%2beG31jzAb8T60sBkijtNKaRZr2C%26%23xA%3b2bd3uBGjQxmoHPeoG6rEPKX553Ecun6lbXmv%2bYdEuryOw1O01DTIZJoZbpVNtLbXmnRx21ZHkjX6%26%23xA%3bvIefxbUI3VY5rn/OQPnw61e6payX%2bn2tnc3ka2E9tCtjGtmZAttcJ6Etw8jiOMTN9YjaNpVCoR1V%26%23xA%3be%2b/mD5zvfLv5bX3mm3hEV3DbwSrDOplETXEkcZ5IpQuY/UrxDCtKVGKvGv8AoYm8/wCpt/8ADTuv%26%23xA%3b%2b8liqhf/APOSWp2ljc3Vv5kS8uLeJ5YbSTyxc26Suilljab9IP6YcihfiePWmKvdfMPnC701NAgs%26%23xA%3bdOF/qfmGYwWtu8/1eJSlpLduXl4SnZICBRNz4Yq89vNY/MXzL501XS7DVYrCfSoYBJoekataCWEv%26%23xA%3byLyXDXOl3TOWJX7NOPcVOKsM0j8w/O6fmJp1tb%2bZNSudHlh0K6%2bpagLGRmGrX9vaXEUrwW8NQqTt%26%23xA%3bwKcTUA%2b2Kvb/AM0/zAh8geTLvzPNZNqEdq8MZtUkERb1pFjrzKv05V6Yq8huP%2bcg7nRNV8w%2bbbnU%26%23xA%3b7DV/LNxZ6Y%2bgeWbfUrFruOeaKEXalI%2bdwDFIz8uadu2KqM3/ADkFf3Wt6X51ttUsLfyjHolxNqXl%26%23xA%3bN9SsBetqMb3Iji9NqXJZwISOKU9sVe0/ll55i89eSNN81RWjWEeo%2bvxtHcSlPQuJIN3CpWvpV6Yq%26%23xA%3bwPyw/wCdw8i%2bTR5NTy4dF/w7pZ5at9dNz631NOQ/cMqcelMVeffmdb/nFFoDt52k9UJqKnS5IWhN%26%23xA%3bnz%2brzAMREsdI/rn1RoBMDIqiXkePLFWUeTBMPInmX1A6x/4DsTaCSvMWhm1s2nKu/wDvPwxVK9St%26%23xA%3bvyJ0jXV8tN%2bV2p6xqcaQobjTrFJoJZZLRLsrG7XMZLLE9WHEdDirFfzC138sPLy2gtfyhbTXmDSf%26%23xA%3b87FBJZ%2buI2RTBaLbvc85WElasyhffFXod7omiaL5K89WWiacNK086nok0dgAV9Jpk0%2bRlYEmjcm3%26%23xA%3b98VT780vOljqXln80PK0VlPDd6Do/O5vXVRDOLu19VBEwPI8AaNUYqxv/nIFy3mW%2bR1SMQeTNYkg%26%23xA%3bmCiKR3dkR4/VNTOqr8XprTh9ok8qYq9E121trT8x/IdraxJb20Frq0cEEShI0RYbcKqKtAoA2AGK%26%23xA%3btfmbZ2dn5f0SG0gjt4f8S6E/pxIqLyfVoGZqKAKsxJPvirze/gsbz81NbjuLaBv%2bds0CGaERpGsi%26%23xA%3bR2N1NG8kBDM785D%2b%2bY0eg4heGKst/OfUPLkOu6Ba%2bbbq6i8ptY6ldahbWs93D6s8Fxp6WhYWbxyu%26%23xA%3bVkuDxXpU17VCrE9c/MP8sLAT/UIPN2qGxgF9qfDWtatxb2ZlWH1Sbm/i5sXaiotS3tiqW%2bbvNHlu%26%23xA%3b/sbuw8n3ut3Ut5BruhX%2bmXV5qupGaeTTJTZhYLia6UCSQqyuoBX9ojfFXq/mWJ4vM/5ZRSDjJHqF%26%23xA%3b0rr4EaJeAjFXmP5RW/mL/ldeq%2buAbm3fU18w8rK1itQFnVbU2E8QEpLiRTIGA2ryq1MVYXon/kwt%26%23xA%3bI/5gfKP/AHWbPFXtv/OSmj3utflZcaNYhWvdS1DTbO1DniplnvYo05N2HJhvir5Nuf8AnHL8y7eX%26%23xA%3bXYpILTn5dtkvNSpcKaRSRvKvDb4jxibbFXs9r5Jtm8xeTYv%2bVYaS4utHvpWtTd2/C8KCy/0iU%2bhR%26%23xA%3bWj9TYEE/Gd9t1Xr35EwiD8tLKAWqWQiv9XQWcZDJDx1a6HpKwABCfZBAxVvS/wAtfM%2bk6ZaaVpvn%26%23xA%3b7VbfTtPhjtbKD6ppD%2bnBCgjjTm9mWbiigVY1OKt6j%2bW/mjU7Gew1Hz3qN3Y3KGO4tptP0WSN0PVW%26%23xA%3bVrEgjFUZpv5cmKDXU1bXLzWJtesItKmuJo7O3MNpCLgIkSWsEEYIN5Iasp7dhiqjD5D86QxJFH%2bY%26%23xA%3bWqrHGoRF%2bpaOaBRQDeyxV0nkPzlJx9T8wNTfgwdOVjopow6MK2WxGKpZ5n/L/XIPI3mG3s7u68z6%26%23xA%3b/q11Z3kjXH1O2kkNrLbgRp6a2tutIrfvSp74qxHzRoP5g6mnnue18pa01z5xsI7KGzub7R/qto0N%26%23xA%3bv6AZAt6x%2bP7TUGKsj/Nf8sfM3mTXBqGiT2yw6lpcvl7VUm5RPFa3MyyPdAp/vQY15cInoATyB6jF%26%23xA%3bUf8Am75G84%2bZpNJn8sXkdjc2Ud5DNcG8nsLhBdejRoJ4ILohv3JBqvQ4qwzT/wAo/wA4Dr%2bnXeq6%26%23xA%3b0l5p0E%2bkvc2t1rd7exqmmXNrO80VvJYQobiUWhqxcVLt44qyEfld5mi/MybU47i3byzf6rD5huHW%26%23xA%3bsc0VzaWz2yWywD4G9YyiR561bjRhWhKqfeftC1%2b48yaHrOmaPba7a2dnqVhf6bczpbh1vzasrfvI%26%23xA%3b5UdR9VYMpHcYqxPWPIY1hYlvfyi0mkLB1%2br6nDa8qEHjIbeCL1EqoJR6qfDFU80fy95muvNuiX0/%26%23xA%3blmz8t6bpM1/e3BhvEuWuJ72Ewn4I4o/iq3Isx6CnhiqcfmBp%2bvNqflbW9I019XbQr%2be4ubCGWCGZ%26%23xA%3b457C4tQY2uHhi%2bF51Jq426VxVhnlmy866H501/zIPJmsXCa03OGxa50RRAX4mb94L6snJo147DiN%26%23xA%3bt%2buKqPlD8gLqK90jzBresTR6lDBpwu9LjjgKJ%2bjZ47uGH1VLV4ywqGYfaFd%2b%2bKs2/N3QNR13ylHZ%26%23xA%3bWOnyaq8epaddT6fDNHbyS29teRzTqkskkCqxjRqHmPbFXkt5%2bWeqS3Hmh4fy31VI9Vs44NHVtZtC%26%23xA%3bYJ0hlRnm/wByJ5qXdSAeWwO2KsY/MX8nvzL1Sy8ujyZ5N1HRb/TbeWHVbiXV7RvWaRYQvpf6dLxX%26%23xA%3blE5IHHqPDZV7z%2bRPlrzD5a/KvRdF8xQG21q2N215C0kczBpr2aZSZI2kRiySBtm/HFWe4q7FXYqx%26%23xA%3bjzb%2bZXkzyt6kOqapbpqYhkmh0pZFN1KEjaQBYq8hyC7FqD3xVhn5af8AOR/kvzfpKXeryQeWLye7%26%23xA%3bms7W0vLlGWYwpE5ZJmWFa0nUcSBv0rir1oEMAQag7gjoRirFvzP89xeQ/I%2bpeaZLJtQXTxEBaI4i%26%23xA%3b5tNMkK1kKvxHKQVPE/LFVT8tvOsfnfyRpfmmOzfT11JHY2cjczG0crxMA9E5KWjJVuIqO2KslxV2%26%23xA%3bKuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxVSuoXntZoEme3eVGRZ4uPOMsCA6cgy8l6ioIxV85Tfl%26%23xA%3bxeeTfMQs7TSrB7N/Sm8yfmV5pmEktz9ZeksNkvJjFMRyQftV6n7LFVgn5Y%2bXNak8g2Wlx%2bXNH832%26%23xA%3bE91cXGseXZpBFrUIkuBZfWrWXkhjQfVeJYHtvtuFX1J%2bXHkWLyT5e/QdvqN5qFms0ktot86yNbQv%26%23xA%3bThbxsAPgQD76nbpiqW/ntpv6R/J7zbb0rw06W5/6RaXHiP8AfWKq/wCS2mDTPym8pWvHgf0XbTOt%26%23xA%3bKUe4jEzV2G/KQ1xVmmKuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxVJfOHl%2bx1zQp7a50211W%26%23xA%3baAG50%2b1vVDw/XIVLQFq9Pj2J8CR0xViX5O%2bUtY0/SjqXmzy9pmk%2balee3jk05EP%2bhyyfWOPNXlPx%26%23xA%3bzySMw5dcVej4qxr8yYfNVx5I1W38q21tea5PEIre2vOPoOkjqsyuHoprCX2Y0xVX8hw%2bYIPJ2kQ%2b%26%23xA%3bYoIbbWordI723tgghRl%2bELGIyU4hQKUxVPsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsV%26%23xA%3bdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdiry%2bP8AOuLXbLj5UsFF4YYbue61a5sobWys%26%23xA%3b50EourxIbmS4RfSYFV4Akkbgb4qh9A/NDzPqF4DY3egea4IWH17TtBkki1BYW%2bH6xCt3L6cqK1K7%26%23xA%3bgEdGrsVWaeVPOb67f6hpt3o17omo6fHBcSW196BLwXTzJDIjQSzLu1rICDQimKskxV2KuxV2KuxV%26%23xA%3b2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Kvn/zH5Y9X/nHvyrfaTp8IuJNN0iXWbiO3V5JIY9PAhlu%26%23xA%3bAis80Vvc%2bjM6kN8CHbFWM%2bTLmw1zz/5S/wAK210lxYrbyax6morqRjuFYfXbj1Unu/Sie3EkLc2T%26%23xA%3b1mdKJVDRV75pv/k0/MP/AGw9E/6jNWxVlWKuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Ku%26%23xA%3bxVgtp%2bTnluztYbOz1TzBbWltGsNvbw65qaRxxoAqIiLOFVVUUAHTFV0f5Q%2bX42do9X8wo0h5OV13%26%23xA%3bVAWPiaXG%2bKpx5Z8kaR5dur28s5766u7%2bOGG4uNRvbm/k9O2MrRIr3Lysqq1xIaDxxVkGKuxV2Kux%26%23xA%3bV2KuxV2KpTo%2bpa9dX2oQ6lo/6NtbZ%2bNjdfWY5xdJ6sq8%2bCANF%2b7SN6N/PT9k4qm2KuxV2KuxV2Ku%26%23xA%3bxV2KuxV2KuxV8%2b2X/OQGo%2bc7jytqfly7tvL2lR6xJa%2babHUbzTY5ns0SCQSILlklKH1HH7kctjiq%26%23xA%3bX3X/ADknq/nfy1dnyT6XlrWdO1CyEp1K705BPZT%2bsJfT%2bvGOOqmNeQWrfEKYq9W/Lj83NI89675p%26%23xA%3b0vTbVo08sXSWrXvqJLFch5J41liKfsH6tyG%2b4OKs8xV2KvDLnz5%2bb2t6XL5g0GzlstK1C2%2btaTHx%26%23xA%3btZgom0G4liX1Hj%2bIrqXo/a6t8P2ajFVW58zfnYLnUBDG9Fa4SzgC2R%2bJLnTOChim5EL3gofcnotF%26%23xA%3bWW/ll518zapd3GgeZbFodVtLYX/14yQkTQXF7dQQfu4VVU4pbfT1xV6DirsVdirsVdirsVdirsVd%26%23xA%3birsVdirsVdir5L0TyNo8tr%2bWzN%2bWcVydRsfUnc3lsP0mf0cJPVasn7vf97R6eHXFVe68h6Muga1M%26%23xA%3bPywiRodcjgS6%2buWxMCm8t0%2bqgepUhg3p8ht8WKvV/wApNBs9E87%2babW08sJ5TjfTNGlOnJNFcB2N%26%23xA%3bxqS%2bvyiZ1HLjxpWvw4q9WxV2KvmDTfMN1qH5VWvlvUJvLsuj6fpWgT29rfy30U6SStCxa6a2kjoC%26%23xA%3bT%2b64Hc05bYqjorDRf8cl/S8s%2br/i7WXqLrVfrPqtGnM8PX9L61/v1KemP2VGKsn/ACKitodaijtV%26%23xA%3bsUgXyvp/BdLkuJrMD9K6p/cvdNJMwr15sd69sVe1Yq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq%2bZtK%26%23xA%3b8jXEFv5IW58jebGfSbX0tdMepsoeX6kIq2gGqJ6K%2btvRfS%2bHan7OKqtx5JkfSNTt08i%2bbhdXGqpd%26%23xA%3bWrNqbGMWouYZGWRf0qeUvpo1H4seVDy2qFXpX5XaI1l5p8w3sGhavoenXVjpcMKa3dG8mkngmvml%26%23xA%3bMcjXV%2bQipPH8PMb1%2bHepVelYq7FXzf5b0Hz/AGfle30%2bXRfMFtMNP0209OLT9Dnjhex4eoyvPepJ%26%23xA%3bIJeBH7xRxrtirN/L2p61p11qlxqXkvX9Wa91Ce/sfUs9DiNok/8AulWS/q/Ebeo3xHviqa%2bSk1G6%26%23xA%3b/MLVNVPlq98u6UdGsbC2ivEtYw0sF3dzSBFtZrhAKXK9/H2qq9ExV2KuxV2KuxV2KuxV2KuxV2Ku%26%23xA%3bxV2KuxV4dF/zkP5ok0CHWf8ACWnpHc6bPrFvZPryLdyWdsjySyJAbPkaLC33Yqipf%2bcjre8urW38%26%23xA%3btadp%2brAaKut6xcS6ulpDY/vEikglc28oLRtKvXj8sVbuP%2bcg9RsvKvmrXL7y3bh/LlvpN3BDaaoL%26%23xA%3bqG7h1edoY2W4W2UJwC8vstX2xVjfl/8A5y9/THmHyvo/%2bDp7T/Ec9vb/AFqa8oifWL1rT1IP9H/0%26%23xA%3biNeG7fB8YZP2eRVfRWKuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KvjFr3WrXWtO/LRr7y%26%23xA%3bZcOug3Om23nEvcssFpdRTpLEbgTiMSkO1P3dKkbYqo2cNlpFhqet%2bVNE0u2az0lNB1fy/rBuZpNa%26%23xA%3bZ543lvLGGOSN3VmiU7NQLXbFXoHlTyV5v85flv5uTTtS0TTNY8yabotjb6XpstzAunW9lJJ6tteJ%26%23xA%3bW4miMkDvGV35fEp2riqf/lv%2bRnnjy5/h%2bfWtWsb%2b40Wf1JVj9Tm8LcYEhivGiWeH6tBCrckFblON%26%23xA%3bpLSCGM4q91xV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV8V2V7%2bWx/Laz/wBM8sxzx%2bWb%26%23xA%3b%2bHUNPmsIW1aTVmhnFtJHcmBnVldo6H1AajFUwtk8yR3/AJStdfk9b8y7nT7Jvy3v7f0hp9tZkHit%26%23xA%3b8CEJfjz/AN1vv1OKvWv%2bcdpvLLav52gt4LtfOsF3Enni6mMf1SfURNdB3sgjEiMyiU7ouxG3gq9q%26%23xA%3bxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Kv//Z%3c/xmpGImg:image%3e %3c/rdf:li%3e %3c/rdf:Alt%3e %3c/xmp:Thumbnails%3e %3cxmpMM:OriginalDocumentID%3euuid:9E3E5C9A8C81DB118734DB58FDDE4BA7%3c/xmpMM:OriginalDocumentID%3e %3cxmpMM:DocumentID%3exmp.did:fe0cf60e-06e3-4658-abf0-5050fb2655d7%3c/xmpMM:DocumentID%3e %3cxmpMM:InstanceID%3exmp.iid:fe0cf60e-06e3-4658-abf0-5050fb2655d7%3c/xmpMM:InstanceID%3e %3cxmpMM:RenditionClass%3eproof:pdf%3c/xmpMM:RenditionClass%3e %3cxmpMM:DerivedFrom rdf:parseType='Resource'%3e %3cstRef:instanceID%3exmp.iid:99e950d0-a23d-4a93-81f7-58751d461a50%3c/stRef:instanceID%3e %3cstRef:documentID%3exmp.did:99e950d0-a23d-4a93-81f7-58751d461a50%3c/stRef:documentID%3e %3cstRef:originalDocumentID%3euuid:9E3E5C9A8C81DB118734DB58FDDE4BA7%3c/stRef:originalDocumentID%3e %3cstRef:renditionClass%3eproof:pdf%3c/stRef:renditionClass%3e %3c/xmpMM:DerivedFrom%3e %3cxmpMM:History%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cstEvt:action%3esaved%3c/stEvt:action%3e %3cstEvt:instanceID%3exmp.iid:78fa4c27-1810-4112-abf8-25d31ae36cdc%3c/stEvt:instanceID%3e %3cstEvt:when%3e2019-06-10T14:32:07%2b02:00%3c/stEvt:when%3e %3cstEvt:softwareAgent%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/stEvt:softwareAgent%3e %3cstEvt:changed%3e/%3c/stEvt:changed%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cstEvt:action%3esaved%3c/stEvt:action%3e %3cstEvt:instanceID%3exmp.iid:fe0cf60e-06e3-4658-abf0-5050fb2655d7%3c/stEvt:instanceID%3e %3cstEvt:when%3e2019-08-26T23:17:08%2b02:00%3c/stEvt:when%3e %3cstEvt:softwareAgent%3eAdobe Illustrator CC 23.0 (Macintosh)%3c/stEvt:softwareAgent%3e %3cstEvt:changed%3e/%3c/stEvt:changed%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpMM:History%3e %3cillustrator:StartupProfile%3eBasic RGB%3c/illustrator:StartupProfile%3e %3cxmpTPg:NPages%3e1%3c/xmpTPg:NPages%3e %3cxmpTPg:HasVisibleTransparency%3eTrue%3c/xmpTPg:HasVisibleTransparency%3e %3cxmpTPg:HasVisibleOverprint%3eFalse%3c/xmpTPg:HasVisibleOverprint%3e %3cxmpTPg:MaxPageSize rdf:parseType='Resource'%3e %3cstDim:w%3e440.000000%3c/stDim:w%3e %3cstDim:h%3e440.000000%3c/stDim:h%3e %3cstDim:unit%3ePixels%3c/stDim:unit%3e %3c/xmpTPg:MaxPageSize%3e %3cxmpTPg:PlateNames%3e %3crdf:Seq%3e %3crdf:li%3eCyan%3c/rdf:li%3e %3crdf:li%3eMagenta%3c/rdf:li%3e %3crdf:li%3eYellow%3c/rdf:li%3e %3crdf:li%3eBlack%3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpTPg:PlateNames%3e %3cxmpTPg:SwatchGroups%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eDomy%c5%9blna grupa pr%c3%b3bek%3c/xmpG:groupName%3e %3cxmpG:groupType%3e0%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eBia%c5%82y%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eCzarny%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eCzerwony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3e%c5%bb%c3%b3%c5%82ty RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eZielony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eNiebieskozielony RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e255%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eNiebieski RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eKarmazynowy RGB%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e255%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e255%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=193 G=39 B=45%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e193%3c/xmpG:red%3e %3cxmpG:green%3e39%3c/xmpG:green%3e %3cxmpG:blue%3e45%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=237 G=28 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e237%3c/xmpG:red%3e %3cxmpG:green%3e28%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=241 G=90 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e241%3c/xmpG:red%3e %3cxmpG:green%3e90%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=247 G=147 B=30%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e247%3c/xmpG:red%3e %3cxmpG:green%3e147%3c/xmpG:green%3e %3cxmpG:blue%3e30%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=251 G=176 B=59%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e251%3c/xmpG:red%3e %3cxmpG:green%3e176%3c/xmpG:green%3e %3cxmpG:blue%3e59%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=252 G=238 B=33%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e252%3c/xmpG:red%3e %3cxmpG:green%3e238%3c/xmpG:green%3e %3cxmpG:blue%3e33%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=217 G=224 B=33%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e217%3c/xmpG:red%3e %3cxmpG:green%3e224%3c/xmpG:green%3e %3cxmpG:blue%3e33%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=140 G=198 B=63%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e140%3c/xmpG:red%3e %3cxmpG:green%3e198%3c/xmpG:green%3e %3cxmpG:blue%3e63%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=57 G=181 B=74%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e57%3c/xmpG:red%3e %3cxmpG:green%3e181%3c/xmpG:green%3e %3cxmpG:blue%3e74%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=146 B=69%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e146%3c/xmpG:green%3e %3cxmpG:blue%3e69%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=104 B=55%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e104%3c/xmpG:green%3e %3cxmpG:blue%3e55%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=34 G=181 B=115%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e34%3c/xmpG:red%3e %3cxmpG:green%3e181%3c/xmpG:green%3e %3cxmpG:blue%3e115%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=169 B=157%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e169%3c/xmpG:green%3e %3cxmpG:blue%3e157%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=41 G=171 B=226%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e41%3c/xmpG:red%3e %3cxmpG:green%3e171%3c/xmpG:green%3e %3cxmpG:blue%3e226%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=113 B=188%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e113%3c/xmpG:green%3e %3cxmpG:blue%3e188%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=46 G=49 B=146%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e46%3c/xmpG:red%3e %3cxmpG:green%3e49%3c/xmpG:green%3e %3cxmpG:blue%3e146%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=27 G=20 B=100%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e27%3c/xmpG:red%3e %3cxmpG:green%3e20%3c/xmpG:green%3e %3cxmpG:blue%3e100%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=102 G=45 B=145%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e102%3c/xmpG:red%3e %3cxmpG:green%3e45%3c/xmpG:green%3e %3cxmpG:blue%3e145%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=147 G=39 B=143%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e147%3c/xmpG:red%3e %3cxmpG:green%3e39%3c/xmpG:green%3e %3cxmpG:blue%3e143%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=158 G=0 B=93%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e158%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e93%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=212 G=20 B=90%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e212%3c/xmpG:red%3e %3cxmpG:green%3e20%3c/xmpG:green%3e %3cxmpG:blue%3e90%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=237 G=30 B=121%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e237%3c/xmpG:red%3e %3cxmpG:green%3e30%3c/xmpG:green%3e %3cxmpG:blue%3e121%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=199 G=178 B=153%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e199%3c/xmpG:red%3e %3cxmpG:green%3e178%3c/xmpG:green%3e %3cxmpG:blue%3e153%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=153 G=134 B=117%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e153%3c/xmpG:red%3e %3cxmpG:green%3e134%3c/xmpG:green%3e %3cxmpG:blue%3e117%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=115 G=99 B=87%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e115%3c/xmpG:red%3e %3cxmpG:green%3e99%3c/xmpG:green%3e %3cxmpG:blue%3e87%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=83 G=71 B=65%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e83%3c/xmpG:red%3e %3cxmpG:green%3e71%3c/xmpG:green%3e %3cxmpG:blue%3e65%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=198 G=156 B=109%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e198%3c/xmpG:red%3e %3cxmpG:green%3e156%3c/xmpG:green%3e %3cxmpG:blue%3e109%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=166 G=124 B=82%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e166%3c/xmpG:red%3e %3cxmpG:green%3e124%3c/xmpG:green%3e %3cxmpG:blue%3e82%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=140 G=98 B=57%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e140%3c/xmpG:red%3e %3cxmpG:green%3e98%3c/xmpG:green%3e %3cxmpG:blue%3e57%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=117 G=76 B=36%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e117%3c/xmpG:red%3e %3cxmpG:green%3e76%3c/xmpG:green%3e %3cxmpG:blue%3e36%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=96 G=56 B=19%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e96%3c/xmpG:red%3e %3cxmpG:green%3e56%3c/xmpG:green%3e %3cxmpG:blue%3e19%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=66 G=33 B=11%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e66%3c/xmpG:red%3e %3cxmpG:green%3e33%3c/xmpG:green%3e %3cxmpG:blue%3e11%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eZimne%3c/xmpG:groupName%3e %3cxmpG:groupType%3e1%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=56 M=0 Y=20 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e101%3c/xmpG:red%3e %3cxmpG:green%3e200%3c/xmpG:green%3e %3cxmpG:blue%3e208%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=51 M=43 Y=0 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e131%3c/xmpG:red%3e %3cxmpG:green%3e139%3c/xmpG:green%3e %3cxmpG:blue%3e197%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eC=26 M=41 Y=0 K=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e186%3c/xmpG:red%3e %3cxmpG:green%3e155%3c/xmpG:green%3e %3cxmpG:blue%3e201%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:groupName%3eSzaro%c5%9bci%3c/xmpG:groupName%3e %3cxmpG:groupType%3e1%3c/xmpG:groupType%3e %3cxmpG:Colorants%3e %3crdf:Seq%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=0 G=0 B=0%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e0%3c/xmpG:red%3e %3cxmpG:green%3e0%3c/xmpG:green%3e %3cxmpG:blue%3e0%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=26 G=26 B=26%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e26%3c/xmpG:red%3e %3cxmpG:green%3e26%3c/xmpG:green%3e %3cxmpG:blue%3e26%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=51 G=51 B=51%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e51%3c/xmpG:red%3e %3cxmpG:green%3e51%3c/xmpG:green%3e %3cxmpG:blue%3e51%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=77 G=77 B=77%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e77%3c/xmpG:red%3e %3cxmpG:green%3e77%3c/xmpG:green%3e %3cxmpG:blue%3e77%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=102 G=102 B=102%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e102%3c/xmpG:red%3e %3cxmpG:green%3e102%3c/xmpG:green%3e %3cxmpG:blue%3e102%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=128 G=128 B=128%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e128%3c/xmpG:red%3e %3cxmpG:green%3e128%3c/xmpG:green%3e %3cxmpG:blue%3e128%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=153 G=153 B=153%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e153%3c/xmpG:red%3e %3cxmpG:green%3e153%3c/xmpG:green%3e %3cxmpG:blue%3e153%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=179 G=179 B=179%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e179%3c/xmpG:red%3e %3cxmpG:green%3e179%3c/xmpG:green%3e %3cxmpG:blue%3e179%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=204 G=204 B=204%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e204%3c/xmpG:red%3e %3cxmpG:green%3e204%3c/xmpG:green%3e %3cxmpG:blue%3e204%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=230 G=230 B=230%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e230%3c/xmpG:red%3e %3cxmpG:green%3e230%3c/xmpG:green%3e %3cxmpG:blue%3e230%3c/xmpG:blue%3e %3c/rdf:li%3e %3crdf:li rdf:parseType='Resource'%3e %3cxmpG:swatchName%3eR=242 G=242 B=242%3c/xmpG:swatchName%3e %3cxmpG:mode%3eRGB%3c/xmpG:mode%3e %3cxmpG:type%3ePROCESS%3c/xmpG:type%3e %3cxmpG:red%3e242%3c/xmpG:red%3e %3cxmpG:green%3e242%3c/xmpG:green%3e %3cxmpG:blue%3e242%3c/xmpG:blue%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpG:Colorants%3e %3c/rdf:li%3e %3c/rdf:Seq%3e %3c/xmpTPg:SwatchGroups%3e %3cpdf:Producer%3eAdobe PDF library 15.00%3c/pdf:Producer%3e %3c/rdf:Description%3e %3c/rdf:RDF%3e%3c/x:xmpmeta%3e%3c%3fxpacket end='w'%3f%3e %3c/metadata%3e%3cg id='Warstwa'%3e %3cg%3e %3crect x='190' y='190' width='60' height='60'/%3e %3crect x='370' y='250' width='60' height='60'/%3e %3crect x='250' y='250' width='60' height='60'/%3e %3crect x='250' y='370' width='60' height='60'/%3e %3crect x='310' y='310' width='60' height='60'/%3e %3crect x='370' y='370' width='60' height='60'/%3e %3crect x='80' y='310' width='50' height='50'/%3e %3crect x='80' y='70' width='50' height='50'/%3e %3crect x='320' y='70' width='50' height='50'/%3e %3cpath d='M400%2c10H280h-30v30v30h-60V40V10h-30H40H10v30v120v30h30h30v60H40H10v30v120v30h30h120h30v-30v-30h60v-60h-60v-30v-30h-30 h-30v-60h30h30v-30v-30h60v30v30h30h30v60h60v-60h30h30v-30V40V10H400z M160%2c280v120H40V280H160z M40%2c160V40h120v120H40z M400%2c160 H280V40h120V160z'/%3e %3c/g%3e%3c/g%3e%3c/svg%3e";

var img$m = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3csvg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M7.67188 2.75C9.20312 2.75 10.6406 3.35938 11.6875 4.45312L10.3594 4.90625L14.2969 8.32812L15.2969 3.20312L13.8125 3.71875C12.3594 1.78125 10.1094 0.640625 7.67188 0.640625C4.35938 0.640625 1.4375 2.76562 0.390625 5.90625L2.375 6.5625C3.14062 4.28125 5.26562 2.75 7.67188 2.75ZM7.67188 13.9062C6.14062 13.9062 4.70312 13.2969 3.65625 12.2031L4.98438 11.75L1.04688 8.32812L0.046875 13.4531L1.53125 12.9375C2.98438 14.875 5.23438 16 7.67188 16C10.9844 16 13.9062 13.8906 14.9531 10.75L12.9688 10.0938C12.2031 12.375 10.0781 13.9062 7.67188 13.9062Z' fill='currentColor' /%3e%3c/svg%3e";

var img$l = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 24.0.2%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 22.1 20.8' style='enable-background:new 0 0 22.1 20.8%3b' xml:space='preserve'%3e%3ctitle%3ebtn.icon%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cg%3e %3cpath d='M0%2c8.7h16.1v12.1H0V8.7z M14.1%2c18.8v-8.1H2v8.1H14.1z M17.2%2c7.1c-1-1-2.2-1.6-3.5-1.8v2.2L7.2%2c3.8L13.7%2c0v2.3 c2.1%2c0.2%2c4.1%2c1.2%2c5.6%2c2.7c1.8%2c1.8%2c2.8%2c4.2%2c2.8%2c6.7h-3C19.1%2c10%2c18.4%2c8.4%2c17.2%2c7.1z'/%3e%3c/g%3e%3c/svg%3e";

var img$k = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 24.0.2%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 22.1 20.8' style='enable-background:new 0 0 22.1 20.8%3b' xml:space='preserve'%3e%3ctitle%3ebtn.icon%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cg%3e %3cpath d='M2.8%2c5c1.5-1.5%2c3.5-2.5%2c5.6-2.7V0l6.5%2c3.8L8.4%2c7.5V5.3C7.1%2c5.6%2c5.9%2c6.2%2c4.9%2c7.1C3.7%2c8.4%2c3%2c10%2c3%2c11.7H0 C0%2c9.2%2c1%2c6.8%2c2.8%2c5z M6%2c8.7h16.1v12.1H6V8.7z M20.1%2c18.8v-8.1H8v8.1H20.1z'/%3e%3c/g%3e%3c/svg%3e";

var img$j = "data:image/svg+xml,%3csvg viewBox='0.1 0.5 43 42.8' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M4.32422 4.58594H12.0156C12.0156 2.91016 12.0156 1.62109 12.0156 0.761719H0.5C0.5 2.4375 0.5 3.72656 0.5 4.58594V12.2773C2.17578 12.2773 3.46484 12.2773 4.32422 12.2773V4.58594ZM31.2227 0.761719V4.58594C34.6172 4.58594 37.1953 4.58594 38.9141 4.58594V12.2773C40.5898 12.2773 41.8789 12.2773 42.7383 12.2773V4.58594C42.7383 2.95312 42.7383 0.761719 42.7383 0.761719H31.2227ZM29.0742 13.1367C26.9688 11.2891 24.4766 10.3438 21.6406 10.3438C18.7617 10.3438 16.2695 11.2891 14.1641 13.1367C12.0156 14.9844 10.7266 17.2188 10.2539 19.9258H0.5C0.5 21.6445 0.5 22.9336 0.5 23.793H10.2539C10.7266 26.5 12.0156 28.7773 14.1641 30.625C16.2695 32.4727 18.7617 33.418 21.6406 33.418C24.4766 33.418 26.9688 32.4727 29.0742 30.625C31.2227 28.7773 32.5117 26.543 32.9844 23.8359H42.7383C42.7383 22.1172 42.7383 20.8281 42.7383 19.9688H32.9844C32.5117 17.2617 31.2227 14.9844 29.0742 13.1367ZM16.8711 15.8438C18.2461 14.7695 19.8359 14.168 21.6406 14.168C23.4023 14.168 24.9922 14.7266 26.3672 15.8438C27.7422 16.9609 28.6445 18.293 29.0742 19.9258H14.1641C14.5938 18.293 15.4961 16.918 16.8711 15.8438ZM26.3672 27.918C24.9922 28.9922 23.4023 29.5938 21.6406 29.5938C19.8359 29.5938 18.2461 29.0352 16.8711 27.918C15.4961 26.8008 14.5938 25.4688 14.1641 23.8359H29.0742C28.6445 25.4688 27.7422 26.8438 26.3672 27.918ZM4.32422 31.4844C2.64844 31.4844 1.35938 31.4844 0.5 31.4844V39.1758C0.5 40.8516 0.5 42.1406 0.5 43H4.32422C7.76172 43 10.3398 43 12.0156 43V39.1758C8.62109 39.1758 6.04297 39.1758 4.32422 39.1758V31.4844ZM38.9141 39.1758C35.4766 39.1758 32.8984 39.1758 31.2227 39.1758V43C34.6172 43 37.1953 43 38.9141 43H42.7383C42.7383 41.3242 42.7383 40.0352 42.7383 39.1758V31.4844C41.0625 31.4844 39.7734 31.4844 38.9141 31.4844V39.1758Z' fill='currentColor' /%3e%3c/svg%3e";

var img$i = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='3 3 17.5 17.5'%3e %3cpath d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'/%3e%3c/svg%3e";

var img$h = "data:image/svg+xml,%3csvg viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.05469 1.53516H8.37891V3.63281H9.43359V0.480469H0V12H4.71094V10.957H1.05469V1.53516ZM2.89453 3.80859V2.40234H3.36328V2.07422H2.02734V2.40234H2.49609V3.80859H2.89453ZM4.30078 2.07422L3.77344 3.80859H4.18359L4.30078 3.36328H4.80469L4.93359 3.80859H5.35547L4.81641 2.07422H4.30078ZM6.36328 3.80859L6.64453 3.17578L6.79688 3.49219L6.96094 3.80859H7.40625L6.89062 2.91797L7.38281 2.07422H6.9375L6.78516 2.39062L6.66797 2.67188L6.53906 2.39062L6.38672 2.07422H5.92969L6.41016 2.92969L5.91797 3.80859H6.36328ZM4.35938 3.07031L4.46484 2.69531L4.54688 2.36719L4.64062 2.69531L4.74609 3.07031H4.35938ZM2.09766 5.71875H4.71094V4.67578H2.09766V5.71875ZM5.76562 12H11.5195V4.67578H5.76562V12ZM10.7344 5.46094V6.50391H6.55078V5.46094H10.7344ZM2.09766 7.81641H4.71094V6.77344H2.09766V7.81641ZM7.47656 7.53516V8.44922H6.55078V7.53516H7.47656ZM9.10547 7.53516V8.44922H8.17969V7.53516H9.10547ZM10.7344 7.53516V8.44922H9.80859V7.53516H10.7344ZM2.09766 9.91406H4.71094V8.85938H2.09766V9.91406ZM7.47656 8.92969V9.84375H6.55078V8.92969H7.47656ZM9.10547 8.92969V9.84375H8.17969V8.92969H9.10547ZM10.7344 8.92969V9.84375H9.80859V8.92969H10.7344ZM7.47656 10.3242V11.25H6.55078V10.3242H7.47656ZM9.10547 10.3242V11.25H8.17969V10.3242H9.10547ZM10.7344 10.3242V11.25H9.80859V10.3242H10.7344Z' fill='currentColor'/%3e%3c/svg%3e";

var img$g = "data:image/svg+xml,%3csvg viewBox='0 0.88 21.14 21.14' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M10.5703 0.880859C4.74805 0.880859 0 5.62891 0 11.4512C0 17.2734 4.74805 22.0215 10.5703 22.0215C16.3926 22.0215 21.1406 17.2734 21.1406 11.4512C21.1406 5.62891 16.3926 0.880859 10.5703 0.880859ZM10.5703 19.1211C6.33789 19.1211 2.90039 15.6836 2.90039 11.4512C2.90039 7.21875 6.33789 3.78125 10.5703 3.78125C14.8027 3.78125 18.2402 7.21875 18.2402 11.4512C18.2402 15.6836 14.8027 19.1211 10.5703 19.1211ZM9.60352 5.69336V10.4844H6.76758V12.418H9.60352V13.3633H11.5371V12.418H12.4824V10.4844H11.5371V5.69336H9.60352Z' /%3e%3c/svg%3e";

var img$f = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='1 1 22 22' fill='none' style='stroke: currentColor%3b fill: none%3b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-trash-2'%3e%3cpolyline points='3 6 5 6 21 6'%3e%3c/polyline%3e%3cpath d='M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2'%3e%3c/path%3e%3cline x1='10' y1='11' x2='10' y2='17'%3e%3c/line%3e%3cline x1='14' y1='11' x2='14' y2='17'%3e%3c/line%3e%3c/svg%3e";

var img$e = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 24.0.3%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 13.4 13.4' style='enable-background:new 0 0 13.4 13.4%3b' xml:space='preserve'%3e%3ctitle%3e%3b%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cg id='Check-Out-Horizontal'%3e %3cpath id='_x3B_' d='M9.4%2c6.9l0.5-0.5l0%2c0L9.6%2c4.8c0.5-0.5%2c0.9-0.9%2c1.2-1.2c0.6%2c1.3%2c1.1%2c2.2%2c1.4%2c2.9L12.8%2c6 c-0.3-1.6-0.6-2.8-0.7-3.6c0.5-0.5%2c0.9-0.9%2c1.2-1.2c0.1-0.1%2c0.2-0.3%2c0.2-0.5s-0.1-0.4-0.2-0.5C13.1%2c0.1%2c12.9%2c0%2c12.8%2c0 s-0.4%2c0.1-0.5%2c0.2c-0.5%2c0.5-0.9%2c0.9-1.2%2c1.2C9.5%2c1.1%2c8.3%2c0.8%2c7.5%2c0.7L7%2c1.2c1.3%2c0.6%2c2.2%2c1.1%2c2.9%2c1.4C9.3%2c3.1%2c8.9%2c3.5%2c8.7%2c3.8 C7.9%2c3.7%2c7.4%2c3.6%2c7%2c3.6L6.5%2c4C7.4%2c4.5%2c8%2c4.8%2c8.4%2c5C8.8%2c5.9%2c9.2%2c6.5%2c9.4%2c6.9z M1%2c10.3L2.3%2c9C2.2%2c8.9%2c2.1%2c8.9%2c2%2c8.8 C1.8%2c8.8%2c1.7%2c8.7%2c1.6%2c8.7C1.5%2c8.4%2c1.4%2c8.1%2c1.3%2c7.9C1.3%2c7.6%2c1.2%2c7.3%2c1.2%2c7H3c0%2c0.2%2c0%2c0.4%2c0%2c0.6l0%2c0.5c0.3-0.2%2c0.4-0.4%2c0.6-0.6 c0-0.1%2c0-0.2%2c0-0.3c0-0.1%2c0-0.2%2c0-0.3h0.6c0.3-0.2%2c0.5-0.4%2c0.6-0.6H3.7c0-0.4%2c0.1-0.8%2c0.1-1.2C3.8%2c4.9%2c3.9%2c4.5%2c4%2c4 C4.2%2c4%2c4.5%2c3.9%2c4.7%2c3.9c0.2%2c0%2c0.4-0.1%2c0.7-0.1c0-0.1%2c0.1-0.2%2c0.1-0.3c0.1-0.1%2c0.1-0.2%2c0.2-0.3l0.1-0.1c-0.3%2c0-0.5%2c0.1-0.8%2c0.1 c-0.3%2c0-0.5%2c0.1-0.8%2c0.2c0.1-0.3%2c0.2-0.6%2c0.3-0.9s0.2-0.6%2c0.3-0.9c0.2-0.1%2c0.3-0.1%2c0.5-0.2c0.2-0.1%2c0.3-0.1%2c0.5-0.1 c0-0.2%2c0-0.4%2c0.1-0.5C5.9%2c0.6%2c6%2c0.5%2c6.2%2c0.3l0.2-0.2C5.2%2c0.1%2c4.2%2c0.4%2c3.2%2c1S1.5%2c2.4%2c0.9%2c3.3c-0.3%2c0.5-0.5%2c1-0.7%2c1.6 C0.1%2c5.5%2c0%2c6.1%2c0%2c6.7C0%2c7.4%2c0.1%2c8%2c0.3%2c8.6C0.4%2c9.2%2c0.7%2c9.8%2c1%2c10.3z M2%2c4c0.2-0.4%2c0.5-0.8%2c0.9-1.1S3.6%2c2.2%2c4%2c2 C3.9%2c2.3%2c3.8%2c2.5%2c3.7%2c2.8C3.6%2c3%2c3.6%2c3.3%2c3.5%2c3.5C3.2%2c3.6%2c3%2c3.7%2c2.7%2c3.7C2.5%2c3.8%2c2.2%2c3.9%2c2%2c4z M3%2c6.5H1.2c0-0.3%2c0.1-0.6%2c0.1-0.8 c0.1-0.3%2c0.2-0.5%2c0.2-0.8c0.3-0.1%2c0.6-0.2%2c0.9-0.3S3%2c4.3%2c3.3%2c4.2C3.2%2c4.6%2c3.2%2c5%2c3.1%2c5.4C3.1%2c5.7%2c3.1%2c6.1%2c3%2c6.5z M6.2%2c7.9 c0.1%2c0%2c0.2%2c0%2c0.2%2c0c0.1%2c0%2c0.2-0.1%2c0.2-0.1C7%2c7.3%2c7.3%2c7.1%2c7.5%2c6.9c0.1-0.1%2c0.2-0.3%2c0.2-0.4S7.6%2c6.1%2c7.5%2c6C7.3%2c5.9%2c7.2%2c5.8%2c7%2c5.8 S6.7%2c5.9%2c6.6%2c6L5.7%2c6.9C5.6%2c7%2c5.5%2c7.1%2c5.5%2c7.3c0%2c0.2%2c0.1%2c0.3%2c0.2%2c0.4c0.1%2c0.1%2c0.1%2c0.1%2c0.2%2c0.1C6%2c7.9%2c6.1%2c7.9%2c6.2%2c7.9z M6.7%2c13.4 c1.2%2c0%2c2.2-0.3%2c3.2-0.8c1-0.6%2c1.8-1.3%2c2.4-2.2c0.3-0.5%2c0.6-1%2c0.8-1.6c0.2-0.6%2c0.3-1.2%2c0.3-1.8l-0.2%2c0.2c-0.1%2c0.1-0.3%2c0.2-0.4%2c0.3 c-0.2%2c0.1-0.3%2c0.1-0.5%2c0.1h-0.1c0%2c0-0.1%2c0-0.1%2c0C12.1%2c7.8%2c12%2c8%2c12%2c8.2c0%2c0.2-0.1%2c0.3-0.2%2c0.5c-0.3%2c0.1-0.6%2c0.2-0.9%2c0.3 c-0.3%2c0.1-0.6%2c0.2-0.9%2c0.3c0.1-0.3%2c0.1-0.5%2c0.2-0.8s0.1-0.5%2c0.1-0.8l-0.1%2c0.1C10.2%2c7.9%2c10.1%2c8%2c10%2c8C9.9%2c8.1%2c9.8%2c8.1%2c9.7%2c8.1 c0%2c0.2-0.1%2c0.4-0.1%2c0.7c0%2c0.2-0.1%2c0.4-0.2%2c0.7C9%2c9.5%2c8.6%2c9.6%2c8.2%2c9.7C7.8%2c9.7%2c7.4%2c9.8%2c7%2c9.8V8.6C6.8%2c8.9%2c6.6%2c9.1%2c6.5%2c9.2v0.6 c-0.1%2c0-0.2%2c0-0.3%2c0c-0.1%2c0-0.2%2c0-0.3%2c0c-0.2%2c0.2-0.4%2c0.4-0.5%2c0.6l0.5%2c0c0.2%2c0%2c0.4%2c0%2c0.6%2c0v1.8c-0.3%2c0-0.6-0.1-0.9-0.1 C5.3%2c12%2c5%2c12%2c4.8%2c11.9c0-0.1-0.1-0.2-0.2-0.4l-0.1-0.4c-0.6%2c0.6-1%2c1-1.3%2c1.3c0.5%2c0.3%2c1.1%2c0.6%2c1.7%2c0.8C5.4%2c13.4%2c6.1%2c13.4%2c6.7%2c13.4z M3.6%2c10.5c0.1%2c0%2c0.2%2c0%2c0.2%2c0c0.1%2c0%2c0.1-0.1%2c0.2-0.1c0.4-0.4%2c0.7-0.7%2c0.9-0.9C5%2c9.3%2c5%2c9.2%2c5%2c9C5%2c8.8%2c5%2c8.7%2c4.9%2c8.6 C4.7%2c8.4%2c4.6%2c8.4%2c4.4%2c8.4C4.3%2c8.4%2c4.1%2c8.4%2c4%2c8.6C3.6%2c9%2c3.3%2c9.2%2c3.1%2c9.4C3%2c9.6%2c2.9%2c9.7%2c2.9%2c9.9c0%2c0.2%2c0.1%2c0.3%2c0.2%2c0.4 c0.1%2c0.1%2c0.1%2c0.1%2c0.2%2c0.1C3.4%2c10.5%2c3.5%2c10.5%2c3.6%2c10.5z M9.4%2c11.5c0.1-0.3%2c0.2-0.5%2c0.3-0.8c0.1-0.3%2c0.2-0.5%2c0.2-0.8 c0.2-0.1%2c0.5-0.1%2c0.8-0.2c0.3-0.1%2c0.5-0.2%2c0.8-0.3c-0.2%2c0.4-0.5%2c0.8-0.9%2c1.1C10.2%2c11%2c9.9%2c11.3%2c9.4%2c11.5z M7%2c12.2v-1.8 c0.3%2c0%2c0.7%2c0%2c1.1-0.1c0.4%2c0%2c0.8-0.1%2c1.1-0.2C9.2%2c10.4%2c9.1%2c10.7%2c9%2c11c-0.1%2c0.3-0.2%2c0.6-0.3%2c0.9c-0.3%2c0.1-0.5%2c0.2-0.8%2c0.2 C7.6%2c12.2%2c7.3%2c12.2%2c7%2c12.2z M1%2c13.1c0.1%2c0%2c0.2%2c0%2c0.2%2c0c0.1%2c0%2c0.1-0.1%2c0.2-0.2c0.4-0.4%2c0.7-0.7%2c0.9-0.9c0.1-0.1%2c0.2-0.3%2c0.2-0.4 s-0.1-0.3-0.2-0.4C2.1%2c11%2c2%2c11%2c1.8%2c11c-0.2%2c0-0.3%2c0.1-0.4%2c0.2C1%2c11.6%2c0.7%2c11.9%2c0.5%2c12c-0.1%2c0.1-0.2%2c0.3-0.2%2c0.4 c0%2c0.2%2c0.1%2c0.3%2c0.2%2c0.4C0.6%2c13%2c0.7%2c13%2c0.8%2c13C0.8%2c13.1%2c0.9%2c13.1%2c1%2c13.1z'/%3e%3c/g%3e%3c/svg%3e";

var img$d = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' id='Layer_1' x='0px' y='0px' viewBox='0 0 32 29.55' style='enable-background:new 0 0 32 29.5%3b' xml:space='preserve'%3e %3cstyle type='text/css'%3e %3c/style%3e %3cpath d='M17.3%2c0.8c3.3%2c5.9%2c8%2c14.8%2c14.5%2c26.5c0.1%2c0.3%2c0.2%2c0.5%2c0.2%2c0.7c0%2c0.3-0.1%2c0.5-0.2%2c0.8c-0.3%2c0.5-0.7%2c0.7-1.3%2c0.7 H1.6c-0.6%2c0-1.1-0.3-1.4-0.7C0.1%2c28.6%2c0%2c28.3%2c0%2c28.1c0-0.2%2c0-0.5%2c0.2-0.8c3.5-5.7%2c7.9-14.8%2c14.4-26.5C14.9%2c0.3%2c15.4%2c0%2c16%2c0 C16.5%2c0%2c17%2c0.3%2c17.3%2c0.8z'%3e%3c/path%3e %3cpath style='fill:white%3b' d='M17.8%2c20.3c0.3-2.4%2c0.7-6%2c1.2-10.9h-6.2c0.2%2c2.4%2c0.6%2c6%2c1.1%2c10.9H17.8z'%3e%3c/path%3e %3cpath style='fill:white%3b' d='M17.8%2c22.6c-0.9%2c0-2.1%2c0-3.9%2c0v3.9c0.9%2c0%2c2.1%2c0%2c3.9%2c0V22.6z'%3e%3c/path%3e%3c/svg%3e";

const iconTypes = {
    ConnectionLost: img$A,
    ErrorIcon: img$x,
    Arrow: img$N,
    Warning: img$d,
    Search: img$i,
    Calendar: img$L,
    Expand: img$v,
    Collapse: img$C,
    Cancel: img$J,
    Check: img$G,
    CancelFilled: img$I,
    CheckFilled: img$F,
    Trash: img$f,
    Time: img$g,
    ExclamationMark: img$w,
    QRCode: img$n,
    CheckIn: img$E,
    CheckOut: img$D,
    CardKey: img$H,
    Key: img$r,
    Camera: img$K,
    Email: img$y,
    Mobile: img$p,
    Address: img$O,
    Guest: img$s,
    Company: img$B,
    TravelAgent: img$e,
    Booker: img$M,
    Lock: img$q,
    EditPen: img$z,
    FlipHorizontal: img$u,
    FlipVertical: img$t,
    RotateLeft: img$l,
    RotateRight: img$k,
    Scanner: img$j,
    Plus: img$o,
    TaxCalculator: img$h,
    Refresh: img$m,
};
var IconTypes;
(function (IconTypes) {
    IconTypes["errorIcon"] = "ErrorIcon";
    IconTypes["connectionLost"] = "ConnectionLost";
    IconTypes["arrow"] = "Arrow";
    IconTypes["warning"] = "Warning";
    IconTypes["search"] = "Search";
    IconTypes["calendar"] = "Calendar";
    IconTypes["expand"] = "Expand";
    IconTypes["collapse"] = "Collapse";
    IconTypes["cancel"] = "Cancel";
    IconTypes["check"] = "Check";
    IconTypes["cancelFilled"] = "CancelFilled";
    IconTypes["checkFilled"] = "CheckFilled";
    IconTypes["trash"] = "Trash";
    IconTypes["time"] = "Time";
    IconTypes["exclamationMark"] = "ExclamationMark";
    IconTypes["qrCode"] = "QRCode";
    IconTypes["checkIn"] = "CheckIn";
    IconTypes["checkOut"] = "CheckOut";
    IconTypes["cardKey"] = "CardKey";
    IconTypes["key"] = "Key";
    IconTypes["camera"] = "Camera";
    IconTypes["email"] = "Email";
    IconTypes["mobile"] = "Mobile";
    IconTypes["address"] = "Address";
    IconTypes["guest"] = "Guest";
    IconTypes["company"] = "Company";
    IconTypes["travelAgent"] = "TravelAgent";
    IconTypes["booker"] = "Booker";
    IconTypes["lock"] = "Lock";
    IconTypes["editPen"] = "EditPen";
    IconTypes["flipHorizontal"] = "FlipHorizontal";
    IconTypes["flipVertical"] = "FlipVertical";
    IconTypes["rotateLeft"] = "RotateLeft";
    IconTypes["rotateRight"] = "RotateRight";
    IconTypes["scanner"] = "Scanner";
    IconTypes["plus"] = "Plus";
    IconTypes["taxCalculator"] = "TaxCalculator";
    IconTypes["refresh"] = "Refresh";
})(IconTypes || (IconTypes = {}));

var css_248z$W = ".icon-svg-element {\n  width: 100%;\n  height: 100%;\n  fill: currentColor;\n}\n.icon-svg-element svg,\n.icon-svg-element div {\n  display: block;\n  width: 100%;\n  height: 100%;\n}";
styleInject(css_248z$W);

const Icon = ({ className, type, dataTestSelector, color, }) => (jsx(ReactSVG, Object.assign({}, (color && { style: { color: `var(${color})` } }), { src: iconTypes[type], "data-test-selector": dataTestSelector, className: classNames('icon-svg-element', className) }), void 0));

var TextSize;
(function (TextSize) {
    TextSize["xlg"] = "xlg";
    TextSize["lg"] = "lg";
    TextSize["md"] = "md";
    TextSize["sm"] = "sm";
    TextSize["xs"] = "xs";
    TextSize["xxs"] = "xxs";
})(TextSize || (TextSize = {}));
var TextWeight;
(function (TextWeight) {
    TextWeight["bold"] = "bold";
    TextWeight["regular"] = "regular";
    TextWeight["light"] = "light";
})(TextWeight || (TextWeight = {}));

var css_248z$V = ".text-component {\n  margin: 0;\n}\n.text-component.text-component-size-xxs {\n  font-size: var(--font-size-xxs);\n}\n.text-component.text-component-size-xs {\n  font-size: var(--font-size-xs);\n}\n.text-component.text-component-size-sm {\n  font-size: var(--font-size-sm);\n}\n.text-component.text-component-size-md {\n  font-size: var(--font-size-md);\n}\n.text-component.text-component-size-lg {\n  font-size: var(--font-size-lg);\n}\n.text-component.text-component-size-xlg {\n  font-size: var(--font-size-xlg);\n}\n.text-component.text-component-weight-bold {\n  font-weight: var(--font-weight-bold);\n}\n.text-component.text-component-weight-regular {\n  font-weight: var(--font-weight-regular);\n}\n.text-component.text-component-weight-light {\n  font-weight: var(--font-weight-light);\n}\n.text-component.text-component-uppercase {\n  text-transform: uppercase;\n}\n.text-component.text-component-underline {\n  text-decoration: underline;\n}\n.text-component.text-component-hint {\n  font-size: var(--font-size-xs);\n  color: var(--hint-font-color);\n}";
styleInject(css_248z$V);

const Text = ({ id, size = TextSize.sm, weight = TextWeight.regular, uppercase, underline, hint, className, dataTestSelector, children, }) => {
    return (jsx("p", Object.assign({ id: id, "data-test-selector": dataTestSelector, className: classNames('text-component', `text-component-size-${size}`, `text-component-weight-${weight}`, {
            'text-component-hint': hint,
            'text-component-uppercase': uppercase,
            'text-component-underline': underline,
        }, className) }, { children: children }), void 0));
};

var css_248z$U = ".validation-message-component {\n  display: flex;\n  align-items: baseline;\n  min-height: 20px;\n}\n.validation-message-component.validation-message-error {\n  color: var(--error-state-color);\n}\n.validation-message-component.validation-message-warn {\n  color: var(--warning-state-color);\n}\n.validation-message-component .validation-message-icon {\n  min-width: 14px;\n  max-width: 14px;\n  height: 14px;\n  margin-right: var(--spacing-s);\n  fill: currentColor;\n}";
styleInject(css_248z$U);

const ValidationMessage = ({ validationStatus, className, dataTestSelector, }) => {
    const status = useMemo(() => {
        return validationStatus === null || validationStatus === void 0 ? void 0 : validationStatus[0];
    }, [validationStatus]);
    return (jsx("div", Object.assign({ "data-test-selector": dataTestSelector, className: classNames('validation-message-component', { [`validation-message-${status === null || status === void 0 ? void 0 : status.severity}`]: status }, className) }, { children: Boolean(status) && (jsxs(Fragment, { children: [jsx(Icon, { type: IconTypes.warning, className: "validation-message-icon", dataTestSelector: "validation-message-icon" }, void 0), jsx(Text, Object.assign({ size: TextSize.xs, weight: TextWeight.light, dataTestSelector: "validation-message-description" }, { children: status === null || status === void 0 ? void 0 : status.description }), void 0)] }, void 0)) }), void 0));
};

var css_248z$T = ".field-wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.field-wrapper.field-wrapper-with-label {\n  overflow: hidden;\n}\n.field-wrapper .field-label {\n  margin-bottom: var(--spacing-xs);\n  overflow: hidden;\n  font-size: var(--font-size-xs);\n  line-height: 18px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transition: color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n.field-wrapper .field-label.field-label-active {\n  color: var(--active-state-color);\n}\n.field-wrapper .field-label.field-label-disabled {\n  color: var(--gray-color-1);\n}";
styleInject(css_248z$T);

const FieldWrapper = ({ id, isFieldActive, hideValidationMessage, label, validationStatus, dataTestSelector, className, disabled, readonly, children, optional, }) => {
    const { t } = useTranslation('FieldWrapper');
    const shouldValidationMessageBeVisible = useMemo(() => {
        return (!hideValidationMessage &&
            !isFieldActive &&
            Boolean(validationStatus === null || validationStatus === void 0 ? void 0 : validationStatus.length) &&
            !disabled &&
            !readonly);
    }, [
        hideValidationMessage,
        validationStatus,
        isFieldActive,
        disabled,
        readonly,
    ]);
    return (jsxs("div", Object.assign({ "data-test-selector": dataTestSelector, className: classNames('field-wrapper', {
            'field-wrapper-with-label': label,
        }, className) }, { children: [label && (jsx("label", Object.assign({ htmlFor: id, className: classNames('field-label', {
                    'field-label-disabled': disabled,
                    'field-label-active': isFieldActive,
                }) }, { children: `${label}${optional ? ` (${t('OPTIONAL')})` : ''}` }), void 0)), children, !hideValidationMessage && (jsx(ValidationMessage, { className: "spacing-top-xxs", validationStatus: shouldValidationMessageBeVisible ? validationStatus : undefined }, void 0))] }), void 0));
};

var css_248z$S = ".field-component-wrapper {\n  position: relative;\n}\n.field-component-wrapper .field-component {\n  width: 100%;\n  height: 44px;\n  padding: 0 var(--spacing-sm);\n  font-size: var(--font-size-sm);\n  background-color: var(--white-color);\n  border: none;\n  border-radius: 4px;\n  outline: none;\n  box-shadow: inset 0 0 0 1px var(--gray-color-1);\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n.field-component-wrapper .field-component:focus:not(:-moz-read-only) {\n  box-shadow: inset 0 0 0 2px var(--active-state-color);\n}\n.field-component-wrapper .field-component:focus:not(:read-only) {\n  box-shadow: inset 0 0 0 2px var(--active-state-color);\n}\n.field-component-wrapper .field-component:disabled {\n  background-color: var(--gray-color-3);\n  opacity: 1;\n}\n.field-component-wrapper .field-component:-moz-read-only:not(:disabled) {\n  cursor: default;\n  box-shadow: inset 0 0 0 1px var(--gray-color-3);\n}\n.field-component-wrapper .field-component:read-only:not(:disabled) {\n  cursor: default;\n  box-shadow: inset 0 0 0 1px var(--gray-color-3);\n}\n.field-component-wrapper .field-component::-webkit-outer-spin-button, .field-component-wrapper .field-component::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n          appearance: none;\n}\n.field-component-wrapper .field-component-invalid {\n  box-shadow: inset 0 0 0 1px var(--error-state-color);\n}\n.field-component-wrapper .field-with-icon {\n  position: relative;\n  padding-right: 44px;\n}\n.field-component-wrapper .field-icon {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 44px;\n  height: 44px;\n  padding: 11px;\n  color: var(--primary-color);\n  pointer-events: none;\n}";
styleInject(css_248z$S);

var FieldMode;
(function (FieldMode) {
    FieldMode["text"] = "text";
    FieldMode["numeric"] = "numeric";
    FieldMode["email"] = "email";
    FieldMode["tel"] = "tel";
    FieldMode["search"] = "search";
})(FieldMode || (FieldMode = {}));
const Field = ({ mode = FieldMode.text, icon, placeholder, id, label, value = '', optional, name, maxLength = 255, hideValidationMessage, validationStatus, dataTestSelector, className, disabled, readonly, onFocus, onBlur, onChange, }) => {
    const [isFieldActive, setFieldActive] = useState(false);
    const [fieldValue, setFieldValue] = useState(value);
    const isInvalid = useMemo(() => !isFieldActive && Boolean(validationStatus === null || validationStatus === void 0 ? void 0 : validationStatus.length), [isFieldActive, validationStatus]);
    const componentId = useMemo(() => id || generateRandomString(), [id]);
    useEffect(() => {
        setFieldValue(value);
    }, [value]);
    const onChangeHandler = (e) => {
        setFieldValue(e.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
    };
    const onFieldFocus = useCallback(() => {
        if (readonly)
            return;
        setFieldActive(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    }, [onFocus, readonly]);
    const onFieldBlur = useCallback(() => {
        if (readonly)
            return;
        setFieldActive(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    }, [onBlur, readonly]);
    return (jsx(FieldWrapper, Object.assign({ dataTestSelector: dataTestSelector, id: componentId, isFieldActive: isFieldActive, className: className, disabled: disabled, readonly: readonly, label: label, optional: optional, validationStatus: validationStatus, hideValidationMessage: hideValidationMessage }, { children: jsxs("div", Object.assign({ className: "field-component-wrapper" }, { children: [jsx("input", { id: componentId, name: name, autoComplete: "off", maxLength: maxLength === 'none' ? undefined : maxLength, onFocus: onFieldFocus, onBlur: onFieldBlur, onChange: onChangeHandler, type: "text", inputMode: mode, className: classNames('field-component', 'field-text', className, {
                        'field-with-icon': icon,
                        'field-component-invalid': isInvalid,
                    }), placeholder: placeholder, disabled: disabled, readOnly: readonly, value: fieldValue }, void 0), icon && jsx(Icon, { type: icon, className: "field-icon" }, void 0)] }), void 0) }), void 0));
};

var reactMobileDatepicker = {exports: {}};

(function (module, exports) {
(function (global, factory) {
	module.exports = factory(React__default, require$$1$1) ;
}(commonjsGlobal, (function (React,ReactDOM) {
function __$styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var React__default = 'default' in React ? React['default'] : React;
ReactDOM = ReactDOM && ReactDOM.hasOwnProperty('default') ? ReactDOM['default'] : ReactDOM;

__$styleInject(".datepicker-modal {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, .6);\n    z-index: 999;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n\n.datepicker {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    z-index: 1;\n    font-size: 16px;\n    text-align: center;\n    font-family: arial,verdana,sans-serif;\n    -webkit-box-sizing: content-box;\n            box-sizing: content-box;\n    -webkit-font-smoothing: antialiased;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.datepicker .datepicker-header {\n        padding: 0 .5em;\n        min-height: 2em;\n        line-height: 2em;\n        font-size: 1.125em;\n    }\n\n.datepicker .datepicker-navbar {\n        padding: 0 .5em .5em .5em;\n        overflow: hidden;\n    }\n\n.datepicker .datepicker-navbar-btn {\n        height: 2.5em;\n        line-height: 2.5em;\n        float: right;\n        padding: 0 1em;\n        cursor: pointer;\n    }\n\n.datepicker .datepicker-caption {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        padding: .5em .25em;\n    }\n\n.datepicker .datepicker-caption-item {\n        -webkit-box-flex: 1;\n            -ms-flex: 1;\n                flex: 1;\n        margin: 0 .25em;\n        height: 40px;\n        line-height: 40px;\n        font-size: 1.2em;\n    }\n\n.datepicker .datepicker-content {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        padding: .5em .25em;\n    }\n\n.datepicker .datepicker-col-1 {\n        -webkit-box-flex: 1;\n            -ms-flex: 1;\n                flex: 1;\n        margin: 0 .25em;\n    }\n\n.datepicker .datepicker-viewport {\n        height: 200px;\n        position: relative;\n        overflow: hidden\n    }\n\n.datepicker .datepicker-viewport::after {\n    content: '';\n    position: absolute;\n    z-index: 2;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    pointer-events: none;\n}\n\n.datepicker .datepicker-wheel {\n        position: absolute;\n        height: 40px;\n        top: 50%;\n        margin-top: -20px;\n        width: 100%;\n    }\n\n.datepicker .datepicker-scroll {\n        list-style-type: none;\n        padding: 0\n    }\n\n.datepicker .datepicker-scroll>li {\n    height: 40px;\n    line-height: 40px;\n    font-size: 1.375em;\n    cursor: pointer;\n}\n\n.datepicker {\n\n    /* default */\n}\n\n.datepicker.default {\n    background-color: #f7f7f7;\n}\n\n.datepicker.default .datepicker-header {\n            color: #4eccc4;\n}\n\n.datepicker.default .datepicker-wheel {\n            border-top: 1px solid #4eccc4;\n            border-bottom: 1px solid #4eccc4;\n}\n\n.datepicker.default .datepicker-caption-item {\n            color: rgb(59, 59, 59);\n}\n\n.datepicker.default .datepicker-scroll li {\n                color: rgb(59, 59, 59);\n            }\n\n.datepicker.default .datepicker-scroll li.disabled {\n                color: rgb(191, 191, 191);\n            }\n\n.datepicker.default .datepicker-navbar-btn {\n            color: #4eccc4;\n}\n\n.datepicker {\n\n    /* dark */\n}\n\n.datepicker.dark {\n    background-color: #263238;\n}\n\n.datepicker.dark .datepicker-header {\n            color: #50ccc4;\n}\n\n.datepicker.dark .datepicker-wheel {\n            border-top: 1px solid #50ccc4;\n            border-bottom: 1px solid #50ccc4;\n}\n\n.datepicker.dark .datepicker-caption-item {\n            color: rgb(201, 203, 204);\n}\n\n.datepicker.dark .datepicker-scroll li {\n                color: rgb(201, 203, 204);\n            }\n\n.datepicker.dark .datepicker-scroll li.disabled {\n                color: rgb(87, 96, 100);\n            }\n\n.datepicker.dark .datepicker-navbar-btn {\n            color: #50ccc4;\n}\n\n.datepicker {\n\n    /* ios */\n}\n\n.datepicker.ios {\n    background-color: #f7f7f7;\n}\n\n.datepicker.ios .datepicker-col-1 {margin: 0;\n}\n\n.datepicker.ios .datepicker-header {\n            color: rgb(59, 59, 59);\n            padding: 0 3.5em;\n}\n\n.datepicker.ios .datepicker-viewport::after {\n    background: -webkit-gradient(linear,left top, left bottom,from(#f7f7f7),color-stop(52%, rgba(245, 245, 245, 0)),color-stop(48%, rgba(245, 245, 245, 0)),to(#f7f7f7));\n    background: linear-gradient(#f7f7f7,rgba(245, 245, 245, 0)52%,rgba(245, 245, 245, 0)48%,#f7f7f7);\n}\n\n.datepicker.ios .datepicker-wheel {\n            border-top: 1px solid #dbdbdb;\n            border-bottom: 1px solid #dbdbdb;\n}\n\n.datepicker.ios .datepicker-caption-item {\n            color: rgb(59, 59, 59);\n}\n\n.datepicker.ios .datepicker-scroll li {\n                color: rgb(59, 59, 59);\n            }\n\n.datepicker.ios .datepicker-scroll li.disabled {\n                color: rgb(191, 191, 191);\n            }\n\n.datepicker.ios .datepicker-navbar {\n            position: absolute;\n            z-index: 2;\n            top: 0;\n            left: 0;\n            width: 100%;\n            padding: 0;\n            border-bottom: 1px solid #acacac;\n}\n\n.datepicker.ios .datepicker-navbar-btn {\n            color: #007aff;\n}\n\n.datepicker.ios .datepicker-navbar-btn:nth-child(2) {\n    float: left;\n}\n\n.datepicker.ios .datepicker-content {\n            padding-top: 48px;\n}\n\n.datepicker.ios .datepicker-header + .datepicker-content {\n          padding-top: 0;\n}\n\n.datepicker.ios .datepicker-caption + .datepicker-content {\n          padding-top: 0;\n}\n\n.datepicker {\n\n    /* android */\n}\n\n.datepicker.android, .datepicker.android-dark {\n    background-color: #f5f5f5;\n}\n\n.datepicker.android .datepicker-header, .datepicker.android-dark .datepicker-header {\n            color: #31b6e7;\n            border-bottom: 2px solid #31b6e7;\n}\n\n.datepicker.android .datepicker-col-1, .datepicker.android-dark .datepicker-col-1 {margin: 0 .625em;\n}\n\n.datepicker.android .datepicker-viewport::after, .datepicker.android-dark .datepicker-viewport::after {\n    background-image: -webkit-gradient(linear,left top, left bottom,from(#f5f5f5),color-stop(52%, rgba(245, 245, 245, 0)),color-stop(48%, rgba(245, 245, 245, 0)),to(#f5f5f5));\n    background-image: linear-gradient(#f5f5f5,rgba(245, 245, 245, 0)52%,rgba(245, 245, 245, 0)48%,#f5f5f5);\n}\n\n.datepicker.android .datepicker-wheel, .datepicker.android-dark .datepicker-wheel {\n            border-top: 2px solid #31b6e7;\n            border-bottom: 2px solid #31b6e7;\n}\n\n.datepicker.android .datepicker-caption-item, .datepicker.android-dark .datepicker-caption-item {\n            color: rgb(56, 56, 56);\n}\n\n.datepicker.android .datepicker-scroll li, .datepicker.android-dark .datepicker-scroll li {\n                font-size: 1.125em;\n                color: rgb(56, 56, 56);\n            }\n\n.datepicker.android .datepicker-scroll li.disabled, .datepicker.android-dark .datepicker-scroll li.disabled {\n                color: rgb(188, 188, 188);\n            }\n\n.datepicker.android .datepicker-navbar, .datepicker.android-dark .datepicker-navbar {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            border-top: 1px solid #d9d4d4;\n            padding: 0;\n}\n\n.datepicker.android .datepicker-navbar-btn, .datepicker.android-dark .datepicker-navbar-btn {\n            padding: 0;\n            color: #000;\n            -webkit-box-flex: 1;\n                -ms-flex: 1;\n                    flex: 1;\n}\n\n.datepicker.android .datepicker-navbar-btn:nth-child(2), .datepicker.android-dark .datepicker-navbar-btn:nth-child(2) {\n    border-left: 1px solid #d9d4d4;\n}\n\n.datepicker {\n\n    /* android-dark */\n}\n\n.datepicker.android-dark {\n    background-color: #292829;\n}\n\n.datepicker.android-dark .datepicker-viewport::after {\n    background-image: -webkit-gradient(linear,left top, left bottom,from(#282828),color-stop(52%, rgba(40, 40, 40, 0)),color-stop(48%, rgba(40, 40, 40, 0)),to(#282828));\n    background-image: linear-gradient(#282828,rgba(40, 40, 40, 0)52%,rgba(40, 40, 40, 0)48%,#282828);\n}\n\n.datepicker.android-dark .datepicker-caption-item {\n            color: rgb(199, 199, 199);\n}\n\n.datepicker.android-dark .datepicker-scroll li {\n                color: rgb(199, 199, 199);\n            }\n\n.datepicker.android-dark .datepicker-scroll li.disabled {\n                color: rgb(88, 88, 88);\n            }\n\n.datepicker.android-dark .datepicker-navbar { border-color: #424542;\n}\n\n.datepicker.android-dark .datepicker-navbar-btn {\n            color: #fff;\n}\n\n.datepicker.android-dark .datepicker-navbar-btn:nth-child(2) {\n    border-color: #424542;\n}\n", {});

/**
 * @module time工具
 */

function throwIfInvalidDate(date) {
    if (Object.prototype.toString.call(date, null) !== '[object Date]') {
        throw new Error('参数类型不对');
    }
}

function daysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

/**
 * 对Date的扩展，将 Date 转化为指定格式的String
 * @param  {Date}       日期
 * @return {String}     字符串格式
 */
function convertDate(date, format) {
    var str = format;
    var o = {
        'M+': date.getMonth() + 1,
        'D+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    if (/(Y+)/.test(format)) {
        str = str.replace(RegExp.$1, date.getFullYear().toString().substr(4 - RegExp.$1.length));
    }

    for (var k in o) {
        // eslint-disable-line
        if (new RegExp('(' + k + ')').test(format)) {
            str = str.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(o[k].toString().length));
        }
    }

    return str;
}

/**
 * 获取相对日期的偏移日期
 * @param  {Date}       日期
 * @return {number}     相对的天数
 */
function nextYear(now) {
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    throwIfInvalidDate(now);
    var date = new Date(now.getFullYear() + index, now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds());
    return date;
}

function nextMonth(now) {
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    throwIfInvalidDate(now);
    var year = now.getFullYear();
    var month = now.getMonth() + index;
    var dayOfMonth = Math.min(now.getDate(), daysInMonth(year, month));
    var date = new Date(year, month, dayOfMonth, now.getHours(), now.getMinutes(), now.getSeconds());
    return date;
}

function nextDate(now) {
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    throwIfInvalidDate(now);
    var date = new Date(now.getTime() + index * 24 * 60 * 60 * 1000);
    return date;
}

function nextHour(now) {
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    throwIfInvalidDate(now);
    var date = new Date(now.getTime() + index * 60 * 60 * 1000);
    return date;
}

function nextMinute(now) {
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    throwIfInvalidDate(now);
    var date = new Date(now.getTime() + index * 60 * 1000);
    return date;
}

function nextSecond(now) {
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    throwIfInvalidDate(now);
    var date = new Date(now.getTime() + index * 1000);
    return date;
}

var TimeUtil = Object.freeze({
	convertDate: convertDate,
	nextYear: nextYear,
	nextMonth: nextMonth,
	nextDate: nextDate,
	nextHour: nextHour,
	nextMinute: nextMinute,
	nextSecond: nextSecond
});

function shallowEqual(prev, next) {
    if (prev === next) return true;
    var prevKeys = Object.keys(prev);
    var nextKeys = Object.keys(next);

    if (prevKeys.length !== nextKeys.length) return false;

    return prevKeys.every(function (key) {
        return prev.hasOwnProperty(key) && prev[key] === next[key];
    });
}

function PureRender(Component$$1) {
    Component$$1.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return PureRender.shouldComponentUpdate(nextProps, nextState, this.props, this.state);
    };
}

PureRender.shouldComponentUpdate = function (nextProps, nextState, preProps, preState) {
    return !shallowEqual(preProps, nextProps) || !shallowEqual(preState, nextState);
};

/**
 * 驼峰写法
 * @param  {String} str 要转化的字符串
 * @return {String}     转化后的字符串
 */
function camelCase(str) {
    return str.replace(/-([a-z])/g, function ($0, $1) {
        return $1.toUpperCase();
    }).replace('-', '');
}

/**
 * 格式化css属性对象
 * @param  {Object} props 属性对象
 * @return {Object}       添加前缀的格式化属性对象
 */
function formatCss(props) {
    var prefixs = ['-webkit-', '-moz-', '-ms-'];

    var result = {};

    var regPrefix = /transform|transition/;

    for (var key in props) {
        if (props.hasOwnProperty(key)) {
            var styleValue = props[key];

            // 如果检测是transform或transition属性
            if (regPrefix.test(key)) {
                for (var i = 0; i < prefixs.length; i++) {
                    var styleName = camelCase(prefixs[i] + key);
                    result[styleName] = styleValue.replace(regPrefix, prefixs[i] + '$&');
                }
            }

            result[key] = styleValue;
        }
    }

    return result;
}

/**
 * 为元素添加css样式
 * @param {Object} element 目标元素
 * @param {Object} props   css属性对象
 */
function addPrefixCss(element, props) {
    var formatedProps = formatCss(props);
    for (var key in formatedProps) {
        if (formatedProps.hasOwnProperty(key)) {
            element.style[key] = formatedProps[key];
        }
    }
}





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

















var toArray = function (arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/**
 * @module Date组件
 */
var DATE_HEIGHT = 40; // 每个日期的高度
var DATE_LENGTH = 10; // 日期的个数
var MIDDLE_INDEX = Math.floor(DATE_LENGTH / 2); // 日期数组中间值的索引
var MIDDLE_Y = -DATE_HEIGHT * MIDDLE_INDEX; // translateY值

var isUndefined = function isUndefined(val) {
    return typeof val === 'undefined';
};
var isFunction = function isFunction(val) {
    return Object.prototype.toString.apply(val) === '[object Function]';
};

/**
 * Class Date组件类
 * @extends Component
 */
var DatePickerItem = function (_Component) {
    inherits(DatePickerItem, _Component);

    function DatePickerItem(props) {
        classCallCheck(this, DatePickerItem);

        var _this = possibleConstructorReturn(this, (DatePickerItem.__proto__ || Object.getPrototypeOf(DatePickerItem)).call(this, props));

        _this.animating = false; // 判断是否在transition过渡动画之中
        _this.touchY = 0; // 保存touchstart的pageY
        _this.translateY = 0; // 容器偏移的距离
        _this.currentIndex = MIDDLE_INDEX; // 滑动中当前日期的索引
        _this.moveDateCount = 0; // 一次滑动移动了多少个时间

        _this.state = {
            translateY: MIDDLE_Y,
            marginTop: (_this.currentIndex - MIDDLE_INDEX) * DATE_HEIGHT
        };

        _this.renderDatepickerItem = _this.renderDatepickerItem.bind(_this);
        _this.handleContentTouch = _this.handleContentTouch.bind(_this);
        _this.handleContentMouseDown = _this.handleContentMouseDown.bind(_this);
        _this.handleContentMouseMove = _this.handleContentMouseMove.bind(_this);
        _this.handleContentMouseUp = _this.handleContentMouseUp.bind(_this);
        return _this;
    }

    createClass(DatePickerItem, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this._iniDates(this.props.value);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var viewport = this.viewport;
            viewport.addEventListener('touchstart', this.handleContentTouch, false);
            viewport.addEventListener('touchmove', this.handleContentTouch, false);
            viewport.addEventListener('touchend', this.handleContentTouch, false);
            viewport.addEventListener('mousedown', this.handleContentMouseDown, false);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.value.getTime() === this.props.value.getTime()) {
                return;
            }
            this._iniDates(nextProps.value);
            this.currentIndex = MIDDLE_INDEX;
            this.setState({
                translateY: MIDDLE_Y,
                marginTop: (this.currentIndex - MIDDLE_INDEX) * DATE_HEIGHT
            });
        }

        /**
         * Optimization component, Prevents unnecessary rendering
         * Only value or state change should re-rendering
         *
         * @param  {Object} nextProps next props
         * @param  {Object} nextState next state
         * @return {Boolean}          Whether re-rendering
         */

    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return nextProps.value.getTime() !== this.props.value.getTime() || !shallowEqual(nextState, this.state);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var viewport = this.viewport;
            viewport.removeEventListener('touchstart', this.handleContentTouch, false);
            viewport.removeEventListener('touchmove', this.handleContentTouch, false);
            viewport.removeEventListener('touchend', this.handleContentTouch, false);
            viewport.removeEventListener('mousedown', this.handleContentMouseDown, false);
        }
    }, {
        key: '_iniDates',
        value: function _iniDates(date) {
            var _this2 = this;

            var typeName = this.props.type;
            var dates = Array.apply(undefined, toConsumableArray(Array(DATE_LENGTH))).map(function (value, index) {
                return TimeUtil['next' + typeName](date, (index - MIDDLE_INDEX) * _this2.props.step);
            });
            this.setState({ dates: dates });
        }
    }, {
        key: '_updateDates',
        value: function _updateDates(direction) {
            var typeName = this.props.type;
            var dates = this.state.dates;

            if (direction === 1) {
                this.currentIndex++;
                this.setState({
                    dates: [].concat(toConsumableArray(dates.slice(1)), [TimeUtil['next' + typeName](dates[dates.length - 1], this.props.step)]),
                    marginTop: (this.currentIndex - MIDDLE_INDEX) * DATE_HEIGHT
                });
            } else {
                this.currentIndex--;
                this.setState({
                    dates: [TimeUtil['next' + typeName](dates[0], -this.props.step)].concat(toConsumableArray(dates.slice(0, dates.length - 1))),
                    marginTop: (this.currentIndex - MIDDLE_INDEX) * DATE_HEIGHT
                });
            }
        }
    }, {
        key: '_checkIsUpdateDates',
        value: function _checkIsUpdateDates(direction, translateY) {
            return direction === 1 ? this.currentIndex * DATE_HEIGHT + DATE_HEIGHT / 2 < -translateY : this.currentIndex * DATE_HEIGHT - DATE_HEIGHT / 2 > -translateY;
        }

        /**
         * 清除对象的transition样式
         * @param  {Dom}     obj     指定的对象
         * @return {undefined}
         */

    }, {
        key: '_clearTransition',
        value: function _clearTransition(obj) {
            addPrefixCss(obj, { transition: '' });
        }

        /**
         * 滑动到下一日期
         * @param  {number} direction 滑动方向
         * @return {undefined}
         */

    }, {
        key: '_moveToNext',
        value: function _moveToNext(direction) {
            var date = this.state.dates[MIDDLE_INDEX];
            var _props = this.props,
                max = _props.max,
                min = _props.min;

            if (direction === -1 && date.getTime() < min.getTime() && this.moveDateCount) {
                this._updateDates(1);
            } else if (direction === 1 && date.getTime() > max.getTime() && this.moveDateCount) {
                this._updateDates(-1);
            }

            this._moveTo(this.refs.scroll, this.currentIndex);
        }

        /**
         * 添加滑动动画
         * @param  {DOM} obj   DOM对象
         * @param  {number} angle 角度
         * @return {undefined}
         */

    }, {
        key: '_moveTo',
        value: function _moveTo(obj, currentIndex) {
            var _this3 = this;

            this.animating = true;

            addPrefixCss(obj, { transition: 'transform .2s ease-out' });

            this.setState({
                translateY: -currentIndex * DATE_HEIGHT
            });

            // NOTE: There is no transitionend, setTimeout is used instead.
            setTimeout(function () {
                _this3.animating = false;
                _this3.props.onSelect(_this3.state.dates[MIDDLE_INDEX]);
                _this3._clearTransition(_this3.refs.scroll);
            }, 200);
        }
    }, {
        key: 'handleStart',
        value: function handleStart(event) {
            this.touchY = !isUndefined(event.targetTouches) && !isUndefined(event.targetTouches[0]) ? event.targetTouches[0].pageY : event.pageY;

            this.translateY = this.state.translateY;
            this.moveDateCount = 0;
        }
    }, {
        key: 'handleMove',
        value: function handleMove(event) {
            var touchY = !isUndefined(event.targetTouches) && !isUndefined(event.targetTouches[0]) ? event.targetTouches[0].pageY : event.pageY;

            var dir = touchY - this.touchY;
            var translateY = this.translateY + dir;
            var direction = dir > 0 ? -1 : 1;

            // 日期最小值，最大值限制
            var date = this.state.dates[MIDDLE_INDEX];
            var _props2 = this.props,
                max = _props2.max,
                min = _props2.min;

            if (date.getTime() < min.getTime() || date.getTime() > max.getTime()) {
                return;
            }

            // 检测是否更新日期列表
            if (this._checkIsUpdateDates(direction, translateY)) {
                this.moveDateCount = direction > 0 ? this.moveDateCount + 1 : this.moveDateCount - 1;
                this._updateDates(direction);
            }

            this.setState({ translateY: translateY });
        }
    }, {
        key: 'handleEnd',
        value: function handleEnd(event) {
            var touchY = event.pageY || event.changedTouches[0].pageY;
            var dir = touchY - this.touchY;
            var direction = dir > 0 ? -1 : 1;
            this._moveToNext(direction);
        }

        /**
         * 滑动日期选择器触屏事件
         * @param  {Object} event 事件对象
         * @return {undefined}
         */

    }, {
        key: 'handleContentTouch',
        value: function handleContentTouch(event) {
            event.preventDefault();
            if (this.animating) return;
            if (event.type === 'touchstart') {
                this.handleStart(event);
            } else if (event.type === 'touchmove') {
                this.handleMove(event);
            } else if (event.type === 'touchend') {
                this.handleEnd(event);
            }
        }

        /**
         * 滑动日期选择器鼠标事件
         * @param  {Object} event 事件对象
         * @return {undefined}
         */

    }, {
        key: 'handleContentMouseDown',
        value: function handleContentMouseDown(event) {
            if (this.animating) return;
            this.handleStart(event);
            document.addEventListener('mousemove', this.handleContentMouseMove);
            document.addEventListener('mouseup', this.handleContentMouseUp);
        }
    }, {
        key: 'handleContentMouseMove',
        value: function handleContentMouseMove(event) {
            if (this.animating) return;
            this.handleMove(event);
        }
    }, {
        key: 'handleContentMouseUp',
        value: function handleContentMouseUp(event) {
            if (this.animating) return;
            this.handleEnd(event);
            document.removeEventListener('mousemove', this.handleContentMouseMove);
            document.removeEventListener('mouseup', this.handleContentMouseUp);
        }

        /**
         * 渲染一个日期DOM对象
         * @param  {Object} date date数据
         * @return {Object}      JSX对象
         */

    }, {
        key: 'renderDatepickerItem',
        value: function renderDatepickerItem(date, index) {
            var className = date < this.props.min || date > this.props.max ? 'disabled' : '';

            var formatDate = void 0;
            if (isFunction(this.props.format)) {
                formatDate = this.props.format(date);
            } else {
                formatDate = convertDate(date, this.props.format);
            }

            return React__default.createElement(
                'li',
                {
                    key: index,
                    className: className },
                formatDate
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var scrollStyle = formatCss({
                transform: 'translateY(' + this.state.translateY + 'px)',
                marginTop: this.state.marginTop
            });

            return React__default.createElement(
                'div',
                { className: 'datepicker-col-1' },
                React__default.createElement(
                    'div',
                    {
                        ref: function ref(viewport) {
                            return _this4.viewport = viewport;
                        } // eslint-disable-line
                        , className: 'datepicker-viewport' },
                    React__default.createElement(
                        'div',
                        { className: 'datepicker-wheel' },
                        React__default.createElement(
                            'ul',
                            {
                                ref: 'scroll',
                                className: 'datepicker-scroll',
                                style: scrollStyle },
                            this.state.dates.map(this.renderDatepickerItem)
                        )
                    )
                )
            );
        }
    }]);
    return DatePickerItem;
}(React.Component);

/**
 * 默认属性
 */
var defaultProps = {
    isPopup: true,
    isOpen: false,
    theme: 'default',
    value: new Date(),
    min: new Date(1970, 0, 1),
    max: new Date(2050, 0, 1),
    showFooter: true,
    showHeader: true,
    showCaption: false,
    dateConfig: {
        'year': {
            format: 'YYYY',
            caption: 'Year',
            step: 1
        },
        'month': {
            format: 'M',
            caption: 'Mon',
            step: 1
        },
        'date': {
            format: 'D',
            caption: 'Day',
            step: 1
        }
    },
    headerFormat: 'YYYY/MM/DD',
    confirmText: '完成',
    cancelText: '取消',
    onChange: function onChange() {},
    onSelect: function onSelect() {},
    onCancel: function onCancel() {}
};

/**
 * 日期配置
 */
var dateConfigMap = {
    'year': {
        format: 'YYYY',
        caption: 'Year',
        step: 1
    },
    'month': {
        format: 'M',
        caption: 'Mon',
        step: 1
    },
    'date': {
        format: 'D',
        caption: 'Day',
        step: 1
    },
    'hour': {
        format: 'hh',
        caption: 'Hour',
        step: 1
    },
    'minute': {
        format: 'mm',
        caption: 'Min',
        step: 1
    },
    'second': {
        format: 'hh',
        caption: 'Sec',
        step: 1
    }
};

/**
 * @module DatePicker Component
 */

/**
 * 大写首字母
 * @param {String} 字符串 
 */
var capitalize = function capitalize(_ref) {
    var _ref2 = toArray(_ref),
        first = _ref2[0],
        rest = _ref2.slice(1);

    return first.toUpperCase() + rest.join('');
};

/**
 * 判断数组
 * @param {any} val 
 */
var isArray = function isArray(val) {
    return Object.prototype.toString.apply(val) === '[object Array]';
};

/**
 * Class DatePicker Component Class
 * @extends Component
 */

var DatePicker = function (_Component) {
    inherits(DatePicker, _Component);

    function DatePicker(props) {
        classCallCheck(this, DatePicker);

        var _this = possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

        _this.state = {
            value: nextDate(_this.props.value)
        };

        if ('dateFormat' in props) {
            console.warn('dateFormat已经被弃用, 请使用dateConfig属性配置');
        }

        if ('dateSteps' in props) {
            console.warn('dateSteps已经被弃用, 请使用dateConfig属性配置');
        }

        if ('showFormat' in props) {
            console.warn('headerFormat, 请使用dateConfig属性');
        }

        _this.handleFinishBtnClick = _this.handleFinishBtnClick.bind(_this);
        _this.handleDateSelect = _this.handleDateSelect.bind(_this);
        return _this;
    }

    createClass(DatePicker, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // update value of state
            var date = nextDate(nextProps.value);
            if (date.getTime() !== this.state.value.getTime()) {
                this.setState({ value: date });
            }
        }

        /**
         * When you swipe two datepickeritems at the same time.
         * Prevent dates from going out.
         */

    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var value = this.state.value;
            var _props = this.props,
                min = _props.min,
                max = _props.max;

            if (value.getTime() > max.getTime()) {
                this.setState({ value: max });
            }

            if (value.getTime() < min.getTime()) {
                this.setState({ value: min });
            }
        }

        /**
         * Optimization component, Prevents unnecessary rendering
         * Only props or state change or value before re-rendering
         *
         * @param  {Object} nextProps next props
         * @param  {Object} nextState next state
         * @return {Boolean}          Whether re-rendering
         */

    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            var date = nextDate(nextState.value);
            return date.getTime() !== this.state.value.getTime() || PureRender.shouldComponentUpdate(nextProps, nextState, this.props, this.state);
        }

        /**
         * 点击完成按钮事件
         * @return {undefined}
         */

    }, {
        key: 'handleFinishBtnClick',
        value: function handleFinishBtnClick() {
            this.props.onSelect(this.state.value);
        }

        /**
         * 选择下一个日期
         * @return {undefined}
         */

    }, {
        key: 'handleDateSelect',
        value: function handleDateSelect(value) {
            var _this2 = this;

            this.setState({ value: value }, function () {
                _this2.props.onChange(value);
            });
        }

        /**
         * 格式化dateConfig
         * @param {*} dataConfig dateConfig属性
         */

    }, {
        key: 'normalizeDateConfig',
        value: function normalizeDateConfig(dataConfig) {
            var configList = [];
            if (isArray(dataConfig)) {
                for (var i = 0; i < dataConfig.length; i++) {
                    var _value = dataConfig[i];
                    if (typeof _value === 'string') {
                        var lowerCaseKey = _value.toLocaleLowerCase();
                        configList.push(_extends({}, dateConfigMap[lowerCaseKey], {
                            type: capitalize(lowerCaseKey)
                        }));
                    }
                }
            } else {
                for (var key in dataConfig) {
                    if (dataConfig.hasOwnProperty(key)) {
                        var _lowerCaseKey = key.toLocaleLowerCase();
                        if (dateConfigMap.hasOwnProperty(_lowerCaseKey)) {
                            configList.push(_extends({}, dateConfigMap[_lowerCaseKey], dataConfig[key], {
                                type: capitalize(_lowerCaseKey)
                            }));
                        }
                    }
                }
            }

            return configList;
        }

        /**
         * render函数
         * @return {Object} JSX对象
         */

    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                min = _props2.min,
                max = _props2.max,
                theme = _props2.theme,
                dateConfig = _props2.dateConfig,
                confirmText = _props2.confirmText,
                cancelText = _props2.cancelText,
                headerFormat = _props2.headerFormat,
                showHeader = _props2.showHeader,
                showFooter = _props2.showFooter,
                customHeader = _props2.customHeader,
                showCaption = _props2.showCaption;

            var value = this.state.value;
            var themeClassName = ['default', 'dark', 'ios', 'android', 'android-dark'].indexOf(theme) === -1 ? 'default' : theme;

            var dataConfigList = this.normalizeDateConfig(dateConfig);

            return React__default.createElement(
                'div',
                {
                    className: 'datepicker ' + themeClassName },
                showHeader && React__default.createElement(
                    'div',
                    { className: 'datepicker-header' },
                    customHeader || convertDate(value, headerFormat)
                ),
                showCaption && React__default.createElement(
                    'div',
                    { className: 'datepicker-caption' },
                    dataConfigList.map(function (item, index) {
                        return React__default.createElement(
                            'div',
                            { key: index, className: 'datepicker-caption-item' },
                            item.caption
                        );
                    })
                ),
                React__default.createElement(
                    'div',
                    { className: 'datepicker-content' },
                    dataConfigList.map(function (item, index) {
                        return React__default.createElement(DatePickerItem, {
                            key: index,
                            value: value,
                            min: min,
                            max: max,
                            step: item.step,
                            type: item.type,
                            format: item.format,
                            onSelect: _this3.handleDateSelect });
                    })
                ),
                showFooter && React__default.createElement(
                    'div',
                    { className: 'datepicker-navbar' },
                    React__default.createElement(
                        'a',
                        {
                            className: 'datepicker-navbar-btn',
                            onClick: this.handleFinishBtnClick },
                        confirmText
                    ),
                    React__default.createElement(
                        'a',
                        {
                            className: 'datepicker-navbar-btn',
                            onClick: this.props.onCancel },
                        cancelText
                    )
                )
            );
        }
    }]);
    return DatePicker;
}(React.Component);

var renderSubtreeIntoContainer = ReactDOM.unstable_renderSubtreeIntoContainer;

var Modal = function (_Component) {
    inherits(Modal, _Component);

    function Modal() {
        classCallCheck(this, Modal);
        return possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
    }

    createClass(Modal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._div = document.createElement('div');
            this._div.classList.add('Modal-Portal');
            document.body.appendChild(this._div);
            this.renderPortal(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            this.renderPortal(newProps);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            ReactDOM.unmountComponentAtNode(this._div);
            this._div.parentNode.removeChild(this._div);
        }
    }, {
        key: 'renderPortal',
        value: function renderPortal(props) {
            var portal = React__default.cloneElement(this.props.children, _extends({}, props, { key: 'portal' }), null);

            this.portal = renderSubtreeIntoContainer(this, portal, this._div);
        }
    }, {
        key: 'render',
        value: function render() {
            return React__default.createElement('noscript', null);
        }
    }]);
    return Modal;
}(React.Component);

Modal.defaultProps = {
    isOpen: false
};

function EnhanceDatePicker(_ref) {
    var isOpen = _ref.isOpen,
        props = objectWithoutProperties(_ref, ['isOpen']);

    function onModalClose(event) {
        if (event.target === event.currentTarget) {
            props.onCancel();
        }
    }

    return React__default.createElement(
        'div',
        {
            style: { display: isOpen ? '' : 'none' },
            onClick: onModalClose,
            className: 'datepicker-modal' },
        React__default.createElement(DatePicker, props)
    );
}

function ModalDatePicker(_ref2) {
    var isPopup = _ref2.isPopup,
        props = objectWithoutProperties(_ref2, ['isPopup']);

    if (!isPopup) {
        return React__default.createElement(DatePicker, props);
    }

    return React__default.createElement(
        Modal,
        props,
        React__default.createElement(EnhanceDatePicker, null)
    );
}

ModalDatePicker.displayName = 'MobileDatePicker';
ModalDatePicker.defaultProps = defaultProps;

return ModalDatePicker;

})));
//# sourceMappingURL=react-mobile-datepicker.js.map
}(reactMobileDatepicker));

var DatePicker = reactMobileDatepicker.exports;

var css_248z$R = ".modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n.modal-overlay .modal-container {\n  display: flex;\n  flex-direction: column;\n  min-width: 228px;\n  padding: var(--spacing-lg);\n  margin: var(--spacing-md);\n  overflow-y: auto;\n  color: var(--body-font-color);\n  background-color: #ffffff;\n  border-radius: 6px;\n  outline: none;\n}\n.modal-overlay .modal-container-lg,\n.modal-overlay .modal-container-md,\n.modal-overlay .modal-container-ms {\n  max-height: 75dvh;\n}\n.modal-overlay .modal-container-sm {\n  width: 228px;\n}\n.modal-overlay .modal-container-md {\n  width: 472px;\n}\n.modal-overlay .modal-container-lg {\n  width: 594px;\n}";
styleInject(css_248z$R);

var BasicModalSize;
(function (BasicModalSize) {
    BasicModalSize["sm"] = "sm";
    BasicModalSize["md"] = "md";
    BasicModalSize["lg"] = "lg";
})(BasicModalSize || (BasicModalSize = {}));
const BasicModal = ({ children, size, dataTestSelector, className, onOverlayClick, }) => {
    const onModalContainerClick = (e) => {
        e.stopPropagation();
    };
    return (jsx("div", Object.assign({ "data-test-selector": dataTestSelector, "data-id": "modal-container", className: classNames('modal-overlay', className), onClick: onOverlayClick }, { children: jsx("div", Object.assign({ onClick: onModalContainerClick, className: classNames('modal-container', {
                [`modal-container-${size}`]: size,
            }), "data-test-selector": dataTestSelector === null || dataTestSelector === void 0 ? void 0 : dataTestSelector.concat('-container') }, { children: children }), void 0) }), void 0));
};

var css_248z$Q = "@keyframes ripple {\n  to {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(1);\n  }\n}\n@keyframes grow-active-circle {\n  to {\n    opacity: 0.7;\n    transform: translate(-50%, -50%) scale(1);\n  }\n}\n.button-component {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 44px;\n  padding: 11px var(--spacing-lg);\n  overflow: hidden;\n  font-family: var(--main-font);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-bold);\n  text-transform: uppercase;\n  cursor: pointer;\n  border-radius: 6px;\n  outline: 0;\n}\n.button-component:not(:disabled)::after {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  display: block;\n  /* stylelint-disable-next-line sh-waqar/declaration-use-variable */\n  padding: 45%;\n  content: \"\";\n  border-radius: 50%;\n  opacity: 0;\n  transform: translate(-50%, -50%) scale(0);\n}\n.button-component:not(:disabled):active::after {\n  animation: grow-active-circle 200ms 70ms ease-out forwards;\n}\n.button-component .ripple {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  /* stylelint-disable-next-line sh-waqar/declaration-use-variable */\n  padding: 45%;\n  border-radius: 50%;\n  opacity: 0.7;\n  transform: translate(-50%, -50%) scale(0);\n  animation: ripple 330ms ease-out forwards;\n}\n.button-component .button-text-content {\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.button-component.button-component-reverse-order {\n  flex-direction: row-reverse;\n}\n.button-component .button-component-icon {\n  width: 22px;\n  height: 22px;\n  margin-left: var(--spacing-md);\n  fill: currentColor;\n}\n.button-component .button-component-icon.button-component-icon-right {\n  margin-right: var(--spacing-md);\n  margin-left: 0;\n}\n.button-component.button-component-icon-standalone {\n  padding: 11px;\n}\n.button-component.button-component-icon-standalone .button-component-icon {\n  margin: 0;\n}\n\n.button-pattern-primary {\n  color: var(--primary-button-active-text-color);\n  transition: background-color 300ms ease-out, color 300ms ease-out;\n  background-color: var(--primary-button-active-background-color);\n  border: 1px solid var(--primary-button-active-border-color);\n}\n.button-pattern-primary::after,\n.button-pattern-primary .ripple {\n  background-color: var(--primary-button-active-text-color);\n}\n.button-pattern-primary:disabled {\n  color: var(--primary-button-disabled-text-color);\n  cursor: default;\n  background-color: var(--primary-button-disabled-background-color);\n  border: 1px solid var(--primary-button-disabled-border-color);\n}\n.button-pattern-primary:hover:not(:disabled) {\n  color: var(--primary-button-clicked-text-color);\n  background-color: var(--primary-button-clicked-background-color);\n  border: 1px solid var(--primary-button-clicked-border-color);\n}\n.button-pattern-primary:hover:not(:disabled)::after,\n.button-pattern-primary:hover:not(:disabled) .ripple {\n  background-color: var(--primary-button-clicked-text-color);\n}\n.button-pattern-secondary {\n  color: var(--secondary-button-active-text-color);\n  transition: background-color 300ms ease-out, color 300ms ease-out;\n  background-color: var(--secondary-button-active-background-color);\n  border: 1px solid var(--secondary-button-active-border-color);\n}\n.button-pattern-secondary::after,\n.button-pattern-secondary .ripple {\n  background-color: var(--secondary-button-active-text-color);\n}\n.button-pattern-secondary:disabled {\n  color: var(--secondary-button-disabled-text-color);\n  cursor: default;\n  background-color: var(--secondary-button-disabled-background-color);\n  border: 1px solid var(--secondary-button-disabled-border-color);\n}\n.button-pattern-secondary:hover:not(:disabled) {\n  color: var(--secondary-button-clicked-text-color);\n  background-color: var(--secondary-button-clicked-background-color);\n  border: 1px solid var(--secondary-button-clicked-border-color);\n}\n.button-pattern-secondary:hover:not(:disabled)::after,\n.button-pattern-secondary:hover:not(:disabled) .ripple {\n  background-color: var(--secondary-button-clicked-text-color);\n}\n.button-pattern-tertiary {\n  color: var(--tertiary-button-active-text-color);\n  transition: background-color 300ms ease-out, color 300ms ease-out;\n  background-color: var(--tertiary-button-active-background-color);\n  border: 1px solid var(--tertiary-button-active-border-color);\n}\n.button-pattern-tertiary::after,\n.button-pattern-tertiary .ripple {\n  background-color: var(--tertiary-button-active-text-color);\n}\n.button-pattern-tertiary:disabled {\n  color: var(--tertiary-button-disabled-text-color);\n  cursor: default;\n  background-color: var(--tertiary-button-disabled-background-color);\n  border: 1px solid var(--tertiary-button-disabled-border-color);\n}\n.button-pattern-tertiary:hover:not(:disabled) {\n  color: var(--tertiary-button-clicked-text-color);\n  background-color: var(--tertiary-button-clicked-background-color);\n  border: 1px solid var(--tertiary-button-clicked-border-color);\n}\n.button-pattern-tertiary:hover:not(:disabled)::after,\n.button-pattern-tertiary:hover:not(:disabled) .ripple {\n  background-color: var(--tertiary-button-clicked-text-color);\n}";
styleInject(css_248z$Q);

var ButtonPattern;
(function (ButtonPattern) {
    ButtonPattern["primary"] = "primary";
    ButtonPattern["secondary"] = "secondary";
    ButtonPattern["tertiary"] = "tertiary";
})(ButtonPattern || (ButtonPattern = {}));
var ButtonIconPosition;
(function (ButtonIconPosition) {
    ButtonIconPosition["left"] = "left";
    ButtonIconPosition["right"] = "right";
})(ButtonIconPosition || (ButtonIconPosition = {}));
const Button = ({ id, type = 'button', pattern = ButtonPattern.primary, children, disabled, className, icon, iconPosition = ButtonIconPosition.right, onClick, dataTestSelector, }) => {
    const createRipple = useCallback((event) => {
        if (event.currentTarget.disabled)
            return;
        const button = event.currentTarget;
        const circle = document.createElement('span');
        circle.classList.add('ripple');
        circle.addEventListener('animationend', (e) => { var _a; return (_a = e.target) === null || _a === void 0 ? void 0 : _a.remove(); }, { once: true });
        button.appendChild(circle);
    }, []);
    return (jsxs("button", Object.assign({ id: id, type: type, "data-test-selector": dataTestSelector, disabled: disabled, className: classNames('button-component', `button-pattern-${pattern}`, {
            'button-component-icon-standalone': !children,
            'button-component-reverse-order': iconPosition === ButtonIconPosition.left,
        }, className), onClick: onClick, onPointerDown: createRipple }, { children: [icon && (jsx(Icon, { className: classNames('button-component-icon', {
                    'button-component-icon-right': iconPosition === ButtonIconPosition.right,
                }), type: icon }, void 0)), typeof children === 'string' ? (jsx("span", Object.assign({ className: "button-text-content" }, { children: children }), void 0)) : (children)] }), void 0));
};

var css_248z$P = ".datepicker-modal-overlay .datepicker-header {\n  text-align: center;\n}\n.datepicker-modal-overlay .datepicker {\n  /* stylelint-disable declaration-no-important */\n  position: static !important;\n  font-family: inherit !important;\n  /* stylelint-enable */\n}\n.datepicker-modal-overlay .datepicker.default {\n  min-width: 350px;\n  background: var(--white-color);\n}\n.datepicker-modal-overlay .datepicker.default .datepicker-caption,\n.datepicker-modal-overlay .datepicker.default .datepicker-content {\n  justify-content: space-evenly;\n  padding: 0;\n}\n.datepicker-modal-overlay .datepicker.default .datepicker-viewport {\n  display: flex;\n  justify-content: center;\n  height: 376px;\n}\n.datepicker-modal-overlay .datepicker.default .datepicker-caption-item {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  color: var(--gray-color-2);\n  text-transform: uppercase;\n}\n.datepicker-modal-overlay .datepicker.default .datepicker-caption-item,\n.datepicker-modal-overlay .datepicker.default .datepicker-col-1 {\n  width: 105px;\n  max-width: 105px;\n  margin: 0;\n  margin-right: var(--spacing-lg);\n}\n.datepicker-modal-overlay .datepicker.default .datepicker-caption-item:last-of-type,\n.datepicker-modal-overlay .datepicker.default .datepicker-col-1:last-of-type {\n  margin-right: 0;\n}\n.datepicker-modal-overlay .datepicker.default .datepicker-wheel {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 44px;\n  /* stylelint-disable-next-line sh-waqar/declaration-use-variable */\n  margin-top: -24px;\n  background-color: var(--primary-color);\n  border: none;\n  border-radius: 4px;\n}\n.datepicker-modal-overlay .datepicker.default .datepicker-scroll {\n  position: absolute;\n  top: -85px;\n}\n.datepicker-modal-overlay .datepicker.default .datepicker-scroll li {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 118px;\n  height: 56px;\n  padding: 0;\n  font-size: var(--font-size-lg);\n  color: var(--black-color);\n  text-transform: uppercase;\n}\n.datepicker-modal-overlay .datepicker.default .datepicker-scroll li.disabled {\n  color: var(--gray-color-3);\n}\n.datepicker-modal-overlay .datepicker.default .datepicker-scroll li:nth-child(6) {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-bold);\n  color: var(--primary-contrast-text-color);\n}\n.datepicker-modal-overlay .datepicker-footer {\n  display: flex;\n  justify-content: space-between;\n}";
styleInject(css_248z$P);

const DateTimePickerModal = ({ onChange, header, dateConfig, value, min, max, closeModal, dataTestSelector, className, allowClear, showCaption, }) => {
    const [t] = useTranslation();
    const [dateTimePickerValue, setDateTimePickerValue] = useState(new Date());
    const handleSelect = useCallback(() => {
        onChange === null || onChange === void 0 ? void 0 : onChange(dateTimePickerValue);
        closeModal === null || closeModal === void 0 ? void 0 : closeModal();
    }, [closeModal, dateTimePickerValue, onChange]);
    const handleClear = useCallback(() => {
        setDateTimePickerValue(new Date());
        onChange === null || onChange === void 0 ? void 0 : onChange(undefined);
        closeModal === null || closeModal === void 0 ? void 0 : closeModal();
    }, [closeModal, onChange]);
    useEffect(() => {
        const newValue = value ? new Date(value) : new Date();
        if (max && newValue > new Date(max)) {
            setDateTimePickerValue(new Date(max));
        }
        else if (min && newValue < new Date(min)) {
            setDateTimePickerValue(new Date(min));
        }
        else {
            setDateTimePickerValue(newValue);
        }
    }, [value, min, max]);
    return (jsxs(BasicModal, Object.assign({ className: classNames('datepicker-modal-overlay', className), dataTestSelector: "date-time-picker-modal" }, { children: [jsx(Text, Object.assign({ size: TextSize.xlg, className: "datepicker-header spacing-bottom-sm" }, { children: header }), void 0), jsx(DatePicker, { showCaption: showCaption, value: dateTimePickerValue, "data-test-selector": dataTestSelector, isPopup: false, min: min && new Date(min), max: max && new Date(max), onChange: setDateTimePickerValue, dateConfig: dateConfig, showHeader: false, showFooter: false }, void 0), jsxs("div", Object.assign({ className: "datepicker-footer spacing-top-md" }, { children: [jsx(Button, Object.assign({ onClick: closeModal, pattern: ButtonPattern.secondary }, { children: t('CANCEL') }), void 0), allowClear && (jsx(Button, Object.assign({ pattern: ButtonPattern.secondary, className: "spacing-left-auto spacing-right-sm", onClick: handleClear }, { children: t('CLEAR') }), void 0)), jsx(Button, Object.assign({ onClick: handleSelect }, { children: t('SAVE') }), void 0)] }), void 0)] }), void 0));
};

var css_248z$O = ".datepicker-field .datepicker-field .field-icon {\n  fill: var(--primary-color);\n}";
styleInject(css_248z$O);

const DATE_PICKER_DATE_FORMAT = 'YYYY-MM-DD';
const DatePickerField = ({ label, id, name, optional, validationStatus, value, min = '1900-1-1', max = '9999-12-31', onChange, onBlur, onFocus, disabled = false, allowClear, className, modalClassName, placeholder, fieldDisplayFormat = DATE_PICKER_DATE_FORMAT, defaultPickerValue, dataTestSelector, hideValidationMessage, }) => {
    const [t] = useTranslation('DatePickerField');
    const [isModalOpen, setModalOpenState] = useState(false);
    const [fieldValue, setFieldValue] = useState();
    const [datePickerValue, setDatePickerValue] = useState();
    const [uid] = useState(id !== null && id !== void 0 ? id : generateRandomString());
    const getFormattedDatePickerValue = useCallback((valueToFormat) => {
        return getFormattedDate(valueToFormat, DATE_PICKER_DATE_FORMAT, undefined, false);
    }, []);
    const getFormattedFieldValue = useCallback((valueToFormat) => {
        return getFormattedDate(valueToFormat, fieldDisplayFormat, DATE_PICKER_DATE_FORMAT, false);
    }, [fieldDisplayFormat]);
    const datePickerFormattedData = useMemo(() => ({
        value: value && getFormattedFieldValue(value),
        min: getFormattedFieldValue(min),
        max: getFormattedFieldValue(max),
    }), [value, min, max, getFormattedFieldValue]);
    const openModal = useCallback(() => {
        const el = document.getElementById(uid);
        if (el) {
            el.blur();
        }
        setModalOpenState(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    }, [uid, onFocus]);
    const closeModal = () => {
        setModalOpenState(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    };
    const handleModalChange = (date) => {
        const fieldValue = date && getFormattedFieldValue(date);
        const outputValue = date && getFormattedDatePickerValue(date);
        const datePickerValues = date || (defaultPickerValue ? new Date(defaultPickerValue) : undefined);
        setFieldValue(fieldValue);
        setDatePickerValue(datePickerValues);
        onChange === null || onChange === void 0 ? void 0 : onChange(outputValue);
    };
    const dateConfig = useMemo(() => {
        const monthMap = [
            t('JAN'),
            t('FEB'),
            t('MAR'),
            t('APR'),
            t('MAY'),
            t('JUN'),
            t('JUL'),
            t('AUG'),
            t('SEP'),
            t('OCT'),
            t('NOV'),
            t('DEC'),
        ];
        return {
            date: {
                format: 'DD',
                step: 1,
            },
            month: {
                format: (value) => {
                    const monthIndex = value.getMonth();
                    return monthMap[monthIndex];
                },
                step: 1,
            },
            year: {
                format: 'YYYY',
                step: 1,
            },
        };
    }, [t]);
    useEffect(() => {
        if (!value) {
            return setFieldValue(undefined);
        }
        setFieldValue(datePickerFormattedData.value);
    }, [datePickerFormattedData.value, value]);
    useEffect(() => {
        if (!value && !defaultPickerValue) {
            setDatePickerValue(undefined);
            return;
        }
        const datePickerValue = (value || defaultPickerValue);
        setDatePickerValue(new Date(datePickerValue));
    }, [defaultPickerValue, value, getFormattedDatePickerValue]);
    return (jsxs("div", Object.assign({ className: classNames('datepicker-field', className), "data-test-selector": dataTestSelector }, { children: [jsx(Field, { id: uid, label: label, placeholder: placeholder, onFocus: openModal, value: fieldValue, disabled: disabled, icon: IconTypes.calendar, className: "datepicker-field", name: name, optional: optional, validationStatus: validationStatus, hideValidationMessage: hideValidationMessage }, void 0), isModalOpen && (jsx(DateTimePickerModal, { closeModal: closeModal, dateConfig: dateConfig, value: datePickerValue, allowClear: allowClear, min: min, max: max, onChange: handleModalChange, header: t('SELECT_DATE'), className: modalClassName }, void 0))] }), void 0));
};

var css_248z$N = ".timepicker-field .field-icon {\n  fill: var(--primary-color);\n}";
styleInject(css_248z$N);

const TIME_PICKER_TIME_FORMAT = 'HH:mm:ss';
const TimePickerField = ({ label, id, name, optional, validationStatus, value, min, max, hideValidationMessage, fieldDisplayFormat = TimeFormats.H24, onChange, onBlur, onFocus, disabled = false, allowClear, className, modalClassName, placeholder, dataTestSelector, }) => {
    const [t] = useTranslation('TimePickerField');
    const [isModalOpen, setModalOpenState] = useState(false);
    const [fieldValue, setFieldValue] = useState(value);
    const [datePickerValue, setDatePickerValue] = useState();
    const [uid] = useState(id !== null && id !== void 0 ? id : generateRandomString());
    const openModal = useCallback(() => {
        const el = document.getElementById(uid);
        if (el) {
            el.blur();
        }
        setModalOpenState(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    }, [uid, onFocus]);
    const closeModal = () => {
        setModalOpenState(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    };
    const handleModalChange = useCallback((date) => {
        const outputValue = date && getFormattedTime(date, TIME_PICKER_TIME_FORMAT);
        const fieldValue = date && getFormattedTime(date, fieldDisplayFormat);
        setFieldValue(fieldValue);
        setDatePickerValue(date);
        onChange === null || onChange === void 0 ? void 0 : onChange(outputValue);
    }, [fieldDisplayFormat, onChange]);
    const formatToH12 = useCallback((date) => {
        let hours = date.getHours();
        const timeOfDay = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        return `${hours} ${timeOfDay}`;
    }, []);
    const dateConfig = useMemo(() => {
        return {
            hour: {
                format: fieldDisplayFormat === TimeFormats.H12 ? formatToH12 : 'hh',
                caption: t('HOUR'),
                step: 1,
            },
            minute: {
                format: 'mm',
                caption: t('MINUTE'),
                step: 1,
            },
        };
    }, [t, formatToH12, fieldDisplayFormat]);
    useEffect(() => {
        if (!value) {
            setFieldValue(undefined);
            setDatePickerValue(undefined);
            return;
        }
        const date = new Date(`${new Date().toDateString()}, ${value}`);
        const fieldValue = getFormattedTime(date, fieldDisplayFormat);
        setFieldValue(fieldValue);
        setDatePickerValue(date);
    }, [value, fieldDisplayFormat]);
    return (jsxs("div", Object.assign({ className: className, "data-test-selector": dataTestSelector }, { children: [jsx(Field, { id: uid, label: label, placeholder: placeholder, onFocus: openModal, value: fieldValue, disabled: disabled, name: name, icon: IconTypes.time, className: "timepicker-field", optional: optional, validationStatus: validationStatus, hideValidationMessage: hideValidationMessage }, void 0), isModalOpen && (jsx(DateTimePickerModal, { showCaption: true, closeModal: closeModal, min: min && `${new Date().toDateString()}, ${min}`, max: max && `${new Date().toDateString()}, ${max}`, value: datePickerValue, allowClear: allowClear, dateConfig: dateConfig, header: t('SELECT_TIME'), onChange: handleModalChange, className: modalClassName }, void 0))] }), void 0));
};

var css_248z$M = ".date-time-picker-fields-set {\n  display: flex;\n  gap: var(--spacing-lg);\n}\n.date-time-picker-fields-set .date-time-picker-field {\n  flex: 1;\n}";
styleInject(css_248z$M);

const START_OF_DAY_TIME = '00:00:00';
const END_OF_DAY_TIME = '23:59:59';
const DATE_TIME_SEPARATOR = 'T';
const DATE_TIME_PICKER_DATE_FORMAT = `${DATE_PICKER_DATE_FORMAT}${DATE_TIME_SEPARATOR}${TIME_PICKER_TIME_FORMAT}`;
const DateTimePickerField = ({ label, name, id, optional, validationStatus, value, min = '1900-1-1', max = '9999-12-31', onChange, onBlur, onFocus, disabled = false, allowClear, className, modalsClassName, placeholder, fieldsDisplayFormats, dataTestSelector, hideValidationMessage, }) => {
    const [fieldValue, setFieldValue] = useState(value);
    const [uid] = useState(id !== null && id !== void 0 ? id : generateRandomString());
    const [dateReachedMin, setDateReachedMin] = useState(false);
    const [dateReachedMax, setDateReachedMax] = useState(false);
    const [dateValue, timeValue] = useMemo(() => {
        return fieldValue ? fieldValue.split(DATE_TIME_SEPARATOR) : [];
    }, [fieldValue]);
    const [dateMin, timeMin] = useMemo(() => {
        return min ? min.split(DATE_TIME_SEPARATOR) : [];
    }, [min]);
    const [dateMax, timeMax] = useMemo(() => {
        return max ? max.split(DATE_TIME_SEPARATOR) : [];
    }, [max]);
    const timeLimitsSpecified = useMemo(() => Boolean(timeMin || timeMax), [timeMin, timeMax]);
    useEffect(() => {
        setFieldValue(value);
    }, [value]);
    useEffect(() => {
        setDateReachedMin(ComparisonDateUtils.compareDates(dateValue, LogicalConditions.LowerOrEqual, dateMin));
        setDateReachedMax(ComparisonDateUtils.compareDates(dateValue, LogicalConditions.GreaterOrEqual, dateMax));
    }, [dateValue, dateMax, dateMin]);
    const onDateChange = useCallback((date) => {
        let newValue;
        if (!date) {
            newValue = undefined;
        }
        else {
            newValue = `${date}${timeValue ? `T${timeValue}` : ''}`;
        }
        setFieldValue(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    }, [timeValue, onChange]);
    const onTimeChange = useCallback((time) => {
        let newValue;
        if (!dateValue || !time) {
            newValue = dateValue;
        }
        else {
            newValue = `${dateValue}T${time}`;
        }
        setFieldValue(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    }, [dateValue, onChange]);
    return (jsx(FieldWrapper, Object.assign({ dataTestSelector: dataTestSelector, id: uid, className: className, disabled: disabled, label: label, optional: optional, validationStatus: validationStatus, hideValidationMessage: hideValidationMessage }, { children: jsxs("div", Object.assign({ className: classNames('date-time-picker-fields-set', className), "data-test-selector": dataTestSelector }, { children: [jsx(DatePickerField, { id: uid, hideValidationMessage: true, validationStatus: validationStatus, modalClassName: modalsClassName, className: "date-time-picker-field", allowClear: allowClear, name: name, value: dateValue, min: dateMin, max: dateMax, onChange: onDateChange, placeholder: placeholder === null || placeholder === void 0 ? void 0 : placeholder.dateField, fieldDisplayFormat: fieldsDisplayFormats === null || fieldsDisplayFormats === void 0 ? void 0 : fieldsDisplayFormats.dateField }, void 0), jsx(TimePickerField, { hideValidationMessage: true, validationStatus: validationStatus, modalClassName: modalsClassName, className: "date-time-picker-field", allowClear: allowClear, disabled: !dateValue, value: dateValue ? timeValue : undefined, min: (timeLimitsSpecified &&
                        (dateReachedMin ? timeMin : START_OF_DAY_TIME)) ||
                        undefined, max: (timeLimitsSpecified &&
                        (dateReachedMax ? timeMax : END_OF_DAY_TIME)) ||
                        undefined, onBlur: onBlur, onFocus: onFocus, onChange: onTimeChange, placeholder: placeholder === null || placeholder === void 0 ? void 0 : placeholder.timeField, fieldDisplayFormat: fieldsDisplayFormats === null || fieldsDisplayFormats === void 0 ? void 0 : fieldsDisplayFormats.timeField }, void 0)] }), void 0) }), void 0));
};

var css_248z$L = ".radio-button-wrapper {\n  display: flex;\n  align-items: flex-start;\n}\n.radio-button-wrapper.radio-button-wrapper-reverse-order {\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n}\n.radio-button-wrapper .radio-button-input-wrapper {\n  position: relative;\n  min-width: 44px;\n  max-width: 44px;\n  min-height: 44px;\n  max-height: 44px;\n}\n.radio-button-wrapper .radio-button-input-wrapper .radio-button-input-circle {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 24px;\n  height: 24px;\n  pointer-events: none;\n  background-color: var(--white-color);\n  border: 1px solid var(--gray-color-1);\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n}\n.radio-button-wrapper .radio-button-input:disabled ~ .radio-button-input-circle {\n  border-color: var(--gray-color-3);\n}\n.radio-button-wrapper .radio-button-input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n  background-color: transparent;\n  border: none;\n  border-radius: 50%;\n  outline: none;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n.radio-button-wrapper .radio-button-input::after {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  display: block;\n  width: 0;\n  height: 0;\n  visibility: hidden;\n  content: \"\";\n  border-radius: 50%;\n  transition: all 350ms cubic-bezier(0.22, 0.61, 0.36, 1);\n  transform: translate(-50%, -50%);\n}\n.radio-button-wrapper .radio-button-input:checked::after {\n  width: 15px;\n  height: 15px;\n  visibility: visible;\n  background-color: var(--gray-color-1);\n}\n.radio-button-wrapper .radio-button-input:not(:disabled):hover::before {\n  position: absolute;\n  display: block;\n  width: 100%;\n  height: 100%;\n  content: \"\";\n  background-color: var(--primary-color);\n  opacity: 0.1;\n}\n.radio-button-wrapper .radio-button-input:not(:disabled):checked::after {\n  background-color: var(--primary-color);\n}\n.radio-button-wrapper .radio-button-input-active-state {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  display: block;\n  width: 0;\n  height: 0;\n  content: \"\";\n  background-color: transparent;\n  border-radius: 50%;\n  opacity: 0;\n  transition: width 300ms cubic-bezier(0.22, 0.61, 0.36, 1), height 300ms cubic-bezier(0.22, 0.61, 0.36, 1);\n  transform: translate(-50%, -50%);\n}\n.radio-button-wrapper .radio-button-input-wrapper:active > .radio-button-input-active-state {\n  width: 100%;\n  height: 100%;\n  background-color: var(--gray-color-1);\n  opacity: 0.4;\n}\n.radio-button-wrapper .radio-button-input-wrapper:active > .radio-button-input:checked + .radio-button-input-active-state {\n  width: 100%;\n  height: 100%;\n  background-color: var(--primary-color);\n  opacity: 0.4;\n}\n.radio-button-wrapper .radio-button-input-wrapper:active > .radio-button-input:disabled + .radio-button-input-active-state {\n  background-color: transparent;\n}\n.radio-button-wrapper .radio-button-input:checked:not(:disabled) ~ .radio-button-input-circle {\n  border-color: var(--primary-color);\n}\n.radio-button-wrapper .radio-button-input-error:not(:disabled) ~ .radio-button-input-circle {\n  border-color: var(--error-state-color);\n}\n.radio-button-wrapper .radio-button-input-warn:not(:disabled) ~ .radio-button-input-circle {\n  border-color: var(--warning-state-color);\n}\n.radio-button-wrapper .radio-button-label {\n  margin: 10px var(--spacing-md) 10px var(--spacing-xs);\n  margin-right: var(--spacing-md);\n  margin-left: var(--spacing-xs);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n.radio-button-wrapper .radio-button-label.radio-button-label-start {\n  margin-right: var(--spacing-xs);\n  margin-left: var(--spacing-md);\n}\n.radio-button-wrapper .radio-button-label.radio-button-label-disabled {\n  color: var(--gray-color-1);\n}";
styleInject(css_248z$L);

var RadioButtonLabelPosition;
(function (RadioButtonLabelPosition) {
    RadioButtonLabelPosition["start"] = "start";
    RadioButtonLabelPosition["end"] = "end";
})(RadioButtonLabelPosition || (RadioButtonLabelPosition = {}));
const RadioButton = ({ label, id, name, className, labelPosition, dataTestSelector, validationStatus, checked, value, disabled, onChange, onFocus, onBlur, }) => {
    var _a;
    const componentId = useMemo(() => id || generateRandomString(), [id]);
    return (jsxs("div", Object.assign({ "data-test-selector": dataTestSelector, className: classNames('radio-button-wrapper', {
            'radio-button-wrapper-reverse-order': labelPosition === RadioButtonLabelPosition.start,
        }) }, { children: [jsxs("div", Object.assign({ className: "radio-button-input-wrapper" }, { children: [jsx("input", { type: "radio", id: componentId, name: name, "data-test-selector": "radio-button-input", className: classNames('radio-button-input', {
                            [`radio-button-input-${(_a = validationStatus === null || validationStatus === void 0 ? void 0 : validationStatus[0]) === null || _a === void 0 ? void 0 : _a.severity}`]: !disabled && (validationStatus === null || validationStatus === void 0 ? void 0 : validationStatus.length),
                        }, className), checked: checked, value: value, onChange: onChange, onFocus: onFocus, onBlur: onBlur, disabled: disabled }, void 0), jsx("span", { className: "radio-button-input-active-state" }, void 0), jsx("span", { className: "radio-button-input-circle" }, void 0)] }), void 0), label && (jsx("label", Object.assign({ htmlFor: componentId, className: classNames('radio-button-label', {
                    'radio-button-label-start': labelPosition === RadioButtonLabelPosition.start,
                    'radio-button-label-disabled': disabled,
                }) }, { children: label }), void 0))] }), void 0));
};

var css_248z$K = ".circular-wrapper {\n  position: relative;\n  width: 88px;\n  height: 88px;\n  color: currentColor;\n}\n\n.circular-wrapper-error {\n  color: var(--error-state-color);\n}\n\n.circular-wrapper-warning {\n  color: var(--warning-state-color);\n}\n\n.circular-wrapper-success {\n  color: var(--success-dark-state-color);\n}\n\n.circular-circle {\n  stroke: currentColor;\n}\n\n.circular-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  /* stylelint-disable-next-line sh-waqar/declaration-use-variable */\n  padding: 21%;\n  transform: translateX(-50%) translateY(-50%);\n}";
styleInject(css_248z$K);

const CURCULAR_MAX_VALUE = 126.92;
var CircularType;
(function (CircularType) {
    CircularType["success"] = "success";
    CircularType["warning"] = "warning";
    CircularType["error"] = "error";
})(CircularType || (CircularType = {}));
const Circular = ({ type, icon, iconColor, circleSegment = 100, size = 80, iconClassName, className, dataTestSelector, }) => {
    const strokeDashoffset = useMemo(() => {
        return `${CURCULAR_MAX_VALUE - (CURCULAR_MAX_VALUE * circleSegment) / 100}px`;
    }, [circleSegment]);
    return (jsxs("div", Object.assign({ "data-test-selector": dataTestSelector, className: classNames('circular-wrapper', className, {
            [`circular-wrapper-${type}`]: type,
        }), style: {
            width: `${size}px`,
            height: `${size}px`,
        } }, { children: [jsx("svg", Object.assign({ viewBox: "22 22 44 44", className: classNames('circular-circle') }, { children: jsx("circle", { cx: "44", cy: "44", r: "20.2", fill: "none", strokeWidth: "3.6", style: {
                        strokeDasharray: CURCULAR_MAX_VALUE,
                        strokeDashoffset: strokeDashoffset,
                    } }, void 0) }), void 0), icon && (jsx(Icon, { color: iconColor, type: icon, className: classNames('circular-icon', iconClassName) }, void 0))] }), void 0));
};

var css_248z$J = ".loader-component {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  text-transform: capitalize;\n}\n.loader-component .loader-circular {\n  color: var(--primary-color);\n}\n.loader-component .loader-circular .circular-circle {\n  animation: loader-rotate-animation 1400ms linear infinite;\n}\n\n@keyframes loader-rotate-animation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}";
styleInject(css_248z$J);

var LoaderSizes;
(function (LoaderSizes) {
    LoaderSizes["sm"] = "sm";
    LoaderSizes["md"] = "md";
    LoaderSizes["lg"] = "lg";
})(LoaderSizes || (LoaderSizes = {}));
const Loader = ({ className, circularClassName, size = LoaderSizes.lg, icon, dataTestSelector, title, description, }) => {
    const loaderSize = useMemo(() => {
        switch (size) {
            case 'sm':
                return 30;
            case 'md':
                return 44;
            default:
                return 88;
        }
    }, [size]);
    return (jsxs("div", Object.assign({ className: classNames('loader-component', className), "data-test-selector": dataTestSelector }, { children: [jsx(Circular, { size: loaderSize, className: classNames('loader-circular', circularClassName), circleSegment: 60, icon: icon, dataTestSelector: "loader-circular" }, void 0), (title || description) && (jsxs("div", Object.assign({ className: "spacing-top-xlg" }, { children: [title && jsx(Text, Object.assign({ dataTestSelector: "loader-title" }, { children: title }), void 0), description && (jsx(Text, Object.assign({ dataTestSelector: "loader-description" }, { children: description }), void 0))] }), void 0))] }), void 0));
};

var css_248z$I = ".field-component-wrapper {\n  position: relative;\n}\n.field-component-wrapper .select-inline-component {\n  position: relative;\n  padding-right: 44px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.field-component-wrapper .select-inline-icon {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 44px;\n  height: 44px;\n  padding: 11px;\n  pointer-events: none;\n  fill: var(--primary-color);\n}\n.field-component-wrapper .select-inline-placeholder {\n  color: var(--gray-color-1);\n}\n.field-component-wrapper .select-inline-option {\n  color: var(--black-color);\n}";
styleInject(css_248z$I);

const SelectInline = ({ id, optionsLoading, options, placeholder, className, disabled, name, value, onFocus, onBlur, onChange, onKeyDown, onMouseDown, }) => {
    const [selectValue, setSelectValue] = useState('');
    useEffect(() => {
        const selectedValue = options === null || options === void 0 ? void 0 : options.find((item) => item.value === value);
        setSelectValue(selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value);
    }, [value, options]);
    const onChangeHandler = (e) => {
        setSelectValue(e.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
    };
    return (jsxs("div", Object.assign({ className: "field-component-wrapper" }, { children: [jsxs("select", Object.assign({ id: id, className: classNames('select-inline-component', className, {
                    'select-inline-placeholder': placeholder && !selectValue,
                }), name: name, onFocus: onFocus, onBlur: onBlur, onChange: onChangeHandler, onMouseDown: onMouseDown, onKeyDown: onKeyDown, disabled: disabled || optionsLoading, value: selectValue || '' }, { children: [jsx("option", Object.assign({ value: "", disabled: true, hidden: true }, { children: placeholder }), void 0), options === null || options === void 0 ? void 0 : options.map(({ title, value, disabled, hidden }, index) => (jsx("option", Object.assign({ className: classNames({ 'select-inline-option': !disabled }), value: value, disabled: disabled, hidden: hidden }, { children: title }), `${value}-${index}`)))] }), void 0), !optionsLoading && (jsx(Icon, { type: IconTypes.arrow, className: "select-inline-icon" }, void 0)), optionsLoading && (jsx(Loader, { size: LoaderSizes.md, circularClassName: "select-inline-icon" }, void 0))] }), void 0));
};

const SEARCH_DEBOUNCE_TIMEOUT = 500;

var css_248z$H = ".separator-component {\n  height: 0;\n  margin: var(--spacing-lg) 0;\n  border-bottom: 1px solid var(--gray-color-3);\n}";
styleInject(css_248z$H);

const Separator = ({ dataTestSelector, className }) => (jsx("div", { className: classNames('separator-component', className), "data-test-selector": dataTestSelector }, void 0));

var css_248z$G = ".select-field-modal .select-modal-header {\n  text-align: center;\n}\n.select-field-modal .select-modal-list-wrapper {\n  /* stylelint-disable-next-line sh-waqar/declaration-use-variable */\n  padding: 0 10px;\n  margin: var(--spacing-xlg) 0;\n  overflow-y: auto;\n}\n.select-field-modal .select-modal-list {\n  margin: 0;\n  /* stylelint-disable-next-line sh-waqar/declaration-use-variable */\n  margin-left: -10px;\n  list-style: none;\n}\n.select-field-modal .select-modal-buttons-wrapper {\n  display: flex;\n  justify-content: space-between;\n}";
styleInject(css_248z$G);

const SUGGESTED_PREFIX = 'suggested-';
const STANDARD_PREFIX = 'standard-';
const OPTION_LIST_ID = 'select-option-id';
const SelectModal = ({ id, optionsLoading, label, suggestedOptionValues, options, value, name, className, modalClassName, modalTitle, searchable = true, disabled, placeholder, allowClear, onChange, onFocus, onBlur, onCancelModal, }) => {
    const [t] = useTranslation('SelectField');
    const [isModalOpen, setModalOpenState] = useState(false);
    const [checkedValue, setCheckedValue] = useState();
    const [selectedValue, setSelectedValue] = useState('');
    const [searchValue, setSearchValue] = useState('');
    useEffect(() => {
        const selectedValue = options === null || options === void 0 ? void 0 : options.find((item) => item.value === value);
        setCheckedValue(selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value);
        setSelectedValue(selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value);
    }, [value, options]);
    useEffect(() => {
        scrollToMiddleOfSelectedOption();
    }, [isModalOpen]);
    const debouncedSearchValue = useDebounce(searchValue, SEARCH_DEBOUNCE_TIMEOUT);
    const filteredOption = useMemo(() => {
        const visibleOptions = options === null || options === void 0 ? void 0 : options.filter(({ hidden }) => !hidden);
        return debouncedSearchValue
            ? visibleOptions === null || visibleOptions === void 0 ? void 0 : visibleOptions.filter((item) => startsWithMatchNormalizedText(stringNormalize(item.title), stringNormalize(debouncedSearchValue).trim()))
            : visibleOptions;
    }, [options, debouncedSearchValue]);
    const suggestedOptions = useMemo(() => {
        return suggestedOptionValues === null || suggestedOptionValues === void 0 ? void 0 : suggestedOptionValues.map((suggestedValue) => options === null || options === void 0 ? void 0 : options.find(({ value }) => value === suggestedValue)).filter(isDefined);
    }, [suggestedOptionValues, options]);
    const isSubmitDisabled = useMemo(() => {
        return (!checkedValue ||
            !(filteredOption === null || filteredOption === void 0 ? void 0 : filteredOption.some((option) => option.value === checkedValue)));
    }, [filteredOption, checkedValue]);
    const scrollToMiddleOfSelectedOption = useCallback(() => {
        if (!isModalOpen || !selectedValue)
            return;
        const isSuggestedValue = suggestedOptionValues === null || suggestedOptionValues === void 0 ? void 0 : suggestedOptionValues.includes(selectedValue);
        const optionSelector = isSuggestedValue && !debouncedSearchValue
            ? `#${SUGGESTED_PREFIX}${selectedValue}`
            : `#${STANDARD_PREFIX}${selectedValue}`;
        const listContainer = document.getElementById(OPTION_LIST_ID);
        const selectedOption = listContainer === null || listContainer === void 0 ? void 0 : listContainer.querySelector(optionSelector);
        if (!listContainer || !selectedOption) {
            return;
        }
        const { height: listHeight, top: listTop } = listContainer.getBoundingClientRect();
        const { height: optionHeight, top: optionTop } = selectedOption.getBoundingClientRect();
        const centerOfList = listHeight / 2;
        const centerOfOption = optionHeight / 2;
        const positionToScroll = optionTop + centerOfOption - listTop - centerOfList;
        listContainer === null || listContainer === void 0 ? void 0 : listContainer.scrollTo({ top: positionToScroll });
    }, [debouncedSearchValue, isModalOpen, selectedValue, suggestedOptionValues]);
    const toggleModalState = (e) => {
        var _a, _b;
        if (disabled)
            return;
        e === null || e === void 0 ? void 0 : e.preventDefault();
        (_b = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (!isModalOpen) {
            onFocus === null || onFocus === void 0 ? void 0 : onFocus();
        }
        else {
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        }
        setModalOpenState(!isModalOpen);
    };
    const onCheckValue = (e) => setCheckedValue(e.target.value);
    const onCancel = (e) => {
        setCheckedValue(selectedValue);
        toggleModalState(e);
        onCancelModal === null || onCancelModal === void 0 ? void 0 : onCancelModal();
    };
    const onClear = () => {
        setCheckedValue(undefined);
        setSelectedValue(undefined);
        setModalOpenState(false);
        onChange === null || onChange === void 0 ? void 0 : onChange(undefined);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    };
    const onSelectValue = () => {
        setSelectedValue(checkedValue);
        setModalOpenState(false);
        onChange === null || onChange === void 0 ? void 0 : onChange(checkedValue);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    };
    return (jsxs(Fragment, { children: [jsx(SelectInline, { id: id, className: className, name: name, onMouseDown: toggleModalState, onKeyDown: toggleModalState, onFocus: toggleModalState, placeholder: placeholder, value: selectedValue, disabled: disabled, options: options, optionsLoading: optionsLoading }, void 0), isModalOpen && (jsxs(BasicModal, Object.assign({ size: BasicModalSize.lg, className: classNames('select-field-modal', modalClassName), dataTestSelector: "select-field-modal" }, { children: [(modalTitle || label) && (jsx(Text, Object.assign({ size: TextSize.xlg, className: classNames('select-modal-header', {
                            'spacing-bottom-lg': searchable,
                        }) }, { children: modalTitle || label }), void 0)), searchable && (jsx(Field, { onChange: setSearchValue, icon: IconTypes.search, placeholder: t('START_SEARCHING'), value: searchValue, hideValidationMessage: true, dataTestSelector: "select-modal-search-field" }, void 0)), jsxs("div", Object.assign({ className: "select-modal-list-wrapper", id: OPTION_LIST_ID }, { children: [!debouncedSearchValue && !!(suggestedOptions === null || suggestedOptions === void 0 ? void 0 : suggestedOptions.length) && (jsxs(Fragment, { children: [jsx(Text, Object.assign({ size: TextSize.xxs, weight: TextWeight.bold, uppercase: true, className: "spacing-bottom-s", dataTestSelector: "select-modal-suggested-title" }, { children: t('SUGGESTED') }), void 0), jsx("ul", Object.assign({ className: "padding-none select-modal-list", "data-test-selector": "select-modal-suggested-list" }, { children: suggestedOptions.map(({ title, value, disabled }) => (jsx(RadioButton, { id: `${SUGGESTED_PREFIX}${value}`, dataTestSelector: `${SUGGESTED_PREFIX}${value}`, label: title, value: value, name: `${SUGGESTED_PREFIX}${label}`, checked: value === checkedValue, onChange: onCheckValue, disabled: disabled }, `${SUGGESTED_PREFIX}${value}`))) }), void 0), jsx(Separator, { className: "spacing-bottom-sm spacing-top-md", dataTestSelector: "select-modal-suggested-separator" }, void 0), jsx(Text, Object.assign({ size: TextSize.xxs, weight: TextWeight.bold, uppercase: true, className: "spacing-bottom-s", dataTestSelector: "select-modal-all-title" }, { children: t('ALL') }), void 0)] }, void 0)), jsx("ul", Object.assign({ className: "padding-none select-modal-list", "data-test-selector": "select-modal-all-list" }, { children: (filteredOption === null || filteredOption === void 0 ? void 0 : filteredOption.length)
                                    ? filteredOption.map(({ title, value, disabled }) => (jsx(RadioButton, { id: `${STANDARD_PREFIX}${value}`, dataTestSelector: `${STANDARD_PREFIX}${value}`, label: title, value: value, name: `${STANDARD_PREFIX}${label}`, checked: value === checkedValue, onChange: onCheckValue, disabled: disabled }, `${STANDARD_PREFIX}${value}`)))
                                    : t('NO_RESULTS') }), void 0)] }), void 0), jsxs("div", Object.assign({ className: "select-modal-buttons-wrapper" }, { children: [jsx(Button, Object.assign({ onClick: onCancel, pattern: ButtonPattern.secondary }, { children: t('CANCEL') }), void 0), allowClear && (jsx(Button, Object.assign({ onClick: onClear, disabled: !checkedValue, pattern: ButtonPattern.secondary, className: "spacing-left-auto spacing-right-sm" }, { children: t('CLEAR') }), void 0)), jsx(Button, Object.assign({ onClick: onSelectValue, disabled: isSubmitDisabled }, { children: t('SAVE') }), void 0)] }), void 0)] }), void 0))] }, void 0));
};

var css_248z$F = ".select-field-component {\n  width: 100%;\n  height: 44px;\n  padding: 0 var(--spacing-md);\n  font-size: var(--font-size-sm);\n  color: var(--black-color);\n  background-color: var(--white-color);\n  border: none;\n  border-radius: 4px;\n  outline: none;\n  box-shadow: inset 0 0 0 1px var(--gray-color-1);\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n.select-field-component:focus {\n  box-shadow: inset 0 0 0 2px var(--active-state-color);\n}\n.select-field-component:disabled {\n  background-color: var(--gray-color-3);\n  opacity: 1;\n}\n.select-field-component.select-field-component-invalid {\n  box-shadow: inset 0 0 0 1px var(--error-state-color);\n}";
styleInject(css_248z$F);

var SelectFieldType;
(function (SelectFieldType) {
    SelectFieldType["inline"] = "select";
    SelectFieldType["modal"] = "modal";
})(SelectFieldType || (SelectFieldType = {}));
const SelectField = ({ dataTestSelector, type = SelectFieldType.modal, id, label, value, optional, hideValidationMessage, validationStatus, className, modalClassName, modalTitle, searchable, disabled, name, optionsLoading, placeholder, suggestedOptionValues, options, allowClear, onFocus, onBlur, onChange, }) => {
    const [isFieldActive, setFieldActive] = useState(false);
    const isInvalid = useMemo(() => !isFieldActive && Boolean(validationStatus === null || validationStatus === void 0 ? void 0 : validationStatus.length), [isFieldActive, validationStatus]);
    const componentId = useMemo(() => id || generateRandomString(), [id]);
    const FieldComponent = useMemo(() => {
        switch (type) {
            case SelectFieldType.modal:
                return SelectModal;
            default:
                return SelectInline;
        }
    }, [type]);
    const onFieldFocus = useCallback(() => {
        setFieldActive(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    }, [onFocus]);
    const onFieldBlur = useCallback(() => {
        setFieldActive(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    }, [onBlur]);
    return (jsx(FieldWrapper, Object.assign({ id: componentId, dataTestSelector: dataTestSelector, isFieldActive: isFieldActive, className: className, disabled: disabled, label: label, optional: optional, hideValidationMessage: hideValidationMessage, validationStatus: validationStatus }, { children: jsx(FieldComponent, { id: componentId, className: classNames('select-field-component', {
                'select-field-component-invalid': isInvalid,
            }), onFocus: onFieldFocus, onBlur: onFieldBlur, disabled: disabled, label: label, value: value, optionsLoading: optionsLoading, placeholder: placeholder, onChange: onChange, suggestedOptionValues: suggestedOptionValues, options: options, name: name, modalClassName: modalClassName, modalTitle: modalTitle, searchable: searchable, allowClear: allowClear }, void 0) }), void 0));
};

var build$1 = {exports: {}};

/*!
 * Signature Pad v2.3.2
 * https://github.com/szimek/signature_pad
 *
 * Copyright 2017 Szymon Nowak
 * Released under the MIT license
 *
 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
 * http://corner.squareup.com/2012/07/smoother-signatures.html
 *
 * Implementation of interpolation using cubic Bézier curves is taken from:
 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
 *
 * Algorithm for approximated length of a Bézier curve is taken from:
 * http://www.lemoda.net/maths/bezier-length/index.html
 *
 */

function Point(x, y, time) {
  this.x = x;
  this.y = y;
  this.time = time || new Date().getTime();
}

Point.prototype.velocityFrom = function (start) {
  return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
};

Point.prototype.distanceTo = function (start) {
  return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
};

Point.prototype.equals = function (other) {
  return this.x === other.x && this.y === other.y && this.time === other.time;
};

function Bezier(startPoint, control1, control2, endPoint) {
  this.startPoint = startPoint;
  this.control1 = control1;
  this.control2 = control2;
  this.endPoint = endPoint;
}

// Returns approximated length.
Bezier.prototype.length = function () {
  var steps = 10;
  var length = 0;
  var px = void 0;
  var py = void 0;

  for (var i = 0; i <= steps; i += 1) {
    var t = i / steps;
    var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
    var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
    if (i > 0) {
      var xdiff = cx - px;
      var ydiff = cy - py;
      length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
    }
    px = cx;
    py = cy;
  }

  return length;
};

/* eslint-disable no-multi-spaces, space-in-parens */
Bezier.prototype._point = function (t, start, c1, c2, end) {
  return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
};

/* eslint-disable */

// http://stackoverflow.com/a/27078401/815507
function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function later() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}

function SignaturePad(canvas, options) {
  var self = this;
  var opts = options || {};

  this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
  this.minWidth = opts.minWidth || 0.5;
  this.maxWidth = opts.maxWidth || 2.5;
  this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds
  this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;

  if (this.throttle) {
    this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
  } else {
    this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
  }

  this.dotSize = opts.dotSize || function () {
    return (this.minWidth + this.maxWidth) / 2;
  };
  this.penColor = opts.penColor || 'black';
  this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
  this.onBegin = opts.onBegin;
  this.onEnd = opts.onEnd;

  this._canvas = canvas;
  this._ctx = canvas.getContext('2d');
  this.clear();

  // We need add these inline so they are available to unbind while still having
  // access to 'self' we could use _.bind but it's not worth adding a dependency.
  this._handleMouseDown = function (event) {
    if (event.which === 1) {
      self._mouseButtonDown = true;
      self._strokeBegin(event);
    }
  };

  this._handleMouseMove = function (event) {
    if (self._mouseButtonDown) {
      self._strokeMoveUpdate(event);
    }
  };

  this._handleMouseUp = function (event) {
    if (event.which === 1 && self._mouseButtonDown) {
      self._mouseButtonDown = false;
      self._strokeEnd(event);
    }
  };

  this._handleTouchStart = function (event) {
    if (event.targetTouches.length === 1) {
      var touch = event.changedTouches[0];
      self._strokeBegin(touch);
    }
  };

  this._handleTouchMove = function (event) {
    // Prevent scrolling.
    event.preventDefault();

    var touch = event.targetTouches[0];
    self._strokeMoveUpdate(touch);
  };

  this._handleTouchEnd = function (event) {
    var wasCanvasTouched = event.target === self._canvas;
    if (wasCanvasTouched) {
      event.preventDefault();
      self._strokeEnd(event);
    }
  };

  // Enable mouse and touch event handlers
  this.on();
}

// Public methods
SignaturePad.prototype.clear = function () {
  var ctx = this._ctx;
  var canvas = this._canvas;

  ctx.fillStyle = this.backgroundColor;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  this._data = [];
  this._reset();
  this._isEmpty = true;
};

SignaturePad.prototype.fromDataURL = function (dataUrl) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var image = new Image();
  var ratio = options.ratio || window.devicePixelRatio || 1;
  var width = options.width || this._canvas.width / ratio;
  var height = options.height || this._canvas.height / ratio;

  this._reset();
  image.src = dataUrl;
  image.onload = function () {
    _this._ctx.drawImage(image, 0, 0, width, height);
  };
  this._isEmpty = false;
};

SignaturePad.prototype.toDataURL = function (type) {
  var _canvas;

  switch (type) {
    case 'image/svg+xml':
      return this._toSVG();
    default:
      for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        options[_key - 1] = arguments[_key];
      }

      return (_canvas = this._canvas).toDataURL.apply(_canvas, [type].concat(options));
  }
};

SignaturePad.prototype.on = function () {
  this._handleMouseEvents();
  this._handleTouchEvents();
};

SignaturePad.prototype.off = function () {
  this._canvas.removeEventListener('mousedown', this._handleMouseDown);
  this._canvas.removeEventListener('mousemove', this._handleMouseMove);
  document.removeEventListener('mouseup', this._handleMouseUp);

  this._canvas.removeEventListener('touchstart', this._handleTouchStart);
  this._canvas.removeEventListener('touchmove', this._handleTouchMove);
  this._canvas.removeEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype.isEmpty = function () {
  return this._isEmpty;
};

// Private methods
SignaturePad.prototype._strokeBegin = function (event) {
  this._data.push([]);
  this._reset();
  this._strokeUpdate(event);

  if (typeof this.onBegin === 'function') {
    this.onBegin(event);
  }
};

SignaturePad.prototype._strokeUpdate = function (event) {
  var x = event.clientX;
  var y = event.clientY;

  var point = this._createPoint(x, y);
  var lastPointGroup = this._data[this._data.length - 1];
  var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
  var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance;

  // Skip this point if it's too close to the previous one
  if (!(lastPoint && isLastPointTooClose)) {
    var _addPoint = this._addPoint(point),
        curve = _addPoint.curve,
        widths = _addPoint.widths;

    if (curve && widths) {
      this._drawCurve(curve, widths.start, widths.end);
    }

    this._data[this._data.length - 1].push({
      x: point.x,
      y: point.y,
      time: point.time,
      color: this.penColor
    });
  }
};

SignaturePad.prototype._strokeEnd = function (event) {
  var canDrawCurve = this.points.length > 2;
  var point = this.points[0]; // Point instance

  if (!canDrawCurve && point) {
    this._drawDot(point);
  }

  if (point) {
    var lastPointGroup = this._data[this._data.length - 1];
    var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object

    // When drawing a dot, there's only one point in a group, so without this check
    // such group would end up with exactly the same 2 points.
    if (!point.equals(lastPoint)) {
      lastPointGroup.push({
        x: point.x,
        y: point.y,
        time: point.time,
        color: this.penColor
      });
    }
  }

  if (typeof this.onEnd === 'function') {
    this.onEnd(event);
  }
};

SignaturePad.prototype._handleMouseEvents = function () {
  this._mouseButtonDown = false;

  this._canvas.addEventListener('mousedown', this._handleMouseDown);
  this._canvas.addEventListener('mousemove', this._handleMouseMove);
  document.addEventListener('mouseup', this._handleMouseUp);
};

SignaturePad.prototype._handleTouchEvents = function () {
  // Pass touch events to canvas element on mobile IE11 and Edge.
  this._canvas.style.msTouchAction = 'none';
  this._canvas.style.touchAction = 'none';

  this._canvas.addEventListener('touchstart', this._handleTouchStart);
  this._canvas.addEventListener('touchmove', this._handleTouchMove);
  this._canvas.addEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype._reset = function () {
  this.points = [];
  this._lastVelocity = 0;
  this._lastWidth = (this.minWidth + this.maxWidth) / 2;
  this._ctx.fillStyle = this.penColor;
};

SignaturePad.prototype._createPoint = function (x, y, time) {
  var rect = this._canvas.getBoundingClientRect();

  return new Point(x - rect.left, y - rect.top, time || new Date().getTime());
};

SignaturePad.prototype._addPoint = function (point) {
  var points = this.points;
  var tmp = void 0;

  points.push(point);

  if (points.length > 2) {
    // To reduce the initial lag make it work with 3 points
    // by copying the first point to the beginning.
    if (points.length === 3) points.unshift(points[0]);

    tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
    var c2 = tmp.c2;
    tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
    var c3 = tmp.c1;
    var curve = new Bezier(points[1], c2, c3, points[2]);
    var widths = this._calculateCurveWidths(curve);

    // Remove the first element from the list,
    // so that we always have no more than 4 points in points array.
    points.shift();

    return { curve: curve, widths: widths };
  }

  return {};
};

SignaturePad.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
  var dx1 = s1.x - s2.x;
  var dy1 = s1.y - s2.y;
  var dx2 = s2.x - s3.x;
  var dy2 = s2.y - s3.y;

  var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
  var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };

  var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
  var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);

  var dxm = m1.x - m2.x;
  var dym = m1.y - m2.y;

  var k = l2 / (l1 + l2);
  var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };

  var tx = s2.x - cm.x;
  var ty = s2.y - cm.y;

  return {
    c1: new Point(m1.x + tx, m1.y + ty),
    c2: new Point(m2.x + tx, m2.y + ty)
  };
};

SignaturePad.prototype._calculateCurveWidths = function (curve) {
  var startPoint = curve.startPoint;
  var endPoint = curve.endPoint;
  var widths = { start: null, end: null };

  var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;

  var newWidth = this._strokeWidth(velocity);

  widths.start = this._lastWidth;
  widths.end = newWidth;

  this._lastVelocity = velocity;
  this._lastWidth = newWidth;

  return widths;
};

SignaturePad.prototype._strokeWidth = function (velocity) {
  return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
};

SignaturePad.prototype._drawPoint = function (x, y, size) {
  var ctx = this._ctx;

  ctx.moveTo(x, y);
  ctx.arc(x, y, size, 0, 2 * Math.PI, false);
  this._isEmpty = false;
};

SignaturePad.prototype._drawCurve = function (curve, startWidth, endWidth) {
  var ctx = this._ctx;
  var widthDelta = endWidth - startWidth;
  var drawSteps = Math.floor(curve.length());

  ctx.beginPath();

  for (var i = 0; i < drawSteps; i += 1) {
    // Calculate the Bezier (x, y) coordinate for this step.
    var t = i / drawSteps;
    var tt = t * t;
    var ttt = tt * t;
    var u = 1 - t;
    var uu = u * u;
    var uuu = uu * u;

    var x = uuu * curve.startPoint.x;
    x += 3 * uu * t * curve.control1.x;
    x += 3 * u * tt * curve.control2.x;
    x += ttt * curve.endPoint.x;

    var y = uuu * curve.startPoint.y;
    y += 3 * uu * t * curve.control1.y;
    y += 3 * u * tt * curve.control2.y;
    y += ttt * curve.endPoint.y;

    var width = startWidth + ttt * widthDelta;
    this._drawPoint(x, y, width);
  }

  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._drawDot = function (point) {
  var ctx = this._ctx;
  var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;

  ctx.beginPath();
  this._drawPoint(point.x, point.y, width);
  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._fromData = function (pointGroups, drawCurve, drawDot) {
  for (var i = 0; i < pointGroups.length; i += 1) {
    var group = pointGroups[i];

    if (group.length > 1) {
      for (var j = 0; j < group.length; j += 1) {
        var rawPoint = group[j];
        var point = new Point(rawPoint.x, rawPoint.y, rawPoint.time);
        var color = rawPoint.color;

        if (j === 0) {
          // First point in a group. Nothing to draw yet.

          // All points in the group have the same color, so it's enough to set
          // penColor just at the beginning.
          this.penColor = color;
          this._reset();

          this._addPoint(point);
        } else if (j !== group.length - 1) {
          // Middle point in a group.
          var _addPoint2 = this._addPoint(point),
              curve = _addPoint2.curve,
              widths = _addPoint2.widths;

          if (curve && widths) {
            drawCurve(curve, widths, color);
          }
        } else ;
      }
    } else {
      this._reset();
      var _rawPoint = group[0];
      drawDot(_rawPoint);
    }
  }
};

SignaturePad.prototype._toSVG = function () {
  var _this2 = this;

  var pointGroups = this._data;
  var canvas = this._canvas;
  var ratio = Math.max(window.devicePixelRatio || 1, 1);
  var minX = 0;
  var minY = 0;
  var maxX = canvas.width / ratio;
  var maxY = canvas.height / ratio;
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  svg.setAttributeNS(null, 'width', canvas.width);
  svg.setAttributeNS(null, 'height', canvas.height);

  this._fromData(pointGroups, function (curve, widths, color) {
    var path = document.createElement('path');

    // Need to check curve for NaN values, these pop up when drawing
    // lines on the canvas that are not continuous. E.g. Sharp corners
    // or stopping mid-stroke and than continuing without lifting mouse.
    if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
      var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));

      path.setAttribute('d', attr);
      path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
      path.setAttribute('stroke', color);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke-linecap', 'round');

      svg.appendChild(path);
    }
  }, function (rawPoint) {
    var circle = document.createElement('circle');
    var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
    circle.setAttribute('r', dotSize);
    circle.setAttribute('cx', rawPoint.x);
    circle.setAttribute('cy', rawPoint.y);
    circle.setAttribute('fill', rawPoint.color);

    svg.appendChild(circle);
  });

  var prefix = 'data:image/svg+xml;base64,';
  var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
  var body = svg.innerHTML;

  // IE hack for missing innerHTML property on SVGElement
  if (body === undefined) {
    var dummy = document.createElement('dummy');
    var nodes = svg.childNodes;
    dummy.innerHTML = '';

    for (var i = 0; i < nodes.length; i += 1) {
      dummy.appendChild(nodes[i].cloneNode(true));
    }

    body = dummy.innerHTML;
  }

  var footer = '</svg>';
  var data = header + body + footer;

  return prefix + btoa(data);
};

SignaturePad.prototype.fromData = function (pointGroups) {
  var _this3 = this;

  this.clear();

  this._fromData(pointGroups, function (curve, widths) {
    return _this3._drawCurve(curve, widths.start, widths.end);
  }, function (rawPoint) {
    return _this3._drawDot(rawPoint);
  });

  this._data = pointGroups;
};

SignaturePad.prototype.toData = function () {
  return this._data;
};

var signature_pad = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': SignaturePad
});

var require$$2$1 = /*@__PURE__*/getAugmentedNamespace(signature_pad);

var build = {exports: {}};

(function (module, exports) {
!function(e,t){module.exports=t();}(commonjsGlobal,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t){function r(e){var t=e.getContext("2d"),r=e.width,n=e.height,o=t.getImageData(0,0,r,n).data,f=a(!0,r,n,o),i=a(!1,r,n,o),c=u(!0,r,n,o),d=u(!1,r,n,o),p=d-c+1,l=i-f+1,s=t.getImageData(c,f,p,l);return e.width=p,e.height=l,t.clearRect(0,0,p,l),t.putImageData(s,0,0),e}function n(e,t,r,n){return {red:n[4*(r*t+e)],green:n[4*(r*t+e)+1],blue:n[4*(r*t+e)+2],alpha:n[4*(r*t+e)+3]}}function o(e,t,r,o){return n(e,t,r,o).alpha}function a(e,t,r,n){for(var a=e?1:-1,u=e?0:r-1,f=u;e?f<r:f>-1;f+=a)for(var i=0;i<t;i++)if(o(i,f,t,n))return f;return null}function u(e,t,r,n){for(var a=e?1:-1,u=e?0:t-1,f=u;e?f<t:f>-1;f+=a)for(var i=0;i<r;i++)if(o(f,i,t,n))return f;return null}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;}])});
}(build));

(function (module, exports) {
!function(e,t){module.exports=t(propTypes.exports,React__default,require$$2$1,build.exports);}(commonjsGlobal,function(e,t,n,r){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={exports:{},id:r,loaded:!1};return e[r].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t);}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r]);}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),f=n(1),p=r(f),l=n(2),d=r(l),v=n(3),h=r(v),_=n(4),g=r(_),m=function(e){function t(){var e,n,r,u;o(this,t);for(var s=arguments.length,c=Array(s),f=0;f<s;f++)c[f]=arguments[f];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(c))),r._sigPad=null,r._excludeOurProps=function(){var e=r.props,t=(e.canvasProps,e.clearOnResize,a(e,["canvasProps","clearOnResize"]));return t},r.getCanvas=function(){return r._canvas},r.getTrimmedCanvas=function(){var e=document.createElement("canvas");return e.width=r._canvas.width,e.height=r._canvas.height,e.getContext("2d").drawImage(r._canvas,0,0),(0, g.default)(e)},r.getSignaturePad=function(){return r._sigPad},r._checkClearOnResize=function(){r.props.clearOnResize&&r._resizeCanvas();},r._resizeCanvas=function(){var e=r.props.canvasProps||{},t=e.width,n=e.height;if(!t||!n){var a=r._canvas,o=Math.max(window.devicePixelRatio||1,1);t||(a.width=a.offsetWidth*o),n||(a.height=a.offsetHeight*o),a.getContext("2d").scale(o,o),r.clear();}},r.on=function(){return window.addEventListener("resize",r._checkClearOnResize),r._sigPad.on()},r.off=function(){return window.removeEventListener("resize",r._checkClearOnResize),r._sigPad.off()},r.clear=function(){return r._sigPad.clear()},r.isEmpty=function(){return r._sigPad.isEmpty()},r.fromDataURL=function(e,t){return r._sigPad.fromDataURL(e,t)},r.toDataURL=function(e,t){return r._sigPad.toDataURL(e,t)},r.fromData=function(e){return r._sigPad.fromData(e)},r.toData=function(){return r._sigPad.toData()},u=n,i(r,u)}return u(t,e),c(t,[{key:"componentDidMount",value:function(){this._sigPad=new h.default(this._canvas,this._excludeOurProps()),this._resizeCanvas(),this.on();}},{key:"componentWillUnmount",value:function(){this.off();}},{key:"componentDidUpdate",value:function(){Object.assign(this._sigPad,this._excludeOurProps());}},{key:"render",value:function(){var e=this,t=this.props.canvasProps;return d.default.createElement("canvas",s({ref:function(t){e._canvas=t;}},t))}}]),t}(l.Component);m.propTypes={velocityFilterWeight:p.default.number,minWidth:p.default.number,maxWidth:p.default.number,minDistance:p.default.number,dotSize:p.default.oneOfType([p.default.number,p.default.func]),penColor:p.default.string,throttle:p.default.number,onEnd:p.default.func,onBegin:p.default.func,canvasProps:p.default.object,clearOnResize:p.default.bool},m.defaultProps={clearOnResize:!0},t.default=m;},function(t,n){t.exports=e;},function(e,n){e.exports=t;},function(e,t){e.exports=n;},function(e,t){e.exports=r;}])});
}(build$1));

var SignatureCanvas = /*@__PURE__*/getDefaultExportFromCjs(build$1.exports);

var ImageMimeTypes;
(function (ImageMimeTypes) {
    ImageMimeTypes["JPEG"] = "image/jpeg";
    ImageMimeTypes["PNG"] = "image/png";
})(ImageMimeTypes || (ImageMimeTypes = {}));
const WHITE_BACKGROUND_FOR_JPEG = '#FFFFFF';
const convertImageTo = async (imageBlob, newImageType) => {
    let imageSizes;
    let convertedImageBlob;
    const image = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const imageUrl = URL.createObjectURL(imageBlob);
    const revokeResources = () => {
        canvas.remove();
        image.remove();
        URL.revokeObjectURL(imageUrl);
    };
    if (!ctx) {
        revokeResources();
        return;
    }
    try {
        // eslint-disable-next-line prefer-const
        imageSizes = await new Promise((resolve, reject) => {
            image.addEventListener('load', function () {
                resolve({
                    width: this.width,
                    height: this.height,
                });
            });
            image.addEventListener('error', reject);
            image.src = imageUrl;
        });
    }
    catch (_a) {
        revokeResources();
        return;
    }
    canvas.width = imageSizes.width;
    canvas.height = imageSizes.height;
    if (newImageType === ImageMimeTypes.JPEG) {
        ctx.fillStyle = WHITE_BACKGROUND_FOR_JPEG;
    }
    ctx.fillRect(0, 0, imageSizes.width, imageSizes.height);
    ctx.drawImage(image, 0, 0, imageSizes.width, imageSizes.height);
    try {
        // eslint-disable-next-line prefer-const
        convertedImageBlob = await new Promise((resolve, reject) => {
            canvas.toBlob((blob) => {
                if (blob instanceof Blob) {
                    resolve(blob);
                }
                else {
                    reject();
                }
            }, newImageType);
        });
    }
    catch (_b) {
        revokeResources();
        return;
    }
    revokeResources();
    return convertedImageBlob;
};

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */

/* eslint-disable no-mixed-operators */
const cssKeywords = colorName;

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

const reverseKeywords = {};
for (const key of Object.keys(cssKeywords)) {
	reverseKeywords[cssKeywords[key]] = key;
}

const convert$1 = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

var conversions$2 = convert$1;

// Hide .channels and .labels properties
for (const model of Object.keys(convert$1)) {
	if (!('channels' in convert$1[model])) {
		throw new Error('missing channels property: ' + model);
	}

	if (!('labels' in convert$1[model])) {
		throw new Error('missing channel labels property: ' + model);
	}

	if (convert$1[model].labels.length !== convert$1[model].channels) {
		throw new Error('channel and label counts mismatch: ' + model);
	}

	const {channels, labels} = convert$1[model];
	delete convert$1[model].channels;
	delete convert$1[model].labels;
	Object.defineProperty(convert$1[model], 'channels', {value: channels});
	Object.defineProperty(convert$1[model], 'labels', {value: labels});
}

convert$1.rgb.hsl = function (rgb) {
	const r = rgb[0] / 255;
	const g = rgb[1] / 255;
	const b = rgb[2] / 255;
	const min = Math.min(r, g, b);
	const max = Math.max(r, g, b);
	const delta = max - min;
	let h;
	let s;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	const l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert$1.rgb.hsv = function (rgb) {
	let rdif;
	let gdif;
	let bdif;
	let h;
	let s;

	const r = rgb[0] / 255;
	const g = rgb[1] / 255;
	const b = rgb[2] / 255;
	const v = Math.max(r, g, b);
	const diff = v - Math.min(r, g, b);
	const diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = 0;
		s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}

		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert$1.rgb.hwb = function (rgb) {
	const r = rgb[0];
	const g = rgb[1];
	let b = rgb[2];
	const h = convert$1.rgb.hsl(rgb)[0];
	const w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert$1.rgb.cmyk = function (rgb) {
	const r = rgb[0] / 255;
	const g = rgb[1] / 255;
	const b = rgb[2] / 255;

	const k = Math.min(1 - r, 1 - g, 1 - b);
	const c = (1 - r - k) / (1 - k) || 0;
	const m = (1 - g - k) / (1 - k) || 0;
	const y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

function comparativeDistance(x, y) {
	/*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/
	return (
		((x[0] - y[0]) ** 2) +
		((x[1] - y[1]) ** 2) +
		((x[2] - y[2]) ** 2)
	);
}

convert$1.rgb.keyword = function (rgb) {
	const reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	let currentClosestDistance = Infinity;
	let currentClosestKeyword;

	for (const keyword of Object.keys(cssKeywords)) {
		const value = cssKeywords[keyword];

		// Compute comparative distance
		const distance = comparativeDistance(rgb, value);

		// Check if its less, if so set as closest
		if (distance < currentClosestDistance) {
			currentClosestDistance = distance;
			currentClosestKeyword = keyword;
		}
	}

	return currentClosestKeyword;
};

convert$1.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert$1.rgb.xyz = function (rgb) {
	let r = rgb[0] / 255;
	let g = rgb[1] / 255;
	let b = rgb[2] / 255;

	// Assume sRGB
	r = r > 0.04045 ? (((r + 0.055) / 1.055) ** 2.4) : (r / 12.92);
	g = g > 0.04045 ? (((g + 0.055) / 1.055) ** 2.4) : (g / 12.92);
	b = b > 0.04045 ? (((b + 0.055) / 1.055) ** 2.4) : (b / 12.92);

	const x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	const y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	const z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert$1.rgb.lab = function (rgb) {
	const xyz = convert$1.rgb.xyz(rgb);
	let x = xyz[0];
	let y = xyz[1];
	let z = xyz[2];

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? (x ** (1 / 3)) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? (y ** (1 / 3)) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? (z ** (1 / 3)) : (7.787 * z) + (16 / 116);

	const l = (116 * y) - 16;
	const a = 500 * (x - y);
	const b = 200 * (y - z);

	return [l, a, b];
};

convert$1.hsl.rgb = function (hsl) {
	const h = hsl[0] / 360;
	const s = hsl[1] / 100;
	const l = hsl[2] / 100;
	let t2;
	let t3;
	let val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	const t1 = 2 * l - t2;

	const rgb = [0, 0, 0];
	for (let i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}

		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert$1.hsl.hsv = function (hsl) {
	const h = hsl[0];
	let s = hsl[1] / 100;
	let l = hsl[2] / 100;
	let smin = s;
	const lmin = Math.max(l, 0.01);

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	const v = (l + s) / 2;
	const sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert$1.hsv.rgb = function (hsv) {
	const h = hsv[0] / 60;
	const s = hsv[1] / 100;
	let v = hsv[2] / 100;
	const hi = Math.floor(h) % 6;

	const f = h - Math.floor(h);
	const p = 255 * v * (1 - s);
	const q = 255 * v * (1 - (s * f));
	const t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert$1.hsv.hsl = function (hsv) {
	const h = hsv[0];
	const s = hsv[1] / 100;
	const v = hsv[2] / 100;
	const vmin = Math.max(v, 0.01);
	let sl;
	let l;

	l = (2 - s) * v;
	const lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert$1.hwb.rgb = function (hwb) {
	const h = hwb[0] / 360;
	let wh = hwb[1] / 100;
	let bl = hwb[2] / 100;
	const ratio = wh + bl;
	let f;

	// Wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	const i = Math.floor(6 * h);
	const v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	const n = wh + f * (v - wh); // Linear interpolation

	let r;
	let g;
	let b;
	/* eslint-disable max-statements-per-line,no-multi-spaces */
	switch (i) {
		default:
		case 6:
		case 0: r = v;  g = n;  b = wh; break;
		case 1: r = n;  g = v;  b = wh; break;
		case 2: r = wh; g = v;  b = n; break;
		case 3: r = wh; g = n;  b = v; break;
		case 4: r = n;  g = wh; b = v; break;
		case 5: r = v;  g = wh; b = n; break;
	}
	/* eslint-enable max-statements-per-line,no-multi-spaces */

	return [r * 255, g * 255, b * 255];
};

convert$1.cmyk.rgb = function (cmyk) {
	const c = cmyk[0] / 100;
	const m = cmyk[1] / 100;
	const y = cmyk[2] / 100;
	const k = cmyk[3] / 100;

	const r = 1 - Math.min(1, c * (1 - k) + k);
	const g = 1 - Math.min(1, m * (1 - k) + k);
	const b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert$1.xyz.rgb = function (xyz) {
	const x = xyz[0] / 100;
	const y = xyz[1] / 100;
	const z = xyz[2] / 100;
	let r;
	let g;
	let b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// Assume sRGB
	r = r > 0.0031308
		? ((1.055 * (r ** (1.0 / 2.4))) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * (g ** (1.0 / 2.4))) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * (b ** (1.0 / 2.4))) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert$1.xyz.lab = function (xyz) {
	let x = xyz[0];
	let y = xyz[1];
	let z = xyz[2];

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? (x ** (1 / 3)) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? (y ** (1 / 3)) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? (z ** (1 / 3)) : (7.787 * z) + (16 / 116);

	const l = (116 * y) - 16;
	const a = 500 * (x - y);
	const b = 200 * (y - z);

	return [l, a, b];
};

convert$1.lab.xyz = function (lab) {
	const l = lab[0];
	const a = lab[1];
	const b = lab[2];
	let x;
	let y;
	let z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	const y2 = y ** 3;
	const x2 = x ** 3;
	const z2 = z ** 3;
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert$1.lab.lch = function (lab) {
	const l = lab[0];
	const a = lab[1];
	const b = lab[2];
	let h;

	const hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	const c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert$1.lch.lab = function (lch) {
	const l = lch[0];
	const c = lch[1];
	const h = lch[2];

	const hr = h / 360 * 2 * Math.PI;
	const a = c * Math.cos(hr);
	const b = c * Math.sin(hr);

	return [l, a, b];
};

convert$1.rgb.ansi16 = function (args, saturation = null) {
	const [r, g, b] = args;
	let value = saturation === null ? convert$1.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	let ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert$1.hsv.ansi16 = function (args) {
	// Optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert$1.rgb.ansi16(convert$1.hsv.rgb(args), args[2]);
};

convert$1.rgb.ansi256 = function (args) {
	const r = args[0];
	const g = args[1];
	const b = args[2];

	// We use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	const ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert$1.ansi16.rgb = function (args) {
	let color = args % 10;

	// Handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	const mult = (~~(args > 50) + 1) * 0.5;
	const r = ((color & 1) * mult) * 255;
	const g = (((color >> 1) & 1) * mult) * 255;
	const b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert$1.ansi256.rgb = function (args) {
	// Handle greyscale
	if (args >= 232) {
		const c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	let rem;
	const r = Math.floor(args / 36) / 5 * 255;
	const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	const b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert$1.rgb.hex = function (args) {
	const integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	const string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert$1.hex.rgb = function (args) {
	const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	let colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(char => {
			return char + char;
		}).join('');
	}

	const integer = parseInt(colorString, 16);
	const r = (integer >> 16) & 0xFF;
	const g = (integer >> 8) & 0xFF;
	const b = integer & 0xFF;

	return [r, g, b];
};

convert$1.rgb.hcg = function (rgb) {
	const r = rgb[0] / 255;
	const g = rgb[1] / 255;
	const b = rgb[2] / 255;
	const max = Math.max(Math.max(r, g), b);
	const min = Math.min(Math.min(r, g), b);
	const chroma = (max - min);
	let grayscale;
	let hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert$1.hsl.hcg = function (hsl) {
	const s = hsl[1] / 100;
	const l = hsl[2] / 100;

	const c = l < 0.5 ? (2.0 * s * l) : (2.0 * s * (1.0 - l));

	let f = 0;
	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert$1.hsv.hcg = function (hsv) {
	const s = hsv[1] / 100;
	const v = hsv[2] / 100;

	const c = s * v;
	let f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert$1.hcg.rgb = function (hcg) {
	const h = hcg[0] / 360;
	const c = hcg[1] / 100;
	const g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	const pure = [0, 0, 0];
	const hi = (h % 1) * 6;
	const v = hi % 1;
	const w = 1 - v;
	let mg = 0;

	/* eslint-disable max-statements-per-line */
	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}
	/* eslint-enable max-statements-per-line */

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert$1.hcg.hsv = function (hcg) {
	const c = hcg[1] / 100;
	const g = hcg[2] / 100;

	const v = c + g * (1.0 - c);
	let f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert$1.hcg.hsl = function (hcg) {
	const c = hcg[1] / 100;
	const g = hcg[2] / 100;

	const l = g * (1.0 - c) + 0.5 * c;
	let s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert$1.hcg.hwb = function (hcg) {
	const c = hcg[1] / 100;
	const g = hcg[2] / 100;
	const v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert$1.hwb.hcg = function (hwb) {
	const w = hwb[1] / 100;
	const b = hwb[2] / 100;
	const v = 1 - b;
	const c = v - w;
	let g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert$1.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert$1.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert$1.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert$1.gray.hsl = function (args) {
	return [0, 0, args[0]];
};

convert$1.gray.hsv = convert$1.gray.hsl;

convert$1.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert$1.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert$1.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert$1.gray.hex = function (gray) {
	const val = Math.round(gray[0] / 100 * 255) & 0xFF;
	const integer = (val << 16) + (val << 8) + val;

	const string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert$1.rgb.gray = function (rgb) {
	const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};

const conversions$1 = conversions$2;

/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	const graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	const models = Object.keys(conversions$1);

	for (let len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	const graph = buildGraph();
	const queue = [fromModel]; // Unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		const current = queue.pop();
		const adjacents = Object.keys(conversions$1[current]);

		for (let len = adjacents.length, i = 0; i < len; i++) {
			const adjacent = adjacents[i];
			const node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	const path = [graph[toModel].parent, toModel];
	let fn = conversions$1[graph[toModel].parent][toModel];

	let cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions$1[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

var route$1 = function (fromModel) {
	const graph = deriveBFS(fromModel);
	const conversion = {};

	const models = Object.keys(graph);
	for (let len = models.length, i = 0; i < len; i++) {
		const toModel = models[i];
		const node = graph[toModel];

		if (node.parent === null) {
			// No possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};

const conversions = conversions$2;
const route = route$1;

const convert = {};

const models = Object.keys(conversions);

function wrapRaw(fn) {
	const wrappedFn = function (...args) {
		const arg0 = args[0];
		if (arg0 === undefined || arg0 === null) {
			return arg0;
		}

		if (arg0.length > 1) {
			args = arg0;
		}

		return fn(args);
	};

	// Preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	const wrappedFn = function (...args) {
		const arg0 = args[0];

		if (arg0 === undefined || arg0 === null) {
			return arg0;
		}

		if (arg0.length > 1) {
			args = arg0;
		}

		const result = fn(args);

		// We're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (let len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// Preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(fromModel => {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	const routes = route(fromModel);
	const routeModels = Object.keys(routes);

	routeModels.forEach(toModel => {
		const fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

var colorConvert = convert;

var lib = {};

var Component = {};

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_min(stylisOptions);

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (process.env.NODE_ENV !== 'production') {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (process.env.NODE_ENV !== 'production' && couldBeSelectorInterpolation && shouldWarnAboutInterpolatingClassNameFromCss && cached !== undefined) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var hasOwnProperty$1 = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? createCache() : null);
var ThemeContext$1 = /*#__PURE__*/createContext({});
EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/createElement(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/forwardRef(render);
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';

var Noop$1 = function Noop() {
  return null;
};

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles);

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty$1.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/createElement(type, newProps);
  var possiblyStyleElement = /*#__PURE__*/createElement(Noop$1, null);


  return /*#__PURE__*/createElement(Fragment$1, null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/createElement(ThemeContext$1.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1="function"===typeof Symbol&&Symbol.for,c$1=b$1?Symbol.for("react.element"):60103,d$1=b$1?Symbol.for("react.portal"):60106,e=b$1?Symbol.for("react.fragment"):60107,f$1=b$1?Symbol.for("react.strict_mode"):60108,g$1=b$1?Symbol.for("react.profiler"):60114,h$1=b$1?Symbol.for("react.provider"):60109,k$1=b$1?Symbol.for("react.context"):60110,l$1=b$1?Symbol.for("react.async_mode"):60111,m$1=b$1?Symbol.for("react.concurrent_mode"):60111,n$1=b$1?Symbol.for("react.forward_ref"):60112,p$1=b$1?Symbol.for("react.suspense"):60113,q$1=b$1?
Symbol.for("react.suspense_list"):60120,r=b$1?Symbol.for("react.memo"):60115,t=b$1?Symbol.for("react.lazy"):60116,v$1=b$1?Symbol.for("react.block"):60121,w$1=b$1?Symbol.for("react.fundamental"):60117,x$2=b$1?Symbol.for("react.responder"):60118,y$1=b$1?Symbol.for("react.scope"):60119;
function z$1(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$1:switch(a=a.type,a){case l$1:case m$1:case e:case g$1:case f$1:case p$1:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n$1:case t:case r:case h$1:return a;default:return u}}case d$1:return u}}}function A$1(a){return z$1(a)===m$1}reactIs_production_min.AsyncMode=l$1;reactIs_production_min.ConcurrentMode=m$1;reactIs_production_min.ContextConsumer=k$1;reactIs_production_min.ContextProvider=h$1;reactIs_production_min.Element=c$1;reactIs_production_min.ForwardRef=n$1;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d$1;
reactIs_production_min.Profiler=g$1;reactIs_production_min.StrictMode=f$1;reactIs_production_min.Suspense=p$1;reactIs_production_min.isAsyncMode=function(a){return A$1(a)||z$1(a)===l$1};reactIs_production_min.isConcurrentMode=A$1;reactIs_production_min.isContextConsumer=function(a){return z$1(a)===k$1};reactIs_production_min.isContextProvider=function(a){return z$1(a)===h$1};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$1};reactIs_production_min.isForwardRef=function(a){return z$1(a)===n$1};reactIs_production_min.isFragment=function(a){return z$1(a)===e};reactIs_production_min.isLazy=function(a){return z$1(a)===t};
reactIs_production_min.isMemo=function(a){return z$1(a)===r};reactIs_production_min.isPortal=function(a){return z$1(a)===d$1};reactIs_production_min.isProfiler=function(a){return z$1(a)===g$1};reactIs_production_min.isStrictMode=function(a){return z$1(a)===f$1};reactIs_production_min.isSuspense=function(a){return z$1(a)===p$1};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m$1||a===g$1||a===f$1||a===p$1||a===q$1||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h$1||a.$$typeof===k$1||a.$$typeof===n$1||a.$$typeof===w$1||a.$$typeof===x$2||a.$$typeof===y$1||a.$$typeof===v$1)};reactIs_production_min.typeOf=z$1;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min;
} else {
  reactIs$1.exports = reactIs_development;
}

var reactIs = reactIs$1.exports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$9(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (process.env.NODE_ENV !== 'production' && (mergedTheme == null || typeof mergedTheme !== 'object' || Array.isArray(mergedTheme))) {
      throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
    }

    return mergedTheme;
  }

  if (process.env.NODE_ENV !== 'production' && (theme == null || typeof theme !== 'object' || Array.isArray(theme))) {
    throw new Error('[ThemeProvider] Please make your theme prop a plain object');
  }

  return _objectSpread$9({}, outerTheme, {}, theme);
};

var createCacheWithTheme = weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
});

var ThemeProvider = function ThemeProvider(props) {
  return /*#__PURE__*/createElement(ThemeContext$1.Consumer, null, function (theme) {
    if (props.theme !== theme) {
      theme = createCacheWithTheme(theme)(props.theme);
    }

    return /*#__PURE__*/createElement(ThemeContext$1.Provider, {
      value: theme
    }, props.children);
  });
};

// should we change this to be forwardRef/withCSSContext style so it doesn't merge with props?
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    return /*#__PURE__*/createElement(ThemeContext$1.Consumer, null, function (theme) {
      return /*#__PURE__*/createElement(Component, _extends$1({
        theme: theme,
        ref: ref
      }, props));
    });
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics_cjs(WithTheme, Component);
}

function useTheme() {
  return React__default.useContext(ThemeContext$1);
}

var emotionTheming_browser_esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ThemeProvider: ThemeProvider,
  useTheme: useTheme,
  withTheme: withTheme
});

var require$$1 = /*@__PURE__*/getAugmentedNamespace(emotionTheming_browser_esm);

var _default = {};

var isObject$1 = function isObject(x) {
	return typeof x === 'object' && x !== null;
};

var isWindow$1 = function (obj) {

  if (obj == null) {
    return false;
  }

  var o = Object(obj);

  return o === o.window;
};

var isObject = isObject$1;
var isWindow = isWindow$1;

function isNode (val) {
  if (!isObject(val) || !isWindow(window) || typeof window.Node !== 'function') {
    return false
  }

  return typeof val.nodeType === 'number' &&
    typeof val.nodeName === 'string'
}

var isDom = isNode;

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    module.exports["default"] = module.exports, module.exports.__esModule = true;
    return _extends.apply(this, arguments);
  }
  module.exports = _extends;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _extends = unwrapExports(_extends_1);

var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  module.exports = _objectWithoutPropertiesLoose;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(objectWithoutPropertiesLoose);

var objectWithoutProperties = createCommonjsModule(function (module) {
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  module.exports = _objectWithoutProperties;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _objectWithoutProperties = unwrapExports(objectWithoutProperties);

var theme$1 = {
  BASE_FONT_FAMILY: 'Menlo, monospace',
  BASE_FONT_SIZE: '11px',
  BASE_LINE_HEIGHT: 1.2,
  BASE_BACKGROUND_COLOR: 'rgb(36, 36, 36)',
  BASE_COLOR: 'rgb(213, 213, 213)',
  OBJECT_PREVIEW_ARRAY_MAX_PROPERTIES: 10,
  OBJECT_PREVIEW_OBJECT_MAX_PROPERTIES: 5,
  OBJECT_NAME_COLOR: 'rgb(227, 110, 236)',
  OBJECT_VALUE_NULL_COLOR: 'rgb(127, 127, 127)',
  OBJECT_VALUE_UNDEFINED_COLOR: 'rgb(127, 127, 127)',
  OBJECT_VALUE_REGEXP_COLOR: 'rgb(233, 63, 59)',
  OBJECT_VALUE_STRING_COLOR: 'rgb(233, 63, 59)',
  OBJECT_VALUE_SYMBOL_COLOR: 'rgb(233, 63, 59)',
  OBJECT_VALUE_NUMBER_COLOR: 'hsl(252, 100%, 75%)',
  OBJECT_VALUE_BOOLEAN_COLOR: 'hsl(252, 100%, 75%)',
  OBJECT_VALUE_FUNCTION_PREFIX_COLOR: 'rgb(85, 106, 242)',
  HTML_TAG_COLOR: 'rgb(93, 176, 215)',
  HTML_TAGNAME_COLOR: 'rgb(93, 176, 215)',
  HTML_TAGNAME_TEXT_TRANSFORM: 'lowercase',
  HTML_ATTRIBUTE_NAME_COLOR: 'rgb(155, 187, 220)',
  HTML_ATTRIBUTE_VALUE_COLOR: 'rgb(242, 151, 102)',
  HTML_COMMENT_COLOR: 'rgb(137, 137, 137)',
  HTML_DOCTYPE_COLOR: 'rgb(192, 192, 192)',
  ARROW_COLOR: 'rgb(145, 145, 145)',
  ARROW_MARGIN_RIGHT: 3,
  ARROW_FONT_SIZE: 12,
  ARROW_ANIMATION_DURATION: '0',
  TREENODE_FONT_FAMILY: 'Menlo, monospace',
  TREENODE_FONT_SIZE: '11px',
  TREENODE_LINE_HEIGHT: 1.2,
  TREENODE_PADDING_LEFT: 12,
  TABLE_BORDER_COLOR: 'rgb(85, 85, 85)',
  TABLE_TH_BACKGROUND_COLOR: 'rgb(44, 44, 44)',
  TABLE_TH_HOVER_COLOR: 'rgb(48, 48, 48)',
  TABLE_SORT_ICON_COLOR: 'black',
  TABLE_DATA_BACKGROUND_IMAGE: 'linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0) 50%, rgba(51, 139, 255, 0.0980392) 50%, rgba(51, 139, 255, 0.0980392))',
  TABLE_DATA_BACKGROUND_SIZE: '128px 32px'
};

var theme$2 = {
  BASE_FONT_FAMILY: 'Menlo, monospace',
  BASE_FONT_SIZE: '11px',
  BASE_LINE_HEIGHT: 1.2,
  BASE_BACKGROUND_COLOR: 'white',
  BASE_COLOR: 'black',
  OBJECT_PREVIEW_ARRAY_MAX_PROPERTIES: 10,
  OBJECT_PREVIEW_OBJECT_MAX_PROPERTIES: 5,
  OBJECT_NAME_COLOR: 'rgb(136, 19, 145)',
  OBJECT_VALUE_NULL_COLOR: 'rgb(128, 128, 128)',
  OBJECT_VALUE_UNDEFINED_COLOR: 'rgb(128, 128, 128)',
  OBJECT_VALUE_REGEXP_COLOR: 'rgb(196, 26, 22)',
  OBJECT_VALUE_STRING_COLOR: 'rgb(196, 26, 22)',
  OBJECT_VALUE_SYMBOL_COLOR: 'rgb(196, 26, 22)',
  OBJECT_VALUE_NUMBER_COLOR: 'rgb(28, 0, 207)',
  OBJECT_VALUE_BOOLEAN_COLOR: 'rgb(28, 0, 207)',
  OBJECT_VALUE_FUNCTION_PREFIX_COLOR: 'rgb(13, 34, 170)',
  HTML_TAG_COLOR: 'rgb(168, 148, 166)',
  HTML_TAGNAME_COLOR: 'rgb(136, 18, 128)',
  HTML_TAGNAME_TEXT_TRANSFORM: 'lowercase',
  HTML_ATTRIBUTE_NAME_COLOR: 'rgb(153, 69, 0)',
  HTML_ATTRIBUTE_VALUE_COLOR: 'rgb(26, 26, 166)',
  HTML_COMMENT_COLOR: 'rgb(35, 110, 37)',
  HTML_DOCTYPE_COLOR: 'rgb(192, 192, 192)',
  ARROW_COLOR: '#6e6e6e',
  ARROW_MARGIN_RIGHT: 3,
  ARROW_FONT_SIZE: 12,
  ARROW_ANIMATION_DURATION: '0',
  TREENODE_FONT_FAMILY: 'Menlo, monospace',
  TREENODE_FONT_SIZE: '11px',
  TREENODE_LINE_HEIGHT: 1.2,
  TREENODE_PADDING_LEFT: 12,
  TABLE_BORDER_COLOR: '#aaa',
  TABLE_TH_BACKGROUND_COLOR: '#eee',
  TABLE_TH_HOVER_COLOR: 'hsla(0, 0%, 90%, 1)',
  TABLE_SORT_ICON_COLOR: '#6e6e6e',
  TABLE_DATA_BACKGROUND_IMAGE: 'linear-gradient(to bottom, white, white 50%, rgb(234, 243, 255) 50%, rgb(234, 243, 255))',
  TABLE_DATA_BACKGROUND_SIZE: '128px 32px'
};

var themes = /*#__PURE__*/Object.freeze({
__proto__: null,
chromeDark: theme$1,
chromeLight: theme$2
});

var arrayWithHoles = createCommonjsModule(function (module) {
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  module.exports = _arrayWithHoles;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(arrayWithHoles);

var iterableToArrayLimit = createCommonjsModule(function (module) {
  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  module.exports = _iterableToArrayLimit;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(iterableToArrayLimit);

var arrayLikeToArray = createCommonjsModule(function (module) {
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  module.exports = _arrayLikeToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(arrayLikeToArray);

var unsupportedIterableToArray = createCommonjsModule(function (module) {
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
  }
  module.exports = _unsupportedIterableToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(unsupportedIterableToArray);

var nonIterableRest = createCommonjsModule(function (module) {
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  module.exports = _nonIterableRest;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(nonIterableRest);

var slicedToArray = createCommonjsModule(function (module) {
  function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
  }
  module.exports = _slicedToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _slicedToArray = unwrapExports(slicedToArray);

var _typeof_1 = createCommonjsModule(function (module) {
  function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      module.exports = _typeof = function _typeof(obj) {
        return typeof obj;
      };
      module.exports["default"] = module.exports, module.exports.__esModule = true;
    } else {
      module.exports = _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
      module.exports["default"] = module.exports, module.exports.__esModule = true;
    }
    return _typeof(obj);
  }
  module.exports = _typeof;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _typeof$1 = unwrapExports(_typeof_1);

var runtime_1 = createCommonjsModule(function (module) {
  var runtime = function (exports) {
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1;
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function (obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []);
      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }
    exports.wrap = wrap;
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      IteratorPrototype = NativeIteratorPrototype;
    }
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }
    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction ||
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }
      genFun.prototype = Object.create(Gp);
      return genFun;
    };
    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;
          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }
          return PromiseImpl.resolve(value).then(function (unwrapped) {
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            return invoke("throw", error, resolve, reject);
          });
        }
      }
      var previousPromise;
      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise =
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
      this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };
    exports.AsyncIterator = AsyncIterator;
    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };
    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }
        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          }
          return doneResult();
        }
        context.method = method;
        context.arg = arg;
        while (true) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if (context.method === "next") {
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }
            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }
          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);
          if (record.type === "normal") {
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;
            if (record.arg === ContinueSentinel) {
              continue;
            }
            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted;
            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];
      if (method === undefined$1) {
        context.delegate = null;
        if (context.method === "throw") {
          if (delegate.iterator["return"]) {
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);
            if (context.method === "throw") {
              return ContinueSentinel;
            }
          }
          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return ContinueSentinel;
      }
      var record = tryCatch(method, delegate.iterator, context.arg);
      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }
      var info = record.arg;
      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }
      if (info.done) {
        context[delegate.resultName] = info.value;
        context.next = delegate.nextLoc;
        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        return info;
      }
      context.delegate = null;
      return ContinueSentinel;
    }
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    Gp[iteratorSymbol] = function () {
      return this;
    };
    Gp.toString = function () {
      return "[object Generator]";
    };
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      if (1 in locs) {
        entry.catchLoc = locs[1];
      }
      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }
      this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }
    exports.keys = function (object) {
      var keys = [];
      for (var key in object) {
        keys.push(key);
      }
      keys.reverse();
      return function next() {
        while (keys.length) {
          var key = keys.pop();
          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        }
        next.done = true;
        return next;
      };
    };
    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }
        if (typeof iterable.next === "function") {
          return iterable;
        }
        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }
            next.value = undefined$1;
            next.done = true;
            return next;
          };
          return next.next = next;
        }
      }
      return {
        next: doneResult
      };
    }
    exports.values = values;
    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }
    Context.prototype = {
      constructor: Context,
      reset: function (skipTempReset) {
        this.prev = 0;
        this.next = 0;
        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);
        if (!skipTempReset) {
          for (var name in this) {
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function () {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;
        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }
        return this.rval;
      },
      dispatchException: function (exception) {
        if (this.done) {
          throw exception;
        }
        var context = this;
        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;
          if (caught) {
            context.method = "next";
            context.arg = undefined$1;
          }
          return !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;
          if (entry.tryLoc === "root") {
            return handle("end");
          }
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function (type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          finallyEntry = null;
        }
        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;
        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }
        return this.complete(record);
      },
      complete: function (record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }
        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }
        return ContinueSentinel;
      },
      finish: function (finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function (tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function (iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };
        if (this.method === "next") {
          this.arg = undefined$1;
        }
        return ContinueSentinel;
      }
    };
    return exports;
  }(
  module.exports );
  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});

var regenerator = runtime_1;

var arrayWithoutHoles = createCommonjsModule(function (module) {
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
  }
  module.exports = _arrayWithoutHoles;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(arrayWithoutHoles);

var iterableToArray = createCommonjsModule(function (module) {
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }
  module.exports = _iterableToArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(iterableToArray);

var nonIterableSpread = createCommonjsModule(function (module) {
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  module.exports = _nonIterableSpread;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
unwrapExports(nonIterableSpread);

var toConsumableArray = createCommonjsModule(function (module) {
  function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
  }
  module.exports = _toConsumableArray;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _toConsumableArray = unwrapExports(toConsumableArray);

var defineProperty = createCommonjsModule(function (module) {
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  module.exports = _defineProperty;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});
var _defineProperty = unwrapExports(defineProperty);

var ExpandedPathsContext = createContext([{}, function () {}]);

var unselectable = {
  WebkitTouchCallout: 'none',
  WebkitUserSelect: 'none',
  KhtmlUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
  OUserSelect: 'none',
  userSelect: 'none'
};

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var base = (function (theme) {
  return {
    DOMNodePreview: {
      htmlOpenTag: {
        base: {
          color: theme.HTML_TAG_COLOR
        },
        tagName: {
          color: theme.HTML_TAGNAME_COLOR,
          textTransform: theme.HTML_TAGNAME_TEXT_TRANSFORM
        },
        htmlAttributeName: {
          color: theme.HTML_ATTRIBUTE_NAME_COLOR
        },
        htmlAttributeValue: {
          color: theme.HTML_ATTRIBUTE_VALUE_COLOR
        }
      },
      htmlCloseTag: {
        base: {
          color: theme.HTML_TAG_COLOR
        },
        offsetLeft: {
          marginLeft: -theme.TREENODE_PADDING_LEFT
        },
        tagName: {
          color: theme.HTML_TAGNAME_COLOR,
          textTransform: theme.HTML_TAGNAME_TEXT_TRANSFORM
        }
      },
      htmlComment: {
        color: theme.HTML_COMMENT_COLOR
      },
      htmlDoctype: {
        color: theme.HTML_DOCTYPE_COLOR
      }
    },
    ObjectPreview: {
      objectDescription: {
        fontStyle: 'italic'
      },
      preview: {
        fontStyle: 'italic'
      },
      arrayMaxProperties: theme.OBJECT_PREVIEW_ARRAY_MAX_PROPERTIES,
      objectMaxProperties: theme.OBJECT_PREVIEW_OBJECT_MAX_PROPERTIES
    },
    ObjectName: {
      base: {
        color: theme.OBJECT_NAME_COLOR
      },
      dimmed: {
        opacity: 0.6
      }
    },
    ObjectValue: {
      objectValueNull: {
        color: theme.OBJECT_VALUE_NULL_COLOR
      },
      objectValueUndefined: {
        color: theme.OBJECT_VALUE_UNDEFINED_COLOR
      },
      objectValueRegExp: {
        color: theme.OBJECT_VALUE_REGEXP_COLOR
      },
      objectValueString: {
        color: theme.OBJECT_VALUE_STRING_COLOR
      },
      objectValueSymbol: {
        color: theme.OBJECT_VALUE_SYMBOL_COLOR
      },
      objectValueNumber: {
        color: theme.OBJECT_VALUE_NUMBER_COLOR
      },
      objectValueBoolean: {
        color: theme.OBJECT_VALUE_BOOLEAN_COLOR
      },
      objectValueFunctionPrefix: {
        color: theme.OBJECT_VALUE_FUNCTION_PREFIX_COLOR,
        fontStyle: 'italic'
      },
      objectValueFunctionName: {
        fontStyle: 'italic'
      }
    },
    TreeView: {
      treeViewOutline: {
        padding: 0,
        margin: 0,
        listStyleType: 'none'
      }
    },
    TreeNode: {
      treeNodeBase: {
        color: theme.BASE_COLOR,
        backgroundColor: theme.BASE_BACKGROUND_COLOR,
        lineHeight: theme.TREENODE_LINE_HEIGHT,
        cursor: 'default',
        boxSizing: 'border-box',
        listStyle: 'none',
        fontFamily: theme.TREENODE_FONT_FAMILY,
        fontSize: theme.TREENODE_FONT_SIZE
      },
      treeNodePreviewContainer: {},
      treeNodePlaceholder: _objectSpread$7({
        whiteSpace: 'pre',
        fontSize: theme.ARROW_FONT_SIZE,
        marginRight: theme.ARROW_MARGIN_RIGHT
      }, unselectable),
      treeNodeArrow: {
        base: _objectSpread$7(_objectSpread$7({
          color: theme.ARROW_COLOR,
          display: 'inline-block',
          fontSize: theme.ARROW_FONT_SIZE,
          marginRight: theme.ARROW_MARGIN_RIGHT
        }, parseFloat(theme.ARROW_ANIMATION_DURATION) > 0 ? {
          transition: "transform ".concat(theme.ARROW_ANIMATION_DURATION, " ease 0s")
        } : {}), unselectable),
        expanded: {
          WebkitTransform: 'rotateZ(90deg)',
          MozTransform: 'rotateZ(90deg)',
          transform: 'rotateZ(90deg)'
        },
        collapsed: {
          WebkitTransform: 'rotateZ(0deg)',
          MozTransform: 'rotateZ(0deg)',
          transform: 'rotateZ(0deg)'
        }
      },
      treeNodeChildNodesContainer: {
        margin: 0,
        paddingLeft: theme.TREENODE_PADDING_LEFT
      }
    },
    TableInspector: {
      base: {
        color: theme.BASE_COLOR,
        position: 'relative',
        border: "1px solid ".concat(theme.TABLE_BORDER_COLOR),
        fontFamily: theme.BASE_FONT_FAMILY,
        fontSize: theme.BASE_FONT_SIZE,
        lineHeight: '120%',
        boxSizing: 'border-box',
        cursor: 'default'
      }
    },
    TableInspectorHeaderContainer: {
      base: {
        top: 0,
        height: '17px',
        left: 0,
        right: 0,
        overflowX: 'hidden'
      },
      table: {
        tableLayout: 'fixed',
        borderSpacing: 0,
        borderCollapse: 'separate',
        height: '100%',
        width: '100%',
        margin: 0
      }
    },
    TableInspectorDataContainer: {
      tr: {
        display: 'table-row'
      },
      td: {
        boxSizing: 'border-box',
        border: 'none',
        height: '16px',
        verticalAlign: 'top',
        padding: '1px 4px',
        WebkitUserSelect: 'text',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        lineHeight: '14px'
      },
      div: {
        position: 'static',
        top: '17px',
        bottom: 0,
        overflowY: 'overlay',
        transform: 'translateZ(0)',
        left: 0,
        right: 0,
        overflowX: 'hidden'
      },
      table: {
        positon: 'static',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        borderTop: '0 none transparent',
        margin: 0,
        backgroundImage: theme.TABLE_DATA_BACKGROUND_IMAGE,
        backgroundSize: theme.TABLE_DATA_BACKGROUND_SIZE,
        tableLayout: 'fixed',
        borderSpacing: 0,
        borderCollapse: 'separate',
        width: '100%',
        fontSize: theme.BASE_FONT_SIZE,
        lineHeight: '120%'
      }
    },
    TableInspectorTH: {
      base: {
        position: 'relative',
        height: 'auto',
        textAlign: 'left',
        backgroundColor: theme.TABLE_TH_BACKGROUND_COLOR,
        borderBottom: "1px solid ".concat(theme.TABLE_BORDER_COLOR),
        fontWeight: 'normal',
        verticalAlign: 'middle',
        padding: '0 4px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        lineHeight: '14px',
        ':hover': {
          backgroundColor: theme.TABLE_TH_HOVER_COLOR
        }
      },
      div: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontSize: theme.BASE_FONT_SIZE,
        lineHeight: '120%'
      }
    },
    TableInspectorLeftBorder: {
      none: {
        borderLeft: 'none'
      },
      solid: {
        borderLeft: "1px solid ".concat(theme.TABLE_BORDER_COLOR)
      }
    },
    TableInspectorSortIcon: _objectSpread$7({
      display: 'block',
      marginRight: 3,
      width: 8,
      height: 7,
      marginTop: -7,
      color: theme.TABLE_SORT_ICON_COLOR,
      fontSize: 12
    }, unselectable)
  };
});

var DEFAULT_THEME_NAME = 'chromeLight';
var ThemeContext = createContext(base(themes[DEFAULT_THEME_NAME]));
var useStyles = function useStyles(baseStylesKey) {
  var themeStyles = useContext(ThemeContext);
  return themeStyles[baseStylesKey];
};
var themeAcceptor = function themeAcceptor(WrappedComponent) {
  var ThemeAcceptor = function ThemeAcceptor(_ref) {
    var _ref$theme = _ref.theme,
        theme = _ref$theme === void 0 ? DEFAULT_THEME_NAME : _ref$theme,
        restProps = _objectWithoutProperties(_ref, ["theme"]);
    var themeStyles = useMemo(function () {
      switch (Object.prototype.toString.call(theme)) {
        case '[object String]':
          return base(themes[theme]);
        case '[object Object]':
          return base(theme);
        default:
          return base(themes[DEFAULT_THEME_NAME]);
      }
    }, [theme]);
    return React__default.createElement(ThemeContext.Provider, {
      value: themeStyles
    }, React__default.createElement(WrappedComponent, restProps));
  };
  ThemeAcceptor.propTypes = {
    theme: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };
  return ThemeAcceptor;
};

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Arrow = function Arrow(_ref) {
  var expanded = _ref.expanded,
      styles = _ref.styles;
  return React__default.createElement("span", {
    style: _objectSpread$6(_objectSpread$6({}, styles.base), expanded ? styles.expanded : styles.collapsed)
  }, "\u25B6");
};
var TreeNode = memo(function (props) {
  props = _objectSpread$6({
    expanded: true,
    nodeRenderer: function nodeRenderer(_ref2) {
      var name = _ref2.name;
      return React__default.createElement("span", null, name);
    },
    onClick: function onClick() {},
    shouldShowArrow: false,
    shouldShowPlaceholder: true
  }, props);
  var _props = props,
      expanded = _props.expanded,
      onClick = _props.onClick,
      children = _props.children,
      nodeRenderer = _props.nodeRenderer,
      title = _props.title,
      shouldShowArrow = _props.shouldShowArrow,
      shouldShowPlaceholder = _props.shouldShowPlaceholder;
  var styles = useStyles('TreeNode');
  var NodeRenderer = nodeRenderer;
  return React__default.createElement("li", {
    "aria-expanded": expanded,
    role: "treeitem",
    style: styles.treeNodeBase,
    title: title
  }, React__default.createElement("div", {
    style: styles.treeNodePreviewContainer,
    onClick: onClick
  }, shouldShowArrow || Children.count(children) > 0 ? React__default.createElement(Arrow, {
    expanded: expanded,
    styles: styles.treeNodeArrow
  }) : shouldShowPlaceholder && React__default.createElement("span", {
    style: styles.treeNodePlaceholder
  }, "\xA0"), React__default.createElement(NodeRenderer, props)), React__default.createElement("ol", {
    role: "group",
    style: styles.treeNodeChildNodesContainer
  }, expanded ? children : undefined));
});
TreeNode.propTypes = {
  name: PropTypes.string,
  data: PropTypes.any,
  expanded: PropTypes.bool,
  shouldShowArrow: PropTypes.bool,
  shouldShowPlaceholder: PropTypes.bool,
  nodeRenderer: PropTypes.func,
  onClick: PropTypes.func
};

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _createForOfIteratorHelper$1(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var DEFAULT_ROOT_PATH = '$';
var WILDCARD = '*';
function hasChildNodes(data, dataIterator) {
  return !dataIterator(data).next().done;
}
var wildcardPathsFromLevel = function wildcardPathsFromLevel(level) {
  return Array.from({
    length: level
  }, function (_, i) {
    return [DEFAULT_ROOT_PATH].concat(Array.from({
      length: i
    }, function () {
      return '*';
    })).join('.');
  });
};
var getExpandedPaths = function getExpandedPaths(data, dataIterator, expandPaths, expandLevel, prevExpandedPaths) {
  var wildcardPaths = [].concat(wildcardPathsFromLevel(expandLevel)).concat(expandPaths).filter(function (path) {
    return typeof path === 'string';
  });
  var expandedPaths = [];
  wildcardPaths.forEach(function (wildcardPath) {
    var keyPaths = wildcardPath.split('.');
    var populatePaths = function populatePaths(curData, curPath, depth) {
      if (depth === keyPaths.length) {
        expandedPaths.push(curPath);
        return;
      }
      var key = keyPaths[depth];
      if (depth === 0) {
        if (hasChildNodes(curData, dataIterator) && (key === DEFAULT_ROOT_PATH || key === WILDCARD)) {
          populatePaths(curData, DEFAULT_ROOT_PATH, depth + 1);
        }
      } else {
        if (key === WILDCARD) {
          var _iterator = _createForOfIteratorHelper$1(dataIterator(curData)),
              _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _step$value = _step.value,
                  name = _step$value.name,
                  _data = _step$value.data;
              if (hasChildNodes(_data, dataIterator)) {
                populatePaths(_data, "".concat(curPath, ".").concat(name), depth + 1);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {
          var value = curData[key];
          if (hasChildNodes(value, dataIterator)) {
            populatePaths(value, "".concat(curPath, ".").concat(key), depth + 1);
          }
        }
      }
    };
    populatePaths(data, '', 0);
  });
  return expandedPaths.reduce(function (obj, path) {
    obj[path] = true;
    return obj;
  }, _objectSpread$5({}, prevExpandedPaths));
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ConnectedTreeNode = memo(function (props) {
  var data = props.data,
      dataIterator = props.dataIterator,
      path = props.path,
      depth = props.depth,
      nodeRenderer = props.nodeRenderer;
  var _useContext = useContext(ExpandedPathsContext),
      _useContext2 = _slicedToArray(_useContext, 2),
      expandedPaths = _useContext2[0],
      setExpandedPaths = _useContext2[1];
  var nodeHasChildNodes = hasChildNodes(data, dataIterator);
  var expanded = !!expandedPaths[path];
  var handleClick = useCallback(function () {
    return nodeHasChildNodes && setExpandedPaths(function (prevExpandedPaths) {
      return _objectSpread$4(_objectSpread$4({}, prevExpandedPaths), {}, _defineProperty({}, path, !expanded));
    });
  }, [nodeHasChildNodes, setExpandedPaths, path, expanded]);
  return React__default.createElement(TreeNode, _extends({
    expanded: expanded,
    onClick: handleClick
    ,
    shouldShowArrow: nodeHasChildNodes
    ,
    shouldShowPlaceholder: depth > 0
    ,
    nodeRenderer: nodeRenderer
  }, props),
  expanded ? _toConsumableArray(dataIterator(data)).map(function (_ref) {
    var name = _ref.name,
        data = _ref.data,
        renderNodeProps = _objectWithoutProperties(_ref, ["name", "data"]);
    return React__default.createElement(ConnectedTreeNode, _extends({
      name: name,
      data: data,
      depth: depth + 1,
      path: "".concat(path, ".").concat(name),
      key: name,
      dataIterator: dataIterator,
      nodeRenderer: nodeRenderer
    }, renderNodeProps));
  }) : null);
});
ConnectedTreeNode.propTypes = {
  name: PropTypes.string,
  data: PropTypes.any,
  dataIterator: PropTypes.func,
  depth: PropTypes.number,
  expanded: PropTypes.bool,
  nodeRenderer: PropTypes.func
};
var TreeView = memo(function (_ref2) {
  var name = _ref2.name,
      data = _ref2.data,
      dataIterator = _ref2.dataIterator,
      nodeRenderer = _ref2.nodeRenderer,
      expandPaths = _ref2.expandPaths,
      expandLevel = _ref2.expandLevel;
  var styles = useStyles('TreeView');
  var stateAndSetter = useState({});
  var _stateAndSetter = _slicedToArray(stateAndSetter, 2),
      setExpandedPaths = _stateAndSetter[1];
  useLayoutEffect(function () {
    return setExpandedPaths(function (prevExpandedPaths) {
      return getExpandedPaths(data, dataIterator, expandPaths, expandLevel, prevExpandedPaths);
    });
  }, [data, dataIterator, expandPaths, expandLevel]);
  return React__default.createElement(ExpandedPathsContext.Provider, {
    value: stateAndSetter
  }, React__default.createElement("ol", {
    role: "tree",
    style: styles.treeViewOutline
  }, React__default.createElement(ConnectedTreeNode, {
    name: name,
    data: data,
    dataIterator: dataIterator,
    depth: 0,
    path: DEFAULT_ROOT_PATH,
    nodeRenderer: nodeRenderer
  })));
});
TreeView.propTypes = {
  name: PropTypes.string,
  data: PropTypes.any,
  dataIterator: PropTypes.func,
  nodeRenderer: PropTypes.func,
  expandPaths: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  expandLevel: PropTypes.number
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ObjectName = function ObjectName(_ref) {
  var name = _ref.name,
      _ref$dimmed = _ref.dimmed,
      dimmed = _ref$dimmed === void 0 ? false : _ref$dimmed,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles;
  var themeStyles = useStyles('ObjectName');
  var appliedStyles = _objectSpread$3(_objectSpread$3(_objectSpread$3({}, themeStyles.base), dimmed ? themeStyles['dimmed'] : {}), styles);
  return React__default.createElement("span", {
    style: appliedStyles
  }, name);
};
ObjectName.propTypes = {
  name: PropTypes.string,
  dimmed: PropTypes.bool
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ObjectValue = function ObjectValue(_ref) {
  var object = _ref.object,
      styles = _ref.styles;
  var themeStyles = useStyles('ObjectValue');
  var mkStyle = function mkStyle(key) {
    return _objectSpread$2(_objectSpread$2({}, themeStyles[key]), styles);
  };
  switch (_typeof$1(object)) {
    case 'bigint':
      return React__default.createElement("span", {
        style: mkStyle('objectValueNumber')
      }, String(object), "n");
    case 'number':
      return React__default.createElement("span", {
        style: mkStyle('objectValueNumber')
      }, String(object));
    case 'string':
      return React__default.createElement("span", {
        style: mkStyle('objectValueString')
      }, "\"", object, "\"");
    case 'boolean':
      return React__default.createElement("span", {
        style: mkStyle('objectValueBoolean')
      }, String(object));
    case 'undefined':
      return React__default.createElement("span", {
        style: mkStyle('objectValueUndefined')
      }, "undefined");
    case 'object':
      if (object === null) {
        return React__default.createElement("span", {
          style: mkStyle('objectValueNull')
        }, "null");
      }
      if (object instanceof Date) {
        return React__default.createElement("span", null, object.toString());
      }
      if (object instanceof RegExp) {
        return React__default.createElement("span", {
          style: mkStyle('objectValueRegExp')
        }, object.toString());
      }
      if (Array.isArray(object)) {
        return React__default.createElement("span", null, "Array(".concat(object.length, ")"));
      }
      if (!object.constructor) {
        return React__default.createElement("span", null, "Object");
      }
      if (typeof object.constructor.isBuffer === 'function' && object.constructor.isBuffer(object)) {
        return React__default.createElement("span", null, "Buffer[".concat(object.length, "]"));
      }
      return React__default.createElement("span", null, object.constructor.name);
    case 'function':
      return React__default.createElement("span", null, React__default.createElement("span", {
        style: mkStyle('objectValueFunctionPrefix')
      }, "\u0192\xA0"), React__default.createElement("span", {
        style: mkStyle('objectValueFunctionName')
      }, object.name, "()"));
    case 'symbol':
      return React__default.createElement("span", {
        style: mkStyle('objectValueSymbol')
      }, object.toString());
    default:
      return React__default.createElement("span", null);
  }
};
ObjectValue.propTypes = {
  object: PropTypes.any
};

var hasOwnProperty = Object.prototype.hasOwnProperty;
var propertyIsEnumerable = Object.prototype.propertyIsEnumerable;

function getPropertyValue(object, propertyName) {
  var propertyDescriptor = Object.getOwnPropertyDescriptor(object, propertyName);
  if (propertyDescriptor.get) {
    try {
      return propertyDescriptor.get();
    } catch (_unused) {
      return propertyDescriptor.get;
    }
  }
  return object[propertyName];
}

function intersperse(arr, sep) {
  if (arr.length === 0) {
    return [];
  }
  return arr.slice(1).reduce(function (xs, x) {
    return xs.concat([sep, x]);
  }, [arr[0]]);
}
var ObjectPreview = function ObjectPreview(_ref) {
  var data = _ref.data;
  var styles = useStyles('ObjectPreview');
  var object = data;
  if (_typeof$1(object) !== 'object' || object === null || object instanceof Date || object instanceof RegExp) {
    return React__default.createElement(ObjectValue, {
      object: object
    });
  }
  if (Array.isArray(object)) {
    var maxProperties = styles.arrayMaxProperties;
    var previewArray = object.slice(0, maxProperties).map(function (element, index) {
      return React__default.createElement(ObjectValue, {
        key: index,
        object: element
      });
    });
    if (object.length > maxProperties) {
      previewArray.push( React__default.createElement("span", {
        key: "ellipsis"
      }, "\u2026"));
    }
    var arrayLength = object.length;
    return React__default.createElement(React__default.Fragment, null, React__default.createElement("span", {
      style: styles.objectDescription
    }, arrayLength === 0 ? "" : "(".concat(arrayLength, ")\xA0")), React__default.createElement("span", {
      style: styles.preview
    }, "[", intersperse(previewArray, ', '), "]"));
  } else {
    var _maxProperties = styles.objectMaxProperties;
    var propertyNodes = [];
    for (var propertyName in object) {
      if (hasOwnProperty.call(object, propertyName)) {
        var ellipsis = void 0;
        if (propertyNodes.length === _maxProperties - 1 && Object.keys(object).length > _maxProperties) {
          ellipsis = React__default.createElement("span", {
            key: 'ellipsis'
          }, "\u2026");
        }
        var propertyValue = getPropertyValue(object, propertyName);
        propertyNodes.push( React__default.createElement("span", {
          key: propertyName
        }, React__default.createElement(ObjectName, {
          name: propertyName || "\"\""
        }), ":\xA0", React__default.createElement(ObjectValue, {
          object: propertyValue
        }), ellipsis));
        if (ellipsis) break;
      }
    }
    var objectConstructorName = object.constructor ? object.constructor.name : 'Object';
    return React__default.createElement(React__default.Fragment, null, React__default.createElement("span", {
      style: styles.objectDescription
    }, objectConstructorName === 'Object' ? '' : "".concat(objectConstructorName, " ")), React__default.createElement("span", {
      style: styles.preview
    }, '{', intersperse(propertyNodes, ', '), '}'));
  }
};

var ObjectRootLabel = function ObjectRootLabel(_ref) {
  var name = _ref.name,
      data = _ref.data;
  if (typeof name === 'string') {
    return React__default.createElement("span", null, React__default.createElement(ObjectName, {
      name: name
    }), React__default.createElement("span", null, ": "), React__default.createElement(ObjectPreview, {
      data: data
    }));
  } else {
    return React__default.createElement(ObjectPreview, {
      data: data
    });
  }
};

var ObjectLabel = function ObjectLabel(_ref) {
  var name = _ref.name,
      data = _ref.data,
      _ref$isNonenumerable = _ref.isNonenumerable,
      isNonenumerable = _ref$isNonenumerable === void 0 ? false : _ref$isNonenumerable;
  var object = data;
  return React__default.createElement("span", null, typeof name === 'string' ? React__default.createElement(ObjectName, {
    name: name,
    dimmed: isNonenumerable
  }) : React__default.createElement(ObjectPreview, {
    data: name
  }), React__default.createElement("span", null, ": "), React__default.createElement(ObjectValue, {
    object: object
  }));
};
ObjectLabel.propTypes = {
  isNonenumerable: PropTypes.bool
};

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var createIterator = function createIterator(showNonenumerable, sortObjectKeys) {
  var objectIterator = regenerator.mark(function objectIterator(data) {
    var shouldIterate, dataIsArray, i, _iterator, _step, entry, _entry, k, v, keys, _iterator2, _step2, propertyName, propertyValue, _propertyValue;
    return regenerator.wrap(function objectIterator$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            shouldIterate = _typeof$1(data) === 'object' && data !== null || typeof data === 'function';
            if (shouldIterate) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            dataIsArray = Array.isArray(data);
            if (!(!dataIsArray && data[Symbol.iterator])) {
              _context.next = 32;
              break;
            }
            i = 0;
            _iterator = _createForOfIteratorHelper(data);
            _context.prev = 7;
            _iterator.s();
          case 9:
            if ((_step = _iterator.n()).done) {
              _context.next = 22;
              break;
            }
            entry = _step.value;
            if (!(Array.isArray(entry) && entry.length === 2)) {
              _context.next = 17;
              break;
            }
            _entry = _slicedToArray(entry, 2), k = _entry[0], v = _entry[1];
            _context.next = 15;
            return {
              name: k,
              data: v
            };
          case 15:
            _context.next = 19;
            break;
          case 17:
            _context.next = 19;
            return {
              name: i.toString(),
              data: entry
            };
          case 19:
            i++;
          case 20:
            _context.next = 9;
            break;
          case 22:
            _context.next = 27;
            break;
          case 24:
            _context.prev = 24;
            _context.t0 = _context["catch"](7);
            _iterator.e(_context.t0);
          case 27:
            _context.prev = 27;
            _iterator.f();
            return _context.finish(27);
          case 30:
            _context.next = 64;
            break;
          case 32:
            keys = Object.getOwnPropertyNames(data);
            if (sortObjectKeys === true && !dataIsArray) {
              keys.sort();
            } else if (typeof sortObjectKeys === 'function') {
              keys.sort(sortObjectKeys);
            }
            _iterator2 = _createForOfIteratorHelper(keys);
            _context.prev = 35;
            _iterator2.s();
          case 37:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 53;
              break;
            }
            propertyName = _step2.value;
            if (!propertyIsEnumerable.call(data, propertyName)) {
              _context.next = 45;
              break;
            }
            propertyValue = getPropertyValue(data, propertyName);
            _context.next = 43;
            return {
              name: propertyName || "\"\"",
              data: propertyValue
            };
          case 43:
            _context.next = 51;
            break;
          case 45:
            if (!showNonenumerable) {
              _context.next = 51;
              break;
            }
            _propertyValue = void 0;
            try {
              _propertyValue = getPropertyValue(data, propertyName);
            } catch (e) {
            }
            if (!(_propertyValue !== undefined)) {
              _context.next = 51;
              break;
            }
            _context.next = 51;
            return {
              name: propertyName,
              data: _propertyValue,
              isNonenumerable: true
            };
          case 51:
            _context.next = 37;
            break;
          case 53:
            _context.next = 58;
            break;
          case 55:
            _context.prev = 55;
            _context.t1 = _context["catch"](35);
            _iterator2.e(_context.t1);
          case 58:
            _context.prev = 58;
            _iterator2.f();
            return _context.finish(58);
          case 61:
            if (!(showNonenumerable && data !== Object.prototype
            )) {
              _context.next = 64;
              break;
            }
            _context.next = 64;
            return {
              name: '__proto__',
              data: Object.getPrototypeOf(data),
              isNonenumerable: true
            };
          case 64:
          case "end":
            return _context.stop();
        }
      }
    }, objectIterator, null, [[7, 24, 27, 30], [35, 55, 58, 61]]);
  });
  return objectIterator;
};
var defaultNodeRenderer = function defaultNodeRenderer(_ref) {
  var depth = _ref.depth,
      name = _ref.name,
      data = _ref.data,
      isNonenumerable = _ref.isNonenumerable;
  return depth === 0 ? React__default.createElement(ObjectRootLabel, {
    name: name,
    data: data
  }) : React__default.createElement(ObjectLabel, {
    name: name,
    data: data,
    isNonenumerable: isNonenumerable
  });
};
var ObjectInspector = function ObjectInspector(_ref2) {
  var _ref2$showNonenumerab = _ref2.showNonenumerable,
      showNonenumerable = _ref2$showNonenumerab === void 0 ? false : _ref2$showNonenumerab,
      sortObjectKeys = _ref2.sortObjectKeys,
      nodeRenderer = _ref2.nodeRenderer,
      treeViewProps = _objectWithoutProperties(_ref2, ["showNonenumerable", "sortObjectKeys", "nodeRenderer"]);
  var dataIterator = createIterator(showNonenumerable, sortObjectKeys);
  var renderer = nodeRenderer ? nodeRenderer : defaultNodeRenderer;
  return React__default.createElement(TreeView, _extends({
    nodeRenderer: renderer,
    dataIterator: dataIterator
  }, treeViewProps));
};
ObjectInspector.propTypes = {
  expandLevel: PropTypes.number,
  expandPaths: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  name: PropTypes.string,
  data: PropTypes.any,
  showNonenumerable: PropTypes.bool,
  sortObjectKeys: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  nodeRenderer: PropTypes.func
};
var ObjectInspector$1 = themeAcceptor(ObjectInspector);

if (!Array.prototype.includes) {
  Array.prototype.includes = function (searchElement
  ) {
    var O = Object(this);
    var len = parseInt(O.length) || 0;
    if (len === 0) {
      return false;
    }
    var n = parseInt(arguments[1]) || 0;
    var k;
    if (n >= 0) {
      k = n;
    } else {
      k = len + n;
      if (k < 0) {
        k = 0;
      }
    }
    var currentElement;
    while (k < len) {
      currentElement = O[k];
      if (searchElement === currentElement || searchElement !== searchElement && currentElement !== currentElement) {
        return true;
      }
      k++;
    }
    return false;
  };
}
function getHeaders(data) {
  if (_typeof$1(data) === 'object') {
    var rowHeaders;
    if (Array.isArray(data)) {
      var nRows = data.length;
      rowHeaders = _toConsumableArray(Array(nRows).keys());
    } else if (data !== null) {
      rowHeaders = Object.keys(data);
    }
    var colHeaders = rowHeaders.reduce(function (colHeaders, rowHeader) {
      var row = data[rowHeader];
      if (_typeof$1(row) === 'object' && row !== null) {
        var cols = Object.keys(row);
        cols.reduce(function (xs, x) {
          if (!xs.includes(x)) {
            xs.push(x);
          }
          return xs;
        }, colHeaders);
      }
      return colHeaders;
    }, []);
    return {
      rowHeaders: rowHeaders,
      colHeaders: colHeaders
    };
  }
  return undefined;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var DataContainer = function DataContainer(_ref) {
  var rows = _ref.rows,
      columns = _ref.columns,
      rowsData = _ref.rowsData;
  var styles = useStyles('TableInspectorDataContainer');
  var borderStyles = useStyles('TableInspectorLeftBorder');
  return React__default.createElement("div", {
    style: styles.div
  }, React__default.createElement("table", {
    style: styles.table
  }, React__default.createElement("colgroup", null), React__default.createElement("tbody", null, rows.map(function (row, i) {
    return React__default.createElement("tr", {
      key: row,
      style: styles.tr
    }, React__default.createElement("td", {
      style: _objectSpread$1(_objectSpread$1({}, styles.td), borderStyles.none)
    }, row), columns.map(function (column) {
      var rowData = rowsData[i];
      if (_typeof$1(rowData) === 'object' && rowData !== null && hasOwnProperty.call(rowData, column)) {
        return React__default.createElement("td", {
          key: column,
          style: _objectSpread$1(_objectSpread$1({}, styles.td), borderStyles.solid)
        }, React__default.createElement(ObjectValue, {
          object: rowData[column]
        }));
      } else {
        return React__default.createElement("td", {
          key: column,
          style: _objectSpread$1(_objectSpread$1({}, styles.td), borderStyles.solid)
        });
      }
    }));
  }))));
};

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$8(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var SortIconContainer = function SortIconContainer(props) {
  return React__default.createElement("div", {
    style: {
      position: 'absolute',
      top: 1,
      right: 0,
      bottom: 1,
      display: 'flex',
      alignItems: 'center'
    }
  }, props.children);
};
var SortIcon = function SortIcon(_ref) {
  var sortAscending = _ref.sortAscending;
  var styles = useStyles('TableInspectorSortIcon');
  var glyph = sortAscending ? '▲' : '▼';
  return React__default.createElement("div", {
    style: styles
  }, glyph);
};
var TH = function TH(_ref2) {
  var _ref2$sortAscending = _ref2.sortAscending,
      sortAscending = _ref2$sortAscending === void 0 ? false : _ref2$sortAscending,
      _ref2$sorted = _ref2.sorted,
      sorted = _ref2$sorted === void 0 ? false : _ref2$sorted,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? undefined : _ref2$onClick,
      _ref2$borderStyle = _ref2.borderStyle,
      borderStyle = _ref2$borderStyle === void 0 ? {} : _ref2$borderStyle,
      children = _ref2.children,
      thProps = _objectWithoutProperties(_ref2, ["sortAscending", "sorted", "onClick", "borderStyle", "children"]);
  var styles = useStyles('TableInspectorTH');
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hovered = _useState2[0],
      setHovered = _useState2[1];
  var handleMouseEnter = useCallback(function () {
    return setHovered(true);
  }, []);
  var handleMouseLeave = useCallback(function () {
    return setHovered(false);
  }, []);
  return React__default.createElement("th", _extends({}, thProps, {
    style: _objectSpread$8(_objectSpread$8(_objectSpread$8({}, styles.base), borderStyle), hovered ? styles.base[':hover'] : {}),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: onClick
  }), React__default.createElement("div", {
    style: styles.div
  }, children), sorted && React__default.createElement(SortIconContainer, null, React__default.createElement(SortIcon, {
    sortAscending: sortAscending
  })));
};

var HeaderContainer = function HeaderContainer(_ref) {
  var _ref$indexColumnText = _ref.indexColumnText,
      indexColumnText = _ref$indexColumnText === void 0 ? '(index)' : _ref$indexColumnText,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      sorted = _ref.sorted,
      sortIndexColumn = _ref.sortIndexColumn,
      sortColumn = _ref.sortColumn,
      sortAscending = _ref.sortAscending,
      onTHClick = _ref.onTHClick,
      onIndexTHClick = _ref.onIndexTHClick;
  var styles = useStyles('TableInspectorHeaderContainer');
  var borderStyles = useStyles('TableInspectorLeftBorder');
  return React__default.createElement("div", {
    style: styles.base
  }, React__default.createElement("table", {
    style: styles.table
  }, React__default.createElement("tbody", null, React__default.createElement("tr", null, React__default.createElement(TH, {
    borderStyle: borderStyles.none,
    sorted: sorted && sortIndexColumn,
    sortAscending: sortAscending,
    onClick: onIndexTHClick
  }, indexColumnText), columns.map(function (column) {
    return React__default.createElement(TH, {
      borderStyle: borderStyles.solid,
      key: column,
      sorted: sorted && sortColumn === column,
      sortAscending: sortAscending,
      onClick: onTHClick.bind(null, column)
    }, column);
  })))));
};

var TableInspector = function TableInspector(_ref) {
  var data = _ref.data,
      columns = _ref.columns;
  var styles = useStyles('TableInspector');
  var _useState = useState({
    sorted: false,
    sortIndexColumn: false,
    sortColumn: undefined,
    sortAscending: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      sorted = _useState2$.sorted,
      sortIndexColumn = _useState2$.sortIndexColumn,
      sortColumn = _useState2$.sortColumn,
      sortAscending = _useState2$.sortAscending,
      setState = _useState2[1];
  var handleIndexTHClick = useCallback(function () {
    setState(function (_ref2) {
      var sortIndexColumn = _ref2.sortIndexColumn,
          sortAscending = _ref2.sortAscending;
      return {
        sorted: true,
        sortIndexColumn: true,
        sortColumn: undefined,
        sortAscending: sortIndexColumn ? !sortAscending : true
      };
    });
  }, []);
  var handleTHClick = useCallback(function (col) {
    setState(function (_ref3) {
      var sortColumn = _ref3.sortColumn,
          sortAscending = _ref3.sortAscending;
      return {
        sorted: true,
        sortIndexColumn: false,
        sortColumn: col,
        sortAscending: col === sortColumn ? !sortAscending : true
      };
    });
  }, []);
  if (_typeof$1(data) !== 'object' || data === null) {
    return React__default.createElement("div", null);
  }
  var _getHeaders = getHeaders(data),
      rowHeaders = _getHeaders.rowHeaders,
      colHeaders = _getHeaders.colHeaders;
  if (columns !== undefined) {
    colHeaders = columns;
  }
  var rowsData = rowHeaders.map(function (rowHeader) {
    return data[rowHeader];
  });
  var columnDataWithRowIndexes;
  if (sortColumn !== undefined) {
    columnDataWithRowIndexes = rowsData.map(function (rowData, index) {
      if (_typeof$1(rowData) === 'object' && rowData !== null
      ) {
          var columnData = rowData[sortColumn];
          return [columnData, index];
        }
      return [undefined, index];
    });
  } else {
    if (sortIndexColumn) {
      columnDataWithRowIndexes = rowHeaders.map(function (rowData, index) {
        var columnData = rowHeaders[index];
        return [columnData, index];
      });
    }
  }
  if (columnDataWithRowIndexes !== undefined) {
    var comparator = function comparator(mapper, ascending) {
      return function (a, b) {
        var v1 = mapper(a);
        var v2 = mapper(b);
        var type1 = _typeof$1(v1);
        var type2 = _typeof$1(v2);
        var lt = function lt(v1, v2) {
          if (v1 < v2) {
            return -1;
          } else if (v1 > v2) {
            return 1;
          } else {
            return 0;
          }
        };
        var result;
        if (type1 === type2) {
          result = lt(v1, v2);
        } else {
          var order = {
            string: 0,
            number: 1,
            object: 2,
            symbol: 3,
            boolean: 4,
            undefined: 5,
            function: 6
          };
          result = lt(order[type1], order[type2]);
        }
        if (!ascending) result = -result;
        return result;
      };
    };
    var sortedRowIndexes = columnDataWithRowIndexes.sort(comparator(function (item) {
      return item[0];
    }, sortAscending)).map(function (item) {
      return item[1];
    });
    rowHeaders = sortedRowIndexes.map(function (i) {
      return rowHeaders[i];
    });
    rowsData = sortedRowIndexes.map(function (i) {
      return rowsData[i];
    });
  }
  return React__default.createElement("div", {
    style: styles.base
  }, React__default.createElement(HeaderContainer, {
    columns: colHeaders
    ,
    sorted: sorted,
    sortIndexColumn: sortIndexColumn,
    sortColumn: sortColumn,
    sortAscending: sortAscending,
    onTHClick: handleTHClick,
    onIndexTHClick: handleIndexTHClick
  }), React__default.createElement(DataContainer, {
    rows: rowHeaders,
    columns: colHeaders,
    rowsData: rowsData
  }));
};
TableInspector.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  columns: PropTypes.array
};
var TableInspector$1 = themeAcceptor(TableInspector);

var TEXT_NODE_MAX_INLINE_CHARS = 80;
var shouldInline = function shouldInline(data) {
  return data.childNodes.length === 0 || data.childNodes.length === 1 && data.childNodes[0].nodeType === Node.TEXT_NODE && data.textContent.length < TEXT_NODE_MAX_INLINE_CHARS;
};

var OpenTag = function OpenTag(_ref) {
  var tagName = _ref.tagName,
      attributes = _ref.attributes,
      styles = _ref.styles;
  return React__default.createElement("span", {
    style: styles.base
  }, '<', React__default.createElement("span", {
    style: styles.tagName
  }, tagName), function () {
    if (attributes) {
      var attributeNodes = [];
      for (var i = 0; i < attributes.length; i++) {
        var attribute = attributes[i];
        attributeNodes.push( React__default.createElement("span", {
          key: i
        }, ' ', React__default.createElement("span", {
          style: styles.htmlAttributeName
        }, attribute.name), '="', React__default.createElement("span", {
          style: styles.htmlAttributeValue
        }, attribute.value), '"'));
      }
      return attributeNodes;
    }
  }(), '>');
};
var CloseTag = function CloseTag(_ref2) {
  var tagName = _ref2.tagName,
      _ref2$isChildNode = _ref2.isChildNode,
      isChildNode = _ref2$isChildNode === void 0 ? false : _ref2$isChildNode,
      styles = _ref2.styles;
  return React__default.createElement("span", {
    style: _extends({}, styles.base, isChildNode && styles.offsetLeft)
  }, '</', React__default.createElement("span", {
    style: styles.tagName
  }, tagName), '>');
};
var nameByNodeType = {
  1: 'ELEMENT_NODE',
  3: 'TEXT_NODE',
  7: 'PROCESSING_INSTRUCTION_NODE',
  8: 'COMMENT_NODE',
  9: 'DOCUMENT_NODE',
  10: 'DOCUMENT_TYPE_NODE',
  11: 'DOCUMENT_FRAGMENT_NODE'
};
var DOMNodePreview = function DOMNodePreview(_ref3) {
  var isCloseTag = _ref3.isCloseTag,
      data = _ref3.data,
      expanded = _ref3.expanded;
  var styles = useStyles('DOMNodePreview');
  if (isCloseTag) {
    return React__default.createElement(CloseTag, {
      styles: styles.htmlCloseTag,
      isChildNode: true,
      tagName: data.tagName
    });
  }
  switch (data.nodeType) {
    case Node.ELEMENT_NODE:
      return React__default.createElement("span", null, React__default.createElement(OpenTag, {
        tagName: data.tagName,
        attributes: data.attributes,
        styles: styles.htmlOpenTag
      }), shouldInline(data) ? data.textContent : !expanded && '…', !expanded && React__default.createElement(CloseTag, {
        tagName: data.tagName,
        styles: styles.htmlCloseTag
      }));
    case Node.TEXT_NODE:
      return React__default.createElement("span", null, data.textContent);
    case Node.CDATA_SECTION_NODE:
      return React__default.createElement("span", null, '<![CDATA[' + data.textContent + ']]>');
    case Node.COMMENT_NODE:
      return React__default.createElement("span", {
        style: styles.htmlComment
      }, '<!--', data.textContent, '-->');
    case Node.PROCESSING_INSTRUCTION_NODE:
      return React__default.createElement("span", null, data.nodeName);
    case Node.DOCUMENT_TYPE_NODE:
      return React__default.createElement("span", {
        style: styles.htmlDoctype
      }, '<!DOCTYPE ', data.name, data.publicId ? " PUBLIC \"".concat(data.publicId, "\"") : '', !data.publicId && data.systemId ? ' SYSTEM' : '', data.systemId ? " \"".concat(data.systemId, "\"") : '', '>');
    case Node.DOCUMENT_NODE:
      return React__default.createElement("span", null, data.nodeName);
    case Node.DOCUMENT_FRAGMENT_NODE:
      return React__default.createElement("span", null, data.nodeName);
    default:
      return React__default.createElement("span", null, nameByNodeType[data.nodeType]);
  }
};
DOMNodePreview.propTypes = {
  isCloseTag: PropTypes.bool,
  name: PropTypes.string,
  data: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired
};

var domIterator = regenerator.mark(function domIterator(data) {
  var textInlined, i, node;
  return regenerator.wrap(function domIterator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(data && data.childNodes)) {
            _context.next = 17;
            break;
          }
          textInlined = shouldInline(data);
          if (!textInlined) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return");
        case 4:
          i = 0;
        case 5:
          if (!(i < data.childNodes.length)) {
            _context.next = 14;
            break;
          }
          node = data.childNodes[i];
          if (!(node.nodeType === Node.TEXT_NODE && node.textContent.trim().length === 0)) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("continue", 11);
        case 9:
          _context.next = 11;
          return {
            name: "".concat(node.tagName, "[").concat(i, "]"),
            data: node
          };
        case 11:
          i++;
          _context.next = 5;
          break;
        case 14:
          if (!data.tagName) {
            _context.next = 17;
            break;
          }
          _context.next = 17;
          return {
            name: 'CLOSE_TAG',
            data: {
              tagName: data.tagName
            },
            isCloseTag: true
          };
        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, domIterator);
});
var DOMInspector = function DOMInspector(props) {
  return React__default.createElement(TreeView, _extends({
    nodeRenderer: DOMNodePreview,
    dataIterator: domIterator
  }, props));
};
DOMInspector.propTypes = {
  data: PropTypes.object.isRequired
};
var DOMInspector$1 = themeAcceptor(DOMInspector);

var Inspector = function Inspector(_ref) {
  var _ref$table = _ref.table,
      table = _ref$table === void 0 ? false : _ref$table,
      data = _ref.data,
      rest = _objectWithoutProperties(_ref, ["table", "data"]);
  if (table) {
    return React__default.createElement(TableInspector$1, _extends({
      data: data
    }, rest));
  }
  if (isDom(data)) return React__default.createElement(DOMInspector$1, _extends({
    data: data
  }, rest));
  return React__default.createElement(ObjectInspector$1, _extends({
    data: data
  }, rest));
};
Inspector.propTypes = {
  data: PropTypes.any,
  name: PropTypes.string,
  table: PropTypes.bool
};

var reactInspector$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': Inspector,
  DOMInspector: DOMInspector$1,
  Inspector: Inspector,
  ObjectInspector: ObjectInspector$1,
  ObjectLabel: ObjectLabel,
  ObjectName: ObjectName,
  ObjectPreview: ObjectPreview,
  ObjectRootLabel: ObjectRootLabel,
  ObjectValue: ObjectValue,
  TableInspector: TableInspector$1,
  chromeDark: theme$1,
  chromeLight: theme$2
});

var require$$2 = /*@__PURE__*/getAugmentedNamespace(reactInspector$1);

(function (exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var react_inspector_1 = require$$2;
var styles = function (props) {
    var isLight = (props.variant || 'light') === 'light';
    var chrome = isLight ? react_inspector_1.chromeLight : react_inspector_1.chromeDark;
    return __assign(__assign({}, chrome), { 
        /**
         * General
         */
        PADDING: '3px 22px 2px 0', 
        /**
         * Default log styles
         */
        LOG_COLOR: chrome.BASE_COLOR, LOG_BACKGROUND: 'transparent', LOG_BORDER: isLight ? 'rgb(236,236,236)' : 'rgb(44,44,44)', LOG_ICON_WIDTH: 10, LOG_ICON_HEIGHT: 18, LOG_ICON: 'none', LOG_AMOUNT_BACKGROUND: '#42597f', LOG_AMOUNT_COLOR: '#8d8f91', LOG_LINK_COLOR: isLight ? 'rgb(66, 66, 66)' : 'rgb(177, 177, 177)', 
        /**
         * Log types
         */
        LOG_WARN_ICON: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACkSURBVChTbY7BCoJQFERn0Q/3BX1JuxQjsSCXiV8gtCgxhCIrKIRIqKDVzXl5w5cNHBjm6eGinXiAXu5inY2xYm/mbpIh+vcFhLA3sx0athNUhymEsP+10lAEEA17x8o/9wFuNGnYuVlWve0SQl7P0sBu3aq2R1Q/1JzSkYGd29eqNv2wjdnUuvNRciC/N+qe+7gidbA8zyHkOINsvA/sumcOkjcabcBmw2+mMgAAAABJRU5ErkJggg==)", LOG_WARN_BACKGROUND: isLight ? 'rgb(255,250,220)' : '#332b00', LOG_WARN_COLOR: isLight ? 'rgb(73,45,2)' : '#ffdc9e', LOG_WARN_BORDER: isLight ? 'rgb(255,244,181)' : '#650', LOG_WARN_AMOUNT_BACKGROUND: '#ffbb17', LOG_WARN_AMOUNT_COLOR: '#8d8f91', LOG_ERROR_ICON: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADESURBVChTY4CB7ZI8tmfU5E6e01b+DMIgNkgMKg0BR9Vkux6YWPx/bemIgkFiIDmwogOaqrYPzazAEm8DwuGKYGyQHEgNw0VT05Mwib9v3v7/kJEHxiA2TDFIDcNNU4vPMFPACj58/P/v40cwGyYOUsNwy8IZRSFIEUgxskKQGoZrzp4ErQapYbgYHG371M4dLACTQGaD5EBqwD6/FpzQ9dTBE64IhkFiIDmwIhi4mlJqey8o4eR9r8jPIAxig8QgsgwMAFZz1YtGPXgjAAAAAElFTkSuQmCC)", LOG_ERROR_BACKGROUND: isLight ? 'rgb(255,235,235)' : '#290000', LOG_ERROR_BORDER: isLight ? 'rgb(253,204,205)' : '#5b0000', LOG_ERROR_COLOR: isLight ? 'rgb(252,0,5)' : '#ff8080', LOG_ERROR_AMOUNT_BACKGROUND: '#dc2727', LOG_ERROR_AMOUNT_COLOR: '#8d8f91', LOG_DEBUG_ICON: "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 459 459'%3e%3cpath fill='%234D88FF' d='M433.5 127.5h-71.4a177.7 177.7 0 0 0-45.9-51L357 35.7 321.3 0l-56.1 56.1c-10.2-2.6-23-5.1-35.7-5.1s-25.5 2.5-35.7 5.1L137.7 0 102 35.7l40.8 40.8a177.7 177.7 0 0 0-45.9 51H25.5v51H79c-2.5 7.7-2.5 17.9-2.5 25.5v25.5h-51v51h51V306a88 88 0 0 0 2.5 25.5H25.5v51h71.4A152.2 152.2 0 0 0 229.5 459c56.1 0 107.1-30.6 132.6-76.5h71.4v-51H380c2.5-7.7 2.5-17.9 2.5-25.5v-25.5h51v-51h-51V204c0-7.7 0-17.9-2.5-25.5h53.5v-51zm-153 204h-102v-51h102v51zm0-102h-102v-51h102v51z'/%3e%3c/svg%3e\")", LOG_DEBUG_BACKGROUND: '', LOG_DEBUG_BORDER: '', LOG_DEBUG_COLOR: '#4D88FF', LOG_COMMAND_ICON: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABaSURBVChTY6AtmDx5cvnUqVP1oFzsoL+/XwCo8DEQv584caIVVBg7mDBhghxQ4Y2+vr6vU6ZM8YAKYwdA00SB+CxQ8S+g4jCoMCYgSiFRVpPkGaAiHMHDwAAA5Ko+F4/l6+MAAAAASUVORK5CYII=)", LOG_RESULT_ICON: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABpSURBVChTY6A92LNnj96uXbvKoVzsYMeOHVbbt29/D1T4eP/+/QJQYVSwe/duD6CCr0B8A8iWgwqjAqBk2NatW38B6bPbtm0TBYkBFbsA+c9ANFgRCBCtEASAAoSthgGiPAMD2IOHgQEA521bM7uG52wAAAAASUVORK5CYII=)", LOG_INFO_ICON: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADISURBVChTY4ABp/AztmZBZ07qe538rO114rOa8+GTskYHbKHSEOARd6nLIOTsf61gIA46U6kVePYQiK3uc/K/hPG+LrCi8IyrtkZh5yCKgk/80w46ba0RdGYGhH/2v6rXyf88qtttGVwSLp2ECQLxeiAu1wo6uwpJ7L+o2f6TDA6xZz8jCyqFnuHXCj4djywmZXHoM/EK0azGqhBsNYpngL6VCTnGqRF4xgKo+D5IDO4ZEEAKnjcQBafvqwWf/YoSPDCAP8AZGAC7mLM81zgOTQAAAABJRU5ErkJggg==)", 
        /**
         * Fonts
         */
        BASE_FONT_FAMILY: 'Consolas, Lucida Console, Courier New, monospace', BASE_FONT_SIZE: '12px', 
        /**
         * Other
         */
        ARROW_FONT_SIZE: 10, OBJECT_VALUE_STRING_COLOR: 'rgb(233,63,59)' });
};
exports["default"] = styles;
//# sourceMappingURL=data:application/json;base64,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
}(_default));

var elements$1 = {};

var theme = {};

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var testOmitPropsOnStringTag = index;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme' && key !== 'innerRef';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Noop = function Noop() {
  return null;
};

var createStyled = function createStyled(tag, options) {
  if (process.env.NODE_ENV !== 'production') {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }

  var identifierName;
  var shouldForwardProp;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
    shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && // $FlowFixMe
      options.shouldForwardProp(propName);
    } : options.shouldForwardProp;
  }

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (process.env.NODE_ENV !== 'production' && args[0][0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (process.env.NODE_ENV !== 'production' && args[0][i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = withEmotionCache(function (props, context, ref) {
      return /*#__PURE__*/createElement(ThemeContext$1.Consumer, null, function (theme) {
        var finalTag = shouldUseAs && props.as || baseTag;
        var className = '';
        var classInterpolations = [];
        var mergedProps = props;

        if (props.theme == null) {
          mergedProps = {};

          for (var key in props) {
            mergedProps[key] = props[key];
          }

          mergedProps.theme = theme;
        }

        if (typeof props.className === 'string') {
          className = getRegisteredStyles(context.registered, classInterpolations, props.className);
        } else if (props.className != null) {
          className = props.className + " ";
        }

        var serialized = serializeStyles(styles.concat(classInterpolations), context.registered, mergedProps);
        insertStyles(context, serialized, typeof finalTag === 'string');
        className += context.key + "-" + serialized.name;

        if (targetClassName !== undefined) {
          className += " " + targetClassName;
        }

        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
        var newProps = {};

        for (var _key in props) {
          if (shouldUseAs && _key === 'as') continue;

          if ( // $FlowFixMe
          finalShouldForwardProp(_key)) {
            newProps[_key] = props[_key];
          }
        }

        newProps.className = className;
        newProps.ref = ref || props.innerRef;

        if (process.env.NODE_ENV !== 'production' && props.innerRef) {
          console.error('`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead' + (identifierName === undefined ? '' : " in the usage of `" + identifierName + "`"));
        }

        var ele = /*#__PURE__*/createElement(finalTag, newProps);
        var possiblyStyleElement = /*#__PURE__*/createElement(Noop, null);


        return /*#__PURE__*/createElement(Fragment$1, null, possiblyStyleElement, ele);
      });
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && process.env.NODE_ENV !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, nextOptions !== undefined ? _objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles);
    };

    return Styled;
  };
};

var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = createStyled.bind();
tags.forEach(function (tagName) {
  newStyled[tagName] = newStyled(tagName);
});

var styled_browser_esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': newStyled
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(styled_browser_esm);

(function (exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var styled_1 = __importDefault(require$$0);
exports["default"] = styled_1["default"];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvQ29tcG9uZW50L3RoZW1lL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsMkRBQXNEO0FBR3RELHFCQUFlLG1CQUErQixDQUFBIn0=
}(theme));

var __importDefault$4 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
elements$1.__esModule = true;
elements$1.Content = elements$1.Timestamp = elements$1.AmountIcon = elements$1.Icon = elements$1.Message = elements$1.Root = void 0;
var theme_1$1 = __importDefault$4(theme);
/**
 * Return themed log-method style
 * @param style The style
 * @param type The method
 */
var Themed = function (style, method, styles) {
    return styles["LOG_" + method.toUpperCase() + "_" + style.toUpperCase()] ||
        styles["LOG_" + style.toUpperCase()];
};
/**
 * console-feed
 */
elements$1.Root = theme_1$1["default"]('div')({
    wordBreak: 'break-word',
    width: '100%'
});
/**
 * console-message
 */
elements$1.Message = theme_1$1["default"]('div')(function (_a) {
    var _b = _a.theme, styles = _b.styles, method = _b.method;
    return ({
        position: 'relative',
        display: 'flex',
        color: Themed('color', method, styles),
        backgroundColor: Themed('background', method, styles),
        borderTop: "1px solid " + Themed('border', method, styles),
        borderBottom: "1px solid " + Themed('border', method, styles),
        marginTop: -1,
        marginBottom: +/^warn|error$/.test(method),
        paddingLeft: 10,
        boxSizing: 'border-box',
        '& *': {
            verticalAlign: 'top',
            boxSizing: 'border-box',
            fontFamily: styles.BASE_FONT_FAMILY,
            whiteSpace: 'pre-wrap',
            fontSize: styles.BASE_FONT_SIZE
        },
        '& a': {
            color: styles.LOG_LINK_COLOR
        }
    });
});
/**
 * message-icon
 */
elements$1.Icon = theme_1$1["default"]('div')(function (_a) {
    var _b = _a.theme, styles = _b.styles, method = _b.method;
    return ({
        width: styles.LOG_ICON_WIDTH,
        height: styles.LOG_ICON_HEIGHT,
        backgroundImage: Themed('icon', method, styles),
        backgroundRepeat: 'no-repeat',
        backgroundSize: styles.LOG_ICON_BACKGROUND_SIZE,
        backgroundPosition: '50% 50%'
    });
});
/**
 * message-amount
 */
elements$1.AmountIcon = theme_1$1["default"]('div')(function (_a) {
    var _b = _a.theme, styles = _b.styles, method = _b.method;
    return ({
        height: '16px',
        margin: '1px 0',
        whiteSpace: 'nowrap',
        fontSize: '10px',
        lineHeight: '17px',
        padding: '0px 3px',
        background: Themed('amount_background', method, styles),
        color: Themed('amount_color', method, styles),
        borderRadius: '8px',
        minWidth: '18px',
        textAlign: 'center'
    });
});
/**
 * timestamp
 */
elements$1.Timestamp = theme_1$1["default"]('div')(function (_a) {
    var _b = _a.theme, styles = _b.styles; _b.method;
    return ({
        padding: '3px 0px 0px 5px',
        width: '110px',
        height: styles.LOG_ICON_HEIGHT,
        color: 'dimgray'
    });
});
/**
 * console-content
 */
elements$1.Content = theme_1$1["default"]('div')(function (_a) {
    var styles = _a.theme.styles;
    return ({
        clear: 'right',
        position: 'relative',
        padding: styles.PADDING,
        marginLeft: 15,
        minHeight: 18,
        flex: 'auto',
        width: 'calc(100% - 15px)'
    });
});

var Message = {};

var Formatted = {};

var elements = {};

var __importDefault$3 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
elements.__esModule = true;
elements.Constructor = elements.HTML = elements.Table = elements.Root = void 0;
var theme_1 = __importDefault$3(theme);
/**
 * Object root
 */
elements.Root = theme_1["default"]('div')({
    display: 'inline-block',
    wordBreak: 'break-all',
    '&::after': {
        content: "' '",
        display: 'inline-block'
    },
    '& > li, & > ol, & > details': {
        backgroundColor: 'transparent !important',
        display: 'inline-block'
    },
    '& ol:empty': {
        paddingLeft: '0 !important'
    }
});
/**
 * Table
 */
elements.Table = theme_1["default"]('span')({
    '& > li': {
        display: 'inline-block',
        marginTop: 5
    }
});
/**
 * HTML
 */
elements.HTML = theme_1["default"]('span')({
    display: 'inline-block',
    '& div:hover': {
        backgroundColor: 'rgba(255, 220, 158, .05) !important',
        borderRadius: '2px'
    }
});
/**
 * Object constructor
 */
elements.Constructor = theme_1["default"]('span')({
    '& > span > span:nth-child(1)': {
        opacity: 0.6
    }
});

var devtoolsParser = {};

var linkifyHtml$1 = {};

var simpleHtmlTokenizer = {};

var html5NamedCharRefs = {};

html5NamedCharRefs.__esModule = true;
var HTML5NamedCharRefs = {
    // We don't need the complete named character reference because linkifyHtml
    // does not modify the escape sequences. We do need &nbsp; so that
    // whitespace is parsed properly. Other types of whitespace should already
    // be accounted for
    nbsp: "\xA0"
};
html5NamedCharRefs.default = HTML5NamedCharRefs;

var entityParser = {};

entityParser.__esModule = true;
function EntityParser(named) {
  this.named = named;
}

var HEXCHARCODE = /^#[xX]([A-Fa-f0-9]+)$/;
var CHARCODE = /^#([0-9]+)$/;
var NAMED = /^([A-Za-z0-9]+)$/;

EntityParser.prototype.parse = function (entity) {
  if (!entity) {
    return;
  }
  var matches = entity.match(HEXCHARCODE);
  if (matches) {
    return "&#x" + matches[1] + ";";
  }
  matches = entity.match(CHARCODE);
  if (matches) {
    return "&#" + matches[1] + ";";
  }
  matches = entity.match(NAMED);
  if (matches) {
    return this.named[matches[1]] || "&" + matches[1] + ";";
  }
};

entityParser.default = EntityParser;

var eventedTokenizer = {};

var utils = {};

utils.__esModule = true;
utils.isSpace = isSpace;
utils.isAlpha = isAlpha;
utils.preprocessInput = preprocessInput;
var WSP = /[\t\n\f ]/;
var ALPHA = /[A-Za-z]/;
var CRLF = /\r\n?/g;

function isSpace(char) {
  return WSP.test(char);
}

function isAlpha(char) {
  return ALPHA.test(char);
}

function preprocessInput(input) {
  return input.replace(CRLF, "\n");
}

eventedTokenizer.__esModule = true;

var _utils = utils;

function EventedTokenizer(delegate, entityParser) {
  this.delegate = delegate;
  this.entityParser = entityParser;

  this.state = null;
  this.input = null;

  this.index = -1;
  this.line = -1;
  this.column = -1;
  this.tagLine = -1;
  this.tagColumn = -1;

  this.reset();
}

EventedTokenizer.prototype = {
  reset: function reset() {
    this.state = 'beforeData';
    this.input = '';

    this.index = 0;
    this.line = 1;
    this.column = 0;

    this.tagLine = -1;
    this.tagColumn = -1;

    this.delegate.reset();
  },

  tokenize: function tokenize(input) {
    this.reset();
    this.tokenizePart(input);
    this.tokenizeEOF();
  },

  tokenizePart: function tokenizePart(input) {
    this.input += (0, _utils.preprocessInput)(input);

    while (this.index < this.input.length) {
      this.states[this.state].call(this);
    }
  },

  tokenizeEOF: function tokenizeEOF() {
    this.flushData();
  },

  flushData: function flushData() {
    if (this.state === 'data') {
      this.delegate.finishData();
      this.state = 'beforeData';
    }
  },

  peek: function peek() {
    return this.input.charAt(this.index);
  },

  consume: function consume() {
    var char = this.peek();

    this.index++;

    if (char === "\n") {
      this.line++;
      this.column = 0;
    } else {
      this.column++;
    }

    return char;
  },

  consumeCharRef: function consumeCharRef() {
    var endIndex = this.input.indexOf(';', this.index);
    if (endIndex === -1) {
      return;
    }
    var entity = this.input.slice(this.index, endIndex);
    var chars = this.entityParser.parse(entity);
    if (chars) {
      var count = entity.length;
      // consume the entity chars
      while (count) {
        this.consume();
        count--;
      }
      // consume the `;`
      this.consume();

      return chars;
    }
  },

  markTagStart: function markTagStart() {
    // these properties to be removed in next major bump
    this.tagLine = this.line;
    this.tagColumn = this.column;

    if (this.delegate.tagOpen) {
      this.delegate.tagOpen();
    }
  },

  states: {
    beforeData: function beforeData() {
      var char = this.peek();

      if (char === "<") {
        this.state = 'tagOpen';
        this.markTagStart();
        this.consume();
      } else {
        this.state = 'data';
        this.delegate.beginData();
      }
    },

    data: function data() {
      var char = this.peek();

      if (char === "<") {
        this.delegate.finishData();
        this.state = 'tagOpen';
        this.markTagStart();
        this.consume();
      } else if (char === "&") {
        this.consume();
        this.delegate.appendToData(this.consumeCharRef() || "&");
      } else {
        this.consume();
        this.delegate.appendToData(char);
      }
    },

    tagOpen: function tagOpen() {
      var char = this.consume();

      if (char === "!") {
        this.state = 'markupDeclaration';
      } else if (char === "/") {
        this.state = 'endTagOpen';
      } else if ((0, _utils.isAlpha)(char)) {
        this.state = 'tagName';
        this.delegate.beginStartTag();
        this.delegate.appendToTagName(char.toLowerCase());
      }
    },

    markupDeclaration: function markupDeclaration() {
      var char = this.consume();

      if (char === "-" && this.input.charAt(this.index) === "-") {
        this.consume();
        this.state = 'commentStart';
        this.delegate.beginComment();
      }
    },

    commentStart: function commentStart() {
      var char = this.consume();

      if (char === "-") {
        this.state = 'commentStartDash';
      } else if (char === ">") {
        this.delegate.finishComment();
        this.state = 'beforeData';
      } else {
        this.delegate.appendToCommentData(char);
        this.state = 'comment';
      }
    },

    commentStartDash: function commentStartDash() {
      var char = this.consume();

      if (char === "-") {
        this.state = 'commentEnd';
      } else if (char === ">") {
        this.delegate.finishComment();
        this.state = 'beforeData';
      } else {
        this.delegate.appendToCommentData("-");
        this.state = 'comment';
      }
    },

    comment: function comment() {
      var char = this.consume();

      if (char === "-") {
        this.state = 'commentEndDash';
      } else {
        this.delegate.appendToCommentData(char);
      }
    },

    commentEndDash: function commentEndDash() {
      var char = this.consume();

      if (char === "-") {
        this.state = 'commentEnd';
      } else {
        this.delegate.appendToCommentData("-" + char);
        this.state = 'comment';
      }
    },

    commentEnd: function commentEnd() {
      var char = this.consume();

      if (char === ">") {
        this.delegate.finishComment();
        this.state = 'beforeData';
      } else {
        this.delegate.appendToCommentData("--" + char);
        this.state = 'comment';
      }
    },

    tagName: function tagName() {
      var char = this.consume();

      if ((0, _utils.isSpace)(char)) {
        this.state = 'beforeAttributeName';
      } else if (char === "/") {
        this.state = 'selfClosingStartTag';
      } else if (char === ">") {
        this.delegate.finishTag();
        this.state = 'beforeData';
      } else {
        this.delegate.appendToTagName(char);
      }
    },

    beforeAttributeName: function beforeAttributeName() {
      var char = this.peek();

      if ((0, _utils.isSpace)(char)) {
        this.consume();
        return;
      } else if (char === "/") {
        this.state = 'selfClosingStartTag';
        this.consume();
      } else if (char === ">") {
        this.consume();
        this.delegate.finishTag();
        this.state = 'beforeData';
      } else {
        this.state = 'attributeName';
        this.delegate.beginAttribute();
        this.consume();
        this.delegate.appendToAttributeName(char);
      }
    },

    attributeName: function attributeName() {
      var char = this.peek();

      if ((0, _utils.isSpace)(char)) {
        this.state = 'afterAttributeName';
        this.consume();
      } else if (char === "/") {
        this.delegate.beginAttributeValue(false);
        this.delegate.finishAttributeValue();
        this.consume();
        this.state = 'selfClosingStartTag';
      } else if (char === "=") {
        this.state = 'beforeAttributeValue';
        this.consume();
      } else if (char === ">") {
        this.delegate.beginAttributeValue(false);
        this.delegate.finishAttributeValue();
        this.consume();
        this.delegate.finishTag();
        this.state = 'beforeData';
      } else {
        this.consume();
        this.delegate.appendToAttributeName(char);
      }
    },

    afterAttributeName: function afterAttributeName() {
      var char = this.peek();

      if ((0, _utils.isSpace)(char)) {
        this.consume();
        return;
      } else if (char === "/") {
        this.delegate.beginAttributeValue(false);
        this.delegate.finishAttributeValue();
        this.consume();
        this.state = 'selfClosingStartTag';
      } else if (char === "=") {
        this.consume();
        this.state = 'beforeAttributeValue';
      } else if (char === ">") {
        this.delegate.beginAttributeValue(false);
        this.delegate.finishAttributeValue();
        this.consume();
        this.delegate.finishTag();
        this.state = 'beforeData';
      } else {
        this.delegate.beginAttributeValue(false);
        this.delegate.finishAttributeValue();
        this.consume();
        this.state = 'attributeName';
        this.delegate.beginAttribute();
        this.delegate.appendToAttributeName(char);
      }
    },

    beforeAttributeValue: function beforeAttributeValue() {
      var char = this.peek();

      if ((0, _utils.isSpace)(char)) {
        this.consume();
      } else if (char === '"') {
        this.state = 'attributeValueDoubleQuoted';
        this.delegate.beginAttributeValue(true);
        this.consume();
      } else if (char === "'") {
        this.state = 'attributeValueSingleQuoted';
        this.delegate.beginAttributeValue(true);
        this.consume();
      } else if (char === ">") {
        this.delegate.beginAttributeValue(false);
        this.delegate.finishAttributeValue();
        this.consume();
        this.delegate.finishTag();
        this.state = 'beforeData';
      } else {
        this.state = 'attributeValueUnquoted';
        this.delegate.beginAttributeValue(false);
        this.consume();
        this.delegate.appendToAttributeValue(char);
      }
    },

    attributeValueDoubleQuoted: function attributeValueDoubleQuoted() {
      var char = this.consume();

      if (char === '"') {
        this.delegate.finishAttributeValue();
        this.state = 'afterAttributeValueQuoted';
      } else if (char === "&") {
        this.delegate.appendToAttributeValue(this.consumeCharRef('"') || "&");
      } else {
        this.delegate.appendToAttributeValue(char);
      }
    },

    attributeValueSingleQuoted: function attributeValueSingleQuoted() {
      var char = this.consume();

      if (char === "'") {
        this.delegate.finishAttributeValue();
        this.state = 'afterAttributeValueQuoted';
      } else if (char === "&") {
        this.delegate.appendToAttributeValue(this.consumeCharRef("'") || "&");
      } else {
        this.delegate.appendToAttributeValue(char);
      }
    },

    attributeValueUnquoted: function attributeValueUnquoted() {
      var char = this.peek();

      if ((0, _utils.isSpace)(char)) {
        this.delegate.finishAttributeValue();
        this.consume();
        this.state = 'beforeAttributeName';
      } else if (char === "&") {
        this.consume();
        this.delegate.appendToAttributeValue(this.consumeCharRef(">") || "&");
      } else if (char === ">") {
        this.delegate.finishAttributeValue();
        this.consume();
        this.delegate.finishTag();
        this.state = 'beforeData';
      } else {
        this.consume();
        this.delegate.appendToAttributeValue(char);
      }
    },

    afterAttributeValueQuoted: function afterAttributeValueQuoted() {
      var char = this.peek();

      if ((0, _utils.isSpace)(char)) {
        this.consume();
        this.state = 'beforeAttributeName';
      } else if (char === "/") {
        this.consume();
        this.state = 'selfClosingStartTag';
      } else if (char === ">") {
        this.consume();
        this.delegate.finishTag();
        this.state = 'beforeData';
      } else {
        this.state = 'beforeAttributeName';
      }
    },

    selfClosingStartTag: function selfClosingStartTag() {
      var char = this.peek();

      if (char === ">") {
        this.consume();
        this.delegate.markTagAsSelfClosing();
        this.delegate.finishTag();
        this.state = 'beforeData';
      } else {
        this.state = 'beforeAttributeName';
      }
    },

    endTagOpen: function endTagOpen() {
      var char = this.consume();

      if ((0, _utils.isAlpha)(char)) {
        this.state = 'tagName';
        this.delegate.beginEndTag();
        this.delegate.appendToTagName(char.toLowerCase());
      }
    }
  }
};

eventedTokenizer.default = EventedTokenizer;

var tokenizer = {};

tokenizer.__esModule = true;

var _eventedTokenizer$1 = eventedTokenizer;

var _eventedTokenizer2$1 = _interopRequireDefault$4(_eventedTokenizer$1);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Tokenizer(entityParser, options) {
  this.token = null;
  this.startLine = 1;
  this.startColumn = 0;
  this.options = options || {};
  this.tokenizer = new _eventedTokenizer2$1.default(this, entityParser);
}

Tokenizer.prototype = {
  tokenize: function tokenize(input) {
    this.tokens = [];
    this.tokenizer.tokenize(input);
    return this.tokens;
  },

  tokenizePart: function tokenizePart(input) {
    this.tokens = [];
    this.tokenizer.tokenizePart(input);
    return this.tokens;
  },

  tokenizeEOF: function tokenizeEOF() {
    this.tokens = [];
    this.tokenizer.tokenizeEOF();
    return this.tokens[0];
  },

  reset: function reset() {
    this.token = null;
    this.startLine = 1;
    this.startColumn = 0;
  },

  addLocInfo: function addLocInfo() {
    if (this.options.loc) {
      this.token.loc = {
        start: {
          line: this.startLine,
          column: this.startColumn
        },
        end: {
          line: this.tokenizer.line,
          column: this.tokenizer.column
        }
      };
    }
    this.startLine = this.tokenizer.line;
    this.startColumn = this.tokenizer.column;
  },

  // Data

  beginData: function beginData() {
    this.token = {
      type: 'Chars',
      chars: ''
    };
    this.tokens.push(this.token);
  },

  appendToData: function appendToData(char) {
    this.token.chars += char;
  },

  finishData: function finishData() {
    this.addLocInfo();
  },

  // Comment

  beginComment: function beginComment() {
    this.token = {
      type: 'Comment',
      chars: ''
    };
    this.tokens.push(this.token);
  },

  appendToCommentData: function appendToCommentData(char) {
    this.token.chars += char;
  },

  finishComment: function finishComment() {
    this.addLocInfo();
  },

  // Tags - basic

  beginStartTag: function beginStartTag() {
    this.token = {
      type: 'StartTag',
      tagName: '',
      attributes: [],
      selfClosing: false
    };
    this.tokens.push(this.token);
  },

  beginEndTag: function beginEndTag() {
    this.token = {
      type: 'EndTag',
      tagName: ''
    };
    this.tokens.push(this.token);
  },

  finishTag: function finishTag() {
    this.addLocInfo();
  },

  markTagAsSelfClosing: function markTagAsSelfClosing() {
    this.token.selfClosing = true;
  },

  // Tags - name

  appendToTagName: function appendToTagName(char) {
    this.token.tagName += char;
  },

  // Tags - attributes

  beginAttribute: function beginAttribute() {
    this._currentAttribute = ["", "", null];
    this.token.attributes.push(this._currentAttribute);
  },

  appendToAttributeName: function appendToAttributeName(char) {
    this._currentAttribute[0] += char;
  },

  beginAttributeValue: function beginAttributeValue(isQuoted) {
    this._currentAttribute[2] = isQuoted;
  },

  appendToAttributeValue: function appendToAttributeValue(char) {
    this._currentAttribute[1] = this._currentAttribute[1] || "";
    this._currentAttribute[1] += char;
  },

  finishAttributeValue: function finishAttributeValue() {}
};

tokenizer.default = Tokenizer;

var tokenize$2 = {};

tokenize$2.__esModule = true;
tokenize$2.default = tokenize$1;

var _tokenizer$1 = tokenizer;

var _tokenizer2$1 = _interopRequireDefault$3(_tokenizer$1);

var _entityParser$1 = entityParser;

var _entityParser2$1 = _interopRequireDefault$3(_entityParser$1);

var _html5NamedCharRefs$1 = html5NamedCharRefs;

var _html5NamedCharRefs2$1 = _interopRequireDefault$3(_html5NamedCharRefs$1);

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function tokenize$1(input, options) {
  var tokenizer = new _tokenizer2$1.default(new _entityParser2$1.default(_html5NamedCharRefs2$1.default), options);
  return tokenizer.tokenize(input);
}

simpleHtmlTokenizer.__esModule = true;

var _html5NamedCharRefs = html5NamedCharRefs;

var _html5NamedCharRefs2 = _interopRequireDefault$2(_html5NamedCharRefs);

var _entityParser = entityParser;

var _entityParser2 = _interopRequireDefault$2(_entityParser);

var _eventedTokenizer = eventedTokenizer;

var _eventedTokenizer2 = _interopRequireDefault$2(_eventedTokenizer);

var _tokenizer = tokenizer;

var _tokenizer2 = _interopRequireDefault$2(_tokenizer);

var _tokenize = tokenize$2;

var _tokenize2 = _interopRequireDefault$2(_tokenize);

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HTML5Tokenizer = {
	HTML5NamedCharRefs: _html5NamedCharRefs2.default,
	EntityParser: _entityParser2.default,
	EventedTokenizer: _eventedTokenizer2.default,
	Tokenizer: _tokenizer2.default,
	tokenize: _tokenize2.default
};

simpleHtmlTokenizer.default = HTML5Tokenizer;

var linkify$2 = {};

var _class$4 = {};

_class$4.__esModule = true;
_class$4.inherits = inherits;
function inherits(parent, child) {
	var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	var extended = Object.create(parent.prototype);
	for (var p in props) {
		extended[p] = props[p];
	}
	extended.constructor = child;
	child.prototype = extended;
	return child;
}

var options$3 = {};

options$3.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var defaults = {
	defaultProtocol: 'http',
	events: null,
	format: noop,
	formatHref: noop,
	nl2br: false,
	tagName: 'a',
	target: typeToTarget,
	validate: true,
	ignoreTags: [],
	attributes: null,
	className: 'linkified' // Deprecated value - no default class will be provided in the future
};

options$3.defaults = defaults;
options$3.Options = Options$2;
options$3.contains = contains;


function Options$2(opts) {
	opts = opts || {};

	this.defaultProtocol = opts.hasOwnProperty('defaultProtocol') ? opts.defaultProtocol : defaults.defaultProtocol;
	this.events = opts.hasOwnProperty('events') ? opts.events : defaults.events;
	this.format = opts.hasOwnProperty('format') ? opts.format : defaults.format;
	this.formatHref = opts.hasOwnProperty('formatHref') ? opts.formatHref : defaults.formatHref;
	this.nl2br = opts.hasOwnProperty('nl2br') ? opts.nl2br : defaults.nl2br;
	this.tagName = opts.hasOwnProperty('tagName') ? opts.tagName : defaults.tagName;
	this.target = opts.hasOwnProperty('target') ? opts.target : defaults.target;
	this.validate = opts.hasOwnProperty('validate') ? opts.validate : defaults.validate;
	this.ignoreTags = [];

	// linkAttributes and linkClass is deprecated
	this.attributes = opts.attributes || opts.linkAttributes || defaults.attributes;
	this.className = opts.hasOwnProperty('className') ? opts.className : opts.linkClass || defaults.className;

	// Make all tags names upper case
	var ignoredTags = opts.hasOwnProperty('ignoreTags') ? opts.ignoreTags : defaults.ignoreTags;
	for (var i = 0; i < ignoredTags.length; i++) {
		this.ignoreTags.push(ignoredTags[i].toUpperCase());
	}
}

Options$2.prototype = {
	/**
  * Given the token, return all options for how it should be displayed
  */
	resolve: function resolve(token) {
		var href = token.toHref(this.defaultProtocol);
		return {
			formatted: this.get('format', token.toString(), token),
			formattedHref: this.get('formatHref', href, token),
			tagName: this.get('tagName', href, token),
			className: this.get('className', href, token),
			target: this.get('target', href, token),
			events: this.getObject('events', href, token),
			attributes: this.getObject('attributes', href, token)
		};
	},


	/**
  * Returns true or false based on whether a token should be displayed as a
  * link based on the user options. By default,
  */
	check: function check(token) {
		return this.get('validate', token.toString(), token);
	},


	// Private methods

	/**
  * Resolve an option's value based on the value of the option and the given
  * params.
  * @param {String} key Name of option to use
  * @param operator will be passed to the target option if it's method
  * @param {MultiToken} token The token from linkify.tokenize
  */
	get: function get(key, operator, token) {
		var optionValue = void 0,
		    option = this[key];
		if (!option) {
			return option;
		}

		switch (typeof option === 'undefined' ? 'undefined' : _typeof(option)) {
			case 'function':
				return option(operator, token.type);
			case 'object':
				optionValue = option.hasOwnProperty(token.type) ? option[token.type] : defaults[key];
				return typeof optionValue === 'function' ? optionValue(operator, token.type) : optionValue;
		}

		return option;
	},
	getObject: function getObject(key, operator, token) {
		var option = this[key];
		return typeof option === 'function' ? option(operator, token.type) : option;
	}
};

/**
 * Quick indexOf replacement for checking the ignoreTags option
 */
function contains(arr, value) {
	for (var i = 0; i < arr.length; i++) {
		if (arr[i] === value) {
			return true;
		}
	}
	return false;
}

function noop(val) {
	return val;
}

function typeToTarget(href, type) {
	return type === 'url' ? '_blank' : null;
}

var scanner$1 = {};

var state$1 = {};

state$1.__esModule = true;
state$1.stateify = state$1.TokenState = state$1.CharacterState = undefined;

var _class$3 = _class$4;

function createStateClass() {
	return function (tClass) {
		this.j = [];
		this.T = tClass || null;
	};
}

/**
	A simple state machine that can emit token classes

	The `j` property in this class refers to state jumps. It's a
	multidimensional array where for each element:

	* index [0] is a symbol or class of symbols to transition to.
	* index [1] is a State instance which matches

	The type of symbol will depend on the target implementation for this class.
	In Linkify, we have a two-stage scanner. Each stage uses this state machine
	but with a slighly different (polymorphic) implementation.

	The `T` property refers to the token class.

	TODO: Can the `on` and `next` methods be combined?

	@class BaseState
*/
var BaseState = createStateClass();
BaseState.prototype = {
	defaultTransition: false,

	/**
 	@method constructor
 	@param {Class} tClass Pass in the kind of token to emit if there are
 		no jumps after this state and the state is accepting.
 */

	/**
 	On the given symbol(s), this machine should go to the given state
 		@method on
 	@param {Array|Mixed} symbol
 	@param {BaseState} state Note that the type of this state should be the
 		same as the current instance (i.e., don't pass in a different
 		subclass)
 */
	on: function on(symbol, state) {
		if (symbol instanceof Array) {
			for (var i = 0; i < symbol.length; i++) {
				this.j.push([symbol[i], state]);
			}
			return this;
		}
		this.j.push([symbol, state]);
		return this;
	},


	/**
 	Given the next item, returns next state for that item
 	@method next
 	@param {Mixed} item Should be an instance of the symbols handled by
 		this particular machine.
 	@return {State} state Returns false if no jumps are available
 */
	next: function next(item) {
		for (var i = 0; i < this.j.length; i++) {
			var jump = this.j[i];
			var symbol = jump[0]; // Next item to check for
			var state = jump[1]; // State to jump to if items match

			// compare item with symbol
			if (this.test(item, symbol)) {
				return state;
			}
		}

		// Nowhere left to jump!
		return this.defaultTransition;
	},


	/**
 	Does this state accept?
 	`true` only of `this.T` exists
 		@method accepts
 	@return {Boolean}
 */
	accepts: function accepts() {
		return !!this.T;
	},


	/**
 	Determine whether a given item "symbolizes" the symbol, where symbol is
 	a class of items handled by this state machine.
 		This method should be overriden in extended classes.
 		@method test
 	@param {Mixed} item Does this item match the given symbol?
 	@param {Mixed} symbol
 	@return {Boolean}
 */
	test: function test(item, symbol) {
		return item === symbol;
	},


	/**
 	Emit the token for this State (just return it in this case)
 	If this emits a token, this instance is an accepting state
 	@method emit
 	@return {Class} T
 */
	emit: function emit() {
		return this.T;
	}
};

/**
	State machine for string-based input

	@class CharacterState
	@extends BaseState
*/
var CharacterState = (0, _class$3.inherits)(BaseState, createStateClass(), {
	/**
 	Does the given character match the given character or regular
 	expression?
 		@method test
 	@param {String} char
 	@param {String|RegExp} charOrRegExp
 	@return {Boolean}
 */
	test: function test(character, charOrRegExp) {
		return character === charOrRegExp || charOrRegExp instanceof RegExp && charOrRegExp.test(character);
	}
});

/**
	State machine for input in the form of TextTokens

	@class TokenState
	@extends BaseState
*/
var TokenState = (0, _class$3.inherits)(BaseState, createStateClass(), {

	/**
  * Similar to `on`, but returns the state the results in the transition from
  * the given item
  * @method jump
  * @param {Mixed} item
  * @param {Token} [token]
  * @return state
  */
	jump: function jump(token) {
		var tClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		var state = this.next(new token('')); // dummy temp token
		if (state === this.defaultTransition) {
			// Make a new state!
			state = new this.constructor(tClass);
			this.on(token, state);
		} else if (tClass) {
			state.T = tClass;
		}
		return state;
	},


	/**
 	Is the given token an instance of the given token class?
 		@method test
 	@param {TextToken} token
 	@param {Class} tokenClass
 	@return {Boolean}
 */
	test: function test(token, tokenClass) {
		return token instanceof tokenClass;
	}
});

/**
	Given a non-empty target string, generates states (if required) for each
	consecutive substring of characters in str starting from the beginning of
	the string. The final state will have a special value, as specified in
	options. All other "in between" substrings will have a default end state.

	This turns the state machine into a Trie-like data structure (rather than a
	intelligently-designed DFA).

	Note that I haven't really tried these with any strings other than
	DOMAIN.

	@param {String} str
	@param {CharacterState} start State to jump from the first character
	@param {Class} endToken Token class to emit when the given string has been
		matched and no more jumps exist.
	@param {Class} defaultToken "Filler token", or which token type to emit when
		we don't have a full match
	@return {Array} list of newly-created states
*/
function stateify(str, start, endToken, defaultToken) {
	var i = 0,
	    len = str.length,
	    state = start,
	    newStates = [],
	    nextState = void 0;

	// Find the next state without a jump to the next character
	while (i < len && (nextState = state.next(str[i]))) {
		state = nextState;
		i++;
	}

	if (i >= len) {
		return [];
	} // no new tokens were added

	while (i < len - 1) {
		nextState = new CharacterState(defaultToken);
		newStates.push(nextState);
		state.on(str[i], nextState);
		state = nextState;
		i++;
	}

	nextState = new CharacterState(endToken);
	newStates.push(nextState);
	state.on(str[len - 1], nextState);

	return newStates;
}

state$1.CharacterState = CharacterState;
state$1.TokenState = TokenState;
state$1.stateify = stateify;

var text = {};

var createTokenClass$1 = {};

createTokenClass$1.__esModule = true;
function createTokenClass() {
	return function (value) {
		if (value) {
			this.v = value;
		}
	};
}

createTokenClass$1.createTokenClass = createTokenClass;

text.__esModule = true;
text.AMPERSAND = text.CLOSEPAREN = text.CLOSEANGLEBRACKET = text.CLOSEBRACKET = text.CLOSEBRACE = text.OPENPAREN = text.OPENANGLEBRACKET = text.OPENBRACKET = text.OPENBRACE = text.WS = text.TLD = text.SYM = text.UNDERSCORE = text.SLASH = text.MAILTO = text.PROTOCOL = text.QUERY = text.POUND = text.PLUS = text.NUM = text.NL = text.LOCALHOST = text.PUNCTUATION = text.DOT = text.COLON = text.AT = text.DOMAIN = text.Base = undefined;

var _createTokenClass$1 = createTokenClass$1;

var _class$2 = _class$4;

/******************************************************************************
	Text Tokens
	Tokens composed of strings
******************************************************************************/

/**
	Abstract class used for manufacturing text tokens.
	Pass in the value this token represents

	@class TextToken
	@abstract
*/
var TextToken = (0, _createTokenClass$1.createTokenClass)();
TextToken.prototype = {
	toString: function toString() {
		return this.v + '';
	}
};

function inheritsToken(value) {
	var props = value ? { v: value } : {};
	return (0, _class$2.inherits)(TextToken, (0, _createTokenClass$1.createTokenClass)(), props);
}

/**
	A valid domain token
	@class DOMAIN
	@extends TextToken
*/
var DOMAIN = inheritsToken();

/**
	@class AT
	@extends TextToken
*/
var AT = inheritsToken('@');

/**
	Represents a single colon `:` character

	@class COLON
	@extends TextToken
*/
var COLON = inheritsToken(':');

/**
	@class DOT
	@extends TextToken
*/
var DOT = inheritsToken('.');

/**
	A character class that can surround the URL, but which the URL cannot begin
	or end with. Does not include certain English punctuation like parentheses.

	@class PUNCTUATION
	@extends TextToken
*/
var PUNCTUATION = inheritsToken();

/**
	The word localhost (by itself)
	@class LOCALHOST
	@extends TextToken
*/
var LOCALHOST = inheritsToken();

/**
	Newline token
	@class NL
	@extends TextToken
*/
var NL$1 = inheritsToken('\n');

/**
	@class NUM
	@extends TextToken
*/
var NUM = inheritsToken();

/**
	@class PLUS
	@extends TextToken
*/
var PLUS = inheritsToken('+');

/**
	@class POUND
	@extends TextToken
*/
var POUND = inheritsToken('#');

/**
	Represents a web URL protocol. Supported types include

	* `http:`
	* `https:`
	* `ftp:`
	* `ftps:`

	@class PROTOCOL
	@extends TextToken
*/
var PROTOCOL = inheritsToken();

/**
	Represents the start of the email URI protocol

	@class MAILTO
	@extends TextToken
*/
var MAILTO = inheritsToken('mailto:');

/**
	@class QUERY
	@extends TextToken
*/
var QUERY = inheritsToken('?');

/**
	@class SLASH
	@extends TextToken
*/
var SLASH = inheritsToken('/');

/**
	@class UNDERSCORE
	@extends TextToken
*/
var UNDERSCORE = inheritsToken('_');

/**
	One ore more non-whitespace symbol.
	@class SYM
	@extends TextToken
*/
var SYM = inheritsToken();

/**
	@class TLD
	@extends TextToken
*/
var TLD = inheritsToken();

/**
	Represents a string of consecutive whitespace characters

	@class WS
	@extends TextToken
*/
var WS = inheritsToken();

/**
	Opening/closing bracket classes
*/

var OPENBRACE = inheritsToken('{');
var OPENBRACKET = inheritsToken('[');
var OPENANGLEBRACKET = inheritsToken('<');
var OPENPAREN = inheritsToken('(');
var CLOSEBRACE = inheritsToken('}');
var CLOSEBRACKET = inheritsToken(']');
var CLOSEANGLEBRACKET = inheritsToken('>');
var CLOSEPAREN = inheritsToken(')');

var AMPERSAND = inheritsToken('&');

text.Base = TextToken;
text.DOMAIN = DOMAIN;
text.AT = AT;
text.COLON = COLON;
text.DOT = DOT;
text.PUNCTUATION = PUNCTUATION;
text.LOCALHOST = LOCALHOST;
text.NL = NL$1;
text.NUM = NUM;
text.PLUS = PLUS;
text.POUND = POUND;
text.QUERY = QUERY;
text.PROTOCOL = PROTOCOL;
text.MAILTO = MAILTO;
text.SLASH = SLASH;
text.UNDERSCORE = UNDERSCORE;
text.SYM = SYM;
text.TLD = TLD;
text.WS = WS;
text.OPENBRACE = OPENBRACE;
text.OPENBRACKET = OPENBRACKET;
text.OPENANGLEBRACKET = OPENANGLEBRACKET;
text.OPENPAREN = OPENPAREN;
text.CLOSEBRACE = CLOSEBRACE;
text.CLOSEBRACKET = CLOSEBRACKET;
text.CLOSEANGLEBRACKET = CLOSEANGLEBRACKET;
text.CLOSEPAREN = CLOSEPAREN;
text.AMPERSAND = AMPERSAND;

scanner$1.__esModule = true;
scanner$1.start = scanner$1.run = scanner$1.TOKENS = scanner$1.State = undefined;

var _state$1 = state$1;

var _text$2 = text;

var TOKENS = _interopRequireWildcard$4(_text$2);

function _interopRequireWildcard$4(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var tlds = 'aaa|aarp|abarth|abb|abbott|abbvie|abc|able|abogado|abudhabi|ac|academy|accenture|accountant|accountants|aco|active|actor|ad|adac|ads|adult|ae|aeg|aero|aetna|af|afamilycompany|afl|africa|ag|agakhan|agency|ai|aig|aigo|airbus|airforce|airtel|akdn|al|alfaromeo|alibaba|alipay|allfinanz|allstate|ally|alsace|alstom|am|americanexpress|americanfamily|amex|amfam|amica|amsterdam|analytics|android|anquan|anz|ao|aol|apartments|app|apple|aq|aquarelle|ar|arab|aramco|archi|army|arpa|art|arte|as|asda|asia|associates|at|athleta|attorney|au|auction|audi|audible|audio|auspost|author|auto|autos|avianca|aw|aws|ax|axa|az|azure|ba|baby|baidu|banamex|bananarepublic|band|bank|bar|barcelona|barclaycard|barclays|barefoot|bargains|baseball|basketball|bauhaus|bayern|bb|bbc|bbt|bbva|bcg|bcn|bd|be|beats|beauty|beer|bentley|berlin|best|bestbuy|bet|bf|bg|bh|bharti|bi|bible|bid|bike|bing|bingo|bio|biz|bj|black|blackfriday|blanco|blockbuster|blog|bloomberg|blue|bm|bms|bmw|bn|bnl|bnpparibas|bo|boats|boehringer|bofa|bom|bond|boo|book|booking|boots|bosch|bostik|boston|bot|boutique|box|br|bradesco|bridgestone|broadway|broker|brother|brussels|bs|bt|budapest|bugatti|build|builders|business|buy|buzz|bv|bw|by|bz|bzh|ca|cab|cafe|cal|call|calvinklein|cam|camera|camp|cancerresearch|canon|capetown|capital|capitalone|car|caravan|cards|care|career|careers|cars|cartier|casa|case|caseih|cash|casino|cat|catering|catholic|cba|cbn|cbre|cbs|cc|cd|ceb|center|ceo|cern|cf|cfa|cfd|cg|ch|chanel|channel|chase|chat|cheap|chintai|chloe|christmas|chrome|chrysler|church|ci|cipriani|circle|cisco|citadel|citi|citic|city|cityeats|ck|cl|claims|cleaning|click|clinic|clinique|clothing|cloud|club|clubmed|cm|cn|co|coach|codes|coffee|college|cologne|com|comcast|commbank|community|company|compare|computer|comsec|condos|construction|consulting|contact|contractors|cooking|cookingchannel|cool|coop|corsica|country|coupon|coupons|courses|cr|credit|creditcard|creditunion|cricket|crown|crs|cruise|cruises|csc|cu|cuisinella|cv|cw|cx|cy|cymru|cyou|cz|dabur|dad|dance|data|date|dating|datsun|day|dclk|dds|de|deal|dealer|deals|degree|delivery|dell|deloitte|delta|democrat|dental|dentist|desi|design|dev|dhl|diamonds|diet|digital|direct|directory|discount|discover|dish|diy|dj|dk|dm|dnp|do|docs|doctor|dodge|dog|doha|domains|dot|download|drive|dtv|dubai|duck|dunlop|duns|dupont|durban|dvag|dvr|dz|earth|eat|ec|eco|edeka|edu|education|ee|eg|email|emerck|energy|engineer|engineering|enterprises|epost|epson|equipment|er|ericsson|erni|es|esq|estate|esurance|et|etisalat|eu|eurovision|eus|events|everbank|exchange|expert|exposed|express|extraspace|fage|fail|fairwinds|faith|family|fan|fans|farm|farmers|fashion|fast|fedex|feedback|ferrari|ferrero|fi|fiat|fidelity|fido|film|final|finance|financial|fire|firestone|firmdale|fish|fishing|fit|fitness|fj|fk|flickr|flights|flir|florist|flowers|fly|fm|fo|foo|food|foodnetwork|football|ford|forex|forsale|forum|foundation|fox|fr|free|fresenius|frl|frogans|frontdoor|frontier|ftr|fujitsu|fujixerox|fun|fund|furniture|futbol|fyi|ga|gal|gallery|gallo|gallup|game|games|gap|garden|gb|gbiz|gd|gdn|ge|gea|gent|genting|george|gf|gg|ggee|gh|gi|gift|gifts|gives|giving|gl|glade|glass|gle|global|globo|gm|gmail|gmbh|gmo|gmx|gn|godaddy|gold|goldpoint|golf|goo|goodhands|goodyear|goog|google|gop|got|gov|gp|gq|gr|grainger|graphics|gratis|green|gripe|grocery|group|gs|gt|gu|guardian|gucci|guge|guide|guitars|guru|gw|gy|hair|hamburg|hangout|haus|hbo|hdfc|hdfcbank|health|healthcare|help|helsinki|here|hermes|hgtv|hiphop|hisamitsu|hitachi|hiv|hk|hkt|hm|hn|hockey|holdings|holiday|homedepot|homegoods|homes|homesense|honda|honeywell|horse|hospital|host|hosting|hot|hoteles|hotels|hotmail|house|how|hr|hsbc|ht|htc|hu|hughes|hyatt|hyundai|ibm|icbc|ice|icu|id|ie|ieee|ifm|ikano|il|im|imamat|imdb|immo|immobilien|in|industries|infiniti|info|ing|ink|institute|insurance|insure|int|intel|international|intuit|investments|io|ipiranga|iq|ir|irish|is|iselect|ismaili|ist|istanbul|it|itau|itv|iveco|iwc|jaguar|java|jcb|jcp|je|jeep|jetzt|jewelry|jio|jlc|jll|jm|jmp|jnj|jo|jobs|joburg|jot|joy|jp|jpmorgan|jprs|juegos|juniper|kaufen|kddi|ke|kerryhotels|kerrylogistics|kerryproperties|kfh|kg|kh|ki|kia|kim|kinder|kindle|kitchen|kiwi|km|kn|koeln|komatsu|kosher|kp|kpmg|kpn|kr|krd|kred|kuokgroup|kw|ky|kyoto|kz|la|lacaixa|ladbrokes|lamborghini|lamer|lancaster|lancia|lancome|land|landrover|lanxess|lasalle|lat|latino|latrobe|law|lawyer|lb|lc|lds|lease|leclerc|lefrak|legal|lego|lexus|lgbt|li|liaison|lidl|life|lifeinsurance|lifestyle|lighting|like|lilly|limited|limo|lincoln|linde|link|lipsy|live|living|lixil|lk|loan|loans|locker|locus|loft|lol|london|lotte|lotto|love|lpl|lplfinancial|lr|ls|lt|ltd|ltda|lu|lundbeck|lupin|luxe|luxury|lv|ly|ma|macys|madrid|maif|maison|makeup|man|management|mango|map|market|marketing|markets|marriott|marshalls|maserati|mattel|mba|mc|mckinsey|md|me|med|media|meet|melbourne|meme|memorial|men|menu|meo|merckmsd|metlife|mg|mh|miami|microsoft|mil|mini|mint|mit|mitsubishi|mk|ml|mlb|mls|mm|mma|mn|mo|mobi|mobile|mobily|moda|moe|moi|mom|monash|money|monster|mopar|mormon|mortgage|moscow|moto|motorcycles|mov|movie|movistar|mp|mq|mr|ms|msd|mt|mtn|mtr|mu|museum|mutual|mv|mw|mx|my|mz|na|nab|nadex|nagoya|name|nationwide|natura|navy|nba|nc|ne|nec|net|netbank|netflix|network|neustar|new|newholland|news|next|nextdirect|nexus|nf|nfl|ng|ngo|nhk|ni|nico|nike|nikon|ninja|nissan|nissay|nl|no|nokia|northwesternmutual|norton|now|nowruz|nowtv|np|nr|nra|nrw|ntt|nu|nyc|nz|obi|observer|off|office|okinawa|olayan|olayangroup|oldnavy|ollo|om|omega|one|ong|onl|online|onyourside|ooo|open|oracle|orange|org|organic|origins|osaka|otsuka|ott|ovh|pa|page|panasonic|panerai|paris|pars|partners|parts|party|passagens|pay|pccw|pe|pet|pf|pfizer|pg|ph|pharmacy|phd|philips|phone|photo|photography|photos|physio|piaget|pics|pictet|pictures|pid|pin|ping|pink|pioneer|pizza|pk|pl|place|play|playstation|plumbing|plus|pm|pn|pnc|pohl|poker|politie|porn|post|pr|pramerica|praxi|press|prime|pro|prod|productions|prof|progressive|promo|properties|property|protection|pru|prudential|ps|pt|pub|pw|pwc|py|qa|qpon|quebec|quest|qvc|racing|radio|raid|re|read|realestate|realtor|realty|recipes|red|redstone|redumbrella|rehab|reise|reisen|reit|reliance|ren|rent|rentals|repair|report|republican|rest|restaurant|review|reviews|rexroth|rich|richardli|ricoh|rightathome|ril|rio|rip|rmit|ro|rocher|rocks|rodeo|rogers|room|rs|rsvp|ru|rugby|ruhr|run|rw|rwe|ryukyu|sa|saarland|safe|safety|sakura|sale|salon|samsclub|samsung|sandvik|sandvikcoromant|sanofi|sap|sapo|sarl|sas|save|saxo|sb|sbi|sbs|sc|sca|scb|schaeffler|schmidt|scholarships|school|schule|schwarz|science|scjohnson|scor|scot|sd|se|search|seat|secure|security|seek|select|sener|services|ses|seven|sew|sex|sexy|sfr|sg|sh|shangrila|sharp|shaw|shell|shia|shiksha|shoes|shop|shopping|shouji|show|showtime|shriram|si|silk|sina|singles|site|sj|sk|ski|skin|sky|skype|sl|sling|sm|smart|smile|sn|sncf|so|soccer|social|softbank|software|sohu|solar|solutions|song|sony|soy|space|spiegel|spot|spreadbetting|sr|srl|srt|st|stada|staples|star|starhub|statebank|statefarm|statoil|stc|stcgroup|stockholm|storage|store|stream|studio|study|style|su|sucks|supplies|supply|support|surf|surgery|suzuki|sv|swatch|swiftcover|swiss|sx|sy|sydney|symantec|systems|sz|tab|taipei|talk|taobao|target|tatamotors|tatar|tattoo|tax|taxi|tc|tci|td|tdk|team|tech|technology|tel|telecity|telefonica|temasek|tennis|teva|tf|tg|th|thd|theater|theatre|tiaa|tickets|tienda|tiffany|tips|tires|tirol|tj|tjmaxx|tjx|tk|tkmaxx|tl|tm|tmall|tn|to|today|tokyo|tools|top|toray|toshiba|total|tours|town|toyota|toys|tr|trade|trading|training|travel|travelchannel|travelers|travelersinsurance|trust|trv|tt|tube|tui|tunes|tushu|tv|tvs|tw|tz|ua|ubank|ubs|uconnect|ug|uk|unicom|university|uno|uol|ups|us|uy|uz|va|vacations|vana|vanguard|vc|ve|vegas|ventures|verisign|versicherung|vet|vg|vi|viajes|video|vig|viking|villas|vin|vip|virgin|visa|vision|vista|vistaprint|viva|vivo|vlaanderen|vn|vodka|volkswagen|volvo|vote|voting|voto|voyage|vu|vuelos|wales|walmart|walter|wang|wanggou|warman|watch|watches|weather|weatherchannel|webcam|weber|website|wed|wedding|weibo|weir|wf|whoswho|wien|wiki|williamhill|win|windows|wine|winners|wme|wolterskluwer|woodside|work|works|world|wow|ws|wtc|wtf|xbox|xerox|xfinity|xihuan|xin|xn--11b4c3d|xn--1ck2e1b|xn--1qqw23a|xn--2scrj9c|xn--30rr7y|xn--3bst00m|xn--3ds443g|xn--3e0b707e|xn--3hcrj9c|xn--3oq18vl8pn36a|xn--3pxu8k|xn--42c2d9a|xn--45br5cyl|xn--45brj9c|xn--45q11c|xn--4gbrim|xn--54b7fta0cc|xn--55qw42g|xn--55qx5d|xn--5su34j936bgsg|xn--5tzm5g|xn--6frz82g|xn--6qq986b3xl|xn--80adxhks|xn--80ao21a|xn--80aqecdr1a|xn--80asehdb|xn--80aswg|xn--8y0a063a|xn--90a3ac|xn--90ae|xn--90ais|xn--9dbq2a|xn--9et52u|xn--9krt00a|xn--b4w605ferd|xn--bck1b9a5dre4c|xn--c1avg|xn--c2br7g|xn--cck2b3b|xn--cg4bki|xn--clchc0ea0b2g2a9gcd|xn--czr694b|xn--czrs0t|xn--czru2d|xn--d1acj3b|xn--d1alf|xn--e1a4c|xn--eckvdtc9d|xn--efvy88h|xn--estv75g|xn--fct429k|xn--fhbei|xn--fiq228c5hs|xn--fiq64b|xn--fiqs8s|xn--fiqz9s|xn--fjq720a|xn--flw351e|xn--fpcrj9c3d|xn--fzc2c9e2c|xn--fzys8d69uvgm|xn--g2xx48c|xn--gckr3f0f|xn--gecrj9c|xn--gk3at1e|xn--h2breg3eve|xn--h2brj9c|xn--h2brj9c8c|xn--hxt814e|xn--i1b6b1a6a2e|xn--imr513n|xn--io0a7i|xn--j1aef|xn--j1amh|xn--j6w193g|xn--jlq61u9w7b|xn--jvr189m|xn--kcrx77d1x4a|xn--kprw13d|xn--kpry57d|xn--kpu716f|xn--kput3i|xn--l1acc|xn--lgbbat1ad8j|xn--mgb9awbf|xn--mgba3a3ejt|xn--mgba3a4f16a|xn--mgba7c0bbn0a|xn--mgbaakc7dvf|xn--mgbaam7a8h|xn--mgbab2bd|xn--mgbai9azgqp6j|xn--mgbayh7gpa|xn--mgbb9fbpob|xn--mgbbh1a|xn--mgbbh1a71e|xn--mgbc0a9azcg|xn--mgbca7dzdo|xn--mgberp4a5d4ar|xn--mgbgu82a|xn--mgbi4ecexp|xn--mgbpl2fh|xn--mgbt3dhd|xn--mgbtx2b|xn--mgbx4cd0ab|xn--mix891f|xn--mk1bu44c|xn--mxtq1m|xn--ngbc5azd|xn--ngbe9e0a|xn--ngbrx|xn--node|xn--nqv7f|xn--nqv7fs00ema|xn--nyqy26a|xn--o3cw4h|xn--ogbpf8fl|xn--p1acf|xn--p1ai|xn--pbt977c|xn--pgbs0dh|xn--pssy2u|xn--q9jyb4c|xn--qcka1pmc|xn--qxam|xn--rhqv96g|xn--rovu88b|xn--rvc1e0am3e|xn--s9brj9c|xn--ses554g|xn--t60b56a|xn--tckwe|xn--tiq49xqyj|xn--unup4y|xn--vermgensberater-ctb|xn--vermgensberatung-pwb|xn--vhquv|xn--vuq861b|xn--w4r85el8fhu5dnra|xn--w4rs40l|xn--wgbh1c|xn--wgbl6a|xn--xhq521b|xn--xkc2al3hye2a|xn--xkc2dl3a5ee0h|xn--y9a3aq|xn--yfro4i67o|xn--ygbi2ammx|xn--zfr164b|xperia|xxx|xyz|yachts|yahoo|yamaxun|yandex|ye|yodobashi|yoga|yokohama|you|youtube|yt|yun|za|zappos|zara|zero|zip|zippo|zm|zone|zuerich|zw'.split('|'); // macro, see gulpfile.js

/**
	The scanner provides an interface that takes a string of text as input, and
	outputs an array of tokens instances that can be used for easy URL parsing.

	@module linkify
	@submodule scanner
	@main scanner
*/

var NUMBERS = '0123456789'.split('');
var ALPHANUM = '0123456789abcdefghijklmnopqrstuvwxyz'.split('');
var WHITESPACE = [' ', '\f', '\r', '\t', '\v', '\xA0', '\u1680', '\u180E']; // excluding line breaks

var domainStates = []; // states that jump to DOMAIN on /[a-z0-9]/
var makeState$1 = function makeState(tokenClass) {
	return new _state$1.CharacterState(tokenClass);
};

// Frequently used states
var S_START$1 = makeState$1();
var S_NUM = makeState$1(_text$2.NUM);
var S_DOMAIN$1 = makeState$1(_text$2.DOMAIN);
var S_DOMAIN_HYPHEN = makeState$1(); // domain followed by 1 or more hyphen characters
var S_WS = makeState$1(_text$2.WS);

// States for special URL symbols
S_START$1.on('@', makeState$1(_text$2.AT)).on('.', makeState$1(_text$2.DOT)).on('+', makeState$1(_text$2.PLUS)).on('#', makeState$1(_text$2.POUND)).on('?', makeState$1(_text$2.QUERY)).on('/', makeState$1(_text$2.SLASH)).on('_', makeState$1(_text$2.UNDERSCORE)).on(':', makeState$1(_text$2.COLON)).on('{', makeState$1(_text$2.OPENBRACE)).on('[', makeState$1(_text$2.OPENBRACKET)).on('<', makeState$1(_text$2.OPENANGLEBRACKET)).on('(', makeState$1(_text$2.OPENPAREN)).on('}', makeState$1(_text$2.CLOSEBRACE)).on(']', makeState$1(_text$2.CLOSEBRACKET)).on('>', makeState$1(_text$2.CLOSEANGLEBRACKET)).on(')', makeState$1(_text$2.CLOSEPAREN)).on('&', makeState$1(_text$2.AMPERSAND)).on([',', ';', '!', '"', '\''], makeState$1(_text$2.PUNCTUATION));

// Whitespace jumps
// Tokens of only non-newline whitespace are arbitrarily long
S_START$1.on('\n', makeState$1(_text$2.NL)).on(WHITESPACE, S_WS);

// If any whitespace except newline, more whitespace!
S_WS.on(WHITESPACE, S_WS);

// Generates states for top-level domains
// Note that this is most accurate when tlds are in alphabetical order
for (var i$2 = 0; i$2 < tlds.length; i$2++) {
	var newStates = (0, _state$1.stateify)(tlds[i$2], S_START$1, _text$2.TLD, _text$2.DOMAIN);
	domainStates.push.apply(domainStates, newStates);
}

// Collect the states generated by different protocls
var partialProtocolFileStates = (0, _state$1.stateify)('file', S_START$1, _text$2.DOMAIN, _text$2.DOMAIN);
var partialProtocolFtpStates = (0, _state$1.stateify)('ftp', S_START$1, _text$2.DOMAIN, _text$2.DOMAIN);
var partialProtocolHttpStates = (0, _state$1.stateify)('http', S_START$1, _text$2.DOMAIN, _text$2.DOMAIN);
var partialProtocolMailtoStates = (0, _state$1.stateify)('mailto', S_START$1, _text$2.DOMAIN, _text$2.DOMAIN);

// Add the states to the array of DOMAINeric states
domainStates.push.apply(domainStates, partialProtocolFileStates);
domainStates.push.apply(domainStates, partialProtocolFtpStates);
domainStates.push.apply(domainStates, partialProtocolHttpStates);
domainStates.push.apply(domainStates, partialProtocolMailtoStates);

// Protocol states
var S_PROTOCOL_FILE = partialProtocolFileStates.pop();
var S_PROTOCOL_FTP = partialProtocolFtpStates.pop();
var S_PROTOCOL_HTTP = partialProtocolHttpStates.pop();
var S_MAILTO$1 = partialProtocolMailtoStates.pop();
var S_PROTOCOL_SECURE = makeState$1(_text$2.DOMAIN);
var S_FULL_PROTOCOL = makeState$1(_text$2.PROTOCOL); // Full protocol ends with COLON
var S_FULL_MAILTO = makeState$1(_text$2.MAILTO); // Mailto ends with COLON

// Secure protocols (end with 's')
S_PROTOCOL_FTP.on('s', S_PROTOCOL_SECURE).on(':', S_FULL_PROTOCOL);

S_PROTOCOL_HTTP.on('s', S_PROTOCOL_SECURE).on(':', S_FULL_PROTOCOL);

domainStates.push(S_PROTOCOL_SECURE);

// Become protocol tokens after a COLON
S_PROTOCOL_FILE.on(':', S_FULL_PROTOCOL);
S_PROTOCOL_SECURE.on(':', S_FULL_PROTOCOL);
S_MAILTO$1.on(':', S_FULL_MAILTO);

// Localhost
var partialLocalhostStates = (0, _state$1.stateify)('localhost', S_START$1, _text$2.LOCALHOST, _text$2.DOMAIN);
domainStates.push.apply(domainStates, partialLocalhostStates);

// Everything else
// DOMAINs make more DOMAINs
// Number and character transitions
S_START$1.on(NUMBERS, S_NUM);
S_NUM.on('-', S_DOMAIN_HYPHEN).on(NUMBERS, S_NUM).on(ALPHANUM, S_DOMAIN$1); // number becomes DOMAIN

S_DOMAIN$1.on('-', S_DOMAIN_HYPHEN).on(ALPHANUM, S_DOMAIN$1);

// All the generated states should have a jump to DOMAIN
for (var _i = 0; _i < domainStates.length; _i++) {
	domainStates[_i].on('-', S_DOMAIN_HYPHEN).on(ALPHANUM, S_DOMAIN$1);
}

S_DOMAIN_HYPHEN.on('-', S_DOMAIN_HYPHEN).on(NUMBERS, S_DOMAIN$1).on(ALPHANUM, S_DOMAIN$1);

// Set default transition
S_START$1.defaultTransition = makeState$1(_text$2.SYM);

/**
	Given a string, returns an array of TOKEN instances representing the
	composition of that string.

	@method run
	@param {String} str Input string to scan
	@return {Array} Array of TOKEN instances
*/
var run$1 = function run(str) {

	// The state machine only looks at lowercase strings.
	// This selective `toLowerCase` is used because lowercasing the entire
	// string causes the length and character position to vary in some in some
	// non-English strings. This happens only on V8-based runtimes.
	var lowerStr = str.replace(/[A-Z]/g, function (c) {
		return c.toLowerCase();
	});
	var len = str.length;
	var tokens = []; // return value

	var cursor = 0;

	// Tokenize the string
	while (cursor < len) {
		var state = S_START$1;
		var nextState = null;
		var tokenLength = 0;
		var latestAccepting = null;
		var sinceAccepts = -1;

		while (cursor < len && (nextState = state.next(lowerStr[cursor]))) {
			state = nextState;

			// Keep track of the latest accepting state
			if (state.accepts()) {
				sinceAccepts = 0;
				latestAccepting = state;
			} else if (sinceAccepts >= 0) {
				sinceAccepts++;
			}

			tokenLength++;
			cursor++;
		}

		if (sinceAccepts < 0) {
			continue;
		} // Should never happen

		// Roll back to the latest accepting state
		cursor -= sinceAccepts;
		tokenLength -= sinceAccepts;

		// Get the class for the new token
		var TOKEN = latestAccepting.emit(); // Current token class

		// No more jumps, just make a new token
		tokens.push(new TOKEN(str.substr(cursor - tokenLength, tokenLength)));
	}

	return tokens;
};

var start$1 = S_START$1;
scanner$1.State = _state$1.CharacterState;
scanner$1.TOKENS = TOKENS;
scanner$1.run = run$1;
scanner$1.start = start$1;

var parser$1 = {};

var multi = {};

multi.__esModule = true;
multi.URL = multi.TEXT = multi.NL = multi.EMAIL = multi.MAILTOEMAIL = multi.Base = undefined;

var _createTokenClass = createTokenClass$1;

var _class$1 = _class$4;

var _text$1 = text;

/******************************************************************************
	Multi-Tokens
	Tokens composed of arrays of TextTokens
******************************************************************************/

// Is the given token a valid domain token?
// Should nums be included here?
function isDomainToken(token) {
	return token instanceof _text$1.DOMAIN || token instanceof _text$1.TLD;
}

/**
	Abstract class used for manufacturing tokens of text tokens. That is rather
	than the value for a token being a small string of text, it's value an array
	of text tokens.

	Used for grouping together URLs, emails, hashtags, and other potential
	creations.

	@class MultiToken
	@abstract
*/
var MultiToken = (0, _createTokenClass.createTokenClass)();

MultiToken.prototype = {
	/**
 	String representing the type for this token
 	@property type
 	@default 'TOKEN'
 */
	type: 'token',

	/**
 	Is this multitoken a link?
 	@property isLink
 	@default false
 */
	isLink: false,

	/**
 	Return the string this token represents.
 	@method toString
 	@return {String}
 */
	toString: function toString() {
		var result = [];
		for (var i = 0; i < this.v.length; i++) {
			result.push(this.v[i].toString());
		}
		return result.join('');
	},


	/**
 	What should the value for this token be in the `href` HTML attribute?
 	Returns the `.toString` value by default.
 		@method toHref
 	@return {String}
 */
	toHref: function toHref() {
		return this.toString();
	},


	/**
 	Returns a hash of relevant values for this token, which includes keys
 	* type - Kind of token ('url', 'email', etc.)
 	* value - Original text
 	* href - The value that should be added to the anchor tag's href
 		attribute
 		@method toObject
 	@param {String} [protocol] `'http'` by default
 	@return {Object}
 */
	toObject: function toObject() {
		var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'http';

		return {
			type: this.type,
			value: this.toString(),
			href: this.toHref(protocol)
		};
	}
};

/**
	Represents an arbitrarily mailto email address with the prefix included
	@class MAILTO
	@extends MultiToken
*/
var MAILTOEMAIL = (0, _class$1.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), {
	type: 'email',
	isLink: true
});

/**
	Represents a list of tokens making up a valid email address
	@class EMAIL
	@extends MultiToken
*/
var EMAIL = (0, _class$1.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), {
	type: 'email',
	isLink: true,
	toHref: function toHref() {
		return 'mailto:' + this.toString();
	}
});

/**
	Represents some plain text
	@class TEXT
	@extends MultiToken
*/
var TEXT = (0, _class$1.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), { type: 'text' });

/**
	Multi-linebreak token - represents a line break
	@class NL
	@extends MultiToken
*/
var NL = (0, _class$1.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), { type: 'nl' });

/**
	Represents a list of tokens making up a valid URL
	@class URL
	@extends MultiToken
*/
var URL$1 = (0, _class$1.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), {
	type: 'url',
	isLink: true,

	/**
 	Lowercases relevant parts of the domain and adds the protocol if
 	required. Note that this will not escape unsafe HTML characters in the
 	URL.
 		@method href
 	@param {String} protocol
 	@return {String}
 */
	toHref: function toHref() {
		var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'http';

		var hasProtocol = false;
		var hasSlashSlash = false;
		var tokens = this.v;
		var result = [];
		var i = 0;

		// Make the first part of the domain lowercase
		// Lowercase protocol
		while (tokens[i] instanceof _text$1.PROTOCOL) {
			hasProtocol = true;
			result.push(tokens[i].toString().toLowerCase());
			i++;
		}

		// Skip slash-slash
		while (tokens[i] instanceof _text$1.SLASH) {
			hasSlashSlash = true;
			result.push(tokens[i].toString());
			i++;
		}

		// Lowercase all other characters in the domain
		while (isDomainToken(tokens[i])) {
			result.push(tokens[i].toString().toLowerCase());
			i++;
		}

		// Leave all other characters as they were written
		for (; i < tokens.length; i++) {
			result.push(tokens[i].toString());
		}

		result = result.join('');

		if (!(hasProtocol || hasSlashSlash)) {
			result = protocol + '://' + result;
		}

		return result;
	},
	hasProtocol: function hasProtocol() {
		return this.v[0] instanceof _text$1.PROTOCOL;
	}
});

multi.Base = MultiToken;
multi.MAILTOEMAIL = MAILTOEMAIL;
multi.EMAIL = EMAIL;
multi.NL = NL;
multi.TEXT = TEXT;
multi.URL = URL$1;

parser$1.__esModule = true;
parser$1.start = parser$1.run = parser$1.TOKENS = parser$1.State = undefined;

var _state = state$1;

var _multi = multi;

var MULTI_TOKENS = _interopRequireWildcard$3(_multi);

var _text = text;

function _interopRequireWildcard$3(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
	Not exactly parser, more like the second-stage scanner (although we can
	theoretically hotswap the code here with a real parser in the future... but
	for a little URL-finding utility abstract syntax trees may be a little
	overkill).

	URL format: http://en.wikipedia.org/wiki/URI_scheme
	Email format: http://en.wikipedia.org/wiki/Email_address (links to RFC in
	reference)

	@module linkify
	@submodule parser
	@main parser
*/

var makeState = function makeState(tokenClass) {
	return new _state.TokenState(tokenClass);
};

// The universal starting state.
var S_START = makeState();

// Intermediate states for URLs. Note that domains that begin with a protocol
// are treated slighly differently from those that don't.
var S_PROTOCOL = makeState(); // e.g., 'http:'
var S_MAILTO = makeState(); // 'mailto:'
var S_PROTOCOL_SLASH = makeState(); // e.g., '/', 'http:/''
var S_PROTOCOL_SLASH_SLASH = makeState(); // e.g., '//', 'http://'
var S_DOMAIN = makeState(); // parsed string ends with a potential domain name (A)
var S_DOMAIN_DOT = makeState(); // (A) domain followed by DOT
var S_TLD = makeState(_multi.URL); // (A) Simplest possible URL with no query string
var S_TLD_COLON = makeState(); // (A) URL followed by colon (potential port number here)
var S_TLD_PORT = makeState(_multi.URL); // TLD followed by a port number
var S_URL = makeState(_multi.URL); // Long URL with optional port and maybe query string
var S_URL_NON_ACCEPTING = makeState(); // URL followed by some symbols (will not be part of the final URL)
var S_URL_OPENBRACE = makeState(); // URL followed by {
var S_URL_OPENBRACKET = makeState(); // URL followed by [
var S_URL_OPENANGLEBRACKET = makeState(); // URL followed by <
var S_URL_OPENPAREN = makeState(); // URL followed by (
var S_URL_OPENBRACE_Q = makeState(_multi.URL); // URL followed by { and some symbols that the URL can end it
var S_URL_OPENBRACKET_Q = makeState(_multi.URL); // URL followed by [ and some symbols that the URL can end it
var S_URL_OPENANGLEBRACKET_Q = makeState(_multi.URL); // URL followed by < and some symbols that the URL can end it
var S_URL_OPENPAREN_Q = makeState(_multi.URL); // URL followed by ( and some symbols that the URL can end it
var S_URL_OPENBRACE_SYMS = makeState(); // S_URL_OPENBRACE_Q followed by some symbols it cannot end it
var S_URL_OPENBRACKET_SYMS = makeState(); // S_URL_OPENBRACKET_Q followed by some symbols it cannot end it
var S_URL_OPENANGLEBRACKET_SYMS = makeState(); // S_URL_OPENANGLEBRACKET_Q followed by some symbols it cannot end it
var S_URL_OPENPAREN_SYMS = makeState(); // S_URL_OPENPAREN_Q followed by some symbols it cannot end it
var S_EMAIL_DOMAIN = makeState(); // parsed string starts with local email info + @ with a potential domain name (C)
var S_EMAIL_DOMAIN_DOT = makeState(); // (C) domain followed by DOT
var S_EMAIL = makeState(_multi.EMAIL); // (C) Possible email address (could have more tlds)
var S_EMAIL_COLON = makeState(); // (C) URL followed by colon (potential port number here)
var S_EMAIL_PORT = makeState(_multi.EMAIL); // (C) Email address with a port
var S_MAILTO_EMAIL = makeState(_multi.MAILTOEMAIL); // Email that begins with the mailto prefix (D)
var S_MAILTO_EMAIL_NON_ACCEPTING = makeState(); // (D) Followed by some non-query string chars
var S_LOCALPART = makeState(); // Local part of the email address
var S_LOCALPART_AT = makeState(); // Local part of the email address plus @
var S_LOCALPART_DOT = makeState(); // Local part of the email address plus '.' (localpart cannot end in .)
var S_NL = makeState(_multi.NL); // single new line

// Make path from start to protocol (with '//')
S_START.on(_text.NL, S_NL).on(_text.PROTOCOL, S_PROTOCOL).on(_text.MAILTO, S_MAILTO).on(_text.SLASH, S_PROTOCOL_SLASH);

S_PROTOCOL.on(_text.SLASH, S_PROTOCOL_SLASH);
S_PROTOCOL_SLASH.on(_text.SLASH, S_PROTOCOL_SLASH_SLASH);

// The very first potential domain name
S_START.on(_text.TLD, S_DOMAIN).on(_text.DOMAIN, S_DOMAIN).on(_text.LOCALHOST, S_TLD).on(_text.NUM, S_DOMAIN);

// Force URL for protocol followed by anything sane
S_PROTOCOL_SLASH_SLASH.on(_text.TLD, S_URL).on(_text.DOMAIN, S_URL).on(_text.NUM, S_URL).on(_text.LOCALHOST, S_URL);

// Account for dots and hyphens
// hyphens are usually parts of domain names
S_DOMAIN.on(_text.DOT, S_DOMAIN_DOT);
S_EMAIL_DOMAIN.on(_text.DOT, S_EMAIL_DOMAIN_DOT);

// Hyphen can jump back to a domain name

// After the first domain and a dot, we can find either a URL or another domain
S_DOMAIN_DOT.on(_text.TLD, S_TLD).on(_text.DOMAIN, S_DOMAIN).on(_text.NUM, S_DOMAIN).on(_text.LOCALHOST, S_DOMAIN);

S_EMAIL_DOMAIN_DOT.on(_text.TLD, S_EMAIL).on(_text.DOMAIN, S_EMAIL_DOMAIN).on(_text.NUM, S_EMAIL_DOMAIN).on(_text.LOCALHOST, S_EMAIL_DOMAIN);

// S_TLD accepts! But the URL could be longer, try to find a match greedily
// The `run` function should be able to "rollback" to the accepting state
S_TLD.on(_text.DOT, S_DOMAIN_DOT);
S_EMAIL.on(_text.DOT, S_EMAIL_DOMAIN_DOT);

// Become real URLs after `SLASH` or `COLON NUM SLASH`
// Here PSS and non-PSS converge
S_TLD.on(_text.COLON, S_TLD_COLON).on(_text.SLASH, S_URL);
S_TLD_COLON.on(_text.NUM, S_TLD_PORT);
S_TLD_PORT.on(_text.SLASH, S_URL);
S_EMAIL.on(_text.COLON, S_EMAIL_COLON);
S_EMAIL_COLON.on(_text.NUM, S_EMAIL_PORT);

// Types of characters the URL can definitely end in
var qsAccepting = [_text.DOMAIN, _text.AT, _text.LOCALHOST, _text.NUM, _text.PLUS, _text.POUND, _text.PROTOCOL, _text.SLASH, _text.TLD, _text.UNDERSCORE, _text.SYM, _text.AMPERSAND];

// Types of tokens that can follow a URL and be part of the query string
// but cannot be the very last characters
// Characters that cannot appear in the URL at all should be excluded
var qsNonAccepting = [_text.COLON, _text.DOT, _text.QUERY, _text.PUNCTUATION, _text.CLOSEBRACE, _text.CLOSEBRACKET, _text.CLOSEANGLEBRACKET, _text.CLOSEPAREN, _text.OPENBRACE, _text.OPENBRACKET, _text.OPENANGLEBRACKET, _text.OPENPAREN];

// These states are responsible primarily for determining whether or not to
// include the final round bracket.

// URL, followed by an opening bracket
S_URL.on(_text.OPENBRACE, S_URL_OPENBRACE).on(_text.OPENBRACKET, S_URL_OPENBRACKET).on(_text.OPENANGLEBRACKET, S_URL_OPENANGLEBRACKET).on(_text.OPENPAREN, S_URL_OPENPAREN);

// URL with extra symbols at the end, followed by an opening bracket
S_URL_NON_ACCEPTING.on(_text.OPENBRACE, S_URL_OPENBRACE).on(_text.OPENBRACKET, S_URL_OPENBRACKET).on(_text.OPENANGLEBRACKET, S_URL_OPENANGLEBRACKET).on(_text.OPENPAREN, S_URL_OPENPAREN);

// Closing bracket component. This character WILL be included in the URL
S_URL_OPENBRACE.on(_text.CLOSEBRACE, S_URL);
S_URL_OPENBRACKET.on(_text.CLOSEBRACKET, S_URL);
S_URL_OPENANGLEBRACKET.on(_text.CLOSEANGLEBRACKET, S_URL);
S_URL_OPENPAREN.on(_text.CLOSEPAREN, S_URL);
S_URL_OPENBRACE_Q.on(_text.CLOSEBRACE, S_URL);
S_URL_OPENBRACKET_Q.on(_text.CLOSEBRACKET, S_URL);
S_URL_OPENANGLEBRACKET_Q.on(_text.CLOSEANGLEBRACKET, S_URL);
S_URL_OPENPAREN_Q.on(_text.CLOSEPAREN, S_URL);
S_URL_OPENBRACE_SYMS.on(_text.CLOSEBRACE, S_URL);
S_URL_OPENBRACKET_SYMS.on(_text.CLOSEBRACKET, S_URL);
S_URL_OPENANGLEBRACKET_SYMS.on(_text.CLOSEANGLEBRACKET, S_URL);
S_URL_OPENPAREN_SYMS.on(_text.CLOSEPAREN, S_URL);

// URL that beings with an opening bracket, followed by a symbols.
// Note that the final state can still be `S_URL_OPENBRACE_Q` (if the URL only
// has a single opening bracket for some reason).
S_URL_OPENBRACE.on(qsAccepting, S_URL_OPENBRACE_Q);
S_URL_OPENBRACKET.on(qsAccepting, S_URL_OPENBRACKET_Q);
S_URL_OPENANGLEBRACKET.on(qsAccepting, S_URL_OPENANGLEBRACKET_Q);
S_URL_OPENPAREN.on(qsAccepting, S_URL_OPENPAREN_Q);
S_URL_OPENBRACE.on(qsNonAccepting, S_URL_OPENBRACE_SYMS);
S_URL_OPENBRACKET.on(qsNonAccepting, S_URL_OPENBRACKET_SYMS);
S_URL_OPENANGLEBRACKET.on(qsNonAccepting, S_URL_OPENANGLEBRACKET_SYMS);
S_URL_OPENPAREN.on(qsNonAccepting, S_URL_OPENPAREN_SYMS);

// URL that begins with an opening bracket, followed by some symbols
S_URL_OPENBRACE_Q.on(qsAccepting, S_URL_OPENBRACE_Q);
S_URL_OPENBRACKET_Q.on(qsAccepting, S_URL_OPENBRACKET_Q);
S_URL_OPENANGLEBRACKET_Q.on(qsAccepting, S_URL_OPENANGLEBRACKET_Q);
S_URL_OPENPAREN_Q.on(qsAccepting, S_URL_OPENPAREN_Q);
S_URL_OPENBRACE_Q.on(qsNonAccepting, S_URL_OPENBRACE_Q);
S_URL_OPENBRACKET_Q.on(qsNonAccepting, S_URL_OPENBRACKET_Q);
S_URL_OPENANGLEBRACKET_Q.on(qsNonAccepting, S_URL_OPENANGLEBRACKET_Q);
S_URL_OPENPAREN_Q.on(qsNonAccepting, S_URL_OPENPAREN_Q);

S_URL_OPENBRACE_SYMS.on(qsAccepting, S_URL_OPENBRACE_Q);
S_URL_OPENBRACKET_SYMS.on(qsAccepting, S_URL_OPENBRACKET_Q);
S_URL_OPENANGLEBRACKET_SYMS.on(qsAccepting, S_URL_OPENANGLEBRACKET_Q);
S_URL_OPENPAREN_SYMS.on(qsAccepting, S_URL_OPENPAREN_Q);
S_URL_OPENBRACE_SYMS.on(qsNonAccepting, S_URL_OPENBRACE_SYMS);
S_URL_OPENBRACKET_SYMS.on(qsNonAccepting, S_URL_OPENBRACKET_SYMS);
S_URL_OPENANGLEBRACKET_SYMS.on(qsNonAccepting, S_URL_OPENANGLEBRACKET_SYMS);
S_URL_OPENPAREN_SYMS.on(qsNonAccepting, S_URL_OPENPAREN_SYMS);

// Account for the query string
S_URL.on(qsAccepting, S_URL);
S_URL_NON_ACCEPTING.on(qsAccepting, S_URL);

S_URL.on(qsNonAccepting, S_URL_NON_ACCEPTING);
S_URL_NON_ACCEPTING.on(qsNonAccepting, S_URL_NON_ACCEPTING);

// Email address-specific state definitions
// Note: We are not allowing '/' in email addresses since this would interfere
// with real URLs

// For addresses with the mailto prefix
// 'mailto:' followed by anything sane is a valid email
S_MAILTO.on(_text.TLD, S_MAILTO_EMAIL).on(_text.DOMAIN, S_MAILTO_EMAIL).on(_text.NUM, S_MAILTO_EMAIL).on(_text.LOCALHOST, S_MAILTO_EMAIL);

// Greedily get more potential valid email values
S_MAILTO_EMAIL.on(qsAccepting, S_MAILTO_EMAIL).on(qsNonAccepting, S_MAILTO_EMAIL_NON_ACCEPTING);
S_MAILTO_EMAIL_NON_ACCEPTING.on(qsAccepting, S_MAILTO_EMAIL).on(qsNonAccepting, S_MAILTO_EMAIL_NON_ACCEPTING);

// For addresses without the mailto prefix
// Tokens allowed in the localpart of the email
var localpartAccepting = [_text.DOMAIN, _text.NUM, _text.PLUS, _text.POUND, _text.QUERY, _text.UNDERSCORE, _text.SYM, _text.AMPERSAND, _text.TLD];

// Some of the tokens in `localpartAccepting` are already accounted for here and
// will not be overwritten (don't worry)
S_DOMAIN.on(localpartAccepting, S_LOCALPART).on(_text.AT, S_LOCALPART_AT);
S_TLD.on(localpartAccepting, S_LOCALPART).on(_text.AT, S_LOCALPART_AT);
S_DOMAIN_DOT.on(localpartAccepting, S_LOCALPART);

// Okay we're on a localpart. Now what?
// TODO: IP addresses and what if the email starts with numbers?
S_LOCALPART.on(localpartAccepting, S_LOCALPART).on(_text.AT, S_LOCALPART_AT) // close to an email address now
.on(_text.DOT, S_LOCALPART_DOT);
S_LOCALPART_DOT.on(localpartAccepting, S_LOCALPART);
S_LOCALPART_AT.on(_text.TLD, S_EMAIL_DOMAIN).on(_text.DOMAIN, S_EMAIL_DOMAIN).on(_text.LOCALHOST, S_EMAIL);
// States following `@` defined above

var run = function run(tokens) {
	var len = tokens.length;
	var cursor = 0;
	var multis = [];
	var textTokens = [];

	while (cursor < len) {
		var state = S_START;
		var secondState = null;
		var nextState = null;
		var multiLength = 0;
		var latestAccepting = null;
		var sinceAccepts = -1;

		while (cursor < len && !(secondState = state.next(tokens[cursor]))) {
			// Starting tokens with nowhere to jump to.
			// Consider these to be just plain text
			textTokens.push(tokens[cursor++]);
		}

		while (cursor < len && (nextState = secondState || state.next(tokens[cursor]))) {

			// Get the next state
			secondState = null;
			state = nextState;

			// Keep track of the latest accepting state
			if (state.accepts()) {
				sinceAccepts = 0;
				latestAccepting = state;
			} else if (sinceAccepts >= 0) {
				sinceAccepts++;
			}

			cursor++;
			multiLength++;
		}

		if (sinceAccepts < 0) {

			// No accepting state was found, part of a regular text token
			// Add all the tokens we looked at to the text tokens array
			for (var i = cursor - multiLength; i < cursor; i++) {
				textTokens.push(tokens[i]);
			}
		} else {

			// Accepting state!

			// First close off the textTokens (if available)
			if (textTokens.length > 0) {
				multis.push(new _multi.TEXT(textTokens));
				textTokens = [];
			}

			// Roll back to the latest accepting state
			cursor -= sinceAccepts;
			multiLength -= sinceAccepts;

			// Create a new multitoken
			var MULTI = latestAccepting.emit();
			multis.push(new MULTI(tokens.slice(cursor - multiLength, cursor)));
		}
	}

	// Finally close off the textTokens (if available)
	if (textTokens.length > 0) {
		multis.push(new _multi.TEXT(textTokens));
	}

	return multis;
};

parser$1.State = _state.TokenState;
parser$1.TOKENS = MULTI_TOKENS;
parser$1.run = run;
parser$1.start = S_START;

linkify$2.__esModule = true;
linkify$2.tokenize = linkify$2.test = linkify$2.scanner = linkify$2.parser = linkify$2.options = linkify$2.inherits = linkify$2.find = undefined;

var _class = _class$4;

var _options = options$3;

var options$2 = _interopRequireWildcard$2(_options);

var _scanner = scanner$1;

var scanner = _interopRequireWildcard$2(_scanner);

var _parser = parser$1;

var parser = _interopRequireWildcard$2(_parser);

function _interopRequireWildcard$2(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

if (!Array.isArray) {
	Array.isArray = function (arg) {
		return Object.prototype.toString.call(arg) === '[object Array]';
	};
}

/**
	Converts a string into tokens that represent linkable and non-linkable bits
	@method tokenize
	@param {String} str
	@return {Array} tokens
*/
var tokenize = function tokenize(str) {
	return parser.run(scanner.run(str));
};

/**
	Returns a list of linkable items in the given string.
*/
var find = function find(str) {
	var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var tokens = tokenize(str);
	var filtered = [];

	for (var i = 0; i < tokens.length; i++) {
		var token = tokens[i];
		if (token.isLink && (!type || token.type === type)) {
			filtered.push(token.toObject());
		}
	}

	return filtered;
};

/**
	Is the given string valid linkable text of some sort
	Note that this does not trim the text for you.

	Optionally pass in a second `type` param, which is the type of link to test
	for.

	For example,

		test(str, 'email');

	Will return `true` if str is a valid email.
*/
var test$1 = function test(str) {
	var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var tokens = tokenize(str);
	return tokens.length === 1 && tokens[0].isLink && (!type || tokens[0].type === type);
};

// Scanner and parser provide states and tokens for the lexicographic stage
// (will be used to add additional link types)
linkify$2.find = find;
linkify$2.inherits = _class.inherits;
linkify$2.options = options$2;
linkify$2.parser = parser;
linkify$2.scanner = scanner;
linkify$2.test = test$1;
linkify$2.tokenize = tokenize;

linkifyHtml$1.__esModule = true;
linkifyHtml$1.default = linkifyHtml;

var _simpleHtmlTokenizer = simpleHtmlTokenizer;

var _simpleHtmlTokenizer2 = _interopRequireDefault$1(_simpleHtmlTokenizer);

var _linkify$1 = linkify$2;

var linkify$1 = _interopRequireWildcard$1(_linkify$1);

function _interopRequireWildcard$1(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var options$1 = linkify$1.options;
var Options$1 = options$1.Options;


var StartTag = 'StartTag';
var EndTag = 'EndTag';
var Chars = 'Chars';
var Comment = 'Comment';

/**
	`tokens` and `token` in this section refer to tokens generated by the HTML
	parser.
*/
function linkifyHtml(str) {
	var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	var tokens = _simpleHtmlTokenizer2.default.tokenize(str);
	var linkifiedTokens = [];
	var linkified = [];
	var i;

	opts = new Options$1(opts);

	// Linkify the tokens given by the parser
	for (i = 0; i < tokens.length; i++) {
		var token = tokens[i];

		if (token.type === StartTag) {
			linkifiedTokens.push(token);

			// Ignore all the contents of ignored tags
			var tagName = token.tagName.toUpperCase();
			var isIgnored = tagName === 'A' || options$1.contains(opts.ignoreTags, tagName);
			if (!isIgnored) {
				continue;
			}

			var preskipLen = linkifiedTokens.length;
			skipTagTokens(tagName, tokens, ++i, linkifiedTokens);
			i += linkifiedTokens.length - preskipLen - 1;
			continue;
		} else if (token.type !== Chars) {
			// Skip this token, it's not important
			linkifiedTokens.push(token);
			continue;
		}

		// Valid text token, linkify it!
		var linkifedChars = linkifyChars(token.chars, opts);
		linkifiedTokens.push.apply(linkifiedTokens, linkifedChars);
	}

	// Convert the tokens back into a string
	for (i = 0; i < linkifiedTokens.length; i++) {
		var _token = linkifiedTokens[i];
		switch (_token.type) {
			case StartTag:
				{
					var link = '<' + _token.tagName;
					if (_token.attributes.length > 0) {
						var attrs = attrsToStrings(_token.attributes);
						link += ' ' + attrs.join(' ');
					}
					link += '>';
					linkified.push(link);
					break;
				}
			case EndTag:
				linkified.push('</' + _token.tagName + '>');
				break;
			case Chars:
				linkified.push(escapeText(_token.chars));
				break;
			case Comment:
				linkified.push('<!--' + escapeText(_token.chars) + '-->');
				break;
		}
	}

	return linkified.join('');
}

/**
	`tokens` and `token` in this section referes to tokens returned by
	`linkify.tokenize`. `linkified` will contain HTML Parser-style tokens
*/
function linkifyChars(str, opts) {
	var tokens = linkify$1.tokenize(str);
	var result = [];

	for (var i = 0; i < tokens.length; i++) {
		var token = tokens[i];

		if (token.type === 'nl' && opts.nl2br) {
			result.push({
				type: StartTag,
				tagName: 'br',
				attributes: [],
				selfClosing: true
			});
			continue;
		} else if (!token.isLink || !opts.check(token)) {
			result.push({ type: Chars, chars: token.toString() });
			continue;
		}

		var _opts$resolve = opts.resolve(token),
		    formatted = _opts$resolve.formatted,
		    formattedHref = _opts$resolve.formattedHref,
		    tagName = _opts$resolve.tagName,
		    className = _opts$resolve.className,
		    target = _opts$resolve.target,
		    attributes = _opts$resolve.attributes;

		// Build up attributes


		var attributeArray = [['href', formattedHref]];

		if (className) {
			attributeArray.push(['class', className]);
		}

		if (target) {
			attributeArray.push(['target', target]);
		}

		for (var attr in attributes) {
			attributeArray.push([attr, attributes[attr]]);
		}

		// Add the required tokens
		result.push({
			type: StartTag,
			tagName: tagName,
			attributes: attributeArray,
			selfClosing: false
		});
		result.push({ type: Chars, chars: formatted });
		result.push({ type: EndTag, tagName: tagName });
	}

	return result;
}

/**
	Returns a list of tokens skipped until the closing tag of tagName.

	* `tagName` is the closing tag which will prompt us to stop skipping
	* `tokens` is the array of tokens generated by HTML5Tokenizer which
	* `i` is the index immediately after the opening tag to skip
	* `skippedTokens` is an array which skipped tokens are being pushed into

	Caveats

	* Assumes that i is the first token after the given opening tagName
	* The closing tag will be skipped, but nothing after it
	* Will track whether there is a nested tag of the same type
*/
function skipTagTokens(tagName, tokens, i, skippedTokens) {

	// number of tokens of this type on the [fictional] stack
	var stackCount = 1;

	while (i < tokens.length && stackCount > 0) {
		var token = tokens[i];

		if (token.type === StartTag && token.tagName.toUpperCase() === tagName) {
			// Nested tag of the same type, "add to stack"
			stackCount++;
		} else if (token.type === EndTag && token.tagName.toUpperCase() === tagName) {
			// Closing tag
			stackCount--;
		}

		skippedTokens.push(token);
		i++;
	}

	// Note that if stackCount > 0 here, the HTML is probably invalid
	return skippedTokens;
}

function escapeText(text) {
	// Not required, HTML tokenizer ensures this occurs properly
	return text;
}

function escapeAttr(attr) {
	return attr.replace(/"/g, '&quot;');
}

function attrsToStrings(attrs) {
	var attrStrs = [];
	for (var i = 0; i < attrs.length; i++) {
		var _attrs$i = attrs[i],
		    name = _attrs$i[0],
		    value = _attrs$i[1];

		attrStrs.push(name + '="' + escapeAttr(value) + '"');
	}
	return attrStrs;
}

var html = linkifyHtml$1.default;

var formatMessage = {};

var stringUtils = {};

(function (exports) {
// Taken from the source of chrome devtools:
// https://github.com/ChromeDevTools/devtools-frontend/blob/master/front_end/platform/utilities.js#L805-L1006
exports.__esModule = true;
exports.String = void 0;
(function (String) {
    /**
     * @param {string} string
     * @param {number} index
     * @return {boolean}
     */
    function isDigitAt(string, index) {
        var c = string.charCodeAt(index);
        return 48 <= c && c <= 57;
    }
    /**
     * @param {string} format
     * @param {!Object.<string, function(string, ...):*>} formatters
     * @return {!Array.<!Object>}
     */
    function tokenizeFormatString(format, formatters) {
        var tokens = [];
        var substitutionIndex = 0;
        function addStringToken(str) {
            if (tokens.length && tokens[tokens.length - 1].type === 'string')
                tokens[tokens.length - 1].value += str;
            else
                tokens.push({ type: 'string', value: str });
        }
        function addSpecifierToken(specifier, precision, substitutionIndex) {
            tokens.push({
                type: 'specifier',
                specifier: specifier,
                precision: precision,
                substitutionIndex: substitutionIndex
            });
        }
        var index = 0;
        for (var precentIndex = format.indexOf('%', index); precentIndex !== -1; precentIndex = format.indexOf('%', index)) {
            if (format.length === index)
                // unescaped % sign at the end of the format string.
                break;
            addStringToken(format.substring(index, precentIndex));
            index = precentIndex + 1;
            if (format[index] === '%') {
                // %% escape sequence.
                addStringToken('%');
                ++index;
                continue;
            }
            if (isDigitAt(format, index)) {
                // The first character is a number, it might be a substitution index.
                var number = parseInt(format.substring(index), 10);
                while (isDigitAt(format, index))
                    ++index;
                // If the number is greater than zero and ends with a "$",
                // then this is a substitution index.
                if (number > 0 && format[index] === '$') {
                    substitutionIndex = number - 1;
                    ++index;
                }
            }
            var precision = -1;
            if (format[index] === '.') {
                // This is a precision specifier. If no digit follows the ".",
                // then the precision should be zero.
                ++index;
                precision = parseInt(format.substring(index), 10);
                if (isNaN(precision))
                    precision = 0;
                while (isDigitAt(format, index))
                    ++index;
            }
            if (!(format[index] in formatters)) {
                addStringToken(format.substring(precentIndex, index + 1));
                ++index;
                continue;
            }
            addSpecifierToken(format[index], precision, substitutionIndex);
            ++substitutionIndex;
            ++index;
        }
        addStringToken(format.substring(index));
        return tokens;
    }
    /**
     * @param {string} format
     * @param {?ArrayLike} substitutions
     * @param {!Object.<string, function(string, ...):Q>} formatters
     * @param {!T} initialValue
     * @param {function(T, Q): T|undefined} append
     * @param {!Array.<!Object>=} tokenizedFormat
     * @return {!{formattedResult: T, unusedSubstitutions: ?ArrayLike}};
     * @template T, Q
     */
    function format(format, substitutions, formatters, initialValue, append, tokenizedFormat) {
        if (!format || !substitutions || !substitutions.length)
            return {
                formattedResult: append(initialValue, format),
                unusedSubstitutions: substitutions
            };
        function prettyFunctionName() {
            return ('String.format("' +
                format +
                '", "' +
                Array.prototype.join.call(substitutions, '", "') +
                '")');
        }
        function warn(msg) {
            console.warn(prettyFunctionName() + ': ' + msg);
        }
        function error(msg) {
            console.error(prettyFunctionName() + ': ' + msg);
        }
        var result = initialValue;
        var tokens = tokenizedFormat || tokenizeFormatString(format, formatters);
        var usedSubstitutionIndexes = {};
        for (var i = 0; i < tokens.length; ++i) {
            var token = tokens[i];
            if (token.type === 'string') {
                result = append(result, token.value);
                continue;
            }
            if (token.type !== 'specifier') {
                error('Unknown token type "' + token.type + '" found.');
                continue;
            }
            if (token.substitutionIndex >= substitutions.length) {
                // If there are not enough substitutions for the current substitutionIndex
                // just output the format specifier literally and move on.
                error('not enough substitution arguments. Had ' +
                    substitutions.length +
                    ' but needed ' +
                    (token.substitutionIndex + 1) +
                    ', so substitution was skipped.');
                result = append(result, '%' + (token.precision > -1 ? token.precision : '') + token.specifier);
                continue;
            }
            usedSubstitutionIndexes[token.substitutionIndex] = true;
            if (!(token.specifier in formatters)) {
                // Encountered an unsupported format character, treat as a string.
                warn('unsupported format character \u201C' +
                    token.specifier +
                    '\u201D. Treating as a string.');
                result = append(result, substitutions[token.substitutionIndex]);
                continue;
            }
            result = append(result, formatters[token.specifier](substitutions[token.substitutionIndex], token));
        }
        var unusedSubstitutions = [];
        for (var i = 0; i < substitutions.length; ++i) {
            if (i in usedSubstitutionIndexes)
                continue;
            unusedSubstitutions.push(substitutions[i]);
        }
        return { formattedResult: result, unusedSubstitutions: unusedSubstitutions };
    }
    String.format = format;
})(exports.String || (exports.String = {}));
//# sourceMappingURL=data:application/json;base64,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
}(stringUtils));

(function (exports) {
exports.__esModule = true;
var string_utils_1 = stringUtils;
function createAppend(s) {
    var container = document.createDocumentFragment();
    container.appendChild(document.createTextNode(s));
    return container;
}
/**
 * @param {string} format
 * @param {!Array.<!SDK.RemoteObject>} parameters
 * @param {!Element} formattedResult
 */
function formatWithSubstitutionString(format, parameters, formattedResult) {
    var formatters = {};
    function stringFormatter(obj) {
        if (typeof obj !== 'string') {
            return '';
        }
        return String(obj);
    }
    function floatFormatter(obj) {
        if (typeof obj !== 'number')
            return 'NaN';
        return obj;
    }
    function integerFormatter(obj) {
        if (typeof obj !== 'number')
            return 'NaN';
        return Math.floor(obj);
    }
    var currentStyle = null;
    function styleFormatter(obj) {
        currentStyle = {};
        var buffer = document.createElement('span');
        buffer.setAttribute('style', obj);
        for (var i = 0; i < buffer.style.length; i++) {
            var property = buffer.style[i];
            if (isWhitelistedProperty(property))
                currentStyle[property] = buffer.style[property];
        }
    }
    function isWhitelistedProperty(property) {
        var prefixes = [
            'background',
            'border',
            'color',
            'font',
            'line',
            'margin',
            'padding',
            'text',
            '-webkit-background',
            '-webkit-border',
            '-webkit-font',
            '-webkit-margin',
            '-webkit-padding',
            '-webkit-text'
        ];
        for (var i = 0; i < prefixes.length; i++) {
            if (property.startsWith(prefixes[i]))
                return true;
        }
        return false;
    }
    formatters.s = stringFormatter;
    formatters.f = floatFormatter;
    // Firebug allows both %i and %d for formatting integers.
    formatters.i = integerFormatter;
    formatters.d = integerFormatter;
    // Firebug uses %c for styling the message.
    formatters.c = styleFormatter;
    function append(a, b) {
        if (b instanceof Node) {
            a.appendChild(b);
        }
        else if (typeof b !== 'undefined') {
            var toAppend = createAppend(String(b));
            if (currentStyle) {
                var wrapper = document.createElement('span');
                wrapper.appendChild(toAppend);
                applyCurrentStyle(wrapper);
                for (var i = 0; i < wrapper.children.length; ++i)
                    applyCurrentStyle(wrapper.children[i]);
                toAppend = wrapper;
            }
            a.appendChild(toAppend);
        }
        return a;
    }
    /**
     * @param {!Element} element
     */
    function applyCurrentStyle(element) {
        for (var key in currentStyle)
            element.style[key] = currentStyle[key];
    }
    // String.format does treat formattedResult like a Builder, result is an object.
    return string_utils_1.String.format(format, parameters, formatters, formattedResult, append);
}
exports["default"] = formatWithSubstitutionString;
//# sourceMappingURL=data:application/json;base64,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
}(formatMessage));

(function (exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var html_1 = __importDefault(html);
var format_message_1 = __importDefault(formatMessage);
/**
 * Formats a console log message using the Devtools parser and returns HTML
 * @param args The arguments passed to the console method
 */
function formatMessage$1(args) {
    var formattedResult = document.createElement('span');
    format_message_1["default"](args[0], args.slice(1), formattedResult);
    return html_1["default"](formattedResult.outerHTML.replace(/(?:\r\n|\r|\n)/g, '<br />'));
}
exports["default"] = formatMessage$1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvQ29tcG9uZW50L2RldnRvb2xzLXBhcnNlci9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLHdEQUFvQztBQUNwQyxvRUFBa0Q7QUFFbEQ7OztHQUdHO0FBQ0gsU0FBUyxhQUFhLENBQUMsSUFBVztJQUNoQyxJQUFNLGVBQWUsR0FBRyxRQUFRLENBQUMsYUFBYSxDQUFDLE1BQU0sQ0FBQyxDQUFBO0lBRXRELDJCQUFtQixDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsRUFBRSxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLGVBQWUsQ0FBQyxDQUFBO0lBRTVELE9BQU8saUJBQU8sQ0FBQyxlQUFlLENBQUMsU0FBUyxDQUFDLE9BQU8sQ0FBQyxpQkFBaUIsRUFBRSxRQUFRLENBQUMsQ0FBQyxDQUFBO0FBQ2hGLENBQUM7QUFFRCxxQkFBZSxhQUFhLENBQUEifQ==
}(devtoolsParser));

(function (exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(React__default);
var elements_1 = elements;
var devtools_parser_1 = __importDefault(devtoolsParser);
var Formatted = /** @class */ (function (_super) {
    __extends(Formatted, _super);
    function Formatted() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Formatted.prototype.render = function () {
        return (React.createElement(elements_1.Root, { "data-type": "formatted", dangerouslySetInnerHTML: {
                __html: devtools_parser_1["default"](this.props.data || [])
            } }));
    };
    return Formatted;
}(React.PureComponent));
exports["default"] = Formatted;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9ybWF0dGVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL0NvbXBvbmVudC9tZXNzYWdlLXBhcnNlcnMvRm9ybWF0dGVkLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLHdEQUFrRDtBQUVsRCx1RUFBdUM7QUFNdkM7SUFBd0IsNkJBQStCO0lBQXZEOztJQVdBLENBQUM7SUFWQywwQkFBTSxHQUFOO1FBQ0UsT0FBTyxDQUNMLG9CQUFDLGVBQUksaUJBQ08sV0FBVyxFQUNyQix1QkFBdUIsRUFBRTtnQkFDdkIsTUFBTSxFQUFFLDRCQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLElBQUksRUFBRSxDQUFDO2FBQ3RDLEdBQ0QsQ0FDSCxDQUFBO0lBQ0gsQ0FBQztJQUNILGdCQUFDO0FBQUQsQ0FBQyxBQVhELENBQXdCLEtBQUssQ0FBQyxhQUFhLEdBVzFDO0FBRUQscUJBQWUsU0FBUyxDQUFBIn0=
}(Formatted));

var _Object = {};

var linkifyReact = {};

linkifyReact.__esModule = true;

var _react = React__default;

var _react2 = _interopRequireDefault(_react);

var _linkify = linkify$2;

var linkify = _interopRequireWildcard(_linkify);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var options = linkify.options;
var Options = options.Options;

// Given a string, converts to an array of valid React components
// (which may include strings)

function stringToElements(str, opts) {

	var tokens = linkify.tokenize(str);
	var elements = [];
	var linkId = 0;

	for (var i = 0; i < tokens.length; i++) {
		var token = tokens[i];

		if (token.type === 'nl' && opts.nl2br) {
			elements.push(_react2.default.createElement('br', { key: 'linkified-' + ++linkId }));
			continue;
		} else if (!token.isLink || !opts.check(token)) {
			// Regular text
			elements.push(token.toString());
			continue;
		}

		var _opts$resolve = opts.resolve(token),
		    formatted = _opts$resolve.formatted,
		    formattedHref = _opts$resolve.formattedHref,
		    tagName = _opts$resolve.tagName,
		    className = _opts$resolve.className,
		    target = _opts$resolve.target,
		    attributes = _opts$resolve.attributes;

		var props = {
			key: 'linkified-' + ++linkId,
			href: formattedHref
		};

		if (className) {
			props.className = className;
		}

		if (target) {
			props.target = target;
		}

		// Build up additional attributes
		// Support for events via attributes hash
		if (attributes) {
			for (var attr in attributes) {
				props[attr] = attributes[attr];
			}
		}

		elements.push(_react2.default.createElement(tagName, props, formatted));
	}

	return elements;
}

// Recursively linkify the contents of the given React Element instance
function linkifyReactElement(element, opts) {
	var elementId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

	if (_react2.default.Children.count(element.props.children) === 0) {
		// No need to clone if the element had no children
		return element;
	}

	var children = [];

	_react2.default.Children.forEach(element.props.children, function (child) {
		if (typeof child === 'string') {
			// ensure that we always generate unique element IDs for keys
			elementId = elementId + 1;
			children.push.apply(children, stringToElements(child, opts));
		} else if (_react2.default.isValidElement(child)) {
			if (typeof child.type === 'string' && options.contains(opts.ignoreTags, child.type.toUpperCase())) {
				// Don't linkify this element
				children.push(child);
			} else {
				children.push(linkifyReactElement(child, opts, ++elementId));
			}
		} else {
			// Unknown element type, just push
			children.push(child);
		}
	});

	// Set a default unique key, copy over remaining props
	var newProps = { key: 'linkified-element-' + elementId };
	for (var prop in element.props) {
		newProps[prop] = element.props[prop];
	}

	return _react2.default.cloneElement(element, newProps, children);
}

var Linkify = function (_React$Component) {
	_inherits(Linkify, _React$Component);

	function Linkify() {
		_classCallCheck(this, Linkify);

		return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	}

	Linkify.prototype.render = function render() {
		// Copy over all non-linkify-specific props
		var newProps = { key: 'linkified-element-0' };
		for (var prop in this.props) {
			if (prop !== 'options' && prop !== 'tagName') {
				newProps[prop] = this.props[prop];
			}
		}

		var opts = new Options(this.props.options);
		var tagName = this.props.tagName || 'span';
		var element = _react2.default.createElement(tagName, newProps);

		return linkifyReactElement(element, opts, 0);
	};

	return Linkify;
}(_react2.default.Component);

linkifyReact.default = Linkify;

var react = linkifyReact.default;

var reactInspector = {};

var _Error = {};

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(React__default);
var react_1 = __importDefault(react);
function splitMessage(message) {
    var breakIndex = message.indexOf('\n');
    // consider that there can be line without a break
    if (breakIndex === -1) {
        return message;
    }
    return message.substr(0, breakIndex);
}
function ErrorPanel(_a) {
    var error = _a.error;
    /* This checks for error logTypes and shortens the message in the console by wrapping
    it a <details /> tag and putting the first line in a <summary /> tag and the other lines
    follow after that. This creates a nice collapsible error message */
    var otherErrorLines;
    var firstLine = splitMessage(error);
    var msgArray = error.split('\n');
    if (msgArray.length > 1) {
        otherErrorLines = msgArray.slice(1);
    }
    if (!otherErrorLines) {
        return React.createElement(react_1["default"], null, error);
    }
    return (React.createElement("details", null,
        React.createElement("summary", { style: { outline: 'none', cursor: 'pointer' } }, firstLine),
        React.createElement(react_1["default"], null, otherErrorLines.join('\n\r'))));
}
exports["default"] = ErrorPanel;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvQ29tcG9uZW50L21lc3NhZ2UtcGFyc2Vycy9FcnJvci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLDBEQUFxQztBQUVyQyxTQUFTLFlBQVksQ0FBQyxPQUFlO0lBQ25DLElBQU0sVUFBVSxHQUFHLE9BQU8sQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUE7SUFDeEMsa0RBQWtEO0lBQ2xELElBQUksVUFBVSxLQUFLLENBQUMsQ0FBQyxFQUFFO1FBQ3JCLE9BQU8sT0FBTyxDQUFBO0tBQ2Y7SUFDRCxPQUFPLE9BQU8sQ0FBQyxNQUFNLENBQUMsQ0FBQyxFQUFFLFVBQVUsQ0FBQyxDQUFBO0FBQ3RDLENBQUM7QUFFRCxTQUFTLFVBQVUsQ0FBQyxFQUE0QjtRQUExQixLQUFLLFdBQUE7SUFDekI7O3VFQUVtRTtJQUNuRSxJQUFJLGVBQWUsQ0FBQTtJQUNuQixJQUFNLFNBQVMsR0FBRyxZQUFZLENBQUMsS0FBSyxDQUFDLENBQUE7SUFDckMsSUFBTSxRQUFRLEdBQUcsS0FBSyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQTtJQUNsQyxJQUFJLFFBQVEsQ0FBQyxNQUFNLEdBQUcsQ0FBQyxFQUFFO1FBQ3ZCLGVBQWUsR0FBRyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFBO0tBQ3BDO0lBRUQsSUFBSSxDQUFDLGVBQWUsRUFBRTtRQUNwQixPQUFPLG9CQUFDLGtCQUFPLFFBQUUsS0FBSyxDQUFXLENBQUE7S0FDbEM7SUFFRCxPQUFPLENBQ0w7UUFDRSxpQ0FBUyxLQUFLLEVBQUUsRUFBRSxPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsSUFDbkQsU0FBUyxDQUNGO1FBQ1Ysb0JBQUMsa0JBQU8sUUFBRSxlQUFlLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFXLENBQ3pDLENBQ1gsQ0FBQTtBQUNILENBQUM7QUFFRCxxQkFBZSxVQUFVLENBQUEifQ==
}(_Error));

(function (exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var emotion_theming_1 = require$$1;
var React = __importStar(React__default);
var react_inspector_1 = require$$2;
var Error_1 = __importDefault(_Error);
var elements_1 = elements;
var REMAINING_KEY = '__console_feed_remaining__';
// copied from react-inspector
function intersperse(arr, sep) {
    if (arr.length === 0) {
        return [];
    }
    return arr.slice(1).reduce(function (xs, x) { return xs.concat([sep, x]); }, [arr[0]]);
}
var getArrayLength = function (array) {
    if (!array || array.length < 1) {
        return 0;
    }
    var remainingKeyCount = array[array.length - 1]
        .toString()
        .split(REMAINING_KEY);
    if (remainingKeyCount[1] === undefined) {
        return array.length;
    }
    else {
        var remaining = parseInt(array[array.length - 1].toString().split(REMAINING_KEY)[1]);
        return array.length - 1 + remaining;
    }
};
var CustomObjectRootLabel = function (_a) {
    var name = _a.name, data = _a.data;
    var rootData = data;
    if (typeof data === 'object' && !Array.isArray(data) && data !== null) {
        var object = {};
        for (var propertyName in data) {
            if (data.hasOwnProperty(propertyName)) {
                var propertyValue = data[propertyName];
                if (Array.isArray(propertyValue)) {
                    var arrayLength = getArrayLength(propertyValue);
                    object[propertyName] = new Array(arrayLength);
                }
                else {
                    object[propertyName] = propertyValue;
                }
            }
        }
        rootData = Object.assign(Object.create(Object.getPrototypeOf(data)), object);
    }
    if (typeof name === 'string') {
        return (React.createElement("span", null,
            React.createElement(react_inspector_1.ObjectName, { name: name }),
            React.createElement("span", null, ": "),
            React.createElement(react_inspector_1.ObjectPreview, { data: rootData })));
    }
    else {
        return React.createElement(react_inspector_1.ObjectPreview, { data: rootData });
    }
};
var CustomObjectLabel = function (_a) {
    var name = _a.name, data = _a.data, _b = _a.isNonenumerable, isNonenumerable = _b === void 0 ? false : _b;
    return name === REMAINING_KEY ? (data > 0 ? (React.createElement("span", null,
        data,
        " more...")) : null) : (React.createElement("span", null,
        typeof name === 'string' ? (React.createElement(react_inspector_1.ObjectName, { name: name, dimmed: isNonenumerable })) : (React.createElement(react_inspector_1.ObjectPreview, { data: name })),
        React.createElement("span", null, ": "),
        React.createElement(react_inspector_1.ObjectValue, { object: data })));
};
var CustomInspector = /** @class */ (function (_super) {
    __extends(CustomInspector, _super);
    function CustomInspector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomInspector.prototype.render = function () {
        var _a = this.props, data = _a.data, theme = _a.theme;
        var styles = theme.styles, method = theme.method;
        var dom = data instanceof HTMLElement;
        var table = method === 'table';
        return (React.createElement(elements_1.Root, { "data-type": table ? 'table' : dom ? 'html' : 'object' }, table ? (React.createElement(elements_1.Table, null,
            React.createElement(react_inspector_1.Inspector, __assign({}, this.props, { theme: styles, table: true })),
            React.createElement(react_inspector_1.Inspector, __assign({}, this.props, { theme: styles, nodeRenderer: this.nodeRenderer.bind(this) })))) : dom ? (React.createElement(elements_1.HTML, null,
            React.createElement(react_inspector_1.DOMInspector, __assign({}, this.props, { theme: styles })))) : (React.createElement(react_inspector_1.Inspector, __assign({}, this.props, { theme: styles, nodeRenderer: this.nodeRenderer.bind(this) })))));
    };
    CustomInspector.prototype.getCustomNode = function (data) {
        var _a;
        var styles = this.props.theme.styles;
        var constructor = (_a = data === null || data === void 0 ? void 0 : data.constructor) === null || _a === void 0 ? void 0 : _a.name;
        if (constructor === 'Function')
            return (React.createElement("span", { style: { fontStyle: 'italic' } },
                React.createElement(react_inspector_1.ObjectPreview, { data: data }), " {",
                React.createElement("span", { style: { color: 'rgb(181, 181, 181)' } }, data.body), "}"));
        if (data instanceof Error && typeof data.stack === 'string') {
            return React.createElement(Error_1["default"], { error: data.stack });
        }
        if (constructor === 'Promise')
            return (React.createElement("span", { style: { fontStyle: 'italic' } },
                "Promise ", "{",
                React.createElement("span", { style: { opacity: 0.6 } }, "<pending>"), "}"));
        if (data instanceof HTMLElement)
            return (React.createElement(elements_1.HTML, null,
                React.createElement(react_inspector_1.DOMInspector, { data: data, theme: styles })));
        if (Array.isArray(data)) {
            var arrayLength = getArrayLength(data);
            var maxProperties = styles.OBJECT_PREVIEW_ARRAY_MAX_PROPERTIES;
            if (typeof data[data.length - 1] === 'string' &&
                data[data.length - 1].includes(REMAINING_KEY)) {
                data = data.slice(0, -1);
            }
            var previewArray = data
                .slice(0, maxProperties)
                .map(function (element, index) {
                if (Array.isArray(element)) {
                    return (React.createElement(react_inspector_1.ObjectValue, { key: index, object: new Array(getArrayLength(element)) }));
                }
                else {
                    return React.createElement(react_inspector_1.ObjectValue, { key: index, object: element });
                }
            });
            if (arrayLength > maxProperties) {
                previewArray.push(React.createElement("span", { key: "ellipsis" }, "\u2026"));
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("span", { style: styles.objectDescription }, arrayLength === 0 ? "" : "(" + arrayLength + ")\u00A0"),
                React.createElement("span", { style: styles.preview },
                    "[",
                    intersperse(previewArray, ', '),
                    "]")));
        }
        return null;
    };
    CustomInspector.prototype.nodeRenderer = function (props) {
        var depth = props.depth, name = props.name, data = props.data, isNonenumerable = props.isNonenumerable;
        // Root
        if (depth === 0) {
            var customNode_1 = this.getCustomNode(data);
            return customNode_1 || React.createElement(CustomObjectRootLabel, { name: name, data: data });
        }
        if (typeof data === 'string' && data.includes(REMAINING_KEY)) {
            name = REMAINING_KEY;
            data = data.split(REMAINING_KEY)[1];
        }
        if (name === 'constructor')
            return (React.createElement(elements_1.Constructor, null,
                React.createElement(react_inspector_1.ObjectLabel, { name: "<constructor>", data: data.name, isNonenumerable: isNonenumerable })));
        var customNode = this.getCustomNode(data);
        return customNode ? (React.createElement(elements_1.Root, null,
            React.createElement(react_inspector_1.ObjectName, { name: name }),
            React.createElement("span", null, ": "),
            customNode)) : (React.createElement(CustomObjectLabel, { name: name, data: data, isNonenumerable: isNonenumerable }));
    };
    return CustomInspector;
}(React.PureComponent));
exports["default"] = emotion_theming_1.withTheme(CustomInspector);
//# sourceMappingURL=data:application/json;base64,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
}(reactInspector));

(function (exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(React__default);
var emotion_theming_1 = require$$1;
var elements_1 = elements;
var react_1 = __importDefault(react);
var react_inspector_1 = __importDefault(reactInspector);
var ObjectTree = /** @class */ (function (_super) {
    __extends(ObjectTree, _super);
    function ObjectTree() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ObjectTree.prototype.render = function () {
        var _this = this;
        var _a = this.props, theme = _a.theme, quoted = _a.quoted, log = _a.log;
        return log.data.map(function (message, i) {
            if (typeof message === 'string') {
                var string = !quoted && message.length ? (message + " ") : (React.createElement("span", null,
                    React.createElement("span", null, "\""),
                    React.createElement("span", { style: {
                            color: theme.styles.OBJECT_VALUE_STRING_COLOR
                        } }, message),
                    React.createElement("span", null, "\" ")));
                return (React.createElement(elements_1.Root, { "data-type": "string", key: i },
                    React.createElement(react_1["default"], { options: _this.props.linkifyOptions }, string)));
            }
            return React.createElement(react_inspector_1["default"], { data: message, key: i });
        });
    };
    return ObjectTree;
}(React.PureComponent));
exports["default"] = emotion_theming_1.withTheme(ObjectTree);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT2JqZWN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL0NvbXBvbmVudC9tZXNzYWdlLXBhcnNlcnMvT2JqZWN0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBRTlCLG1EQUEyQztBQUMzQyx3REFBa0Q7QUFFbEQsMERBQXFDO0FBR3JDLHVFQUEwQztBQVMxQztJQUF5Qiw4QkFBK0I7SUFBeEQ7O0lBaUNBLENBQUM7SUFoQ0MsMkJBQU0sR0FBTjtRQUFBLGlCQStCQztRQTlCTyxJQUFBLEtBQXlCLElBQUksQ0FBQyxLQUFLLEVBQWpDLEtBQUssV0FBQSxFQUFFLE1BQU0sWUFBQSxFQUFFLEdBQUcsU0FBZSxDQUFBO1FBRXpDLE9BQU8sR0FBRyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsVUFBQyxPQUFZLEVBQUUsQ0FBUztZQUMxQyxJQUFJLE9BQU8sT0FBTyxLQUFLLFFBQVEsRUFBRTtnQkFDL0IsSUFBTSxNQUFNLEdBQ1YsQ0FBQyxNQUFNLElBQUksT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FDdkIsT0FBTyxNQUFHLENBQ2QsQ0FBQyxDQUFDLENBQUMsQ0FDRjtvQkFDRSx1Q0FBYztvQkFDZCw4QkFDRSxLQUFLLEVBQUU7NEJBQ0wsS0FBSyxFQUFFLEtBQUssQ0FBQyxNQUFNLENBQUMseUJBQXlCO3lCQUM5QyxJQUVBLE9BQU8sQ0FDSDtvQkFDUCx3Q0FBZSxDQUNWLENBQ1IsQ0FBQTtnQkFFSCxPQUFPLENBQ0wsb0JBQUMsZUFBSSxpQkFBVyxRQUFRLEVBQUMsR0FBRyxFQUFFLENBQUM7b0JBQzdCLG9CQUFDLGtCQUFPLElBQUMsT0FBTyxFQUFFLEtBQUksQ0FBQyxLQUFLLENBQUMsY0FBYyxJQUFHLE1BQU0sQ0FBVyxDQUMxRCxDQUNSLENBQUE7YUFDRjtZQUVELE9BQU8sb0JBQUMsNEJBQVMsSUFBQyxJQUFJLEVBQUUsT0FBTyxFQUFFLEdBQUcsRUFBRSxDQUFDLEdBQUksQ0FBQTtRQUM3QyxDQUFDLENBQUMsQ0FBQTtJQUNKLENBQUM7SUFDSCxpQkFBQztBQUFELENBQUMsQUFqQ0QsQ0FBeUIsS0FBSyxDQUFDLGFBQWEsR0FpQzNDO0FBRUQscUJBQWUsMkJBQVMsQ0FBQyxVQUFVLENBQUMsQ0FBQSJ9
}(_Object));

(function (exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(React__default);
var emotion_theming_1 = require$$1;
var elements_1 = elements$1;
var Formatted_1 = __importDefault(Formatted);
var Object_1 = __importDefault(_Object);
var Error_1 = __importDefault(_Error);
// https://developer.mozilla.org/en-US/docs/Web/API/console#Using_string_substitutions
var reSubstitutions = /(%[coOs])|(%(([0-9]*[.])?[0-9]+)?[dif])/g;
var ConsoleMessage = /** @class */ (function (_super) {
    __extends(ConsoleMessage, _super);
    function ConsoleMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.theme = function (theme) { return (__assign(__assign({}, theme), { method: _this.props.log.method })); };
        return _this;
    }
    ConsoleMessage.prototype.shouldComponentUpdate = function (nextProps) {
        return this.props.log.amount !== nextProps.log.amount;
    };
    ConsoleMessage.prototype.render = function () {
        var log = this.props.log;
        return (React.createElement(emotion_theming_1.ThemeProvider, { theme: this.theme },
            React.createElement(elements_1.Message, { "data-method": log.method },
                log.amount > 1 ? React.createElement(elements_1.AmountIcon, null, log.amount) : React.createElement(elements_1.Icon, null),
                log.timestamp ? React.createElement(elements_1.Timestamp, null, log.timestamp) : React.createElement("span", null),
                React.createElement(elements_1.Content, null, this.getNode()))));
    };
    ConsoleMessage.prototype.getNode = function () {
        var _a;
        var log = this.props.log;
        // Error handling
        var error = this.typeCheck(log);
        if (error)
            return error;
        // Chrome formatting
        if (log.data.length > 0 && typeof log.data[0] === 'string') {
            var matchLength = (_a = log.data[0].match(reSubstitutions)) === null || _a === void 0 ? void 0 : _a.length;
            if (matchLength) {
                var restData = log.data.slice(1 + matchLength);
                return (React.createElement(React.Fragment, null,
                    React.createElement(Formatted_1["default"], { data: log.data }),
                    restData.length > 0 && (React.createElement(Object_1["default"], { quoted: false, log: __assign(__assign({}, log), { data: restData }), linkifyOptions: this.props.linkifyOptions }))));
            }
        }
        // Error panel
        if (log.data.every(function (message) { return typeof message === 'string'; }) &&
            log.method === 'error') {
            return React.createElement(Error_1["default"], { error: log.data.join(' ') });
        }
        // Normal inspector
        var quoted = typeof log.data[0] !== 'string';
        return (React.createElement(Object_1["default"], { log: log, quoted: quoted, linkifyOptions: this.props.linkifyOptions }));
    };
    ConsoleMessage.prototype.typeCheck = function (log) {
        if (!log) {
            return (React.createElement(Formatted_1["default"], { data: [
                    "%c[console-feed] %cFailed to parse message! %clog was typeof " + typeof log + ", but it should've been a log object",
                    'color: red',
                    'color: orange',
                    'color: cyan',
                ] }));
        }
        else if (!(log.data instanceof Array)) {
            return (React.createElement(Formatted_1["default"], { data: [
                    '%c[console-feed] %cFailed to parse message! %clog.data was not an array!',
                    'color: red',
                    'color: orange',
                    'color: cyan',
                ] }));
        }
        return false;
    };
    return ConsoleMessage;
}(React.Component));
exports["default"] = ConsoleMessage;
//# sourceMappingURL=data:application/json;base64,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
}(Message));

(function (exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(React__default);
var emotion_theming_1 = require$$1;
var default_1 = __importDefault(_default);
var elements_1 = elements$1;
var Message_1 = __importDefault(Message);
// https://stackoverflow.com/a/48254637/4089357
var customStringify = function (v) {
    var cache = new Set();
    return JSON.stringify(v, function (key, value) {
        if (typeof value === 'object' && value !== null) {
            if (cache.has(value)) {
                // Circular reference found, discard key
                return;
            }
            // Store value in our set
            cache.add(value);
        }
        return value;
    });
};
var getTheme = function (props) { return ({
    variant: props.variant || 'light',
    styles: __assign(__assign({}, default_1["default"](props)), props.styles)
}); };
var Console = /** @class */ (function (_super) {
    __extends(Console, _super);
    function Console() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            theme: getTheme(_this.props),
            prevStyles: _this.props.styles,
            prevVariant: _this.props.variant
        };
        return _this;
    }
    Console.getDerivedStateFromProps = function (props, state) {
        if (props.variant !== state.prevVariant ||
            JSON.stringify(props.styles) !== JSON.stringify(props.prevStyles)) {
            return {
                theme: getTheme(props),
                prevStyles: props.styles,
                prevVariant: props.variant
            };
        }
        return null;
    };
    Console.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.filter, filter = _b === void 0 ? [] : _b, _c = _a.logs, logs = _c === void 0 ? [] : _c, searchKeywords = _a.searchKeywords, logFilter = _a.logFilter, _d = _a.logGrouping, logGrouping = _d === void 0 ? true : _d;
        if (searchKeywords) {
            var regex_1 = new RegExp(searchKeywords);
            var filterFun = logFilter
                ? logFilter
                : function (log) {
                    try {
                        return regex_1.test(customStringify(log));
                    }
                    catch (e) {
                        return true;
                    }
                };
            // @ts-ignore
            logs = logs.filter(filterFun);
        }
        if (logGrouping) {
            // @ts-ignore
            logs = logs.reduce(function (acc, log) {
                var prevLog = acc[acc.length - 1];
                if (prevLog &&
                    prevLog.amount &&
                    prevLog.method === log.method &&
                    prevLog.data.length === log.data.length &&
                    prevLog.data.every(function (value, i) { return log.data[i] === value; })) {
                    prevLog.amount += 1;
                    return acc;
                }
                acc.push(__assign(__assign({}, log), { amount: 1 }));
                return acc;
            }, []);
        }
        return (React.createElement(emotion_theming_1.ThemeProvider, { theme: this.state.theme },
            React.createElement(elements_1.Root, null, logs.map(function (log, i) {
                // If the filter is defined and doesn't include the method
                var filtered = filter.length !== 0 &&
                    log.method &&
                    filter.indexOf(log.method) === -1;
                return filtered ? null : (React.createElement(Message_1["default"], { log: log, key: log.id || log.method + "-" + i, linkifyOptions: _this.props.linkifyOptions }));
            }))));
    };
    return Console;
}(React.PureComponent));
exports["default"] = Console;
//# sourceMappingURL=data:application/json;base64,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
}(Component));

var Hook = {};

var Methods = {};

(function (exports) {
exports.__esModule = true;
var methods = [
    'log',
    'debug',
    'info',
    'warn',
    'error',
    'table',
    'clear',
    'time',
    'timeEnd',
    'count',
    'assert',
    'command',
    'result',
    'dir',
];
exports["default"] = methods;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWV0aG9kcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kZWZpbml0aW9ucy9NZXRob2RzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsSUFBTSxPQUFPLEdBQUc7SUFDZCxLQUFLO0lBQ0wsT0FBTztJQUNQLE1BQU07SUFDTixNQUFNO0lBQ04sT0FBTztJQUNQLE9BQU87SUFDUCxPQUFPO0lBQ1AsTUFBTTtJQUNOLFNBQVM7SUFDVCxPQUFPO0lBQ1AsUUFBUTtJQUNSLFNBQVM7SUFDVCxRQUFRO0lBQ1IsS0FBSztDQUNOLENBQUE7QUFFRCxxQkFBZSxPQUFPLENBQUEifQ==
}(Methods));

var parse = {};

var GUID = {};

(function (exports) {
exports.__esModule = true;
function guidGenerator() {
    var S4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (S4() +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        '-' +
        Date.now());
}
exports["default"] = guidGenerator;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR1VJRC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9Ib29rL3BhcnNlL0dVSUQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxTQUF3QixhQUFhO0lBQ25DLElBQUksRUFBRSxHQUFHO1FBQ1AsT0FBTyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDLEdBQUcsT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsUUFBUSxDQUFDLEVBQUUsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsQ0FBQTtJQUN4RSxDQUFDLENBQUE7SUFDRCxPQUFPLENBQ0wsRUFBRSxFQUFFO1FBQ0osRUFBRSxFQUFFO1FBQ0osR0FBRztRQUNILEVBQUUsRUFBRTtRQUNKLEdBQUc7UUFDSCxFQUFFLEVBQUU7UUFDSixHQUFHO1FBQ0gsRUFBRSxFQUFFO1FBQ0osR0FBRztRQUNILEVBQUUsRUFBRTtRQUNKLEdBQUc7UUFDSCxJQUFJLENBQUMsR0FBRyxFQUFFLENBQ1gsQ0FBQTtBQUNILENBQUM7QUFsQkQsbUNBa0JDIn0=
}(GUID));

var timing = {};

var state = {};

state.__esModule = true;
state.update = state.state = void 0;
function update(newState) {
    state.state = newState;
}
state.update = update;

var dispatch = {};

var reducer = {};

(function (exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.initialState = void 0;
exports.initialState = {
    timings: {},
    count: {}
};
var now = function () {
    return typeof performance !== 'undefined' && performance.now
        ? performance.now()
        : Date.now();
};
exports["default"] = (function (state, action) {
    var _a, _b, _c;
    if (state === void 0) { state = exports.initialState; }
    switch (action.type) {
        case 'COUNT': {
            var times = state.count[action.name] || 0;
            return __assign(__assign({}, state), { count: __assign(__assign({}, state.count), (_a = {}, _a[action.name] = times + 1, _a)) });
        }
        case 'TIME_START': {
            return __assign(__assign({}, state), { timings: __assign(__assign({}, state.timings), (_b = {}, _b[action.name] = {
                    start: now()
                }, _b)) });
        }
        case 'TIME_END': {
            var timing = state.timings[action.name];
            var end = now();
            var start = timing.start;
            var time = end - start;
            return __assign(__assign({}, state), { timings: __assign(__assign({}, state.timings), (_c = {}, _c[action.name] = __assign(__assign({}, timing), { end: end,
                    time: time }), _c)) });
        }
        default: {
            return state;
        }
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVkdWNlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9Ib29rL3N0b3JlL3JlZHVjZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7QUFFYSxRQUFBLFlBQVksR0FBRztJQUMxQixPQUFPLEVBQUUsRUFBRTtJQUNYLEtBQUssRUFBRSxFQUFFO0NBQ1YsQ0FBQTtBQUVELElBQU0sR0FBRyxHQUFHO0lBQ1YsT0FBTyxPQUFPLFdBQVcsS0FBSyxXQUFXLElBQUksV0FBVyxDQUFDLEdBQUc7UUFDMUQsQ0FBQyxDQUFDLFdBQVcsQ0FBQyxHQUFHLEVBQUU7UUFDbkIsQ0FBQyxDQUFDLElBQUksQ0FBQyxHQUFHLEVBQUUsQ0FBQTtBQUNoQixDQUFDLENBQUE7QUFFRCxzQkFBZSxVQUFDLEtBQW9CLEVBQUUsTUFBYzs7SUFBcEMsc0JBQUEsRUFBQSxRQUFRLG9CQUFZO0lBQ2xDLFFBQVEsTUFBTSxDQUFDLElBQUksRUFBRTtRQUNuQixLQUFLLE9BQU8sQ0FBQyxDQUFDO1lBQ1osSUFBTSxLQUFLLEdBQUcsS0FBSyxDQUFDLEtBQUssQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFBO1lBRTNDLDZCQUNLLEtBQUssS0FDUixLQUFLLHdCQUNBLEtBQUssQ0FBQyxLQUFLLGdCQUNiLE1BQU0sQ0FBQyxJQUFJLElBQUcsS0FBSyxHQUFHLENBQUMsVUFFM0I7U0FDRjtRQUVELEtBQUssWUFBWSxDQUFDLENBQUM7WUFDakIsNkJBQ0ssS0FBSyxLQUNSLE9BQU8sd0JBQ0YsS0FBSyxDQUFDLE9BQU8sZ0JBQ2YsTUFBTSxDQUFDLElBQUksSUFBRztvQkFDYixLQUFLLEVBQUUsR0FBRyxFQUFFO2lCQUNiLFVBRUo7U0FDRjtRQUVELEtBQUssVUFBVSxDQUFDLENBQUM7WUFDZixJQUFNLE1BQU0sR0FBRyxLQUFLLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQTtZQUV6QyxJQUFNLEdBQUcsR0FBRyxHQUFHLEVBQUUsQ0FBQTtZQUNULElBQUEsS0FBSyxHQUFLLE1BQU0sTUFBWCxDQUFXO1lBRXhCLElBQU0sSUFBSSxHQUFHLEdBQUcsR0FBRyxLQUFLLENBQUE7WUFFeEIsNkJBQ0ssS0FBSyxLQUNSLE9BQU8sd0JBQ0YsS0FBSyxDQUFDLE9BQU8sZ0JBQ2YsTUFBTSxDQUFDLElBQUksMEJBQ1AsTUFBTSxLQUNULEdBQUcsS0FBQTtvQkFDSCxJQUFJLE1BQUEsYUFHVDtTQUNGO1FBRUQsT0FBTyxDQUFDLENBQUM7WUFDUCxPQUFPLEtBQUssQ0FBQTtTQUNiO0tBQ0Y7QUFDSCxDQUFDLEVBQUEifQ==
}(reducer));

(function (exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var reducer_1 = __importDefault(reducer);
var state_1 = state;
function dispatch(action) {
    state_1.update(reducer_1["default"](state_1.state, action));
}
exports["default"] = dispatch;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlzcGF0Y2guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvSG9vay9zdG9yZS9kaXNwYXRjaC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUNBLHNEQUE4QjtBQUM5QixpQ0FBdUM7QUFFdkMsU0FBUyxRQUFRLENBQUMsTUFBYztJQUM5QixjQUFNLENBQUMsb0JBQU0sQ0FBQyxhQUFLLEVBQUUsTUFBTSxDQUFDLENBQUMsQ0FBQTtBQUMvQixDQUFDO0FBRUQscUJBQWUsUUFBUSxDQUFBIn0=
}(dispatch));

var actions = {};

actions.__esModule = true;
actions.timeEnd = actions.timeStart = actions.count = void 0;
function count$1(name) {
    return {
        type: 'COUNT',
        name: name
    };
}
actions.count = count$1;
function timeStart(name) {
    return {
        type: 'TIME_START',
        name: name
    };
}
actions.timeStart = timeStart;
function timeEnd(name) {
    return {
        type: 'TIME_END',
        name: name
    };
}
actions.timeEnd = timeEnd;

var __importDefault$2 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
timing.__esModule = true;
timing.stop = timing.start = void 0;
var state_1$1 = state;
var dispatch_1$1 = __importDefault$2(dispatch);
var actions_1$1 = actions;
function start(label) {
    dispatch_1$1["default"](actions_1$1.timeStart(label));
}
timing.start = start;
function stop(label) {
    var timing = state_1$1.state === null || state_1$1.state === void 0 ? void 0 : state_1$1.state.timings[label];
    if (timing && !timing.end) {
        dispatch_1$1["default"](actions_1$1.timeEnd(label));
        var time = state_1$1.state.timings[label].time;
        return {
            method: 'log',
            data: [label + ": " + time + "ms"]
        };
    }
    return {
        method: 'warn',
        data: ["Timer '" + label + "' does not exist"]
    };
}
timing.stop = stop;

var count = {};

var __importDefault$1 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
count.__esModule = true;
count.increment = void 0;
var state_1 = state;
var dispatch_1 = __importDefault$1(dispatch);
var actions_1 = actions;
function increment(label) {
    dispatch_1["default"](actions_1.count(label));
    var times = state_1.state.count[label];
    return {
        method: 'log',
        data: [label + ": " + times]
    };
}
count.increment = increment;

var assert = {};

var __spreadArrays = (commonjsGlobal && commonjsGlobal.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
assert.__esModule = true;
assert.test = void 0;
function test(expression) {
    var messages = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        messages[_i - 1] = arguments[_i];
    }
    if (expression)
        return false;
    // Default message
    if (messages.length === 0)
        messages.push('console.assert');
    return {
        method: 'error',
        data: __spreadArrays(["Assertion failed:"], messages)
    };
}
assert.test = test;

(function (exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (commonjsGlobal && commonjsGlobal.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var GUID_1 = __importDefault(GUID);
var Timing = __importStar(timing);
var Count = __importStar(count);
var Assert = __importStar(assert);
/**
 * Parses a console log and converts it to a special Log object
 * @argument method The console method to parse
 * @argument data The arguments passed to the console method
 */
function Parse(method, data, staticID) {
    // Create an ID
    var id = staticID || GUID_1["default"]();
    // Parse the methods
    switch (method) {
        case 'clear': {
            return {
                method: method,
                id: id
            };
        }
        case 'count': {
            var label = typeof data[0] === 'string' ? data[0] : 'default';
            if (!label)
                return false;
            return __assign(__assign({}, Count.increment(label)), { id: id });
        }
        case 'time':
        case 'timeEnd': {
            var label = typeof data[0] === 'string' ? data[0] : 'default';
            if (!label)
                return false;
            if (method === 'time') {
                Timing.start(label);
                return false;
            }
            return __assign(__assign({}, Timing.stop(label)), { id: id });
        }
        case 'assert': {
            var valid = data.length !== 0;
            if (valid) {
                var assertion = Assert.test.apply(Assert, __spreadArrays([data[0]], data.slice(1)));
                if (assertion) {
                    return __assign(__assign({}, assertion), { id: id });
                }
            }
            return false;
        }
        case 'error': {
            var errors = data.map(function (error) {
                try {
                    return error.stack || error;
                }
                catch (e) {
                    return error;
                }
            });
            return {
                method: method,
                id: id,
                data: errors
            };
        }
        default: {
            return {
                method: method,
                id: id,
                data: data
            };
        }
    }
}
exports["default"] = Parse;
//# sourceMappingURL=data:application/json;base64,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
}(parse));

var Transform = {};

var arithmetic = {};

(function (exports) {
exports.__esModule = true;
var Arithmetic;
(function (Arithmetic) {
    Arithmetic[Arithmetic["infinity"] = 0] = "infinity";
    Arithmetic[Arithmetic["minusInfinity"] = 1] = "minusInfinity";
    Arithmetic[Arithmetic["minusZero"] = 2] = "minusZero";
})(Arithmetic || (Arithmetic = {}));
function isMinusZero(value) {
    return 1 / value === -Infinity;
}
exports["default"] = {
    type: 'Arithmetic',
    lookup: Number,
    shouldTransform: function (type, value) {
        return (type === 'number' &&
            (value === Infinity || value === -Infinity || isMinusZero(value)));
    },
    toSerializable: function (value) {
        return value === Infinity
            ? Arithmetic.infinity
            : value === -Infinity
                ? Arithmetic.minusInfinity
                : Arithmetic.minusZero;
    },
    fromSerializable: function (data) {
        if (data === Arithmetic.infinity)
            return Infinity;
        if (data === Arithmetic.minusInfinity)
            return -Infinity;
        if (data === Arithmetic.minusZero)
            return -0;
        return data;
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXJpdGhtZXRpYy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9UcmFuc2Zvcm0vYXJpdGhtZXRpYy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLElBQUssVUFJSjtBQUpELFdBQUssVUFBVTtJQUNiLG1EQUFRLENBQUE7SUFDUiw2REFBYSxDQUFBO0lBQ2IscURBQVMsQ0FBQTtBQUNYLENBQUMsRUFKSSxVQUFVLEtBQVYsVUFBVSxRQUlkO0FBRUQsU0FBUyxXQUFXLENBQUMsS0FBSztJQUN4QixPQUFPLENBQUMsR0FBRyxLQUFLLEtBQUssQ0FBQyxRQUFRLENBQUE7QUFDaEMsQ0FBQztBQUVELHFCQUFlO0lBQ2IsSUFBSSxFQUFFLFlBQVk7SUFDbEIsTUFBTSxFQUFFLE1BQU07SUFDZCxlQUFlLEVBQWYsVUFBZ0IsSUFBUyxFQUFFLEtBQVU7UUFDbkMsT0FBTyxDQUNMLElBQUksS0FBSyxRQUFRO1lBQ2pCLENBQUMsS0FBSyxLQUFLLFFBQVEsSUFBSSxLQUFLLEtBQUssQ0FBQyxRQUFRLElBQUksV0FBVyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQ2xFLENBQUE7SUFDSCxDQUFDO0lBQ0QsY0FBYyxFQUFkLFVBQWUsS0FBSztRQUNsQixPQUFPLEtBQUssS0FBSyxRQUFRO1lBQ3ZCLENBQUMsQ0FBQyxVQUFVLENBQUMsUUFBUTtZQUNyQixDQUFDLENBQUMsS0FBSyxLQUFLLENBQUMsUUFBUTtnQkFDckIsQ0FBQyxDQUFDLFVBQVUsQ0FBQyxhQUFhO2dCQUMxQixDQUFDLENBQUMsVUFBVSxDQUFDLFNBQVMsQ0FBQTtJQUMxQixDQUFDO0lBQ0QsZ0JBQWdCLEVBQWhCLFVBQWlCLElBQWdCO1FBQy9CLElBQUksSUFBSSxLQUFLLFVBQVUsQ0FBQyxRQUFRO1lBQUUsT0FBTyxRQUFRLENBQUE7UUFDakQsSUFBSSxJQUFJLEtBQUssVUFBVSxDQUFDLGFBQWE7WUFBRSxPQUFPLENBQUMsUUFBUSxDQUFBO1FBQ3ZELElBQUksSUFBSSxLQUFLLFVBQVUsQ0FBQyxTQUFTO1lBQUUsT0FBTyxDQUFDLENBQUMsQ0FBQTtRQUU1QyxPQUFPLElBQUksQ0FBQTtJQUNiLENBQUM7Q0FDRixDQUFBIn0=
}(arithmetic));

var BigInt$1 = {};

(function (exports) {
exports.__esModule = true;
/**
 * Serialize a `bigint` to a string
 */
exports["default"] = {
    type: 'BigInt',
    shouldTransform: function (_type, obj) {
        return typeof obj === 'bigint';
    },
    toSerializable: function (value) {
        return value + "n";
    },
    fromSerializable: function (data) {
        return BigInt(data.slice(0, -1));
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmlnSW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL1RyYW5zZm9ybS9CaWdJbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQTs7R0FFRztBQUNILHFCQUFlO0lBQ2IsSUFBSSxFQUFFLFFBQVE7SUFDZCxlQUFlLEVBQWYsVUFBZ0IsS0FBVSxFQUFFLEdBQVE7UUFDbEMsT0FBTyxPQUFPLEdBQUcsS0FBSyxRQUFRLENBQUE7SUFDaEMsQ0FBQztJQUNELGNBQWMsRUFBZCxVQUFlLEtBQWE7UUFDMUIsT0FBVSxLQUFLLE1BQUcsQ0FBQTtJQUNwQixDQUFDO0lBQ0QsZ0JBQWdCLEVBQWhCLFVBQWlCLElBQVk7UUFDM0IsT0FBTyxNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO0lBQ2xDLENBQUM7Q0FDRixDQUFBIn0=
}(BigInt$1));

var _Function = {};

(function (exports) {
exports.__esModule = true;
/**
 * Serialize a function into JSON
 */
exports["default"] = {
    type: 'Function',
    lookup: Function,
    shouldTransform: function (type, obj) {
        return typeof obj === 'function';
    },
    toSerializable: function (func) {
        var body = '';
        try {
            body = func
                .toString()
                .substring(body.indexOf('{') + 1, body.lastIndexOf('}'));
        }
        catch (e) { }
        return {
            name: func.name,
            body: body,
            proto: Object.getPrototypeOf(func).constructor.name
        };
    },
    fromSerializable: function (data) {
        try {
            var tempFunc = function () { };
            if (typeof data.name === 'string') {
                Object.defineProperty(tempFunc, 'name', {
                    value: data.name,
                    writable: false
                });
            }
            if (typeof data.body === 'string') {
                Object.defineProperty(tempFunc, 'body', {
                    value: data.body,
                    writable: false
                });
            }
            if (typeof data.proto === 'string') {
                // @ts-ignore
                tempFunc.constructor = {
                    name: data.proto
                };
            }
            return tempFunc;
        }
        catch (e) {
            return data;
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRnVuY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvVHJhbnNmb3JtL0Z1bmN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBTUE7O0dBRUc7QUFDSCxxQkFBZTtJQUNiLElBQUksRUFBRSxVQUFVO0lBQ2hCLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLGVBQWUsRUFBZixVQUFnQixJQUFTLEVBQUUsR0FBUTtRQUNqQyxPQUFPLE9BQU8sR0FBRyxLQUFLLFVBQVUsQ0FBQTtJQUNsQyxDQUFDO0lBQ0QsY0FBYyxFQUFkLFVBQWUsSUFBYztRQUMzQixJQUFJLElBQUksR0FBRyxFQUFFLENBQUE7UUFDYixJQUFJO1lBQ0YsSUFBSSxHQUFHLElBQUk7aUJBQ1IsUUFBUSxFQUFFO2lCQUNWLFNBQVMsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsRUFBRSxJQUFJLENBQUMsV0FBVyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUE7U0FDM0Q7UUFBQyxPQUFPLENBQUMsRUFBRSxHQUFFO1FBRWQsT0FBTztZQUNMLElBQUksRUFBRSxJQUFJLENBQUMsSUFBSTtZQUNmLElBQUksTUFBQTtZQUNKLEtBQUssRUFBRSxNQUFNLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxDQUFDLFdBQVcsQ0FBQyxJQUFJO1NBQ3BELENBQUE7SUFDSCxDQUFDO0lBQ0QsZ0JBQWdCLEVBQWhCLFVBQWlCLElBQWE7UUFDNUIsSUFBSTtZQUNGLElBQU0sUUFBUSxHQUFHLGNBQWEsQ0FBQyxDQUFBO1lBRS9CLElBQUksT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLFFBQVEsRUFBRTtnQkFDakMsTUFBTSxDQUFDLGNBQWMsQ0FBQyxRQUFRLEVBQUUsTUFBTSxFQUFFO29CQUN0QyxLQUFLLEVBQUUsSUFBSSxDQUFDLElBQUk7b0JBQ2hCLFFBQVEsRUFBRSxLQUFLO2lCQUNoQixDQUFDLENBQUE7YUFDSDtZQUVELElBQUksT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLFFBQVEsRUFBRTtnQkFDakMsTUFBTSxDQUFDLGNBQWMsQ0FBQyxRQUFRLEVBQUUsTUFBTSxFQUFFO29CQUN0QyxLQUFLLEVBQUUsSUFBSSxDQUFDLElBQUk7b0JBQ2hCLFFBQVEsRUFBRSxLQUFLO2lCQUNoQixDQUFDLENBQUE7YUFDSDtZQUVELElBQUksT0FBTyxJQUFJLENBQUMsS0FBSyxLQUFLLFFBQVEsRUFBRTtnQkFDbEMsYUFBYTtnQkFDYixRQUFRLENBQUMsV0FBVyxHQUFHO29CQUNyQixJQUFJLEVBQUUsSUFBSSxDQUFDLEtBQUs7aUJBQ2pCLENBQUE7YUFDRjtZQUVELE9BQU8sUUFBUSxDQUFBO1NBQ2hCO1FBQUMsT0FBTyxDQUFDLEVBQUU7WUFDVixPQUFPLElBQUksQ0FBQTtTQUNaO0lBQ0gsQ0FBQztDQUNGLENBQUEifQ==
}(_Function));

var HTML = {};

(function (exports) {
exports.__esModule = true;
// Sandbox HTML elements
var sandbox;
function getSandbox() {
    return (sandbox || (sandbox = document.implementation.createHTMLDocument('sandbox')));
}
function objectifyAttributes(element) {
    var data = {};
    for (var _i = 0, _a = element.attributes; _i < _a.length; _i++) {
        var attribute = _a[_i];
        data[attribute.name] = attribute.value;
    }
    return data;
}
/**
 * Serialize a HTML element into JSON
 */
exports["default"] = {
    type: 'HTMLElement',
    shouldTransform: function (type, obj) {
        return (obj &&
            obj.children &&
            typeof obj.innerHTML === 'string' &&
            typeof obj.tagName === 'string');
    },
    toSerializable: function (element) {
        return {
            tagName: element.tagName.toLowerCase(),
            attributes: objectifyAttributes(element),
            innerHTML: element.innerHTML
        };
    },
    fromSerializable: function (data) {
        try {
            var element = getSandbox().createElement(data.tagName);
            element.innerHTML = data.innerHTML;
            for (var _i = 0, _a = Object.keys(data.attributes); _i < _a.length; _i++) {
                var attribute = _a[_i];
                try {
                    element.setAttribute(attribute, data.attributes[attribute]);
                }
                catch (e) { }
            }
            return element;
        }
        catch (e) {
            return data;
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSFRNTC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9UcmFuc2Zvcm0vSFRNTC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHdCQUF3QjtBQUN4QixJQUFJLE9BQWlCLENBQUE7QUFDckIsU0FBUyxVQUFVO0lBQ2pCLE9BQU8sQ0FBQyxPQUFPLEtBQVAsT0FBTyxHQUFLLFFBQVEsQ0FBQyxjQUFjLENBQUMsa0JBQWtCLENBQUMsU0FBUyxDQUFDLEVBQUMsQ0FBQTtBQUM1RSxDQUFDO0FBVUQsU0FBUyxtQkFBbUIsQ0FBQyxPQUFZO0lBQ3ZDLElBQU0sSUFBSSxHQUFHLEVBQUUsQ0FBQTtJQUNmLEtBQXNCLFVBQWtCLEVBQWxCLEtBQUEsT0FBTyxDQUFDLFVBQVUsRUFBbEIsY0FBa0IsRUFBbEIsSUFBa0IsRUFBRTtRQUFyQyxJQUFJLFNBQVMsU0FBQTtRQUNoQixJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxHQUFHLFNBQVMsQ0FBQyxLQUFLLENBQUE7S0FDdkM7SUFDRCxPQUFPLElBQUksQ0FBQTtBQUNiLENBQUM7QUFFRDs7R0FFRztBQUNILHFCQUFlO0lBQ2IsSUFBSSxFQUFFLGFBQWE7SUFDbkIsZUFBZSxFQUFmLFVBQWdCLElBQVMsRUFBRSxHQUFRO1FBQ2pDLE9BQU8sQ0FDTCxHQUFHO1lBQ0gsR0FBRyxDQUFDLFFBQVE7WUFDWixPQUFPLEdBQUcsQ0FBQyxTQUFTLEtBQUssUUFBUTtZQUNqQyxPQUFPLEdBQUcsQ0FBQyxPQUFPLEtBQUssUUFBUSxDQUNoQyxDQUFBO0lBQ0gsQ0FBQztJQUNELGNBQWMsRUFBZCxVQUFlLE9BQW9CO1FBQ2pDLE9BQU87WUFDTCxPQUFPLEVBQUUsT0FBTyxDQUFDLE9BQU8sQ0FBQyxXQUFXLEVBQUU7WUFDdEMsVUFBVSxFQUFFLG1CQUFtQixDQUFDLE9BQU8sQ0FBQztZQUN4QyxTQUFTLEVBQUUsT0FBTyxDQUFDLFNBQVM7U0FDbEIsQ0FBQTtJQUNkLENBQUM7SUFDRCxnQkFBZ0IsRUFBaEIsVUFBaUIsSUFBYTtRQUM1QixJQUFJO1lBQ0YsSUFBTSxPQUFPLEdBQUcsVUFBVSxFQUFFLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQTtZQUN4RCxPQUFPLENBQUMsU0FBUyxHQUFHLElBQUksQ0FBQyxTQUFTLENBQUE7WUFDbEMsS0FBc0IsVUFBNEIsRUFBNUIsS0FBQSxNQUFNLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsRUFBNUIsY0FBNEIsRUFBNUIsSUFBNEIsRUFBRTtnQkFBL0MsSUFBSSxTQUFTLFNBQUE7Z0JBQ2hCLElBQUk7b0JBQ0YsT0FBTyxDQUFDLFlBQVksQ0FBQyxTQUFTLEVBQUUsSUFBSSxDQUFDLFVBQVUsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFBO2lCQUM1RDtnQkFBQyxPQUFPLENBQUMsRUFBRSxHQUFFO2FBQ2Y7WUFDRCxPQUFPLE9BQU8sQ0FBQTtTQUNmO1FBQUMsT0FBTyxDQUFDLEVBQUU7WUFDVixPQUFPLElBQUksQ0FBQTtTQUNaO0lBQ0gsQ0FBQztDQUNGLENBQUEifQ==
}(HTML));

var _Map = {};

(function (exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
/**
 * Serialize a Map into JSON
 */
exports["default"] = {
    type: 'Map',
    lookup: Map,
    shouldTransform: function (type, obj) {
        return obj && obj.constructor && obj.constructor.name === 'Map';
    },
    toSerializable: function (map) {
        var body = {};
        map.forEach(function (value, key) {
            var k = typeof key == 'object' ? JSON.stringify(key) : key;
            body[k] = value;
        });
        return {
            name: 'Map',
            body: body,
            proto: Object.getPrototypeOf(map).constructor.name
        };
    },
    fromSerializable: function (data) {
        var body = data.body;
        var obj = __assign({}, body);
        if (typeof data.proto === 'string') {
            // @ts-ignore
            obj.constructor = {
                name: data.proto
            };
        }
        return obj;
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL1RyYW5zZm9ybS9NYXAudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQU1BOztHQUVHO0FBQ0gscUJBQWU7SUFDYixJQUFJLEVBQUUsS0FBSztJQUNYLE1BQU0sRUFBRSxHQUFHO0lBQ1gsZUFBZSxFQUFmLFVBQWdCLElBQVMsRUFBRSxHQUFRO1FBQ2pDLE9BQU8sR0FBRyxJQUFJLEdBQUcsQ0FBQyxXQUFXLElBQUksR0FBRyxDQUFDLFdBQVcsQ0FBQyxJQUFJLEtBQUssS0FBSyxDQUFBO0lBQ2pFLENBQUM7SUFDRCxjQUFjLEVBQWQsVUFBZSxHQUFRO1FBQ3JCLElBQUksSUFBSSxHQUFHLEVBQUUsQ0FBQTtRQUViLEdBQUcsQ0FBQyxPQUFPLENBQUMsVUFBVSxLQUFLLEVBQUUsR0FBRztZQUM5QixJQUFNLENBQUMsR0FBRyxPQUFPLEdBQUcsSUFBSSxRQUFRLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQTtZQUM1RCxJQUFJLENBQUMsQ0FBQyxDQUFDLEdBQUcsS0FBSyxDQUFBO1FBQ2pCLENBQUMsQ0FBQyxDQUFBO1FBRUYsT0FBTztZQUNMLElBQUksRUFBRSxLQUFLO1lBQ1gsSUFBSSxNQUFBO1lBQ0osS0FBSyxFQUFFLE1BQU0sQ0FBQyxjQUFjLENBQUMsR0FBRyxDQUFDLENBQUMsV0FBVyxDQUFDLElBQUk7U0FDbkQsQ0FBQTtJQUNILENBQUM7SUFDRCxnQkFBZ0IsRUFBaEIsVUFBaUIsSUFBYTtRQUNwQixJQUFBLElBQUksR0FBSyxJQUFJLEtBQVQsQ0FBUztRQUNyQixJQUFJLEdBQUcsZ0JBQVEsSUFBSSxDQUFFLENBQUE7UUFFckIsSUFBSSxPQUFPLElBQUksQ0FBQyxLQUFLLEtBQUssUUFBUSxFQUFFO1lBQ2xDLGFBQWE7WUFDYixHQUFHLENBQUMsV0FBVyxHQUFHO2dCQUNoQixJQUFJLEVBQUUsSUFBSSxDQUFDLEtBQUs7YUFDakIsQ0FBQTtTQUNGO1FBRUQsT0FBTyxHQUFHLENBQUE7SUFDWixDQUFDO0NBQ0YsQ0FBQSJ9
}(_Map));

var replicator$1 = {};

(function (exports) {
exports.__esModule = true;
// Const
var TRANSFORMED_TYPE_KEY = '@t';
var CIRCULAR_REF_KEY = '@r';
var KEY_REQUIRE_ESCAPING_RE = /^#*@(t|r)$/;
var REMAINING_KEY = '__console_feed_remaining__';
var GLOBAL = (function getGlobal() {
    // NOTE: see http://www.ecma-international.org/ecma-262/6.0/index.html#sec-performeval step 10
    var savedEval = eval;
    return savedEval('this');
})();
var ARRAY_BUFFER_SUPPORTED = typeof ArrayBuffer === 'function';
var MAP_SUPPORTED = typeof Map === 'function';
var SET_SUPPORTED = typeof Set === 'function';
var TYPED_ARRAY_CTORS = [
    'Int8Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Int16Array',
    'Uint16Array',
    'Int32Array',
    'Uint32Array',
    'Float32Array',
    'Float64Array',
];
// Saved proto functions
var arrSlice = Array.prototype.slice;
// Default serializer
var JSONSerializer = {
    serialize: function (val) {
        return JSON.stringify(val);
    },
    deserialize: function (val) {
        return JSON.parse(val);
    }
};
// EncodingTransformer
var EncodingTransformer = /** @class */ (function () {
    function EncodingTransformer(val, transforms, limit) {
        this.references = val;
        this.transforms = transforms;
        this.transformsMap = this._makeTransformsMap();
        this.circularCandidates = [];
        this.circularCandidatesDescrs = [];
        this.circularRefCount = 0;
        this.limit = limit !== null && limit !== void 0 ? limit : Infinity;
    }
    EncodingTransformer._createRefMark = function (idx) {
        var obj = Object.create(null);
        obj[CIRCULAR_REF_KEY] = idx;
        return obj;
    };
    EncodingTransformer.prototype._createCircularCandidate = function (val, parent, key) {
        this.circularCandidates.push(val);
        this.circularCandidatesDescrs.push({ parent: parent, key: key, refIdx: -1 });
    };
    EncodingTransformer.prototype._applyTransform = function (val, parent, key, transform) {
        var result = Object.create(null);
        var serializableVal = transform.toSerializable(val);
        if (typeof serializableVal === 'object')
            this._createCircularCandidate(val, parent, key);
        result[TRANSFORMED_TYPE_KEY] = transform.type;
        result.data = this._handleValue(function () { return serializableVal; }, parent, key);
        return result;
    };
    EncodingTransformer.prototype._handleArray = function (arr) {
        var result = [];
        var arrayLimit = Math.min(arr.length, this.limit);
        var remaining = arr.length - arrayLimit;
        var _loop_1 = function (i) {
            result[i] = this_1._handleValue(function () { return arr[i]; }, result, i);
        };
        var this_1 = this;
        for (var i = 0; i < arrayLimit; i++) {
            _loop_1(i);
        }
        result[arrayLimit] = REMAINING_KEY + remaining;
        return result;
    };
    EncodingTransformer.prototype._handlePlainObject = function (obj) {
        var _a, _b;
        var result = Object.create(null);
        var counter = 0;
        var total = 0;
        var _loop_2 = function (key) {
            if (Reflect.has(obj, key)) {
                if (counter >= this_2.limit) {
                    total++;
                    return "continue";
                }
                var resultKey = KEY_REQUIRE_ESCAPING_RE.test(key) ? "#" + key : key;
                result[resultKey] = this_2._handleValue(function () { return obj[key]; }, result, resultKey);
                counter++;
                total++;
            }
        };
        var this_2 = this;
        for (var key in obj) {
            _loop_2(key);
        }
        var remaining = total - counter;
        var name = (_b = (_a = obj === null || obj === void 0 ? void 0 : obj.__proto__) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name;
        if (name && name !== 'Object') {
            result.constructor = { name: name };
        }
        if (remaining) {
            result[REMAINING_KEY] = remaining;
        }
        return result;
    };
    EncodingTransformer.prototype._handleObject = function (obj, parent, key) {
        this._createCircularCandidate(obj, parent, key);
        return Array.isArray(obj)
            ? this._handleArray(obj)
            : this._handlePlainObject(obj);
    };
    EncodingTransformer.prototype._ensureCircularReference = function (obj) {
        var circularCandidateIdx = this.circularCandidates.indexOf(obj);
        if (circularCandidateIdx > -1) {
            var descr = this.circularCandidatesDescrs[circularCandidateIdx];
            if (descr.refIdx === -1)
                descr.refIdx = descr.parent ? ++this.circularRefCount : 0;
            return EncodingTransformer._createRefMark(descr.refIdx);
        }
        return null;
    };
    EncodingTransformer.prototype._handleValue = function (getVal, parent, key) {
        try {
            var val = getVal();
            var type = typeof val;
            var isObject = type === 'object' && val !== null;
            if (isObject) {
                var refMark = this._ensureCircularReference(val);
                if (refMark)
                    return refMark;
            }
            var transform = this._findTransform(type, val);
            if (transform) {
                return this._applyTransform(val, parent, key, transform);
            }
            if (isObject)
                return this._handleObject(val, parent, key);
            return val;
        }
        catch (e) {
            try {
                return this._handleValue(function () { return (e instanceof Error ? e : new Error(e)); }, parent, key);
            }
            catch (_a) {
                return null;
            }
        }
    };
    EncodingTransformer.prototype._makeTransformsMap = function () {
        if (!MAP_SUPPORTED) {
            return;
        }
        var map = new Map();
        this.transforms.forEach(function (transform) {
            if (transform.lookup) {
                map.set(transform.lookup, transform);
            }
        });
        return map;
    };
    EncodingTransformer.prototype._findTransform = function (type, val) {
        if (MAP_SUPPORTED) {
            if (val && val.constructor) {
                var transform = this.transformsMap.get(val.constructor);
                if (transform === null || transform === void 0 ? void 0 : transform.shouldTransform(type, val))
                    return transform;
            }
        }
        for (var _i = 0, _a = this.transforms; _i < _a.length; _i++) {
            var transform = _a[_i];
            if (transform.shouldTransform(type, val))
                return transform;
        }
    };
    EncodingTransformer.prototype.transform = function () {
        var _this = this;
        var references = [this._handleValue(function () { return _this.references; }, null, null)];
        for (var _i = 0, _a = this.circularCandidatesDescrs; _i < _a.length; _i++) {
            var descr = _a[_i];
            if (descr.refIdx > 0) {
                references[descr.refIdx] = descr.parent[descr.key];
                descr.parent[descr.key] = EncodingTransformer._createRefMark(descr.refIdx);
            }
        }
        return references;
    };
    return EncodingTransformer;
}());
// DecodingTransform
var DecodingTransformer = /** @class */ (function () {
    function DecodingTransformer(references, transformsMap) {
        this.activeTransformsStack = [];
        this.visitedRefs = Object.create(null);
        this.references = references;
        this.transformMap = transformsMap;
    }
    DecodingTransformer.prototype._handlePlainObject = function (obj) {
        var unescaped = Object.create(null);
        if ('constructor' in obj) {
            if (!obj.constructor || typeof obj.constructor.name !== 'string') {
                obj.constructor = {
                    name: 'Object'
                };
            }
        }
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                this._handleValue(obj[key], obj, key);
                if (KEY_REQUIRE_ESCAPING_RE.test(key)) {
                    // NOTE: use intermediate object to avoid unescaped and escaped keys interference
                    // E.g. unescaped "##@t" will be "#@t" which can overwrite escaped "#@t".
                    unescaped[key.substring(1)] = obj[key];
                    delete obj[key];
                }
            }
        }
        for (var unsecapedKey in unescaped)
            obj[unsecapedKey] = unescaped[unsecapedKey];
    };
    DecodingTransformer.prototype._handleTransformedObject = function (obj, parent, key) {
        var transformType = obj[TRANSFORMED_TYPE_KEY];
        var transform = this.transformMap[transformType];
        if (!transform)
            throw new Error("Can't find transform for \"" + transformType + "\" type.");
        this.activeTransformsStack.push(obj);
        this._handleValue(obj.data, obj, 'data');
        this.activeTransformsStack.pop();
        parent[key] = transform.fromSerializable(obj.data);
    };
    DecodingTransformer.prototype._handleCircularSelfRefDuringTransform = function (refIdx, parent, key) {
        // NOTE: we've hit a hard case: object reference itself during transformation.
        // We can't dereference it since we don't have resulting object yet. And we'll
        // not be able to restore reference lately because we will need to traverse
        // transformed object again and reference might be unreachable or new object contain
        // new circular references. As a workaround we create getter, so once transformation
        // complete, dereferenced property will point to correct transformed object.
        var references = this.references;
        Object.defineProperty(parent, key, {
            // @ts-ignore
            val: void 0,
            configurable: true,
            enumerable: true,
            get: function () {
                if (this.val === void 0)
                    this.val = references[refIdx];
                return this.val;
            },
            set: function (value) {
                this.val = value;
            }
        });
    };
    DecodingTransformer.prototype._handleCircularRef = function (refIdx, parent, key) {
        if (this.activeTransformsStack.includes(this.references[refIdx]))
            this._handleCircularSelfRefDuringTransform(refIdx, parent, key);
        else {
            if (!this.visitedRefs[refIdx]) {
                this.visitedRefs[refIdx] = true;
                this._handleValue(this.references[refIdx], this.references, refIdx);
            }
            parent[key] = this.references[refIdx];
        }
    };
    DecodingTransformer.prototype._handleValue = function (val, parent, key) {
        if (typeof val !== 'object' || val === null)
            return;
        var refIdx = val[CIRCULAR_REF_KEY];
        if (refIdx !== void 0)
            this._handleCircularRef(refIdx, parent, key);
        else if (val[TRANSFORMED_TYPE_KEY])
            this._handleTransformedObject(val, parent, key);
        else if (Array.isArray(val)) {
            for (var i = 0; i < val.length; i++)
                this._handleValue(val[i], val, i);
        }
        else
            this._handlePlainObject(val);
    };
    DecodingTransformer.prototype.transform = function () {
        this.visitedRefs[0] = true;
        this._handleValue(this.references[0], this.references, 0);
        return this.references[0];
    };
    return DecodingTransformer;
}());
// Transforms
var builtInTransforms = [
    {
        type: '[[NaN]]',
        shouldTransform: function (type, val) {
            return type === 'number' && isNaN(val);
        },
        toSerializable: function () {
            return '';
        },
        fromSerializable: function () {
            return NaN;
        }
    },
    {
        type: '[[undefined]]',
        shouldTransform: function (type) {
            return type === 'undefined';
        },
        toSerializable: function () {
            return '';
        },
        fromSerializable: function () {
            return void 0;
        }
    },
    {
        type: '[[Date]]',
        lookup: Date,
        shouldTransform: function (type, val) {
            return val instanceof Date;
        },
        toSerializable: function (date) {
            return date.getTime();
        },
        fromSerializable: function (val) {
            var date = new Date();
            date.setTime(val);
            return date;
        }
    },
    {
        type: '[[RegExp]]',
        lookup: RegExp,
        shouldTransform: function (type, val) {
            return val instanceof RegExp;
        },
        toSerializable: function (re) {
            var result = {
                src: re.source,
                flags: ''
            };
            if (re.global)
                result.flags += 'g';
            if (re.ignoreCase)
                result.flags += 'i';
            if (re.multiline)
                result.flags += 'm';
            return result;
        },
        fromSerializable: function (val) {
            return new RegExp(val.src, val.flags);
        }
    },
    {
        type: '[[Error]]',
        lookup: Error,
        shouldTransform: function (type, val) {
            return val instanceof Error;
        },
        toSerializable: function (err) {
            var _a, _b;
            if (!err.stack) {
                (_b = (_a = Error).captureStackTrace) === null || _b === void 0 ? void 0 : _b.call(_a, err);
            }
            return {
                name: err.name,
                message: err.message,
                stack: err.stack
            };
        },
        fromSerializable: function (val) {
            var Ctor = GLOBAL[val.name] || Error;
            var err = new Ctor(val.message);
            err.stack = val.stack;
            return err;
        }
    },
    {
        type: '[[ArrayBuffer]]',
        lookup: ARRAY_BUFFER_SUPPORTED && ArrayBuffer,
        shouldTransform: function (type, val) {
            return ARRAY_BUFFER_SUPPORTED && val instanceof ArrayBuffer;
        },
        toSerializable: function (buffer) {
            var view = new Int8Array(buffer);
            return arrSlice.call(view);
        },
        fromSerializable: function (val) {
            if (ARRAY_BUFFER_SUPPORTED) {
                var buffer = new ArrayBuffer(val.length);
                var view = new Int8Array(buffer);
                view.set(val);
                return buffer;
            }
            return val;
        }
    },
    {
        type: '[[TypedArray]]',
        shouldTransform: function (type, val) {
            if (ARRAY_BUFFER_SUPPORTED) {
                return ArrayBuffer.isView(val) && !(val instanceof DataView);
            }
            for (var _i = 0, TYPED_ARRAY_CTORS_1 = TYPED_ARRAY_CTORS; _i < TYPED_ARRAY_CTORS_1.length; _i++) {
                var ctorName = TYPED_ARRAY_CTORS_1[_i];
                if (typeof GLOBAL[ctorName] === 'function' &&
                    val instanceof GLOBAL[ctorName])
                    return true;
            }
            return false;
        },
        toSerializable: function (arr) {
            return {
                ctorName: arr.constructor.name,
                arr: arrSlice.call(arr)
            };
        },
        fromSerializable: function (val) {
            return typeof GLOBAL[val.ctorName] === 'function'
                ? new GLOBAL[val.ctorName](val.arr)
                : val.arr;
        }
    },
    {
        type: '[[Map]]',
        lookup: MAP_SUPPORTED && Map,
        shouldTransform: function (type, val) {
            return MAP_SUPPORTED && val instanceof Map;
        },
        toSerializable: function (map) {
            var flattenedKVArr = [];
            map.forEach(function (val, key) {
                flattenedKVArr.push(key);
                flattenedKVArr.push(val);
            });
            return flattenedKVArr;
        },
        fromSerializable: function (val) {
            if (MAP_SUPPORTED) {
                // NOTE: new Map(iterable) is not supported by all browsers
                var map = new Map();
                for (var i = 0; i < val.length; i += 2)
                    map.set(val[i], val[i + 1]);
                return map;
            }
            var kvArr = [];
            // @ts-ignore
            for (var j = 0; j < val.length; j += 2)
                kvArr.push([val[i], val[i + 1]]);
            return kvArr;
        }
    },
    {
        type: '[[Set]]',
        lookup: SET_SUPPORTED && Set,
        shouldTransform: function (type, val) {
            return SET_SUPPORTED && val instanceof Set;
        },
        toSerializable: function (set) {
            var arr = [];
            set.forEach(function (val) {
                arr.push(val);
            });
            return arr;
        },
        fromSerializable: function (val) {
            if (SET_SUPPORTED) {
                // NOTE: new Set(iterable) is not supported by all browsers
                var set = new Set();
                for (var i = 0; i < val.length; i++)
                    set.add(val[i]);
                return set;
            }
            return val;
        }
    },
];
// Replicator
var Replicator = /** @class */ (function () {
    function Replicator(serializer) {
        this.transforms = [];
        this.transformsMap = Object.create(null);
        this.serializer = serializer || JSONSerializer;
        this.addTransforms(builtInTransforms);
    }
    Replicator.prototype.addTransforms = function (transforms) {
        transforms = Array.isArray(transforms) ? transforms : [transforms];
        for (var _i = 0, transforms_1 = transforms; _i < transforms_1.length; _i++) {
            var transform = transforms_1[_i];
            if (this.transformsMap[transform.type])
                throw new Error("Transform with type \"" + transform.type + "\" was already added.");
            this.transforms.push(transform);
            this.transformsMap[transform.type] = transform;
        }
        return this;
    };
    Replicator.prototype.removeTransforms = function (transforms) {
        transforms = Array.isArray(transforms) ? transforms : [transforms];
        for (var _i = 0, transforms_2 = transforms; _i < transforms_2.length; _i++) {
            var transform = transforms_2[_i];
            var idx = this.transforms.indexOf(transform);
            if (idx > -1)
                this.transforms.splice(idx, 1);
            delete this.transformsMap[transform.type];
        }
        return this;
    };
    Replicator.prototype.encode = function (val, limit) {
        var transformer = new EncodingTransformer(val, this.transforms, limit);
        var references = transformer.transform();
        return this.serializer.serialize(references);
    };
    Replicator.prototype.decode = function (val) {
        var references = this.serializer.deserialize(val);
        var transformer = new DecodingTransformer(references, this.transformsMap);
        return transformer.transform();
    };
    return Replicator;
}());
exports["default"] = Replicator;
//# sourceMappingURL=data:application/json;base64,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
}(replicator$1));

var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Transform.__esModule = true;
Transform.Decode = Transform.Encode = void 0;
var arithmetic_1 = __importDefault(arithmetic);
var BigInt_1 = __importDefault(BigInt$1);
var Function_1 = __importDefault(_Function);
var HTML_1 = __importDefault(HTML);
var Map_1 = __importDefault(_Map);
var replicator_1 = __importDefault(replicator$1);
var transforms = [HTML_1["default"], Function_1["default"], arithmetic_1["default"], Map_1["default"], BigInt_1["default"]];
var replicator = new replicator_1["default"]();
replicator.addTransforms(transforms);
function Encode(data, limit) {
    return JSON.parse(replicator.encode(data, limit));
}
Transform.Encode = Encode;
function Decode(data) {
    var decoded = replicator.decode(JSON.stringify(data));
    // remove __console_feed_remaining__
    decoded.data.pop();
    return decoded;
}
Transform.Decode = Decode;

(function (exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var Methods_1 = __importDefault(Methods);
var parse_1 = __importDefault(parse);
var Transform_1 = Transform;
// import Construct from './construct'
/**
 * Hook a console constructor and forward messages to a callback
 * @argument console The Console constructor to Hook
 * @argument callback The callback to be called once a message is logged
 */
function Hook(console, callback, encode, limit) {
    if (encode === void 0) { encode = true; }
    var TargetConsole = console;
    var Storage = {
        pointers: {},
        src: {
            npm: 'https://npmjs.com/package/console-feed',
            github: 'https://github.com/samdenty/console-feed'
        }
    };
    var _loop_1 = function (method) {
        var NativeMethod = TargetConsole[method];
        // Override
        TargetConsole[method] = function () {
            // Pass back to native method
            NativeMethod.apply(this, arguments);
            // Parse arguments and send to transport
            var args = [].slice.call(arguments);
            // setTimeout to prevent lag
            setTimeout(function () {
                var parsed = parse_1["default"](method, args);
                if (parsed) {
                    var encoded = parsed;
                    if (encode) {
                        encoded = Transform_1.Encode(parsed, limit);
                    }
                    callback(encoded, parsed);
                }
            });
        };
        // Store native methods
        Storage.pointers[method] = NativeMethod;
    };
    // Override console methods
    for (var _i = 0, Methods_2 = Methods_1["default"]; _i < Methods_2.length; _i++) {
        var method = Methods_2[_i];
        _loop_1(method);
    }
    TargetConsole.feed = Storage;
    return TargetConsole;
}
exports["default"] = Hook;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvSG9vay9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQU9BLG1FQUE0QztBQUU1QyxrREFBMkI7QUFFM0IsMENBQXFDO0FBQ3JDLHNDQUFzQztBQUV0Qzs7OztHQUlHO0FBQ0gsU0FBd0IsSUFBSSxDQUMxQixPQUFnQixFQUNoQixRQUFrQixFQUNsQixNQUFhLEVBQ2IsS0FBYztJQURkLHVCQUFBLEVBQUEsYUFBYTtJQUdiLElBQU0sYUFBYSxHQUFHLE9BQXdCLENBQUE7SUFDOUMsSUFBTSxPQUFPLEdBQVk7UUFDdkIsUUFBUSxFQUFFLEVBQUU7UUFDWixHQUFHLEVBQUU7WUFDSCxHQUFHLEVBQUUsd0NBQXdDO1lBQzdDLE1BQU0sRUFBRSwwQ0FBMEM7U0FDbkQ7S0FDRixDQUFBOzRCQUdRLE1BQU07UUFDYixJQUFNLFlBQVksR0FBRyxhQUFhLENBQUMsTUFBTSxDQUFDLENBQUE7UUFFMUMsV0FBVztRQUNYLGFBQWEsQ0FBQyxNQUFNLENBQUMsR0FBRztZQUN0Qiw2QkFBNkI7WUFDN0IsWUFBWSxDQUFDLEtBQUssQ0FBQyxJQUFJLEVBQUUsU0FBUyxDQUFDLENBQUE7WUFFbkMsd0NBQXdDO1lBQ3hDLElBQU0sSUFBSSxHQUFHLEVBQUUsQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFBO1lBRXJDLDRCQUE0QjtZQUM1QixVQUFVLENBQUM7Z0JBQ1QsSUFBTSxNQUFNLEdBQUcsa0JBQUssQ0FBQyxNQUF3QixFQUFFLElBQUksQ0FBQyxDQUFBO2dCQUNwRCxJQUFJLE1BQU0sRUFBRTtvQkFDVixJQUFJLE9BQU8sR0FBWSxNQUFpQixDQUFBO29CQUN4QyxJQUFJLE1BQU0sRUFBRTt3QkFDVixPQUFPLEdBQUcsa0JBQU0sQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFZLENBQUE7cUJBQzNDO29CQUNELFFBQVEsQ0FBQyxPQUFPLEVBQUUsTUFBTSxDQUFDLENBQUE7aUJBQzFCO1lBQ0gsQ0FBQyxDQUFDLENBQUE7UUFDSixDQUFDLENBQUE7UUFFRCx1QkFBdUI7UUFDdkIsT0FBTyxDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsR0FBRyxZQUFZLENBQUE7O0lBMUJ6QywyQkFBMkI7SUFDM0IsS0FBbUIsVUFBTyxFQUFQLFlBQUEsb0JBQU8sRUFBUCxxQkFBTyxFQUFQLElBQU87UUFBckIsSUFBSSxNQUFNLGdCQUFBO2dCQUFOLE1BQU07S0EwQmQ7SUFFRCxhQUFhLENBQUMsSUFBSSxHQUFHLE9BQU8sQ0FBQTtJQUU1QixPQUFPLGFBQWEsQ0FBQTtBQUN0QixDQUFDO0FBL0NELDBCQStDQyJ9
}(Hook));

var Unhook = {};

(function (exports) {
exports.__esModule = true;
/**
 * Unhook a console constructor and restore back the Native methods
 * @argument console The Console constructor to Hook
 */
function Unhook(console) {
    if (console.feed) {
        for (var _i = 0, _a = Object.keys(console.feed.pointers); _i < _a.length; _i++) {
            var method = _a[_i];
            console[method] = console.feed.pointers[method];
        }
        return delete console.feed;
    }
    else {
        return false;
    }
}
exports["default"] = Unhook;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvVW5ob29rL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUE7OztHQUdHO0FBQ0gsU0FBUyxNQUFNLENBQUMsT0FBc0I7SUFDcEMsSUFBSSxPQUFPLENBQUMsSUFBSSxFQUFFO1FBQ2hCLEtBQXFCLFVBQWtDLEVBQWxDLEtBQUEsTUFBTSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxFQUFsQyxjQUFrQyxFQUFsQyxJQUFrQyxFQUFFO1lBQXBELElBQU0sTUFBTSxTQUFBO1lBQ2YsT0FBTyxDQUFDLE1BQU0sQ0FBQyxHQUFHLE9BQU8sQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxDQUFBO1NBQ2hEO1FBQ0QsT0FBTyxPQUFPLE9BQU8sQ0FBQyxJQUFJLENBQUE7S0FDM0I7U0FBTTtRQUNMLE9BQU8sS0FBSyxDQUFBO0tBQ2I7QUFDSCxDQUFDO0FBRUQscUJBQWUsTUFBTSxDQUFBIn0=
}(Unhook));

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.Encode = exports.Decode = exports.Unhook = exports.Hook = exports.Console = void 0;
var Component_1 = Component;
__createBinding(exports, Component_1, "default", "Console");
var Hook_1 = Hook;
__createBinding(exports, Hook_1, "default", "Hook");
var Unhook_1 = Unhook;
__createBinding(exports, Unhook_1, "default", "Unhook");
var Transform_1 = Transform;
__createBinding(exports, Transform_1, "Decode");
var Transform_2 = Transform;
__createBinding(exports, Transform_2, "Encode");
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUFBLHlDQUFnRDtBQUF2Qyw0REFBa0I7QUFDM0IsK0JBQXdDO0FBQS9CLG9EQUFlO0FBQ3hCLG1DQUE0QztBQUFuQyx3REFBaUI7QUFFMUIseUNBQW9DO0FBQTNCLGdEQUFNO0FBQ2YseUNBQW9DO0FBQTNCLGdEQUFNIn0=
}(lib));

var css_248z$E = ".console-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.console-wrapper .console-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: var(--spacing-sm);\n  background-color: #636363;\n  border-bottom: 1px solid navbar-font-border-color;\n}\n.console-wrapper .console-elements {\n  flex: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.console-wrapper .console-filter-keyword-label {\n  margin-right: var(--spacing-sm);\n  font-size: 13px;\n}";
styleInject(css_248z$E);

var css_248z$D = ".console-input-wrapper {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding-left: var(--spacing-md);\n}\n.console-input-wrapper .console-input-mark {\n  margin-right: var(--spacing-lg);\n  color: #5187ff;\n}\n.console-input-wrapper .console-input {\n  flex: 1;\n  padding: var(--spacing-xxs) 0;\n  margin: 0;\n  font-size: 12px;\n  color: #ffffff;\n  background: transparent;\n  border: 0;\n  outline: none;\n}";
styleInject(css_248z$D);

var css_248z$C = ".console-logs-filter-form {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 1000;\n  display: flex;\n  flex-wrap: wrap;\n  width: 250px;\n  padding: var(--spacing-md);\n  background-color: #cccccc;\n  border-radius: 5px;\n  transform: translate(-50%, -50%);\n}\n.console-logs-filter-form .console-logs-filter-option {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  width: 45%;\n  padding: var(--spacing-s);\n  margin: var(--spacing-s);\n  font-size: 14px;\n  text-transform: capitalize;\n  white-space: nowrap;\n}\n.console-logs-filter-form .console-logs-filter-option-input {\n  margin-right: var(--spacing-sm);\n}\n.console-logs-filter-form .console-logs-filter-button {\n  width: 80px;\n  height: 30px;\n  margin: auto;\n}";
styleInject(css_248z$C);

var css_248z$B = ".console-loading-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  margin: 0;\n  font-size: 20px;\n  color: #ffffff;\n}";
styleInject(css_248z$B);

const LoadingPlaceholder = () => (jsx("p", Object.assign({ className: "console-loading-placeholder" }, { children: "Loading..." }), void 0));

var css_248z$A = ".console-navbar-wrapper {\n  display: flex;\n  height: 45px;\n  background-color: #313131;\n  border-bottom: 1px solid #8a8a8a;\n}\n.console-navbar-wrapper .console-navbar-tab {\n  display: flex;\n  align-items: center;\n  padding: var(--spacing-md);\n  margin: 0 var(--spacing-md);\n  font-size: 14px;\n  color: #ffffff;\n  background-color: #171717;\n}\n.console-navbar-wrapper .console-navbar-buttons-wrapper {\n  display: flex;\n  margin-right: var(--spacing-xs);\n  margin-left: auto;\n}\n.console-navbar-wrapper .console-navbar-buttons-wrapper .console-navbar-button {\n  margin: var(--spacing-xs);\n  margin-left: var(--spacing-md);\n}";
styleInject(css_248z$A);

const Navbar = ({ onToggleConsoleClick, onCloseConsoleClick, isConsoleHidden, }) => (jsxs("div", Object.assign({ className: "console-navbar-wrapper" }, { children: [jsx("p", Object.assign({ className: "console-navbar-tab" }, { children: "Console" }), void 0), jsxs("div", Object.assign({ className: "console-navbar-buttons-wrapper" }, { children: [jsx("button", Object.assign({ className: "console-navbar-button", onClick: onToggleConsoleClick, type: "button" }, { children: isConsoleHidden ? 'Show console' : 'Hide console' }), void 0), jsx("button", Object.assign({ className: "console-navbar-button", onClick: onCloseConsoleClick, type: "button" }, { children: "Close console" }), void 0)] }), void 0)] }), void 0));

var css_248z$z = ".console-simulator-wrapper {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  width: 100%;\n  font-family: Consolas, Lucida Console, Courier New, monospace;\n  background-color: #242424;\n  /* stylelint-disable-next-line selector-max-universal */\n}\n.console-simulator-wrapper * {\n  box-sizing: border-box;\n}\n.console-simulator-wrapper .console-container-wrapper {\n  height: 300px;\n  overflow: hidden;\n}\n.console-simulator-wrapper .console-container-hidden {\n  height: 0;\n}";
styleInject(css_248z$z);

const Console = React__default.lazy(() => import('./Console-66ecadc8.js'));
var ConsoleState;
(function (ConsoleState) {
    ConsoleState["enabled"] = "enabled";
})(ConsoleState || (ConsoleState = {}));
const ENABLE_CONSOLE_EVENT = 'ENABLE_CONSOLE_EVENT';
const CONSOLE_SIMULATOR_INITIAL_SATE_FLAG = 'CONSOLE_SIMULATOR_INITIAL_SATE_FLAG';
const CONSOLE_NAVBAR_CSS_VARIABLE = '--console-simulator-nav-height';
const ConsoleSimulator = () => {
    const [isConsoleOpened, setConsoleOpened] = useState(false);
    const [isConsoleHidden, setConsoleHidden] = useState(false);
    const handleToggleConsole = () => {
        setConsoleHidden(!isConsoleHidden);
    };
    const handleCloseConsole = () => {
        setConsoleOpened(false);
        localStorage.removeItem(CONSOLE_SIMULATOR_INITIAL_SATE_FLAG);
        document.documentElement.style.setProperty(CONSOLE_NAVBAR_CSS_VARIABLE, '0px');
    };
    useEffect(() => {
        const openConsoleCallback = () => {
            setConsoleOpened(true);
            localStorage.setItem(CONSOLE_SIMULATOR_INITIAL_SATE_FLAG, ConsoleState.enabled);
            document.documentElement.style.setProperty(CONSOLE_NAVBAR_CSS_VARIABLE, '45px');
        };
        if (localStorage.getItem(CONSOLE_SIMULATOR_INITIAL_SATE_FLAG) ===
            ConsoleState.enabled) {
            openConsoleCallback();
        }
        window.addEventListener(ENABLE_CONSOLE_EVENT, openConsoleCallback);
        return () => {
            window.removeEventListener(ENABLE_CONSOLE_EVENT, openConsoleCallback);
        };
    }, [setConsoleOpened]);
    return isConsoleOpened ? (jsxs("div", Object.assign({ className: "console-simulator-wrapper" }, { children: [jsx(Navbar, { isConsoleHidden: isConsoleHidden, onCloseConsoleClick: handleCloseConsole, onToggleConsoleClick: handleToggleConsole }, void 0), jsx("div", Object.assign({ className: classNames('console-container-wrapper', {
                    'console-container-hidden': isConsoleHidden,
                }) }, { children: jsx(Suspense, Object.assign({ fallback: jsx(LoadingPlaceholder, {}, void 0) }, { children: jsx(Console, { isHidden: isConsoleHidden }, void 0) }), void 0) }), void 0)] }), void 0)) : null;
};
ConsoleSimulator.ENABLE_CONSOLE_EVENT = ENABLE_CONSOLE_EVENT;

var ThemeType;
(function (ThemeType) {
    ThemeType["default"] = "default";
})(ThemeType || (ThemeType = {}));

class KioskComponentsConfigurator {
    static async changeLanguage(language) {
        return i18next.changeLanguage(language);
    }
    static openConsoleSimulator() {
        const openConsoleEvent = new CustomEvent(ConsoleSimulator.ENABLE_CONSOLE_EVENT);
        window.dispatchEvent(openConsoleEvent);
    }
    static createThemeVariables(themeType, themeOptions) {
        const elementId = `${themeType}-theme-variables`;
        const exitingStyleElement = document.querySelector(`style#${elementId}`);
        const styleElement = exitingStyleElement || document.createElement('style');
        let styleRules = themeType === ThemeType.default
            ? '[class*="-kiosk-components-theme"], :root {'
            : `.with-${themeType}-kiosk-components-theme {`;
        Object.entries(themeOptions).forEach(([varKey, value]) => {
            if (!value || !varKey)
                return;
            styleRules += `${varKey}: ${value};`;
            if (varKey === '--primary-color') {
                styleRules += `--active-state-color: ${KioskComponentsConfigurator.determineActiveColor(value)};`;
                styleRules += `--primary-contrast-text-color: ${KioskComponentsConfigurator.determinePrimaryRelatedTextColor(value)};`;
            }
        });
        styleRules += 'font-family: var(--main-font);';
        if (!exitingStyleElement) {
            styleElement.id = elementId;
            document.head.appendChild(styleElement);
        }
        styleElement.innerHTML = styleRules;
    }
    static setTheme(themeType) {
        const classList = document.body.classList;
        const indexOfThemeClass = Array.from(classList).findIndex((value) => /with-.*-kiosk-components-theme/g.test(value));
        if (indexOfThemeClass >= 0) {
            const themeClass = classList[indexOfThemeClass];
            classList.remove(themeClass);
        }
        classList.add(`with-${themeType}-kiosk-components-theme`);
    }
    static determineActiveColor(hexPrimaryColor) {
        const [h, s, l] = colorConvert.hex.hsl(hexPrimaryColor);
        return `#${colorConvert.hsl.hex([h, s, l + 18])}`;
    }
    static determinePrimaryRelatedTextColor(hexPrimaryColor) {
        const [red, green, blue] = colorConvert.hex.rgb(hexPrimaryColor);
        const o = Math.round((red * 299 + green * 587 + blue * 114) / 1000);
        return o <= 180 ? 'var(--white-color)' : 'var(--black-color)';
    }
}

class LogReporter {
    static get isLocalEnv() {
        return window.location.host.includes('localhost');
    }
    static get currentDateTime() {
        return new Date().toUTCString();
    }
    static assignRemoteLogger(remoteLogger) {
        LogReporter.remoteLogger = remoteLogger;
    }
}
LogReporter.maxLogsStorageSize = 100;
LogReporter.consoleMethodsMap = {
    fatal: console.error,
    error: console.error,
    warning: console.warn,
    information: console.info,
    debug: console.debug,
    verbose: console.log,
};
LogReporter.logToStorage = (storageLogKey, logData) => {
    const savedLogsArray = LogReporter.getLogs(storageLogKey);
    if (savedLogsArray.length >= LogReporter.maxLogsStorageSize) {
        savedLogsArray.shift();
    }
    savedLogsArray.push(logData);
    window.localStorage.setItem(storageLogKey, JSON.stringify(savedLogsArray));
};
LogReporter.logMethod = (severity, consoleMethod, remoteLogMethod) => (storageLogKey, logDetails, sendLog) => {
    const { message, details } = logDetails;
    const singleLog = Object.assign(Object.assign({}, logDetails), { date: LogReporter.currentDateTime, severity });
    consoleMethod === null || consoleMethod === void 0 ? void 0 : consoleMethod(...[message, details].filter(Boolean));
    LogReporter.logToStorage(storageLogKey, singleLog);
    if (!(LogReporter.remoteLogger && sendLog))
        return;
    LogReporter.remoteLogger[remoteLogMethod](JSON.stringify(logDetails));
};
LogReporter.getLogs = (storageLogKey) => {
    const stringifiedLogs = window.localStorage.getItem(storageLogKey);
    return stringifiedLogs ? JSON.parse(stringifiedLogs) : [];
};
LogReporter.log = new Proxy({}, {
    get: (_, prop) => {
        /**
         * To avoid problems with minio in local environment
         * changes log method to debug which is not configured to be logged by default
         */
        const remoteLogMethod = LogReporter.isLocalEnv ? 'debug' : prop;
        const consoleMethod = LogReporter.consoleMethodsMap[prop];
        return LogReporter.logMethod(prop, consoleMethod, remoteLogMethod);
    },
});

// DEFLATE is a complex format; to read this code, you should probably check the RFC first:

// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array, u16 = Uint16Array, u32 = Uint32Array;
// fixed length extra bits
var fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, /* unused */ 0, 0, /* impossible */ 0]);
// fixed distance extra bits
// see fleb note
var fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, /* unused */ 0, 0]);
// code length index map
var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
// get base, reverse index map from extra bits
var freb = function (eb, start) {
    var b = new u16(31);
    for (var i = 0; i < 31; ++i) {
        b[i] = start += 1 << eb[i - 1];
    }
    // numbers here are at max 18 bits
    var r = new u32(b[30]);
    for (var i = 1; i < 30; ++i) {
        for (var j = b[i]; j < b[i + 1]; ++j) {
            r[j] = ((j - b[i]) << 5) | i;
        }
    }
    return [b, r];
};
var _a = freb(fleb, 2), fl = _a[0], revfl = _a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b[0], revfd = _b[1];
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for (var i$1 = 0; i$1 < 32768; ++i$1) {
    // reverse table algorithm from SO
    var x$1 = ((i$1 & 0xAAAA) >>> 1) | ((i$1 & 0x5555) << 1);
    x$1 = ((x$1 & 0xCCCC) >>> 2) | ((x$1 & 0x3333) << 2);
    x$1 = ((x$1 & 0xF0F0) >>> 4) | ((x$1 & 0x0F0F) << 4);
    rev[i$1] = (((x$1 & 0xFF00) >>> 8) | ((x$1 & 0x00FF) << 8)) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = (function (cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new u16(mb);
    // length of cd must be 288 (total # of codes)
    for (; i < s; ++i)
        ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new u16(mb);
    for (i = 0; i < mb; ++i) {
        le[i] = (le[i - 1] + l[i - 1]) << 1;
    }
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for (i = 0; i < s; ++i) {
            // ignore 0 lengths
            if (cd[i]) {
                // num encoding both symbol and bits read
                var sv = (i << 4) | cd[i];
                // free bits
                var r_1 = mb - cd[i];
                // start value
                var v = le[cd[i] - 1]++ << r_1;
                // m is end value
                for (var m = v | ((1 << r_1) - 1); v <= m; ++v) {
                    // every 16 bit value starting with the code yields the same result
                    co[rev[v] >>> rvb] = sv;
                }
            }
        }
    }
    else {
        co = new u16(s);
        for (i = 0; i < s; ++i)
            co[i] = rev[le[cd[i] - 1]++] >>> (15 - cd[i]);
    }
    return co;
});
// fixed length tree
var flt = new u8(288);
for (var i$1 = 0; i$1 < 144; ++i$1)
    flt[i$1] = 8;
for (var i$1 = 144; i$1 < 256; ++i$1)
    flt[i$1] = 9;
for (var i$1 = 256; i$1 < 280; ++i$1)
    flt[i$1] = 7;
for (var i$1 = 280; i$1 < 288; ++i$1)
    flt[i$1] = 8;
// fixed distance tree
var fdt = new u8(32);
for (var i$1 = 0; i$1 < 32; ++i$1)
    fdt[i$1] = 5;
// fixed length map
var flm = /*#__PURE__*/ hMap(flt, 9, 0), flrm = /*#__PURE__*/ hMap(flt, 9, 1);
// fixed distance map
var fdm = /*#__PURE__*/ hMap(fdt, 5, 0), fdrm = /*#__PURE__*/ hMap(fdt, 5, 1);
// find max of array
var max = function (a) {
    var m = a[0];
    for (var i = 1; i < a.length; ++i) {
        if (a[i] > m)
            m = a[i];
    }
    return m;
};
// read d, starting at bit p and mask with m
var bits = function (d, p, m) {
    var o = (p / 8) >> 0;
    return ((d[o] | (d[o + 1] << 8)) >>> (p & 7)) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var bits16 = function (d, p) {
    var o = (p / 8) >> 0;
    return ((d[o] | (d[o + 1] << 8) | (d[o + 2] << 16)) >>> (p & 7));
};
// get end of byte
var shft = function (p) { return ((p / 8) >> 0) + (p & 7 && 1); };
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function (v, s, e) {
    if (s == null || s < 0)
        s = 0;
    if (e == null || e > v.length)
        e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v instanceof u16 ? u16 : v instanceof u32 ? u32 : u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
// expands raw DEFLATE data
var inflt = function (dat, buf, st) {
    // source length
    var sl = dat.length;
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st)
        st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf)
        buf = new u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function (l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            st.f = final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = shft(pos) + 4, l = dat[s - 4] | (dat[s - 3] << 8), t = s + l;
                if (t > sl) {
                    if (noSt)
                        throw 'unexpected EOF';
                    break;
                }
                // ensure size
                if (noBuf)
                    cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8;
                continue;
            }
            else if (type == 1)
                lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new u8(tl);
                // code length tree
                var clt = new u8(19);
                for (var i = 0; i < hcLen; ++i) {
                    // use index map to get real code
                    clt[clim[i]] = bits(dat, pos + i * 3, 7);
                }
                pos += hcLen * 3;
                // code lengths bits
                var clb = max(clt), clbmsk = (1 << clb) - 1;
                if (!noSt && pos + tl * (clb + 7) > tbts)
                    break;
                // code lengths map
                var clm = hMap(clt, clb, 1);
                for (var i = 0; i < tl;) {
                    var r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) {
                        ldt[i++] = s;
                    }
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16)
                            n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17)
                            n = 3 + bits(dat, pos, 7), pos += 3;
                        else if (s == 18)
                            n = 11 + bits(dat, pos, 127), pos += 7;
                        while (n--)
                            ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = max(lt);
                // max dist bits
                dbt = max(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            }
            else
                throw 'invalid block type';
            if (pos > tbts)
                throw 'unexpected EOF';
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf)
            cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var mxa = lbt + dbt + 18;
        while (noSt || pos + mxa < tbts) {
            // bits read, code
            var c = lm[bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts)
                throw 'unexpected EOF';
            if (!c)
                throw 'invalid length/literal';
            if (sym < 256)
                buf[bt++] = sym;
            else if (sym == 256) {
                lm = null;
                break;
            }
            else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                var d = dm[bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d)
                    throw 'invalid distance';
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    dt += bits16(dat, pos) & ((1 << b) - 1), pos += b;
                }
                if (pos > tbts)
                    throw 'unexpected EOF';
                if (noBuf)
                    cbuf(bt + 131072);
                var end = bt + add;
                for (; bt < end; bt += 4) {
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = pos, st.b = bt;
        if (lm)
            final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    } while (!final);
    return bt == buf.length ? buf : slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var hTree = function (d, mb) {
    // Need extra info to make a tree
    var t = [];
    for (var i = 0; i < d.length; ++i) {
        if (d[i])
            t.push({ s: i, f: d[i] });
    }
    var s = t.length;
    var t2 = t.slice();
    if (!s)
        return [new u8(0), 0];
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [v, 1];
    }
    t.sort(function (a, b) { return a.f - b.f; });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({ s: -1, f: 25001 });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = { s: -1, f: l.f + r.f, l: l, r: r };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while (i1 != s - 1) {
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = { s: -1, f: l.f + r.f, l: l, r: r };
    }
    var maxSym = t2[0].s;
    for (var i = 1; i < s; ++i) {
        if (t2[i].s > maxSym)
            maxSym = t2[i].s;
    }
    // code lengths
    var tr = new u16(maxSym + 1);
    // max bits in tree
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function (a, b) { return tr[b.s] - tr[a.s] || a.f - b.f; });
        for (; i < s; ++i) {
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << (mbt - tr[i2_1]));
                tr[i2_1] = mb;
            }
            else
                break;
        }
        dt >>>= lft;
        while (dt > 0) {
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb)
                dt -= 1 << (mb - tr[i2_2]++ - 1);
            else
                ++i;
        }
        for (; i >= 0 && dt; --i) {
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [new u8(tr), mbt];
};
// get the max length and assign length codes
var ln = function (n, l, d) {
    return n.s == -1
        ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1))
        : (l[n.s] = d);
};
// length codes generation
var lc = function (c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while (s && !c[--s])
        ;
    var cl = new u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function (v) { cl[cli++] = v; };
    for (var i = 1; i <= s; ++i) {
        if (c[i] == cln && i != s)
            ++cls;
        else {
            if (!cln && cls > 2) {
                for (; cls > 138; cls -= 138)
                    w(32754);
                if (cls > 2) {
                    w(cls > 10 ? ((cls - 11) << 5) | 28690 : ((cls - 3) << 5) | 12305);
                    cls = 0;
                }
            }
            else if (cls > 3) {
                w(cln), --cls;
                for (; cls > 6; cls -= 6)
                    w(8304);
                if (cls > 2)
                    w(((cls - 3) << 5) | 8208), cls = 0;
            }
            while (cls--)
                w(cln);
            cls = 1;
            cln = c[i];
        }
    }
    return [cl.subarray(0, cli), s];
};
// calculate the length of output from tree, code lengths
var clen = function (cf, cl) {
    var l = 0;
    for (var i = 0; i < cl.length; ++i)
        l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function (out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for (var i = 0; i < s; ++i)
        out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var wblk = function (dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a = hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new u16(19);
    for (var i = 0; i < lclt.length; ++i)
        lcfreq[lclt[i] & 31]++;
    for (var i = 0; i < lcdt.length; ++i)
        lcfreq[lcdt[i] & 31]++;
    var _e = hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc)
        ;
    var flen = (bl + 5) << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen)
        return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for (var i = 0; i < nlcc; ++i)
            wbits(out, p + 3 * i, lct[clim[i]]);
        p += 3 * nlcc;
        var lcts = [lclt, lcdt];
        for (var it = 0; it < 2; ++it) {
            var clct = lcts[it];
            for (var i = 0; i < clct.length; ++i) {
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), p += lct[len];
                if (len > 15)
                    wbits(out, p, (clct[i] >>> 5) & 127), p += clct[i] >>> 12;
            }
        }
    }
    else {
        lm = flm, ll = flt, dm = fdm, dl = fdt;
    }
    for (var i = 0; i < li; ++i) {
        if (syms[i] > 255) {
            var len = (syms[i] >>> 18) & 31;
            wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7)
                wbits(out, p, (syms[i] >>> 23) & 31), p += fleb[len];
            var dst = syms[i] & 31;
            wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3)
                wbits16(out, p, (syms[i] >>> 5) & 8191), p += fdeb[dst];
        }
        else {
            wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
        }
    }
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/ new u32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
// empty
var et$1 = /*#__PURE__*/ new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function (dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.floor(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) {
        for (var i = 0; i <= s; i += 65535) {
            // end
            var e = i + 65535;
            if (e < s) {
                // write full block
                pos = wfblk(w, pos, dat.subarray(i, e));
            }
            else {
                // write final block
                w[i] = lst;
                pos = wfblk(w, pos, dat.subarray(i, s));
            }
        }
    }
    else {
        var opt = deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new u16(32768), head = new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function (i) { return (dat[i] ^ (dat[i + 1] << bs1_1) ^ (dat[i + 2] << bs2_1)) & msk_1; };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new u32(25000);
        // length/literal freq   distance freq
        var lf = new u16(288), df = new u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for (; i < s; ++i) {
            // hash value
            var hv = hsh(i);
            // index mod 32768
            var imod = i & 32767;
            // previous index with this value
            var pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for (var j = 0; j < 286; ++j)
                        lf[j] = 0;
                    for (var j = 0; j < 30; ++j)
                        df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = (imod - pimod) & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while (dif <= maxd && --ch_1 && imod != pimod) {
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for (; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl)
                                ;
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn)
                                    break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for (var j = 0; j < mmd; ++j) {
                                    var ti = (i - dif + j + 32768) & 32767;
                                    var pti = prev[ti];
                                    var cd = (ti - pti + 32768) & 32767;
                                    if (cd > md)
                                        md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += (imod - pimod + 32768) & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | (revfl[l] << 18) | revfd[d];
                    var lin = revfl[l] & 31, din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                }
                else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst)
            pos = wfblk(w, pos, et$1);
    }
    return slc(o, 0, pre + shft(pos) + post);
};
// Alder32
var adler = function () {
    var a = 1, b = 0;
    return {
        p: function (d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length;
            for (var i = 0; i != l;) {
                var e = Math.min(i + 5552, l);
                for (; i < e; ++i)
                    n += d[i], m += n;
                n %= 65521, m %= 65521;
            }
            a = n, b = m;
        },
        d: function () { return ((a >>> 8) << 16 | (b & 255) << 8 | (b >>> 8)) + ((a & 255) << 23) * 2; }
    };
};
// deflate with opts
var dopt = function (dat, opt, pre, post, st) {
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : (12 + opt.mem), pre, post, !st);
};
// write bytes
var wbytes = function (d, b, v) {
    for (; v; ++b)
        d[b] = v, v >>>= 8;
};
// zlib header
var zlh = function (c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = (fl << 6) | (fl ? (32 - 2 * fl) : 1);
};
// zlib valid
var zlv = function (d) {
    if ((d[0] & 15) != 8 || (d[0] >>> 4) > 7 || ((d[0] << 8 | d[1]) % 31))
        throw 'invalid zlib data';
    if (d[1] & 32)
        throw 'invalid zlib data: preset dictionaries not supported';
};
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */
function zlibSync(data, opts) {
    if (opts === void 0) { opts = {}; }
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function unzlibSync(data, out) {
    return inflt((zlv(data), data.subarray(2, -4)), out);
}

/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.5.1 Built on 2022-01-28T15:37:57.791Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */
var n=function(){return "undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this}();function i(){n.console&&"function"==typeof n.console.log&&n.console.log.apply(n.console,arguments);}var a={log:i,warn:function(t){n.console&&("function"==typeof n.console.warn?n.console.warn.apply(n.console,arguments):i.call(null,arguments));},error:function(t){n.console&&("function"==typeof n.console.error?n.console.error.apply(n.console,arguments):i(t));}};function o(t,e,r){var n=new XMLHttpRequest;n.open("GET",t),n.responseType="blob",n.onload=function(){l(n.response,e,r);},n.onerror=function(){a.error("could not download file");},n.send();}function s(t){var e=new XMLHttpRequest;e.open("HEAD",t,!1);try{e.send();}catch(t){}return e.status>=200&&e.status<=299}function c(t){try{t.dispatchEvent(new MouseEvent("click"));}catch(r){var e=document.createEvent("MouseEvents");e.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),t.dispatchEvent(e);}}var u,h,l=n.saveAs||("object"!==("undefined"==typeof window?"undefined":_typeof$2(window))||window!==n?function(){}:"undefined"!=typeof HTMLAnchorElement&&"download"in HTMLAnchorElement.prototype?function(t,e,r){var i=n.URL||n.webkitURL,a=document.createElement("a");e=e||t.name||"download",a.download=e,a.rel="noopener","string"==typeof t?(a.href=t,a.origin!==location.origin?s(a.href)?o(t,e,r):c(a,a.target="_blank"):c(a)):(a.href=i.createObjectURL(t),setTimeout((function(){i.revokeObjectURL(a.href);}),4e4),setTimeout((function(){c(a);}),0));}:"msSaveOrOpenBlob"in navigator?function(e,r,n){if(r=r||e.name||"download","string"==typeof e)if(s(e))o(e,r,n);else {var i=document.createElement("a");i.href=e,i.target="_blank",setTimeout((function(){c(i);}));}else navigator.msSaveOrOpenBlob(function(e,r){return void 0===r?r={autoBom:!1}:"object"!==_typeof$2(r)&&(a.warn("Deprecated: Expected third argument to be a object"),r={autoBom:!r}),r.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type)?new Blob([String.fromCharCode(65279),e],{type:e.type}):e}(e,n),r);}:function(e,r,i,a){if((a=a||open("","_blank"))&&(a.document.title=a.document.body.innerText="downloading..."),"string"==typeof e)return o(e,r,i);var s="application/octet-stream"===e.type,c=/constructor/i.test(n.HTMLElement)||n.safari,u=/CriOS\/[\d]+/.test(navigator.userAgent);if((u||s&&c)&&"object"===("undefined"==typeof FileReader?"undefined":_typeof$2(FileReader))){var h=new FileReader;h.onloadend=function(){var t=h.result;t=u?t:t.replace(/^data:[^;]*;/,"data:attachment/file;"),a?a.location.href=t:location=t,a=null;},h.readAsDataURL(e);}else {var l=n.URL||n.webkitURL,f=l.createObjectURL(e);a?a.location=f:location.href=f,a=null,setTimeout((function(){l.revokeObjectURL(f);}),4e4);}});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */function f(t){var e;t=t||"",this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6));t={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"}[t=(t=t.replace(/ /g,"")).toLowerCase()]||t;for(var r=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return [parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return [parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return [parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],n=0;n<r.length;n++){var i=r[n].re,a=r[n].process,o=i.exec(t);o&&(e=a(o),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0);}this.r=this.r<0||isNaN(this.r)?0:this.r>255?255:this.r,this.g=this.g<0||isNaN(this.g)?0:this.g>255?255:this.g,this.b=this.b<0||isNaN(this.b)?0:this.b>255?255:this.b,this.toRGB=function(){return "rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),r=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==r.length&&(r="0"+r),"#"+t+e+r};}
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */
function d(t,e){var r=t[0],n=t[1],i=t[2],a=t[3];r=g(r,n,i,a,e[0],7,-680876936),a=g(a,r,n,i,e[1],12,-389564586),i=g(i,a,r,n,e[2],17,606105819),n=g(n,i,a,r,e[3],22,-1044525330),r=g(r,n,i,a,e[4],7,-176418897),a=g(a,r,n,i,e[5],12,1200080426),i=g(i,a,r,n,e[6],17,-1473231341),n=g(n,i,a,r,e[7],22,-45705983),r=g(r,n,i,a,e[8],7,1770035416),a=g(a,r,n,i,e[9],12,-1958414417),i=g(i,a,r,n,e[10],17,-42063),n=g(n,i,a,r,e[11],22,-1990404162),r=g(r,n,i,a,e[12],7,1804603682),a=g(a,r,n,i,e[13],12,-40341101),i=g(i,a,r,n,e[14],17,-1502002290),r=m(r,n=g(n,i,a,r,e[15],22,1236535329),i,a,e[1],5,-165796510),a=m(a,r,n,i,e[6],9,-1069501632),i=m(i,a,r,n,e[11],14,643717713),n=m(n,i,a,r,e[0],20,-373897302),r=m(r,n,i,a,e[5],5,-701558691),a=m(a,r,n,i,e[10],9,38016083),i=m(i,a,r,n,e[15],14,-660478335),n=m(n,i,a,r,e[4],20,-405537848),r=m(r,n,i,a,e[9],5,568446438),a=m(a,r,n,i,e[14],9,-1019803690),i=m(i,a,r,n,e[3],14,-187363961),n=m(n,i,a,r,e[8],20,1163531501),r=m(r,n,i,a,e[13],5,-1444681467),a=m(a,r,n,i,e[2],9,-51403784),i=m(i,a,r,n,e[7],14,1735328473),r=v(r,n=m(n,i,a,r,e[12],20,-1926607734),i,a,e[5],4,-378558),a=v(a,r,n,i,e[8],11,-2022574463),i=v(i,a,r,n,e[11],16,1839030562),n=v(n,i,a,r,e[14],23,-35309556),r=v(r,n,i,a,e[1],4,-1530992060),a=v(a,r,n,i,e[4],11,1272893353),i=v(i,a,r,n,e[7],16,-155497632),n=v(n,i,a,r,e[10],23,-1094730640),r=v(r,n,i,a,e[13],4,681279174),a=v(a,r,n,i,e[0],11,-358537222),i=v(i,a,r,n,e[3],16,-722521979),n=v(n,i,a,r,e[6],23,76029189),r=v(r,n,i,a,e[9],4,-640364487),a=v(a,r,n,i,e[12],11,-421815835),i=v(i,a,r,n,e[15],16,530742520),r=b(r,n=v(n,i,a,r,e[2],23,-995338651),i,a,e[0],6,-198630844),a=b(a,r,n,i,e[7],10,1126891415),i=b(i,a,r,n,e[14],15,-1416354905),n=b(n,i,a,r,e[5],21,-57434055),r=b(r,n,i,a,e[12],6,1700485571),a=b(a,r,n,i,e[3],10,-1894986606),i=b(i,a,r,n,e[10],15,-1051523),n=b(n,i,a,r,e[1],21,-2054922799),r=b(r,n,i,a,e[8],6,1873313359),a=b(a,r,n,i,e[15],10,-30611744),i=b(i,a,r,n,e[6],15,-1560198380),n=b(n,i,a,r,e[13],21,1309151649),r=b(r,n,i,a,e[4],6,-145523070),a=b(a,r,n,i,e[11],10,-1120210379),i=b(i,a,r,n,e[2],15,718787259),n=b(n,i,a,r,e[9],21,-343485551),t[0]=_(r,t[0]),t[1]=_(n,t[1]),t[2]=_(i,t[2]),t[3]=_(a,t[3]);}function p(t,e,r,n,i,a){return e=_(_(e,t),_(n,a)),_(e<<i|e>>>32-i,r)}function g(t,e,r,n,i,a,o){return p(e&r|~e&n,t,e,i,a,o)}function m(t,e,r,n,i,a,o){return p(e&n|r&~n,t,e,i,a,o)}function v(t,e,r,n,i,a,o){return p(e^r^n,t,e,i,a,o)}function b(t,e,r,n,i,a,o){return p(r^(e|~n),t,e,i,a,o)}function y(t){var e,r=t.length,n=[1732584193,-271733879,-1732584194,271733878];for(e=64;e<=t.length;e+=64)d(n,w(t.substring(e-64,e)));t=t.substring(e-64);var i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(e=0;e<t.length;e++)i[e>>2]|=t.charCodeAt(e)<<(e%4<<3);if(i[e>>2]|=128<<(e%4<<3),e>55)for(d(n,i),e=0;e<16;e++)i[e]=0;return i[14]=8*r,d(n,i),n}function w(t){var e,r=[];for(e=0;e<64;e+=4)r[e>>2]=t.charCodeAt(e)+(t.charCodeAt(e+1)<<8)+(t.charCodeAt(e+2)<<16)+(t.charCodeAt(e+3)<<24);return r}u=n.atob.bind(n),h=n.btoa.bind(n);var N="0123456789abcdef".split("");function L(t){for(var e="",r=0;r<4;r++)e+=N[t>>8*r+4&15]+N[t>>8*r&15];return e}function A(t){return String.fromCharCode((255&t)>>0,(65280&t)>>8,(16711680&t)>>16,(4278190080&t)>>24)}function x(t){return y(t).map(A).join("")}var S="5d41402abc4b2a76b9719d911017c592"!=function(t){for(var e=0;e<t.length;e++)t[e]=L(t[e]);return t.join("")}(y("hello"));function _(t,e){if(S){var r=(65535&t)+(65535&e);return (t>>16)+(e>>16)+(r>>16)<<16|65535&r}return t+e&4294967295}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */function P(t,e){var r,n,i,a;if(t!==r){for(var o=(i=t,a=1+(256/t.length>>0),new Array(a+1).join(i)),s=[],c=0;c<256;c++)s[c]=c;var u=0;for(c=0;c<256;c++){var h=s[c];u=(u+h+o.charCodeAt(c))%256,s[c]=s[u],s[u]=h;}r=t,n=s;}else s=n;var l=e.length,f=0,d=0,p="";for(c=0;c<l;c++)d=(d+(h=s[f=(f+1)%256]))%256,s[f]=s[d],s[d]=h,o=s[(s[f]+s[d])%256],p+=String.fromCharCode(e.charCodeAt(c)^o);return p}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */var k={print:4,modify:8,copy:16,"annot-forms":32};function I(t,e,r,n){this.v=1,this.r=2;var i=192;t.forEach((function(t){i+=k[t];})),this.padding="(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";var a=(e+this.padding).substr(0,32),o=(r+this.padding).substr(0,32);this.O=this.processOwnerPassword(a,o),this.P=-(1+(255^i)),this.encryptionKey=x(a+this.O+this.lsbFirstWord(this.P)+this.hexToBytes(n)).substr(0,5),this.U=P(this.encryptionKey,this.padding);}function F(t){if(/[^\u0000-\u00ff]/.test(t))throw new Error("Invalid PDF Name Object: "+t+", Only accept ASCII characters.");for(var e="",r=t.length,n=0;n<r;n++){var i=t.charCodeAt(n);if(i<33||35===i||37===i||40===i||41===i||47===i||60===i||62===i||91===i||93===i||123===i||125===i||i>126)e+="#"+("0"+i.toString(16)).slice(-2);else e+=t[n];}return e}function C(e){if("object"!==_typeof$2(e))throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");var r={};this.subscribe=function(t,e,n){if(n=n||!1,"string"!=typeof t||"function"!=typeof e||"boolean"!=typeof n)throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");r.hasOwnProperty(t)||(r[t]={});var i=Math.random().toString(35);return r[t][i]=[e,!!n],i},this.unsubscribe=function(t){for(var e in r)if(r[e][t])return delete r[e][t],0===Object.keys(r[e]).length&&delete r[e],!0;return !1},this.publish=function(t){if(r.hasOwnProperty(t)){var i=Array.prototype.slice.call(arguments,1),o=[];for(var s in r[t]){var c=r[t][s];try{c[0].apply(e,i);}catch(t){n.console&&a.error("jsPDF PubSub Error",t.message,t);}c[1]&&o.push(s);}o.length&&o.forEach(this.unsubscribe);}},this.getTopics=function(){return r};}function j(t){if(!(this instanceof j))return new j(t);var e="opacity,stroke-opacity".split(",");for(var r in t)t.hasOwnProperty(r)&&e.indexOf(r)>=0&&(this[r]=t[r]);this.id="",this.objectNumber=-1;}function O(t,e){this.gState=t,this.matrix=e,this.id="",this.objectNumber=-1;}function B(t,e,r,n,i){if(!(this instanceof B))return new B(t,e,r,n,i);this.type="axial"===t?2:3,this.coords=e,this.colors=r,O.call(this,n,i);}function M(t,e,r,n,i){if(!(this instanceof M))return new M(t,e,r,n,i);this.boundingBox=t,this.xStep=e,this.yStep=r,this.stream="",this.cloneIndex=0,O.call(this,n,i);}function E(e){var r,i="string"==typeof arguments[0]?arguments[0]:"p",o=arguments[1],s=arguments[2],c=arguments[3],u=[],d=1,p=16,g="S",m=null;"object"===_typeof$2(e=e||{})&&(i=e.orientation,o=e.unit||o,s=e.format||s,c=e.compress||e.compressPdf||c,null!==(m=e.encryption||null)&&(m.userPassword=m.userPassword||"",m.ownerPassword=m.ownerPassword||"",m.userPermissions=m.userPermissions||[]),d="number"==typeof e.userUnit?Math.abs(e.userUnit):1,void 0!==e.precision&&(r=e.precision),void 0!==e.floatPrecision&&(p=e.floatPrecision),g=e.defaultPathOperation||"S"),u=e.filters||(!0===c?["FlateEncode"]:u),o=o||"mm",i=(""+(i||"P")).toLowerCase();var v=e.putOnlyUsedFonts||!1,b={},y={internal:{},__private__:{}};y.__private__.PubSub=C;var w="1.3",N=y.__private__.getPdfVersion=function(){return w};y.__private__.setPdfVersion=function(t){w=t;};var L={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};y.__private__.getPageFormats=function(){return L};var A=y.__private__.getPageFormat=function(t){return L[t]};s=s||"a4";var x={COMPAT:"compat",ADVANCED:"advanced"},S=x.COMPAT;function _(){this.saveGraphicsState(),lt(new Vt(_t,0,0,-_t,0,Rr()*_t).toString()+" cm"),this.setFontSize(this.getFontSize()/_t),g="n",S=x.ADVANCED;}function P(){this.restoreGraphicsState(),g="S",S=x.COMPAT;}var k=y.__private__.combineFontStyleAndFontWeight=function(t,e){if("bold"==t&&"normal"==e||"bold"==t&&400==e||"normal"==t&&"italic"==e||"bold"==t&&"italic"==e)throw new Error("Invalid Combination of fontweight and fontstyle");return e&&(t=400==e||"normal"===e?"italic"===t?"italic":"normal":700!=e&&"bold"!==e||"normal"!==t?(700==e?"bold":e)+""+t:"bold"),t};y.advancedAPI=function(t){var e=S===x.COMPAT;return e&&_.call(this),"function"!=typeof t||(t(this),e&&P.call(this)),this},y.compatAPI=function(t){var e=S===x.ADVANCED;return e&&P.call(this),"function"!=typeof t||(t(this),e&&_.call(this)),this},y.isAdvancedAPI=function(){return S===x.ADVANCED};var O,q=function(t){if(S!==x.ADVANCED)throw new Error(t+" is only available in 'advanced' API mode. You need to call advancedAPI() first.")},D=y.roundToPrecision=y.__private__.roundToPrecision=function(t,e){var n=r||e;if(isNaN(t)||isNaN(n))throw new Error("Invalid argument passed to jsPDF.roundToPrecision");return t.toFixed(n).replace(/0+$/,"")};O=y.hpf=y.__private__.hpf="number"==typeof p?function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return D(t,p)}:"smart"===p?function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return D(t,t>-1&&t<1?16:5)}:function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return D(t,16)};var R=y.f2=y.__private__.f2=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return D(t,2)},T=y.__private__.f3=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f3");return D(t,3)},U=y.scale=y.__private__.scale=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.scale");return S===x.COMPAT?t*_t:S===x.ADVANCED?t:void 0},z=function(t){return S===x.COMPAT?Rr()-t:S===x.ADVANCED?t:void 0},H=function(t){return U(z(t))};y.__private__.setPrecision=y.setPrecision=function(t){"number"==typeof parseInt(t,10)&&(r=parseInt(t,10));};var W,V="00000000000000000000000000000000",G=y.__private__.getFileId=function(){return V},Y=y.__private__.setFileId=function(t){return V=void 0!==t&&/^[a-fA-F0-9]{32}$/.test(t)?t.toUpperCase():V.split("").map((function(){return "ABCDEF0123456789".charAt(Math.floor(16*Math.random()))})).join(""),null!==m&&(Ye=new I(m.userPermissions,m.userPassword,m.ownerPassword,V)),V};y.setFileId=function(t){return Y(t),this},y.getFileId=function(){return G()};var J=y.__private__.convertDateToPDFDate=function(t){var e=t.getTimezoneOffset(),r=e<0?"+":"-",n=Math.floor(Math.abs(e/60)),i=Math.abs(e%60),a=[r,Q(n),"'",Q(i),"'"].join("");return ["D:",t.getFullYear(),Q(t.getMonth()+1),Q(t.getDate()),Q(t.getHours()),Q(t.getMinutes()),Q(t.getSeconds()),a].join("")},X=y.__private__.convertPDFDateToDate=function(t){var e=parseInt(t.substr(2,4),10),r=parseInt(t.substr(6,2),10)-1,n=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),a=parseInt(t.substr(12,2),10),o=parseInt(t.substr(14,2),10);return new Date(e,r,n,i,a,o,0)},K=y.__private__.setCreationDate=function(t){var e;if(void 0===t&&(t=new Date),t instanceof Date)e=J(t);else {if(!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t))throw new Error("Invalid argument passed to jsPDF.setCreationDate");e=t;}return W=e},Z=y.__private__.getCreationDate=function(t){var e=W;return "jsDate"===t&&(e=X(W)),e};y.setCreationDate=function(t){return K(t),this},y.getCreationDate=function(t){return Z(t)};var $,Q=y.__private__.padd2=function(t){return ("0"+parseInt(t)).slice(-2)},tt=y.__private__.padd2Hex=function(t){return ("00"+(t=t.toString())).substr(t.length)},et=0,rt=[],nt=[],it=0,at=[],ot=[],st=!1,ct=nt,ut=function(){et=0,it=0,nt=[],rt=[],at=[],Qt=Kt(),te=Kt();};y.__private__.setCustomOutputDestination=function(t){st=!0,ct=t;};var ht=function(t){st||(ct=t);};y.__private__.resetCustomOutputDestination=function(){st=!1,ct=nt;};var lt=y.__private__.out=function(t){return t=t.toString(),it+=t.length+1,ct.push(t),ct},ft=y.__private__.write=function(t){return lt(1===arguments.length?t.toString():Array.prototype.join.call(arguments," "))},dt=y.__private__.getArrayBuffer=function(t){for(var e=t.length,r=new ArrayBuffer(e),n=new Uint8Array(r);e--;)n[e]=t.charCodeAt(e);return r},pt=[["Helvetica","helvetica","normal","WinAnsiEncoding"],["Helvetica-Bold","helvetica","bold","WinAnsiEncoding"],["Helvetica-Oblique","helvetica","italic","WinAnsiEncoding"],["Helvetica-BoldOblique","helvetica","bolditalic","WinAnsiEncoding"],["Courier","courier","normal","WinAnsiEncoding"],["Courier-Bold","courier","bold","WinAnsiEncoding"],["Courier-Oblique","courier","italic","WinAnsiEncoding"],["Courier-BoldOblique","courier","bolditalic","WinAnsiEncoding"],["Times-Roman","times","normal","WinAnsiEncoding"],["Times-Bold","times","bold","WinAnsiEncoding"],["Times-Italic","times","italic","WinAnsiEncoding"],["Times-BoldItalic","times","bolditalic","WinAnsiEncoding"],["ZapfDingbats","zapfdingbats","normal",null],["Symbol","symbol","normal",null]];y.__private__.getStandardFonts=function(){return pt};var gt=e.fontSize||16;y.__private__.setFontSize=y.setFontSize=function(t){return gt=S===x.ADVANCED?t/_t:t,this};var mt,vt=y.__private__.getFontSize=y.getFontSize=function(){return S===x.COMPAT?gt:gt*_t},bt=e.R2L||!1;y.__private__.setR2L=y.setR2L=function(t){return bt=t,this},y.__private__.getR2L=y.getR2L=function(){return bt};var yt,wt=y.__private__.setZoomMode=function(t){var e=[void 0,null,"fullwidth","fullheight","fullpage","original"];if(/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t))mt=t;else if(isNaN(t)){if(-1===e.indexOf(t))throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "'+t+'" is not recognized.');mt=t;}else mt=parseInt(t,10);};y.__private__.getZoomMode=function(){return mt};var Nt,Lt=y.__private__.setPageMode=function(t){if(-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(t))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+t+'" is not recognized.');yt=t;};y.__private__.getPageMode=function(){return yt};var At=y.__private__.setLayoutMode=function(t){if(-1==[void 0,null,"continuous","single","twoleft","tworight","two"].indexOf(t))throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "'+t+'" is not recognized.');Nt=t;};y.__private__.getLayoutMode=function(){return Nt},y.__private__.setDisplayMode=y.setDisplayMode=function(t,e,r){return wt(t),At(e),Lt(r),this};var xt={title:"",subject:"",author:"",keywords:"",creator:""};y.__private__.getDocumentProperty=function(t){if(-1===Object.keys(xt).indexOf(t))throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");return xt[t]},y.__private__.getDocumentProperties=function(){return xt},y.__private__.setDocumentProperties=y.setProperties=y.setDocumentProperties=function(t){for(var e in xt)xt.hasOwnProperty(e)&&t[e]&&(xt[e]=t[e]);return this},y.__private__.setDocumentProperty=function(t,e){if(-1===Object.keys(xt).indexOf(t))throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");return xt[t]=e};var St,_t,Pt,kt,It,Ft={},Ct={},jt=[],Ot={},Bt={},Mt={},Et={},qt=null,Dt=0,Rt=[],Tt=new C(y),Ut=e.hotfixes||[],zt={},Ht={},Wt=[],Vt=function t(e,r,n,i,a,o){if(!(this instanceof t))return new t(e,r,n,i,a,o);isNaN(e)&&(e=1),isNaN(r)&&(r=0),isNaN(n)&&(n=0),isNaN(i)&&(i=1),isNaN(a)&&(a=0),isNaN(o)&&(o=0),this._matrix=[e,r,n,i,a,o];};Object.defineProperty(Vt.prototype,"sx",{get:function(){return this._matrix[0]},set:function(t){this._matrix[0]=t;}}),Object.defineProperty(Vt.prototype,"shy",{get:function(){return this._matrix[1]},set:function(t){this._matrix[1]=t;}}),Object.defineProperty(Vt.prototype,"shx",{get:function(){return this._matrix[2]},set:function(t){this._matrix[2]=t;}}),Object.defineProperty(Vt.prototype,"sy",{get:function(){return this._matrix[3]},set:function(t){this._matrix[3]=t;}}),Object.defineProperty(Vt.prototype,"tx",{get:function(){return this._matrix[4]},set:function(t){this._matrix[4]=t;}}),Object.defineProperty(Vt.prototype,"ty",{get:function(){return this._matrix[5]},set:function(t){this._matrix[5]=t;}}),Object.defineProperty(Vt.prototype,"a",{get:function(){return this._matrix[0]},set:function(t){this._matrix[0]=t;}}),Object.defineProperty(Vt.prototype,"b",{get:function(){return this._matrix[1]},set:function(t){this._matrix[1]=t;}}),Object.defineProperty(Vt.prototype,"c",{get:function(){return this._matrix[2]},set:function(t){this._matrix[2]=t;}}),Object.defineProperty(Vt.prototype,"d",{get:function(){return this._matrix[3]},set:function(t){this._matrix[3]=t;}}),Object.defineProperty(Vt.prototype,"e",{get:function(){return this._matrix[4]},set:function(t){this._matrix[4]=t;}}),Object.defineProperty(Vt.prototype,"f",{get:function(){return this._matrix[5]},set:function(t){this._matrix[5]=t;}}),Object.defineProperty(Vt.prototype,"rotation",{get:function(){return Math.atan2(this.shx,this.sx)}}),Object.defineProperty(Vt.prototype,"scaleX",{get:function(){return this.decompose().scale.sx}}),Object.defineProperty(Vt.prototype,"scaleY",{get:function(){return this.decompose().scale.sy}}),Object.defineProperty(Vt.prototype,"isIdentity",{get:function(){return 1===this.sx&&(0===this.shy&&(0===this.shx&&(1===this.sy&&(0===this.tx&&0===this.ty))))}}),Vt.prototype.join=function(t){return [this.sx,this.shy,this.shx,this.sy,this.tx,this.ty].map(O).join(t)},Vt.prototype.multiply=function(t){var e=t.sx*this.sx+t.shy*this.shx,r=t.sx*this.shy+t.shy*this.sy,n=t.shx*this.sx+t.sy*this.shx,i=t.shx*this.shy+t.sy*this.sy,a=t.tx*this.sx+t.ty*this.shx+this.tx,o=t.tx*this.shy+t.ty*this.sy+this.ty;return new Vt(e,r,n,i,a,o)},Vt.prototype.decompose=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty,o=Math.sqrt(t*t+e*e),s=(t/=o)*r+(e/=o)*n;r-=t*s,n-=e*s;var c=Math.sqrt(r*r+n*n);return s/=c,t*(n/=c)<e*(r/=c)&&(t=-t,e=-e,s=-s,o=-o),{scale:new Vt(o,0,0,c,0,0),translate:new Vt(1,0,0,1,i,a),rotate:new Vt(t,e,-e,t,0,0),skew:new Vt(1,0,s,1,0,0)}},Vt.prototype.toString=function(t){return this.join(" ")},Vt.prototype.inversed=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty,o=1/(t*n-e*r),s=n*o,c=-e*o,u=-r*o,h=t*o;return new Vt(s,c,u,h,-s*i-u*a,-c*i-h*a)},Vt.prototype.applyToPoint=function(t){var e=t.x*this.sx+t.y*this.shx+this.tx,r=t.x*this.shy+t.y*this.sy+this.ty;return new Cr(e,r)},Vt.prototype.applyToRectangle=function(t){var e=this.applyToPoint(t),r=this.applyToPoint(new Cr(t.x+t.w,t.y+t.h));return new jr(e.x,e.y,r.x-e.x,r.y-e.y)},Vt.prototype.clone=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty;return new Vt(t,e,r,n,i,a)},y.Matrix=Vt;var Gt=y.matrixMult=function(t,e){return e.multiply(t)},Yt=new Vt(1,0,0,1,0,0);y.unitMatrix=y.identityMatrix=Yt;var Jt=function(t,e){if(!Bt[t]){var r=(e instanceof B?"Sh":"P")+(Object.keys(Ot).length+1).toString(10);e.id=r,Bt[t]=r,Ot[r]=e,Tt.publish("addPattern",e);}};y.ShadingPattern=B,y.TilingPattern=M,y.addShadingPattern=function(t,e){return q("addShadingPattern()"),Jt(t,e),this},y.beginTilingPattern=function(t){q("beginTilingPattern()"),Br(t.boundingBox[0],t.boundingBox[1],t.boundingBox[2]-t.boundingBox[0],t.boundingBox[3]-t.boundingBox[1],t.matrix);},y.endTilingPattern=function(t,e){q("endTilingPattern()"),e.stream=ot[$].join("\n"),Jt(t,e),Tt.publish("endTilingPattern",e),Wt.pop().restore();};var Xt=y.__private__.newObject=function(){var t=Kt();return Zt(t,!0),t},Kt=y.__private__.newObjectDeferred=function(){return et++,rt[et]=function(){return it},et},Zt=function(t,e){return e="boolean"==typeof e&&e,rt[t]=it,e&&lt(t+" 0 obj"),t},$t=y.__private__.newAdditionalObject=function(){var t={objId:Kt(),content:""};return at.push(t),t},Qt=Kt(),te=Kt(),ee=y.__private__.decodeColorString=function(t){var e=t.split(" ");if(2!==e.length||"g"!==e[1]&&"G"!==e[1]){if(5===e.length&&("k"===e[4]||"K"===e[4])){e=[(1-e[0])*(1-e[3]),(1-e[1])*(1-e[3]),(1-e[2])*(1-e[3]),"r"];}}else {var r=parseFloat(e[0]);e=[r,r,r,"r"];}for(var n="#",i=0;i<3;i++)n+=("0"+Math.floor(255*parseFloat(e[i])).toString(16)).slice(-2);return n},re=y.__private__.encodeColorString=function(e){var r;"string"==typeof e&&(e={ch1:e});var n=e.ch1,i=e.ch2,a=e.ch3,o=e.ch4,s="draw"===e.pdfColorType?["G","RG","K"]:["g","rg","k"];if("string"==typeof n&&"#"!==n.charAt(0)){var c=new f(n);if(c.ok)n=c.toHex();else if(!/^\d*\.?\d*$/.test(n))throw new Error('Invalid color "'+n+'" passed to jsPDF.encodeColorString.')}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var u=parseInt(n.substr(1),16);n=u>>16&255,i=u>>8&255,a=255&u;}if(void 0===i||void 0===o&&n===i&&i===a)if("string"==typeof n)r=n+" "+s[0];else switch(e.precision){case 2:r=R(n/255)+" "+s[0];break;case 3:default:r=T(n/255)+" "+s[0];}else if(void 0===o||"object"===_typeof$2(o)){if(o&&!isNaN(o.a)&&0===o.a)return r=["1.","1.","1.",s[1]].join(" ");if("string"==typeof n)r=[n,i,a,s[1]].join(" ");else switch(e.precision){case 2:r=[R(n/255),R(i/255),R(a/255),s[1]].join(" ");break;default:case 3:r=[T(n/255),T(i/255),T(a/255),s[1]].join(" ");}}else if("string"==typeof n)r=[n,i,a,o,s[2]].join(" ");else switch(e.precision){case 2:r=[R(n),R(i),R(a),R(o),s[2]].join(" ");break;case 3:default:r=[T(n),T(i),T(a),T(o),s[2]].join(" ");}return r},ne=y.__private__.getFilters=function(){return u},ie=y.__private__.putStream=function(t){var e=(t=t||{}).data||"",r=t.filters||ne(),n=t.alreadyAppliedFilters||[],i=t.addLength1||!1,a=e.length,o=t.objectId,s=function(t){return t};if(null!==m&&void 0===o)throw new Error("ObjectId must be passed to putStream for file encryption");null!==m&&(s=Ye.encryptor(o,0));var c={};!0===r&&(r=["FlateEncode"]);var u=t.additionalKeyValues||[],h=(c=void 0!==E.API.processDataByFilters?E.API.processDataByFilters(e,r):{data:e,reverseChain:[]}).reverseChain+(Array.isArray(n)?n.join(" "):n.toString());if(0!==c.data.length&&(u.push({key:"Length",value:c.data.length}),!0===i&&u.push({key:"Length1",value:a})),0!=h.length)if(h.split("/").length-1==1)u.push({key:"Filter",value:h});else {u.push({key:"Filter",value:"["+h+"]"});for(var l=0;l<u.length;l+=1)if("DecodeParms"===u[l].key){for(var f=[],d=0;d<c.reverseChain.split("/").length-1;d+=1)f.push("null");f.push(u[l].value),u[l].value="["+f.join(" ")+"]";}}lt("<<");for(var p=0;p<u.length;p++)lt("/"+u[p].key+" "+u[p].value);lt(">>"),0!==c.data.length&&(lt("stream"),lt(s(c.data)),lt("endstream"));},ae=y.__private__.putPage=function(t){var e=t.number,r=t.data,n=t.objId,i=t.contentsObjId;Zt(n,!0),lt("<</Type /Page"),lt("/Parent "+t.rootDictionaryObjId+" 0 R"),lt("/Resources "+t.resourceDictionaryObjId+" 0 R"),lt("/MediaBox ["+parseFloat(O(t.mediaBox.bottomLeftX))+" "+parseFloat(O(t.mediaBox.bottomLeftY))+" "+O(t.mediaBox.topRightX)+" "+O(t.mediaBox.topRightY)+"]"),null!==t.cropBox&&lt("/CropBox ["+O(t.cropBox.bottomLeftX)+" "+O(t.cropBox.bottomLeftY)+" "+O(t.cropBox.topRightX)+" "+O(t.cropBox.topRightY)+"]"),null!==t.bleedBox&&lt("/BleedBox ["+O(t.bleedBox.bottomLeftX)+" "+O(t.bleedBox.bottomLeftY)+" "+O(t.bleedBox.topRightX)+" "+O(t.bleedBox.topRightY)+"]"),null!==t.trimBox&&lt("/TrimBox ["+O(t.trimBox.bottomLeftX)+" "+O(t.trimBox.bottomLeftY)+" "+O(t.trimBox.topRightX)+" "+O(t.trimBox.topRightY)+"]"),null!==t.artBox&&lt("/ArtBox ["+O(t.artBox.bottomLeftX)+" "+O(t.artBox.bottomLeftY)+" "+O(t.artBox.topRightX)+" "+O(t.artBox.topRightY)+"]"),"number"==typeof t.userUnit&&1!==t.userUnit&&lt("/UserUnit "+t.userUnit),Tt.publish("putPage",{objId:n,pageContext:Rt[e],pageNumber:e,page:r}),lt("/Contents "+i+" 0 R"),lt(">>"),lt("endobj");var a=r.join("\n");return S===x.ADVANCED&&(a+="\nQ"),Zt(i,!0),ie({data:a,filters:ne(),objectId:i}),lt("endobj"),n},oe=y.__private__.putPages=function(){var t,e,r=[];for(t=1;t<=Dt;t++)Rt[t].objId=Kt(),Rt[t].contentsObjId=Kt();for(t=1;t<=Dt;t++)r.push(ae({number:t,data:ot[t],objId:Rt[t].objId,contentsObjId:Rt[t].contentsObjId,mediaBox:Rt[t].mediaBox,cropBox:Rt[t].cropBox,bleedBox:Rt[t].bleedBox,trimBox:Rt[t].trimBox,artBox:Rt[t].artBox,userUnit:Rt[t].userUnit,rootDictionaryObjId:Qt,resourceDictionaryObjId:te}));Zt(Qt,!0),lt("<</Type /Pages");var n="/Kids [";for(e=0;e<Dt;e++)n+=r[e]+" 0 R ";lt(n+"]"),lt("/Count "+Dt),lt(">>"),lt("endobj"),Tt.publish("postPutPages");},se=function(t){Tt.publish("putFont",{font:t,out:lt,newObject:Xt,putStream:ie}),!0!==t.isAlreadyPutted&&(t.objectNumber=Xt(),lt("<<"),lt("/Type /Font"),lt("/BaseFont /"+F(t.postScriptName)),lt("/Subtype /Type1"),"string"==typeof t.encoding&&lt("/Encoding /"+t.encoding),lt("/FirstChar 32"),lt("/LastChar 255"),lt(">>"),lt("endobj"));},ce=function(){for(var t in Ft)Ft.hasOwnProperty(t)&&(!1===v||!0===v&&b.hasOwnProperty(t))&&se(Ft[t]);},ue=function(t){t.objectNumber=Xt();var e=[];e.push({key:"Type",value:"/XObject"}),e.push({key:"Subtype",value:"/Form"}),e.push({key:"BBox",value:"["+[O(t.x),O(t.y),O(t.x+t.width),O(t.y+t.height)].join(" ")+"]"}),e.push({key:"Matrix",value:"["+t.matrix.toString()+"]"});var r=t.pages[1].join("\n");ie({data:r,additionalKeyValues:e,objectId:t.objectNumber}),lt("endobj");},he=function(){for(var t in zt)zt.hasOwnProperty(t)&&ue(zt[t]);},le=function(t,e){var r,n=[],i=1/(e-1);for(r=0;r<1;r+=i)n.push(r);if(n.push(1),0!=t[0].offset){var a={offset:0,color:t[0].color};t.unshift(a);}if(1!=t[t.length-1].offset){var o={offset:1,color:t[t.length-1].color};t.push(o);}for(var s="",c=0,u=0;u<n.length;u++){for(r=n[u];r>t[c+1].offset;)c++;var h=t[c].offset,l=(r-h)/(t[c+1].offset-h),f=t[c].color,d=t[c+1].color;s+=tt(Math.round((1-l)*f[0]+l*d[0]).toString(16))+tt(Math.round((1-l)*f[1]+l*d[1]).toString(16))+tt(Math.round((1-l)*f[2]+l*d[2]).toString(16));}return s.trim()},fe=function(t,e){e||(e=21);var r=Xt(),n=le(t.colors,e),i=[];i.push({key:"FunctionType",value:"0"}),i.push({key:"Domain",value:"[0.0 1.0]"}),i.push({key:"Size",value:"["+e+"]"}),i.push({key:"BitsPerSample",value:"8"}),i.push({key:"Range",value:"[0.0 1.0 0.0 1.0 0.0 1.0]"}),i.push({key:"Decode",value:"[0.0 1.0 0.0 1.0 0.0 1.0]"}),ie({data:n,additionalKeyValues:i,alreadyAppliedFilters:["/ASCIIHexDecode"],objectId:r}),lt("endobj"),t.objectNumber=Xt(),lt("<< /ShadingType "+t.type),lt("/ColorSpace /DeviceRGB");var a="/Coords ["+O(parseFloat(t.coords[0]))+" "+O(parseFloat(t.coords[1]))+" ";2===t.type?a+=O(parseFloat(t.coords[2]))+" "+O(parseFloat(t.coords[3])):a+=O(parseFloat(t.coords[2]))+" "+O(parseFloat(t.coords[3]))+" "+O(parseFloat(t.coords[4]))+" "+O(parseFloat(t.coords[5])),lt(a+="]"),t.matrix&&lt("/Matrix ["+t.matrix.toString()+"]"),lt("/Function "+r+" 0 R"),lt("/Extend [true true]"),lt(">>"),lt("endobj");},de=function(t,e){var r=Kt(),n=Xt();e.push({resourcesOid:r,objectOid:n}),t.objectNumber=n;var i=[];i.push({key:"Type",value:"/Pattern"}),i.push({key:"PatternType",value:"1"}),i.push({key:"PaintType",value:"1"}),i.push({key:"TilingType",value:"1"}),i.push({key:"BBox",value:"["+t.boundingBox.map(O).join(" ")+"]"}),i.push({key:"XStep",value:O(t.xStep)}),i.push({key:"YStep",value:O(t.yStep)}),i.push({key:"Resources",value:r+" 0 R"}),t.matrix&&i.push({key:"Matrix",value:"["+t.matrix.toString()+"]"}),ie({data:t.stream,additionalKeyValues:i,objectId:t.objectNumber}),lt("endobj");},pe=function(t){var e;for(e in Ot)Ot.hasOwnProperty(e)&&(Ot[e]instanceof B?fe(Ot[e]):Ot[e]instanceof M&&de(Ot[e],t));},ge=function(t){for(var e in t.objectNumber=Xt(),lt("<<"),t)switch(e){case"opacity":lt("/ca "+R(t[e]));break;case"stroke-opacity":lt("/CA "+R(t[e]));}lt(">>"),lt("endobj");},me=function(){var t;for(t in Mt)Mt.hasOwnProperty(t)&&ge(Mt[t]);},ve=function(){for(var t in lt("/XObject <<"),zt)zt.hasOwnProperty(t)&&zt[t].objectNumber>=0&&lt("/"+t+" "+zt[t].objectNumber+" 0 R");Tt.publish("putXobjectDict"),lt(">>");},be=function(){Ye.oid=Xt(),lt("<<"),lt("/Filter /Standard"),lt("/V "+Ye.v),lt("/R "+Ye.r),lt("/U <"+Ye.toHexString(Ye.U)+">"),lt("/O <"+Ye.toHexString(Ye.O)+">"),lt("/P "+Ye.P),lt(">>"),lt("endobj");},ye=function(){for(var t in lt("/Font <<"),Ft)Ft.hasOwnProperty(t)&&(!1===v||!0===v&&b.hasOwnProperty(t))&&lt("/"+t+" "+Ft[t].objectNumber+" 0 R");lt(">>");},we=function(){if(Object.keys(Ot).length>0){for(var t in lt("/Shading <<"),Ot)Ot.hasOwnProperty(t)&&Ot[t]instanceof B&&Ot[t].objectNumber>=0&&lt("/"+t+" "+Ot[t].objectNumber+" 0 R");Tt.publish("putShadingPatternDict"),lt(">>");}},Ne=function(t){if(Object.keys(Ot).length>0){for(var e in lt("/Pattern <<"),Ot)Ot.hasOwnProperty(e)&&Ot[e]instanceof y.TilingPattern&&Ot[e].objectNumber>=0&&Ot[e].objectNumber<t&&lt("/"+e+" "+Ot[e].objectNumber+" 0 R");Tt.publish("putTilingPatternDict"),lt(">>");}},Le=function(){if(Object.keys(Mt).length>0){var t;for(t in lt("/ExtGState <<"),Mt)Mt.hasOwnProperty(t)&&Mt[t].objectNumber>=0&&lt("/"+t+" "+Mt[t].objectNumber+" 0 R");Tt.publish("putGStateDict"),lt(">>");}},Ae=function(t){Zt(t.resourcesOid,!0),lt("<<"),lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),ye(),we(),Ne(t.objectOid),Le(),ve(),lt(">>"),lt("endobj");},xe=function(){var t=[];ce(),me(),he(),pe(t),Tt.publish("putResources"),t.forEach(Ae),Ae({resourcesOid:te,objectOid:Number.MAX_SAFE_INTEGER}),Tt.publish("postPutResources");},Se=function(){Tt.publish("putAdditionalObjects");for(var t=0;t<at.length;t++){var e=at[t];Zt(e.objId,!0),lt(e.content),lt("endobj");}Tt.publish("postPutAdditionalObjects");},_e=function(t){Ct[t.fontName]=Ct[t.fontName]||{},Ct[t.fontName][t.fontStyle]=t.id;},Pe=function(t,e,r,n,i){var a={id:"F"+(Object.keys(Ft).length+1).toString(10),postScriptName:t,fontName:e,fontStyle:r,encoding:n,isStandardFont:i||!1,metadata:{}};return Tt.publish("addFont",{font:a,instance:this}),Ft[a.id]=a,_e(a),a.id},ke=function(t){for(var e=0,r=pt.length;e<r;e++){var n=Pe.call(this,t[e][0],t[e][1],t[e][2],pt[e][3],!0);!1===v&&(b[n]=!0);var i=t[e][0].split("-");_e({id:n,fontName:i[0],fontStyle:i[1]||""});}Tt.publish("addFonts",{fonts:Ft,dictionary:Ct});},Ie=function(t){return t.foo=function(){try{return t.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var r="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!n.console)throw new Error(r);n.console.error(r,t),n.alert&&alert(r);}},t.foo.bar=t,t.foo},Fe=function(t,e){var r,n,i,a,o,s,c,u,h;if(i=(e=e||{}).sourceEncoding||"Unicode",o=e.outputEncoding,(e.autoencode||o)&&Ft[St].metadata&&Ft[St].metadata[i]&&Ft[St].metadata[i].encoding&&(a=Ft[St].metadata[i].encoding,!o&&Ft[St].encoding&&(o=Ft[St].encoding),!o&&a.codePages&&(o=a.codePages[0]),"string"==typeof o&&(o=a[o]),o)){for(c=!1,s=[],r=0,n=t.length;r<n;r++)(u=o[t.charCodeAt(r)])?s.push(String.fromCharCode(u)):s.push(t[r]),s[r].charCodeAt(0)>>8&&(c=!0);t=s.join("");}for(r=t.length;void 0===c&&0!==r;)t.charCodeAt(r-1)>>8&&(c=!0),r--;if(!c)return t;for(s=e.noBOM?[]:[254,255],r=0,n=t.length;r<n;r++){if((h=(u=t.charCodeAt(r))>>8)>>8)throw new Error("Character at position "+r+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(h),s.push(u-(h<<8));}return String.fromCharCode.apply(void 0,s)},Ce=y.__private__.pdfEscape=y.pdfEscape=function(t,e){return Fe(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},je=y.__private__.beginPage=function(t){ot[++Dt]=[],Rt[Dt]={objId:0,contentsObjId:0,userUnit:Number(d),artBox:null,bleedBox:null,cropBox:null,trimBox:null,mediaBox:{bottomLeftX:0,bottomLeftY:0,topRightX:Number(t[0]),topRightY:Number(t[1])}},Me(Dt),ht(ot[$]);},Oe=function(t,e){var r,n,o;switch(i=e||i,"string"==typeof t&&(r=A(t.toLowerCase()),Array.isArray(r)&&(n=r[0],o=r[1])),Array.isArray(t)&&(n=t[0]*_t,o=t[1]*_t),isNaN(n)&&(n=s[0],o=s[1]),(n>14400||o>14400)&&(a.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"),n=Math.min(14400,n),o=Math.min(14400,o)),s=[n,o],i.substr(0,1)){case"l":o>n&&(s=[o,n]);break;case"p":n>o&&(s=[o,n]);}je(s),pr(fr),lt(Lr),0!==kr&&lt(kr+" J"),0!==Ir&&lt(Ir+" j"),Tt.publish("addPage",{pageNumber:Dt});},Be=function(t){t>0&&t<=Dt&&(ot.splice(t,1),Rt.splice(t,1),Dt--,$>Dt&&($=Dt),this.setPage($));},Me=function(t){t>0&&t<=Dt&&($=t);},Ee=y.__private__.getNumberOfPages=y.getNumberOfPages=function(){return ot.length-1},qe=function(t,e,r){var n,i=void 0;return r=r||{},t=void 0!==t?t:Ft[St].fontName,e=void 0!==e?e:Ft[St].fontStyle,n=t.toLowerCase(),void 0!==Ct[n]&&void 0!==Ct[n][e]?i=Ct[n][e]:void 0!==Ct[t]&&void 0!==Ct[t][e]?i=Ct[t][e]:!1===r.disableWarning&&a.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),i||r.noFallback||null==(i=Ct.times[e])&&(i=Ct.times.normal),i},De=y.__private__.putInfo=function(){var t=Xt(),e=function(t){return t};for(var r in null!==m&&(e=Ye.encryptor(t,0)),lt("<<"),lt("/Producer ("+Ce(e("jsPDF "+E.version))+")"),xt)xt.hasOwnProperty(r)&&xt[r]&&lt("/"+r.substr(0,1).toUpperCase()+r.substr(1)+" ("+Ce(e(xt[r]))+")");lt("/CreationDate ("+Ce(e(W))+")"),lt(">>"),lt("endobj");},Re=y.__private__.putCatalog=function(t){var e=(t=t||{}).rootDictionaryObjId||Qt;switch(Xt(),lt("<<"),lt("/Type /Catalog"),lt("/Pages "+e+" 0 R"),mt||(mt="fullwidth"),mt){case"fullwidth":lt("/OpenAction [3 0 R /FitH null]");break;case"fullheight":lt("/OpenAction [3 0 R /FitV null]");break;case"fullpage":lt("/OpenAction [3 0 R /Fit]");break;case"original":lt("/OpenAction [3 0 R /XYZ null null 1]");break;default:var r=""+mt;"%"===r.substr(r.length-1)&&(mt=parseInt(mt)/100),"number"==typeof mt&&lt("/OpenAction [3 0 R /XYZ null null "+R(mt)+"]");}switch(Nt||(Nt="continuous"),Nt){case"continuous":lt("/PageLayout /OneColumn");break;case"single":lt("/PageLayout /SinglePage");break;case"two":case"twoleft":lt("/PageLayout /TwoColumnLeft");break;case"tworight":lt("/PageLayout /TwoColumnRight");}yt&&lt("/PageMode /"+yt),Tt.publish("putCatalog"),lt(">>"),lt("endobj");},Te=y.__private__.putTrailer=function(){lt("trailer"),lt("<<"),lt("/Size "+(et+1)),lt("/Root "+et+" 0 R"),lt("/Info "+(et-1)+" 0 R"),null!==m&&lt("/Encrypt "+Ye.oid+" 0 R"),lt("/ID [ <"+V+"> <"+V+"> ]"),lt(">>");},Ue=y.__private__.putHeader=function(){lt("%PDF-"+w),lt("%ºß¬à");},ze=y.__private__.putXRef=function(){var t="0000000000";lt("xref"),lt("0 "+(et+1)),lt("0000000000 65535 f ");for(var e=1;e<=et;e++){"function"==typeof rt[e]?lt((t+rt[e]()).slice(-10)+" 00000 n "):void 0!==rt[e]?lt((t+rt[e]).slice(-10)+" 00000 n "):lt("0000000000 00000 n ");}},He=y.__private__.buildDocument=function(){ut(),ht(nt),Tt.publish("buildDocument"),Ue(),oe(),Se(),xe(),null!==m&&be(),De(),Re();var t=it;return ze(),Te(),lt("startxref"),lt(""+t),lt("%%EOF"),ht(ot[$]),nt.join("\n")},We=y.__private__.getBlob=function(t){return new Blob([dt(t)],{type:"application/pdf"})},Ve=y.output=y.__private__.output=Ie((function(t,e){switch("string"==typeof(e=e||{})?e={filename:e}:e.filename=e.filename||"generated.pdf",t){case void 0:return He();case"save":y.save(e.filename);break;case"arraybuffer":return dt(He());case"blob":return We(He());case"bloburi":case"bloburl":if(void 0!==n.URL&&"function"==typeof n.URL.createObjectURL)return n.URL&&n.URL.createObjectURL(We(He()))||void 0;a.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");break;case"datauristring":case"dataurlstring":var r="",i=He();try{r=h(i);}catch(t){r=h(unescape(encodeURIComponent(i)));}return "data:application/pdf;filename="+e.filename+";base64,"+r;case"pdfobjectnewwindow":if("[object Window]"===Object.prototype.toString.call(n)){var o="https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js",s=' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';e.pdfObjectUrl&&(o=e.pdfObjectUrl,s="");var c='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="'+o+'"'+s+'><\/script><script >PDFObject.embed("'+this.output("dataurlstring")+'", '+JSON.stringify(e)+");<\/script></body></html>",u=n.open();return null!==u&&u.document.write(c),u}throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");case"pdfjsnewwindow":if("[object Window]"===Object.prototype.toString.call(n)){var l='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="'+(e.pdfJsUrl||"examples/PDF.js/web/viewer.html")+"?file=&downloadName="+e.filename+'" width="500px" height="400px" /></body></html>',f=n.open();if(null!==f){f.document.write(l);var d=this;f.document.documentElement.querySelector("#pdfViewer").onload=function(){f.document.title=e.filename,f.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(d.output("bloburl"));};}return f}throw new Error("The option pdfjsnewwindow just works in a browser-environment.");case"dataurlnewwindow":if("[object Window]"!==Object.prototype.toString.call(n))throw new Error("The option dataurlnewwindow just works in a browser-environment.");var p='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="'+this.output("datauristring",e)+'"></iframe></body></html>',g=n.open();if(null!==g&&(g.document.write(p),g.document.title=e.filename),g||"undefined"==typeof safari)return g;break;case"datauri":case"dataurl":return n.document.location.href=this.output("datauristring",e);default:return null}})),Ge=function(t){return !0===Array.isArray(Ut)&&Ut.indexOf(t)>-1};switch(o){case"pt":_t=1;break;case"mm":_t=72/25.4;break;case"cm":_t=72/2.54;break;case"in":_t=72;break;case"px":_t=1==Ge("px_scaling")?.75:96/72;break;case"pc":case"em":_t=12;break;case"ex":_t=6;break;default:if("number"!=typeof o)throw new Error("Invalid unit: "+o);_t=o;}var Ye=null;K(),Y();var Je=function(t){return null!==m?Ye.encryptor(t,0):function(t){return t}},Xe=y.__private__.getPageInfo=y.getPageInfo=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfo");return {objId:Rt[t].objId,pageNumber:t,pageContext:Rt[t]}},Ke=y.__private__.getPageInfoByObjId=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");for(var e in Rt)if(Rt[e].objId===t)break;return Xe(e)},Ze=y.__private__.getCurrentPageInfo=y.getCurrentPageInfo=function(){return {objId:Rt[$].objId,pageNumber:$,pageContext:Rt[$]}};y.addPage=function(){return Oe.apply(this,arguments),this},y.setPage=function(){return Me.apply(this,arguments),ht.call(this,ot[$]),this},y.insertPage=function(t){return this.addPage(),this.movePage($,t),this},y.movePage=function(t,e){var r,n;if(t>e){r=ot[t],n=Rt[t];for(var i=t;i>e;i--)ot[i]=ot[i-1],Rt[i]=Rt[i-1];ot[e]=r,Rt[e]=n,this.setPage(e);}else if(t<e){r=ot[t],n=Rt[t];for(var a=t;a<e;a++)ot[a]=ot[a+1],Rt[a]=Rt[a+1];ot[e]=r,Rt[e]=n,this.setPage(e);}return this},y.deletePage=function(){return Be.apply(this,arguments),this},y.__private__.text=y.text=function(e,r,n,i,a){var o,s,c,u,h,l,f,d,p,g=(i=i||{}).scope||this;if("number"==typeof e&&"number"==typeof r&&("string"==typeof n||Array.isArray(n))){var m=n;n=r,r=e,e=m;}if(arguments[3]instanceof Vt==!1?(c=arguments[4],u=arguments[5],"object"===_typeof$2(f=arguments[3])&&null!==f||("string"==typeof c&&(u=c,c=null),"string"==typeof f&&(u=f,f=null),"number"==typeof f&&(c=f,f=null),i={flags:f,angle:c,align:u})):(q("The transform parameter of text() with a Matrix value"),p=a),isNaN(r)||isNaN(n)||null==e)throw new Error("Invalid arguments passed to jsPDF.text");if(0===e.length)return g;var v="",y=!1,w="number"==typeof i.lineHeightFactor?i.lineHeightFactor:lr,N=g.internal.scaleFactor;function L(t){return t=t.split("\t").join(Array(i.TabLen||9).join(" ")),Ce(t,f)}function A(t){for(var e,r=t.concat(),n=[],i=r.length;i--;)"string"==typeof(e=r.shift())?n.push(e):Array.isArray(t)&&(1===e.length||void 0===e[1]&&void 0===e[2])?n.push(e[0]):n.push([e[0],e[1],e[2]]);return n}function _(t,e){var r;if("string"==typeof t)r=e(t)[0];else if(Array.isArray(t)){for(var n,i,a=t.concat(),o=[],s=a.length;s--;)"string"==typeof(n=a.shift())?o.push(e(n)[0]):Array.isArray(n)&&"string"==typeof n[0]&&(i=e(n[0],n[1],n[2]),o.push([i[0],i[1],i[2]]));r=o;}return r}var P=!1,k=!0;if("string"==typeof e)P=!0;else if(Array.isArray(e)){var I=e.concat();s=[];for(var F,C=I.length;C--;)("string"!=typeof(F=I.shift())||Array.isArray(F)&&"string"!=typeof F[0])&&(k=!1);P=k;}if(!1===P)throw new Error('Type of text must be string or Array. "'+e+'" is not recognized.');"string"==typeof e&&(e=e.match(/[\r?\n]/)?e.split(/\r\n|\r|\n/g):[e]);var j=gt/g.internal.scaleFactor,B=j*(w-1);switch(i.baseline){case"bottom":n-=B;break;case"top":n+=j-B;break;case"hanging":n+=j-2*B;break;case"middle":n+=j/2-B;}if((l=i.maxWidth||0)>0&&("string"==typeof e?e=g.splitTextToSize(e,l):"[object Array]"===Object.prototype.toString.call(e)&&(e=e.reduce((function(t,e){return t.concat(g.splitTextToSize(e,l))}),[]))),o={text:e,x:r,y:n,options:i,mutex:{pdfEscape:Ce,activeFontKey:St,fonts:Ft,activeFontSize:gt}},Tt.publish("preProcessText",o),e=o.text,c=(i=o.options).angle,p instanceof Vt==!1&&c&&"number"==typeof c){c*=Math.PI/180,0===i.rotationDirection&&(c=-c),S===x.ADVANCED&&(c=-c);var M=Math.cos(c),E=Math.sin(c);p=new Vt(M,E,-E,M,0,0);}else c&&c instanceof Vt&&(p=c);S!==x.ADVANCED||p||(p=Yt),void 0!==(h=i.charSpace||_r)&&(v+=O(U(h))+" Tc\n",this.setCharSpace(this.getCharSpace()||0)),void 0!==(d=i.horizontalScale)&&(v+=O(100*d)+" Tz\n");i.lang;var D=-1,R=void 0!==i.renderingMode?i.renderingMode:i.stroke,T=g.internal.getCurrentPageInfo().pageContext;switch(R){case 0:case!1:case"fill":D=0;break;case 1:case!0:case"stroke":D=1;break;case 2:case"fillThenStroke":D=2;break;case 3:case"invisible":D=3;break;case 4:case"fillAndAddForClipping":D=4;break;case 5:case"strokeAndAddPathForClipping":D=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":D=6;break;case 7:case"addToPathForClipping":D=7;}var z=void 0!==T.usedRenderingMode?T.usedRenderingMode:-1;-1!==D?v+=D+" Tr\n":-1!==z&&(v+="0 Tr\n"),-1!==D&&(T.usedRenderingMode=D),u=i.align||"left";var H,W=gt*w,V=g.internal.pageSize.getWidth(),G=Ft[St];h=i.charSpace||_r,l=i.maxWidth||0,f=Object.assign({autoencode:!0,noBOM:!0},i.flags);var Y=[];if("[object Array]"===Object.prototype.toString.call(e)){var J;s=A(e),"left"!==u&&(H=s.map((function(t){return g.getStringUnitWidth(t,{font:G,charSpace:h,fontSize:gt,doKerning:!1})*gt/N})));var X,K=0;if("right"===u){r-=H[0],e=[],C=s.length;for(var Z=0;Z<C;Z++)0===Z?(X=br(r),J=yr(n)):(X=U(K-H[Z]),J=-W),e.push([s[Z],X,J]),K=H[Z];}else if("center"===u){r-=H[0]/2,e=[],C=s.length;for(var $=0;$<C;$++)0===$?(X=br(r),J=yr(n)):(X=U((K-H[$])/2),J=-W),e.push([s[$],X,J]),K=H[$];}else if("left"===u){e=[],C=s.length;for(var Q=0;Q<C;Q++)e.push(s[Q]);}else {if("justify"!==u)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');e=[],C=s.length,l=0!==l?l:V;for(var tt=0;tt<C;tt++)J=0===tt?yr(n):-W,X=0===tt?br(r):0,tt<C-1?Y.push(O(U((l-H[tt])/(s[tt].split(" ").length-1)))):Y.push(0),e.push([s[tt],X,J]);}}var et="boolean"==typeof i.R2L?i.R2L:bt;!0===et&&(e=_(e,(function(t,e,r){return [t.split("").reverse().join(""),e,r]}))),o={text:e,x:r,y:n,options:i,mutex:{pdfEscape:Ce,activeFontKey:St,fonts:Ft,activeFontSize:gt}},Tt.publish("postProcessText",o),e=o.text,y=o.mutex.isHex||!1;var rt=Ft[St].encoding;"WinAnsiEncoding"!==rt&&"StandardEncoding"!==rt||(e=_(e,(function(t,e,r){return [L(t),e,r]}))),s=A(e),e=[];for(var nt,it,at,ot=0,st=1,ct=Array.isArray(s[0])?st:ot,ut="",ht=function(t,e,r){var n="";return r instanceof Vt?(r="number"==typeof i.angle?Gt(r,new Vt(1,0,0,1,t,e)):Gt(new Vt(1,0,0,1,t,e),r),S===x.ADVANCED&&(r=Gt(new Vt(1,0,0,-1,0,0),r)),n=r.join(" ")+" Tm\n"):n=O(t)+" "+O(e)+" Td\n",n},ft=0;ft<s.length;ft++){switch(ut="",ct){case st:at=(y?"<":"(")+s[ft][0]+(y?">":")"),nt=parseFloat(s[ft][1]),it=parseFloat(s[ft][2]);break;case ot:at=(y?"<":"(")+s[ft]+(y?">":")"),nt=br(r),it=yr(n);}void 0!==Y&&void 0!==Y[ft]&&(ut=Y[ft]+" Tw\n"),0===ft?e.push(ut+ht(nt,it,p)+at):ct===ot?e.push(ut+at):ct===st&&e.push(ut+ht(nt,it,p)+at);}e=ct===ot?e.join(" Tj\nT* "):e.join(" Tj\n"),e+=" Tj\n";var dt="BT\n/";return dt+=St+" "+gt+" Tf\n",dt+=O(gt*w)+" TL\n",dt+=xr+"\n",dt+=v,dt+=e,lt(dt+="ET"),b[St]=!0,g};var $e=y.__private__.clip=y.clip=function(t){return lt("evenodd"===t?"W*":"W"),this};y.clipEvenOdd=function(){return $e("evenodd")},y.__private__.discardPath=y.discardPath=function(){return lt("n"),this};var Qe=y.__private__.isValidStyle=function(t){var e=!1;return -1!==[void 0,null,"S","D","F","DF","FD","f","f*","B","B*","n"].indexOf(t)&&(e=!0),e};y.__private__.setDefaultPathOperation=y.setDefaultPathOperation=function(t){return Qe(t)&&(g=t),this};var tr=y.__private__.getStyle=y.getStyle=function(t){var e=g;switch(t){case"D":case"S":e="S";break;case"F":e="f";break;case"FD":case"DF":e="B";break;case"f":case"f*":case"B":case"B*":e=t;}return e},er=y.close=function(){return lt("h"),this};y.stroke=function(){return lt("S"),this},y.fill=function(t){return rr("f",t),this},y.fillEvenOdd=function(t){return rr("f*",t),this},y.fillStroke=function(t){return rr("B",t),this},y.fillStrokeEvenOdd=function(t){return rr("B*",t),this};var rr=function(e,r){"object"===_typeof$2(r)?ar(r,e):lt(e);},nr=function(t){null===t||S===x.ADVANCED&&void 0===t||(t=tr(t),lt(t));};function ir(t,e,r,n,i){var a=new M(e||this.boundingBox,r||this.xStep,n||this.yStep,this.gState,i||this.matrix);a.stream=this.stream;var o=t+"$$"+this.cloneIndex+++"$$";return Jt(o,a),a}var ar=function(t,e){var r=Bt[t.key],n=Ot[r];if(n instanceof B)lt("q"),lt(or(e)),n.gState&&y.setGState(n.gState),lt(t.matrix.toString()+" cm"),lt("/"+r+" sh"),lt("Q");else if(n instanceof M){var i=new Vt(1,0,0,-1,0,Rr());t.matrix&&(i=i.multiply(t.matrix||Yt),r=ir.call(n,t.key,t.boundingBox,t.xStep,t.yStep,i).id),lt("q"),lt("/Pattern cs"),lt("/"+r+" scn"),n.gState&&y.setGState(n.gState),lt(e),lt("Q");}},or=function(t){switch(t){case"f":case"F":return "W n";case"f*":return "W* n";case"B":return "W S";case"B*":return "W* S";case"S":return "W S";case"n":return "W n"}},sr=y.moveTo=function(t,e){return lt(O(U(t))+" "+O(H(e))+" m"),this},cr=y.lineTo=function(t,e){return lt(O(U(t))+" "+O(H(e))+" l"),this},ur=y.curveTo=function(t,e,r,n,i,a){return lt([O(U(t)),O(H(e)),O(U(r)),O(H(n)),O(U(i)),O(H(a)),"c"].join(" ")),this};y.__private__.line=y.line=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Qe(i))throw new Error("Invalid arguments passed to jsPDF.line");return S===x.COMPAT?this.lines([[r-t,n-e]],t,e,[1,1],i||"S"):this.lines([[r-t,n-e]],t,e,[1,1]).stroke()},y.__private__.lines=y.lines=function(t,e,r,n,i,a){var o,s,c,u,h,l,f,d,p,g,m,v;if("number"==typeof t&&(v=r,r=e,e=t,t=v),n=n||[1,1],a=a||!1,isNaN(e)||isNaN(r)||!Array.isArray(t)||!Array.isArray(n)||!Qe(i)||"boolean"!=typeof a)throw new Error("Invalid arguments passed to jsPDF.lines");for(sr(e,r),o=n[0],s=n[1],u=t.length,g=e,m=r,c=0;c<u;c++)2===(h=t[c]).length?(g=h[0]*o+g,m=h[1]*s+m,cr(g,m)):(l=h[0]*o+g,f=h[1]*s+m,d=h[2]*o+g,p=h[3]*s+m,g=h[4]*o+g,m=h[5]*s+m,ur(l,f,d,p,g,m));return a&&er(),nr(i),this},y.path=function(t){for(var e=0;e<t.length;e++){var r=t[e],n=r.c;switch(r.op){case"m":sr(n[0],n[1]);break;case"l":cr(n[0],n[1]);break;case"c":ur.apply(this,n);break;case"h":er();}}return this},y.__private__.rect=y.rect=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Qe(i))throw new Error("Invalid arguments passed to jsPDF.rect");return S===x.COMPAT&&(n=-n),lt([O(U(t)),O(H(e)),O(U(r)),O(U(n)),"re"].join(" ")),nr(i),this},y.__private__.triangle=y.triangle=function(t,e,r,n,i,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(a)||!Qe(o))throw new Error("Invalid arguments passed to jsPDF.triangle");return this.lines([[r-t,n-e],[i-r,a-n],[t-i,e-a]],t,e,[1,1],o,!0),this},y.__private__.roundedRect=y.roundedRect=function(t,e,r,n,i,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(a)||!Qe(o))throw new Error("Invalid arguments passed to jsPDF.roundedRect");var s=4/3*(Math.SQRT2-1);return i=Math.min(i,.5*r),a=Math.min(a,.5*n),this.lines([[r-2*i,0],[i*s,0,i,a-a*s,i,a],[0,n-2*a],[0,a*s,-i*s,a,-i,a],[2*i-r,0],[-i*s,0,-i,-a*s,-i,-a],[0,2*a-n],[0,-a*s,i*s,-a,i,-a]],t+i,e,[1,1],o,!0),this},y.__private__.ellipse=y.ellipse=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Qe(i))throw new Error("Invalid arguments passed to jsPDF.ellipse");var a=4/3*(Math.SQRT2-1)*r,o=4/3*(Math.SQRT2-1)*n;return sr(t+r,e),ur(t+r,e-o,t+a,e-n,t,e-n),ur(t-a,e-n,t-r,e-o,t-r,e),ur(t-r,e+o,t-a,e+n,t,e+n),ur(t+a,e+n,t+r,e+o,t+r,e),nr(i),this},y.__private__.circle=y.circle=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||!Qe(n))throw new Error("Invalid arguments passed to jsPDF.circle");return this.ellipse(t,e,r,r,n)},y.setFont=function(t,e,r){return r&&(e=k(e,r)),St=qe(t,e,{disableWarning:!1}),this};var hr=y.__private__.getFont=y.getFont=function(){return Ft[qe.apply(y,arguments)]};y.__private__.getFontList=y.getFontList=function(){var t,e,r={};for(t in Ct)if(Ct.hasOwnProperty(t))for(e in r[t]=[],Ct[t])Ct[t].hasOwnProperty(e)&&r[t].push(e);return r},y.addFont=function(t,e,r,n,i){var a=["StandardEncoding","MacRomanEncoding","Identity-H","WinAnsiEncoding"];return arguments[3]&&-1!==a.indexOf(arguments[3])?i=arguments[3]:arguments[3]&&-1==a.indexOf(arguments[3])&&(r=k(r,n)),i=i||"Identity-H",Pe.call(this,t,e,r,i)};var lr,fr=e.lineWidth||.200025,dr=y.__private__.getLineWidth=y.getLineWidth=function(){return fr},pr=y.__private__.setLineWidth=y.setLineWidth=function(t){return fr=t,lt(O(U(t))+" w"),this};y.__private__.setLineDash=E.API.setLineDash=E.API.setLineDashPattern=function(t,e){if(t=t||[],e=e||0,isNaN(e)||!Array.isArray(t))throw new Error("Invalid arguments passed to jsPDF.setLineDash");return t=t.map((function(t){return O(U(t))})).join(" "),e=O(U(e)),lt("["+t+"] "+e+" d"),this};var gr=y.__private__.getLineHeight=y.getLineHeight=function(){return gt*lr};y.__private__.getLineHeight=y.getLineHeight=function(){return gt*lr};var mr=y.__private__.setLineHeightFactor=y.setLineHeightFactor=function(t){return "number"==typeof(t=t||1.15)&&(lr=t),this},vr=y.__private__.getLineHeightFactor=y.getLineHeightFactor=function(){return lr};mr(e.lineHeight);var br=y.__private__.getHorizontalCoordinate=function(t){return U(t)},yr=y.__private__.getVerticalCoordinate=function(t){return S===x.ADVANCED?t:Rt[$].mediaBox.topRightY-Rt[$].mediaBox.bottomLeftY-U(t)},wr=y.__private__.getHorizontalCoordinateString=y.getHorizontalCoordinateString=function(t){return O(br(t))},Nr=y.__private__.getVerticalCoordinateString=y.getVerticalCoordinateString=function(t){return O(yr(t))},Lr=e.strokeColor||"0 G";y.__private__.getStrokeColor=y.getDrawColor=function(){return ee(Lr)},y.__private__.setStrokeColor=y.setDrawColor=function(t,e,r,n){return Lr=re({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"draw",precision:2}),lt(Lr),this};var Ar=e.fillColor||"0 g";y.__private__.getFillColor=y.getFillColor=function(){return ee(Ar)},y.__private__.setFillColor=y.setFillColor=function(t,e,r,n){return Ar=re({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"fill",precision:2}),lt(Ar),this};var xr=e.textColor||"0 g",Sr=y.__private__.getTextColor=y.getTextColor=function(){return ee(xr)};y.__private__.setTextColor=y.setTextColor=function(t,e,r,n){return xr=re({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"text",precision:3}),this};var _r=e.charSpace,Pr=y.__private__.getCharSpace=y.getCharSpace=function(){return parseFloat(_r||0)};y.__private__.setCharSpace=y.setCharSpace=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.setCharSpace");return _r=t,this};var kr=0;y.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2},y.__private__.setLineCap=y.setLineCap=function(t){var e=y.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return kr=e,lt(e+" J"),this};var Ir=0;y.__private__.setLineJoin=y.setLineJoin=function(t){var e=y.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return Ir=e,lt(e+" j"),this},y.__private__.setLineMiterLimit=y.__private__.setMiterLimit=y.setLineMiterLimit=y.setMiterLimit=function(t){if(t=t||0,isNaN(t))throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");return lt(O(U(t))+" M"),this},y.GState=j,y.setGState=function(t){(t="string"==typeof t?Mt[Et[t]]:Fr(null,t)).equals(qt)||(lt("/"+t.id+" gs"),qt=t);};var Fr=function(t,e){if(!t||!Et[t]){var r=!1;for(var n in Mt)if(Mt.hasOwnProperty(n)&&Mt[n].equals(e)){r=!0;break}if(r)e=Mt[n];else {var i="GS"+(Object.keys(Mt).length+1).toString(10);Mt[i]=e,e.id=i;}return t&&(Et[t]=e.id),Tt.publish("addGState",e),e}};y.addGState=function(t,e){return Fr(t,e),this},y.saveGraphicsState=function(){return lt("q"),jt.push({key:St,size:gt,color:xr}),this},y.restoreGraphicsState=function(){lt("Q");var t=jt.pop();return St=t.key,gt=t.size,xr=t.color,qt=null,this},y.setCurrentTransformationMatrix=function(t){return lt(t.toString()+" cm"),this},y.comment=function(t){return lt("#"+t),this};var Cr=function(t,e){var r=t||0;Object.defineProperty(this,"x",{enumerable:!0,get:function(){return r},set:function(t){isNaN(t)||(r=parseFloat(t));}});var n=e||0;Object.defineProperty(this,"y",{enumerable:!0,get:function(){return n},set:function(t){isNaN(t)||(n=parseFloat(t));}});var i="pt";return Object.defineProperty(this,"type",{enumerable:!0,get:function(){return i},set:function(t){i=t.toString();}}),this},jr=function(t,e,r,n){Cr.call(this,t,e),this.type="rect";var i=r||0;Object.defineProperty(this,"w",{enumerable:!0,get:function(){return i},set:function(t){isNaN(t)||(i=parseFloat(t));}});var a=n||0;return Object.defineProperty(this,"h",{enumerable:!0,get:function(){return a},set:function(t){isNaN(t)||(a=parseFloat(t));}}),this},Or=function(){this.page=Dt,this.currentPage=$,this.pages=ot.slice(0),this.pagesContext=Rt.slice(0),this.x=Pt,this.y=kt,this.matrix=It,this.width=qr($),this.height=Rr($),this.outputDestination=ct,this.id="",this.objectNumber=-1;};Or.prototype.restore=function(){Dt=this.page,$=this.currentPage,Rt=this.pagesContext,ot=this.pages,Pt=this.x,kt=this.y,It=this.matrix,Dr($,this.width),Tr($,this.height),ct=this.outputDestination;};var Br=function(t,e,r,n,i){Wt.push(new Or),Dt=$=0,ot=[],Pt=t,kt=e,It=i,je([r,n]);},Mr=function(t){if(Ht[t])Wt.pop().restore();else {var e=new Or,r="Xo"+(Object.keys(zt).length+1).toString(10);e.id=r,Ht[t]=r,zt[r]=e,Tt.publish("addFormObject",e),Wt.pop().restore();}};for(var Er in y.beginFormObject=function(t,e,r,n,i){return Br(t,e,r,n,i),this},y.endFormObject=function(t){return Mr(t),this},y.doFormObject=function(t,e){var r=zt[Ht[t]];return lt("q"),lt(e.toString()+" cm"),lt("/"+r.id+" Do"),lt("Q"),this},y.getFormObject=function(t){var e=zt[Ht[t]];return {x:e.x,y:e.y,width:e.width,height:e.height,matrix:e.matrix}},y.save=function(t,e){return t=t||"generated.pdf",(e=e||{}).returnPromise=e.returnPromise||!1,!1===e.returnPromise?(l(We(He()),t),"function"==typeof l.unload&&n.setTimeout&&setTimeout(l.unload,911),this):new Promise((function(e,r){try{var i=l(We(He()),t);"function"==typeof l.unload&&n.setTimeout&&setTimeout(l.unload,911),e(i);}catch(t){r(t.message);}}))},E.API)E.API.hasOwnProperty(Er)&&("events"===Er&&E.API.events.length?function(t,e){var r,n,i;for(i=e.length-1;-1!==i;i--)r=e[i][0],n=e[i][1],t.subscribe.apply(t,[r].concat("function"==typeof n?[n]:n));}(Tt,E.API.events):y[Er]=E.API[Er]);var qr=y.getPageWidth=function(t){return (Rt[t=t||$].mediaBox.topRightX-Rt[t].mediaBox.bottomLeftX)/_t},Dr=y.setPageWidth=function(t,e){Rt[t].mediaBox.topRightX=e*_t+Rt[t].mediaBox.bottomLeftX;},Rr=y.getPageHeight=function(t){return (Rt[t=t||$].mediaBox.topRightY-Rt[t].mediaBox.bottomLeftY)/_t},Tr=y.setPageHeight=function(t,e){Rt[t].mediaBox.topRightY=e*_t+Rt[t].mediaBox.bottomLeftY;};return y.internal={pdfEscape:Ce,getStyle:tr,getFont:hr,getFontSize:vt,getCharSpace:Pr,getTextColor:Sr,getLineHeight:gr,getLineHeightFactor:vr,getLineWidth:dr,write:ft,getHorizontalCoordinate:br,getVerticalCoordinate:yr,getCoordinateString:wr,getVerticalCoordinateString:Nr,collections:{},newObject:Xt,newAdditionalObject:$t,newObjectDeferred:Kt,newObjectDeferredBegin:Zt,getFilters:ne,putStream:ie,events:Tt,scaleFactor:_t,pageSize:{getWidth:function(){return qr($)},setWidth:function(t){Dr($,t);},getHeight:function(){return Rr($)},setHeight:function(t){Tr($,t);}},encryptionOptions:m,encryption:Ye,getEncryptor:Je,output:Ve,getNumberOfPages:Ee,pages:ot,out:lt,f2:R,f3:T,getPageInfo:Xe,getPageInfoByObjId:Ke,getCurrentPageInfo:Ze,getPDFVersion:N,Point:Cr,Rectangle:jr,Matrix:Vt,hasHotfix:Ge},Object.defineProperty(y.internal.pageSize,"width",{get:function(){return qr($)},set:function(t){Dr($,t);},enumerable:!0,configurable:!0}),Object.defineProperty(y.internal.pageSize,"height",{get:function(){return Rr($)},set:function(t){Tr($,t);},enumerable:!0,configurable:!0}),ke.call(y,pt),St="F1",Oe(s,i),Tt.publish("initialized"),y}I.prototype.lsbFirstWord=function(t){return String.fromCharCode(t>>0&255,t>>8&255,t>>16&255,t>>24&255)},I.prototype.toHexString=function(t){return t.split("").map((function(t){return ("0"+(255&t.charCodeAt(0)).toString(16)).slice(-2)})).join("")},I.prototype.hexToBytes=function(t){for(var e=[],r=0;r<t.length;r+=2)e.push(String.fromCharCode(parseInt(t.substr(r,2),16)));return e.join("")},I.prototype.processOwnerPassword=function(t,e){return P(x(e).substr(0,5),t)},I.prototype.encryptor=function(t,e){var r=x(this.encryptionKey+String.fromCharCode(255&t,t>>8&255,t>>16&255,255&e,e>>8&255)).substr(0,10);return function(t){return P(r,t)}},j.prototype.equals=function(e){var r,n="id,objectNumber,equals";if(!e||_typeof$2(e)!==_typeof$2(this))return !1;var i=0;for(r in this)if(!(n.indexOf(r)>=0)){if(this.hasOwnProperty(r)&&!e.hasOwnProperty(r))return !1;if(this[r]!==e[r])return !1;i++;}for(r in e)e.hasOwnProperty(r)&&n.indexOf(r)<0&&i--;return 0===i},E.API={events:[]},E.version="2.5.1";var q=E.API,D=1,R=function(t){return t.replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},T=function(t){return t.replace(/\\\\/g,"\\").replace(/\\\(/g,"(").replace(/\\\)/g,")")},U=function(t){return t.toFixed(2)},z=function(t){return t.toFixed(5)};q.__acroform__={};var H=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t;},W=function(t){return t*D},V=function(t){var e=new ut,r=At.internal.getHeight(t)||0,n=At.internal.getWidth(t)||0;return e.BBox=[0,0,Number(U(n)),Number(U(r))],e},G=q.__acroform__.setBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");return t|=1<<e},Y=q.__acroform__.clearBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");return t&=~(1<<e)},J=q.__acroform__.getBit=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");return 0==(t&1<<e)?0:1},X=q.__acroform__.getBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");return J(t,e-1)},K=q.__acroform__.setBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");return G(t,e-1)},Z=q.__acroform__.clearBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");return Y(t,e-1)},$=q.__acroform__.calculateCoordinates=function(t,e){var r=e.internal.getHorizontalCoordinate,n=e.internal.getVerticalCoordinate,i=t[0],a=t[1],o=t[2],s=t[3],c={};return c.lowerLeft_X=r(i)||0,c.lowerLeft_Y=n(a+s)||0,c.upperRight_X=r(i+o)||0,c.upperRight_Y=n(a)||0,[Number(U(c.lowerLeft_X)),Number(U(c.lowerLeft_Y)),Number(U(c.upperRight_X)),Number(U(c.upperRight_Y))]},Q=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],r=t._V||t.DV,n=tt(t,r),i=t.scope.internal.getFont(t.fontName,t.fontStyle).id;e.push("/Tx BMC"),e.push("q"),e.push("BT"),e.push(t.scope.__private__.encodeColorString(t.color)),e.push("/"+i+" "+U(n.fontSize)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push(n.text),e.push("ET"),e.push("Q"),e.push("EMC");var a=V(t);return a.scope=t.scope,a.stream=e.join("\n"),a}},tt=function(t,e){var r=0===t.fontSize?t.maxFontSize:t.fontSize,n={text:"",fontSize:""},i=(e=")"==(e="("==e.substr(0,1)?e.substr(1):e).substr(e.length-1)?e.substr(0,e.length-1):e).split(" ");i=t.multiline?i.map((function(t){return t.split("\n")})):i.map((function(t){return [t]}));var a=r,o=At.internal.getHeight(t)||0;o=o<0?-o:o;var s=At.internal.getWidth(t)||0;s=s<0?-s:s;var c=function(e,r,n){if(e+1<i.length){var a=r+" "+i[e+1][0];return et(a,t,n).width<=s-4}return !1};a++;t:for(;a>0;){e="",a--;var u,h,l=et("3",t,a).height,f=t.multiline?o-a:(o-l)/2,d=f+=2,p=0,g=0,m=0;if(a<=0){e="(...) Tj\n",e+="% Width of Text: "+et(e,t,a=12).width+", FieldWidth:"+s+"\n";break}for(var v="",b=0,y=0;y<i.length;y++)if(i.hasOwnProperty(y)){var w=!1;if(1!==i[y].length&&m!==i[y].length-1){if((l+2)*(b+2)+2>o)continue t;v+=i[y][m],w=!0,g=y,y--;}else {v=" "==(v+=i[y][m]+" ").substr(v.length-1)?v.substr(0,v.length-1):v;var N=parseInt(y),L=c(N,v,a),A=y>=i.length-1;if(L&&!A){v+=" ",m=0;continue}if(L||A){if(A)g=N;else if(t.multiline&&(l+2)*(b+2)+2>o)continue t}else {if(!t.multiline)continue t;if((l+2)*(b+2)+2>o)continue t;g=N;}}for(var x="",S=p;S<=g;S++){var _=i[S];if(t.multiline){if(S===g){x+=_[m]+" ",m=(m+1)%_.length;continue}if(S===p){x+=_[_.length-1]+" ";continue}}x+=_[0]+" ";}switch(x=" "==x.substr(x.length-1)?x.substr(0,x.length-1):x,h=et(x,t,a).width,t.textAlign){case"right":u=s-h-2;break;case"center":u=(s-h)/2;break;case"left":default:u=2;}e+=U(u)+" "+U(d)+" Td\n",e+="("+R(x)+") Tj\n",e+=-U(u)+" 0 Td\n",d=-(a+2),h=0,p=w?g:g+1,b++,v="";}break}return n.text=e,n.fontSize=a,n},et=function(t,e,r){var n=e.scope.internal.getFont(e.fontName,e.fontStyle),i=e.scope.getStringUnitWidth(t,{font:n,fontSize:parseFloat(r),charSpace:0})*parseFloat(r);return {height:e.scope.getStringUnitWidth("3",{font:n,fontSize:parseFloat(r),charSpace:0})*parseFloat(r)*1.5,width:i}},rt={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},nt=function(t,e){var r={type:"reference",object:t};void 0===e.internal.getPageInfo(t.page).pageContext.annotations.find((function(t){return t.type===r.type&&t.object===r.object}))&&e.internal.getPageInfo(t.page).pageContext.annotations.push(r);},it=function(e,r){for(var n in e)if(e.hasOwnProperty(n)){var i=n,a=e[n];r.internal.newObjectDeferredBegin(a.objId,!0),"object"===_typeof$2(a)&&"function"==typeof a.putStream&&a.putStream(),delete e[i];}},at=function(e,r){if(r.scope=e,void 0!==e.internal&&(void 0===e.internal.acroformPlugin||!1===e.internal.acroformPlugin.isInitialized)){if(lt.FieldNum=0,e.internal.acroformPlugin=JSON.parse(JSON.stringify(rt)),e.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");D=e.internal.scaleFactor,e.internal.acroformPlugin.acroFormDictionaryRoot=new ht,e.internal.acroformPlugin.acroFormDictionaryRoot.scope=e,e.internal.acroformPlugin.acroFormDictionaryRoot._eventID=e.internal.events.subscribe("postPutResources",(function(){!function(t){t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID,t.internal.acroformPlugin.printedOut=!0;}(e);})),e.internal.events.subscribe("buildDocument",(function(){!function(t){t.internal.acroformPlugin.acroFormDictionaryRoot.objId=void 0;var e=t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;for(var r in e)if(e.hasOwnProperty(r)){var n=e[r];n.objId=void 0,n.hasAnnotation&&nt(n,t);}}(e);})),e.internal.events.subscribe("putCatalog",(function(){!function(t){if(void 0===t.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("putCatalogCallback: Root missing.");t.internal.write("/AcroForm "+t.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R");}(e);})),e.internal.events.subscribe("postPutPages",(function(r){!function(e,r){var n=!e;for(var i in e||(r.internal.newObjectDeferredBegin(r.internal.acroformPlugin.acroFormDictionaryRoot.objId,!0),r.internal.acroformPlugin.acroFormDictionaryRoot.putStream()),e=e||r.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if(e.hasOwnProperty(i)){var a=e[i],o=[],s=a.Rect;if(a.Rect&&(a.Rect=$(a.Rect,r)),r.internal.newObjectDeferredBegin(a.objId,!0),a.DA=At.createDefaultAppearanceStream(a),"object"===_typeof$2(a)&&"function"==typeof a.getKeyValueListForStream&&(o=a.getKeyValueListForStream()),a.Rect=s,a.hasAppearanceStream&&!a.appearanceStreamContent){var c=Q(a);o.push({key:"AP",value:"<</N "+c+">>"}),r.internal.acroformPlugin.xForms.push(c);}if(a.appearanceStreamContent){var u="";for(var h in a.appearanceStreamContent)if(a.appearanceStreamContent.hasOwnProperty(h)){var l=a.appearanceStreamContent[h];if(u+="/"+h+" ",u+="<<",Object.keys(l).length>=1||Array.isArray(l)){for(var i in l)if(l.hasOwnProperty(i)){var f=l[i];"function"==typeof f&&(f=f.call(r,a)),u+="/"+i+" "+f+" ",r.internal.acroformPlugin.xForms.indexOf(f)>=0||r.internal.acroformPlugin.xForms.push(f);}}else "function"==typeof(f=l)&&(f=f.call(r,a)),u+="/"+i+" "+f,r.internal.acroformPlugin.xForms.indexOf(f)>=0||r.internal.acroformPlugin.xForms.push(f);u+=">>";}o.push({key:"AP",value:"<<\n"+u+">>"});}r.internal.putStream({additionalKeyValues:o,objectId:a.objId}),r.internal.out("endobj");}n&&it(r.internal.acroformPlugin.xForms,r);}(r,e);})),e.internal.acroformPlugin.isInitialized=!0;}},ot=q.__acroform__.arrayToPdfArray=function(e,r,n){var i=function(t){return t};if(Array.isArray(e)){for(var a="[",o=0;o<e.length;o++)switch(0!==o&&(a+=" "),_typeof$2(e[o])){case"boolean":case"number":case"object":a+=e[o].toString();break;case"string":"/"!==e[o].substr(0,1)?(void 0!==r&&n&&(i=n.internal.getEncryptor(r)),a+="("+R(i(e[o].toString()))+")"):a+=e[o].toString();}return a+="]"}throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray")};var st=function(t,e,r){var n=function(t){return t};return void 0!==e&&r&&(n=r.internal.getEncryptor(e)),(t=t||"").toString(),t="("+R(n(t))+")"},ct=function(){this._objId=void 0,this._scope=void 0,Object.defineProperty(this,"objId",{get:function(){if(void 0===this._objId){if(void 0===this.scope)return;this._objId=this.scope.internal.newObjectDeferred();}return this._objId},set:function(t){this._objId=t;}}),Object.defineProperty(this,"scope",{value:this._scope,writable:!0});};ct.prototype.toString=function(){return this.objId+" 0 R"},ct.prototype.putStream=function(){var t=this.getKeyValueListForStream();this.scope.internal.putStream({data:this.stream,additionalKeyValues:t,objectId:this.objId}),this.scope.internal.out("endobj");},ct.prototype.getKeyValueListForStream=function(){var t=[],e=Object.getOwnPropertyNames(this).filter((function(t){return "content"!=t&&"appearanceStreamContent"!=t&&"scope"!=t&&"objId"!=t&&"_"!=t.substring(0,1)}));for(var r in e)if(!1===Object.getOwnPropertyDescriptor(this,e[r]).configurable){var n=e[r],i=this[n];i&&(Array.isArray(i)?t.push({key:n,value:ot(i,this.objId,this.scope)}):i instanceof ct?(i.scope=this.scope,t.push({key:n,value:i.objId+" 0 R"})):"function"!=typeof i&&t.push({key:n,value:i}));}return t};var ut=function(){ct.call(this),Object.defineProperty(this,"Type",{value:"/XObject",configurable:!1,writable:!0}),Object.defineProperty(this,"Subtype",{value:"/Form",configurable:!1,writable:!0}),Object.defineProperty(this,"FormType",{value:1,configurable:!1,writable:!0});var t,e=[];Object.defineProperty(this,"BBox",{configurable:!1,get:function(){return e},set:function(t){e=t;}}),Object.defineProperty(this,"Resources",{value:"2 0 R",configurable:!1,writable:!0}),Object.defineProperty(this,"stream",{enumerable:!1,configurable:!0,set:function(e){t=e.trim();},get:function(){return t||null}});};H(ut,ct);var ht=function(){ct.call(this);var t,e=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return e.length>0?e:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!1,configurable:!1,get:function(){return e}}),Object.defineProperty(this,"DA",{enumerable:!1,configurable:!1,get:function(){if(t){var e=function(t){return t};return this.scope&&(e=this.scope.internal.getEncryptor(this.objId)),"("+R(e(t))+")"}},set:function(e){t=e;}});};H(ht,ct);var lt=function t(){ct.call(this);var e=4;Object.defineProperty(this,"F",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute F supplied.');e=t;}}),Object.defineProperty(this,"showWhenPrinted",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(e,3))},set:function(t){!0===Boolean(t)?this.F=K(e,3):this.F=Z(e,3);}});var r=0;Object.defineProperty(this,"Ff",{enumerable:!1,configurable:!1,get:function(){return r},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute Ff supplied.');r=t;}});var n=[];Object.defineProperty(this,"Rect",{enumerable:!1,configurable:!1,get:function(){if(0!==n.length)return n},set:function(t){n=void 0!==t?t:[];}}),Object.defineProperty(this,"x",{enumerable:!0,configurable:!0,get:function(){return !n||isNaN(n[0])?0:n[0]},set:function(t){n[0]=t;}}),Object.defineProperty(this,"y",{enumerable:!0,configurable:!0,get:function(){return !n||isNaN(n[1])?0:n[1]},set:function(t){n[1]=t;}}),Object.defineProperty(this,"width",{enumerable:!0,configurable:!0,get:function(){return !n||isNaN(n[2])?0:n[2]},set:function(t){n[2]=t;}}),Object.defineProperty(this,"height",{enumerable:!0,configurable:!0,get:function(){return !n||isNaN(n[3])?0:n[3]},set:function(t){n[3]=t;}});var i="";Object.defineProperty(this,"FT",{enumerable:!0,configurable:!1,get:function(){return i},set:function(t){switch(t){case"/Btn":case"/Tx":case"/Ch":case"/Sig":i=t;break;default:throw new Error('Invalid value "'+t+'" for attribute FT supplied.')}}});var a=null;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,get:function(){if(!a||a.length<1){if(this instanceof yt)return;a="FieldObject"+t.FieldNum++;}var e=function(t){return t};return this.scope&&(e=this.scope.internal.getEncryptor(this.objId)),"("+R(e(a))+")"},set:function(t){a=t.toString();}}),Object.defineProperty(this,"fieldName",{configurable:!0,enumerable:!0,get:function(){return a},set:function(t){a=t;}});var o="helvetica";Object.defineProperty(this,"fontName",{enumerable:!0,configurable:!0,get:function(){return o},set:function(t){o=t;}});var s="normal";Object.defineProperty(this,"fontStyle",{enumerable:!0,configurable:!0,get:function(){return s},set:function(t){s=t;}});var c=0;Object.defineProperty(this,"fontSize",{enumerable:!0,configurable:!0,get:function(){return c},set:function(t){c=t;}});var u=void 0;Object.defineProperty(this,"maxFontSize",{enumerable:!0,configurable:!0,get:function(){return void 0===u?50/D:u},set:function(t){u=t;}});var h="black";Object.defineProperty(this,"color",{enumerable:!0,configurable:!0,get:function(){return h},set:function(t){h=t;}});var l="/F1 0 Tf 0 g";Object.defineProperty(this,"DA",{enumerable:!0,configurable:!1,get:function(){if(!(!l||this instanceof yt||this instanceof Nt))return st(l,this.objId,this.scope)},set:function(t){t=t.toString(),l=t;}});var f=null;Object.defineProperty(this,"DV",{enumerable:!1,configurable:!1,get:function(){if(f)return this instanceof mt==!1?st(f,this.objId,this.scope):f},set:function(t){t=t.toString(),f=this instanceof mt==!1?"("===t.substr(0,1)?T(t.substr(1,t.length-2)):T(t):t;}}),Object.defineProperty(this,"defaultValue",{enumerable:!0,configurable:!0,get:function(){return this instanceof mt==!0?T(f.substr(1,f.length-1)):f},set:function(t){t=t.toString(),f=this instanceof mt==!0?"/"+t:t;}});var d=null;Object.defineProperty(this,"_V",{enumerable:!1,configurable:!1,get:function(){if(d)return d},set:function(t){this.V=t;}}),Object.defineProperty(this,"V",{enumerable:!1,configurable:!1,get:function(){if(d)return this instanceof mt==!1?st(d,this.objId,this.scope):d},set:function(t){t=t.toString(),d=this instanceof mt==!1?"("===t.substr(0,1)?T(t.substr(1,t.length-2)):T(t):t;}}),Object.defineProperty(this,"value",{enumerable:!0,configurable:!0,get:function(){return this instanceof mt==!0?T(d.substr(1,d.length-1)):d},set:function(t){t=t.toString(),d=this instanceof mt==!0?"/"+t:t;}}),Object.defineProperty(this,"hasAnnotation",{enumerable:!0,configurable:!0,get:function(){return this.Rect}}),Object.defineProperty(this,"Type",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Widget":null}});var p,g=!1;Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return g},set:function(t){t=Boolean(t),g=t;}}),Object.defineProperty(this,"page",{enumerable:!0,configurable:!0,get:function(){if(p)return p},set:function(t){p=t;}}),Object.defineProperty(this,"readOnly",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,1))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,1):this.Ff=Z(this.Ff,1);}}),Object.defineProperty(this,"required",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,2))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,2):this.Ff=Z(this.Ff,2);}}),Object.defineProperty(this,"noExport",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,3))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,3):this.Ff=Z(this.Ff,3);}});var m=null;Object.defineProperty(this,"Q",{enumerable:!0,configurable:!1,get:function(){if(null!==m)return m},set:function(t){if(-1===[0,1,2].indexOf(t))throw new Error('Invalid value "'+t+'" for attribute Q supplied.');m=t;}}),Object.defineProperty(this,"textAlign",{get:function(){var t;switch(m){case 0:default:t="left";break;case 1:t="center";break;case 2:t="right";}return t},configurable:!0,enumerable:!0,set:function(t){switch(t){case"right":case 2:m=2;break;case"center":case 1:m=1;break;case"left":case 0:default:m=0;}}});};H(lt,ct);var ft=function(){lt.call(this),this.FT="/Ch",this.V="()",this.fontName="zapfdingbats";var t=0;Object.defineProperty(this,"TI",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=e;}}),Object.defineProperty(this,"topIndex",{enumerable:!0,configurable:!0,get:function(){return t},set:function(e){t=e;}});var e=[];Object.defineProperty(this,"Opt",{enumerable:!0,configurable:!1,get:function(){return ot(e,this.objId,this.scope)},set:function(t){var r,n;n=[],"string"==typeof(r=t)&&(n=function(t,e,r){r||(r=1);for(var n,i=[];n=e.exec(t);)i.push(n[r]);return i}(r,/\((.*?)\)/g)),e=n;}}),this.getOptions=function(){return e},this.setOptions=function(t){e=t,this.sort&&e.sort();},this.addOption=function(t){t=(t=t||"").toString(),e.push(t),this.sort&&e.sort();},this.removeOption=function(t,r){for(r=r||!1,t=(t=t||"").toString();-1!==e.indexOf(t)&&(e.splice(e.indexOf(t),1),!1!==r););},Object.defineProperty(this,"combo",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,18))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,18):this.Ff=Z(this.Ff,18);}}),Object.defineProperty(this,"edit",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,19))},set:function(t){!0===this.combo&&(!0===Boolean(t)?this.Ff=K(this.Ff,19):this.Ff=Z(this.Ff,19));}}),Object.defineProperty(this,"sort",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,20))},set:function(t){!0===Boolean(t)?(this.Ff=K(this.Ff,20),e.sort()):this.Ff=Z(this.Ff,20);}}),Object.defineProperty(this,"multiSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,22))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,22):this.Ff=Z(this.Ff,22);}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,23):this.Ff=Z(this.Ff,23);}}),Object.defineProperty(this,"commitOnSelChange",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,27))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,27):this.Ff=Z(this.Ff,27);}}),this.hasAppearanceStream=!1;};H(ft,lt);var dt=function(){ft.call(this),this.fontName="helvetica",this.combo=!1;};H(dt,ft);var pt=function(){dt.call(this),this.combo=!0;};H(pt,dt);var gt=function(){pt.call(this),this.edit=!0;};H(gt,pt);var mt=function(){lt.call(this),this.FT="/Btn",Object.defineProperty(this,"noToggleToOff",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,15))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,15):this.Ff=Z(this.Ff,15);}}),Object.defineProperty(this,"radio",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,16))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,16):this.Ff=Z(this.Ff,16);}}),Object.defineProperty(this,"pushButton",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,17))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,17):this.Ff=Z(this.Ff,17);}}),Object.defineProperty(this,"radioIsUnison",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,26):this.Ff=Z(this.Ff,26);}});var e,r={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t=function(t){return t};if(this.scope&&(t=this.scope.internal.getEncryptor(this.objId)),0!==Object.keys(r).length){var e,n=[];for(e in n.push("<<"),r)n.push("/"+e+" ("+R(t(r[e]))+")");return n.push(">>"),n.join("\n")}},set:function(e){"object"===_typeof$2(e)&&(r=e);}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return r.CA||""},set:function(t){"string"==typeof t&&(r.CA=t);}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t;}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return e.substr(1,e.length-1)},set:function(t){e="/"+t;}});};H(mt,lt);var vt=function(){mt.call(this),this.pushButton=!0;};H(vt,mt);var bt=function(){mt.call(this),this.radio=!0,this.pushButton=!1;var t=[];Object.defineProperty(this,"Kids",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=void 0!==e?e:[];}});};H(bt,mt);var yt=function(){var e,r;lt.call(this),Object.defineProperty(this,"Parent",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t;}}),Object.defineProperty(this,"optionName",{enumerable:!1,configurable:!0,get:function(){return r},set:function(t){r=t;}});var n,i={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t=function(t){return t};this.scope&&(t=this.scope.internal.getEncryptor(this.objId));var e,r=[];for(e in r.push("<<"),i)r.push("/"+e+" ("+R(t(i[e]))+")");return r.push(">>"),r.join("\n")},set:function(e){"object"===_typeof$2(e)&&(i=e);}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return i.CA||""},set:function(t){"string"==typeof t&&(i.CA=t);}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return n},set:function(t){n=t;}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return n.substr(1,n.length-1)},set:function(t){n="/"+t;}}),this.caption="l",this.appearanceState="Off",this._AppearanceType=At.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(this.optionName);};H(yt,lt),bt.prototype.setAppearance=function(t){if(!("createAppearanceStream"in t)||!("getCA"in t))throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");for(var e in this.Kids)if(this.Kids.hasOwnProperty(e)){var r=this.Kids[e];r.appearanceStreamContent=t.createAppearanceStream(r.optionName),r.caption=t.getCA();}},bt.prototype.createOption=function(t){var e=new yt;return e.Parent=this,e.optionName=t,this.Kids.push(e),xt.call(this.scope,e),e};var wt=function(){mt.call(this),this.fontName="zapfdingbats",this.caption="3",this.appearanceState="On",this.value="On",this.textAlign="center",this.appearanceStreamContent=At.CheckBox.createAppearanceStream();};H(wt,mt);var Nt=function(){lt.call(this),this.FT="/Tx",Object.defineProperty(this,"multiline",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,13))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,13):this.Ff=Z(this.Ff,13);}}),Object.defineProperty(this,"fileSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,21))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,21):this.Ff=Z(this.Ff,21);}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,23):this.Ff=Z(this.Ff,23);}}),Object.defineProperty(this,"doNotScroll",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,24))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,24):this.Ff=Z(this.Ff,24);}}),Object.defineProperty(this,"comb",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,25))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,25):this.Ff=Z(this.Ff,25);}}),Object.defineProperty(this,"richText",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,26):this.Ff=Z(this.Ff,26);}});var t=null;Object.defineProperty(this,"MaxLen",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=e;}}),Object.defineProperty(this,"maxLength",{enumerable:!0,configurable:!0,get:function(){return t},set:function(e){Number.isInteger(e)&&(t=e);}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return this.V||this.DV}});};H(Nt,lt);var Lt=function(){Nt.call(this),Object.defineProperty(this,"password",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,14))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,14):this.Ff=Z(this.Ff,14);}}),this.password=!0;};H(Lt,Nt);var At={CheckBox:{createAppearanceStream:function(){return {N:{On:At.CheckBox.YesNormal},D:{On:At.CheckBox.YesPushDown,Off:At.CheckBox.OffPushDown}}},YesPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[],n=t.scope.internal.getFont(t.fontName,t.fontStyle).id,i=t.scope.__private__.encodeColorString(t.color),a=tt(t,t.caption);return r.push("0.749023 g"),r.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),r.push("f"),r.push("BMC"),r.push("q"),r.push("0 0 1 rg"),r.push("/"+n+" "+U(a.fontSize)+" Tf "+i),r.push("BT"),r.push(a.text),r.push("ET"),r.push("Q"),r.push("EMC"),e.stream=r.join("\n"),e},YesNormal:function(t){var e=V(t);e.scope=t.scope;var r=t.scope.internal.getFont(t.fontName,t.fontStyle).id,n=t.scope.__private__.encodeColorString(t.color),i=[],a=At.internal.getHeight(t),o=At.internal.getWidth(t),s=tt(t,t.caption);return i.push("1 g"),i.push("0 0 "+U(o)+" "+U(a)+" re"),i.push("f"),i.push("q"),i.push("0 0 1 rg"),i.push("0 0 "+U(o-1)+" "+U(a-1)+" re"),i.push("W"),i.push("n"),i.push("0 g"),i.push("BT"),i.push("/"+r+" "+U(s.fontSize)+" Tf "+n),i.push(s.text),i.push("ET"),i.push("Q"),e.stream=i.join("\n"),e},OffPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[];return r.push("0.749023 g"),r.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),r.push("f"),e.stream=r.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:At.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=At.RadioButton.Circle.YesNormal,e.D[t]=At.RadioButton.Circle.YesPushDown,e},getCA:function(){return "l"},YesNormal:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.getWidth(t)<=At.internal.getHeight(t)?At.internal.getWidth(t)/4:At.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=At.internal.Bezier_C,a=Number((n*i).toFixed(5));return r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(n+" 0 m"),r.push(n+" "+a+" "+a+" "+n+" 0 "+n+" c"),r.push("-"+a+" "+n+" -"+n+" "+a+" -"+n+" 0 c"),r.push("-"+n+" -"+a+" -"+a+" -"+n+" 0 -"+n+" c"),r.push(a+" -"+n+" "+n+" -"+a+" "+n+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e},YesPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.getWidth(t)<=At.internal.getHeight(t)?At.internal.getWidth(t)/4:At.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=Number((2*n).toFixed(5)),a=Number((i*At.internal.Bezier_C).toFixed(5)),o=Number((n*At.internal.Bezier_C).toFixed(5));return r.push("0.749023 g"),r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(i+" 0 m"),r.push(i+" "+a+" "+a+" "+i+" 0 "+i+" c"),r.push("-"+a+" "+i+" -"+i+" "+a+" -"+i+" 0 c"),r.push("-"+i+" -"+a+" -"+a+" -"+i+" 0 -"+i+" c"),r.push(a+" -"+i+" "+i+" -"+a+" "+i+" 0 c"),r.push("f"),r.push("Q"),r.push("0 g"),r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(n+" 0 m"),r.push(n+" "+o+" "+o+" "+n+" 0 "+n+" c"),r.push("-"+o+" "+n+" -"+n+" "+o+" -"+n+" 0 c"),r.push("-"+n+" -"+o+" -"+o+" -"+n+" 0 -"+n+" c"),r.push(o+" -"+n+" "+n+" -"+o+" "+n+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.getWidth(t)<=At.internal.getHeight(t)?At.internal.getWidth(t)/4:At.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=Number((2*n).toFixed(5)),a=Number((i*At.internal.Bezier_C).toFixed(5));return r.push("0.749023 g"),r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(i+" 0 m"),r.push(i+" "+a+" "+a+" "+i+" 0 "+i+" c"),r.push("-"+a+" "+i+" -"+i+" "+a+" -"+i+" 0 c"),r.push("-"+i+" -"+a+" -"+a+" -"+i+" 0 -"+i+" c"),r.push(a+" -"+i+" "+i+" -"+a+" "+i+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:At.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=At.RadioButton.Cross.YesNormal,e.D[t]=At.RadioButton.Cross.YesPushDown,e},getCA:function(){return "8"},YesNormal:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.calculateCross(t);return r.push("q"),r.push("1 1 "+U(At.internal.getWidth(t)-2)+" "+U(At.internal.getHeight(t)-2)+" re"),r.push("W"),r.push("n"),r.push(U(n.x1.x)+" "+U(n.x1.y)+" m"),r.push(U(n.x2.x)+" "+U(n.x2.y)+" l"),r.push(U(n.x4.x)+" "+U(n.x4.y)+" m"),r.push(U(n.x3.x)+" "+U(n.x3.y)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},YesPushDown:function(t){var e=V(t);e.scope=t.scope;var r=At.internal.calculateCross(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),n.push("f"),n.push("q"),n.push("1 1 "+U(At.internal.getWidth(t)-2)+" "+U(At.internal.getHeight(t)-2)+" re"),n.push("W"),n.push("n"),n.push(U(r.x1.x)+" "+U(r.x1.y)+" m"),n.push(U(r.x2.x)+" "+U(r.x2.y)+" l"),n.push(U(r.x4.x)+" "+U(r.x4.y)+" m"),n.push(U(r.x3.x)+" "+U(r.x3.y)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[];return r.push("0.749023 g"),r.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),r.push("f"),e.stream=r.join("\n"),e}}},createDefaultAppearanceStream:function(t){var e=t.scope.internal.getFont(t.fontName,t.fontStyle).id,r=t.scope.__private__.encodeColorString(t.color);return "/"+e+" "+t.fontSize+" Tf "+r}};At.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=At.internal.getWidth(t),r=At.internal.getHeight(t),n=Math.min(e,r);return {x1:{x:(e-n)/2,y:(r-n)/2+n},x2:{x:(e-n)/2+n,y:(r-n)/2},x3:{x:(e-n)/2,y:(r-n)/2},x4:{x:(e-n)/2+n,y:(r-n)/2+n}}}},At.internal.getWidth=function(e){var r=0;return "object"===_typeof$2(e)&&(r=W(e.Rect[2])),r},At.internal.getHeight=function(e){var r=0;return "object"===_typeof$2(e)&&(r=W(e.Rect[3])),r};var xt=q.addField=function(t){if(at(this,t),!(t instanceof lt))throw new Error("Invalid argument passed to jsPDF.addField.");var e;return (e=t).scope.internal.acroformPlugin.printedOut&&(e.scope.internal.acroformPlugin.printedOut=!1,e.scope.internal.acroformPlugin.acroFormDictionaryRoot=null),e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e),t.page=t.scope.internal.getCurrentPageInfo().pageNumber,this};q.AcroFormChoiceField=ft,q.AcroFormListBox=dt,q.AcroFormComboBox=pt,q.AcroFormEditBox=gt,q.AcroFormButton=mt,q.AcroFormPushButton=vt,q.AcroFormRadioButton=bt,q.AcroFormCheckBox=wt,q.AcroFormTextField=Nt,q.AcroFormPasswordField=Lt,q.AcroFormAppearance=At,q.AcroForm={ChoiceField:ft,ListBox:dt,ComboBox:pt,EditBox:gt,Button:mt,PushButton:vt,RadioButton:bt,CheckBox:wt,TextField:Nt,PasswordField:Lt,Appearance:At},E.AcroForm={ChoiceField:ft,ListBox:dt,ComboBox:pt,EditBox:gt,Button:mt,PushButton:vt,RadioButton:bt,CheckBox:wt,TextField:Nt,PasswordField:Lt,Appearance:At};function _t(t){return t.reduce((function(t,e,r){return t[e]=r,t}),{})}!function(e){e.__addimage__={};var r="UNKNOWN",n={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0],[255,216,255,219],[255,216,255,238]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],WEBP:[[82,73,70,70,void 0,void 0,void 0,void 0,87,69,66,80]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]},i=e.__addimage__.getImageFileTypeByImageData=function(t,e){var i,a,o,s,c,u=r;if("RGBA"===(e=e||r)||void 0!==t.data&&t.data instanceof Uint8ClampedArray&&"height"in t&&"width"in t)return "RGBA";if(x(t))for(c in n)for(o=n[c],i=0;i<o.length;i+=1){for(s=!0,a=0;a<o[i].length;a+=1)if(void 0!==o[i][a]&&o[i][a]!==t[a]){s=!1;break}if(!0===s){u=c;break}}else for(c in n)for(o=n[c],i=0;i<o.length;i+=1){for(s=!0,a=0;a<o[i].length;a+=1)if(void 0!==o[i][a]&&o[i][a]!==t.charCodeAt(a)){s=!1;break}if(!0===s){u=c;break}}return u===r&&e!==r&&(u=e),u},a=function t(e){for(var r=this.internal.write,n=this.internal.putStream,i=(0, this.internal.getFilters)();-1!==i.indexOf("FlateEncode");)i.splice(i.indexOf("FlateEncode"),1);e.objectId=this.internal.newObject();var a=[];if(a.push({key:"Type",value:"/XObject"}),a.push({key:"Subtype",value:"/Image"}),a.push({key:"Width",value:e.width}),a.push({key:"Height",value:e.height}),e.colorSpace===b.INDEXED?a.push({key:"ColorSpace",value:"[/Indexed /DeviceRGB "+(e.palette.length/3-1)+" "+("sMask"in e&&void 0!==e.sMask?e.objectId+2:e.objectId+1)+" 0 R]"}):(a.push({key:"ColorSpace",value:"/"+e.colorSpace}),e.colorSpace===b.DEVICE_CMYK&&a.push({key:"Decode",value:"[1 0 1 0 1 0 1 0]"})),a.push({key:"BitsPerComponent",value:e.bitsPerComponent}),"decodeParameters"in e&&void 0!==e.decodeParameters&&a.push({key:"DecodeParms",value:"<<"+e.decodeParameters+">>"}),"transparency"in e&&Array.isArray(e.transparency)){for(var o="",s=0,c=e.transparency.length;s<c;s++)o+=e.transparency[s]+" "+e.transparency[s]+" ";a.push({key:"Mask",value:"["+o+"]"});}void 0!==e.sMask&&a.push({key:"SMask",value:e.objectId+1+" 0 R"});var u=void 0!==e.filter?["/"+e.filter]:void 0;if(n({data:e.data,additionalKeyValues:a,alreadyAppliedFilters:u,objectId:e.objectId}),r("endobj"),"sMask"in e&&void 0!==e.sMask){var h="/Predictor "+e.predictor+" /Colors 1 /BitsPerComponent "+e.bitsPerComponent+" /Columns "+e.width,l={width:e.width,height:e.height,colorSpace:"DeviceGray",bitsPerComponent:e.bitsPerComponent,decodeParameters:h,data:e.sMask};"filter"in e&&(l.filter=e.filter),t.call(this,l);}if(e.colorSpace===b.INDEXED){var f=this.internal.newObject();n({data:_(new Uint8Array(e.palette)),objectId:f}),r("endobj");}},o=function(){var t=this.internal.collections.addImage_images;for(var e in t)a.call(this,t[e]);},s=function(){var t,e=this.internal.collections.addImage_images,r=this.internal.write;for(var n in e)r("/I"+(t=e[n]).index,t.objectId,"0","R");},c=function(){this.internal.collections.addImage_images||(this.internal.collections.addImage_images={},this.internal.events.subscribe("putResources",o),this.internal.events.subscribe("putXobjectDict",s));},h=function(){var t=this.internal.collections.addImage_images;return c.call(this),t},l=function(){return Object.keys(this.internal.collections.addImage_images).length},f=function(t){return "function"==typeof e["process"+t.toUpperCase()]},d=function(e){return "object"===_typeof$2(e)&&1===e.nodeType},p=function(t,r){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return u(unescape(n).split("base64,").pop());var i=e.loadFile(n,!0);if(void 0!==i)return i}if("CANVAS"===t.nodeName){if(0===t.width||0===t.height)throw new Error("Given canvas must have data. Canvas width: "+t.width+", height: "+t.height);var a;switch(r){case"PNG":a="image/png";break;case"WEBP":a="image/webp";break;case"JPEG":case"JPG":default:a="image/jpeg";}return u(t.toDataURL(a,1).split("base64,").pop())}},g=function(t){var e=this.internal.collections.addImage_images;if(e)for(var r in e)if(t===e[r].alias)return e[r]},m=function(t,e,r){return t||e||(t=-96,e=-96),t<0&&(t=-1*r.width*72/t/this.internal.scaleFactor),e<0&&(e=-1*r.height*72/e/this.internal.scaleFactor),0===t&&(t=e*r.width/r.height),0===e&&(e=t*r.height/r.width),[t,e]},v=function(t,e,r,n,i,a){var o=m.call(this,r,n,i),s=this.internal.getCoordinateString,c=this.internal.getVerticalCoordinateString,u=h.call(this);if(r=o[0],n=o[1],u[i.index]=i,a){a*=Math.PI/180;var l=Math.cos(a),f=Math.sin(a),d=function(t){return t.toFixed(4)},p=[d(l),d(f),d(-1*f),d(l),0,0,"cm"];}this.internal.write("q"),a?(this.internal.write([1,"0","0",1,s(t),c(e+n),"cm"].join(" ")),this.internal.write(p.join(" ")),this.internal.write([s(r),"0","0",s(n),"0","0","cm"].join(" "))):this.internal.write([s(r),"0","0",s(n),s(t),c(e+n),"cm"].join(" ")),this.isAdvancedAPI()&&this.internal.write([1,0,0,-1,0,0,"cm"].join(" ")),this.internal.write("/I"+i.index+" Do"),this.internal.write("Q");},b=e.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"};e.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"};var y=e.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},w=e.__addimage__.sHashCode=function(t){var e,r,n=0;if("string"==typeof t)for(r=t.length,e=0;e<r;e++)n=(n<<5)-n+t.charCodeAt(e),n|=0;else if(x(t))for(r=t.byteLength/2,e=0;e<r;e++)n=(n<<5)-n+t[e],n|=0;return n},N=e.__addimage__.validateStringAsBase64=function(t){(t=t||"").toString().trim();var e=!0;return 0===t.length&&(e=!1),t.length%4!=0&&(e=!1),!1===/^[A-Za-z0-9+/]+$/.test(t.substr(0,t.length-2))&&(e=!1),!1===/^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2))&&(e=!1),e},L=e.__addimage__.extractImageFromDataUrl=function(t){var e=(t=t||"").split("base64,"),r=null;if(2===e.length){var n=/^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(e[0]);Array.isArray(n)&&(r={mimeType:n[1],charset:n[2],data:e[1]});}return r},A=e.__addimage__.supportsArrayBuffer=function(){return "undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array};e.__addimage__.isArrayBuffer=function(t){return A()&&t instanceof ArrayBuffer};var x=e.__addimage__.isArrayBufferView=function(t){return A()&&"undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array)},S=e.__addimage__.binaryStringToUint8Array=function(t){for(var e=t.length,r=new Uint8Array(e),n=0;n<e;n++)r[n]=t.charCodeAt(n);return r},_=e.__addimage__.arrayBufferToBinaryString=function(t){for(var e="",r=x(t)?t:new Uint8Array(t),n=0;n<r.length;n+=8192)e+=String.fromCharCode.apply(null,r.subarray(n,n+8192));return e};e.addImage=function(){var e,n,i,a,o,s,u,h,l;if("number"==typeof arguments[1]?(n=r,i=arguments[1],a=arguments[2],o=arguments[3],s=arguments[4],u=arguments[5],h=arguments[6],l=arguments[7]):(n=arguments[1],i=arguments[2],a=arguments[3],o=arguments[4],s=arguments[5],u=arguments[6],h=arguments[7],l=arguments[8]),"object"===_typeof$2(e=arguments[0])&&!d(e)&&"imageData"in e){var f=e;e=f.imageData,n=f.format||n||r,i=f.x||i||0,a=f.y||a||0,o=f.w||f.width||o,s=f.h||f.height||s,u=f.alias||u,h=f.compression||h,l=f.rotation||f.angle||l;}var p=this.internal.getFilters();if(void 0===h&&-1!==p.indexOf("FlateEncode")&&(h="SLOW"),isNaN(i)||isNaN(a))throw new Error("Invalid coordinates passed to jsPDF.addImage");c.call(this);var g=P.call(this,e,n,u,h);return v.call(this,i,a,o,s,g,l),this};var P=function(t,n,a,o){var s,c,u;if("string"==typeof t&&i(t)===r){t=unescape(t);var h=k(t,!1);(""!==h||void 0!==(h=e.loadFile(t,!0)))&&(t=h);}if(d(t)&&(t=p(t,n)),n=i(t,n),!f(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if((null==(u=a)||0===u.length)&&(a=function(t){return "string"==typeof t||x(t)?w(t):x(t.data)?w(t.data):null}(t)),(s=g.call(this,a))||(A()&&(t instanceof Uint8Array||"RGBA"===n||(c=t,t=S(t))),s=this["process"+n.toUpperCase()](t,l.call(this),a,function(t){return t&&"string"==typeof t&&(t=t.toUpperCase()),t in e.image_compression?t:y.NONE}(o),c)),!s)throw new Error("An unknown error occurred whilst processing the image.");return s},k=e.__addimage__.convertBase64ToBinaryString=function(t,e){var r;e="boolean"!=typeof e||e;var n,i="";if("string"==typeof t){n=null!==(r=L(t))?r.data:t;try{i=u(n);}catch(t){if(e)throw N(n)?new Error("atob-Error in jsPDF.convertBase64ToBinaryString "+t.message):new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ")}}return i};e.getImageProperties=function(t){var n,a,o="";if(d(t)&&(t=p(t)),"string"==typeof t&&i(t)===r&&(""===(o=k(t,!1))&&(o=e.loadFile(t)||""),t=o),a=i(t),!f(a))throw new Error("addImage does not support files of type '"+a+"', please ensure that a plugin for '"+a+"' support is added.");if(!A()||t instanceof Uint8Array||(t=S(t)),!(n=this["process"+a.toUpperCase()](t)))throw new Error("An unknown error occurred whilst processing the image");return n.fileType=a,n};}(E.API),
/**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(t){if(void 0!==t&&""!=t)return !0};E.API.events.push(["addPage",function(t){this.internal.getPageInfo(t.pageNumber).pageContext.annotations=[];}]),t.events.push(["putPage",function(t){for(var r,n,i,a=this.internal.getCoordinateString,o=this.internal.getVerticalCoordinateString,s=this.internal.getPageInfoByObjId(t.objId),c=t.pageContext.annotations,u=!1,h=0;h<c.length&&!u;h++)switch((r=c[h]).type){case"link":(e(r.options.url)||e(r.options.pageNumber))&&(u=!0);break;case"reference":case"text":case"freetext":u=!0;}if(0!=u){this.internal.write("/Annots [");for(var l=0;l<c.length;l++){r=c[l];var f=this.internal.pdfEscape,d=this.internal.getEncryptor(t.objId);switch(r.type){case"reference":this.internal.write(" "+r.object.objId+" 0 R ");break;case"text":var p=this.internal.newAdditionalObject(),g=this.internal.newAdditionalObject(),m=this.internal.getEncryptor(p.objId),v=r.title||"Note";i="<</Type /Annot /Subtype /Text "+(n="/Rect ["+a(r.bounds.x)+" "+o(r.bounds.y+r.bounds.h)+" "+a(r.bounds.x+r.bounds.w)+" "+o(r.bounds.y)+"] ")+"/Contents ("+f(m(r.contents))+")",i+=" /Popup "+g.objId+" 0 R",i+=" /P "+s.objId+" 0 R",i+=" /T ("+f(m(v))+") >>",p.content=i;var b=p.objId+" 0 R";i="<</Type /Annot /Subtype /Popup "+(n="/Rect ["+a(r.bounds.x+30)+" "+o(r.bounds.y+r.bounds.h)+" "+a(r.bounds.x+r.bounds.w+30)+" "+o(r.bounds.y)+"] ")+" /Parent "+b,r.open&&(i+=" /Open true"),i+=" >>",g.content=i,this.internal.write(p.objId,"0 R",g.objId,"0 R");break;case"freetext":n="/Rect ["+a(r.bounds.x)+" "+o(r.bounds.y)+" "+a(r.bounds.x+r.bounds.w)+" "+o(r.bounds.y+r.bounds.h)+"] ";var y=r.color||"#000000";i="<</Type /Annot /Subtype /FreeText "+n+"/Contents ("+f(d(r.contents))+")",i+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+y+")",i+=" /Border [0 0 0]",i+=" >>",this.internal.write(i);break;case"link":if(r.options.name){var w=this.annotations._nameMap[r.options.name];r.options.pageNumber=w.page,r.options.top=w.y;}else r.options.top||(r.options.top=0);if(n="/Rect ["+r.finalBounds.x+" "+r.finalBounds.y+" "+r.finalBounds.w+" "+r.finalBounds.h+"] ",i="",r.options.url)i="<</Type /Annot /Subtype /Link "+n+"/Border [0 0 0] /A <</S /URI /URI ("+f(d(r.options.url))+") >>";else if(r.options.pageNumber){switch(i="<</Type /Annot /Subtype /Link "+n+"/Border [0 0 0] /Dest ["+this.internal.getPageInfo(r.options.pageNumber).objId+" 0 R",r.options.magFactor=r.options.magFactor||"XYZ",r.options.magFactor){case"Fit":i+=" /Fit]";break;case"FitH":i+=" /FitH "+r.options.top+"]";break;case"FitV":r.options.left=r.options.left||0,i+=" /FitV "+r.options.left+"]";break;case"XYZ":default:var N=o(r.options.top);r.options.left=r.options.left||0,void 0===r.options.zoom&&(r.options.zoom=0),i+=" /XYZ "+r.options.left+" "+N+" "+r.options.zoom+"]";}}""!=i&&(i+=" >>",this.internal.write(i));}}this.internal.write("]");}}]),t.createAnnotation=function(t){var e=this.internal.getCurrentPageInfo();switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":e.pageContext.annotations.push(t);}},t.link=function(t,e,r,n,i){var a=this.internal.getCurrentPageInfo(),o=this.internal.getCoordinateString,s=this.internal.getVerticalCoordinateString;a.pageContext.annotations.push({finalBounds:{x:o(t),y:s(e),w:o(t+r),h:s(e+n)},options:i,type:"link"});},t.textWithLink=function(t,e,r,n){var i,a,o=this.getTextWidth(t),s=this.internal.getLineHeight()/this.internal.scaleFactor;if(void 0!==n.maxWidth){a=n.maxWidth;var c=this.splitTextToSize(t,a).length;i=Math.ceil(s*c);}else a=o,i=s;return this.text(t,e,r,n),r+=.2*s,"center"===n.align&&(e-=o/2),"right"===n.align&&(e-=o),this.link(e,r-s,a,i,n),o},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor};}(E.API),
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e={1569:[65152],1570:[65153,65154],1571:[65155,65156],1572:[65157,65158],1573:[65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194],1584:[65195,65196],1585:[65197,65198],1586:[65199,65200],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},r={65247:{65154:65269,65156:65271,65160:65273,65166:65275},65248:{65154:65270,65156:65272,65160:65274,65166:65276},65165:{65247:{65248:{65258:65010}}},1617:{1612:64606,1613:64607,1614:64608,1615:64609,1616:64610}},n={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},i=[1570,1571,1573,1575];t.__arabicParser__={};var a=t.__arabicParser__.isInArabicSubstitutionA=function(t){return void 0!==e[t.charCodeAt(0)]},o=t.__arabicParser__.isArabicLetter=function(t){return "string"==typeof t&&/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t)},s=t.__arabicParser__.isArabicEndLetter=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length<=2},c=t.__arabicParser__.isArabicAlfLetter=function(t){return o(t)&&i.indexOf(t.charCodeAt(0))>=0};t.__arabicParser__.arabicLetterHasIsolatedForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=1};var u=t.__arabicParser__.arabicLetterHasFinalForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=2};t.__arabicParser__.arabicLetterHasInitialForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=3};var h=t.__arabicParser__.arabicLetterHasMedialForm=function(t){return o(t)&&a(t)&&4==e[t.charCodeAt(0)].length},l=t.__arabicParser__.resolveLigatures=function(t){var e=0,n=r,i="",a=0;for(e=0;e<t.length;e+=1)void 0!==n[t.charCodeAt(e)]?(a++,"number"==typeof(n=n[t.charCodeAt(e)])&&(i+=String.fromCharCode(n),n=r,a=0),e===t.length-1&&(n=r,i+=t.charAt(e-(a-1)),e-=a-1,a=0)):(n=r,i+=t.charAt(e-a),e-=a,a=0);return i};t.__arabicParser__.isArabicDiacritic=function(t){return void 0!==t&&void 0!==n[t.charCodeAt(0)]};var f=t.__arabicParser__.getCorrectForm=function(t,e,r){return o(t)?!1===a(t)?-1:!u(t)||!o(e)&&!o(r)||!o(r)&&s(e)||s(t)&&!o(e)||s(t)&&c(e)||s(t)&&s(e)?0:h(t)&&o(e)&&!s(e)&&o(r)&&u(r)?3:s(t)||!o(r)?1:2:-1},d=function(t){var r=0,n=0,i=0,a="",s="",c="",u=(t=t||"").split("\\s+"),h=[];for(r=0;r<u.length;r+=1){for(h.push(""),n=0;n<u[r].length;n+=1)a=u[r][n],s=u[r][n-1],c=u[r][n+1],o(a)?(i=f(a,s,c),h[r]+=-1!==i?String.fromCharCode(e[a.charCodeAt(0)][i]):a):h[r]+=a;h[r]=l(h[r]);}return h.join(" ")},p=t.__arabicParser__.processArabic=t.processArabic=function(){var t,e="string"==typeof arguments[0]?arguments[0]:arguments[0].text,r=[];if(Array.isArray(e)){var n=0;for(r=[],n=0;n<e.length;n+=1)Array.isArray(e[n])?r.push([d(e[n][0]),e[n][1],e[n][2]]):r.push([d(e[n])]);t=r;}else t=d(e);return "string"==typeof arguments[0]?t:(arguments[0].text=t,arguments[0])};t.events.push(["preProcessText",p]);}(E.API),E.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",(function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj");})),this.internal.events.subscribe("putCatalog",(function(){this.internal.out("/OpenAction "+e+" 0 R");}));}return this},
/**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(){var t=void 0;Object.defineProperty(this,"pdf",{get:function(){return t},set:function(e){t=e;}});var e=150;Object.defineProperty(this,"width",{get:function(){return e},set:function(t){e=isNaN(t)||!1===Number.isInteger(t)||t<0?150:t,this.getContext("2d").pageWrapXEnabled&&(this.getContext("2d").pageWrapX=e+1);}});var r=300;Object.defineProperty(this,"height",{get:function(){return r},set:function(t){r=isNaN(t)||!1===Number.isInteger(t)||t<0?300:t,this.getContext("2d").pageWrapYEnabled&&(this.getContext("2d").pageWrapY=r+1);}});var n=[];Object.defineProperty(this,"childNodes",{get:function(){return n},set:function(t){n=t;}});var i={};Object.defineProperty(this,"style",{get:function(){return i},set:function(t){i=t;}}),Object.defineProperty(this,"parentNode",{});};e.prototype.getContext=function(t,e){var r;if("2d"!==(t=t||"2d"))return null;for(r in e)this.pdf.context2d.hasOwnProperty(r)&&(this.pdf.context2d[r]=e[r]);return this.pdf.context2d._canvas=this,this.pdf.context2d},e.prototype.toDataURL=function(){throw new Error("toDataURL is not implemented.")},t.events.push(["initialized",function(){this.canvas=new e,this.canvas.pdf=this;}]);}(E.API),function(e){var r={left:0,top:0,bottom:0,right:0},n=!1,i=function(){void 0===this.internal.__cell__&&(this.internal.__cell__={},this.internal.__cell__.padding=3,this.internal.__cell__.headerFunction=void 0,this.internal.__cell__.margins=Object.assign({},r),this.internal.__cell__.margins.width=this.getPageWidth(),a.call(this));},a=function(){this.internal.__cell__.lastCell=new o,this.internal.__cell__.pages=1;},o=function(){var t=arguments[0];Object.defineProperty(this,"x",{enumerable:!0,get:function(){return t},set:function(e){t=e;}});var e=arguments[1];Object.defineProperty(this,"y",{enumerable:!0,get:function(){return e},set:function(t){e=t;}});var r=arguments[2];Object.defineProperty(this,"width",{enumerable:!0,get:function(){return r},set:function(t){r=t;}});var n=arguments[3];Object.defineProperty(this,"height",{enumerable:!0,get:function(){return n},set:function(t){n=t;}});var i=arguments[4];Object.defineProperty(this,"text",{enumerable:!0,get:function(){return i},set:function(t){i=t;}});var a=arguments[5];Object.defineProperty(this,"lineNumber",{enumerable:!0,get:function(){return a},set:function(t){a=t;}});var o=arguments[6];return Object.defineProperty(this,"align",{enumerable:!0,get:function(){return o},set:function(t){o=t;}}),this};o.prototype.clone=function(){return new o(this.x,this.y,this.width,this.height,this.text,this.lineNumber,this.align)},o.prototype.toArray=function(){return [this.x,this.y,this.width,this.height,this.text,this.lineNumber,this.align]},e.setHeaderFunction=function(t){return i.call(this),this.internal.__cell__.headerFunction="function"==typeof t?t:void 0,this},e.getTextDimensions=function(t,e){i.call(this);var r=(e=e||{}).fontSize||this.getFontSize(),n=e.font||this.getFont(),a=e.scaleFactor||this.internal.scaleFactor,o=0,s=0,c=0,u=this;if(!Array.isArray(t)&&"string"!=typeof t){if("number"!=typeof t)throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");t=String(t);}var h=e.maxWidth;h>0?"string"==typeof t?t=this.splitTextToSize(t,h):"[object Array]"===Object.prototype.toString.call(t)&&(t=t.reduce((function(t,e){return t.concat(u.splitTextToSize(e,h))}),[])):t=Array.isArray(t)?t:[t];for(var l=0;l<t.length;l++)o<(c=this.getStringUnitWidth(t[l],{font:n})*r)&&(o=c);return 0!==o&&(s=t.length),{w:o/=a,h:Math.max((s*r*this.getLineHeightFactor()-r*(this.getLineHeightFactor()-1))/a,0)}},e.cellAddPage=function(){i.call(this),this.addPage();var t=this.internal.__cell__.margins||r;return this.internal.__cell__.lastCell=new o(t.left,t.top,void 0,void 0),this.internal.__cell__.pages+=1,this};var s=e.cell=function(){var t;t=arguments[0]instanceof o?arguments[0]:new o(arguments[0],arguments[1],arguments[2],arguments[3],arguments[4],arguments[5]),i.call(this);var e=this.internal.__cell__.lastCell,a=this.internal.__cell__.padding,s=this.internal.__cell__.margins||r,c=this.internal.__cell__.tableHeaderRow,u=this.internal.__cell__.printHeaders;return void 0!==e.lineNumber&&(e.lineNumber===t.lineNumber?(t.x=(e.x||0)+(e.width||0),t.y=e.y||0):e.y+e.height+t.height+s.bottom>this.getPageHeight()?(this.cellAddPage(),t.y=s.top,u&&c&&(this.printHeaderRow(t.lineNumber,!0),t.y+=c[0].height)):t.y=e.y+e.height||t.y),void 0!==t.text[0]&&(this.rect(t.x,t.y,t.width,t.height,!0===n?"FD":void 0),"right"===t.align?this.text(t.text,t.x+t.width-a,t.y+a,{align:"right",baseline:"top"}):"center"===t.align?this.text(t.text,t.x+t.width/2,t.y+a,{align:"center",baseline:"top",maxWidth:t.width-a-a}):this.text(t.text,t.x+a,t.y+a,{align:"left",baseline:"top",maxWidth:t.width-a-a})),this.internal.__cell__.lastCell=t,this};e.table=function(e,n,u,h,l){if(i.call(this),!u)throw new Error("No data for PDF table.");var f,d,p,g,m=[],v=[],b=[],y={},w={},N=[],L=[],A=(l=l||{}).autoSize||!1,x=!1!==l.printHeaders,S=l.css&&void 0!==l.css["font-size"]?16*l.css["font-size"]:l.fontSize||12,_=l.margins||Object.assign({width:this.getPageWidth()},r),P="number"==typeof l.padding?l.padding:3,k=l.headerBackgroundColor||"#c8c8c8",I=l.headerTextColor||"#000";if(a.call(this),this.internal.__cell__.printHeaders=x,this.internal.__cell__.margins=_,this.internal.__cell__.table_font_size=S,this.internal.__cell__.padding=P,this.internal.__cell__.headerBackgroundColor=k,this.internal.__cell__.headerTextColor=I,this.setFontSize(S),null==h)v=m=Object.keys(u[0]),b=m.map((function(){return "left"}));else if(Array.isArray(h)&&"object"===_typeof$2(h[0]))for(m=h.map((function(t){return t.name})),v=h.map((function(t){return t.prompt||t.name||""})),b=h.map((function(t){return t.align||"left"})),f=0;f<h.length;f+=1)w[h[f].name]=h[f].width*(19.049976/25.4);else Array.isArray(h)&&"string"==typeof h[0]&&(v=m=h,b=m.map((function(){return "left"})));if(A||Array.isArray(h)&&"string"==typeof h[0])for(f=0;f<m.length;f+=1){for(y[g=m[f]]=u.map((function(t){return t[g]})),this.setFont(void 0,"bold"),N.push(this.getTextDimensions(v[f],{fontSize:this.internal.__cell__.table_font_size,scaleFactor:this.internal.scaleFactor}).w),d=y[g],this.setFont(void 0,"normal"),p=0;p<d.length;p+=1)N.push(this.getTextDimensions(d[p],{fontSize:this.internal.__cell__.table_font_size,scaleFactor:this.internal.scaleFactor}).w);w[g]=Math.max.apply(null,N)+P+P,N=[];}if(x){var F={};for(f=0;f<m.length;f+=1)F[m[f]]={},F[m[f]].text=v[f],F[m[f]].align=b[f];var C=c.call(this,F,w);L=m.map((function(t){return new o(e,n,w[t],C,F[t].text,void 0,F[t].align)})),this.setTableHeaderRow(L),this.printHeaderRow(1,!1);}var j=h.reduce((function(t,e){return t[e.name]=e.align,t}),{});for(f=0;f<u.length;f+=1){"rowStart"in l&&l.rowStart instanceof Function&&l.rowStart({row:f,data:u[f]},this);var O=c.call(this,u[f],w);for(p=0;p<m.length;p+=1){var B=u[f][m[p]];"cellStart"in l&&l.cellStart instanceof Function&&l.cellStart({row:f,col:p,data:B},this),s.call(this,new o(e,n,w[m[p]],O,B,f+2,j[m[p]]));}}return this.internal.__cell__.table_x=e,this.internal.__cell__.table_y=n,this};var c=function(t,e){var r=this.internal.__cell__.padding,n=this.internal.__cell__.table_font_size,i=this.internal.scaleFactor;return Object.keys(t).map((function(n){var i=t[n];return this.splitTextToSize(i.hasOwnProperty("text")?i.text:i,e[n]-r-r)}),this).map((function(t){return this.getLineHeightFactor()*t.length*n/i+r+r}),this).reduce((function(t,e){return Math.max(t,e)}),0)};e.setTableHeaderRow=function(t){i.call(this),this.internal.__cell__.tableHeaderRow=t;},e.printHeaderRow=function(t,e){if(i.call(this),!this.internal.__cell__.tableHeaderRow)throw new Error("Property tableHeaderRow does not exist.");var r;if(n=!0,"function"==typeof this.internal.__cell__.headerFunction){var a=this.internal.__cell__.headerFunction(this,this.internal.__cell__.pages);this.internal.__cell__.lastCell=new o(a[0],a[1],a[2],a[3],void 0,-1);}this.setFont(void 0,"bold");for(var c=[],u=0;u<this.internal.__cell__.tableHeaderRow.length;u+=1){r=this.internal.__cell__.tableHeaderRow[u].clone(),e&&(r.y=this.internal.__cell__.margins.top||0,c.push(r)),r.lineNumber=t;var h=this.getTextColor();this.setTextColor(this.internal.__cell__.headerTextColor),this.setFillColor(this.internal.__cell__.headerBackgroundColor),s.call(this,r),this.setTextColor(h);}c.length>0&&this.setTableHeaderRow(c),this.setFont(void 0,"normal"),n=!1;};}(E.API);var Pt={italic:["italic","oblique","normal"],oblique:["oblique","italic","normal"],normal:["normal","oblique","italic"]},kt=["ultra-condensed","extra-condensed","condensed","semi-condensed","normal","semi-expanded","expanded","extra-expanded","ultra-expanded"],It=_t(kt),Ft=[100,200,300,400,500,600,700,800,900],Ct=_t(Ft);function jt(t){var e=t.family.replace(/"|'/g,"").toLowerCase(),r=function(t){return Pt[t=t||"normal"]?t:"normal"}(t.style),n=function(t){if(!t)return 400;if("number"==typeof t)return t>=100&&t<=900&&t%100==0?t:400;if(/^\d00$/.test(t))return parseInt(t);switch(t){case"bold":return 700;case"normal":default:return 400}}(t.weight),i=function(t){return "number"==typeof It[t=t||"normal"]?t:"normal"}(t.stretch);return {family:e,style:r,weight:n,stretch:i,src:t.src||[],ref:t.ref||{name:e,style:[i,r,n].join(" ")}}}function Ot(t,e,r,n){var i;for(i=r;i>=0&&i<e.length;i+=n)if(t[e[i]])return t[e[i]];for(i=r;i>=0&&i<e.length;i-=n)if(t[e[i]])return t[e[i]]}var Bt={"sans-serif":"helvetica",fixed:"courier",monospace:"courier",terminal:"courier",cursive:"times",fantasy:"times",serif:"times"},Mt={caption:"times",icon:"times",menu:"times","message-box":"times","small-caption":"times","status-bar":"times"};function Et(t){return [t.stretch,t.style,t.weight,t.family].join(" ")}function qt(t,e,r){for(var n=(r=r||{}).defaultFontFamily||"times",i=Object.assign({},Bt,r.genericFontFamilies||{}),a=null,o=null,s=0;s<e.length;++s)if(i[(a=jt(e[s])).family]&&(a.family=i[a.family]),t.hasOwnProperty(a.family)){o=t[a.family];break}if(!(o=o||t[n]))throw new Error("Could not find a font-family for the rule '"+Et(a)+"' and default family '"+n+"'.");if(o=function(t,e){if(e[t])return e[t];var r=It[t],n=r<=It.normal?-1:1,i=Ot(e,kt,r,n);if(!i)throw new Error("Could not find a matching font-stretch value for "+t);return i}(a.stretch,o),o=function(t,e){if(e[t])return e[t];for(var r=Pt[t],n=0;n<r.length;++n)if(e[r[n]])return e[r[n]];throw new Error("Could not find a matching font-style for "+t)}(a.style,o),!(o=function(t,e){if(e[t])return e[t];if(400===t&&e[500])return e[500];if(500===t&&e[400])return e[400];var r=Ct[t],n=Ot(e,Ft,r,t<400?-1:1);if(!n)throw new Error("Could not find a matching font-weight for value "+t);return n}(a.weight,o)))throw new Error("Failed to resolve a font for the rule '"+Et(a)+"'.");return o}function Dt(t){return t.trimLeft()}function Rt(t,e){for(var r=0;r<t.length;){if(t.charAt(r)===e)return [t.substring(0,r),t.substring(r+1)];r+=1;}return null}function Tt(t){var e=t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);return null===e?null:[e[0],t.substring(e[0].length)]}var Ut,zt,Ht,Wt=["times"];!function(e){var r,n,i,o,s,c,u,h,l,d=function(t){return t=t||{},this.isStrokeTransparent=t.isStrokeTransparent||!1,this.strokeOpacity=t.strokeOpacity||1,this.strokeStyle=t.strokeStyle||"#000000",this.fillStyle=t.fillStyle||"#000000",this.isFillTransparent=t.isFillTransparent||!1,this.fillOpacity=t.fillOpacity||1,this.font=t.font||"10px sans-serif",this.textBaseline=t.textBaseline||"alphabetic",this.textAlign=t.textAlign||"left",this.lineWidth=t.lineWidth||1,this.lineJoin=t.lineJoin||"miter",this.lineCap=t.lineCap||"butt",this.path=t.path||[],this.transform=void 0!==t.transform?t.transform.clone():new h,this.globalCompositeOperation=t.globalCompositeOperation||"normal",this.globalAlpha=t.globalAlpha||1,this.clip_path=t.clip_path||[],this.currentPoint=t.currentPoint||new c,this.miterLimit=t.miterLimit||10,this.lastPoint=t.lastPoint||new c,this.lineDashOffset=t.lineDashOffset||0,this.lineDash=t.lineDash||[],this.margin=t.margin||[0,0,0,0],this.prevPageLastElemOffset=t.prevPageLastElemOffset||0,this.ignoreClearRect="boolean"!=typeof t.ignoreClearRect||t.ignoreClearRect,this};e.events.push(["initialized",function(){this.context2d=new p(this),r=this.internal.f2,n=this.internal.getCoordinateString,i=this.internal.getVerticalCoordinateString,o=this.internal.getHorizontalCoordinate,s=this.internal.getVerticalCoordinate,c=this.internal.Point,u=this.internal.Rectangle,h=this.internal.Matrix,l=new d;}]);var p=function(t){Object.defineProperty(this,"canvas",{get:function(){return {parentNode:!1,style:!1}}});var e=t;Object.defineProperty(this,"pdf",{get:function(){return e}});var r=!1;Object.defineProperty(this,"pageWrapXEnabled",{get:function(){return r},set:function(t){r=Boolean(t);}});var n=!1;Object.defineProperty(this,"pageWrapYEnabled",{get:function(){return n},set:function(t){n=Boolean(t);}});var i=0;Object.defineProperty(this,"posX",{get:function(){return i},set:function(t){isNaN(t)||(i=t);}});var a=0;Object.defineProperty(this,"posY",{get:function(){return a},set:function(t){isNaN(t)||(a=t);}}),Object.defineProperty(this,"margin",{get:function(){return l.margin},set:function(t){var e;"number"==typeof t?e=[t,t,t,t]:((e=new Array(4))[0]=t[0],e[1]=t.length>=2?t[1]:e[0],e[2]=t.length>=3?t[2]:e[0],e[3]=t.length>=4?t[3]:e[1]),l.margin=e;}});var o=!1;Object.defineProperty(this,"autoPaging",{get:function(){return o},set:function(t){o=t;}});var s=0;Object.defineProperty(this,"lastBreak",{get:function(){return s},set:function(t){s=t;}});var c=[];Object.defineProperty(this,"pageBreaks",{get:function(){return c},set:function(t){c=t;}}),Object.defineProperty(this,"ctx",{get:function(){return l},set:function(t){t instanceof d&&(l=t);}}),Object.defineProperty(this,"path",{get:function(){return l.path},set:function(t){l.path=t;}});var u=[];Object.defineProperty(this,"ctxStack",{get:function(){return u},set:function(t){u=t;}}),Object.defineProperty(this,"fillStyle",{get:function(){return this.ctx.fillStyle},set:function(t){var e;e=g(t),this.ctx.fillStyle=e.style,this.ctx.isFillTransparent=0===e.a,this.ctx.fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a});}}),Object.defineProperty(this,"strokeStyle",{get:function(){return this.ctx.strokeStyle},set:function(t){var e=g(t);this.ctx.strokeStyle=e.style,this.ctx.isStrokeTransparent=0===e.a,this.ctx.strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b));}}),Object.defineProperty(this,"lineCap",{get:function(){return this.ctx.lineCap},set:function(t){-1!==["butt","round","square"].indexOf(t)&&(this.ctx.lineCap=t,this.pdf.setLineCap(t));}}),Object.defineProperty(this,"lineWidth",{get:function(){return this.ctx.lineWidth},set:function(t){isNaN(t)||(this.ctx.lineWidth=t,this.pdf.setLineWidth(t));}}),Object.defineProperty(this,"lineJoin",{get:function(){return this.ctx.lineJoin},set:function(t){-1!==["bevel","round","miter"].indexOf(t)&&(this.ctx.lineJoin=t,this.pdf.setLineJoin(t));}}),Object.defineProperty(this,"miterLimit",{get:function(){return this.ctx.miterLimit},set:function(t){isNaN(t)||(this.ctx.miterLimit=t,this.pdf.setMiterLimit(t));}}),Object.defineProperty(this,"textBaseline",{get:function(){return this.ctx.textBaseline},set:function(t){this.ctx.textBaseline=t;}}),Object.defineProperty(this,"textAlign",{get:function(){return this.ctx.textAlign},set:function(t){-1!==["right","end","center","left","start"].indexOf(t)&&(this.ctx.textAlign=t);}});var h=null;function f(t,e){if(null===h){var r=function(t){var e=[];return Object.keys(t).forEach((function(r){t[r].forEach((function(t){var n=null;switch(t){case"bold":n={family:r,weight:"bold"};break;case"italic":n={family:r,style:"italic"};break;case"bolditalic":n={family:r,weight:"bold",style:"italic"};break;case"":case"normal":n={family:r};}null!==n&&(n.ref={name:r,style:t},e.push(n));}));})),e}(t.getFontList());h=function(t){for(var e={},r=0;r<t.length;++r){var n=jt(t[r]),i=n.family,a=n.stretch,o=n.style,s=n.weight;e[i]=e[i]||{},e[i][a]=e[i][a]||{},e[i][a][o]=e[i][a][o]||{},e[i][a][o][s]=n;}return e}(r.concat(e));}return h}var p=null;Object.defineProperty(this,"fontFaces",{get:function(){return p},set:function(t){h=null,p=t;}}),Object.defineProperty(this,"font",{get:function(){return this.ctx.font},set:function(t){var e;if(this.ctx.font=t,null!==(e=/^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))){var r=e[1],n=(e[2],e[3]),i=e[4],a=(e[5],e[6]),o=/^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];i="px"===o?Math.floor(parseFloat(i)*this.pdf.internal.scaleFactor):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)*this.pdf.internal.scaleFactor),this.pdf.setFontSize(i);var s=function(t){var e,r,n=[],i=t.trim();if(""===i)return Wt;if(i in Mt)return [Mt[i]];for(;""!==i;){switch(r=null,e=(i=Dt(i)).charAt(0)){case'"':case"'":r=Rt(i.substring(1),e);break;default:r=Tt(i);}if(null===r)return Wt;if(n.push(r[0]),""!==(i=Dt(r[1]))&&","!==i.charAt(0))return Wt;i=i.replace(/^,/,"");}return n}(a);if(this.fontFaces){var c=qt(f(this.pdf,this.fontFaces),s.map((function(t){return {family:t,stretch:"normal",weight:n,style:r}})));this.pdf.setFont(c.ref.name,c.ref.style);}else {var u="";("bold"===n||parseInt(n,10)>=700||"bold"===r)&&(u="bold"),"italic"===r&&(u+="italic"),0===u.length&&(u="normal");for(var h="",l={arial:"Helvetica",Arial:"Helvetica",verdana:"Helvetica",Verdana:"Helvetica",helvetica:"Helvetica",Helvetica:"Helvetica","sans-serif":"Helvetica",fixed:"Courier",monospace:"Courier",terminal:"Courier",cursive:"Times",fantasy:"Times",serif:"Times"},d=0;d<s.length;d++){if(void 0!==this.pdf.internal.getFont(s[d],u,{noFallback:!0,disableWarning:!0})){h=s[d];break}if("bolditalic"===u&&void 0!==this.pdf.internal.getFont(s[d],"bold",{noFallback:!0,disableWarning:!0}))h=s[d],u="bold";else if(void 0!==this.pdf.internal.getFont(s[d],"normal",{noFallback:!0,disableWarning:!0})){h=s[d],u="normal";break}}if(""===h)for(var p=0;p<s.length;p++)if(l[s[p]]){h=l[s[p]];break}h=""===h?"Times":h,this.pdf.setFont(h,u);}}}}),Object.defineProperty(this,"globalCompositeOperation",{get:function(){return this.ctx.globalCompositeOperation},set:function(t){this.ctx.globalCompositeOperation=t;}}),Object.defineProperty(this,"globalAlpha",{get:function(){return this.ctx.globalAlpha},set:function(t){this.ctx.globalAlpha=t;}}),Object.defineProperty(this,"lineDashOffset",{get:function(){return this.ctx.lineDashOffset},set:function(t){this.ctx.lineDashOffset=t,T.call(this);}}),Object.defineProperty(this,"lineDash",{get:function(){return this.ctx.lineDash},set:function(t){this.ctx.lineDash=t,T.call(this);}}),Object.defineProperty(this,"ignoreClearRect",{get:function(){return this.ctx.ignoreClearRect},set:function(t){this.ctx.ignoreClearRect=Boolean(t);}});};p.prototype.setLineDash=function(t){this.lineDash=t;},p.prototype.getLineDash=function(){return this.lineDash.length%2?this.lineDash.concat(this.lineDash):this.lineDash.slice()},p.prototype.fill=function(){A.call(this,"fill",!1);},p.prototype.stroke=function(){A.call(this,"stroke",!1);},p.prototype.beginPath=function(){this.path=[{type:"begin"}];},p.prototype.moveTo=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.moveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.moveTo");var r=this.ctx.transform.applyToPoint(new c(t,e));this.path.push({type:"mt",x:r.x,y:r.y}),this.ctx.lastPoint=new c(t,e);},p.prototype.closePath=function(){var e=new c(0,0),r=0;for(r=this.path.length-1;-1!==r;r--)if("begin"===this.path[r].type&&"object"===_typeof$2(this.path[r+1])&&"number"==typeof this.path[r+1].x){e=new c(this.path[r+1].x,this.path[r+1].y);break}this.path.push({type:"close"}),this.ctx.lastPoint=new c(e.x,e.y);},p.prototype.lineTo=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.lineTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.lineTo");var r=this.ctx.transform.applyToPoint(new c(t,e));this.path.push({type:"lt",x:r.x,y:r.y}),this.ctx.lastPoint=new c(r.x,r.y);},p.prototype.clip=function(){this.ctx.clip_path=JSON.parse(JSON.stringify(this.path)),A.call(this,null,!0);},p.prototype.quadraticCurveTo=function(t,e,r,n){if(isNaN(r)||isNaN(n)||isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");var i=this.ctx.transform.applyToPoint(new c(r,n)),o=this.ctx.transform.applyToPoint(new c(t,e));this.path.push({type:"qct",x1:o.x,y1:o.y,x:i.x,y:i.y}),this.ctx.lastPoint=new c(i.x,i.y);},p.prototype.bezierCurveTo=function(t,e,r,n,i,o){if(isNaN(i)||isNaN(o)||isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.bezierCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");var s=this.ctx.transform.applyToPoint(new c(i,o)),u=this.ctx.transform.applyToPoint(new c(t,e)),h=this.ctx.transform.applyToPoint(new c(r,n));this.path.push({type:"bct",x1:u.x,y1:u.y,x2:h.x,y2:h.y,x:s.x,y:s.y}),this.ctx.lastPoint=new c(s.x,s.y);},p.prototype.arc=function(t,e,r,n,i,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i))throw a.error("jsPDF.context2d.arc: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.arc");if(o=Boolean(o),!this.ctx.transform.isIdentity){var s=this.ctx.transform.applyToPoint(new c(t,e));t=s.x,e=s.y;var u=this.ctx.transform.applyToPoint(new c(0,r)),h=this.ctx.transform.applyToPoint(new c(0,0));r=Math.sqrt(Math.pow(u.x-h.x,2)+Math.pow(u.y-h.y,2));}Math.abs(i-n)>=2*Math.PI&&(n=0,i=2*Math.PI),this.path.push({type:"arc",x:t,y:e,radius:r,startAngle:n,endAngle:i,counterclockwise:o});},p.prototype.arcTo=function(t,e,r,n,i){throw new Error("arcTo not implemented.")},p.prototype.rect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.rect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rect");this.moveTo(t,e),this.lineTo(t+r,e),this.lineTo(t+r,e+n),this.lineTo(t,e+n),this.lineTo(t,e),this.lineTo(t+r,e),this.lineTo(t,e);},p.prototype.fillRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.fillRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillRect");if(!m.call(this)){var i={};"butt"!==this.lineCap&&(i.lineCap=this.lineCap,this.lineCap="butt"),"miter"!==this.lineJoin&&(i.lineJoin=this.lineJoin,this.lineJoin="miter"),this.beginPath(),this.rect(t,e,r,n),this.fill(),i.hasOwnProperty("lineCap")&&(this.lineCap=i.lineCap),i.hasOwnProperty("lineJoin")&&(this.lineJoin=i.lineJoin);}},p.prototype.strokeRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.strokeRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");v.call(this)||(this.beginPath(),this.rect(t,e,r,n),this.stroke());},p.prototype.clearRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.clearRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.clearRect");this.ignoreClearRect||(this.fillStyle="#ffffff",this.fillRect(t,e,r,n));},p.prototype.save=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,r=0;r<this.pdf.internal.getNumberOfPages();r++)this.pdf.setPage(r+1),this.pdf.internal.out("q");if(this.pdf.setPage(e),t){this.ctx.fontSize=this.pdf.internal.getFontSize();var n=new d(this.ctx);this.ctxStack.push(this.ctx),this.ctx=n;}},p.prototype.restore=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,r=0;r<this.pdf.internal.getNumberOfPages();r++)this.pdf.setPage(r+1),this.pdf.internal.out("Q");this.pdf.setPage(e),t&&0!==this.ctxStack.length&&(this.ctx=this.ctxStack.pop(),this.fillStyle=this.ctx.fillStyle,this.strokeStyle=this.ctx.strokeStyle,this.font=this.ctx.font,this.lineCap=this.ctx.lineCap,this.lineWidth=this.ctx.lineWidth,this.lineJoin=this.ctx.lineJoin,this.lineDash=this.ctx.lineDash,this.lineDashOffset=this.ctx.lineDashOffset);},p.prototype.toDataURL=function(){throw new Error("toDataUrl not implemented.")};var g=function(t){var e,r,n,i;if(!0===t.isCanvasGradient&&(t=t.getColor()),!t)return {r:0,g:0,b:0,a:0,style:t};if(/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t))e=0,r=0,n=0,i=0;else {var a=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);if(null!==a)e=parseInt(a[1]),r=parseInt(a[2]),n=parseInt(a[3]),i=1;else if(null!==(a=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t)))e=parseInt(a[1]),r=parseInt(a[2]),n=parseInt(a[3]),i=parseFloat(a[4]);else {if(i=1,"string"==typeof t&&"#"!==t.charAt(0)){var o=new f(t);t=o.ok?o.toHex():"#000000";}4===t.length?(e=t.substring(1,2),e+=e,r=t.substring(2,3),r+=r,n=t.substring(3,4),n+=n):(e=t.substring(1,3),r=t.substring(3,5),n=t.substring(5,7)),e=parseInt(e,16),r=parseInt(r,16),n=parseInt(n,16);}}return {r:e,g:r,b:n,a:i,style:t}},m=function(){return this.ctx.isFillTransparent||0==this.globalAlpha},v=function(){return Boolean(this.ctx.isStrokeTransparent||0==this.globalAlpha)};p.prototype.fillText=function(t,e,r,n){if(isNaN(e)||isNaN(r)||"string"!=typeof t)throw a.error("jsPDF.context2d.fillText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillText");if(n=isNaN(n)?void 0:n,!m.call(this)){var i=q(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;C.call(this,{text:t,x:e,y:r,scale:o,angle:i,align:this.textAlign,maxWidth:n});}},p.prototype.strokeText=function(t,e,r,n){if(isNaN(e)||isNaN(r)||"string"!=typeof t)throw a.error("jsPDF.context2d.strokeText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeText");if(!v.call(this)){n=isNaN(n)?void 0:n;var i=q(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;C.call(this,{text:t,x:e,y:r,scale:o,renderingMode:"stroke",angle:i,align:this.textAlign,maxWidth:n});}},p.prototype.measureText=function(t){if("string"!=typeof t)throw a.error("jsPDF.context2d.measureText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.measureText");var e=this.pdf,r=this.pdf.internal.scaleFactor,n=e.internal.getFontSize(),i=e.getStringUnitWidth(t)*n/e.internal.scaleFactor,o=function(t){var e=(t=t||{}).width||0;return Object.defineProperty(this,"width",{get:function(){return e}}),this};return new o({width:i*=Math.round(96*r/72*1e4)/1e4})},p.prototype.scale=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.scale: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.scale");var r=new h(t,0,0,e,0,0);this.ctx.transform=this.ctx.transform.multiply(r);},p.prototype.rotate=function(t){if(isNaN(t))throw a.error("jsPDF.context2d.rotate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rotate");var e=new h(Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0);this.ctx.transform=this.ctx.transform.multiply(e);},p.prototype.translate=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.translate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.translate");var r=new h(1,0,0,1,t,e);this.ctx.transform=this.ctx.transform.multiply(r);},p.prototype.transform=function(t,e,r,n,i,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(o))throw a.error("jsPDF.context2d.transform: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.transform");var s=new h(t,e,r,n,i,o);this.ctx.transform=this.ctx.transform.multiply(s);},p.prototype.setTransform=function(t,e,r,n,i,a){t=isNaN(t)?1:t,e=isNaN(e)?0:e,r=isNaN(r)?0:r,n=isNaN(n)?1:n,i=isNaN(i)?0:i,a=isNaN(a)?0:a,this.ctx.transform=new h(t,e,r,n,i,a);};var b=function(){return this.margin[0]>0||this.margin[1]>0||this.margin[2]>0||this.margin[3]>0};p.prototype.drawImage=function(t,e,r,n,i,a,o,s,c){var l=this.pdf.getImageProperties(t),f=1,d=1,p=1,g=1;void 0!==n&&void 0!==s&&(p=s/n,g=c/i,f=l.width/n*s/n,d=l.height/i*c/i),void 0===a&&(a=e,o=r,e=0,r=0),void 0!==n&&void 0===s&&(s=n,c=i),void 0===n&&void 0===s&&(s=l.width,c=l.height);for(var m,v=this.ctx.transform.decompose(),w=q(v.rotate.shx),A=new h,S=(A=(A=(A=A.multiply(v.translate)).multiply(v.skew)).multiply(v.scale)).applyToRectangle(new u(a-e*p,o-r*g,n*f,i*d)),_=y.call(this,S),P=[],k=0;k<_.length;k+=1)-1===P.indexOf(_[k])&&P.push(_[k]);if(L(P),this.autoPaging)for(var I=P[0],F=P[P.length-1],C=I;C<F+1;C++){this.pdf.setPage(C);var j=this.pdf.internal.pageSize.width-this.margin[3]-this.margin[1],O=1===C?this.posY+this.margin[0]:this.margin[0],B=this.pdf.internal.pageSize.height-this.posY-this.margin[0]-this.margin[2],M=this.pdf.internal.pageSize.height-this.margin[0]-this.margin[2],E=1===C?0:B+(C-2)*M;if(0!==this.ctx.clip_path.length){var D=this.path;m=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=N(m,this.posX+this.margin[3],-E+O+this.ctx.prevPageLastElemOffset),x.call(this,"fill",!0),this.path=D;}var R=JSON.parse(JSON.stringify(S));R=N([R],this.posX+this.margin[3],-E+O+this.ctx.prevPageLastElemOffset)[0];var T=(C>I||C<F)&&b.call(this);T&&(this.pdf.saveGraphicsState(),this.pdf.rect(this.margin[3],this.margin[0],j,M,null).clip().discardPath()),this.pdf.addImage(t,"JPEG",R.x,R.y,R.w,R.h,null,null,w),T&&this.pdf.restoreGraphicsState();}else this.pdf.addImage(t,"JPEG",S.x,S.y,S.w,S.h,null,null,w);};var y=function(t,e,r){var n=[];e=e||this.pdf.internal.pageSize.width,r=r||this.pdf.internal.pageSize.height-this.margin[0]-this.margin[2];var i=this.posY+this.ctx.prevPageLastElemOffset;switch(t.type){default:case"mt":case"lt":n.push(Math.floor((t.y+i)/r)+1);break;case"arc":n.push(Math.floor((t.y+i-t.radius)/r)+1),n.push(Math.floor((t.y+i+t.radius)/r)+1);break;case"qct":var a=D(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x,t.y);n.push(Math.floor((a.y+i)/r)+1),n.push(Math.floor((a.y+a.h+i)/r)+1);break;case"bct":var o=R(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x2,t.y2,t.x,t.y);n.push(Math.floor((o.y+i)/r)+1),n.push(Math.floor((o.y+o.h+i)/r)+1);break;case"rect":n.push(Math.floor((t.y+i)/r)+1),n.push(Math.floor((t.y+t.h+i)/r)+1);}for(var s=0;s<n.length;s+=1)for(;this.pdf.internal.getNumberOfPages()<n[s];)w.call(this);return n},w=function(){var t=this.fillStyle,e=this.strokeStyle,r=this.font,n=this.lineCap,i=this.lineWidth,a=this.lineJoin;this.pdf.addPage(),this.fillStyle=t,this.strokeStyle=e,this.font=r,this.lineCap=n,this.lineWidth=i,this.lineJoin=a;},N=function(t,e,r){for(var n=0;n<t.length;n++)switch(t[n].type){case"bct":t[n].x2+=e,t[n].y2+=r;case"qct":t[n].x1+=e,t[n].y1+=r;case"mt":case"lt":case"arc":default:t[n].x+=e,t[n].y+=r;}return t},L=function(t){return t.sort((function(t,e){return t-e}))},A=function(t,e){for(var r,n,i=this.fillStyle,a=this.strokeStyle,o=this.lineCap,s=this.lineWidth,c=Math.abs(s*this.ctx.transform.scaleX),u=this.lineJoin,h=JSON.parse(JSON.stringify(this.path)),l=JSON.parse(JSON.stringify(this.path)),f=[],d=0;d<l.length;d++)if(void 0!==l[d].x)for(var p=y.call(this,l[d]),g=0;g<p.length;g+=1)-1===f.indexOf(p[g])&&f.push(p[g]);for(var m=0;m<f.length;m++)for(;this.pdf.internal.getNumberOfPages()<f[m];)w.call(this);if(L(f),this.autoPaging)for(var v=f[0],A=f[f.length-1],S=v;S<A+1;S++){this.pdf.setPage(S),this.fillStyle=i,this.strokeStyle=a,this.lineCap=o,this.lineWidth=c,this.lineJoin=u;var _=this.pdf.internal.pageSize.width-this.margin[3]-this.margin[1],P=1===S?this.posY+this.margin[0]:this.margin[0],k=this.pdf.internal.pageSize.height-this.posY-this.margin[0]-this.margin[2],I=this.pdf.internal.pageSize.height-this.margin[0]-this.margin[2],F=1===S?0:k+(S-2)*I;if(0!==this.ctx.clip_path.length){var C=this.path;r=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=N(r,this.posX+this.margin[3],-F+P+this.ctx.prevPageLastElemOffset),x.call(this,t,!0),this.path=C;}if(n=JSON.parse(JSON.stringify(h)),this.path=N(n,this.posX+this.margin[3],-F+P+this.ctx.prevPageLastElemOffset),!1===e||0===S){var j=(S>v||S<A)&&b.call(this);j&&(this.pdf.saveGraphicsState(),this.pdf.rect(this.margin[3],this.margin[0],_,I,null).clip().discardPath()),x.call(this,t,e),j&&this.pdf.restoreGraphicsState();}this.lineWidth=s;}else this.lineWidth=c,x.call(this,t,e),this.lineWidth=s;this.path=h;},x=function(t,e){if(("stroke"!==t||e||!v.call(this))&&("stroke"===t||e||!m.call(this))){for(var r,n,i=[],a=this.path,o=0;o<a.length;o++){var s=a[o];switch(s.type){case"begin":i.push({begin:!0});break;case"close":i.push({close:!0});break;case"mt":i.push({start:s,deltas:[],abs:[]});break;case"lt":var c=i.length;if(a[o-1]&&!isNaN(a[o-1].x)&&(r=[s.x-a[o-1].x,s.y-a[o-1].y],c>0))for(;c>=0;c--)if(!0!==i[c-1].close&&!0!==i[c-1].begin){i[c-1].deltas.push(r),i[c-1].abs.push(s);break}break;case"bct":r=[s.x1-a[o-1].x,s.y1-a[o-1].y,s.x2-a[o-1].x,s.y2-a[o-1].y,s.x-a[o-1].x,s.y-a[o-1].y],i[i.length-1].deltas.push(r);break;case"qct":var u=a[o-1].x+2/3*(s.x1-a[o-1].x),h=a[o-1].y+2/3*(s.y1-a[o-1].y),l=s.x+2/3*(s.x1-s.x),f=s.y+2/3*(s.y1-s.y),d=s.x,p=s.y;r=[u-a[o-1].x,h-a[o-1].y,l-a[o-1].x,f-a[o-1].y,d-a[o-1].x,p-a[o-1].y],i[i.length-1].deltas.push(r);break;case"arc":i.push({deltas:[],abs:[],arc:!0}),Array.isArray(i[i.length-1].abs)&&i[i.length-1].abs.push(s);}}n=e?null:"stroke"===t?"stroke":"fill";for(var g=!1,b=0;b<i.length;b++)if(i[b].arc)for(var y=i[b].abs,w=0;w<y.length;w++){var N=y[w];"arc"===N.type?P.call(this,N.x,N.y,N.radius,N.startAngle,N.endAngle,N.counterclockwise,void 0,e,!g):j.call(this,N.x,N.y),g=!0;}else if(!0===i[b].close)this.pdf.internal.out("h"),g=!1;else if(!0!==i[b].begin){var L=i[b].start.x,A=i[b].start.y;O.call(this,i[b].deltas,L,A),g=!0;}n&&k.call(this,n),e&&I.call(this);}},S=function(t){var e=this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor,r=e*(this.pdf.internal.getLineHeightFactor()-1);switch(this.ctx.textBaseline){case"bottom":return t-r;case"top":return t+e-r;case"hanging":return t+e-2*r;case"middle":return t+e/2-r;case"ideographic":return t;case"alphabetic":default:return t}},_=function(t){return t+this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor*(this.pdf.internal.getLineHeightFactor()-1)};p.prototype.createLinearGradient=function(){var t=function(){};return t.colorStops=[],t.addColorStop=function(t,e){this.colorStops.push([t,e]);},t.getColor=function(){return 0===this.colorStops.length?"#000000":this.colorStops[0][1]},t.isCanvasGradient=!0,t},p.prototype.createPattern=function(){return this.createLinearGradient()},p.prototype.createRadialGradient=function(){return this.createLinearGradient()};var P=function(t,e,r,n,i,a,o,s,c){for(var u=M.call(this,r,n,i,a),h=0;h<u.length;h++){var l=u[h];0===h&&(c?F.call(this,l.x1+t,l.y1+e):j.call(this,l.x1+t,l.y1+e)),B.call(this,t,e,l.x2,l.y2,l.x3,l.y3,l.x4,l.y4);}s?I.call(this):k.call(this,o);},k=function(t){switch(t){case"stroke":this.pdf.internal.out("S");break;case"fill":this.pdf.internal.out("f");}},I=function(){this.pdf.clip(),this.pdf.discardPath();},F=function(t,e){this.pdf.internal.out(n(t)+" "+i(e)+" m");},C=function(t){var e;switch(t.align){case"right":case"end":e="right";break;case"center":e="center";break;case"left":case"start":default:e="left";}var r=this.pdf.getTextDimensions(t.text),n=S.call(this,t.y),i=_.call(this,n)-r.h,a=this.ctx.transform.applyToPoint(new c(t.x,n)),o=this.ctx.transform.decompose(),s=new h;s=(s=(s=s.multiply(o.translate)).multiply(o.skew)).multiply(o.scale);for(var l,f,d,p=this.ctx.transform.applyToRectangle(new u(t.x,n,r.w,r.h)),g=s.applyToRectangle(new u(t.x,i,r.w,r.h)),m=y.call(this,g),v=[],w=0;w<m.length;w+=1)-1===v.indexOf(m[w])&&v.push(m[w]);if(L(v),this.autoPaging)for(var A=v[0],P=v[v.length-1],k=A;k<P+1;k++){this.pdf.setPage(k);var I=1===k?this.posY+this.margin[0]:this.margin[0],F=this.pdf.internal.pageSize.height-this.posY-this.margin[0]-this.margin[2],C=this.pdf.internal.pageSize.height-this.margin[2],j=C-this.margin[0],O=this.pdf.internal.pageSize.width-this.margin[1],B=O-this.margin[3],M=1===k?0:F+(k-2)*j;if(0!==this.ctx.clip_path.length){var E=this.path;l=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=N(l,this.posX+this.margin[3],-1*M+I),x.call(this,"fill",!0),this.path=E;}var q=N([JSON.parse(JSON.stringify(g))],this.posX+this.margin[3],-M+I+this.ctx.prevPageLastElemOffset)[0];t.scale>=.01&&(f=this.pdf.internal.getFontSize(),this.pdf.setFontSize(f*t.scale),d=this.lineWidth,this.lineWidth=d*t.scale);var D="text"!==this.autoPaging;if(D||q.y+q.h<=C){if(D||q.y>=I&&q.x<=O){var R=D?t.text:this.pdf.splitTextToSize(t.text,t.maxWidth||O-q.x)[0],T=N([JSON.parse(JSON.stringify(p))],this.posX+this.margin[3],-M+I+this.ctx.prevPageLastElemOffset)[0],U=D&&(k>A||k<P)&&b.call(this);U&&(this.pdf.saveGraphicsState(),this.pdf.rect(this.margin[3],this.margin[0],B,j,null).clip().discardPath()),this.pdf.text(R,T.x,T.y,{angle:t.angle,align:e,renderingMode:t.renderingMode}),U&&this.pdf.restoreGraphicsState();}}else q.y<C&&(this.ctx.prevPageLastElemOffset+=C-q.y);t.scale>=.01&&(this.pdf.setFontSize(f),this.lineWidth=d);}else t.scale>=.01&&(f=this.pdf.internal.getFontSize(),this.pdf.setFontSize(f*t.scale),d=this.lineWidth,this.lineWidth=d*t.scale),this.pdf.text(t.text,a.x+this.posX,a.y+this.posY,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),t.scale>=.01&&(this.pdf.setFontSize(f),this.lineWidth=d);},j=function(t,e,r,a){r=r||0,a=a||0,this.pdf.internal.out(n(t+r)+" "+i(e+a)+" l");},O=function(t,e,r){return this.pdf.lines(t,e,r,null,null)},B=function(t,e,n,i,a,c,u,h){this.pdf.internal.out([r(o(n+t)),r(s(i+e)),r(o(a+t)),r(s(c+e)),r(o(u+t)),r(s(h+e)),"c"].join(" "));},M=function(t,e,r,n){for(var i=2*Math.PI,a=Math.PI/2;e>r;)e-=i;var o=Math.abs(r-e);o<i&&n&&(o=i-o);for(var s=[],c=n?-1:1,u=e;o>1e-5;){var h=u+c*Math.min(o,a);s.push(E.call(this,t,u,h)),o-=Math.abs(h-u),u=h;}return s},E=function(t,e,r){var n=(r-e)/2,i=t*Math.cos(n),a=t*Math.sin(n),o=i,s=-a,c=o*o+s*s,u=c+o*i+s*a,h=4/3*(Math.sqrt(2*c*u)-u)/(o*a-s*i),l=o-h*s,f=s+h*o,d=l,p=-f,g=n+e,m=Math.cos(g),v=Math.sin(g);return {x1:t*Math.cos(e),y1:t*Math.sin(e),x2:l*m-f*v,y2:l*v+f*m,x3:d*m-p*v,y3:d*v+p*m,x4:t*Math.cos(r),y4:t*Math.sin(r)}},q=function(t){return 180*t/Math.PI},D=function(t,e,r,n,i,a){var o=t+.5*(r-t),s=e+.5*(n-e),c=i+.5*(r-i),h=a+.5*(n-a),l=Math.min(t,i,o,c),f=Math.max(t,i,o,c),d=Math.min(e,a,s,h),p=Math.max(e,a,s,h);return new u(l,d,f-l,p-d)},R=function(t,e,r,n,i,a,o,s){var c,h,l,f,d,p,g,m,v,b,y,w,N,L,A=r-t,x=n-e,S=i-r,_=a-n,P=o-i,k=s-a;for(h=0;h<41;h++)v=(g=(l=t+(c=h/40)*A)+c*((d=r+c*S)-l))+c*(d+c*(i+c*P-d)-g),b=(m=(f=e+c*x)+c*((p=n+c*_)-f))+c*(p+c*(a+c*k-p)-m),0==h?(y=v,w=b,N=v,L=b):(y=Math.min(y,v),w=Math.min(w,b),N=Math.max(N,v),L=Math.max(L,b));return new u(Math.round(y),Math.round(w),Math.round(N-y),Math.round(L-w))},T=function(){if(this.prevLineDash||this.ctx.lineDash.length||this.ctx.lineDashOffset){var t,e,r=(t=this.ctx.lineDash,e=this.ctx.lineDashOffset,JSON.stringify({lineDash:t,lineDashOffset:e}));this.prevLineDash!==r&&(this.pdf.setLineDash(this.ctx.lineDash,this.ctx.lineDashOffset),this.prevLineDash=r);}};}(E.API),
/**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var r=function(t){var e,r,n,i,a,o,s,c,u,h;for(/[^\x00-\xFF]/.test(t),r=[],n=0,i=(t+=e="\0\0\0\0".slice(t.length%4||4)).length;i>n;n+=4)0!==(a=(t.charCodeAt(n)<<24)+(t.charCodeAt(n+1)<<16)+(t.charCodeAt(n+2)<<8)+t.charCodeAt(n+3))?(o=(a=((a=((a=((a=(a-(h=a%85))/85)-(u=a%85))/85)-(c=a%85))/85)-(s=a%85))/85)%85,r.push(o+33,s+33,c+33,u+33,h+33)):r.push(122);return function(t,e){for(var r=e;r>0;r--)t.pop();}(r,e.length),String.fromCharCode.apply(String,r)+"~>"},n=function(t){var e,r,n,i,a,o=String,s="length",c=255,u="charCodeAt",h="slice",l="replace";for(t[h](-2),t=t[h](0,-2)[l](/\s/g,"")[l]("z","!!!!!"),n=[],i=0,a=(t+=e="uuuuu"[h](t[s]%5||5))[s];a>i;i+=5)r=52200625*(t[u](i)-33)+614125*(t[u](i+1)-33)+7225*(t[u](i+2)-33)+85*(t[u](i+3)-33)+(t[u](i+4)-33),n.push(c&r>>24,c&r>>16,c&r>>8,c&r);return function(t,e){for(var r=e;r>0;r--)t.pop();}(n,e[s]),o.fromCharCode.apply(o,n)},i=function(t){var e=new RegExp(/^([0-9A-Fa-f]{2})+$/);if(-1!==(t=t.replace(/\s/g,"")).indexOf(">")&&(t=t.substr(0,t.indexOf(">"))),t.length%2&&(t+="0"),!1===e.test(t))return "";for(var r="",n=0;n<t.length;n+=2)r+=String.fromCharCode("0x"+(t[n]+t[n+1]));return r},a=function(t){for(var r=new Uint8Array(t.length),n=t.length;n--;)r[n]=t.charCodeAt(n);return t=(r=zlibSync(r)).reduce((function(t,e){return t+String.fromCharCode(e)}),"")};t.processDataByFilters=function(t,e){var o=0,s=t||"",c=[];for("string"==typeof(e=e||[])&&(e=[e]),o=0;o<e.length;o+=1)switch(e[o]){case"ASCII85Decode":case"/ASCII85Decode":s=n(s),c.push("/ASCII85Encode");break;case"ASCII85Encode":case"/ASCII85Encode":s=r(s),c.push("/ASCII85Decode");break;case"ASCIIHexDecode":case"/ASCIIHexDecode":s=i(s),c.push("/ASCIIHexEncode");break;case"ASCIIHexEncode":case"/ASCIIHexEncode":s=s.split("").map((function(t){return ("0"+t.charCodeAt().toString(16)).slice(-2)})).join("")+">",c.push("/ASCIIHexDecode");break;case"FlateEncode":case"/FlateEncode":s=a(s),c.push("/FlateDecode");break;default:throw new Error('The filter: "'+e[o]+'" is not implemented')}return {data:s,reverseChain:c.reverse().join(" ")}};}(E.API),
/**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.loadFile=function(t,e,r){return function(t,e,r){e=!1!==e,r="function"==typeof r?r:function(){};var n=void 0;try{n=function(t,e,r){var n=new XMLHttpRequest,i=0,a=function(t){var e=t.length,r=[],n=String.fromCharCode;for(i=0;i<e;i+=1)r.push(n(255&t.charCodeAt(i)));return r.join("")};if(n.open("GET",t,!e),n.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(n.onload=function(){200===n.status?r(a(this.responseText)):r(void 0);}),n.send(null),e&&200===n.status)return a(n.responseText)}(t,e,r);}catch(t){}return n}(t,e,r)},t.loadImageFile=t.loadFile;}(E.API),function(e){function r(){return (n.html2canvas?Promise.resolve(n.html2canvas):import('./html2canvas-fa6b4d83.js').then(function (n) { return n.h; })).catch((function(t){return Promise.reject(new Error("Could not load html2canvas: "+t))})).then((function(t){return t.default?t.default:t}))}function i(){return (n.DOMPurify?Promise.resolve(n.DOMPurify):import('./purify-0bcda0c6.js').then(function (n) { return n.p; })).catch((function(t){return Promise.reject(new Error("Could not load dompurify: "+t))})).then((function(t){return t.default?t.default:t}))}var a=function(e){var r=_typeof$2(e);return "undefined"===r?"undefined":"string"===r||e instanceof String?"string":"number"===r||e instanceof Number?"number":"function"===r||e instanceof Function?"function":e&&e.constructor===Array?"array":e&&1===e.nodeType?"element":"object"===r?"object":"unknown"},o=function(t,e){var r=document.createElement(t);for(var n in e.className&&(r.className=e.className),e.innerHTML&&e.dompurify&&(r.innerHTML=e.dompurify.sanitize(e.innerHTML)),e.style)r.style[n]=e.style[n];return r},s=function t(e){var r=Object.assign(t.convert(Promise.resolve()),JSON.parse(JSON.stringify(t.template))),n=t.convert(Promise.resolve(),r);return n=(n=n.setProgress(1,t,1,[t])).set(e)};(s.prototype=Object.create(Promise.prototype)).constructor=s,s.convert=function(t,e){return t.__proto__=e||s.prototype,t},s.template={prop:{src:null,container:null,overlay:null,canvas:null,img:null,pdf:null,pageSize:null,callback:function(){}},progress:{val:0,state:null,n:0,stack:[]},opt:{filename:"file.pdf",margin:[0,0,0,0],enableLinks:!0,x:0,y:0,html2canvas:{},jsPDF:{},backgroundColor:"transparent"}},s.prototype.from=function(t,e){return this.then((function(){switch(e=e||function(t){switch(a(t)){case"string":return "string";case"element":return "canvas"===t.nodeName.toLowerCase()?"canvas":"element";default:return "unknown"}}(t)){case"string":return this.then(i).then((function(e){return this.set({src:o("div",{innerHTML:t,dompurify:e})})}));case"element":return this.set({src:t});case"canvas":return this.set({canvas:t});case"img":return this.set({img:t});default:return this.error("Unknown source type.")}}))},s.prototype.to=function(t){switch(t){case"container":return this.toContainer();case"canvas":return this.toCanvas();case"img":return this.toImg();case"pdf":return this.toPdf();default:return this.error("Invalid target.")}},s.prototype.toContainer=function(){return this.thenList([function(){return this.prop.src||this.error("Cannot duplicate - no source HTML.")},function(){return this.prop.pageSize||this.setPageSize()}]).then((function(){var t={position:"relative",display:"inline-block",width:("number"!=typeof this.opt.width||isNaN(this.opt.width)||"number"!=typeof this.opt.windowWidth||isNaN(this.opt.windowWidth)?Math.max(this.prop.src.clientWidth,this.prop.src.scrollWidth,this.prop.src.offsetWidth):this.opt.windowWidth)+"px",left:0,right:0,top:0,margin:"auto",backgroundColor:this.opt.backgroundColor},e=function t(e,r){for(var n=3===e.nodeType?document.createTextNode(e.nodeValue):e.cloneNode(!1),i=e.firstChild;i;i=i.nextSibling)!0!==r&&1===i.nodeType&&"SCRIPT"===i.nodeName||n.appendChild(t(i,r));return 1===e.nodeType&&("CANVAS"===e.nodeName?(n.width=e.width,n.height=e.height,n.getContext("2d").drawImage(e,0,0)):"TEXTAREA"!==e.nodeName&&"SELECT"!==e.nodeName||(n.value=e.value),n.addEventListener("load",(function(){n.scrollTop=e.scrollTop,n.scrollLeft=e.scrollLeft;}),!0)),n}(this.prop.src,this.opt.html2canvas.javascriptEnabled);"BODY"===e.tagName&&(t.height=Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight)+"px"),this.prop.overlay=o("div",{className:"html2pdf__overlay",style:{position:"fixed",overflow:"hidden",zIndex:1e3,left:"-100000px",right:0,bottom:0,top:0}}),this.prop.container=o("div",{className:"html2pdf__container",style:t}),this.prop.container.appendChild(e),this.prop.container.firstChild.appendChild(o("div",{style:{clear:"both",border:"0 none transparent",margin:0,padding:0,height:0}})),this.prop.container.style.float="none",this.prop.overlay.appendChild(this.prop.container),document.body.appendChild(this.prop.overlay),this.prop.container.firstChild.style.position="relative",this.prop.container.height=Math.max(this.prop.container.firstChild.clientHeight,this.prop.container.firstChild.scrollHeight,this.prop.container.firstChild.offsetHeight)+"px";}))},s.prototype.toCanvas=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(r).then((function(t){var e=Object.assign({},this.opt.html2canvas);return delete e.onrendered,t(this.prop.container,e)})).then((function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay);}))},s.prototype.toContext2d=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(r).then((function(t){var e=this.opt.jsPDF,r=this.opt.fontFaces,n="number"!=typeof this.opt.width||isNaN(this.opt.width)||"number"!=typeof this.opt.windowWidth||isNaN(this.opt.windowWidth)?1:this.opt.width/this.opt.windowWidth,i=Object.assign({async:!0,allowTaint:!0,scale:n,scrollX:this.opt.scrollX||0,scrollY:this.opt.scrollY||0,backgroundColor:"#ffffff",imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1},this.opt.html2canvas);if(delete i.onrendered,e.context2d.autoPaging=void 0===this.opt.autoPaging||this.opt.autoPaging,e.context2d.posX=this.opt.x,e.context2d.posY=this.opt.y,e.context2d.margin=this.opt.margin,e.context2d.fontFaces=r,r)for(var a=0;a<r.length;++a){var o=r[a],s=o.src.find((function(t){return "truetype"===t.format}));s&&e.addFont(s.url,o.ref.name,o.ref.style);}return i.windowHeight=i.windowHeight||0,i.windowHeight=0==i.windowHeight?Math.max(this.prop.container.clientHeight,this.prop.container.scrollHeight,this.prop.container.offsetHeight):i.windowHeight,e.context2d.save(!0),t(this.prop.container,i)})).then((function(t){this.opt.jsPDF.context2d.restore(!0),(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay);}))},s.prototype.toImg=function(){return this.thenList([function(){return this.prop.canvas||this.toCanvas()}]).then((function(){var t=this.prop.canvas.toDataURL("image/"+this.opt.image.type,this.opt.image.quality);this.prop.img=document.createElement("img"),this.prop.img.src=t;}))},s.prototype.toPdf=function(){return this.thenList([function(){return this.toContext2d()}]).then((function(){this.prop.pdf=this.prop.pdf||this.opt.jsPDF;}))},s.prototype.output=function(t,e,r){return "img"===(r=r||"pdf").toLowerCase()||"image"===r.toLowerCase()?this.outputImg(t,e):this.outputPdf(t,e)},s.prototype.outputPdf=function(t,e){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then((function(){return this.prop.pdf.output(t,e)}))},s.prototype.outputImg=function(t){return this.thenList([function(){return this.prop.img||this.toImg()}]).then((function(){switch(t){case void 0:case"img":return this.prop.img;case"datauristring":case"dataurlstring":return this.prop.img.src;case"datauri":case"dataurl":return document.location.href=this.prop.img.src;default:throw 'Image output type "'+t+'" is not supported.'}}))},s.prototype.save=function(t){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).set(t?{filename:t}:null).then((function(){this.prop.pdf.save(this.opt.filename);}))},s.prototype.doCallback=function(){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then((function(){this.prop.callback(this.prop.pdf);}))},s.prototype.set=function(t){if("object"!==a(t))return this;var e=Object.keys(t||{}).map((function(e){if(e in s.template.prop)return function(){this.prop[e]=t[e];};switch(e){case"margin":return this.setMargin.bind(this,t.margin);case"jsPDF":return function(){return this.opt.jsPDF=t.jsPDF,this.setPageSize()};case"pageSize":return this.setPageSize.bind(this,t.pageSize);default:return function(){this.opt[e]=t[e];}}}),this);return this.then((function(){return this.thenList(e)}))},s.prototype.get=function(t,e){return this.then((function(){var r=t in s.template.prop?this.prop[t]:this.opt[t];return e?e(r):r}))},s.prototype.setMargin=function(t){return this.then((function(){switch(a(t)){case"number":t=[t,t,t,t];case"array":if(2===t.length&&(t=[t[0],t[1],t[0],t[1]]),4===t.length)break;default:return this.error("Invalid margin array.")}this.opt.margin=t;})).then(this.setPageSize)},s.prototype.setPageSize=function(t){function e(t,e){return Math.floor(t*e/72*96)}return this.then((function(){(t=t||E.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner")||(t.inner={width:t.width-this.opt.margin[1]-this.opt.margin[3],height:t.height-this.opt.margin[0]-this.opt.margin[2]},t.inner.px={width:e(t.inner.width,t.k),height:e(t.inner.height,t.k)},t.inner.ratio=t.inner.height/t.inner.width),this.prop.pageSize=t;}))},s.prototype.setProgress=function(t,e,r,n){return null!=t&&(this.progress.val=t),null!=e&&(this.progress.state=e),null!=r&&(this.progress.n=r),null!=n&&(this.progress.stack=n),this.progress.ratio=this.progress.val/this.progress.state,this},s.prototype.updateProgress=function(t,e,r,n){return this.setProgress(t?this.progress.val+t:null,e||null,r?this.progress.n+r:null,n?this.progress.stack.concat(n):null)},s.prototype.then=function(t,e){var r=this;return this.thenCore(t,e,(function(t,e){return r.updateProgress(null,null,1,[t]),Promise.prototype.then.call(this,(function(e){return r.updateProgress(null,t),e})).then(t,e).then((function(t){return r.updateProgress(1),t}))}))},s.prototype.thenCore=function(t,e,r){r=r||Promise.prototype.then;t&&(t=t.bind(this)),e&&(e=e.bind(this));var n=-1!==Promise.toString().indexOf("[native code]")&&"Promise"===Promise.name?this:s.convert(Object.assign({},this),Promise.prototype),i=r.call(n,t,e);return s.convert(i,this.__proto__)},s.prototype.thenExternal=function(t,e){return Promise.prototype.then.call(this,t,e)},s.prototype.thenList=function(t){var e=this;return t.forEach((function(t){e=e.thenCore(t);})),e},s.prototype.catch=function(t){t&&(t=t.bind(this));var e=Promise.prototype.catch.call(this,t);return s.convert(e,this)},s.prototype.catchExternal=function(t){return Promise.prototype.catch.call(this,t)},s.prototype.error=function(t){return this.then((function(){throw new Error(t)}))},s.prototype.using=s.prototype.set,s.prototype.saveAs=s.prototype.save,s.prototype.export=s.prototype.output,s.prototype.run=s.prototype.then,E.getPageSize=function(e,r,n){if("object"===_typeof$2(e)){var i=e;e=i.orientation,r=i.unit||r,n=i.format||n;}r=r||"mm",n=n||"a4",e=(""+(e||"P")).toLowerCase();var a,o=(""+n).toLowerCase(),s={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};switch(r){case"pt":a=1;break;case"mm":a=72/25.4;break;case"cm":a=72/2.54;break;case"in":a=72;break;case"px":a=.75;break;case"pc":case"em":a=12;break;case"ex":a=6;break;default:throw "Invalid unit: "+r}var c,u=0,h=0;if(s.hasOwnProperty(o))u=s[o][1]/a,h=s[o][0]/a;else try{u=n[1],h=n[0];}catch(t){throw new Error("Invalid format: "+n)}if("p"===e||"portrait"===e)e="p",h>u&&(c=h,h=u,u=c);else {if("l"!==e&&"landscape"!==e)throw "Invalid orientation: "+e;e="l",u>h&&(c=h,h=u,u=c);}return {width:h,height:u,unit:r,k:a,orientation:e}},e.html=function(t,e){(e=e||{}).callback=e.callback||function(){},e.html2canvas=e.html2canvas||{},e.html2canvas.canvas=e.html2canvas.canvas||this.canvas,e.jsPDF=e.jsPDF||this,e.fontFaces=e.fontFaces?e.fontFaces.map(jt):null;var r=new s(e);return e.worker?r:r.from(t).doCallback()};}(E.API),E.API.addJS=function(t){return Ht=t,this.internal.events.subscribe("postPutResources",(function(){Ut=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(Ut+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),zt=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+Ht+")"),this.internal.out(">>"),this.internal.out("endobj");})),this.internal.events.subscribe("putCatalog",(function(){void 0!==Ut&&void 0!==zt&&this.internal.out("/Names <</JavaScript "+Ut+" 0 R>>");})),this},
/**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e;t.events.push(["postPutResources",function(){var t=this,r=/^(\d+) 0 obj$/;if(this.outline.root.children.length>0)for(var n=t.outline.render().split(/\r\n/),i=0;i<n.length;i++){var a=n[i],o=r.exec(a);if(null!=o){var s=o[1];t.internal.newObjectDeferredBegin(s,!1);}t.internal.write(a);}if(this.outline.createNamedDestinations){var c=this.internal.pages.length,u=[];for(i=0;i<c;i++){var h=t.internal.newObject();u.push(h);var l=t.internal.getPageInfo(i+1);t.internal.write("<< /D["+l.objId+" 0 R /XYZ null null null]>> endobj");}var f=t.internal.newObject();t.internal.write("<< /Names [ ");for(i=0;i<u.length;i++)t.internal.write("(page_"+(i+1)+")"+u[i]+" 0 R");t.internal.write(" ] >>","endobj"),e=t.internal.newObject(),t.internal.write("<< /Dests "+f+" 0 R"),t.internal.write(">>","endobj");}}]),t.events.push(["putCatalog",function(){this.outline.root.children.length>0&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+e+" 0 R"));}]),t.events.push(["initialized",function(){var t=this;t.outline={createNamedDestinations:!1,root:{children:[]}},t.outline.add=function(t,e,r){var n={title:e,options:r,children:[]};return null==t&&(t=this.root),t.children.push(n),n},t.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=t,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},t.outline.genIds_r=function(e){e.id=t.internal.newObjectDeferred();for(var r=0;r<e.children.length;r++)this.genIds_r(e.children[r]);},t.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),t.children.length>0&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd();},t.outline.renderItems=function(e){for(var r=this.ctx.pdf.internal.getVerticalCoordinateString,n=0;n<e.children.length;n++){var i=e.children[n];this.objStart(i),this.line("/Title "+this.makeString(i.title)),this.line("/Parent "+this.makeRef(e)),n>0&&this.line("/Prev "+this.makeRef(e.children[n-1])),n<e.children.length-1&&this.line("/Next "+this.makeRef(e.children[n+1])),i.children.length>0&&(this.line("/First "+this.makeRef(i.children[0])),this.line("/Last "+this.makeRef(i.children[i.children.length-1])));var a=this.count=this.count_r({count:0},i);if(a>0&&this.line("/Count "+a),i.options&&i.options.pageNumber){var o=t.internal.getPageInfo(i.options.pageNumber);this.line("/Dest ["+o.objId+" 0 R /XYZ 0 "+r(0)+" 0]");}this.objEnd();}for(var s=0;s<e.children.length;s++)this.renderItems(e.children[s]);},t.outline.line=function(t){this.ctx.val+=t+"\r\n";},t.outline.makeRef=function(t){return t.id+" 0 R"},t.outline.makeString=function(e){return "("+t.internal.pdfEscape(e)+")"},t.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n";},t.outline.objEnd=function(){this.ctx.val+=">> \r\nendobj\r\n";},t.outline.count_r=function(t,e){for(var r=0;r<e.children.length;r++)t.count++,this.count_r(t,e.children[r]);return t.count};}]);}(E.API),
/**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=[192,193,194,195,196,197,198,199];t.processJPEG=function(t,r,n,i,a,o){var s,c=this.decode.DCT_DECODE,u=null;if("string"==typeof t||this.__addimage__.isArrayBuffer(t)||this.__addimage__.isArrayBufferView(t)){switch(t=a||t,t=this.__addimage__.isArrayBuffer(t)?new Uint8Array(t):t,(s=function(t){for(var r,n=256*t.charCodeAt(4)+t.charCodeAt(5),i=t.length,a={width:0,height:0,numcomponents:1},o=4;o<i;o+=2){if(o+=n,-1!==e.indexOf(t.charCodeAt(o+1))){r=256*t.charCodeAt(o+5)+t.charCodeAt(o+6),a={width:256*t.charCodeAt(o+7)+t.charCodeAt(o+8),height:r,numcomponents:t.charCodeAt(o+9)};break}n=256*t.charCodeAt(o+2)+t.charCodeAt(o+3);}return a}(t=this.__addimage__.isArrayBufferView(t)?this.__addimage__.arrayBufferToBinaryString(t):t)).numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;case 3:o=this.color_spaces.DEVICE_RGB;}u={data:t,width:s.width,height:s.height,colorSpace:o,bitsPerComponent:8,filter:c,index:r,alias:n};}return u};}(E.API);var Vt,Gt,Yt,Jt,Xt,Kt=function(){var t,e,i;function a(t){var e,r,n,i,a,o,s,c,u,h,l,f,d,p;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},o=null;;){switch(e=this.readUInt32(),u=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":o&&this.animation.frames.push(o),this.pos+=4,o={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},a=this.readUInt16(),i=this.readUInt16()||100,o.delay=1e3*a/i,o.disposeOp=this.data[this.pos++],o.blendOp=this.data[this.pos++],o.data=[];break;case"IDAT":case"fdAT":for("fdAT"===u&&(this.pos+=4,e-=4),t=(null!=o?o.data:void 0)||this.imgData,f=0;0<=e?f<e:f>e;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(n=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>n)throw new Error("More transparent colors than palette size");if((h=n-this.transparency.indexed.length)>0)for(d=0;0<=h?d<h:d>h;0<=h?++d:--d)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e);}break;case"tEXt":s=(l=this.read(e)).indexOf(0),c=String.fromCharCode.apply(String,l.slice(0,s)),this.text[c]=String.fromCharCode.apply(String,l.slice(s+1));break;case"IEND":return o&&this.animation.frames.push(o),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(p=this.colorType)||6===p,r=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*r,this.colorSpace=function(){switch(this.colors){case 1:return "DeviceGray";case 3:return "DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e;}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}a.prototype.read=function(t){var e,r;for(r=[],e=0;0<=t?e<t:e>t;0<=t?++e:--e)r.push(this.data[this.pos++]);return r},a.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},a.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},a.prototype.decodePixels=function(t){var e=this.pixelBitlength/8,n=new Uint8Array(this.width*this.height*e),i=0,a=this;if(null==t&&(t=this.imgData),0===t.length)return new Uint8Array(0);function o(r,o,s,c){var u,h,l,f,d,p,g,m,v,b,y,w,N,L,A,x,S,_,P,k,I,F=Math.ceil((a.width-r)/s),C=Math.ceil((a.height-o)/c),j=a.width==F&&a.height==C;for(L=e*F,w=j?n:new Uint8Array(L*C),p=t.length,N=0,h=0;N<C&&i<p;){switch(t[i++]){case 0:for(f=S=0;S<L;f=S+=1)w[h++]=t[i++];break;case 1:for(f=_=0;_<L;f=_+=1)u=t[i++],d=f<e?0:w[h-e],w[h++]=(u+d)%256;break;case 2:for(f=P=0;P<L;f=P+=1)u=t[i++],l=(f-f%e)/e,A=N&&w[(N-1)*L+l*e+f%e],w[h++]=(A+u)%256;break;case 3:for(f=k=0;k<L;f=k+=1)u=t[i++],l=(f-f%e)/e,d=f<e?0:w[h-e],A=N&&w[(N-1)*L+l*e+f%e],w[h++]=(u+Math.floor((d+A)/2))%256;break;case 4:for(f=I=0;I<L;f=I+=1)u=t[i++],l=(f-f%e)/e,d=f<e?0:w[h-e],0===N?A=x=0:(A=w[(N-1)*L+l*e+f%e],x=l&&w[(N-1)*L+(l-1)*e+f%e]),g=d+A-x,m=Math.abs(g-d),b=Math.abs(g-A),y=Math.abs(g-x),v=m<=b&&m<=y?d:b<=y?A:x,w[h++]=(u+v)%256;break;default:throw new Error("Invalid filter algorithm: "+t[i-1])}if(!j){var O=((o+N*c)*a.width+r)*e,B=N*L;for(f=0;f<F;f+=1){for(var M=0;M<e;M+=1)n[O++]=w[B++];O+=(s-1)*e;}}N++;}}return t=unzlibSync(t),1==a.interlaceMethod?(o(0,0,8,8),o(4,0,8,8),o(0,4,4,8),o(2,0,4,4),o(0,2,2,4),o(1,0,2,2),o(0,1,1,2)):o(0,0,1,1),n},a.prototype.decodePalette=function(){var t,e,r,n,i,a,o,s,c;for(r=this.palette,a=this.transparency.indexed||[],i=new Uint8Array((a.length||0)+r.length),n=0,t=0,e=o=0,s=r.length;o<s;e=o+=3)i[n++]=r[e],i[n++]=r[e+1],i[n++]=r[e+2],i[n++]=null!=(c=a[t++])?c:255;return i},a.prototype.copyToImageData=function(t,e){var r,n,i,a,o,s,c,u,h,l,f;if(n=this.colors,h=null,r=this.hasAlphaChannel,this.palette.length&&(h=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),n=4,r=!0),u=(i=t.data||t).length,o=h||e,a=s=0,1===n)for(;a<u;)c=h?4*e[a/4]:s,l=o[c++],i[a++]=l,i[a++]=l,i[a++]=l,i[a++]=r?o[c++]:255,s=c;else for(;a<u;)c=h?4*e[a/4]:s,i[a++]=o[c++],i[a++]=o[c++],i[a++]=o[c++],i[a++]=r?o[c++]:255,s=c;},a.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};var o=function(){if("[object Window]"===Object.prototype.toString.call(n)){try{e=n.document.createElement("canvas"),i=e.getContext("2d");}catch(t){return !1}return !0}return !1};return o(),t=function(t){var r;if(!0===o())return i.width=t.width,i.height=t.height,i.clearRect(0,0,t.width,t.height),i.putImageData(t,0,0),(r=new Image).src=e.toDataURL(),r;throw new Error("This method requires a Browser with Canvas-capability.")},a.prototype.decodeFrames=function(e){var r,n,i,a,o,s,c,u;if(this.animation){for(u=[],n=o=0,s=(c=this.animation.frames).length;o<s;n=++o)r=c[n],i=e.createImageData(r.width,r.height),a=this.decodePixels(new Uint8Array(r.data)),this.copyToImageData(i,a),r.imageData=i,u.push(r.image=t(i));return u}},a.prototype.renderFrame=function(t,e){var r,n,i;return r=(n=this.animation.frames)[e],i=n[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===r.blendOp&&t.clearRect(r.xOffset,r.yOffset,r.width,r.height),t.drawImage(r.image,r.xOffset,r.yOffset)},a.prototype.animate=function(t){var e,r,n,i,a,o,s=this;return r=0,o=this.animation,i=o.numFrames,n=o.frames,a=o.numPlays,(e=function(){var o,c;if(o=r++%i,c=n[o],s.renderFrame(t,o),i>1&&r/i<a)return s.animation._timeout=setTimeout(e,c.delay)})()},a.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},a.prototype.render=function(t){var e,r;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(r=e.createImageData(this.width,this.height),this.copyToImageData(r,this.decodePixels()),e.putImageData(r,0,0))},a}();
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
/**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */
function Zt(t){var e=0;if(71!==t[e++]||73!==t[e++]||70!==t[e++]||56!==t[e++]||56!=(t[e++]+1&253)||97!==t[e++])throw new Error("Invalid GIF 87a/89a header.");var r=t[e++]|t[e++]<<8,n=t[e++]|t[e++]<<8,i=t[e++],a=i>>7,o=1<<(7&i)+1;t[e++];t[e++];var s=null,c=null;a&&(s=e,c=o,e+=3*o);var u=!0,h=[],l=0,f=null,d=0,p=null;for(this.width=r,this.height=n;u&&e<t.length;)switch(t[e++]){case 33:switch(t[e++]){case 255:if(11!==t[e]||78==t[e+1]&&69==t[e+2]&&84==t[e+3]&&83==t[e+4]&&67==t[e+5]&&65==t[e+6]&&80==t[e+7]&&69==t[e+8]&&50==t[e+9]&&46==t[e+10]&&48==t[e+11]&&3==t[e+12]&&1==t[e+13]&&0==t[e+16])e+=14,p=t[e++]|t[e++]<<8,e++;else for(e+=12;;){if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P;}break;case 249:if(4!==t[e++]||0!==t[e+4])throw new Error("Invalid graphics extension block.");var g=t[e++];l=t[e++]|t[e++]<<8,f=t[e++],0==(1&g)&&(f=null),d=g>>2&7,e++;break;case 254:for(;;){if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P;}break;default:throw new Error("Unknown graphic control label: 0x"+t[e-1].toString(16))}break;case 44:var m=t[e++]|t[e++]<<8,v=t[e++]|t[e++]<<8,b=t[e++]|t[e++]<<8,y=t[e++]|t[e++]<<8,w=t[e++],N=w>>6&1,L=1<<(7&w)+1,A=s,x=c,S=!1;if(w>>7){S=!0;A=e,x=L,e+=3*L;}var _=e;for(e++;;){var P;if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P;}h.push({x:m,y:v,width:b,height:y,has_local_palette:S,palette_offset:A,palette_size:x,data_offset:_,data_length:e-_,transparent_index:f,interlaced:!!N,delay:l,disposal:d});break;case 59:u=!1;break;default:throw new Error("Unknown gif block: 0x"+t[e-1].toString(16))}this.numFrames=function(){return h.length},this.loopCount=function(){return p},this.frameInfo=function(t){if(t<0||t>=h.length)throw new Error("Frame index out of range.");return h[t]},this.decodeAndBlitFrameBGRA=function(e,n){var i=this.frameInfo(e),a=i.width*i.height,o=new Uint8Array(a);$t(t,i.data_offset,o,a);var s=i.palette_offset,c=i.transparent_index;null===c&&(c=256);var u=i.width,h=r-u,l=u,f=4*(i.y*r+i.x),d=4*((i.y+i.height)*r+i.x),p=f,g=4*h;!0===i.interlaced&&(g+=4*r*7);for(var m=8,v=0,b=o.length;v<b;++v){var y=o[v];if(0===l&&(l=u,(p+=g)>=d&&(g=4*h+4*r*(m-1),p=f+(u+h)*(m<<1),m>>=1)),y===c)p+=4;else {var w=t[s+3*y],N=t[s+3*y+1],L=t[s+3*y+2];n[p++]=L,n[p++]=N,n[p++]=w,n[p++]=255;}--l;}},this.decodeAndBlitFrameRGBA=function(e,n){var i=this.frameInfo(e),a=i.width*i.height,o=new Uint8Array(a);$t(t,i.data_offset,o,a);var s=i.palette_offset,c=i.transparent_index;null===c&&(c=256);var u=i.width,h=r-u,l=u,f=4*(i.y*r+i.x),d=4*((i.y+i.height)*r+i.x),p=f,g=4*h;!0===i.interlaced&&(g+=4*r*7);for(var m=8,v=0,b=o.length;v<b;++v){var y=o[v];if(0===l&&(l=u,(p+=g)>=d&&(g=4*h+4*r*(m-1),p=f+(u+h)*(m<<1),m>>=1)),y===c)p+=4;else {var w=t[s+3*y],N=t[s+3*y+1],L=t[s+3*y+2];n[p++]=w,n[p++]=N,n[p++]=L,n[p++]=255;}--l;}};}function $t(t,e,r,n){for(var i=t[e++],o=1<<i,s=o+1,c=s+1,u=i+1,h=(1<<u)-1,l=0,f=0,d=0,p=t[e++],g=new Int32Array(4096),m=null;;){for(;l<16&&0!==p;)f|=t[e++]<<l,l+=8,1===p?p=t[e++]:--p;if(l<u)break;var v=f&h;if(f>>=u,l-=u,v!==o){if(v===s)break;for(var b=v<c?v:m,y=0,w=b;w>o;)w=g[w]>>8,++y;var N=w;if(d+y+(b!==v?1:0)>n)return void a.log("Warning, gif stream longer than expected.");r[d++]=N;var L=d+=y;for(b!==v&&(r[d++]=N),w=b;y--;)w=g[w],r[--L]=255&w,w>>=8;null!==m&&c<4096&&(g[c++]=m<<8|N,c>=h+1&&u<12&&(++u,h=h<<1|1)),m=v;}else c=s+1,h=(1<<(u=i+1))-1,m=null;}return d!==n&&a.log("Warning, gif stream shorter than expected."),r}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/function Qt(t){var e,r,n,i,a,o=Math.floor,s=new Array(64),c=new Array(64),u=new Array(64),h=new Array(64),l=new Array(65535),f=new Array(65535),d=new Array(64),p=new Array(64),g=[],m=0,v=7,b=new Array(64),y=new Array(64),w=new Array(64),N=new Array(256),L=new Array(2048),A=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],x=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],S=[0,1,2,3,4,5,6,7,8,9,10,11],_=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],P=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],k=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],I=[0,1,2,3,4,5,6,7,8,9,10,11],F=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],C=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function j(t,e){for(var r=0,n=0,i=new Array,a=1;a<=16;a++){for(var o=1;o<=t[a];o++)i[e[n]]=[],i[e[n]][0]=r,i[e[n]][1]=a,n++,r++;r*=2;}return i}function O(t){for(var e=t[0],r=t[1]-1;r>=0;)e&1<<r&&(m|=1<<v),r--,--v<0&&(255==m?(B(255),B(0)):B(m),v=7,m=0);}function B(t){g.push(t);}function M(t){B(t>>8&255),B(255&t);}function E(t,e,r,n,i){for(var a,o=i[0],s=i[240],c=function(t,e){var r,n,i,a,o,s,c,u,h,l,f=0;for(h=0;h<8;++h){r=t[f],n=t[f+1],i=t[f+2],a=t[f+3],o=t[f+4],s=t[f+5],c=t[f+6];var p=r+(u=t[f+7]),g=r-u,m=n+c,v=n-c,b=i+s,y=i-s,w=a+o,N=a-o,L=p+w,A=p-w,x=m+b,S=m-b;t[f]=L+x,t[f+4]=L-x;var _=.707106781*(S+A);t[f+2]=A+_,t[f+6]=A-_;var P=.382683433*((L=N+y)-(S=v+g)),k=.5411961*L+P,I=1.306562965*S+P,F=.707106781*(x=y+v),C=g+F,j=g-F;t[f+5]=j+k,t[f+3]=j-k,t[f+1]=C+I,t[f+7]=C-I,f+=8;}for(f=0,h=0;h<8;++h){r=t[f],n=t[f+8],i=t[f+16],a=t[f+24],o=t[f+32],s=t[f+40],c=t[f+48];var O=r+(u=t[f+56]),B=r-u,M=n+c,E=n-c,q=i+s,D=i-s,R=a+o,T=a-o,U=O+R,z=O-R,H=M+q,W=M-q;t[f]=U+H,t[f+32]=U-H;var V=.707106781*(W+z);t[f+16]=z+V,t[f+48]=z-V;var G=.382683433*((U=T+D)-(W=E+B)),Y=.5411961*U+G,J=1.306562965*W+G,X=.707106781*(H=D+E),K=B+X,Z=B-X;t[f+40]=Z+Y,t[f+24]=Z-Y,t[f+8]=K+J,t[f+56]=K-J,f++;}for(h=0;h<64;++h)l=t[h]*e[h],d[h]=l>0?l+.5|0:l-.5|0;return d}(t,e),u=0;u<64;++u)p[A[u]]=c[u];var h=p[0]-r;r=p[0],0==h?O(n[0]):(O(n[f[a=32767+h]]),O(l[a]));for(var g=63;g>0&&0==p[g];)g--;if(0==g)return O(o),r;for(var m,v=1;v<=g;){for(var b=v;0==p[v]&&v<=g;)++v;var y=v-b;if(y>=16){m=y>>4;for(var w=1;w<=m;++w)O(s);y&=15;}a=32767+p[v],O(i[(y<<4)+f[a]]),O(l[a]),v++;}return 63!=g&&O(o),r}function q(t){(t=Math.min(Math.max(t,1),100),a!=t)&&(!function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],r=0;r<64;r++){var n=o((e[r]*t+50)/100);n=Math.min(Math.max(n,1),255),s[A[r]]=n;}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],a=0;a<64;a++){var l=o((i[a]*t+50)/100);l=Math.min(Math.max(l,1),255),c[A[a]]=l;}for(var f=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],d=0,p=0;p<8;p++)for(var g=0;g<8;g++)u[d]=1/(s[A[d]]*f[p]*f[g]*8),h[d]=1/(c[A[d]]*f[p]*f[g]*8),d++;}(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),a=t);}this.encode=function(t,a){a&&q(a),g=new Array,m=0,v=7,M(65496),M(65504),M(16),B(74),B(70),B(73),B(70),B(0),B(1),B(1),B(0),M(1),M(1),B(0),B(0),function(){M(65499),M(132),B(0);for(var t=0;t<64;t++)B(s[t]);B(1);for(var e=0;e<64;e++)B(c[e]);}(),function(t,e){M(65472),M(17),B(8),M(e),M(t),B(3),B(1),B(17),B(0),B(2),B(17),B(1),B(3),B(17),B(1);}(t.width,t.height),function(){M(65476),M(418),B(0);for(var t=0;t<16;t++)B(x[t+1]);for(var e=0;e<=11;e++)B(S[e]);B(16);for(var r=0;r<16;r++)B(_[r+1]);for(var n=0;n<=161;n++)B(P[n]);B(1);for(var i=0;i<16;i++)B(k[i+1]);for(var a=0;a<=11;a++)B(I[a]);B(17);for(var o=0;o<16;o++)B(F[o+1]);for(var s=0;s<=161;s++)B(C[s]);}(),M(65498),M(12),B(3),B(1),B(0),B(2),B(17),B(3),B(17),B(0),B(63),B(0);var o=0,l=0,f=0;m=0,v=7,this.encode.displayName="_encode_";for(var d,p,N,A,j,D,R,T,U,z=t.data,H=t.width,W=t.height,V=4*H,G=0;G<W;){for(d=0;d<V;){for(j=V*G+d,R=-1,T=0,U=0;U<64;U++)D=j+(T=U>>3)*V+(R=4*(7&U)),G+T>=W&&(D-=V*(G+1+T-W)),d+R>=V&&(D-=d+R-V+4),p=z[D++],N=z[D++],A=z[D++],b[U]=(L[p]+L[N+256>>0]+L[A+512>>0]>>16)-128,y[U]=(L[p+768>>0]+L[N+1024>>0]+L[A+1280>>0]>>16)-128,w[U]=(L[p+1280>>0]+L[N+1536>>0]+L[A+1792>>0]>>16)-128;o=E(b,u,o,e,n),l=E(y,h,l,r,i),f=E(w,h,f,r,i),d+=32;}G+=8;}if(v>=0){var Y=[];Y[1]=v+1,Y[0]=(1<<v+1)-1,O(Y);}return M(65497),new Uint8Array(g)},t=t||50,function(){for(var t=String.fromCharCode,e=0;e<256;e++)N[e]=t(e);}(),e=j(x,S),r=j(k,I),n=j(_,P),i=j(F,C),function(){for(var t=1,e=2,r=1;r<=15;r++){for(var n=t;n<e;n++)f[32767+n]=r,l[32767+n]=[],l[32767+n][1]=r,l[32767+n][0]=n;for(var i=-(e-1);i<=-t;i++)f[32767+i]=r,l[32767+i]=[],l[32767+i][1]=r,l[32767+i][0]=e-1+i;t<<=1,e<<=1;}}(),function(){for(var t=0;t<256;t++)L[t]=19595*t,L[t+256>>0]=38470*t,L[t+512>>0]=7471*t+32768,L[t+768>>0]=-11059*t,L[t+1024>>0]=-21709*t,L[t+1280>>0]=32768*t+8421375,L[t+1536>>0]=-27439*t,L[t+1792>>0]=-5329*t;}(),q(t);}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */function te(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR();}function ee(t){function e(t){if(!t)throw Error("assert :P")}function r(t,e,r){for(var n=0;4>n;n++)if(t[e+n]!=r.charCodeAt(n))return !0;return !1}function n(t,e,r,n,i){for(var a=0;a<i;a++)t[e+a]=r[n+a];}function i(t,e,r,n){for(var i=0;i<n;i++)t[e+i]=r;}function a(t){return new Int32Array(t)}function o(t,e){for(var r=[],n=0;n<t;n++)r.push(new e);return r}function s(t,e){var r=[];return function t(r,n,i){for(var a=i[n],o=0;o<a&&(r.push(i.length>n+1?[]:new e),!(i.length<n+1));o++)t(r[o],n+1,i);}(r,0,t),r}var c=function(){var t=this;function c(t,e){for(var r=1<<e-1>>>0;t&r;)r>>>=1;return r?(t&r-1)+r:t}function u(t,r,n,i,a){e(!(i%n));do{t[r+(i-=n)]=a;}while(0<i)}function h(t,r,n,i,o){if(e(2328>=o),512>=o)var s=a(512);else if(null==(s=a(o)))return 0;return function(t,r,n,i,o,s){var h,f,d=r,p=1<<n,g=a(16),m=a(16);for(e(0!=o),e(null!=i),e(null!=t),e(0<n),f=0;f<o;++f){if(15<i[f])return 0;++g[i[f]];}if(g[0]==o)return 0;for(m[1]=0,h=1;15>h;++h){if(g[h]>1<<h)return 0;m[h+1]=m[h]+g[h];}for(f=0;f<o;++f)h=i[f],0<i[f]&&(s[m[h]++]=f);if(1==m[15])return (i=new l).g=0,i.value=s[0],u(t,d,1,p,i),p;var v,b=-1,y=p-1,w=0,N=1,L=1,A=1<<n;for(f=0,h=1,o=2;h<=n;++h,o<<=1){if(N+=L<<=1,0>(L-=g[h]))return 0;for(;0<g[h];--g[h])(i=new l).g=h,i.value=s[f++],u(t,d+w,o,A,i),w=c(w,h);}for(h=n+1,o=2;15>=h;++h,o<<=1){if(N+=L<<=1,0>(L-=g[h]))return 0;for(;0<g[h];--g[h]){if(i=new l,(w&y)!=b){for(d+=A,v=1<<(b=h)-n;15>b&&!(0>=(v-=g[b]));)++b,v<<=1;p+=A=1<<(v=b-n),t[r+(b=w&y)].g=v+n,t[r+b].value=d-r-b;}i.g=h-n,i.value=s[f++],u(t,d+(w>>n),o,A,i),w=c(w,h);}}return N!=2*m[15]-1?0:p}(t,r,n,i,o,s)}function l(){this.value=this.g=0;}function f(){this.value=this.g=0;}function d(){this.G=o(5,l),this.H=a(5),this.jc=this.Qb=this.qb=this.nd=0,this.pd=o(Dr,f);}function p(t,r,n,i){e(null!=t),e(null!=r),e(2147483648>i),t.Ca=254,t.I=0,t.b=-8,t.Ka=0,t.oa=r,t.pa=n,t.Jd=r,t.Yc=n+i,t.Zc=4<=i?n+i-4+1:n,_(t);}function g(t,e){for(var r=0;0<e--;)r|=k(t,128)<<e;return r}function m(t,e){var r=g(t,e);return P(t)?-r:r}function v(t,r,n,i){var a,o=0;for(e(null!=t),e(null!=r),e(4294967288>i),t.Sb=i,t.Ra=0,t.u=0,t.h=0,4<i&&(i=4),a=0;a<i;++a)o+=r[n+a]<<8*a;t.Ra=o,t.bb=i,t.oa=r,t.pa=n;}function b(t){for(;8<=t.u&&t.bb<t.Sb;)t.Ra>>>=8,t.Ra+=t.oa[t.pa+t.bb]<<Ur-8>>>0,++t.bb,t.u-=8;A(t)&&(t.h=1,t.u=0);}function y(t,r){if(e(0<=r),!t.h&&r<=Tr){var n=L(t)&Rr[r];return t.u+=r,b(t),n}return t.h=1,t.u=0}function w(){this.b=this.Ca=this.I=0,this.oa=[],this.pa=0,this.Jd=[],this.Yc=0,this.Zc=[],this.Ka=0;}function N(){this.Ra=0,this.oa=[],this.h=this.u=this.bb=this.Sb=this.pa=0;}function L(t){return t.Ra>>>(t.u&Ur-1)>>>0}function A(t){return e(t.bb<=t.Sb),t.h||t.bb==t.Sb&&t.u>Ur}function x(t,e){t.u=e,t.h=A(t);}function S(t){t.u>=zr&&(e(t.u>=zr),b(t));}function _(t){e(null!=t&&null!=t.oa),t.pa<t.Zc?(t.I=(t.oa[t.pa++]|t.I<<8)>>>0,t.b+=8):(e(null!=t&&null!=t.oa),t.pa<t.Yc?(t.b+=8,t.I=t.oa[t.pa++]|t.I<<8):t.Ka?t.b=0:(t.I<<=8,t.b+=8,t.Ka=1));}function P(t){return g(t,1)}function k(t,e){var r=t.Ca;0>t.b&&_(t);var n=t.b,i=r*e>>>8,a=(t.I>>>n>i)+0;for(a?(r-=i,t.I-=i+1<<n>>>0):r=i+1,n=r,i=0;256<=n;)i+=8,n>>=8;return n=7^i+Hr[n],t.b-=n,t.Ca=(r<<n)-1,a}function I(t,e,r){t[e+0]=r>>24&255,t[e+1]=r>>16&255,t[e+2]=r>>8&255,t[e+3]=r>>0&255;}function F(t,e){return t[e+0]<<0|t[e+1]<<8}function C(t,e){return F(t,e)|t[e+2]<<16}function j(t,e){return F(t,e)|F(t,e+2)<<16}function O(t,r){var n=1<<r;return e(null!=t),e(0<r),t.X=a(n),null==t.X?0:(t.Mb=32-r,t.Xa=r,1)}function B(t,r){e(null!=t),e(null!=r),e(t.Xa==r.Xa),n(r.X,0,t.X,0,1<<r.Xa);}function M(){this.X=[],this.Xa=this.Mb=0;}function E(t,r,n,i){e(null!=n),e(null!=i);var a=n[0],o=i[0];return 0==a&&(a=(t*o+r/2)/r),0==o&&(o=(r*a+t/2)/t),0>=a||0>=o?0:(n[0]=a,i[0]=o,1)}function q(t,e){return t+(1<<e)-1>>>e}function D(t,e){return ((4278255360&t)+(4278255360&e)>>>0&4278255360)+((16711935&t)+(16711935&e)>>>0&16711935)>>>0}function R(e,r){t[r]=function(r,n,i,a,o,s,c){var u;for(u=0;u<o;++u){var h=t[e](s[c+u-1],i,a+u);s[c+u]=D(r[n+u],h);}};}function T(){this.ud=this.hd=this.jd=0;}function U(t,e){return ((4278124286&(t^e))>>>1)+(t&e)>>>0}function z(t){return 0<=t&&256>t?t:0>t?0:255<t?255:void 0}function H(t,e){return z(t+(t-e+.5>>1))}function W(t,e,r){return Math.abs(e-r)-Math.abs(t-r)}function V(t,e,r,n,i,a,o){for(n=a[o-1],r=0;r<i;++r)a[o+r]=n=D(t[e+r],n);}function G(t,e,r,n,i){var a;for(a=0;a<r;++a){var o=t[e+a],s=o>>8&255,c=16711935&(c=(c=16711935&o)+((s<<16)+s));n[i+a]=(4278255360&o)+c>>>0;}}function Y(t,e){e.jd=t>>0&255,e.hd=t>>8&255,e.ud=t>>16&255;}function J(t,e,r,n,i,a){var o;for(o=0;o<n;++o){var s=e[r+o],c=s>>>8,u=s,h=255&(h=(h=s>>>16)+((t.jd<<24>>24)*(c<<24>>24)>>>5));u=255&(u=(u=u+((t.hd<<24>>24)*(c<<24>>24)>>>5))+((t.ud<<24>>24)*(h<<24>>24)>>>5));i[a+o]=(4278255360&s)+(h<<16)+u;}}function X(e,r,n,i,a){t[r]=function(t,e,r,n,o,s,c,u,h){for(n=c;n<u;++n)for(c=0;c<h;++c)o[s++]=a(r[i(t[e++])]);},t[e]=function(e,r,o,s,c,u,h){var l=8>>e.b,f=e.Ea,d=e.K[0],p=e.w;if(8>l)for(e=(1<<e.b)-1,p=(1<<l)-1;r<o;++r){var g,m=0;for(g=0;g<f;++g)g&e||(m=i(s[c++])),u[h++]=a(d[m&p]),m>>=l;}else t["VP8LMapColor"+n](s,c,d,p,u,h,r,o,f);};}function K(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>16&255,n[i++]=a>>8&255,n[i++]=a>>0&255;}}function Z(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>16&255,n[i++]=a>>8&255,n[i++]=a>>0&255,n[i++]=a>>24&255;}}function $(t,e,r,n,i){for(r=e+r;e<r;){var a=(o=t[e++])>>16&240|o>>12&15,o=o>>0&240|o>>28&15;n[i++]=a,n[i++]=o;}}function Q(t,e,r,n,i){for(r=e+r;e<r;){var a=(o=t[e++])>>16&248|o>>13&7,o=o>>5&224|o>>3&31;n[i++]=a,n[i++]=o;}}function tt(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>0&255,n[i++]=a>>8&255,n[i++]=a>>16&255;}}function et(t,e,r,i,a,o){if(0==o)for(r=e+r;e<r;)I(i,((o=t[e++])[0]>>24|o[1]>>8&65280|o[2]<<8&16711680|o[3]<<24)>>>0),a+=32;else n(i,a,t,e,r);}function rt(e,r){t[r][0]=t[e+"0"],t[r][1]=t[e+"1"],t[r][2]=t[e+"2"],t[r][3]=t[e+"3"],t[r][4]=t[e+"4"],t[r][5]=t[e+"5"],t[r][6]=t[e+"6"],t[r][7]=t[e+"7"],t[r][8]=t[e+"8"],t[r][9]=t[e+"9"],t[r][10]=t[e+"10"],t[r][11]=t[e+"11"],t[r][12]=t[e+"12"],t[r][13]=t[e+"13"],t[r][14]=t[e+"0"],t[r][15]=t[e+"0"];}function nt(t){return t==Hn||t==Wn||t==Vn||t==Gn}function it(){this.eb=[],this.size=this.A=this.fb=0;}function at(){this.y=[],this.f=[],this.ea=[],this.F=[],this.Tc=this.Ed=this.Cd=this.Fd=this.lb=this.Db=this.Ab=this.fa=this.J=this.W=this.N=this.O=0;}function ot(){this.Rd=this.height=this.width=this.S=0,this.f={},this.f.RGBA=new it,this.f.kb=new at,this.sd=null;}function st(){this.width=[0],this.height=[0],this.Pd=[0],this.Qd=[0],this.format=[0];}function ct(){this.Id=this.fd=this.Md=this.hb=this.ib=this.da=this.bd=this.cd=this.j=this.v=this.Da=this.Sd=this.ob=0;}function ut(t){return alert("todo:WebPSamplerProcessPlane"),t.T}function ht(t,e){var r=t.T,i=e.ba.f.RGBA,a=i.eb,o=i.fb+t.ka*i.A,s=vi[e.ba.S],c=t.y,u=t.O,h=t.f,l=t.N,f=t.ea,d=t.W,p=e.cc,g=e.dc,m=e.Mc,v=e.Nc,b=t.ka,y=t.ka+t.T,w=t.U,N=w+1>>1;for(0==b?s(c,u,null,null,h,l,f,d,h,l,f,d,a,o,null,null,w):(s(e.ec,e.fc,c,u,p,g,m,v,h,l,f,d,a,o-i.A,a,o,w),++r);b+2<y;b+=2)p=h,g=l,m=f,v=d,l+=t.Rc,d+=t.Rc,o+=2*i.A,s(c,(u+=2*t.fa)-t.fa,c,u,p,g,m,v,h,l,f,d,a,o-i.A,a,o,w);return u+=t.fa,t.j+y<t.o?(n(e.ec,e.fc,c,u,w),n(e.cc,e.dc,h,l,N),n(e.Mc,e.Nc,f,d,N),r--):1&y||s(c,u,null,null,h,l,f,d,h,l,f,d,a,o+i.A,null,null,w),r}function lt(t,r,n){var i=t.F,a=[t.J];if(null!=i){var o=t.U,s=r.ba.S,c=s==Tn||s==Vn;r=r.ba.f.RGBA;var u=[0],h=t.ka;u[0]=t.T,t.Kb&&(0==h?--u[0]:(--h,a[0]-=t.width),t.j+t.ka+t.T==t.o&&(u[0]=t.o-t.j-h));var l=r.eb;h=r.fb+h*r.A;t=Sn(i,a[0],t.width,o,u,l,h+(c?0:3),r.A),e(n==u),t&&nt(s)&&An(l,h,c,o,u,r.A);}return 0}function ft(t){var e=t.ma,r=e.ba.S,n=11>r,i=r==qn||r==Rn||r==Tn||r==Un||12==r||nt(r);if(e.memory=null,e.Ib=null,e.Jb=null,e.Nd=null,!Mr(e.Oa,t,i?11:12))return 0;if(i&&nt(r)&&br(),t.da)alert("todo:use_scaling");else {if(n){if(e.Ib=ut,t.Kb){if(r=t.U+1>>1,e.memory=a(t.U+2*r),null==e.memory)return 0;e.ec=e.memory,e.fc=0,e.cc=e.ec,e.dc=e.fc+t.U,e.Mc=e.cc,e.Nc=e.dc+r,e.Ib=ht,br();}}else alert("todo:EmitYUV");i&&(e.Jb=lt,n&&mr());}if(n&&!Ci){for(t=0;256>t;++t)ji[t]=89858*(t-128)+_i>>Si,Mi[t]=-22014*(t-128)+_i,Bi[t]=-45773*(t-128),Oi[t]=113618*(t-128)+_i>>Si;for(t=Pi;t<ki;++t)e=76283*(t-16)+_i>>Si,Ei[t-Pi]=Vt(e,255),qi[t-Pi]=Vt(e+8>>4,15);Ci=1;}return 1}function dt(t){var r=t.ma,n=t.U,i=t.T;return e(!(1&t.ka)),0>=n||0>=i?0:(n=r.Ib(t,r),null!=r.Jb&&r.Jb(t,r,n),r.Dc+=n,1)}function pt(t){t.ma.memory=null;}function gt(t,e,r,n){return 47!=y(t,8)?0:(e[0]=y(t,14)+1,r[0]=y(t,14)+1,n[0]=y(t,1),0!=y(t,3)?0:!t.h)}function mt(t,e){if(4>t)return t+1;var r=t-2>>1;return (2+(1&t)<<r)+y(e,r)+1}function vt(t,e){return 120<e?e-120:1<=(r=((r=$n[e-1])>>4)*t+(8-(15&r)))?r:1;var r;}function bt(t,e,r){var n=L(r),i=t[e+=255&n].g-8;return 0<i&&(x(r,r.u+8),n=L(r),e+=t[e].value,e+=n&(1<<i)-1),x(r,r.u+t[e].g),t[e].value}function yt(t,r,n){return n.g+=t.g,n.value+=t.value<<r>>>0,e(8>=n.g),t.g}function wt(t,r,n){var i=t.xc;return e((r=0==i?0:t.vc[t.md*(n>>i)+(r>>i)])<t.Wb),t.Ya[r]}function Nt(t,r,i,a){var o=t.ab,s=t.c*r,c=t.C;r=c+r;var u=i,h=a;for(a=t.Ta,i=t.Ua;0<o--;){var l=t.gc[o],f=c,d=r,p=u,g=h,m=(h=a,u=i,l.Ea);switch(e(f<d),e(d<=l.nc),l.hc){case 2:Gr(p,g,(d-f)*m,h,u);break;case 0:var v=f,b=d,y=h,w=u,N=(_=l).Ea;0==v&&(Wr(p,g,null,null,1,y,w),V(p,g+1,0,0,N-1,y,w+1),g+=N,w+=N,++v);for(var L=1<<_.b,A=L-1,x=q(N,_.b),S=_.K,_=_.w+(v>>_.b)*x;v<b;){var P=S,k=_,I=1;for(Vr(p,g,y,w-N,1,y,w);I<N;){var F=(I&~A)+L;F>N&&(F=N),(0, Zr[P[k++]>>8&15])(p,g+ +I,y,w+I-N,F-I,y,w+I),I=F;}g+=N,w+=N,++v&A||(_+=x);}d!=l.nc&&n(h,u-m,h,u+(d-f-1)*m,m);break;case 1:for(m=p,b=g,N=(p=l.Ea)-(w=p&~(y=(g=1<<l.b)-1)),v=q(p,l.b),L=l.K,l=l.w+(f>>l.b)*v;f<d;){for(A=L,x=l,S=new T,_=b+w,P=b+p;b<_;)Y(A[x++],S),$r(S,m,b,g,h,u),b+=g,u+=g;b<P&&(Y(A[x++],S),$r(S,m,b,N,h,u),b+=N,u+=N),++f&y||(l+=v);}break;case 3:if(p==h&&g==u&&0<l.b){for(b=h,p=m=u+(d-f)*m-(w=(d-f)*q(l.Ea,l.b)),g=h,y=u,v=[],w=(N=w)-1;0<=w;--w)v[w]=g[y+w];for(w=N-1;0<=w;--w)b[p+w]=v[w];Yr(l,f,d,h,m,h,u);}else Yr(l,f,d,p,g,h,u);}u=a,h=i;}h!=i&&n(a,i,u,h,s);}function Lt(t,r){var n=t.V,i=t.Ba+t.c*t.C,a=r-t.C;if(e(r<=t.l.o),e(16>=a),0<a){var o=t.l,s=t.Ta,c=t.Ua,u=o.width;if(Nt(t,a,n,i),a=c=[c],e((n=t.C)<(i=r)),e(o.v<o.va),i>o.o&&(i=o.o),n<o.j){var h=o.j-n;n=o.j;a[0]+=h*u;}if(n>=i?n=0:(a[0]+=4*o.v,o.ka=n-o.j,o.U=o.va-o.v,o.T=i-n,n=1),n){if(c=c[0],11>(n=t.ca).S){var l=n.f.RGBA,f=(i=n.S,a=o.U,o=o.T,h=l.eb,l.A),d=o;for(l=l.fb+t.Ma*l.A;0<d--;){var p=s,g=c,m=a,v=h,b=l;switch(i){case En:Qr(p,g,m,v,b);break;case qn:tn(p,g,m,v,b);break;case Hn:tn(p,g,m,v,b),An(v,b,0,m,1,0);break;case Dn:nn(p,g,m,v,b);break;case Rn:et(p,g,m,v,b,1);break;case Wn:et(p,g,m,v,b,1),An(v,b,0,m,1,0);break;case Tn:et(p,g,m,v,b,0);break;case Vn:et(p,g,m,v,b,0),An(v,b,1,m,1,0);break;case Un:en(p,g,m,v,b);break;case Gn:en(p,g,m,v,b),xn(v,b,m,1,0);break;case zn:rn(p,g,m,v,b);break;default:e(0);}c+=u,l+=f;}t.Ma+=o;}else alert("todo:EmitRescaledRowsYUVA");e(t.Ma<=n.height);}}t.C=r,e(t.C<=t.i);}function At(t){var e;if(0<t.ua)return 0;for(e=0;e<t.Wb;++e){var r=t.Ya[e].G,n=t.Ya[e].H;if(0<r[1][n[1]+0].g||0<r[2][n[2]+0].g||0<r[3][n[3]+0].g)return 0}return 1}function xt(t,r,n,i,a,o){if(0!=t.Z){var s=t.qd,c=t.rd;for(e(null!=mi[t.Z]);r<n;++r)mi[t.Z](s,c,i,a,i,a,o),s=i,c=a,a+=o;t.qd=s,t.rd=c;}}function St(t,r){var n=t.l.ma,i=0==n.Z||1==n.Z?t.l.j:t.C;i=t.C<i?i:t.C;if(e(r<=t.l.o),r>i){var a=t.l.width,o=n.ca,s=n.tb+a*i,c=t.V,u=t.Ba+t.c*i,h=t.gc;e(1==t.ab),e(3==h[0].hc),Xr(h[0],i,r,c,u,o,s),xt(n,i,r,o,s,a);}t.C=t.Ma=r;}function _t(t,r,n,i,a,o,s){var c=t.$/i,u=t.$%i,h=t.m,l=t.s,f=n+t.$,d=f;a=n+i*a;var p=n+i*o,g=280+l.ua,m=t.Pb?c:16777216,v=0<l.ua?l.Wa:null,b=l.wc,y=f<p?wt(l,u,c):null;e(t.C<o),e(p<=a);var w=!1;t:for(;;){for(;w||f<p;){var N=0;if(c>=m){var _=f-n;e((m=t).Pb),m.wd=m.m,m.xd=_,0<m.s.ua&&B(m.s.Wa,m.s.vb),m=c+ti;}if(u&b||(y=wt(l,u,c)),e(null!=y),y.Qb&&(r[f]=y.qb,w=!0),!w)if(S(h),y.jc){N=h,_=r;var P=f,k=y.pd[L(N)&Dr-1];e(y.jc),256>k.g?(x(N,N.u+k.g),_[P]=k.value,N=0):(x(N,N.u+k.g-256),e(256<=k.value),N=k.value),0==N&&(w=!0);}else N=bt(y.G[0],y.H[0],h);if(h.h)break;if(w||256>N){if(!w)if(y.nd)r[f]=(y.qb|N<<8)>>>0;else {if(S(h),w=bt(y.G[1],y.H[1],h),S(h),_=bt(y.G[2],y.H[2],h),P=bt(y.G[3],y.H[3],h),h.h)break;r[f]=(P<<24|w<<16|N<<8|_)>>>0;}if(w=!1,++f,++u>=i&&(u=0,++c,null!=s&&c<=o&&!(c%16)&&s(t,c),null!=v))for(;d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N;}else if(280>N){if(N=mt(N-256,h),_=bt(y.G[4],y.H[4],h),S(h),_=vt(i,_=mt(_,h)),h.h)break;if(f-n<_||a-f<N)break t;for(P=0;P<N;++P)r[f+P]=r[f+P-_];for(f+=N,u+=N;u>=i;)u-=i,++c,null!=s&&c<=o&&!(c%16)&&s(t,c);if(e(f<=a),u&b&&(y=wt(l,u,c)),null!=v)for(;d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N;}else {if(!(N<g))break t;for(w=N-280,e(null!=v);d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N;N=f,e(!(w>>>(_=v).Xa)),r[N]=_.X[w],w=!0;}w||e(h.h==A(h));}if(t.Pb&&h.h&&f<a)e(t.m.h),t.a=5,t.m=t.wd,t.$=t.xd,0<t.s.ua&&B(t.s.vb,t.s.Wa);else {if(h.h)break t;null!=s&&s(t,c>o?o:c),t.a=0,t.$=f-n;}return 1}return t.a=3,0}function Pt(t){e(null!=t),t.vc=null,t.yc=null,t.Ya=null;var r=t.Wa;null!=r&&(r.X=null),t.vb=null,e(null!=t);}function kt(){var e=new or;return null==e?null:(e.a=0,e.xb=gi,rt("Predictor","VP8LPredictors"),rt("Predictor","VP8LPredictors_C"),rt("PredictorAdd","VP8LPredictorsAdd"),rt("PredictorAdd","VP8LPredictorsAdd_C"),Gr=G,$r=J,Qr=K,tn=Z,en=$,rn=Q,nn=tt,t.VP8LMapColor32b=Jr,t.VP8LMapColor8b=Kr,e)}function It(t,r,n,s,c){var u=1,f=[t],p=[r],g=s.m,m=s.s,v=null,b=0;t:for(;;){if(n)for(;u&&y(g,1);){var w=f,N=p,A=s,_=1,P=A.m,k=A.gc[A.ab],I=y(P,2);if(A.Oc&1<<I)u=0;else {switch(A.Oc|=1<<I,k.hc=I,k.Ea=w[0],k.nc=N[0],k.K=[null],++A.ab,e(4>=A.ab),I){case 0:case 1:k.b=y(P,3)+2,_=It(q(k.Ea,k.b),q(k.nc,k.b),0,A,k.K),k.K=k.K[0];break;case 3:var F,C=y(P,8)+1,j=16<C?0:4<C?1:2<C?2:3;if(w[0]=q(k.Ea,j),k.b=j,F=_=It(C,1,0,A,k.K)){var B,M=C,E=k,R=1<<(8>>E.b),T=a(R);if(null==T)F=0;else {var U=E.K[0],z=E.w;for(T[0]=E.K[0][0],B=1;B<1*M;++B)T[B]=D(U[z+B],T[B-1]);for(;B<4*R;++B)T[B]=0;E.K[0]=null,E.K[0]=T,F=1;}}_=F;break;case 2:break;default:e(0);}u=_;}}if(f=f[0],p=p[0],u&&y(g,1)&&!(u=1<=(b=y(g,4))&&11>=b)){s.a=3;break t}var H;if(H=u)e:{var W,V,G,Y=s,J=f,X=p,K=b,Z=n,$=Y.m,Q=Y.s,tt=[null],et=1,rt=0,nt=Qn[K];r:for(;;){if(Z&&y($,1)){var it=y($,3)+2,at=q(J,it),ot=q(X,it),st=at*ot;if(!It(at,ot,0,Y,tt))break r;for(tt=tt[0],Q.xc=it,W=0;W<st;++W){var ct=tt[W]>>8&65535;tt[W]=ct,ct>=et&&(et=ct+1);}}if($.h)break r;for(V=0;5>V;++V){var ut=Xn[V];!V&&0<K&&(ut+=1<<K),rt<ut&&(rt=ut);}var ht=o(et*nt,l),lt=et,ft=o(lt,d);if(null==ft)var dt=null;else e(65536>=lt),dt=ft;var pt=a(rt);if(null==dt||null==pt||null==ht){Y.a=1;break r}var gt=ht;for(W=G=0;W<et;++W){var mt=dt[W],vt=mt.G,bt=mt.H,wt=0,Nt=1,Lt=0;for(V=0;5>V;++V){ut=Xn[V],vt[V]=gt,bt[V]=G,!V&&0<K&&(ut+=1<<K);n:{var At,xt=ut,St=Y,kt=pt,Ft=gt,Ct=G,jt=0,Ot=St.m,Bt=y(Ot,1);if(i(kt,0,0,xt),Bt){var Mt=y(Ot,1)+1,Et=y(Ot,1),qt=y(Ot,0==Et?1:8);kt[qt]=1,2==Mt&&(kt[qt=y(Ot,8)]=1);var Dt=1;}else {var Rt=a(19),Tt=y(Ot,4)+4;if(19<Tt){St.a=3;var Ut=0;break n}for(At=0;At<Tt;++At)Rt[Zn[At]]=y(Ot,3);var zt=void 0,Ht=void 0,Wt=St,Vt=Rt,Gt=xt,Yt=kt,Jt=0,Xt=Wt.m,Kt=8,Zt=o(128,l);i:for(;h(Zt,0,7,Vt,19);){if(y(Xt,1)){var $t=2+2*y(Xt,3);if((zt=2+y(Xt,$t))>Gt)break i}else zt=Gt;for(Ht=0;Ht<Gt&&zt--;){S(Xt);var Qt=Zt[0+(127&L(Xt))];x(Xt,Xt.u+Qt.g);var te=Qt.value;if(16>te)Yt[Ht++]=te,0!=te&&(Kt=te);else {var ee=16==te,re=te-16,ne=Jn[re],ie=y(Xt,Yn[re])+ne;if(Ht+ie>Gt)break i;for(var ae=ee?Kt:0;0<ie--;)Yt[Ht++]=ae;}}Jt=1;break i}Jt||(Wt.a=3),Dt=Jt;}(Dt=Dt&&!Ot.h)&&(jt=h(Ft,Ct,8,kt,xt)),Dt&&0!=jt?Ut=jt:(St.a=3,Ut=0);}if(0==Ut)break r;if(Nt&&1==Kn[V]&&(Nt=0==gt[G].g),wt+=gt[G].g,G+=Ut,3>=V){var oe,se=pt[0];for(oe=1;oe<ut;++oe)pt[oe]>se&&(se=pt[oe]);Lt+=se;}}if(mt.nd=Nt,mt.Qb=0,Nt&&(mt.qb=(vt[3][bt[3]+0].value<<24|vt[1][bt[1]+0].value<<16|vt[2][bt[2]+0].value)>>>0,0==wt&&256>vt[0][bt[0]+0].value&&(mt.Qb=1,mt.qb+=vt[0][bt[0]+0].value<<8)),mt.jc=!mt.Qb&&6>Lt,mt.jc){var ce,ue=mt;for(ce=0;ce<Dr;++ce){var he=ce,le=ue.pd[he],fe=ue.G[0][ue.H[0]+he];256<=fe.value?(le.g=fe.g+256,le.value=fe.value):(le.g=0,le.value=0,he>>=yt(fe,8,le),he>>=yt(ue.G[1][ue.H[1]+he],16,le),he>>=yt(ue.G[2][ue.H[2]+he],0,le),yt(ue.G[3][ue.H[3]+he],24,le));}}}Q.vc=tt,Q.Wb=et,Q.Ya=dt,Q.yc=ht,H=1;break e}H=0;}if(!(u=H)){s.a=3;break t}if(0<b){if(m.ua=1<<b,!O(m.Wa,b)){s.a=1,u=0;break t}}else m.ua=0;var de=s,pe=f,ge=p,me=de.s,ve=me.xc;if(de.c=pe,de.i=ge,me.md=q(pe,ve),me.wc=0==ve?-1:(1<<ve)-1,n){s.xb=pi;break t}if(null==(v=a(f*p))){s.a=1,u=0;break t}u=(u=_t(s,v,0,f,p,p,null))&&!g.h;break t}return u?(null!=c?c[0]=v:(e(null==v),e(n)),s.$=0,n||Pt(m)):Pt(m),u}function Ft(t,r){var n=t.c*t.i,i=n+r+16*r;return e(t.c<=r),t.V=a(i),null==t.V?(t.Ta=null,t.Ua=0,t.a=1,0):(t.Ta=t.V,t.Ua=t.Ba+n+r,1)}function Ct(t,r){var n=t.C,i=r-n,a=t.V,o=t.Ba+t.c*n;for(e(r<=t.l.o);0<i;){var s=16<i?16:i,c=t.l.ma,u=t.l.width,h=u*s,l=c.ca,f=c.tb+u*n,d=t.Ta,p=t.Ua;Nt(t,s,a,o),_n(d,p,l,f,h),xt(c,n,n+s,l,f,u),i-=s,a+=s*t.c,n+=s;}e(n==r),t.C=t.Ma=r;}function jt(){this.ub=this.yd=this.td=this.Rb=0;}function Ot(){this.Kd=this.Ld=this.Ud=this.Td=this.i=this.c=0;}function Bt(){this.Fb=this.Bb=this.Cb=0,this.Zb=a(4),this.Lb=a(4);}function Mt(){this.Yb=function(){var t=[];return function t(e,r,n){for(var i=n[r],a=0;a<i&&(e.push(n.length>r+1?[]:0),!(n.length<r+1));a++)t(e[a],r+1,n);}(t,0,[3,11]),t}();}function Et(){this.jb=a(3),this.Wc=s([4,8],Mt),this.Xc=s([4,17],Mt);}function qt(){this.Pc=this.wb=this.Tb=this.zd=0,this.vd=new a(4),this.od=new a(4);}function Dt(){this.ld=this.La=this.dd=this.tc=0;}function Rt(){this.Na=this.la=0;}function Tt(){this.Sc=[0,0],this.Eb=[0,0],this.Qc=[0,0],this.ia=this.lc=0;}function Ut(){this.ad=a(384),this.Za=0,this.Ob=a(16),this.$b=this.Ad=this.ia=this.Gc=this.Hc=this.Dd=0;}function zt(){this.uc=this.M=this.Nb=0,this.wa=Array(new Dt),this.Y=0,this.ya=Array(new Ut),this.aa=0,this.l=new Gt;}function Ht(){this.y=a(16),this.f=a(8),this.ea=a(8);}function Wt(){this.cb=this.a=0,this.sc="",this.m=new w,this.Od=new jt,this.Kc=new Ot,this.ed=new qt,this.Qa=new Bt,this.Ic=this.$c=this.Aa=0,this.D=new zt,this.Xb=this.Va=this.Hb=this.zb=this.yb=this.Ub=this.za=0,this.Jc=o(8,w),this.ia=0,this.pb=o(4,Tt),this.Pa=new Et,this.Bd=this.kc=0,this.Ac=[],this.Bc=0,this.zc=[0,0,0,0],this.Gd=Array(new Ht),this.Hd=0,this.rb=Array(new Rt),this.sb=0,this.wa=Array(new Dt),this.Y=0,this.oc=[],this.pc=0,this.sa=[],this.ta=0,this.qa=[],this.ra=0,this.Ha=[],this.B=this.R=this.Ia=0,this.Ec=[],this.M=this.ja=this.Vb=this.Fc=0,this.ya=Array(new Ut),this.L=this.aa=0,this.gd=s([4,2],Dt),this.ga=null,this.Fa=[],this.Cc=this.qc=this.P=0,this.Gb=[],this.Uc=0,this.mb=[],this.nb=0,this.rc=[],this.Ga=this.Vc=0;}function Vt(t,e){return 0>t?0:t>e?e:t}function Gt(){this.T=this.U=this.ka=this.height=this.width=0,this.y=[],this.f=[],this.ea=[],this.Rc=this.fa=this.W=this.N=this.O=0,this.ma="void",this.put="VP8IoPutHook",this.ac="VP8IoSetupHook",this.bc="VP8IoTeardownHook",this.ha=this.Kb=0,this.data=[],this.hb=this.ib=this.da=this.o=this.j=this.va=this.v=this.Da=this.ob=this.w=0,this.F=[],this.J=0;}function Yt(){var t=new Wt;return null!=t&&(t.a=0,t.sc="OK",t.cb=0,t.Xb=0,ni||(ni=Zt)),t}function Jt(t,e,r){return 0==t.a&&(t.a=e,t.sc=r,t.cb=0),0}function Xt(t,e,r){return 3<=r&&157==t[e+0]&&1==t[e+1]&&42==t[e+2]}function Kt(t,r){if(null==t)return 0;if(t.a=0,t.sc="OK",null==r)return Jt(t,2,"null VP8Io passed to VP8GetHeaders()");var n=r.data,a=r.w,o=r.ha;if(4>o)return Jt(t,7,"Truncated header.");var s=n[a+0]|n[a+1]<<8|n[a+2]<<16,c=t.Od;if(c.Rb=!(1&s),c.td=s>>1&7,c.yd=s>>4&1,c.ub=s>>5,3<c.td)return Jt(t,3,"Incorrect keyframe parameters.");if(!c.yd)return Jt(t,4,"Frame not displayable.");a+=3,o-=3;var u=t.Kc;if(c.Rb){if(7>o)return Jt(t,7,"cannot parse picture header");if(!Xt(n,a,o))return Jt(t,3,"Bad code word");u.c=16383&(n[a+4]<<8|n[a+3]),u.Td=n[a+4]>>6,u.i=16383&(n[a+6]<<8|n[a+5]),u.Ud=n[a+6]>>6,a+=7,o-=7,t.za=u.c+15>>4,t.Ub=u.i+15>>4,r.width=u.c,r.height=u.i,r.Da=0,r.j=0,r.v=0,r.va=r.width,r.o=r.height,r.da=0,r.ib=r.width,r.hb=r.height,r.U=r.width,r.T=r.height,i((s=t.Pa).jb,0,255,s.jb.length),e(null!=(s=t.Qa)),s.Cb=0,s.Bb=0,s.Fb=1,i(s.Zb,0,0,s.Zb.length),i(s.Lb,0,0,s.Lb);}if(c.ub>o)return Jt(t,7,"bad partition length");p(s=t.m,n,a,c.ub),a+=c.ub,o-=c.ub,c.Rb&&(u.Ld=P(s),u.Kd=P(s)),u=t.Qa;var h,l=t.Pa;if(e(null!=s),e(null!=u),u.Cb=P(s),u.Cb){if(u.Bb=P(s),P(s)){for(u.Fb=P(s),h=0;4>h;++h)u.Zb[h]=P(s)?m(s,7):0;for(h=0;4>h;++h)u.Lb[h]=P(s)?m(s,6):0;}if(u.Bb)for(h=0;3>h;++h)l.jb[h]=P(s)?g(s,8):255;}else u.Bb=0;if(s.Ka)return Jt(t,3,"cannot parse segment header");if((u=t.ed).zd=P(s),u.Tb=g(s,6),u.wb=g(s,3),u.Pc=P(s),u.Pc&&P(s)){for(l=0;4>l;++l)P(s)&&(u.vd[l]=m(s,6));for(l=0;4>l;++l)P(s)&&(u.od[l]=m(s,6));}if(t.L=0==u.Tb?0:u.zd?1:2,s.Ka)return Jt(t,3,"cannot parse filter header");var f=o;if(o=h=a,a=h+f,u=f,t.Xb=(1<<g(t.m,2))-1,f<3*(l=t.Xb))n=7;else {for(h+=3*l,u-=3*l,f=0;f<l;++f){var d=n[o+0]|n[o+1]<<8|n[o+2]<<16;d>u&&(d=u),p(t.Jc[+f],n,h,d),h+=d,u-=d,o+=3;}p(t.Jc[+l],n,h,u),n=h<a?0:5;}if(0!=n)return Jt(t,n,"cannot parse partitions");for(n=g(h=t.m,7),o=P(h)?m(h,4):0,a=P(h)?m(h,4):0,u=P(h)?m(h,4):0,l=P(h)?m(h,4):0,h=P(h)?m(h,4):0,f=t.Qa,d=0;4>d;++d){if(f.Cb){var v=f.Zb[d];f.Fb||(v+=n);}else {if(0<d){t.pb[d]=t.pb[0];continue}v=n;}var b=t.pb[d];b.Sc[0]=ei[Vt(v+o,127)],b.Sc[1]=ri[Vt(v+0,127)],b.Eb[0]=2*ei[Vt(v+a,127)],b.Eb[1]=101581*ri[Vt(v+u,127)]>>16,8>b.Eb[1]&&(b.Eb[1]=8),b.Qc[0]=ei[Vt(v+l,117)],b.Qc[1]=ri[Vt(v+h,127)],b.lc=v+h;}if(!c.Rb)return Jt(t,4,"Not a key frame.");for(P(s),c=t.Pa,n=0;4>n;++n){for(o=0;8>o;++o)for(a=0;3>a;++a)for(u=0;11>u;++u)l=k(s,ui[n][o][a][u])?g(s,8):si[n][o][a][u],c.Wc[n][o].Yb[a][u]=l;for(o=0;17>o;++o)c.Xc[n][o]=c.Wc[n][hi[o]];}return t.kc=P(s),t.kc&&(t.Bd=g(s,8)),t.cb=1}function Zt(t,e,r,n,i,a,o){var s=e[i].Yb[r];for(r=0;16>i;++i){if(!k(t,s[r+0]))return i;for(;!k(t,s[r+1]);)if(s=e[++i].Yb[0],r=0,16==i)return 16;var c=e[i+1].Yb;if(k(t,s[r+2])){var u=t,h=0;if(k(u,(f=s)[(l=r)+3]))if(k(u,f[l+6])){for(s=0,l=2*(h=k(u,f[l+8]))+(f=k(u,f[l+9+h])),h=0,f=ii[l];f[s];++s)h+=h+k(u,f[s]);h+=3+(8<<l);}else k(u,f[l+7])?(h=7+2*k(u,165),h+=k(u,145)):h=5+k(u,159);else h=k(u,f[l+4])?3+k(u,f[l+5]):2;s=c[2];}else h=1,s=c[1];c=o+ai[i],0>(u=t).b&&_(u);var l,f=u.b,d=(l=u.Ca>>1)-(u.I>>f)>>31;--u.b,u.Ca+=d,u.Ca|=1,u.I-=(l+1&d)<<f,a[c]=((h^d)-d)*n[(0<i)+0];}return 16}function $t(t){var e=t.rb[t.sb-1];e.la=0,e.Na=0,i(t.zc,0,0,t.zc.length),t.ja=0;}function Qt(t,r){if(null==t)return 0;if(null==r)return Jt(t,2,"NULL VP8Io parameter in VP8Decode().");if(!t.cb&&!Kt(t,r))return 0;if(e(t.cb),null==r.ac||r.ac(r)){r.ob&&(t.L=0);var s=Ri[t.L];if(2==t.L?(t.yb=0,t.zb=0):(t.yb=r.v-s>>4,t.zb=r.j-s>>4,0>t.yb&&(t.yb=0),0>t.zb&&(t.zb=0)),t.Va=r.o+15+s>>4,t.Hb=r.va+15+s>>4,t.Hb>t.za&&(t.Hb=t.za),t.Va>t.Ub&&(t.Va=t.Ub),0<t.L){var c=t.ed;for(s=0;4>s;++s){var u;if(t.Qa.Cb){var h=t.Qa.Lb[s];t.Qa.Fb||(h+=c.Tb);}else h=c.Tb;for(u=0;1>=u;++u){var l=t.gd[s][u],f=h;if(c.Pc&&(f+=c.vd[0],u&&(f+=c.od[0])),0<(f=0>f?0:63<f?63:f)){var d=f;0<c.wb&&((d=4<c.wb?d>>2:d>>1)>9-c.wb&&(d=9-c.wb)),1>d&&(d=1),l.dd=d,l.tc=2*f+d,l.ld=40<=f?2:15<=f?1:0;}else l.tc=0;l.La=u;}}}s=0;}else Jt(t,6,"Frame setup failed"),s=t.a;if(s=0==s){if(s){t.$c=0,0<t.Aa||(t.Ic=Ui);t:{s=t.Ic;c=4*(d=t.za);var p=32*d,g=d+1,m=0<t.L?d*(0<t.Aa?2:1):0,v=(2==t.Aa?2:1)*d;if((l=c+832+(u=3*(16*s+Ri[t.L])/2*p)+(h=null!=t.Fa&&0<t.Fa.length?t.Kc.c*t.Kc.i:0))!=l)s=0;else {if(l>t.Vb){if(t.Vb=0,t.Ec=a(l),t.Fc=0,null==t.Ec){s=Jt(t,1,"no memory during frame initialization.");break t}t.Vb=l;}l=t.Ec,f=t.Fc,t.Ac=l,t.Bc=f,f+=c,t.Gd=o(p,Ht),t.Hd=0,t.rb=o(g+1,Rt),t.sb=1,t.wa=m?o(m,Dt):null,t.Y=0,t.D.Nb=0,t.D.wa=t.wa,t.D.Y=t.Y,0<t.Aa&&(t.D.Y+=d),e(!0),t.oc=l,t.pc=f,f+=832,t.ya=o(v,Ut),t.aa=0,t.D.ya=t.ya,t.D.aa=t.aa,2==t.Aa&&(t.D.aa+=d),t.R=16*d,t.B=8*d,d=(p=Ri[t.L])*t.R,p=p/2*t.B,t.sa=l,t.ta=f+d,t.qa=t.sa,t.ra=t.ta+16*s*t.R+p,t.Ha=t.qa,t.Ia=t.ra+8*s*t.B+p,t.$c=0,f+=u,t.mb=h?l:null,t.nb=h?f:null,e(f+h<=t.Fc+t.Vb),$t(t),i(t.Ac,t.Bc,0,c),s=1;}}if(s){if(r.ka=0,r.y=t.sa,r.O=t.ta,r.f=t.qa,r.N=t.ra,r.ea=t.Ha,r.Vd=t.Ia,r.fa=t.R,r.Rc=t.B,r.F=null,r.J=0,!Cn){for(s=-255;255>=s;++s)Pn[255+s]=0>s?-s:s;for(s=-1020;1020>=s;++s)kn[1020+s]=-128>s?-128:127<s?127:s;for(s=-112;112>=s;++s)In[112+s]=-16>s?-16:15<s?15:s;for(s=-255;510>=s;++s)Fn[255+s]=0>s?0:255<s?255:s;Cn=1;}an=ue,on=ae,cn=oe,un=se,hn=ce,sn=ie,ln=Je,fn=Xe,dn=$e,pn=Qe,gn=Ke,mn=Ze,vn=tr,bn=er,yn=ze,wn=He,Nn=We,Ln=Ve,fi[0]=xe,fi[1]=le,fi[2]=Le,fi[3]=Ae,fi[4]=Se,fi[5]=Pe,fi[6]=_e,fi[7]=ke,fi[8]=Fe,fi[9]=Ie,li[0]=ve,li[1]=de,li[2]=pe,li[3]=ge,li[4]=be,li[5]=ye,li[6]=we,di[0]=Be,di[1]=fe,di[2]=Ce,di[3]=je,di[4]=Ee,di[5]=Me,di[6]=qe,s=1;}else s=0;}s&&(s=function(t,r){for(t.M=0;t.M<t.Va;++t.M){var o,s=t.Jc[t.M&t.Xb],c=t.m,u=t;for(o=0;o<u.za;++o){var h=c,l=u,f=l.Ac,d=l.Bc+4*o,p=l.zc,g=l.ya[l.aa+o];if(l.Qa.Bb?g.$b=k(h,l.Pa.jb[0])?2+k(h,l.Pa.jb[2]):k(h,l.Pa.jb[1]):g.$b=0,l.kc&&(g.Ad=k(h,l.Bd)),g.Za=!k(h,145)+0,g.Za){var m=g.Ob,v=0;for(l=0;4>l;++l){var b,y=p[0+l];for(b=0;4>b;++b){y=ci[f[d+b]][y];for(var w=oi[k(h,y[0])];0<w;)w=oi[2*w+k(h,y[w])];y=-w,f[d+b]=y;}n(m,v,f,d,4),v+=4,p[0+l]=y;}}else y=k(h,156)?k(h,128)?1:3:k(h,163)?2:0,g.Ob[0]=y,i(f,d,y,4),i(p,0,y,4);g.Dd=k(h,142)?k(h,114)?k(h,183)?1:3:2:0;}if(u.m.Ka)return Jt(t,7,"Premature end-of-partition0 encountered.");for(;t.ja<t.za;++t.ja){if(u=s,h=(c=t).rb[c.sb-1],f=c.rb[c.sb+c.ja],o=c.ya[c.aa+c.ja],d=c.kc?o.Ad:0)h.la=f.la=0,o.Za||(h.Na=f.Na=0),o.Hc=0,o.Gc=0,o.ia=0;else {var N,L;h=f,f=u,d=c.Pa.Xc,p=c.ya[c.aa+c.ja],g=c.pb[p.$b];if(l=p.ad,m=0,v=c.rb[c.sb-1],y=b=0,i(l,m,0,384),p.Za)var A=0,x=d[3];else {w=a(16);var S=h.Na+v.Na;if(S=ni(f,d[1],S,g.Eb,0,w,0),h.Na=v.Na=(0<S)+0,1<S)an(w,0,l,m);else {var _=w[0]+3>>3;for(w=0;256>w;w+=16)l[m+w]=_;}A=1,x=d[0];}var P=15&h.la,I=15&v.la;for(w=0;4>w;++w){var F=1&I;for(_=L=0;4>_;++_)P=P>>1|(F=(S=ni(f,x,S=F+(1&P),g.Sc,A,l,m))>A)<<7,L=L<<2|(3<S?3:1<S?2:0!=l[m+0]),m+=16;P>>=4,I=I>>1|F<<7,b=(b<<8|L)>>>0;}for(x=P,A=I>>4,N=0;4>N;N+=2){for(L=0,P=h.la>>4+N,I=v.la>>4+N,w=0;2>w;++w){for(F=1&I,_=0;2>_;++_)S=F+(1&P),P=P>>1|(F=0<(S=ni(f,d[2],S,g.Qc,0,l,m)))<<3,L=L<<2|(3<S?3:1<S?2:0!=l[m+0]),m+=16;P>>=2,I=I>>1|F<<5;}y|=L<<4*N,x|=P<<4<<N,A|=(240&I)<<N;}h.la=x,v.la=A,p.Hc=b,p.Gc=y,p.ia=43690&y?0:g.ia,d=!(b|y);}if(0<c.L&&(c.wa[c.Y+c.ja]=c.gd[o.$b][o.Za],c.wa[c.Y+c.ja].La|=!d),u.Ka)return Jt(t,7,"Premature end-of-file encountered.")}if($t(t),c=r,u=1,o=(s=t).D,h=0<s.L&&s.M>=s.zb&&s.M<=s.Va,0==s.Aa)t:{if(o.M=s.M,o.uc=h,Or(s,o),u=1,o=(L=s.D).Nb,h=(y=Ri[s.L])*s.R,f=y/2*s.B,w=16*o*s.R,_=8*o*s.B,d=s.sa,p=s.ta-h+w,g=s.qa,l=s.ra-f+_,m=s.Ha,v=s.Ia-f+_,I=0==(P=L.M),b=P>=s.Va-1,2==s.Aa&&Or(s,L),L.uc)for(F=(S=s).D.M,e(S.D.uc),L=S.yb;L<S.Hb;++L){A=L,x=F;var C=(j=(U=S).D).Nb;N=U.R;var j=j.wa[j.Y+A],O=U.sa,B=U.ta+16*C*N+16*A,M=j.dd,E=j.tc;if(0!=E)if(e(3<=E),1==U.L)0<A&&wn(O,B,N,E+4),j.La&&Ln(O,B,N,E),0<x&&yn(O,B,N,E+4),j.La&&Nn(O,B,N,E);else {var q=U.B,D=U.qa,R=U.ra+8*C*q+8*A,T=U.Ha,U=U.Ia+8*C*q+8*A;C=j.ld;0<A&&(fn(O,B,N,E+4,M,C),pn(D,R,T,U,q,E+4,M,C)),j.La&&(mn(O,B,N,E,M,C),bn(D,R,T,U,q,E,M,C)),0<x&&(ln(O,B,N,E+4,M,C),dn(D,R,T,U,q,E+4,M,C)),j.La&&(gn(O,B,N,E,M,C),vn(D,R,T,U,q,E,M,C));}}if(s.ia&&alert("todo:DitherRow"),null!=c.put){if(L=16*P,P=16*(P+1),I?(c.y=s.sa,c.O=s.ta+w,c.f=s.qa,c.N=s.ra+_,c.ea=s.Ha,c.W=s.Ia+_):(L-=y,c.y=d,c.O=p,c.f=g,c.N=l,c.ea=m,c.W=v),b||(P-=y),P>c.o&&(P=c.o),c.F=null,c.J=null,null!=s.Fa&&0<s.Fa.length&&L<P&&(c.J=lr(s,c,L,P-L),c.F=s.mb,null==c.F&&0==c.F.length)){u=Jt(s,3,"Could not decode alpha data.");break t}L<c.j&&(y=c.j-L,L=c.j,e(!(1&y)),c.O+=s.R*y,c.N+=s.B*(y>>1),c.W+=s.B*(y>>1),null!=c.F&&(c.J+=c.width*y)),L<P&&(c.O+=c.v,c.N+=c.v>>1,c.W+=c.v>>1,null!=c.F&&(c.J+=c.v),c.ka=L-c.j,c.U=c.va-c.v,c.T=P-L,u=c.put(c));}o+1!=s.Ic||b||(n(s.sa,s.ta-h,d,p+16*s.R,h),n(s.qa,s.ra-f,g,l+8*s.B,f),n(s.Ha,s.Ia-f,m,v+8*s.B,f));}if(!u)return Jt(t,6,"Output aborted.")}return 1}(t,r)),null!=r.bc&&r.bc(r),s&=1;}return s?(t.cb=0,s):0}function te(t,e,r,n,i){i=t[e+r+32*n]+(i>>3),t[e+r+32*n]=-256&i?0>i?0:255:i;}function ee(t,e,r,n,i,a){te(t,e,0,r,n+i),te(t,e,1,r,n+a),te(t,e,2,r,n-a),te(t,e,3,r,n-i);}function re(t){return (20091*t>>16)+t}function ne(t,e,r,n){var i,o=0,s=a(16);for(i=0;4>i;++i){var c=t[e+0]+t[e+8],u=t[e+0]-t[e+8],h=(35468*t[e+4]>>16)-re(t[e+12]),l=re(t[e+4])+(35468*t[e+12]>>16);s[o+0]=c+l,s[o+1]=u+h,s[o+2]=u-h,s[o+3]=c-l,o+=4,e++;}for(i=o=0;4>i;++i)c=(t=s[o+0]+4)+s[o+8],u=t-s[o+8],h=(35468*s[o+4]>>16)-re(s[o+12]),te(r,n,0,0,c+(l=re(s[o+4])+(35468*s[o+12]>>16))),te(r,n,1,0,u+h),te(r,n,2,0,u-h),te(r,n,3,0,c-l),o++,n+=32;}function ie(t,e,r,n){var i=t[e+0]+4,a=35468*t[e+4]>>16,o=re(t[e+4]),s=35468*t[e+1]>>16;ee(r,n,0,i+o,t=re(t[e+1]),s),ee(r,n,1,i+a,t,s),ee(r,n,2,i-a,t,s),ee(r,n,3,i-o,t,s);}function ae(t,e,r,n,i){ne(t,e,r,n),i&&ne(t,e+16,r,n+4);}function oe(t,e,r,n){on(t,e+0,r,n,1),on(t,e+32,r,n+128,1);}function se(t,e,r,n){var i;for(t=t[e+0]+4,i=0;4>i;++i)for(e=0;4>e;++e)te(r,n,e,i,t);}function ce(t,e,r,n){t[e+0]&&un(t,e+0,r,n),t[e+16]&&un(t,e+16,r,n+4),t[e+32]&&un(t,e+32,r,n+128),t[e+48]&&un(t,e+48,r,n+128+4);}function ue(t,e,r,n){var i,o=a(16);for(i=0;4>i;++i){var s=t[e+0+i]+t[e+12+i],c=t[e+4+i]+t[e+8+i],u=t[e+4+i]-t[e+8+i],h=t[e+0+i]-t[e+12+i];o[0+i]=s+c,o[8+i]=s-c,o[4+i]=h+u,o[12+i]=h-u;}for(i=0;4>i;++i)s=(t=o[0+4*i]+3)+o[3+4*i],c=o[1+4*i]+o[2+4*i],u=o[1+4*i]-o[2+4*i],h=t-o[3+4*i],r[n+0]=s+c>>3,r[n+16]=h+u>>3,r[n+32]=s-c>>3,r[n+48]=h-u>>3,n+=64;}function he(t,e,r){var n,i=e-32,a=Bn,o=255-t[i-1];for(n=0;n<r;++n){var s,c=a,u=o+t[e-1];for(s=0;s<r;++s)t[e+s]=c[u+t[i+s]];e+=32;}}function le(t,e){he(t,e,4);}function fe(t,e){he(t,e,8);}function de(t,e){he(t,e,16);}function pe(t,e){var r;for(r=0;16>r;++r)n(t,e+32*r,t,e-32,16);}function ge(t,e){var r;for(r=16;0<r;--r)i(t,e,t[e-1],16),e+=32;}function me(t,e,r){var n;for(n=0;16>n;++n)i(e,r+32*n,t,16);}function ve(t,e){var r,n=16;for(r=0;16>r;++r)n+=t[e-1+32*r]+t[e+r-32];me(n>>5,t,e);}function be(t,e){var r,n=8;for(r=0;16>r;++r)n+=t[e-1+32*r];me(n>>4,t,e);}function ye(t,e){var r,n=8;for(r=0;16>r;++r)n+=t[e+r-32];me(n>>4,t,e);}function we(t,e){me(128,t,e);}function Ne(t,e,r){return t+2*e+r+2>>2}function Le(t,e){var r,i=e-32;i=new Uint8Array([Ne(t[i-1],t[i+0],t[i+1]),Ne(t[i+0],t[i+1],t[i+2]),Ne(t[i+1],t[i+2],t[i+3]),Ne(t[i+2],t[i+3],t[i+4])]);for(r=0;4>r;++r)n(t,e+32*r,i,0,i.length);}function Ae(t,e){var r=t[e-1],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96];I(t,e+0,16843009*Ne(t[e-1-32],r,n)),I(t,e+32,16843009*Ne(r,n,i)),I(t,e+64,16843009*Ne(n,i,a)),I(t,e+96,16843009*Ne(i,a,a));}function xe(t,e){var r,n=4;for(r=0;4>r;++r)n+=t[e+r-32]+t[e-1+32*r];for(n>>=3,r=0;4>r;++r)i(t,e+32*r,n,4);}function Se(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1-32],o=t[e+0-32],s=t[e+1-32],c=t[e+2-32],u=t[e+3-32];t[e+0+96]=Ne(n,i,t[e-1+96]),t[e+1+96]=t[e+0+64]=Ne(r,n,i),t[e+2+96]=t[e+1+64]=t[e+0+32]=Ne(a,r,n),t[e+3+96]=t[e+2+64]=t[e+1+32]=t[e+0+0]=Ne(o,a,r),t[e+3+64]=t[e+2+32]=t[e+1+0]=Ne(s,o,a),t[e+3+32]=t[e+2+0]=Ne(c,s,o),t[e+3+0]=Ne(u,c,s);}function _e(t,e){var r=t[e+1-32],n=t[e+2-32],i=t[e+3-32],a=t[e+4-32],o=t[e+5-32],s=t[e+6-32],c=t[e+7-32];t[e+0+0]=Ne(t[e+0-32],r,n),t[e+1+0]=t[e+0+32]=Ne(r,n,i),t[e+2+0]=t[e+1+32]=t[e+0+64]=Ne(n,i,a),t[e+3+0]=t[e+2+32]=t[e+1+64]=t[e+0+96]=Ne(i,a,o),t[e+3+32]=t[e+2+64]=t[e+1+96]=Ne(a,o,s),t[e+3+64]=t[e+2+96]=Ne(o,s,c),t[e+3+96]=Ne(s,c,c);}function Pe(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1-32],o=t[e+0-32],s=t[e+1-32],c=t[e+2-32],u=t[e+3-32];t[e+0+0]=t[e+1+64]=a+o+1>>1,t[e+1+0]=t[e+2+64]=o+s+1>>1,t[e+2+0]=t[e+3+64]=s+c+1>>1,t[e+3+0]=c+u+1>>1,t[e+0+96]=Ne(i,n,r),t[e+0+64]=Ne(n,r,a),t[e+0+32]=t[e+1+96]=Ne(r,a,o),t[e+1+32]=t[e+2+96]=Ne(a,o,s),t[e+2+32]=t[e+3+96]=Ne(o,s,c),t[e+3+32]=Ne(s,c,u);}function ke(t,e){var r=t[e+0-32],n=t[e+1-32],i=t[e+2-32],a=t[e+3-32],o=t[e+4-32],s=t[e+5-32],c=t[e+6-32],u=t[e+7-32];t[e+0+0]=r+n+1>>1,t[e+1+0]=t[e+0+64]=n+i+1>>1,t[e+2+0]=t[e+1+64]=i+a+1>>1,t[e+3+0]=t[e+2+64]=a+o+1>>1,t[e+0+32]=Ne(r,n,i),t[e+1+32]=t[e+0+96]=Ne(n,i,a),t[e+2+32]=t[e+1+96]=Ne(i,a,o),t[e+3+32]=t[e+2+96]=Ne(a,o,s),t[e+3+64]=Ne(o,s,c),t[e+3+96]=Ne(s,c,u);}function Ie(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96];t[e+0+0]=r+n+1>>1,t[e+2+0]=t[e+0+32]=n+i+1>>1,t[e+2+32]=t[e+0+64]=i+a+1>>1,t[e+1+0]=Ne(r,n,i),t[e+3+0]=t[e+1+32]=Ne(n,i,a),t[e+3+32]=t[e+1+64]=Ne(i,a,a),t[e+3+64]=t[e+2+64]=t[e+0+96]=t[e+1+96]=t[e+2+96]=t[e+3+96]=a;}function Fe(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96],o=t[e-1-32],s=t[e+0-32],c=t[e+1-32],u=t[e+2-32];t[e+0+0]=t[e+2+32]=r+o+1>>1,t[e+0+32]=t[e+2+64]=n+r+1>>1,t[e+0+64]=t[e+2+96]=i+n+1>>1,t[e+0+96]=a+i+1>>1,t[e+3+0]=Ne(s,c,u),t[e+2+0]=Ne(o,s,c),t[e+1+0]=t[e+3+32]=Ne(r,o,s),t[e+1+32]=t[e+3+64]=Ne(n,r,o),t[e+1+64]=t[e+3+96]=Ne(i,n,r),t[e+1+96]=Ne(a,i,n);}function Ce(t,e){var r;for(r=0;8>r;++r)n(t,e+32*r,t,e-32,8);}function je(t,e){var r;for(r=0;8>r;++r)i(t,e,t[e-1],8),e+=32;}function Oe(t,e,r){var n;for(n=0;8>n;++n)i(e,r+32*n,t,8);}function Be(t,e){var r,n=8;for(r=0;8>r;++r)n+=t[e+r-32]+t[e-1+32*r];Oe(n>>4,t,e);}function Me(t,e){var r,n=4;for(r=0;8>r;++r)n+=t[e+r-32];Oe(n>>3,t,e);}function Ee(t,e){var r,n=4;for(r=0;8>r;++r)n+=t[e-1+32*r];Oe(n>>3,t,e);}function qe(t,e){Oe(128,t,e);}function De(t,e,r){var n=t[e-r],i=t[e+0],a=3*(i-n)+jn[1020+t[e-2*r]-t[e+r]],o=On[112+(a+4>>3)];t[e-r]=Bn[255+n+On[112+(a+3>>3)]],t[e+0]=Bn[255+i-o];}function Re(t,e,r,n){var i=t[e+0],a=t[e+r];return Mn[255+t[e-2*r]-t[e-r]]>n||Mn[255+a-i]>n}function Te(t,e,r,n){return 4*Mn[255+t[e-r]-t[e+0]]+Mn[255+t[e-2*r]-t[e+r]]<=n}function Ue(t,e,r,n,i){var a=t[e-3*r],o=t[e-2*r],s=t[e-r],c=t[e+0],u=t[e+r],h=t[e+2*r],l=t[e+3*r];return 4*Mn[255+s-c]+Mn[255+o-u]>n?0:Mn[255+t[e-4*r]-a]<=i&&Mn[255+a-o]<=i&&Mn[255+o-s]<=i&&Mn[255+l-h]<=i&&Mn[255+h-u]<=i&&Mn[255+u-c]<=i}function ze(t,e,r,n){var i=2*n+1;for(n=0;16>n;++n)Te(t,e+n,r,i)&&De(t,e+n,r);}function He(t,e,r,n){var i=2*n+1;for(n=0;16>n;++n)Te(t,e+n*r,1,i)&&De(t,e+n*r,1);}function We(t,e,r,n){var i;for(i=3;0<i;--i)ze(t,e+=4*r,r,n);}function Ve(t,e,r,n){var i;for(i=3;0<i;--i)He(t,e+=4,r,n);}function Ge(t,e,r,n,i,a,o,s){for(a=2*a+1;0<i--;){if(Ue(t,e,r,a,o))if(Re(t,e,r,s))De(t,e,r);else {var c=t,u=e,h=r,l=c[u-2*h],f=c[u-h],d=c[u+0],p=c[u+h],g=c[u+2*h],m=27*(b=jn[1020+3*(d-f)+jn[1020+l-p]])+63>>7,v=18*b+63>>7,b=9*b+63>>7;c[u-3*h]=Bn[255+c[u-3*h]+b],c[u-2*h]=Bn[255+l+v],c[u-h]=Bn[255+f+m],c[u+0]=Bn[255+d-m],c[u+h]=Bn[255+p-v],c[u+2*h]=Bn[255+g-b];}e+=n;}}function Ye(t,e,r,n,i,a,o,s){for(a=2*a+1;0<i--;){if(Ue(t,e,r,a,o))if(Re(t,e,r,s))De(t,e,r);else {var c=t,u=e,h=r,l=c[u-h],f=c[u+0],d=c[u+h],p=On[112+((g=3*(f-l))+4>>3)],g=On[112+(g+3>>3)],m=p+1>>1;c[u-2*h]=Bn[255+c[u-2*h]+m],c[u-h]=Bn[255+l+g],c[u+0]=Bn[255+f-p],c[u+h]=Bn[255+d-m];}e+=n;}}function Je(t,e,r,n,i,a){Ge(t,e,r,1,16,n,i,a);}function Xe(t,e,r,n,i,a){Ge(t,e,1,r,16,n,i,a);}function Ke(t,e,r,n,i,a){var o;for(o=3;0<o;--o)Ye(t,e+=4*r,r,1,16,n,i,a);}function Ze(t,e,r,n,i,a){var o;for(o=3;0<o;--o)Ye(t,e+=4,1,r,16,n,i,a);}function $e(t,e,r,n,i,a,o,s){Ge(t,e,i,1,8,a,o,s),Ge(r,n,i,1,8,a,o,s);}function Qe(t,e,r,n,i,a,o,s){Ge(t,e,1,i,8,a,o,s),Ge(r,n,1,i,8,a,o,s);}function tr(t,e,r,n,i,a,o,s){Ye(t,e+4*i,i,1,8,a,o,s),Ye(r,n+4*i,i,1,8,a,o,s);}function er(t,e,r,n,i,a,o,s){Ye(t,e+4,1,i,8,a,o,s),Ye(r,n+4,1,i,8,a,o,s);}function rr(){this.ba=new ot,this.ec=[],this.cc=[],this.Mc=[],this.Dc=this.Nc=this.dc=this.fc=0,this.Oa=new ct,this.memory=0,this.Ib="OutputFunc",this.Jb="OutputAlphaFunc",this.Nd="OutputRowFunc";}function nr(){this.data=[],this.offset=this.kd=this.ha=this.w=0,this.na=[],this.xa=this.gb=this.Ja=this.Sa=this.P=0;}function ir(){this.nc=this.Ea=this.b=this.hc=0,this.K=[],this.w=0;}function ar(){this.ua=0,this.Wa=new M,this.vb=new M,this.md=this.xc=this.wc=0,this.vc=[],this.Wb=0,this.Ya=new d,this.yc=new l;}function or(){this.xb=this.a=0,this.l=new Gt,this.ca=new ot,this.V=[],this.Ba=0,this.Ta=[],this.Ua=0,this.m=new N,this.Pb=0,this.wd=new N,this.Ma=this.$=this.C=this.i=this.c=this.xd=0,this.s=new ar,this.ab=0,this.gc=o(4,ir),this.Oc=0;}function sr(){this.Lc=this.Z=this.$a=this.i=this.c=0,this.l=new Gt,this.ic=0,this.ca=[],this.tb=0,this.qd=null,this.rd=0;}function cr(t,e,r,n,i,a,o){for(t=null==t?0:t[e+0],e=0;e<o;++e)i[a+e]=t+r[n+e]&255,t=i[a+e];}function ur(t,e,r,n,i,a,o){var s;if(null==t)cr(null,null,r,n,i,a,o);else for(s=0;s<o;++s)i[a+s]=t[e+s]+r[n+s]&255;}function hr(t,e,r,n,i,a,o){if(null==t)cr(null,null,r,n,i,a,o);else {var s,c=t[e+0],u=c,h=c;for(s=0;s<o;++s)u=h+(c=t[e+s])-u,h=r[n+s]+(-256&u?0>u?0:255:u)&255,u=c,i[a+s]=h;}}function lr(t,r,i,o){var s=r.width,c=r.o;if(e(null!=t&&null!=r),0>i||0>=o||i+o>c)return null;if(!t.Cc){if(null==t.ga){var u;if(t.ga=new sr,(u=null==t.ga)||(u=r.width*r.o,e(0==t.Gb.length),t.Gb=a(u),t.Uc=0,null==t.Gb?u=0:(t.mb=t.Gb,t.nb=t.Uc,t.rc=null,u=1),u=!u),!u){u=t.ga;var h=t.Fa,l=t.P,f=t.qc,d=t.mb,p=t.nb,g=l+1,m=f-1,b=u.l;if(e(null!=h&&null!=d&&null!=r),mi[0]=null,mi[1]=cr,mi[2]=ur,mi[3]=hr,u.ca=d,u.tb=p,u.c=r.width,u.i=r.height,e(0<u.c&&0<u.i),1>=f)r=0;else if(u.$a=h[l+0]>>0&3,u.Z=h[l+0]>>2&3,u.Lc=h[l+0]>>4&3,l=h[l+0]>>6&3,0>u.$a||1<u.$a||4<=u.Z||1<u.Lc||l)r=0;else if(b.put=dt,b.ac=ft,b.bc=pt,b.ma=u,b.width=r.width,b.height=r.height,b.Da=r.Da,b.v=r.v,b.va=r.va,b.j=r.j,b.o=r.o,u.$a)t:{e(1==u.$a),r=kt();e:for(;;){if(null==r){r=0;break t}if(e(null!=u),u.mc=r,r.c=u.c,r.i=u.i,r.l=u.l,r.l.ma=u,r.l.width=u.c,r.l.height=u.i,r.a=0,v(r.m,h,g,m),!It(u.c,u.i,1,r,null))break e;if(1==r.ab&&3==r.gc[0].hc&&At(r.s)?(u.ic=1,h=r.c*r.i,r.Ta=null,r.Ua=0,r.V=a(h),r.Ba=0,null==r.V?(r.a=1,r=0):r=1):(u.ic=0,r=Ft(r,u.c)),!r)break e;r=1;break t}u.mc=null,r=0;}else r=m>=u.c*u.i;u=!r;}if(u)return null;1!=t.ga.Lc?t.Ga=0:o=c-i;}e(null!=t.ga),e(i+o<=c);t:{if(r=(h=t.ga).c,c=h.l.o,0==h.$a){if(g=t.rc,m=t.Vc,b=t.Fa,l=t.P+1+i*r,f=t.mb,d=t.nb+i*r,e(l<=t.P+t.qc),0!=h.Z)for(e(null!=mi[h.Z]),u=0;u<o;++u)mi[h.Z](g,m,b,l,f,d,r),g=f,m=d,d+=r,l+=r;else for(u=0;u<o;++u)n(f,d,b,l,r),g=f,m=d,d+=r,l+=r;t.rc=g,t.Vc=m;}else {if(e(null!=h.mc),r=i+o,e(null!=(u=h.mc)),e(r<=u.i),u.C>=r)r=1;else if(h.ic||mr(),h.ic){h=u.V,g=u.Ba,m=u.c;var y=u.i,w=(b=1,l=u.$/m,f=u.$%m,d=u.m,p=u.s,u.$),N=m*y,L=m*r,x=p.wc,_=w<L?wt(p,f,l):null;e(w<=N),e(r<=y),e(At(p));e:for(;;){for(;!d.h&&w<L;){if(f&x||(_=wt(p,f,l)),e(null!=_),S(d),256>(y=bt(_.G[0],_.H[0],d)))h[g+w]=y,++w,++f>=m&&(f=0,++l<=r&&!(l%16)&&St(u,l));else {if(!(280>y)){b=0;break e}y=mt(y-256,d);var P,k=bt(_.G[4],_.H[4],d);if(S(d),!(w>=(k=vt(m,k=mt(k,d)))&&N-w>=y)){b=0;break e}for(P=0;P<y;++P)h[g+w+P]=h[g+w+P-k];for(w+=y,f+=y;f>=m;)f-=m,++l<=r&&!(l%16)&&St(u,l);w<L&&f&x&&(_=wt(p,f,l));}e(d.h==A(d));}St(u,l>r?r:l);break e}!b||d.h&&w<N?(b=0,u.a=d.h?5:3):u.$=w,r=b;}else r=_t(u,u.V,u.Ba,u.c,u.i,r,Ct);if(!r){o=0;break t}}i+o>=c&&(t.Cc=1),o=1;}if(!o)return null;if(t.Cc&&(null!=(o=t.ga)&&(o.mc=null),t.ga=null,0<t.Ga))return alert("todo:WebPDequantizeLevels"),null}return t.nb+i*s}function fr(t,e,r,n,i,a){for(;0<i--;){var o,s=t,c=e+(r?1:0),u=t,h=e+(r?0:3);for(o=0;o<n;++o){var l=u[h+4*o];255!=l&&(l*=32897,s[c+4*o+0]=s[c+4*o+0]*l>>23,s[c+4*o+1]=s[c+4*o+1]*l>>23,s[c+4*o+2]=s[c+4*o+2]*l>>23);}e+=a;}}function dr(t,e,r,n,i){for(;0<n--;){var a;for(a=0;a<r;++a){var o=t[e+2*a+0],s=15&(u=t[e+2*a+1]),c=4369*s,u=(240&u|u>>4)*c>>16;t[e+2*a+0]=(240&o|o>>4)*c>>16&240|(15&o|o<<4)*c>>16>>4&15,t[e+2*a+1]=240&u|s;}e+=i;}}function pr(t,e,r,n,i,a,o,s){var c,u,h=255;for(u=0;u<i;++u){for(c=0;c<n;++c){var l=t[e+c];a[o+4*c]=l,h&=l;}e+=r,o+=s;}return 255!=h}function gr(t,e,r,n,i){var a;for(a=0;a<i;++a)r[n+a]=t[e+a]>>8;}function mr(){An=fr,xn=dr,Sn=pr,_n=gr;}function vr(r,n,i){t[r]=function(t,r,a,o,s,c,u,h,l,f,d,p,g,m,v,b,y){var w,N=y-1>>1,L=s[c+0]|u[h+0]<<16,A=l[f+0]|d[p+0]<<16;e(null!=t);var x=3*L+A+131074>>2;for(n(t[r+0],255&x,x>>16,g,m),null!=a&&(x=3*A+L+131074>>2,n(a[o+0],255&x,x>>16,v,b)),w=1;w<=N;++w){var S=s[c+w]|u[h+w]<<16,_=l[f+w]|d[p+w]<<16,P=L+S+A+_+524296,k=P+2*(S+A)>>3;x=k+L>>1,L=(P=P+2*(L+_)>>3)+S>>1,n(t[r+2*w-1],255&x,x>>16,g,m+(2*w-1)*i),n(t[r+2*w-0],255&L,L>>16,g,m+(2*w-0)*i),null!=a&&(x=P+A>>1,L=k+_>>1,n(a[o+2*w-1],255&x,x>>16,v,b+(2*w-1)*i),n(a[o+2*w+0],255&L,L>>16,v,b+(2*w+0)*i)),L=S,A=_;}1&y||(x=3*L+A+131074>>2,n(t[r+y-1],255&x,x>>16,g,m+(y-1)*i),null!=a&&(x=3*A+L+131074>>2,n(a[o+y-1],255&x,x>>16,v,b+(y-1)*i)));};}function br(){vi[En]=bi,vi[qn]=wi,vi[Dn]=yi,vi[Rn]=Ni,vi[Tn]=Li,vi[Un]=Ai,vi[zn]=xi,vi[Hn]=wi,vi[Wn]=Ni,vi[Vn]=Li,vi[Gn]=Ai;}function yr(t){return t&~Fi?0>t?0:255:t>>Ii}function wr(t,e){return yr((19077*t>>8)+(26149*e>>8)-14234)}function Nr(t,e,r){return yr((19077*t>>8)-(6419*e>>8)-(13320*r>>8)+8708)}function Lr(t,e){return yr((19077*t>>8)+(33050*e>>8)-17685)}function Ar(t,e,r,n,i){n[i+0]=wr(t,r),n[i+1]=Nr(t,e,r),n[i+2]=Lr(t,e);}function xr(t,e,r,n,i){n[i+0]=Lr(t,e),n[i+1]=Nr(t,e,r),n[i+2]=wr(t,r);}function Sr(t,e,r,n,i){var a=Nr(t,e,r);e=a<<3&224|Lr(t,e)>>3,n[i+0]=248&wr(t,r)|a>>5,n[i+1]=e;}function _r(t,e,r,n,i){var a=240&Lr(t,e)|15;n[i+0]=240&wr(t,r)|Nr(t,e,r)>>4,n[i+1]=a;}function Pr(t,e,r,n,i){n[i+0]=255,Ar(t,e,r,n,i+1);}function kr(t,e,r,n,i){xr(t,e,r,n,i),n[i+3]=255;}function Ir(t,e,r,n,i){Ar(t,e,r,n,i),n[i+3]=255;}function Vt(t,e){return 0>t?0:t>e?e:t}function Fr(e,r,n){t[e]=function(t,e,i,a,o,s,c,u,h){for(var l=u+(-2&h)*n;u!=l;)r(t[e+0],i[a+0],o[s+0],c,u),r(t[e+1],i[a+0],o[s+0],c,u+n),e+=2,++a,++s,u+=2*n;1&h&&r(t[e+0],i[a+0],o[s+0],c,u);};}function Cr(t,e,r){return 0==r?0==t?0==e?6:5:0==e?4:0:r}function jr(t,e,r,n,i){switch(t>>>30){case 3:on(e,r,n,i,0);break;case 2:sn(e,r,n,i);break;case 1:un(e,r,n,i);}}function Or(t,e){var r,a,o=e.M,s=e.Nb,c=t.oc,u=t.pc+40,h=t.oc,l=t.pc+584,f=t.oc,d=t.pc+600;for(r=0;16>r;++r)c[u+32*r-1]=129;for(r=0;8>r;++r)h[l+32*r-1]=129,f[d+32*r-1]=129;for(0<o?c[u-1-32]=h[l-1-32]=f[d-1-32]=129:(i(c,u-32-1,127,21),i(h,l-32-1,127,9),i(f,d-32-1,127,9)),a=0;a<t.za;++a){var p=e.ya[e.aa+a];if(0<a){for(r=-1;16>r;++r)n(c,u+32*r-4,c,u+32*r+12,4);for(r=-1;8>r;++r)n(h,l+32*r-4,h,l+32*r+4,4),n(f,d+32*r-4,f,d+32*r+4,4);}var g=t.Gd,m=t.Hd+a,v=p.ad,b=p.Hc;if(0<o&&(n(c,u-32,g[m].y,0,16),n(h,l-32,g[m].f,0,8),n(f,d-32,g[m].ea,0,8)),p.Za){var y=c,w=u-32+16;for(0<o&&(a>=t.za-1?i(y,w,g[m].y[15],4):n(y,w,g[m+1].y,0,4)),r=0;4>r;r++)y[w+128+r]=y[w+256+r]=y[w+384+r]=y[w+0+r];for(r=0;16>r;++r,b<<=2)y=c,w=u+Di[r],fi[p.Ob[r]](y,w),jr(b,v,16*+r,y,w);}else if(y=Cr(a,o,p.Ob[0]),li[y](c,u),0!=b)for(r=0;16>r;++r,b<<=2)jr(b,v,16*+r,c,u+Di[r]);for(r=p.Gc,y=Cr(a,o,p.Dd),di[y](h,l),di[y](f,d),b=v,y=h,w=l,255&(p=r>>0)&&(170&p?cn(b,256,y,w):hn(b,256,y,w)),p=f,b=d,255&(r>>=8)&&(170&r?cn(v,320,p,b):hn(v,320,p,b)),o<t.Ub-1&&(n(g[m].y,0,c,u+480,16),n(g[m].f,0,h,l+224,8),n(g[m].ea,0,f,d+224,8)),r=8*s*t.B,g=t.sa,m=t.ta+16*a+16*s*t.R,v=t.qa,p=t.ra+8*a+r,b=t.Ha,y=t.Ia+8*a+r,r=0;16>r;++r)n(g,m+r*t.R,c,u+32*r,16);for(r=0;8>r;++r)n(v,p+r*t.B,h,l+32*r,8),n(b,y+r*t.B,f,d+32*r,8);}}function Br(t,n,i,a,o,s,c,u,h){var l=[0],f=[0],d=0,p=null!=h?h.kd:0,g=null!=h?h:new nr;if(null==t||12>i)return 7;g.data=t,g.w=n,g.ha=i,n=[n],i=[i],g.gb=[g.gb];t:{var m=n,b=i,y=g.gb;if(e(null!=t),e(null!=b),e(null!=y),y[0]=0,12<=b[0]&&!r(t,m[0],"RIFF")){if(r(t,m[0]+8,"WEBP")){y=3;break t}var w=j(t,m[0]+4);if(12>w||4294967286<w){y=3;break t}if(p&&w>b[0]-8){y=7;break t}y[0]=w,m[0]+=12,b[0]-=12;}y=0;}if(0!=y)return y;for(w=0<g.gb[0],i=i[0];;){t:{var L=t;b=n,y=i;var A=l,x=f,S=m=[0];if((k=d=[d])[0]=0,8>y[0])y=7;else {if(!r(L,b[0],"VP8X")){if(10!=j(L,b[0]+4)){y=3;break t}if(18>y[0]){y=7;break t}var _=j(L,b[0]+8),P=1+C(L,b[0]+12);if(2147483648<=P*(L=1+C(L,b[0]+15))){y=3;break t}null!=S&&(S[0]=_),null!=A&&(A[0]=P),null!=x&&(x[0]=L),b[0]+=18,y[0]-=18,k[0]=1;}y=0;}}if(d=d[0],m=m[0],0!=y)return y;if(b=!!(2&m),!w&&d)return 3;if(null!=s&&(s[0]=!!(16&m)),null!=c&&(c[0]=b),null!=u&&(u[0]=0),c=l[0],m=f[0],d&&b&&null==h){y=0;break}if(4>i){y=7;break}if(w&&d||!w&&!d&&!r(t,n[0],"ALPH")){i=[i],g.na=[g.na],g.P=[g.P],g.Sa=[g.Sa];t:{_=t,y=n,w=i;var k=g.gb;A=g.na,x=g.P,S=g.Sa;P=22,e(null!=_),e(null!=w),L=y[0];var I=w[0];for(e(null!=A),e(null!=S),A[0]=null,x[0]=null,S[0]=0;;){if(y[0]=L,w[0]=I,8>I){y=7;break t}var F=j(_,L+4);if(4294967286<F){y=3;break t}var O=8+F+1&-2;if(P+=O,0<k&&P>k){y=3;break t}if(!r(_,L,"VP8 ")||!r(_,L,"VP8L")){y=0;break t}if(I[0]<O){y=7;break t}r(_,L,"ALPH")||(A[0]=_,x[0]=L+8,S[0]=F),L+=O,I-=O;}}if(i=i[0],g.na=g.na[0],g.P=g.P[0],g.Sa=g.Sa[0],0!=y)break}i=[i],g.Ja=[g.Ja],g.xa=[g.xa];t:if(k=t,y=n,w=i,A=g.gb[0],x=g.Ja,S=g.xa,_=y[0],L=!r(k,_,"VP8 "),P=!r(k,_,"VP8L"),e(null!=k),e(null!=w),e(null!=x),e(null!=S),8>w[0])y=7;else {if(L||P){if(k=j(k,_+4),12<=A&&k>A-12){y=3;break t}if(p&&k>w[0]-8){y=7;break t}x[0]=k,y[0]+=8,w[0]-=8,S[0]=P;}else S[0]=5<=w[0]&&47==k[_+0]&&!(k[_+4]>>5),x[0]=w[0];y=0;}if(i=i[0],g.Ja=g.Ja[0],g.xa=g.xa[0],n=n[0],0!=y)break;if(4294967286<g.Ja)return 3;if(null==u||b||(u[0]=g.xa?2:1),c=[c],m=[m],g.xa){if(5>i){y=7;break}u=c,p=m,b=s,null==t||5>i?t=0:5<=i&&47==t[n+0]&&!(t[n+4]>>5)?(w=[0],k=[0],A=[0],v(x=new N,t,n,i),gt(x,w,k,A)?(null!=u&&(u[0]=w[0]),null!=p&&(p[0]=k[0]),null!=b&&(b[0]=A[0]),t=1):t=0):t=0;}else {if(10>i){y=7;break}u=m,null==t||10>i||!Xt(t,n+3,i-3)?t=0:(p=t[n+0]|t[n+1]<<8|t[n+2]<<16,b=16383&(t[n+7]<<8|t[n+6]),t=16383&(t[n+9]<<8|t[n+8]),1&p||3<(p>>1&7)||!(p>>4&1)||p>>5>=g.Ja||!b||!t?t=0:(c&&(c[0]=b),u&&(u[0]=t),t=1));}if(!t)return 3;if(c=c[0],m=m[0],d&&(l[0]!=c||f[0]!=m))return 3;null!=h&&(h[0]=g,h.offset=n-h.w,e(4294967286>n-h.w),e(h.offset==h.ha-i));break}return 0==y||7==y&&d&&null==h?(null!=s&&(s[0]|=null!=g.na&&0<g.na.length),null!=a&&(a[0]=c),null!=o&&(o[0]=m),0):y}function Mr(t,e,r){var n=e.width,i=e.height,a=0,o=0,s=n,c=i;if(e.Da=null!=t&&0<t.Da,e.Da&&(s=t.cd,c=t.bd,a=t.v,o=t.j,11>r||(a&=-2,o&=-2),0>a||0>o||0>=s||0>=c||a+s>n||o+c>i))return 0;if(e.v=a,e.j=o,e.va=a+s,e.o=o+c,e.U=s,e.T=c,e.da=null!=t&&0<t.da,e.da){if(!E(s,c,r=[t.ib],a=[t.hb]))return 0;e.ib=r[0],e.hb=a[0];}return e.ob=null!=t&&t.ob,e.Kb=null==t||!t.Sd,e.da&&(e.ob=e.ib<3*n/4&&e.hb<3*i/4,e.Kb=0),1}function Er(t){if(null==t)return 2;if(11>t.S){var e=t.f.RGBA;e.fb+=(t.height-1)*e.A,e.A=-e.A;}else e=t.f.kb,t=t.height,e.O+=(t-1)*e.fa,e.fa=-e.fa,e.N+=(t-1>>1)*e.Ab,e.Ab=-e.Ab,e.W+=(t-1>>1)*e.Db,e.Db=-e.Db,null!=e.F&&(e.J+=(t-1)*e.lb,e.lb=-e.lb);return 0}function qr(t,e,r,n){if(null==n||0>=t||0>=e)return 2;if(null!=r){if(r.Da){var i=r.cd,o=r.bd,s=-2&r.v,c=-2&r.j;if(0>s||0>c||0>=i||0>=o||s+i>t||c+o>e)return 2;t=i,e=o;}if(r.da){if(!E(t,e,i=[r.ib],o=[r.hb]))return 2;t=i[0],e=o[0];}}n.width=t,n.height=e;t:{var u=n.width,h=n.height;if(t=n.S,0>=u||0>=h||!(t>=En&&13>t))t=2;else {if(0>=n.Rd&&null==n.sd){s=o=i=e=0;var l=(c=u*zi[t])*h;if(11>t||(o=(h+1)/2*(e=(u+1)/2),12==t&&(s=(i=u)*h)),null==(h=a(l+2*o+s))){t=1;break t}n.sd=h,11>t?((u=n.f.RGBA).eb=h,u.fb=0,u.A=c,u.size=l):((u=n.f.kb).y=h,u.O=0,u.fa=c,u.Fd=l,u.f=h,u.N=0+l,u.Ab=e,u.Cd=o,u.ea=h,u.W=0+l+o,u.Db=e,u.Ed=o,12==t&&(u.F=h,u.J=0+l+2*o),u.Tc=s,u.lb=i);}if(e=1,i=n.S,o=n.width,s=n.height,i>=En&&13>i)if(11>i)t=n.f.RGBA,e&=(c=Math.abs(t.A))*(s-1)+o<=t.size,e&=c>=o*zi[i],e&=null!=t.eb;else {t=n.f.kb,c=(o+1)/2,l=(s+1)/2,u=Math.abs(t.fa);h=Math.abs(t.Ab);var f=Math.abs(t.Db),d=Math.abs(t.lb),p=d*(s-1)+o;e&=u*(s-1)+o<=t.Fd,e&=h*(l-1)+c<=t.Cd,e=(e&=f*(l-1)+c<=t.Ed)&u>=o&h>=c&f>=c,e&=null!=t.y,e&=null!=t.f,e&=null!=t.ea,12==i&&(e&=d>=o,e&=p<=t.Tc,e&=null!=t.F);}else e=0;t=e?0:2;}}return 0!=t||null!=r&&r.fd&&(t=Er(n)),t}var Dr=64,Rr=[0,1,3,7,15,31,63,127,255,511,1023,2047,4095,8191,16383,32767,65535,131071,262143,524287,1048575,2097151,4194303,8388607,16777215],Tr=24,Ur=32,zr=8,Hr=[0,0,1,1,2,2,2,2,3,3,3,3,3,3,3,3,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7];R("Predictor0","PredictorAdd0"),t.Predictor0=function(){return 4278190080},t.Predictor1=function(t){return t},t.Predictor2=function(t,e,r){return e[r+0]},t.Predictor3=function(t,e,r){return e[r+1]},t.Predictor4=function(t,e,r){return e[r-1]},t.Predictor5=function(t,e,r){return U(U(t,e[r+1]),e[r+0])},t.Predictor6=function(t,e,r){return U(t,e[r-1])},t.Predictor7=function(t,e,r){return U(t,e[r+0])},t.Predictor8=function(t,e,r){return U(e[r-1],e[r+0])},t.Predictor9=function(t,e,r){return U(e[r+0],e[r+1])},t.Predictor10=function(t,e,r){return U(U(t,e[r-1]),U(e[r+0],e[r+1]))},t.Predictor11=function(t,e,r){var n=e[r+0];return 0>=W(n>>24&255,t>>24&255,(e=e[r-1])>>24&255)+W(n>>16&255,t>>16&255,e>>16&255)+W(n>>8&255,t>>8&255,e>>8&255)+W(255&n,255&t,255&e)?n:t},t.Predictor12=function(t,e,r){var n=e[r+0];return (z((t>>24&255)+(n>>24&255)-((e=e[r-1])>>24&255))<<24|z((t>>16&255)+(n>>16&255)-(e>>16&255))<<16|z((t>>8&255)+(n>>8&255)-(e>>8&255))<<8|z((255&t)+(255&n)-(255&e)))>>>0},t.Predictor13=function(t,e,r){var n=e[r-1];return (H((t=U(t,e[r+0]))>>24&255,n>>24&255)<<24|H(t>>16&255,n>>16&255)<<16|H(t>>8&255,n>>8&255)<<8|H(t>>0&255,n>>0&255))>>>0};var Wr=t.PredictorAdd0;t.PredictorAdd1=V,R("Predictor2","PredictorAdd2"),R("Predictor3","PredictorAdd3"),R("Predictor4","PredictorAdd4"),R("Predictor5","PredictorAdd5"),R("Predictor6","PredictorAdd6"),R("Predictor7","PredictorAdd7"),R("Predictor8","PredictorAdd8"),R("Predictor9","PredictorAdd9"),R("Predictor10","PredictorAdd10"),R("Predictor11","PredictorAdd11"),R("Predictor12","PredictorAdd12"),R("Predictor13","PredictorAdd13");var Vr=t.PredictorAdd2;X("ColorIndexInverseTransform","MapARGB","32b",(function(t){return t>>8&255}),(function(t){return t})),X("VP8LColorIndexInverseTransformAlpha","MapAlpha","8b",(function(t){return t}),(function(t){return t>>8&255}));var Gr,Yr=t.ColorIndexInverseTransform,Jr=t.MapARGB,Xr=t.VP8LColorIndexInverseTransformAlpha,Kr=t.MapAlpha,Zr=t.VP8LPredictorsAdd=[];Zr.length=16,(t.VP8LPredictors=[]).length=16,(t.VP8LPredictorsAdd_C=[]).length=16,(t.VP8LPredictors_C=[]).length=16;var $r,Qr,tn,en,rn,nn,an,on,sn,cn,un,hn,ln,fn,dn,pn,gn,mn,vn,bn,yn,wn,Nn,Ln,An,xn,Sn,_n,Pn=a(511),kn=a(2041),In=a(225),Fn=a(767),Cn=0,jn=kn,On=In,Bn=Fn,Mn=Pn,En=0,qn=1,Dn=2,Rn=3,Tn=4,Un=5,zn=6,Hn=7,Wn=8,Vn=9,Gn=10,Yn=[2,3,7],Jn=[3,3,11],Xn=[280,256,256,256,40],Kn=[0,1,1,1,0],Zn=[17,18,0,1,2,3,4,5,16,6,7,8,9,10,11,12,13,14,15],$n=[24,7,23,25,40,6,39,41,22,26,38,42,56,5,55,57,21,27,54,58,37,43,72,4,71,73,20,28,53,59,70,74,36,44,88,69,75,52,60,3,87,89,19,29,86,90,35,45,68,76,85,91,51,61,104,2,103,105,18,30,102,106,34,46,84,92,67,77,101,107,50,62,120,1,119,121,83,93,17,31,100,108,66,78,118,122,33,47,117,123,49,63,99,109,82,94,0,116,124,65,79,16,32,98,110,48,115,125,81,95,64,114,126,97,111,80,113,127,96,112],Qn=[2954,2956,2958,2962,2970,2986,3018,3082,3212,3468,3980,5004],ti=8,ei=[4,5,6,7,8,9,10,10,11,12,13,14,15,16,17,17,18,19,20,20,21,21,22,22,23,23,24,25,25,26,27,28,29,30,31,32,33,34,35,36,37,37,38,39,40,41,42,43,44,45,46,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,76,77,78,79,80,81,82,83,84,85,86,87,88,89,91,93,95,96,98,100,101,102,104,106,108,110,112,114,116,118,122,124,126,128,130,132,134,136,138,140,143,145,148,151,154,157],ri=[4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,119,122,125,128,131,134,137,140,143,146,149,152,155,158,161,164,167,170,173,177,181,185,189,193,197,201,205,209,213,217,221,225,229,234,239,245,249,254,259,264,269,274,279,284],ni=null,ii=[[173,148,140,0],[176,155,140,135,0],[180,157,141,134,130,0],[254,254,243,230,196,177,153,140,133,130,129,0]],ai=[0,1,4,8,5,2,3,6,9,12,13,10,7,11,14,15],oi=[-0,1,-1,2,-2,3,4,6,-3,5,-4,-5,-6,7,-7,8,-8,-9],si=[[[[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128]],[[253,136,254,255,228,219,128,128,128,128,128],[189,129,242,255,227,213,255,219,128,128,128],[106,126,227,252,214,209,255,255,128,128,128]],[[1,98,248,255,236,226,255,255,128,128,128],[181,133,238,254,221,234,255,154,128,128,128],[78,134,202,247,198,180,255,219,128,128,128]],[[1,185,249,255,243,255,128,128,128,128,128],[184,150,247,255,236,224,128,128,128,128,128],[77,110,216,255,236,230,128,128,128,128,128]],[[1,101,251,255,241,255,128,128,128,128,128],[170,139,241,252,236,209,255,255,128,128,128],[37,116,196,243,228,255,255,255,128,128,128]],[[1,204,254,255,245,255,128,128,128,128,128],[207,160,250,255,238,128,128,128,128,128,128],[102,103,231,255,211,171,128,128,128,128,128]],[[1,152,252,255,240,255,128,128,128,128,128],[177,135,243,255,234,225,128,128,128,128,128],[80,129,211,255,194,224,128,128,128,128,128]],[[1,1,255,128,128,128,128,128,128,128,128],[246,1,255,128,128,128,128,128,128,128,128],[255,128,128,128,128,128,128,128,128,128,128]]],[[[198,35,237,223,193,187,162,160,145,155,62],[131,45,198,221,172,176,220,157,252,221,1],[68,47,146,208,149,167,221,162,255,223,128]],[[1,149,241,255,221,224,255,255,128,128,128],[184,141,234,253,222,220,255,199,128,128,128],[81,99,181,242,176,190,249,202,255,255,128]],[[1,129,232,253,214,197,242,196,255,255,128],[99,121,210,250,201,198,255,202,128,128,128],[23,91,163,242,170,187,247,210,255,255,128]],[[1,200,246,255,234,255,128,128,128,128,128],[109,178,241,255,231,245,255,255,128,128,128],[44,130,201,253,205,192,255,255,128,128,128]],[[1,132,239,251,219,209,255,165,128,128,128],[94,136,225,251,218,190,255,255,128,128,128],[22,100,174,245,186,161,255,199,128,128,128]],[[1,182,249,255,232,235,128,128,128,128,128],[124,143,241,255,227,234,128,128,128,128,128],[35,77,181,251,193,211,255,205,128,128,128]],[[1,157,247,255,236,231,255,255,128,128,128],[121,141,235,255,225,227,255,255,128,128,128],[45,99,188,251,195,217,255,224,128,128,128]],[[1,1,251,255,213,255,128,128,128,128,128],[203,1,248,255,255,128,128,128,128,128,128],[137,1,177,255,224,255,128,128,128,128,128]]],[[[253,9,248,251,207,208,255,192,128,128,128],[175,13,224,243,193,185,249,198,255,255,128],[73,17,171,221,161,179,236,167,255,234,128]],[[1,95,247,253,212,183,255,255,128,128,128],[239,90,244,250,211,209,255,255,128,128,128],[155,77,195,248,188,195,255,255,128,128,128]],[[1,24,239,251,218,219,255,205,128,128,128],[201,51,219,255,196,186,128,128,128,128,128],[69,46,190,239,201,218,255,228,128,128,128]],[[1,191,251,255,255,128,128,128,128,128,128],[223,165,249,255,213,255,128,128,128,128,128],[141,124,248,255,255,128,128,128,128,128,128]],[[1,16,248,255,255,128,128,128,128,128,128],[190,36,230,255,236,255,128,128,128,128,128],[149,1,255,128,128,128,128,128,128,128,128]],[[1,226,255,128,128,128,128,128,128,128,128],[247,192,255,128,128,128,128,128,128,128,128],[240,128,255,128,128,128,128,128,128,128,128]],[[1,134,252,255,255,128,128,128,128,128,128],[213,62,250,255,255,128,128,128,128,128,128],[55,93,255,128,128,128,128,128,128,128,128]],[[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128]]],[[[202,24,213,235,186,191,220,160,240,175,255],[126,38,182,232,169,184,228,174,255,187,128],[61,46,138,219,151,178,240,170,255,216,128]],[[1,112,230,250,199,191,247,159,255,255,128],[166,109,228,252,211,215,255,174,128,128,128],[39,77,162,232,172,180,245,178,255,255,128]],[[1,52,220,246,198,199,249,220,255,255,128],[124,74,191,243,183,193,250,221,255,255,128],[24,71,130,219,154,170,243,182,255,255,128]],[[1,182,225,249,219,240,255,224,128,128,128],[149,150,226,252,216,205,255,171,128,128,128],[28,108,170,242,183,194,254,223,255,255,128]],[[1,81,230,252,204,203,255,192,128,128,128],[123,102,209,247,188,196,255,233,128,128,128],[20,95,153,243,164,173,255,203,128,128,128]],[[1,222,248,255,216,213,128,128,128,128,128],[168,175,246,252,235,205,255,255,128,128,128],[47,116,215,255,211,212,255,255,128,128,128]],[[1,121,236,253,212,214,255,255,128,128,128],[141,84,213,252,201,202,255,219,128,128,128],[42,80,160,240,162,185,255,205,128,128,128]],[[1,1,255,128,128,128,128,128,128,128,128],[244,1,255,128,128,128,128,128,128,128,128],[238,1,255,128,128,128,128,128,128,128,128]]]],ci=[[[231,120,48,89,115,113,120,152,112],[152,179,64,126,170,118,46,70,95],[175,69,143,80,85,82,72,155,103],[56,58,10,171,218,189,17,13,152],[114,26,17,163,44,195,21,10,173],[121,24,80,195,26,62,44,64,85],[144,71,10,38,171,213,144,34,26],[170,46,55,19,136,160,33,206,71],[63,20,8,114,114,208,12,9,226],[81,40,11,96,182,84,29,16,36]],[[134,183,89,137,98,101,106,165,148],[72,187,100,130,157,111,32,75,80],[66,102,167,99,74,62,40,234,128],[41,53,9,178,241,141,26,8,107],[74,43,26,146,73,166,49,23,157],[65,38,105,160,51,52,31,115,128],[104,79,12,27,217,255,87,17,7],[87,68,71,44,114,51,15,186,23],[47,41,14,110,182,183,21,17,194],[66,45,25,102,197,189,23,18,22]],[[88,88,147,150,42,46,45,196,205],[43,97,183,117,85,38,35,179,61],[39,53,200,87,26,21,43,232,171],[56,34,51,104,114,102,29,93,77],[39,28,85,171,58,165,90,98,64],[34,22,116,206,23,34,43,166,73],[107,54,32,26,51,1,81,43,31],[68,25,106,22,64,171,36,225,114],[34,19,21,102,132,188,16,76,124],[62,18,78,95,85,57,50,48,51]],[[193,101,35,159,215,111,89,46,111],[60,148,31,172,219,228,21,18,111],[112,113,77,85,179,255,38,120,114],[40,42,1,196,245,209,10,25,109],[88,43,29,140,166,213,37,43,154],[61,63,30,155,67,45,68,1,209],[100,80,8,43,154,1,51,26,71],[142,78,78,16,255,128,34,197,171],[41,40,5,102,211,183,4,1,221],[51,50,17,168,209,192,23,25,82]],[[138,31,36,171,27,166,38,44,229],[67,87,58,169,82,115,26,59,179],[63,59,90,180,59,166,93,73,154],[40,40,21,116,143,209,34,39,175],[47,15,16,183,34,223,49,45,183],[46,17,33,183,6,98,15,32,183],[57,46,22,24,128,1,54,17,37],[65,32,73,115,28,128,23,128,205],[40,3,9,115,51,192,18,6,223],[87,37,9,115,59,77,64,21,47]],[[104,55,44,218,9,54,53,130,226],[64,90,70,205,40,41,23,26,57],[54,57,112,184,5,41,38,166,213],[30,34,26,133,152,116,10,32,134],[39,19,53,221,26,114,32,73,255],[31,9,65,234,2,15,1,118,73],[75,32,12,51,192,255,160,43,51],[88,31,35,67,102,85,55,186,85],[56,21,23,111,59,205,45,37,192],[55,38,70,124,73,102,1,34,98]],[[125,98,42,88,104,85,117,175,82],[95,84,53,89,128,100,113,101,45],[75,79,123,47,51,128,81,171,1],[57,17,5,71,102,57,53,41,49],[38,33,13,121,57,73,26,1,85],[41,10,67,138,77,110,90,47,114],[115,21,2,10,102,255,166,23,6],[101,29,16,10,85,128,101,196,26],[57,18,10,102,102,213,34,20,43],[117,20,15,36,163,128,68,1,26]],[[102,61,71,37,34,53,31,243,192],[69,60,71,38,73,119,28,222,37],[68,45,128,34,1,47,11,245,171],[62,17,19,70,146,85,55,62,70],[37,43,37,154,100,163,85,160,1],[63,9,92,136,28,64,32,201,85],[75,15,9,9,64,255,184,119,16],[86,6,28,5,64,255,25,248,1],[56,8,17,132,137,255,55,116,128],[58,15,20,82,135,57,26,121,40]],[[164,50,31,137,154,133,25,35,218],[51,103,44,131,131,123,31,6,158],[86,40,64,135,148,224,45,183,128],[22,26,17,131,240,154,14,1,209],[45,16,21,91,64,222,7,1,197],[56,21,39,155,60,138,23,102,213],[83,12,13,54,192,255,68,47,28],[85,26,85,85,128,128,32,146,171],[18,11,7,63,144,171,4,4,246],[35,27,10,146,174,171,12,26,128]],[[190,80,35,99,180,80,126,54,45],[85,126,47,87,176,51,41,20,32],[101,75,128,139,118,146,116,128,85],[56,41,15,176,236,85,37,9,62],[71,30,17,119,118,255,17,18,138],[101,38,60,138,55,70,43,26,142],[146,36,19,30,171,255,97,27,20],[138,45,61,62,219,1,81,188,64],[32,41,20,117,151,142,20,21,163],[112,19,12,61,195,128,48,4,24]]],ui=[[[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[176,246,255,255,255,255,255,255,255,255,255],[223,241,252,255,255,255,255,255,255,255,255],[249,253,253,255,255,255,255,255,255,255,255]],[[255,244,252,255,255,255,255,255,255,255,255],[234,254,254,255,255,255,255,255,255,255,255],[253,255,255,255,255,255,255,255,255,255,255]],[[255,246,254,255,255,255,255,255,255,255,255],[239,253,254,255,255,255,255,255,255,255,255],[254,255,254,255,255,255,255,255,255,255,255]],[[255,248,254,255,255,255,255,255,255,255,255],[251,255,254,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[251,254,254,255,255,255,255,255,255,255,255],[254,255,254,255,255,255,255,255,255,255,255]],[[255,254,253,255,254,255,255,255,255,255,255],[250,255,254,255,254,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[217,255,255,255,255,255,255,255,255,255,255],[225,252,241,253,255,255,254,255,255,255,255],[234,250,241,250,253,255,253,254,255,255,255]],[[255,254,255,255,255,255,255,255,255,255,255],[223,254,254,255,255,255,255,255,255,255,255],[238,253,254,254,255,255,255,255,255,255,255]],[[255,248,254,255,255,255,255,255,255,255,255],[249,254,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,255,255,255,255,255,255,255,255,255],[247,254,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[252,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,254,255,255,255,255,255,255,255,255],[253,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,253,255,255,255,255,255,255,255,255],[250,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[186,251,250,255,255,255,255,255,255,255,255],[234,251,244,254,255,255,255,255,255,255,255],[251,251,243,253,254,255,254,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[236,253,254,255,255,255,255,255,255,255,255],[251,253,253,254,254,255,255,255,255,255,255]],[[255,254,254,255,255,255,255,255,255,255,255],[254,254,254,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,255,255,255,255,255,255,255,255,255],[254,254,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[248,255,255,255,255,255,255,255,255,255,255],[250,254,252,254,255,255,255,255,255,255,255],[248,254,249,253,255,255,255,255,255,255,255]],[[255,253,253,255,255,255,255,255,255,255,255],[246,253,253,255,255,255,255,255,255,255,255],[252,254,251,254,254,255,255,255,255,255,255]],[[255,254,252,255,255,255,255,255,255,255,255],[248,254,253,255,255,255,255,255,255,255,255],[253,255,254,254,255,255,255,255,255,255,255]],[[255,251,254,255,255,255,255,255,255,255,255],[245,251,254,255,255,255,255,255,255,255,255],[253,253,254,255,255,255,255,255,255,255,255]],[[255,251,253,255,255,255,255,255,255,255,255],[252,253,254,255,255,255,255,255,255,255,255],[255,254,255,255,255,255,255,255,255,255,255]],[[255,252,255,255,255,255,255,255,255,255,255],[249,255,254,255,255,255,255,255,255,255,255],[255,255,254,255,255,255,255,255,255,255,255]],[[255,255,253,255,255,255,255,255,255,255,255],[250,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]]],hi=[0,1,2,3,6,4,5,6,6,6,6,6,6,6,6,7,0],li=[],fi=[],di=[],pi=1,gi=2,mi=[],vi=[];vr("UpsampleRgbLinePair",Ar,3),vr("UpsampleBgrLinePair",xr,3),vr("UpsampleRgbaLinePair",Ir,4),vr("UpsampleBgraLinePair",kr,4),vr("UpsampleArgbLinePair",Pr,4),vr("UpsampleRgba4444LinePair",_r,2),vr("UpsampleRgb565LinePair",Sr,2);var bi=t.UpsampleRgbLinePair,yi=t.UpsampleBgrLinePair,wi=t.UpsampleRgbaLinePair,Ni=t.UpsampleBgraLinePair,Li=t.UpsampleArgbLinePair,Ai=t.UpsampleRgba4444LinePair,xi=t.UpsampleRgb565LinePair,Si=16,_i=1<<Si-1,Pi=-227,ki=482,Ii=6,Fi=(256<<Ii)-1,Ci=0,ji=a(256),Oi=a(256),Bi=a(256),Mi=a(256),Ei=a(ki-Pi),qi=a(ki-Pi);Fr("YuvToRgbRow",Ar,3),Fr("YuvToBgrRow",xr,3),Fr("YuvToRgbaRow",Ir,4),Fr("YuvToBgraRow",kr,4),Fr("YuvToArgbRow",Pr,4),Fr("YuvToRgba4444Row",_r,2),Fr("YuvToRgb565Row",Sr,2);var Di=[0,4,8,12,128,132,136,140,256,260,264,268,384,388,392,396],Ri=[0,2,8],Ti=[8,7,6,4,4,2,2,2,1,1,1,1],Ui=1;this.WebPDecodeRGBA=function(t,r,n,i,a){var o=qn,s=new rr,c=new ot;s.ba=c,c.S=o,c.width=[c.width],c.height=[c.height];var u=c.width,h=c.height,l=new st;if(null==l||null==t)var f=2;else e(null!=l),f=Br(t,r,n,l.width,l.height,l.Pd,l.Qd,l.format,null);if(0!=f?u=0:(null!=u&&(u[0]=l.width[0]),null!=h&&(h[0]=l.height[0]),u=1),u){c.width=c.width[0],c.height=c.height[0],null!=i&&(i[0]=c.width),null!=a&&(a[0]=c.height);t:{if(i=new Gt,(a=new nr).data=t,a.w=r,a.ha=n,a.kd=1,r=[0],e(null!=a),(0==(t=Br(a.data,a.w,a.ha,null,null,null,r,null,a))||7==t)&&r[0]&&(t=4),0==(r=t)){if(e(null!=s),i.data=a.data,i.w=a.w+a.offset,i.ha=a.ha-a.offset,i.put=dt,i.ac=ft,i.bc=pt,i.ma=s,a.xa){if(null==(t=kt())){s=1;break t}if(function(t,r){var n=[0],i=[0],a=[0];e:for(;;){if(null==t)return 0;if(null==r)return t.a=2,0;if(t.l=r,t.a=0,v(t.m,r.data,r.w,r.ha),!gt(t.m,n,i,a)){t.a=3;break e}if(t.xb=gi,r.width=n[0],r.height=i[0],!It(n[0],i[0],1,t,null))break e;return 1}return e(0!=t.a),0}(t,i)){if(i=0==(r=qr(i.width,i.height,s.Oa,s.ba))){e:{i=t;r:for(;;){if(null==i){i=0;break e}if(e(null!=i.s.yc),e(null!=i.s.Ya),e(0<i.s.Wb),e(null!=(n=i.l)),e(null!=(a=n.ma)),0!=i.xb){if(i.ca=a.ba,i.tb=a.tb,e(null!=i.ca),!Mr(a.Oa,n,Rn)){i.a=2;break r}if(!Ft(i,n.width))break r;if(n.da)break r;if((n.da||nt(i.ca.S))&&mr(),11>i.ca.S||(alert("todo:WebPInitConvertARGBToYUV"),null!=i.ca.f.kb.F&&mr()),i.Pb&&0<i.s.ua&&null==i.s.vb.X&&!O(i.s.vb,i.s.Wa.Xa)){i.a=1;break r}i.xb=0;}if(!_t(i,i.V,i.Ba,i.c,i.i,n.o,Lt))break r;a.Dc=i.Ma,i=1;break e}e(0!=i.a),i=0;}i=!i;}i&&(r=t.a);}else r=t.a;}else {if(null==(t=new Yt)){s=1;break t}if(t.Fa=a.na,t.P=a.P,t.qc=a.Sa,Kt(t,i)){if(0==(r=qr(i.width,i.height,s.Oa,s.ba))){if(t.Aa=0,n=s.Oa,e(null!=(a=t)),null!=n){if(0<(u=0>(u=n.Md)?0:100<u?255:255*u/100)){for(h=l=0;4>h;++h)12>(f=a.pb[h]).lc&&(f.ia=u*Ti[0>f.lc?0:f.lc]>>3),l|=f.ia;l&&(alert("todo:VP8InitRandom"),a.ia=1);}a.Ga=n.Id,100<a.Ga?a.Ga=100:0>a.Ga&&(a.Ga=0);}Qt(t,i)||(r=t.a);}}else r=t.a;}0==r&&null!=s.Oa&&s.Oa.fd&&(r=Er(s.ba));}s=r;}o=0!=s?null:11>o?c.f.RGBA.eb:c.f.kb.y;}else o=null;return o};var zi=[3,4,3,4,4,2,2,4,4,4,2,1,1];};function u(t,e){for(var r="",n=0;n<4;n++)r+=String.fromCharCode(t[e++]);return r}function h(t,e){return (t[e+0]<<0|t[e+1]<<8|t[e+2]<<16)>>>0}function l(t,e){return (t[e+0]<<0|t[e+1]<<8|t[e+2]<<16|t[e+3]<<24)>>>0}new c;var f=[0],d=[0],p=[],g=new c,m=t,v=function(t,e){var r={},n=0,i=!1,a=0,o=0;if(r.frames=[],!
/** @license
   * Copyright (c) 2017 Dominik Homberger
  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  https://webpjs.appspot.com
  WebPRiffParser dominikhlbg@gmail.com
  */
function(t,e,r,n){for(var i=0;i<n;i++)if(t[e+i]!=r.charCodeAt(i))return !0;return !1}(t,e,"RIFF",4)){var s,c;l(t,e+=4);for(e+=8;e<t.length;){var f=u(t,e),d=l(t,e+=4);e+=4;var p=d+(1&d);switch(f){case"VP8 ":case"VP8L":void 0===r.frames[n]&&(r.frames[n]={});(v=r.frames[n]).src_off=i?o:e-8,v.src_size=a+d+8,n++,i&&(i=!1,a=0,o=0);break;case"VP8X":(v=r.header={}).feature_flags=t[e];var g=e+4;v.canvas_width=1+h(t,g);g+=3;v.canvas_height=1+h(t,g);g+=3;break;case"ALPH":i=!0,a=p+8,o=e-8;break;case"ANIM":(v=r.header).bgcolor=l(t,e);g=e+4;v.loop_count=(s=t)[(c=g)+0]<<0|s[c+1]<<8;g+=2;break;case"ANMF":var m,v;(v=r.frames[n]={}).offset_x=2*h(t,e),e+=3,v.offset_y=2*h(t,e),e+=3,v.width=1+h(t,e),e+=3,v.height=1+h(t,e),e+=3,v.duration=h(t,e),e+=3,m=t[e++],v.dispose=1&m,v.blend=m>>1&1;}"ANMF"!=f&&(e+=p);}return r}}(m,0);v.response=m,v.rgbaoutput=!0,v.dataurl=!1;var b=v.header?v.header:null,y=v.frames?v.frames:null;if(b){b.loop_counter=b.loop_count,f=[b.canvas_height],d=[b.canvas_width];for(var w=0;w<y.length&&0!=y[w].blend;w++);}var N=y[0],L=g.WebPDecodeRGBA(m,N.src_off,N.src_size,d,f);N.rgba=L,N.imgwidth=d[0],N.imgheight=f[0];for(var A=0;A<d[0]*f[0]*4;A++)p[A]=L[A];return this.width=d,this.height=f,this.data=p,this}!function(t){var r=function(){return "function"==typeof zlibSync},n=function(r,n,a,h){var l=4,f=s;switch(h){case t.image_compression.FAST:l=1,f=o;break;case t.image_compression.MEDIUM:l=6,f=c;break;case t.image_compression.SLOW:l=9,f=u;}r=i(r,n,a,f);var d=zlibSync(r,{level:l});return t.__addimage__.arrayBufferToBinaryString(d)},i=function(t,e,r,n){for(var i,a,o,s=t.length/e,c=new Uint8Array(t.length+s),u=l(),h=0;h<s;h+=1){if(o=h*e,i=t.subarray(o,o+e),n)c.set(n(i,r,a),o+h);else {for(var d,p=u.length,g=[];d<p;d+=1)g[d]=u[d](i,r,a);var m=f(g.concat());c.set(g[m],o+h);}a=i;}return c},a=function(t){var e=Array.apply([],t);return e.unshift(0),e},o=function(t,e){var r,n=[],i=t.length;n[0]=1;for(var a=0;a<i;a+=1)r=t[a-e]||0,n[a+1]=t[a]-r+256&255;return n},s=function(t,e,r){var n,i=[],a=t.length;i[0]=2;for(var o=0;o<a;o+=1)n=r&&r[o]||0,i[o+1]=t[o]-n+256&255;return i},c=function(t,e,r){var n,i,a=[],o=t.length;a[0]=3;for(var s=0;s<o;s+=1)n=t[s-e]||0,i=r&&r[s]||0,a[s+1]=t[s]+256-(n+i>>>1)&255;return a},u=function(t,e,r){var n,i,a,o,s=[],c=t.length;s[0]=4;for(var u=0;u<c;u+=1)n=t[u-e]||0,i=r&&r[u]||0,a=r&&r[u-e]||0,o=h(n,i,a),s[u+1]=t[u]-o+256&255;return s},h=function(t,e,r){if(t===e&&e===r)return t;var n=Math.abs(e-r),i=Math.abs(t-r),a=Math.abs(t+e-r-r);return n<=i&&n<=a?t:i<=a?e:r},l=function(){return [a,o,s,c,u]},f=function(t){var e=t.map((function(t){return t.reduce((function(t,e){return t+Math.abs(e)}),0)}));return e.indexOf(Math.min.apply(null,e))};t.processPNG=function(e,i,a,o){var s,c,u,h,l,f,d,p,g,m,v,b,y,w,N,L=this.decode.FLATE_DECODE,A="";if(this.__addimage__.isArrayBuffer(e)&&(e=new Uint8Array(e)),this.__addimage__.isArrayBufferView(e)){if(e=(u=new Kt(e)).imgData,c=u.bits,s=u.colorSpace,l=u.colors,-1!==[4,6].indexOf(u.colorType)){if(8===u.bits){g=(p=32==u.pixelBitlength?new Uint32Array(u.decodePixels().buffer):16==u.pixelBitlength?new Uint16Array(u.decodePixels().buffer):new Uint8Array(u.decodePixels().buffer)).length,v=new Uint8Array(g*u.colors),m=new Uint8Array(g);var x,S=u.pixelBitlength-u.bits;for(w=0,N=0;w<g;w++){for(y=p[w],x=0;x<S;)v[N++]=y>>>x&255,x+=u.bits;m[w]=y>>>x&255;}}if(16===u.bits){g=(p=new Uint32Array(u.decodePixels().buffer)).length,v=new Uint8Array(g*(32/u.pixelBitlength)*u.colors),m=new Uint8Array(g*(32/u.pixelBitlength)),b=u.colors>1,w=0,N=0;for(var _=0;w<g;)y=p[w++],v[N++]=y>>>0&255,b&&(v[N++]=y>>>16&255,y=p[w++],v[N++]=y>>>0&255),m[_++]=y>>>16&255;c=8;}o!==t.image_compression.NONE&&r()?(e=n(v,u.width*u.colors,u.colors,o),d=n(m,u.width,1,o)):(e=v,d=m,L=void 0);}if(3===u.colorType&&(s=this.color_spaces.INDEXED,f=u.palette,u.transparency.indexed)){var P=u.transparency.indexed,k=0;for(w=0,g=P.length;w<g;++w)k+=P[w];if((k/=255)===g-1&&-1!==P.indexOf(0))h=[P.indexOf(0)];else if(k!==g){for(p=u.decodePixels(),m=new Uint8Array(p.length),w=0,g=p.length;w<g;w++)m[w]=P[p[w]];d=n(m,u.width,1);}}var I=function(e){var r;switch(e){case t.image_compression.FAST:r=11;break;case t.image_compression.MEDIUM:r=13;break;case t.image_compression.SLOW:r=14;break;default:r=12;}return r}(o);return L===this.decode.FLATE_DECODE&&(A="/Predictor "+I+" "),A+="/Colors "+l+" /BitsPerComponent "+c+" /Columns "+u.width,(this.__addimage__.isArrayBuffer(e)||this.__addimage__.isArrayBufferView(e))&&(e=this.__addimage__.arrayBufferToBinaryString(e)),(d&&this.__addimage__.isArrayBuffer(d)||this.__addimage__.isArrayBufferView(d))&&(d=this.__addimage__.arrayBufferToBinaryString(d)),{alias:a,data:e,index:i,filter:L,decodeParameters:A,transparency:h,palette:f,sMask:d,predictor:I,width:u.width,height:u.height,bitsPerComponent:c,colorSpace:s}}};}(E.API),function(t){t.processGIF89A=function(e,r,n,i){var a=new Zt(e),o=a.width,s=a.height,c=[];a.decodeAndBlitFrameRGBA(0,c);var u={data:c,width:o,height:s},h=new Qt(100).encode(u,100);return t.processJPEG.call(this,h,r,n,i)},t.processGIF87A=t.processGIF89A;}(E.API),te.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var r=this.datav.getUint8(this.pos++,!0),n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:n,blue:r,quad:a};}}this.height<0&&(this.height*=-1,this.bottom_up=!1);},te.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]();}catch(t){a.log("bit decode error:"+t);}},te.prototype.bit1=function(){var t,e=Math.ceil(this.width/8),r=e%4;for(t=this.height-1;t>=0;t--){for(var n=this.bottom_up?t:this.height-1-t,i=0;i<e;i++)for(var a=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var c=this.palette[a>>7-s&1];this.data[o+4*s]=c.blue,this.data[o+4*s+1]=c.green,this.data[o+4*s+2]=c.red,this.data[o+4*s+3]=255;}0!==r&&(this.pos+=4-r);}},te.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,r=this.height-1;r>=0;r--){for(var n=this.bottom_up?r:this.height-1-r,i=0;i<t;i++){var a=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+2*i*4,s=a>>4,c=15&a,u=this.palette[s];if(this.data[o]=u.blue,this.data[o+1]=u.green,this.data[o+2]=u.red,this.data[o+3]=255,2*i+1>=this.width)break;u=this.palette[c],this.data[o+4]=u.blue,this.data[o+4+1]=u.green,this.data[o+4+2]=u.red,this.data[o+4+3]=255;}0!==e&&(this.pos+=4-e);}},te.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;e>=0;e--){for(var r=this.bottom_up?e:this.height-1-e,n=0;n<this.width;n++){var i=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+4*n;if(i<this.palette.length){var o=this.palette[i];this.data[a]=o.red,this.data[a+1]=o.green,this.data[a+2]=o.blue,this.data[a+3]=255;}else this.data[a]=255,this.data[a+1]=255,this.data[a+2]=255,this.data[a+3]=255;}0!==t&&(this.pos+=4-t);}},te.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),r=this.height-1;r>=0;r--){for(var n=this.bottom_up?r:this.height-1-r,i=0;i<this.width;i++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var o=(a&e)/e*255|0,s=(a>>5&e)/e*255|0,c=(a>>10&e)/e*255|0,u=a>>15?255:0,h=n*this.width*4+4*i;this.data[h]=c,this.data[h+1]=s,this.data[h+2]=o,this.data[h+3]=u;}this.pos+=t;}},te.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),r=parseInt("111111",2),n=this.height-1;n>=0;n--){for(var i=this.bottom_up?n:this.height-1-n,a=0;a<this.width;a++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(o&e)/e*255|0,c=(o>>5&r)/r*255|0,u=(o>>11)/e*255|0,h=i*this.width*4+4*a;this.data[h]=u,this.data[h+1]=c,this.data[h+2]=s,this.data[h+3]=255;}this.pos+=t;}},te.prototype.bit24=function(){for(var t=this.height-1;t>=0;t--){for(var e=this.bottom_up?t:this.height-1-t,r=0;r<this.width;r++){var n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),o=e*this.width*4+4*r;this.data[o]=a,this.data[o+1]=i,this.data[o+2]=n,this.data[o+3]=255;}this.pos+=this.width%4;}},te.prototype.bit32=function(){for(var t=this.height-1;t>=0;t--)for(var e=this.bottom_up?t:this.height-1-t,r=0;r<this.width;r++){var n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*r;this.data[s]=a,this.data[s+1]=i,this.data[s+2]=n,this.data[s+3]=o;}},te.prototype.getData=function(){return this.data},
/**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.processBMP=function(e,r,n,i){var a=new te(e,!1),o=a.width,s=a.height,c={data:a.getData(),width:o,height:s},u=new Qt(100).encode(c,100);return t.processJPEG.call(this,u,r,n,i)};}(E.API),ee.prototype.getData=function(){return this.data},
/**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.processWEBP=function(e,r,n,i){var a=new ee(e,!1),o=a.width,s=a.height,c={data:a.getData(),width:o,height:s},u=new Qt(100).encode(c,100);return t.processJPEG.call(this,u,r,n,i)};}(E.API),E.API.processRGBA=function(t,e,r){for(var n=t.data,i=n.length,a=new Uint8Array(i/4*3),o=new Uint8Array(i/4),s=0,c=0,u=0;u<i;u+=4){var h=n[u],l=n[u+1],f=n[u+2],d=n[u+3];a[s++]=h,a[s++]=l,a[s++]=f,o[c++]=d;}var p=this.__addimage__.arrayBufferToBinaryString(a);return {alpha:this.__addimage__.arrayBufferToBinaryString(o),data:p,index:e,alias:r,colorSpace:"DeviceRGB",bitsPerComponent:8,width:t.width,height:t.height}},E.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"North Macedonia",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",(function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")");})),this.internal.languageSettings.isSubscribed=!0)),this},Vt=E.API,Gt=Vt.getCharWidthsArray=function(e,r){var n,i,a=(r=r||{}).font||this.internal.getFont(),o=r.fontSize||this.internal.getFontSize(),s=r.charSpace||this.internal.getCharSpace(),c=r.widths?r.widths:a.metadata.Unicode.widths,u=c.fof?c.fof:1,h=r.kerning?r.kerning:a.metadata.Unicode.kerning,l=h.fof?h.fof:1,f=!1!==r.doKerning,d=0,p=e.length,g=0,m=c[0]||u,v=[];for(n=0;n<p;n++)i=e.charCodeAt(n),"function"==typeof a.metadata.widthOfString?v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(i))+s*(1e3/o)||0)/1e3):(d=f&&"object"===_typeof$2(h[i])&&!isNaN(parseInt(h[i][g],10))?h[i][g]/l:0,v.push((c[i]||m)/u+d)),g=i;return v},Yt=Vt.getStringUnitWidth=function(t,e){var r=(e=e||{}).fontSize||this.internal.getFontSize(),n=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return Vt.processArabic&&(t=Vt.processArabic(t)),"function"==typeof n.metadata.widthOfString?n.metadata.widthOfString(t,r,i)/r:Gt.apply(this,arguments).reduce((function(t,e){return t+e}),0)},Jt=function(t,e,r,n){for(var i=[],a=0,o=t.length,s=0;a!==o&&s+e[a]<r;)s+=e[a],a++;i.push(t.slice(0,a));var c=a;for(s=0;a!==o;)s+e[a]>n&&(i.push(t.slice(c,a)),s=0,c=a),s+=e[a],a++;return c!==a&&i.push(t.slice(c,a)),i},Xt=function(t,e,r){r||(r={});var n,i,a,o,s,c,u,h=[],l=[h],f=r.textIndent||0,d=0,p=0,g=t.split(" "),m=Gt.apply(this,[" ",r])[0];if(c=-1===r.lineIndent?g[0].length+2:r.lineIndent||0){var v=Array(c).join(" "),b=[];g.map((function(t){(t=t.split(/\s*\n/)).length>1?b=b.concat(t.map((function(t,e){return (e&&t.length?"\n":"")+t}))):b.push(t[0]);})),g=b,c=Yt.apply(this,[v,r]);}for(a=0,o=g.length;a<o;a++){var y=0;if(n=g[a],c&&"\n"==n[0]&&(n=n.substr(1),y=1),f+d+(p=(i=Gt.apply(this,[n,r])).reduce((function(t,e){return t+e}),0))>e||y){if(p>e){for(s=Jt.apply(this,[n,i,e-(f+d),e]),h.push(s.shift()),h=[s.pop()];s.length;)l.push([s.shift()]);p=i.slice(n.length-(h[0]?h[0].length:0)).reduce((function(t,e){return t+e}),0);}else h=[n];l.push(h),f=p+c,d=m;}else h.push(n),f+=d+p,d=m;}return u=c?function(t,e){return (e?v:"")+t.join(" ")}:function(t){return t.join(" ")},l.map(u)},Vt.splitTextToSize=function(t,e,r){var n,i=(r=r||{}).fontSize||this.internal.getFontSize(),a=function(t){if(t.widths&&t.kerning)return {widths:t.widths,kerning:t.kerning};var e=this.internal.getFont(t.fontName,t.fontStyle);return e.metadata.Unicode?{widths:e.metadata.Unicode.widths||{0:1},kerning:e.metadata.Unicode.kerning||{}}:{font:e.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,r);n=Array.isArray(t)?t:String(t).split(/\r?\n/);var o=1*this.internal.scaleFactor*e/i;a.textIndent=r.textIndent?1*r.textIndent*this.internal.scaleFactor/i:0,a.lineIndent=r.lineIndent;var s,c,u=[];for(s=0,c=n.length;s<c;s++)u=u.concat(Xt.apply(this,[n[s],o,a]));return u},function(e){e.__fontmetrics__=e.__fontmetrics__||{};for(var r="klmnopqrstuvwxyz",n={},i={},a=0;a<r.length;a++)n[r[a]]="0123456789abcdef"[a],i["0123456789abcdef"[a]]=r[a];var o=function(t){return "0x"+parseInt(t,10).toString(16)},s=e.__fontmetrics__.compress=function(e){var r,n,a,c,u=["{"];for(var h in e){if(r=e[h],isNaN(parseInt(h,10))?n="'"+h+"'":(h=parseInt(h,10),n=(n=o(h).slice(2)).slice(0,-1)+i[n.slice(-1)]),"number"==typeof r)r<0?(a=o(r).slice(3),c="-"):(a=o(r).slice(2),c=""),a=c+a.slice(0,-1)+i[a.slice(-1)];else {if("object"!==_typeof$2(r))throw new Error("Don't know what to do with value type "+_typeof$2(r)+".");a=s(r);}u.push(n+a);}return u.push("}"),u.join("")},c=e.__fontmetrics__.uncompress=function(t){if("string"!=typeof t)throw new Error("Invalid argument passed to uncompress.");for(var e,r,i,a,o={},s=1,c=o,u=[],h="",l="",f=t.length-1,d=1;d<f;d+=1)"'"==(a=t[d])?e?(i=e.join(""),e=void 0):e=[]:e?e.push(a):"{"==a?(u.push([c,i]),c={},i=void 0):"}"==a?((r=u.pop())[0][r[1]]=c,i=void 0,c=r[0]):"-"==a?s=-1:void 0===i?n.hasOwnProperty(a)?(h+=n[a],i=parseInt(h,16)*s,s=1,h=""):h+=a:n.hasOwnProperty(a)?(l+=n[a],c[i]=parseInt(l,16)*s,s=1,i=void 0,l=""):l+=a;return o},u={codePages:["WinAnsiEncoding"],WinAnsiEncoding:c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},h={Unicode:{Courier:u,"Courier-Bold":u,"Courier-BoldOblique":u,"Courier-Oblique":u,Helvetica:u,"Helvetica-Bold":u,"Helvetica-BoldOblique":u,"Helvetica-Oblique":u,"Times-Roman":u,"Times-Bold":u,"Times-BoldItalic":u,"Times-Italic":u}},l={Unicode:{"Courier-Oblique":c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}};e.events.push(["addFont",function(t){var e=t.font,r=l.Unicode[e.postScriptName];r&&(e.metadata.Unicode={},e.metadata.Unicode.widths=r.widths,e.metadata.Unicode.kerning=r.kerning);var n=h.Unicode[e.postScriptName];n&&(e.metadata.Unicode.encoding=n,e.encoding=n.codePages[0]);}]);}(E.API),
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(t){for(var e=t.length,r=new Uint8Array(e),n=0;n<e;n++)r[n]=t.charCodeAt(n);return r};t.API.events.push(["addFont",function(r){var n=void 0,i=r.font,a=r.instance;if(!i.isStandardFont){if(void 0===a)throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('"+i.postScriptName+"').");if("string"!=typeof(n=!1===a.existsFileInVFS(i.postScriptName)?a.loadFile(i.postScriptName):a.getFileFromVFS(i.postScriptName)))throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('"+i.postScriptName+"').");!function(r,n){n=/^\x00\x01\x00\x00/.test(n)?e(n):e(u(n)),r.metadata=t.API.TTFFont.open(n),r.metadata.Unicode=r.metadata.Unicode||{encoding:{},kerning:{},widths:[]},r.metadata.glyIdsUsed=[0];}(i,n);}}]);}(E),
/** @license
 * Copyright (c) 2012 Willow Systems Corporation, https://github.com/willowsystems
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t){function e(){return (n.canvg?Promise.resolve(n.canvg):import('./index.es-2eee81a7.js')).catch((function(t){return Promise.reject(new Error("Could not load canvg: "+t))})).then((function(t){return t.default?t.default:t}))}E.API.addSvgAsImage=function(t,r,n,i,o,s,c,u){if(isNaN(r)||isNaN(n))throw a.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(i)||isNaN(o))throw a.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var h=document.createElement("canvas");h.width=i,h.height=o;var l=h.getContext("2d");l.fillStyle="#fff",l.fillRect(0,0,h.width,h.height);var f={ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0},d=this;return e().then((function(e){return e.fromString(l,t,f)}),(function(){return Promise.reject(new Error("Could not load canvg."))})).then((function(t){return t.render(f)})).then((function(){d.addImage(h.toDataURL("image/jpeg",1),r,n,i,o,c,u);}))};}(),E.API.putTotalPages=function(t){var e,r=0;parseInt(this.internal.getFont().id.substr(1),10)<15?(e=new RegExp(t,"g"),r=this.internal.getNumberOfPages()):(e=new RegExp(this.pdfEscape16(t,this.internal.getFont()),"g"),r=this.pdfEscape16(this.internal.getNumberOfPages()+"",this.internal.getFont()));for(var n=1;n<=this.internal.getNumberOfPages();n++)for(var i=0;i<this.internal.pages[n].length;i++)this.internal.pages[n][i]=this.internal.pages[n][i].replace(e,r);return this},E.API.viewerPreferences=function(e,r){var n;e=e||{},r=r||!1;var i,a,o,s={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},c=Object.keys(s),u=[],h=0,l=0,f=0;function d(t,e){var r,n=!1;for(r=0;r<t.length;r+=1)t[r]===e&&(n=!0);return n}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(s)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===e||!0===r){var p=c.length;for(f=0;f<p;f+=1)n[c[f]].value=n[c[f]].defaultValue,n[c[f]].explicitSet=!1;}if("object"===_typeof$2(e))for(a in e)if(o=e[a],d(c,a)&&void 0!==o){if("boolean"===n[a].type&&"boolean"==typeof o)n[a].value=o;else if("name"===n[a].type&&d(n[a].valueSet,o))n[a].value=o;else if("integer"===n[a].type&&Number.isInteger(o))n[a].value=o;else if("array"===n[a].type){for(h=0;h<o.length;h+=1)if(i=!0,1===o[h].length&&"number"==typeof o[h][0])u.push(String(o[h]-1));else if(o[h].length>1){for(l=0;l<o[h].length;l+=1)"number"!=typeof o[h][l]&&(i=!1);!0===i&&u.push([o[h][0]-1,o[h][1]-1].join(" "));}n[a].value="["+u.join(" ")+"]";}else n[a].value=n[a].defaultValue;n[a].explicitSet=!0;}return !1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",(function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>");})),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},
/** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t){var e=function(){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+this.internal.__metadata__.namespaceuri+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),r=unescape(encodeURIComponent(t)),n=unescape(encodeURIComponent(this.internal.__metadata__.metadata)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),a=unescape(encodeURIComponent("</x:xmpmeta>")),o=r.length+n.length+i.length+e.length+a.length;this.internal.__metadata__.metadata_object_number=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+o+" >>"),this.internal.write("stream"),this.internal.write(e+r+n+i+a),this.internal.write("endstream"),this.internal.write("endobj");},r=function(){this.internal.__metadata__.metadata_object_number&&this.internal.write("/Metadata "+this.internal.__metadata__.metadata_object_number+" 0 R");};t.addMetadata=function(t,n){return void 0===this.internal.__metadata__&&(this.internal.__metadata__={metadata:t,namespaceuri:n||"http://jspdf.default.namespaceuri/"},this.internal.events.subscribe("putCatalog",r),this.internal.events.subscribe("postPutResources",e)),this};}(E.API),function(t){var e=t.API,r=e.pdfEscape16=function(t,e){for(var r,n=e.metadata.Unicode.widths,i=["","0","00","000","0000"],a=[""],o=0,s=t.length;o<s;++o){if(r=e.metadata.characterToGlyph(t.charCodeAt(o)),e.metadata.glyIdsUsed.push(r),e.metadata.toUnicode[r]=t.charCodeAt(o),-1==n.indexOf(r)&&(n.push(r),n.push([parseInt(e.metadata.widthOfGlyph(r),10)])),"0"==r)return a.join("");r=r.toString(16),a.push(i[4-r.length],r);}return a.join("")},n=function(t){var e,r,n,i,a,o,s;for(a="/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange",n=[],o=0,s=(r=Object.keys(t).sort((function(t,e){return t-e}))).length;o<s;o++)e=r[o],n.length>=100&&(a+="\n"+n.length+" beginbfchar\n"+n.join("\n")+"\nendbfchar",n=[]),void 0!==t[e]&&null!==t[e]&&"function"==typeof t[e].toString&&(i=("0000"+t[e].toString(16)).slice(-4),e=("0000"+(+e).toString(16)).slice(-4),n.push("<"+e+"><"+i+">"));return n.length&&(a+="\n"+n.length+" beginbfchar\n"+n.join("\n")+"\nendbfchar\n"),a+="endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend"};e.events.push(["putFont",function(e){!function(e){var r=e.font,i=e.out,a=e.newObject,o=e.putStream;if(r.metadata instanceof t.API.TTFFont&&"Identity-H"===r.encoding){for(var s=r.metadata.Unicode.widths,c=r.metadata.subset.encode(r.metadata.glyIdsUsed,1),u="",h=0;h<c.length;h++)u+=String.fromCharCode(c[h]);var l=a();o({data:u,addLength1:!0,objectId:l}),i("endobj");var f=a();o({data:n(r.metadata.toUnicode),addLength1:!0,objectId:f}),i("endobj");var d=a();i("<<"),i("/Type /FontDescriptor"),i("/FontName /"+F(r.fontName)),i("/FontFile2 "+l+" 0 R"),i("/FontBBox "+t.API.PDFObject.convert(r.metadata.bbox)),i("/Flags "+r.metadata.flags),i("/StemV "+r.metadata.stemV),i("/ItalicAngle "+r.metadata.italicAngle),i("/Ascent "+r.metadata.ascender),i("/Descent "+r.metadata.decender),i("/CapHeight "+r.metadata.capHeight),i(">>"),i("endobj");var p=a();i("<<"),i("/Type /Font"),i("/BaseFont /"+F(r.fontName)),i("/FontDescriptor "+d+" 0 R"),i("/W "+t.API.PDFObject.convert(s)),i("/CIDToGIDMap /Identity"),i("/DW 1000"),i("/Subtype /CIDFontType2"),i("/CIDSystemInfo"),i("<<"),i("/Supplement 0"),i("/Registry (Adobe)"),i("/Ordering ("+r.encoding+")"),i(">>"),i(">>"),i("endobj"),r.objectNumber=a(),i("<<"),i("/Type /Font"),i("/Subtype /Type0"),i("/ToUnicode "+f+" 0 R"),i("/BaseFont /"+F(r.fontName)),i("/Encoding /"+r.encoding),i("/DescendantFonts ["+p+" 0 R]"),i(">>"),i("endobj"),r.isAlreadyPutted=!0;}}(e);}]);e.events.push(["putFont",function(e){!function(e){var r=e.font,i=e.out,a=e.newObject,o=e.putStream;if(r.metadata instanceof t.API.TTFFont&&"WinAnsiEncoding"===r.encoding){for(var s=r.metadata.rawData,c="",u=0;u<s.length;u++)c+=String.fromCharCode(s[u]);var h=a();o({data:c,addLength1:!0,objectId:h}),i("endobj");var l=a();o({data:n(r.metadata.toUnicode),addLength1:!0,objectId:l}),i("endobj");var f=a();i("<<"),i("/Descent "+r.metadata.decender),i("/CapHeight "+r.metadata.capHeight),i("/StemV "+r.metadata.stemV),i("/Type /FontDescriptor"),i("/FontFile2 "+h+" 0 R"),i("/Flags 96"),i("/FontBBox "+t.API.PDFObject.convert(r.metadata.bbox)),i("/FontName /"+F(r.fontName)),i("/ItalicAngle "+r.metadata.italicAngle),i("/Ascent "+r.metadata.ascender),i(">>"),i("endobj"),r.objectNumber=a();for(var d=0;d<r.metadata.hmtx.widths.length;d++)r.metadata.hmtx.widths[d]=parseInt(r.metadata.hmtx.widths[d]*(1e3/r.metadata.head.unitsPerEm));i("<</Subtype/TrueType/Type/Font/ToUnicode "+l+" 0 R/BaseFont/"+F(r.fontName)+"/FontDescriptor "+f+" 0 R/Encoding/"+r.encoding+" /FirstChar 29 /LastChar 255 /Widths "+t.API.PDFObject.convert(r.metadata.hmtx.widths)+">>"),i("endobj"),r.isAlreadyPutted=!0;}}(e);}]);var i=function(t){var e,n=t.text||"",i=t.x,a=t.y,o=t.options||{},s=t.mutex||{},c=s.pdfEscape,u=s.activeFontKey,h=s.fonts,l=u,f="",d=0,p="",g=h[l].encoding;if("Identity-H"!==h[l].encoding)return {text:n,x:i,y:a,options:o,mutex:s};for(p=n,l=u,Array.isArray(n)&&(p=n[0]),d=0;d<p.length;d+=1)h[l].metadata.hasOwnProperty("cmap")&&(e=h[l].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]),e||p[d].charCodeAt(0)<256&&h[l].metadata.hasOwnProperty("Unicode")?f+=p[d]:f+="";var m="";return parseInt(l.slice(1))<14||"WinAnsiEncoding"===g?m=c(f,l).split("").map((function(t){return t.charCodeAt(0).toString(16)})).join(""):"Identity-H"===g&&(m=r(f,h[l])),s.isHex=!0,{text:m,x:i,y:a,options:o,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",r=[],n={text:e,x:t.x,y:t.y,options:t.options,mutex:t.mutex};if(Array.isArray(e)){var a=0;for(a=0;a<e.length;a+=1)Array.isArray(e[a])&&3===e[a].length?r.push([i(Object.assign({},n,{text:e[a][0]})).text,e[a][1],e[a][2]]):r.push(i(Object.assign({},n,{text:e[a]})).text);t.text=r;}else t.text=i(Object.assign({},n,{text:e})).text;}]);}(E),
/**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(){return void 0===this.internal.vFS&&(this.internal.vFS={}),!0};t.existsFileInVFS=function(t){return e.call(this),void 0!==this.internal.vFS[t]},t.addFileToVFS=function(t,r){return e.call(this),this.internal.vFS[t]=r,this},t.getFileFromVFS=function(t){return e.call(this),void 0!==this.internal.vFS[t]?this.internal.vFS[t]:null};}(E.API),
/**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */
function(t){t.__bidiEngine__=t.prototype.__bidiEngine__=function(t){var r,n,i,a,o,s,c,u=e,h=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],l=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],f={L:0,R:1,EN:2,AN:3,N:4,B:5,S:6},d={0:0,5:1,6:2,7:3,32:4,251:5,254:6,255:7},p=["(",")","(","<",">","<","[","]","[","{","}","{","«","»","«","‹","›","‹","⁅","⁆","⁅","⁽","⁾","⁽","₍","₎","₍","≤","≥","≤","〈","〉","〈","﹙","﹚","﹙","﹛","﹜","﹛","﹝","﹞","﹝","﹤","﹥","﹤"],g=new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),m=!1,v=0;this.__bidiEngine__={};var b=function(t){var e=t.charCodeAt(),r=e>>8,n=d[r];return void 0!==n?u[256*n+(255&e)]:252===r||253===r?"AL":g.test(r)?"L":8===r?"R":"N"},y=function(t){for(var e,r=0;r<t.length;r++){if("L"===(e=b(t.charAt(r))))return !1;if("R"===e)return !0}return !1},w=function(t,e,o,s){var c,u,h,l,f=e[s];switch(f){case"L":case"R":m=!1;break;case"N":case"AN":break;case"EN":m&&(f="AN");break;case"AL":m=!0,f="R";break;case"WS":f="N";break;case"CS":s<1||s+1>=e.length||"EN"!==(c=o[s-1])&&"AN"!==c||"EN"!==(u=e[s+1])&&"AN"!==u?f="N":m&&(u="AN"),f=u===c?u:"N";break;case"ES":f="EN"===(c=s>0?o[s-1]:"B")&&s+1<e.length&&"EN"===e[s+1]?"EN":"N";break;case"ET":if(s>0&&"EN"===o[s-1]){f="EN";break}if(m){f="N";break}for(h=s+1,l=e.length;h<l&&"ET"===e[h];)h++;f=h<l&&"EN"===e[h]?"EN":"N";break;case"NSM":if(i&&!a){for(l=e.length,h=s+1;h<l&&"NSM"===e[h];)h++;if(h<l){var d=t[s],p=d>=1425&&d<=2303||64286===d;if(c=e[h],p&&("R"===c||"AL"===c)){f="R";break}}}f=s<1||"B"===(c=e[s-1])?"N":o[s-1];break;case"B":m=!1,r=!0,f=v;break;case"S":n=!0,f="N";break;case"LRE":case"RLE":case"LRO":case"RLO":case"PDF":m=!1;break;case"BN":f="N";}return f},N=function(t,e,r){var n=t.split("");return r&&L(n,r,{hiLevel:v}),n.reverse(),e&&e.reverse(),n.join("")},L=function(t,e,i){var a,o,s,c,u,d=-1,p=t.length,g=0,y=[],N=v?l:h,L=[];for(m=!1,r=!1,n=!1,o=0;o<p;o++)L[o]=b(t[o]);for(s=0;s<p;s++){if(u=g,y[s]=w(t,L,y,s),a=240&(g=N[u][f[y[s]]]),g&=15,e[s]=c=N[g][5],a>0)if(16===a){for(o=d;o<s;o++)e[o]=1;d=-1;}else d=-1;if(N[g][6])-1===d&&(d=s);else if(d>-1){for(o=d;o<s;o++)e[o]=c;d=-1;}"B"===L[s]&&(e[s]=0),i.hiLevel|=c;}n&&function(t,e,r){for(var n=0;n<r;n++)if("S"===t[n]){e[n]=v;for(var i=n-1;i>=0&&"WS"===t[i];i--)e[i]=v;}}(L,e,p);},A=function(t,e,n,i,a){if(!(a.hiLevel<t)){if(1===t&&1===v&&!r)return e.reverse(),void(n&&n.reverse());for(var o,s,c,u,h=e.length,l=0;l<h;){if(i[l]>=t){for(c=l+1;c<h&&i[c]>=t;)c++;for(u=l,s=c-1;u<s;u++,s--)o=e[u],e[u]=e[s],e[s]=o,n&&(o=n[u],n[u]=n[s],n[s]=o);l=c;}l++;}}},x=function(t,e,r){var n=t.split(""),i={hiLevel:v};return r||(r=[]),L(n,r,i),function(t,e,r){if(0!==r.hiLevel&&c)for(var n,i=0;i<t.length;i++)1===e[i]&&(n=p.indexOf(t[i]))>=0&&(t[i]=p[n+1]);}(n,r,i),A(2,n,e,r,i),A(1,n,e,r,i),n.join("")};return this.__bidiEngine__.doBidiReorder=function(t,e,r){if(function(t,e){if(e)for(var r=0;r<t.length;r++)e[r]=r;void 0===a&&(a=y(t)),void 0===s&&(s=y(t));}(t,e),i||!o||s)if(i&&o&&a^s)v=a?1:0,t=N(t,e,r);else if(!i&&o&&s)v=a?1:0,t=x(t,e,r),t=N(t,e);else if(!i||a||o||s){if(i&&!o&&a^s)t=N(t,e),a?(v=0,t=x(t,e,r)):(v=1,t=x(t,e,r),t=N(t,e));else if(i&&a&&!o&&s)v=1,t=x(t,e,r),t=N(t,e);else if(!i&&!o&&a^s){var n=c;a?(v=1,t=x(t,e,r),v=0,c=!1,t=x(t,e,r),c=n):(v=0,t=x(t,e,r),t=N(t,e),v=1,c=!1,t=x(t,e,r),c=n,t=N(t,e));}}else v=0,t=x(t,e,r);else v=a?1:0,t=x(t,e,r);return t},this.__bidiEngine__.setOptions=function(t){t&&(i=t.isInputVisual,o=t.isOutputVisual,a=t.isInputRtl,s=t.isOutputRtl,c=t.isSymmetricSwapping);},this.__bidiEngine__.setOptions(t),this.__bidiEngine__};var e=["BN","BN","BN","BN","BN","BN","BN","BN","BN","S","B","S","WS","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","B","B","B","S","WS","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","BN","BN","BN","BN","BN","BN","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","CS","N","ET","ET","ET","ET","N","N","N","N","L","N","N","BN","N","N","ET","ET","EN","EN","N","L","N","N","N","EN","L","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","N","N","N","N","N","ET","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","NSM","R","NSM","NSM","R","NSM","NSM","R","NSM","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","N","N","N","N","N","R","R","R","R","R","N","N","N","N","N","N","N","N","N","N","N","AN","AN","AN","AN","AN","AN","N","N","AL","ET","ET","AL","CS","AL","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","AN","AN","AN","AN","AN","AN","AN","AN","AN","ET","AN","AN","AL","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","N","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","NSM","NSM","N","NSM","NSM","NSM","NSM","AL","AL","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","R","N","N","N","N","R","N","N","N","N","N","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","BN","BN","BN","L","R","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","B","LRE","RLE","PDF","LRO","RLO","CS","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","BN","BN","BN","BN","BN","N","LRI","RLI","FSI","PDI","BN","BN","BN","BN","BN","BN","EN","L","N","N","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","L","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","N","N","N","N","N","R","NSM","R","R","R","R","R","R","R","R","R","R","ES","R","R","R","R","R","R","R","R","R","R","R","R","R","N","R","R","R","R","R","N","R","N","R","R","N","R","R","N","R","R","R","R","R","R","R","R","R","R","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","CS","N","N","CS","N","N","N","N","N","N","N","N","N","ET","N","N","ES","ES","N","N","N","N","N","ET","ET","N","N","N","N","N","AL","AL","AL","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","BN","N","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","N","N","N","ET","ET","N","N","N","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N"],r=new t.__bidiEngine__({isInputVisual:!0});t.API.events.push(["postProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),i=(t.mutex,n.lang,[]);if(n.isInputVisual="boolean"!=typeof n.isInputVisual||n.isInputVisual,r.setOptions(n),"[object Array]"===Object.prototype.toString.call(e)){var a=0;for(i=[],a=0;a<e.length;a+=1)"[object Array]"===Object.prototype.toString.call(e[a])?i.push([r.doBidiReorder(e[a][0]),e[a][1],e[a][2]]):i.push([r.doBidiReorder(e[a])]);t.text=i;}else t.text=r.doBidiReorder(e);r.setOptions({isInputVisual:!0});}]);}(E),E.API.TTFFont=function(){function t(t){var e;if(this.rawData=t,e=this.contents=new ne(t),this.contents.pos=4,"ttcf"===e.readString(4))throw new Error("TTCF not supported.");e.pos=0,this.parse(),this.subset=new Le(this),this.registerTTF();}return t.open=function(e){return new t(e)},t.prototype.parse=function(){return this.directory=new ie(this.contents),this.head=new se(this),this.name=new pe(this),this.cmap=new ue(this),this.toUnicode={},this.hhea=new he(this),this.maxp=new ge(this),this.hmtx=new me(this),this.post=new fe(this),this.os2=new le(this),this.loca=new Ne(this),this.glyf=new be(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},t.prototype.registerTTF=function(){var t,e,r,n,i;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var e,r,n,i;for(i=[],e=0,r=(n=this.bbox).length;e<r;e++)t=n[e],i.push(Math.round(t*this.scaleFactor));return i}.call(this),this.stemV=0,this.post.exists?(r=255&(n=this.post.italic_angle),0!=(32768&(e=n>>16))&&(e=-(1+(65535^e))),this.italicAngle=+(e+"."+r)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(i=this.familyClass)||2===i||3===i||4===i||5===i||7===i,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},t.prototype.characterToGlyph=function(t){var e;return (null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},t.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},t.prototype.widthOfString=function(t,e,r){var n,i,a,o;for(a=0,i=0,o=(t=""+t).length;0<=o?i<o:i>o;i=0<=o?++i:--i)n=t.charCodeAt(i),a+=this.widthOfGlyph(this.characterToGlyph(n))+r*(1e3/e)||0;return a*(e/1e3)},t.prototype.lineHeight=function(t,e){var r;return null==e&&(e=!1),r=e?this.lineGap:0,(this.ascender+r-this.decender)/1e3*t},t}();var re,ne=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length;}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return (t=this.readUInt32())>=2147483648?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return (t=this.readUInt16())>=32768?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,r;for(r=[],e=0;0<=t?e<t:e>t;e=0<=t?++e:--e)r[e]=String.fromCharCode(this.readByte());return r.join("")},t.prototype.writeString=function(t){var e,r,n;for(n=[],e=0,r=t.length;0<=r?e<r:e>r;e=0<=r?++e:--e)n.push(this.writeByte(t.charCodeAt(e)));return n},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,r,n,i,a,o,s;return t=this.readByte(),e=this.readByte(),r=this.readByte(),n=this.readByte(),i=this.readByte(),a=this.readByte(),o=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^r)+4294967296*(255^n)+16777216*(255^i)+65536*(255^a)+256*(255^o)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*r+4294967296*n+16777216*i+65536*a+256*o+s},t.prototype.writeLongLong=function(t){var e,r;return e=Math.floor(t/4294967296),r=4294967295&t,this.writeByte(e>>24&255),this.writeByte(e>>16&255),this.writeByte(e>>8&255),this.writeByte(255&e),this.writeByte(r>>24&255),this.writeByte(r>>16&255),this.writeByte(r>>8&255),this.writeByte(255&r)},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,r;for(e=[],r=0;0<=t?r<t:r>t;r=0<=t?++r:--r)e.push(this.readByte());return e},t.prototype.write=function(t){var e,r,n,i;for(i=[],r=0,n=t.length;r<n;r++)e=t[r],i.push(this.writeByte(e));return i},t}(),ie=function(){var t;function e(t){var e,r,n;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},r=0,n=this.tableCount;0<=n?r<n:r>n;r=0<=n?++r:--r)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e;}return e.prototype.encode=function(e){var r,n,i,a,o,s,c,u,h,l,f,d,p;for(p in f=Object.keys(e).length,s=Math.log(2),h=16*Math.floor(Math.log(f)/s),a=Math.floor(h/s),u=16*f-h,(n=new ne).writeInt(this.scalarType),n.writeShort(f),n.writeShort(h),n.writeShort(a),n.writeShort(u),i=16*f,c=n.pos+i,o=null,d=[],e)for(l=e[p],n.writeString(p),n.writeInt(t(l)),n.writeInt(c),n.writeInt(l.length),d=d.concat(l),"head"===p&&(o=c),c+=l.length;c%4;)d.push(0),c++;return n.write(d),r=2981146554-t(n.data),n.pos=o+8,n.writeUInt32(r),n.data},t=function(t){var e,r,n,i;for(t=ve.call(t);t.length%4;)t.push(0);for(n=new ne(t),r=0,e=0,i=t.length;e<i;e=e+=4)r+=n.readUInt32();return 4294967295&r},e}(),ae={}.hasOwnProperty,oe=function(t,e){for(var r in e)ae.call(e,r)&&(t[r]=e[r]);function n(){this.constructor=t;}return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t};re=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents));}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var se=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e.prototype.encode=function(t){var e;return (e=new ne).writeInt(this.version),e.writeInt(this.revision),e.writeInt(this.checkSumAdjustment),e.writeInt(this.magicNumber),e.writeShort(this.flags),e.writeShort(this.unitsPerEm),e.writeLongLong(this.created),e.writeLongLong(this.modified),e.writeShort(this.xMin),e.writeShort(this.yMin),e.writeShort(this.xMax),e.writeShort(this.yMax),e.writeShort(this.macStyle),e.writeShort(this.lowestRecPPEM),e.writeShort(this.fontDirectionHint),e.writeShort(t),e.writeShort(this.glyphDataFormat),e.data},e}(),ce=function(){function t(t,e){var r,n,i,a,o,s,c,u,h,l,f,d,p,g,m,v,b;switch(this.platformID=t.readUInt16(),this.encodingID=t.readShort(),this.offset=e+t.readInt(),h=t.pos,t.pos=this.offset,this.format=t.readUInt16(),this.length=t.readUInt16(),this.language=t.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=0;s<256;++s)this.codeMap[s]=t.readByte();break;case 4:for(f=t.readUInt16(),l=f/2,t.pos+=6,i=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),t.pos+=2,p=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),c=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),u=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),n=(this.length-t.pos+this.offset)/2,o=function(){var e,r;for(r=[],s=e=0;0<=n?e<n:e>n;s=0<=n?++e:--e)r.push(t.readUInt16());return r}(),s=m=0,b=i.length;m<b;s=++m)for(g=i[s],r=v=d=p[s];d<=g?v<=g:v>=g;r=d<=g?++v:--v)0===u[s]?a=r+c[s]:0!==(a=o[u[s]/2+(r-d)-(l-s)]||0)&&(a+=c[s]),this.codeMap[r]=65535&a;}t.pos=h;}return t.encode=function(t,e){var r,n,i,a,o,s,c,u,h,l,f,d,p,g,m,v,b,y,w,N,L,A,x,S,_,P,k,I,F,C,j,O,B,M,E,q,D,R,T,U,z,H,W,V,G,Y;switch(I=new ne,a=Object.keys(t).sort((function(t,e){return t-e})),e){case"macroman":for(p=0,g=function(){var t=[];for(d=0;d<256;++d)t.push(0);return t}(),v={0:0},i={},F=0,B=a.length;F<B;F++)null==v[W=t[n=a[F]]]&&(v[W]=++p),i[n]={old:t[n],new:v[t[n]]},g[n]=v[t[n]];return I.writeUInt16(1),I.writeUInt16(0),I.writeUInt32(12),I.writeUInt16(0),I.writeUInt16(262),I.writeUInt16(0),I.write(g),{charMap:i,subtable:I.data,maxGlyphID:p+1};case"unicode":for(P=[],h=[],b=0,v={},r={},m=c=null,C=0,M=a.length;C<M;C++)null==v[w=t[n=a[C]]]&&(v[w]=++b),r[n]={old:w,new:v[w]},o=v[w]-n,null!=m&&o===c||(m&&h.push(m),P.push(n),c=o),m=n;for(m&&h.push(m),h.push(65535),P.push(65535),S=2*(x=P.length),A=2*Math.pow(Math.log(x)/Math.LN2,2),l=Math.log(A/2)/Math.LN2,L=2*x-A,s=[],N=[],f=[],d=j=0,E=P.length;j<E;d=++j){if(_=P[d],u=h[d],65535===_){s.push(0),N.push(0);break}if(_-(k=r[_].new)>=32768)for(s.push(0),N.push(2*(f.length+x-d)),n=O=_;_<=u?O<=u:O>=u;n=_<=u?++O:--O)f.push(r[n].new);else s.push(k-_),N.push(0);}for(I.writeUInt16(3),I.writeUInt16(1),I.writeUInt32(12),I.writeUInt16(4),I.writeUInt16(16+8*x+2*f.length),I.writeUInt16(0),I.writeUInt16(S),I.writeUInt16(A),I.writeUInt16(l),I.writeUInt16(L),z=0,q=h.length;z<q;z++)n=h[z],I.writeUInt16(n);for(I.writeUInt16(0),H=0,D=P.length;H<D;H++)n=P[H],I.writeUInt16(n);for(V=0,R=s.length;V<R;V++)o=s[V],I.writeUInt16(o);for(G=0,T=N.length;G<T;G++)y=N[G],I.writeUInt16(y);for(Y=0,U=f.length;Y<U;Y++)p=f[Y],I.writeUInt16(p);return {charMap:r,subtable:I.data,maxGlyphID:b+1}}},t}(),ue=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,r,n;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:r>n;r=0<=n?++r:--r)e=new ce(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return !0},e.encode=function(t,e){var r,n;return null==e&&(e="macroman"),r=ce.encode(t,e),(n=new ne).writeUInt16(0),n.writeUInt16(1),r.table=n.data.concat(r.subtable),r},e}(),he=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),le=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="OS/2",e.prototype.parse=function(t){if(t.pos=this.offset,this.version=t.readUInt16(),this.averageCharWidth=t.readShort(),this.weightClass=t.readUInt16(),this.widthClass=t.readUInt16(),this.type=t.readShort(),this.ySubscriptXSize=t.readShort(),this.ySubscriptYSize=t.readShort(),this.ySubscriptXOffset=t.readShort(),this.ySubscriptYOffset=t.readShort(),this.ySuperscriptXSize=t.readShort(),this.ySuperscriptYSize=t.readShort(),this.ySuperscriptXOffset=t.readShort(),this.ySuperscriptYOffset=t.readShort(),this.yStrikeoutSize=t.readShort(),this.yStrikeoutPosition=t.readShort(),this.familyClass=t.readShort(),this.panose=function(){var e,r;for(r=[],e=0;e<10;++e)r.push(t.readByte());return r}(),this.charRange=function(){var e,r;for(r=[],e=0;e<4;++e)r.push(t.readInt());return r}(),this.vendorID=t.readString(4),this.selection=t.readShort(),this.firstCharIndex=t.readShort(),this.lastCharIndex=t.readShort(),this.version>0&&(this.ascent=t.readShort(),this.descent=t.readShort(),this.lineGap=t.readShort(),this.winAscent=t.readShort(),this.winDescent=t.readShort(),this.codePageRange=function(){var e,r;for(r=[],e=0;e<2;e=++e)r.push(t.readInt());return r}(),this.version>1))return this.xHeight=t.readShort(),this.capHeight=t.readShort(),this.defaultChar=t.readShort(),this.breakChar=t.readShort(),this.maxContext=t.readShort()},e}(),fe=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="post",e.prototype.parse=function(t){var e,r,n;switch(t.pos=this.offset,this.format=t.readInt(),this.italicAngle=t.readInt(),this.underlinePosition=t.readShort(),this.underlineThickness=t.readShort(),this.isFixedPitch=t.readInt(),this.minMemType42=t.readInt(),this.maxMemType42=t.readInt(),this.minMemType1=t.readInt(),this.maxMemType1=t.readInt(),this.format){case 65536:break;case 131072:var i;for(r=t.readUInt16(),this.glyphNameIndex=[],i=0;0<=r?i<r:i>r;i=0<=r?++i:--i)this.glyphNameIndex.push(t.readUInt16());for(this.names=[],n=[];t.pos<this.offset+this.length;)e=t.readByte(),n.push(this.names.push(t.readString(e)));return n;case 151552:return r=t.readUInt16(),this.offsets=t.read(r);case 196608:break;case 262144:return this.map=function(){var e,r,n;for(n=[],i=e=0,r=this.file.maxp.numGlyphs;0<=r?e<r:e>r;i=0<=r?++e:--e)n.push(t.readUInt32());return n}.call(this)}},e}(),de=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID;},pe=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="name",e.prototype.parse=function(t){var e,r,n,i,a,o,s,c,u,h,l;for(t.pos=this.offset,t.readShort(),e=t.readShort(),o=t.readShort(),r=[],i=0;0<=e?i<e:i>e;i=0<=e?++i:--i)r.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+o+t.readShort()});for(s={},i=u=0,h=r.length;u<h;i=++u)n=r[i],t.pos=n.offset,c=t.readString(n.length),a=new de(c,n),null==s[l=n.nameID]&&(s[l]=[]),s[n.nameID].push(a);this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5];try{this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"");}catch(t){this.postscriptName=s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"");}return this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),ge=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),me=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="hmtx",e.prototype.parse=function(t){var e,r,n,i,a,o,s;for(t.pos=this.offset,this.metrics=[],e=0,o=this.file.hhea.numberOfMetrics;0<=o?e<o:e>o;e=0<=o?++e:--e)this.metrics.push({advance:t.readUInt16(),lsb:t.readInt16()});for(n=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var r,i;for(i=[],e=r=0;0<=n?r<n:r>n;e=0<=n?++r:--r)i.push(t.readInt16());return i}(),this.widths=function(){var t,e,r,n;for(n=[],t=0,e=(r=this.metrics).length;t<e;t++)i=r[t],n.push(i.advance);return n}.call(this),r=this.widths[this.widths.length-1],s=[],e=a=0;0<=n?a<n:a>n;e=0<=n?++a:--a)s.push(this.widths.push(r));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),ve=[].slice,be=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="glyf",e.prototype.parse=function(){return this.cache={}},e.prototype.glyphFor=function(t){var e,r,n,i,a,o,s,c,u,h;return t in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,r=i.indexOf(t),0===(n=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+r,a=(o=new ne(e.read(n))).readShort(),c=o.readShort(),h=o.readShort(),s=o.readShort(),u=o.readShort(),this.cache[t]=-1===a?new we(o,c,h,s,u):new ye(o,a,c,h,s,u),this.cache[t]))},e.prototype.encode=function(t,e,r){var n,i,a,o,s;for(a=[],i=[],o=0,s=e.length;o<s;o++)n=t[e[o]],i.push(a.length),n&&(a=a.concat(n.encode(r)));return i.push(a.length),{table:a,offsets:i}},e}(),ye=function(){function t(t,e,r,n,i,a){this.raw=t,this.numberOfContours=e,this.xMin=r,this.yMin=n,this.xMax=i,this.yMax=a,this.compound=!1;}return t.prototype.encode=function(){return this.raw.data},t}(),we=function(){function t(t,e,r,n,i){var a,o;for(this.raw=t,this.xMin=e,this.yMin=r,this.xMax=n,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],a=this.raw;o=a.readShort(),this.glyphOffsets.push(a.pos),this.glyphIDs.push(a.readUInt16()),32&o;)a.pos+=1&o?4:2,128&o?a.pos+=8:64&o?a.pos+=4:8&o&&(a.pos+=2);}return t.prototype.encode=function(){var t,e,r;for(e=new ne(ve.call(this.raw.data)),t=0,r=this.glyphIDs.length;t<r;++t)e.pos=this.glyphOffsets[t];return e.data},t}(),Ne=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="loca",e.prototype.parse=function(t){var e,r;return t.pos=this.offset,e=this.file.head.indexToLocFormat,this.offsets=0===e?function(){var e,n;for(n=[],r=0,e=this.length;r<e;r+=2)n.push(2*t.readUInt16());return n}.call(this):function(){var e,n;for(n=[],r=0,e=this.length;r<e;r+=4)n.push(t.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var r=new Uint32Array(this.offsets.length),n=0,i=0,a=0;a<r.length;++a)if(r[a]=n,i<e.length&&e[i]==a){++i,r[a]=n;var o=this.offsets[a],s=this.offsets[a+1]-o;s>0&&(n+=s);}for(var c=new Array(4*r.length),u=0;u<r.length;++u)c[4*u+3]=255&r[u],c[4*u+2]=(65280&r[u])>>8,c[4*u+1]=(16711680&r[u])>>16,c[4*u]=(4278190080&r[u])>>24;return c},e}(),Le=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33;}return t.prototype.generateCmap=function(){var t,e,r,n,i;for(e in n=this.font.cmap.tables[0].codeMap,t={},i=this.subset)r=i[e],t[e]=n[r];return t},t.prototype.glyphsFor=function(t){var e,r,n,i,a,o,s;for(n={},a=0,o=t.length;a<o;a++)n[i=t[a]]=this.font.glyf.glyphFor(i);for(i in e=[],n)(null!=(r=n[i])?r.compound:void 0)&&e.push.apply(e,r.glyphIDs);if(e.length>0)for(i in s=this.glyphsFor(e))r=s[i],n[i]=r;return n},t.prototype.encode=function(t,e){var r,n,i,a,o,s,c,u,h,l,f,d,p,g,m;for(n in r=ue.encode(this.generateCmap(),"unicode"),a=this.glyphsFor(t),f={0:0},m=r.charMap)f[(s=m[n]).old]=s.new;for(d in l=r.maxGlyphID,a)d in f||(f[d]=l++);return u=function(t){var e,r;for(e in r={},t)r[t[e]]=e;return r}(f),h=Object.keys(u).sort((function(t,e){return t-e})),p=function(){var t,e,r;for(r=[],t=0,e=h.length;t<e;t++)o=h[t],r.push(u[o]);return r}(),i=this.font.glyf.encode(a,p,f),c=this.font.loca.encode(i.offsets,p),g={cmap:this.font.cmap.raw(),glyf:i.table,loca:c,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.encode(e)},this.font.os2.exists&&(g["OS/2"]=this.font.os2.raw()),this.font.directory.encode(g)},t}();E.API.PDFObject=function(){var t;function e(){}return t=function(t,e){return (Array(e+1).join("0")+t).slice(-e)},e.convert=function(r){var n,i,a,o;if(Array.isArray(r))return "["+function(){var t,i,a;for(a=[],t=0,i=r.length;t<i;t++)n=r[t],a.push(e.convert(n));return a}().join(" ")+"]";if("string"==typeof r)return "/"+r;if(null!=r?r.isString:void 0)return "("+r+")";if(r instanceof Date)return "(D:"+t(r.getUTCFullYear(),4)+t(r.getUTCMonth(),2)+t(r.getUTCDate(),2)+t(r.getUTCHours(),2)+t(r.getUTCMinutes(),2)+t(r.getUTCSeconds(),2)+"Z)";if("[object Object]"==={}.toString.call(r)){for(i in a=["<<"],r)o=r[i],a.push("/"+i+" "+e.convert(o));return a.push(">>"),a.join("\n")}return ""+r},e}();

var template = ({ fontFaces, fontFamily, padding, content, pdfSelector }) => `
<style>
  ${fontFaces || ''}

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html, body {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
  }

  .main-container {
    width: 100vw;
    box-sizing: border-box;
    ${fontFamily ? `font-family: "${fontFamily}";` : ''}
    ${padding ? `padding: ${padding}px;` : ''}
  }

  .main-container a a,
  .main-container a u,
  .main-container u a,
  .main-container u u {
    text-decoration: none;
  }

  .main-container ul {
    padding-inline-start: 2em;
  }

  .main-container ul li {
    padding-left: 0.3em;
  }

  .main-container ol {
    padding-inline-start: 2.3em;
  }
</style>

<div id="${pdfSelector}" class="main-container">
  ${content || ''}
</div>
`;

class PDFCreator {
    constructor() {
        this.headerHeight = 0;
        this.footerHeight = 0;
        this.pdfWrapperId = 'pdfWrapperId';
        this.pdfSelector = 'pdfContainer';
        this.kioskComponentsVariablesId = 'custom-theme-variables';
        /**
         * Workaround for html2canvas bug, related to wrong underline position calculation for custom font
         */
        this.wrapUnderlineAndAnchorTagsContent = (doc) => {
            const anchors = Array.from(doc.body.querySelectorAll('a:not(a a, u a)'));
            const underlineElements = Array.from(doc.body.querySelectorAll('u:not(u u, a u)'));
            [...anchors, ...underlineElements].forEach((element) => {
                const cssStyles = window.getComputedStyle(element);
                const isUnderlined = cssStyles.textDecorationLine === 'underline' ||
                    cssStyles.textDecorationLine === 'inherit';
                if (!isUnderlined) {
                    return;
                }
                const borderBottomStyles = `${cssStyles.textDecorationThickness &&
                    cssStyles.textDecorationThickness !== 'auto'
                    ? cssStyles.textDecorationThickness
                    : '0.1em'} ${cssStyles.textDecorationStyle || 'solid'} ${cssStyles.textDecorationColor || 'currentColor'}`;
                element.style.textDecoration = 'none';
                element.innerHTML = this.splitElementContentCharacters(element, borderBottomStyles);
            });
        };
        this.splitElementContentCharacters = (element, borderBottomStyles) => {
            const nodes = Array.from(element.childNodes);
            if (!nodes.length) {
                return '';
            }
            return nodes.reduce((parentInnerHTML, node) => {
                if (node instanceof HTMLElement) {
                    node.innerHTML = this.splitElementContentCharacters(node, borderBottomStyles);
                    return parentInnerHTML + node.outerHTML;
                }
                if (!node.textContent)
                    return parentInnerHTML;
                return (parentInnerHTML +
                    node.textContent.replaceAll(/./g, (char) => {
                        const innerSpan = document.createElement('span');
                        innerSpan.textContent = char;
                        innerSpan.style.borderBottom = borderBottomStyles;
                        return innerSpan.outerHTML;
                    }));
            }, '');
        };
        this.wrapTextInBreakableSpanElements = (textContent) => {
            return `<span data-splitted="true">${textContent
                .split('.')
                .join('.</span><span data-splitted="true">')}</span>`;
        };
        this.alignElementToTop = (element, sizes) => {
            const isInlineElement = window.getComputedStyle(element).display === 'inline';
            element.setAttribute('style', `margin-top: ${this.topOfAvailableCurrentPageSpace - sizes.top}px; ${isInlineElement ? 'display: inline-block;' : ''}`);
        };
        this.startNewPage = (element, sizes, beforeElement = true) => {
            this.pageAmount++;
            this.addHeaderToCurrentPage();
            this.addFooterToCurrentPage();
            const marginToInnerTopOfNextPage = this.topOfAvailableCurrentPageSpace -
                (beforeElement ? sizes.top : sizes.bottom);
            const isInlineElement = window.getComputedStyle(element).display === 'inline';
            element.style[beforeElement ? 'marginTop' : 'marginBottom'] = `${marginToInnerTopOfNextPage}px`;
            if (isInlineElement) {
                element.style.display = 'inline-block';
            }
        };
        this.getElementOuterSizes = (htmlElement) => {
            const sizes = htmlElement.getBoundingClientRect();
            const { marginTop, marginBottom, marginLeft, marginRight } = window.getComputedStyle(htmlElement);
            return {
                top: Math.ceil(sizes.top - parseFloat(marginTop)),
                bottom: Math.ceil(sizes.bottom + parseFloat(marginBottom)),
                left: Math.ceil(sizes.left - parseFloat(marginLeft)),
                right: Math.ceil(sizes.right + parseFloat(marginRight)),
                height: Math.ceil(sizes.height + parseFloat(marginTop) + parseFloat(marginBottom)),
                width: Math.ceil(sizes.width + parseFloat(marginLeft) + parseFloat(marginRight)),
                x: Math.ceil(sizes.top - parseFloat(marginTop)),
                y: Math.ceil(sizes.left - parseFloat(marginLeft)),
            };
        };
        this.mapValidNodeElements = (element) => {
            if (element === this.slotsContainer)
                return undefined;
            if (element.nodeName === 'STYLE')
                return undefined;
            if (element.nodeType === Node.TEXT_NODE) {
                if (element.textContent === '\n')
                    return undefined;
                return { textElement: element };
            }
            if (element.nodeType === Node.ELEMENT_NODE)
                return { htmlElement: element };
            return undefined;
        };
        this.shouldElementBeSplitted = (sizes, dataset) => {
            return Boolean(sizes.bottom > this.bottomOfAvailableCurrentPageSpace ||
                (dataset === null || dataset === void 0 ? void 0 : dataset.breakPageBefore) ||
                (dataset === null || dataset === void 0 ? void 0 : dataset.breakPageAfter));
        };
        this.splitElementThroughPages = (doc, containerElement) => {
            var _a;
            if (!((_a = containerElement === null || containerElement === void 0 ? void 0 : containerElement.childNodes) === null || _a === void 0 ? void 0 : _a.length))
                return;
            Array.from(containerElement.childNodes)
                .map(this.mapValidNodeElements)
                .filter(isDefined)
                .forEach(({ htmlElement, textElement }) => {
                let wasElementSplitted = false;
                const range = textElement ? document.createRange() : undefined;
                if (textElement) {
                    range === null || range === void 0 ? void 0 : range.selectNodeContents(textElement);
                }
                let sizes = textElement && range
                    ? range.getBoundingClientRect()
                    : this.getElementOuterSizes(htmlElement);
                if (this.shouldElementBeSplitted(sizes, htmlElement === null || htmlElement === void 0 ? void 0 : htmlElement.dataset)) {
                    wasElementSplitted = true;
                    if (textElement === null || textElement === void 0 ? void 0 : textElement.textContent) {
                        const textWrapper = document.createElement('span');
                        textWrapper.innerHTML = this.wrapTextInBreakableSpanElements(textElement.textContent);
                        textElement.replaceWith(textWrapper);
                        this.splitElementThroughPages(doc, textWrapper);
                    }
                    else if (htmlElement) {
                        if (!this.pageAmount) {
                            this.startNewPage(htmlElement, sizes);
                            sizes = this.getElementOuterSizes(htmlElement);
                        }
                        if (htmlElement.dataset.breakPageAfter &&
                            sizes.bottom < doc.body.offsetHeight - PDFCreator.pdfMargin) {
                            this.startNewPage(htmlElement, sizes, false);
                            sizes = this.getElementOuterSizes(htmlElement);
                        }
                        if (htmlElement.dataset.breakPageBefore &&
                            sizes.top > doc.body.clientTop + PDFCreator.pdfMargin) {
                            this.startNewPage(htmlElement, sizes);
                            sizes = this.getElementOuterSizes(htmlElement);
                        }
                        if (sizes.bottom > this.bottomOfAvailableCurrentPageSpace &&
                            htmlElement.dataset.avoidBreakPageInside &&
                            sizes.height <= this.availableInnerHeightOfSinglePdfPage) {
                            this.startNewPage(htmlElement, sizes);
                            sizes = this.getElementOuterSizes(htmlElement);
                        }
                        if (sizes.bottom > this.bottomOfAvailableCurrentPageSpace) {
                            if (!htmlElement.childNodes.length ||
                                htmlElement.dataset.splitted) {
                                this.startNewPage(htmlElement, sizes);
                                sizes = this.getElementOuterSizes(htmlElement);
                            }
                            else {
                                this.splitElementThroughPages(doc, htmlElement);
                            }
                        }
                    }
                }
                if (!wasElementSplitted &&
                    htmlElement &&
                    this.topOfAvailableCurrentPageSpace > sizes.top) {
                    this.alignElementToTop(htmlElement, sizes);
                }
                range === null || range === void 0 ? void 0 : range.detach();
                return;
            });
        };
        this.filterOutRedundantElements = (element) => {
            const wrapper = document.getElementById(this.pdfWrapperId);
            if (!wrapper)
                return true;
            return !(element.tagName === 'HEAD' ||
                element.tagName === 'META' ||
                element.id === this.kioskComponentsVariablesId ||
                element === wrapper ||
                element.contains(wrapper) ||
                wrapper.contains(element));
        };
        this.prepareSlotsData = () => {
            var _a;
            this.headerElement = this.pdfContainer.querySelector('[data-slot="header"]');
            this.footerElement = this.pdfContainer.querySelector('[data-slot="footer"]');
            const parentOfSlots = (_a = (this.headerElement || this.footerElement)) === null || _a === void 0 ? void 0 : _a.parentElement;
            if (parentOfSlots) {
                this.slotsContainer = document.createElement('div');
                parentOfSlots.appendChild(this.slotsContainer);
            }
            if (this.headerElement) {
                const { height } = this.headerElement.getBoundingClientRect();
                const { marginBottom, marginTop } = window.getComputedStyle(this.headerElement);
                this.headerHeight = Math.ceil(height + parseFloat(marginBottom) + parseFloat(marginTop));
                this.headerElement.remove();
            }
            if (this.footerElement) {
                const { height } = this.footerElement.getBoundingClientRect();
                const { marginBottom, marginTop } = window.getComputedStyle(this.footerElement);
                this.footerHeight = Math.ceil(height + parseFloat(marginBottom) + parseFloat(marginTop));
                this.footerElement.remove();
            }
        };
        this.prepareDocumentBeforeRender = (doc) => {
            const pdfContainer = doc.getElementById(this.pdfSelector);
            if (!pdfContainer)
                return;
            this.pdfContainer = pdfContainer;
            this.prepareSlotsData();
            this.splitElementThroughPages(doc, this.pdfContainer);
            this.wrapUnderlineAndAnchorTagsContent(doc);
        };
        this.creator = new E({
            format: 'a4',
            unit: 'pt',
            putOnlyUsedFonts: true,
            compress: true,
        });
        this.pdfPageWidth = this.creator.internal.pageSize.getWidth();
        this.pdfPageHeight = this.creator.internal.pageSize.getHeight();
        this.pageAmount = 0;
        this.wrapperElement = document.createElement('div');
        this.wrapperElement.id = this.pdfWrapperId;
    }
    get availableInnerHeightOfSinglePdfPage() {
        return Math.ceil(this.pdfPageHeight -
            2 * PDFCreator.pdfMargin -
            this.headerHeight -
            this.footerHeight);
    }
    get availableInnerWidthOfSinglePdfPage() {
        return Math.ceil(this.pdfPageWidth - 2 * PDFCreator.pdfMargin);
    }
    get totalDocumentHeight() {
        return this.pdfPageHeight * this.pageAmount;
    }
    get bottomOfAvailableCurrentPageSpace() {
        if (!this.totalDocumentHeight)
            return 0;
        return Math.ceil(this.totalDocumentHeight - (PDFCreator.pdfMargin + this.footerHeight));
    }
    get topOfAvailableCurrentPageSpace() {
        if (!this.bottomOfAvailableCurrentPageSpace)
            return 0;
        return Math.ceil(this.bottomOfAvailableCurrentPageSpace -
            this.availableInnerHeightOfSinglePdfPage);
    }
    static prefetchFont(src) {
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = src;
        link.as = 'fetch';
        link.type = 'font/ttf';
        document.head.appendChild(link);
    }
    static configure(options) {
        const { margin, fonts, standardFont } = options;
        PDFCreator.mainFont = standardFont;
        if (isDefined(margin)) {
            PDFCreator.pdfMargin = margin;
        }
        if (isDefined(fonts)) {
            PDFCreator.fonts = fonts;
            fonts.forEach((font) => {
                if (!font.prefetch)
                    return;
                PDFCreator.prefetchFont(font.source);
            });
        }
    }
    get standardFont() {
        var _a;
        if (!PDFCreator.fonts)
            return undefined;
        return PDFCreator.mainFont || ((_a = PDFCreator.fonts[0]) === null || _a === void 0 ? void 0 : _a.family);
    }
    async fetchFont(src) {
        try {
            return await fetch(src, {
                headers: { 'Content-Type': 'font/ttf' },
            }).then((fontResponse) => fontResponse.blob());
        }
        catch (error) {
            const message = error === null || error === void 0 ? void 0 : error.message;
            throw new Error(`Failed to fetch font${message ? ` (${message})` : ''}`);
        }
    }
    async embedFonts() {
        const fontUrls = [];
        let fontFaces = '';
        if (!PDFCreator.fonts)
            return { fontUrls, fontFaces };
        await Promise.all(PDFCreator.fonts.map(async (font) => {
            const fontBlob = await this.fetchFont(font.source);
            const fontUrl = URL.createObjectURL(fontBlob);
            const fontScriptName = `${font.family}-${font.style}-${font.weight}.ttf`;
            const fontBinaryString = await blobToBinaryString(fontBlob);
            this.creator.addFileToVFS(fontScriptName, fontBinaryString);
            this.creator.addFont(fontScriptName, font.family, font.style, font.weight);
            fontFaces += `
        @font-face {
            font-family: "${font.family}";
            ${font.weight ? `font-weight: ${font.weight};` : ''}
            ${font.style ? `font-style: ${font.style};` : ''}
            src: url("${fontUrl}") format("truetype");
        }
        \n`;
            fontUrls.push(fontUrl);
        }));
        return { fontUrls, fontFaces };
    }
    addFooterToCurrentPage() {
        if (!this.footerElement || !this.slotsContainer)
            return;
        const footerCopy = this.footerElement.cloneNode(true);
        footerCopy.style.position = 'absolute';
        footerCopy.style.left = `${PDFCreator.pdfMargin}px`;
        footerCopy.style.top = `${this.bottomOfAvailableCurrentPageSpace}px`;
        footerCopy.style.width = `${this.availableInnerWidthOfSinglePdfPage}px`;
        this.slotsContainer.appendChild(footerCopy);
    }
    addHeaderToCurrentPage() {
        if (!this.headerElement || !this.slotsContainer)
            return;
        const headerCopy = this.headerElement.cloneNode(true);
        headerCopy.style.position = 'absolute';
        headerCopy.style.left = `${PDFCreator.pdfMargin}px`;
        headerCopy.style.top = `${this.topOfAvailableCurrentPageSpace - this.headerHeight}px`;
        headerCopy.style.width = `${this.availableInnerWidthOfSinglePdfPage}px`;
        this.slotsContainer.appendChild(headerCopy);
    }
    addPageNumbers(numberOfPages) {
        for (let page = 1; page < numberOfPages + 1; page++) {
            const horizontalPos = this.pdfPageWidth / 2;
            const verticalPos = this.pdfPageHeight - 10;
            this.creator.setPage(page);
            this.creator.setFontSize(9);
            this.creator.setTextColor(0, 0, 0);
            this.creator.text(i18next.t('PAGE_COUNTER', {
                page,
                numberOfPages,
            }), horizontalPos, verticalPos, {
                align: 'center',
            });
        }
    }
    async createPDF(pdfContent) {
        try {
            const { fontFaces, fontUrls } = await this.embedFonts();
            if (this.standardFont) {
                this.creator.setFont(this.standardFont);
            }
            this.wrapperElement.innerHTML = template({
                pdfSelector: this.pdfSelector,
                padding: PDFCreator.pdfMargin,
                fontFaces,
                fontFamily: this.standardFont,
                content: pdfContent,
            });
            await new Promise((resolve) => {
                this.creator.html(this.wrapperElement, {
                    callback: resolve,
                    margin: 0,
                    html2canvas: {
                        ignoreElements: this.filterOutRedundantElements,
                        onclone: this.prepareDocumentBeforeRender,
                        logging: false,
                        windowWidth: this.pdfPageWidth,
                        letterRendering: true,
                    },
                });
            });
            const pages = this.creator.getNumberOfPages();
            if (pages > 1) {
                this.addPageNumbers(pages);
            }
            const pdfBlob = this.creator.output('blob');
            fontUrls.forEach(URL.revokeObjectURL);
            return pdfBlob;
        }
        catch (error) {
            const message = error === null || error === void 0 ? void 0 : error.message;
            throw new Error(`PDF_CREATOR_ERROR${message ? `: ${message}` : ''}`);
        }
    }
}
PDFCreator.pdfMargin = 24;

var css_248z$y = ".signature-wrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  padding: var(--spacing-md) 0;\n}\n.signature-wrapper .signature-canvas-container {\n  position: relative;\n  flex: 1;\n}\n.signature-wrapper .signature-canvas-container .signature-clear {\n  position: absolute;\n  right: 0;\n  padding: var(--spacing-md);\n  cursor: pointer;\n  background: none;\n  border: none;\n  outline: none;\n}\n.signature-wrapper .signature-canvas-container .signature-clear .signature-clear-text {\n  color: var(--primary-color);\n  text-underline-offset: var(--spacing-xs);\n}\n.signature-wrapper .signature-canvas-container .signature-info {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n.signature-wrapper .signature-canvas-container .signature-info .signature-info-text {\n  color: #cacaca;\n  pointer-events: none;\n}\n.signature-wrapper .signature-canvas-container .signature-canvas {\n  width: 100%;\n  height: 100%;\n  background-color: var(--white-color);\n  border: 1px dashed var(--gray-color-1);\n  border-radius: 3px;\n}";
styleInject(css_248z$y);

const SIGNATURE_DOT_SIZE = 2;
const SIGNATURE_MIN_WIDTH = 1.5;
const SIGNATURE_MAX_WIDTH = 3;
const SignatureField = ({ dataTestSelector, className, label, placeholder, signatureImageMimeType = ImageMimeTypes.PNG, onReset, onSignatureCompleted, }) => {
    const [isSignatureStarted, setSignatureStarted] = useState(false);
    const [t] = useTranslation();
    const canvas = useRef();
    const clearPanel = useCallback(() => {
        if (onReset)
            onReset();
        if (canvas.current) {
            canvas.current.clear();
        }
        setSignatureStarted(false);
    }, [onReset]);
    const hideOverlay = useCallback(() => {
        setSignatureStarted(true);
    }, []);
    const resizeCanvas = useCallback(() => {
        if (canvas === null || canvas === void 0 ? void 0 : canvas.current) {
            const canvasElement = canvas.current._canvas;
            canvasElement.width = canvasElement.offsetWidth;
            clearPanel();
        }
    }, [clearPanel]);
    const getImage = useCallback(async () => {
        if (!canvas.current)
            return undefined;
        return new Promise((resolve) => canvas.current.getTrimmedCanvas().toBlob((blob) => resolve(blob)));
    }, []);
    const handleSignatureCompleted = useCallback(async () => {
        let blob = await getImage();
        if (signatureImageMimeType === ImageMimeTypes.JPEG && blob) {
            blob = await convertImageTo(blob, ImageMimeTypes.JPEG);
        }
        if (onSignatureCompleted && blob) {
            onSignatureCompleted(blob);
        }
        setSignatureStarted(true);
    }, [getImage, signatureImageMimeType, onSignatureCompleted]);
    useEffect(() => {
        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);
        return () => {
            window.removeEventListener('resize', resizeCanvas);
        };
    }, [resizeCanvas]);
    return (jsxs("div", Object.assign({ className: classNames('signature-wrapper', className), "data-test-selector": dataTestSelector }, { children: [label && (jsx(Text, Object.assign({ size: TextSize.xlg, weight: TextWeight.light, className: "spacing-bottom-lg" }, { children: label }), void 0)), jsxs("div", Object.assign({ className: "signature-canvas-container" }, { children: [isSignatureStarted && (jsx("button", Object.assign({ type: "button", className: "signature-clear", onClick: clearPanel }, { children: jsx(Text, Object.assign({ className: "signature-clear-text", underline: true }, { children: t('CLEAR') }), void 0) }), void 0)), !isSignatureStarted && placeholder && (jsx("div", Object.assign({ className: "signature-info" }, { children: jsx(Text, Object.assign({ className: "signature-info-text", size: TextSize.xlg }, { children: placeholder }), void 0) }), void 0)), jsx(SignatureCanvas, { ref: canvas, dotSize: SIGNATURE_DOT_SIZE, minWidth: SIGNATURE_MIN_WIDTH, maxWidth: SIGNATURE_MAX_WIDTH, clearOnResize: false, onBegin: hideOverlay, onEnd: handleSignatureCompleted, canvasProps: {
                            className: 'signature-canvas',
                        } }, void 0)] }), void 0)] }), void 0));
};

var css_248z$x = ".body-component {\n  flex: 1;\n  overflow: hidden auto;\n  background: transparent;\n}";
styleInject(css_248z$x);

const Body = ({ children, id, className, dataTestSelector, onScroll, }) => {
    return (jsx("main", Object.assign({ id: id, "data-test-selector": dataTestSelector, className: classNames('body-component', className), onScroll: onScroll }, { children: children }), void 0));
};

var css_248z$w = ".box-element {\n  display: block;\n}\n.box-element.box-size-sm-0, .box-element.box-size-lg-0 {\n  display: none;\n}\n.box-element.box-size-sm-auto, .box-element.box-size-lg-auto {\n  flex-basis: auto;\n}\n.box-element.box-size-sm-1 {\n  flex-basis: calc((100% / 12) * 1);\n  max-width: calc((100% / 12) * 1);\n}\n@media (min-width: 1024px) {\n  .box-element.box-size-lg-1 {\n    display: block;\n    flex-basis: calc((100% / 12) * 1);\n    max-width: calc((100% / 12) * 1);\n  }\n}\n.box-element.box-size-sm-2 {\n  flex-basis: calc((100% / 12) * 2);\n  max-width: calc((100% / 12) * 2);\n}\n@media (min-width: 1024px) {\n  .box-element.box-size-lg-2 {\n    display: block;\n    flex-basis: calc((100% / 12) * 2);\n    max-width: calc((100% / 12) * 2);\n  }\n}\n.box-element.box-size-sm-3 {\n  flex-basis: calc((100% / 12) * 3);\n  max-width: calc((100% / 12) * 3);\n}\n@media (min-width: 1024px) {\n  .box-element.box-size-lg-3 {\n    display: block;\n    flex-basis: calc((100% / 12) * 3);\n    max-width: calc((100% / 12) * 3);\n  }\n}\n.box-element.box-size-sm-4 {\n  flex-basis: calc((100% / 12) * 4);\n  max-width: calc((100% / 12) * 4);\n}\n@media (min-width: 1024px) {\n  .box-element.box-size-lg-4 {\n    display: block;\n    flex-basis: calc((100% / 12) * 4);\n    max-width: calc((100% / 12) * 4);\n  }\n}\n.box-element.box-size-sm-5 {\n  flex-basis: calc((100% / 12) * 5);\n  max-width: calc((100% / 12) * 5);\n}\n@media (min-width: 1024px) {\n  .box-element.box-size-lg-5 {\n    display: block;\n    flex-basis: calc((100% / 12) * 5);\n    max-width: calc((100% / 12) * 5);\n  }\n}\n.box-element.box-size-sm-6 {\n  flex-basis: calc((100% / 12) * 6);\n  max-width: calc((100% / 12) * 6);\n}\n@media (min-width: 1024px) {\n  .box-element.box-size-lg-6 {\n    display: block;\n    flex-basis: calc((100% / 12) * 6);\n    max-width: calc((100% / 12) * 6);\n  }\n}\n.box-element.box-size-sm-7 {\n  flex-basis: calc((100% / 12) * 7);\n  max-width: calc((100% / 12) * 7);\n}\n@media (min-width: 1024px) {\n  .box-element.box-size-lg-7 {\n    display: block;\n    flex-basis: calc((100% / 12) * 7);\n    max-width: calc((100% / 12) * 7);\n  }\n}\n.box-element.box-size-sm-8 {\n  flex-basis: calc((100% / 12) * 8);\n  max-width: calc((100% / 12) * 8);\n}\n@media (min-width: 1024px) {\n  .box-element.box-size-lg-8 {\n    display: block;\n    flex-basis: calc((100% / 12) * 8);\n    max-width: calc((100% / 12) * 8);\n  }\n}\n.box-element.box-size-sm-9 {\n  flex-basis: calc((100% / 12) * 9);\n  max-width: calc((100% / 12) * 9);\n}\n@media (min-width: 1024px) {\n  .box-element.box-size-lg-9 {\n    display: block;\n    flex-basis: calc((100% / 12) * 9);\n    max-width: calc((100% / 12) * 9);\n  }\n}\n.box-element.box-size-sm-10 {\n  flex-basis: calc((100% / 12) * 10);\n  max-width: calc((100% / 12) * 10);\n}\n@media (min-width: 1024px) {\n  .box-element.box-size-lg-10 {\n    display: block;\n    flex-basis: calc((100% / 12) * 10);\n    max-width: calc((100% / 12) * 10);\n  }\n}\n.box-element.box-size-sm-11 {\n  flex-basis: calc((100% / 12) * 11);\n  max-width: calc((100% / 12) * 11);\n}\n@media (min-width: 1024px) {\n  .box-element.box-size-lg-11 {\n    display: block;\n    flex-basis: calc((100% / 12) * 11);\n    max-width: calc((100% / 12) * 11);\n  }\n}\n.box-element.box-size-sm-12 {\n  flex-basis: calc((100% / 12) * 12);\n  max-width: calc((100% / 12) * 12);\n}\n@media (min-width: 1024px) {\n  .box-element.box-size-lg-12 {\n    display: block;\n    flex-basis: calc((100% / 12) * 12);\n    max-width: calc((100% / 12) * 12);\n  }\n}\n.box-element.box-grow {\n  flex-grow: 1;\n}";
styleInject(css_248z$w);

const Box = ({ children, className, sizeLg, sizeSm = 12, grow = false, dataTestSelector, }) => {
    return (jsx("div", Object.assign({ "data-test-selector": dataTestSelector, className: classNames('box-element', {
            [`box-size-sm-${sizeSm}`]: true,
            [`box-size-lg-${sizeLg}`]: isDefined(sizeLg),
            'box-grow': grow,
        }, className) }, { children: children }), void 0));
};

var css_248z$v = ".error-modal-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding-top: var(--spacing-lg);\n}\n.error-modal-content-wrapper .error-modal-content-circular svg {\n  fill: var(--primary-color);\n}\n.error-modal-content-wrapper .error-modal-description {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding-top: var(--spacing-xlg);\n  text-align: center;\n  white-space: pre-wrap;\n}\n.error-modal-content-wrapper .error-modal-button {\n  margin-top: var(--spacing-lg);\n}";
styleInject(css_248z$v);

const ErrorModal = ({ description, className, dataTestSelector, confirmButtonText, onConfirm, }) => {
    const [t] = useTranslation('ErrorModal');
    return (jsx(BasicModal, Object.assign({ dataTestSelector: dataTestSelector, className: className }, { children: jsxs("div", Object.assign({ "data-test": "ErrorModal", className: "error-modal-content-wrapper" }, { children: [jsx(Circular, { className: "error-modal-content-circular", type: CircularType.warning, icon: IconTypes.exclamationMark }, void 0), jsxs("div", Object.assign({ className: "error-modal-description" }, { children: [description || jsx(Text, { children: t('ERROR_MESSAGE') }, void 0), jsx(Button, Object.assign({ onClick: onConfirm, className: "error-modal-button" }, { children: confirmButtonText || t('TRY_AGAIN') }), void 0)] }), void 0)] }), void 0) }), void 0));
};

var css_248z$u = ".loading-modal-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding-top: var(--spacing-lg);\n}\n.loading-modal-content-wrapper .loading-modal-description {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding-top: var(--spacing-xlg);\n  text-align: center;\n  white-space: pre-wrap;\n}";
styleInject(css_248z$u);

const LoadingModal = ({ description, className, dataTestSelector, }) => {
    const [t] = useTranslation('LoadingModal');
    return (jsx(BasicModal, Object.assign({ dataTestSelector: dataTestSelector, className: className }, { children: jsxs("div", Object.assign({ "data-test": "Loading", className: "loading-modal-content-wrapper" }, { children: [jsx(Loader, {}, void 0), jsx("div", Object.assign({ className: "loading-modal-description spacing-bottom-lg" }, { children: description || (jsxs(Fragment, { children: [jsx(Text, { children: t('LOADING') }, void 0), jsx(Text, { children: t('PLEASE_WAIT') }, void 0)] }, void 0)) }), void 0)] }), void 0) }), void 0));
};

var css_248z$t = ".view-component {\n  display: flex;\n  flex-direction: column;\n  height: calc(100dvh - var(--console-simulator-nav-height));\n  max-height: -webkit-fill-available;\n  max-height: -moz-available;\n  max-height: fill;\n}";
styleInject(css_248z$t);

const View = React__default.forwardRef(({ isLoading, isError, loadingMessage, errorMessage, onErrorModalSubmit, children, dataTestSelector, className, tabIndex, }, ref) => {
    return (jsxs("div", Object.assign({ className: classNames('view-component', className), "data-test-selector": dataTestSelector, tabIndex: tabIndex, ref: ref }, { children: [isError && (jsx(ErrorModal, { description: errorMessage, onConfirm: onErrorModalSubmit }, void 0)), !isError && isLoading && jsx(LoadingModal, { description: loadingMessage }, void 0), children] }), void 0));
});

var css_248z$s = ".error-view-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n}\n.error-view-container .circular-icon {\n  fill: var(--primary-color);\n}";
styleInject(css_248z$s);

const ErrorView = ({ className, dataTestSelector }) => {
    const [t] = useTranslation('ErrorView');
    return (jsx(View, Object.assign({ className: className, dataTestSelector: dataTestSelector }, { children: jsxs("div", Object.assign({ className: "error-view-container" }, { children: [jsx(Text, Object.assign({ className: "spacing-bottom-lg", size: TextSize.xlg, weight: TextWeight.bold }, { children: t('CRITICAL_ERROR') }), void 0), jsx(Circular, { size: 120, type: CircularType.warning, icon: IconTypes.errorIcon }, void 0), jsx(Text, Object.assign({ className: "spacing-top-lg" }, { children: t('ERROR_MESSAGE') }), void 0), jsx(Text, Object.assign({ className: "spacing-top-md" }, { children: t('REPORT_PROBLEM') }), void 0)] }), void 0) }), void 0));
};

const ExpandPanelContext = createContext({
    isExpanded: false,
});
const useExpandPanelContext = () => {
    return useContext(ExpandPanelContext);
};
const ExpandPanelContextProvider = ({ isExpanded, children, }) => {
    const contextValue = useMemo(() => ({
        isExpanded,
    }), [isExpanded]);
    return (jsx(ExpandPanelContext.Provider, Object.assign({ value: contextValue }, { children: children }), void 0));
};

var css_248z$r = ".extendable-panel-extendable-element {\n  height: auto;\n  overflow: hidden;\n  transition: height 300ms cubic-bezier(0.4, 0, 0.2, 1);\n}";
styleInject(css_248z$r);

const ExtendableElement = ({ dataTestSelector, children, }) => {
    const { isExpanded } = useExpandPanelContext();
    const container = useRef(null);
    const [spacings, setSpacing] = useState(0);
    const [childSizes, setChildSizes] = useState(0);
    const recalculateSpacings = useCallback(() => {
        if (!container.current)
            return;
        const childArray = Array.from(container.current.childNodes);
        const spacings = childArray
            .map((element) => window.getComputedStyle(element))
            .reduce((sum, elementStyles, index, elementsArray) => {
            let currentSum = sum;
            if (index === 0) {
                currentSum += parseFloat(elementStyles.marginTop);
                if (elementsArray.length === 1) {
                    currentSum += parseFloat(elementStyles.marginBottom);
                }
                return currentSum;
            }
            currentSum += Math.max(parseFloat(elementStyles.marginTop), parseFloat(elementsArray[index - 1].marginBottom));
            if (index + 1 === elementsArray.length) {
                currentSum += parseFloat(elementStyles.marginBottom);
            }
            return currentSum;
        }, 0);
        setSpacing(spacings);
    }, []);
    const recalculateElementSizing = useCallback(() => {
        if (!container.current)
            return;
        const childArray = Array.from(container.current.childNodes);
        const childSizes = childArray.reduce((sum, item) => sum + item.getBoundingClientRect().height, 0);
        setChildSizes(childSizes);
    }, []);
    useEffect(() => {
        let resizeObserver;
        if (container.current) {
            recalculateSpacings();
            recalculateElementSizing();
            const childArray = Array.from(container.current.childNodes);
            // eslint-disable-next-line prefer-const
            resizeObserver = new ResizeObserver(() => {
                recalculateSpacings();
                recalculateElementSizing();
            });
            childArray.forEach((child) => resizeObserver.observe(child));
        }
        return () => {
            resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect();
        };
    }, [children, recalculateElementSizing, recalculateSpacings]);
    useEffect(() => {
        if (container.current) {
            if (!isExpanded) {
                container.current.style.height = '0px';
            }
            else {
                container.current.style.height = `${childSizes + spacings}px`;
            }
        }
    }, [isExpanded, spacings, childSizes]);
    return (jsx("div", Object.assign({ ref: container, className: "extendable-panel-extendable-element", "data-test-selector": dataTestSelector }, { children: children }), void 0));
};

var css_248z$q = ".extendable-panel {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.extendable-panel .extendable-panel-content {\n  width: 100%;\n}";
styleInject(css_248z$q);

const ExpandPanel = ({ children, className, isExpanded = false, dataTestSelector, }) => (jsx("div", Object.assign({ className: classNames('extendable-panel', className), "data-test-selector": dataTestSelector }, { children: jsx(ExpandPanelContextProvider, Object.assign({ isExpanded: isExpanded }, { children: jsx("div", Object.assign({ className: "extendable-panel-content" }, { children: children }), void 0) }), void 0) }), void 0));
ExpandPanel.ExtendableElement = ExtendableElement;

var FlexDirection;
(function (FlexDirection) {
    FlexDirection["row"] = "row";
    FlexDirection["column"] = "column";
})(FlexDirection || (FlexDirection = {}));
var AlignItems;
(function (AlignItems) {
    AlignItems["baseline"] = "baseline";
    AlignItems["center"] = "center";
    AlignItems["flexEnd"] = "flex-end";
    AlignItems["flexStart"] = "flex-start";
    AlignItems["normal"] = "normal";
    AlignItems["stretch"] = "stretch";
})(AlignItems || (AlignItems = {}));
var JustifyContent;
(function (JustifyContent) {
    JustifyContent["center"] = "center";
    JustifyContent["flexEnd"] = "flex-end";
    JustifyContent["flexStart"] = "flex-start";
    JustifyContent["normal"] = "normal";
    JustifyContent["spaceAround"] = "space-around";
    JustifyContent["spaceBetween"] = "space-between";
})(JustifyContent || (JustifyContent = {}));

var css_248z$p = ".flex-element {\n  display: flex;\n}\n.flex-element.justify-center {\n  justify-content: center;\n}\n.flex-element.justify-flex-end {\n  justify-content: flex-end;\n}\n.flex-element.justify-flex-start {\n  justify-content: flex-start;\n}\n.flex-element.justify-normal {\n  justify-content: normal;\n}\n.flex-element.justify-space-around {\n  justify-content: space-around;\n}\n.flex-element.justify-space-between {\n  justify-content: space-between;\n}\n.flex-element.align-baseline {\n  align-items: baseline;\n}\n.flex-element.align-center {\n  align-items: center;\n}\n.flex-element.align-flex-end {\n  align-items: flex-end;\n}\n.flex-element.align-flex-start {\n  align-items: flex-start;\n}\n.flex-element.align-normal {\n  align-items: normal;\n}\n.flex-element.align-stretch {\n  align-items: stretch;\n}\n.flex-element.direction-row {\n  flex-direction: row;\n}\n.flex-element.direction-column {\n  flex-direction: column;\n}\n.flex-element.flex-wrap {\n  flex-wrap: wrap;\n}\n.flex-element.flex-grow {\n  flex-grow: 1;\n}\n.flex-element.flex-shrink-off {\n  flex-shrink: 0;\n}";
styleInject(css_248z$p);

const Flex = ({ children, className, alignItems = AlignItems.normal, direction = FlexDirection.row, justifyContent = JustifyContent.normal, wrapped = false, grow = false, shrink = true, style, dataTestSelector, }) => {
    return (jsx("div", Object.assign({ style: style, "data-test-selector": dataTestSelector, className: classNames('flex-element', {
            [`align-${alignItems}`]: alignItems,
            [`justify-${justifyContent}`]: alignItems,
            [`direction-${direction}`]: alignItems,
            'flex-grow': grow,
            'flex-shrink-off': !shrink,
            'flex-wrap': wrapped,
        }, className) }, { children: children }), void 0));
};

var css_248z$o = ".footer-component {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n  height: var(--footer-height);\n  min-height: var(--footer-height);\n  padding: 0 var(--spacing-lg);\n  color: var(--footer-font-color);\n  background-color: var(--footer-background-color);\n}\n.footer-component .footer-component-content {\n  flex: 1;\n}";
styleInject(css_248z$o);

const Footer = ({ hasPrimaryButton, hasSecondaryButton, isPrimaryDisabled, isSecondaryDisabled, primaryLabel, secondaryLabel, onPrimaryClick, onSecondaryClick, children, className, dataTestSelector, }) => {
    const [t] = useTranslation('Footer');
    return (jsxs("footer", Object.assign({ "data-test-selector": dataTestSelector, className: classNames('footer-component', className) }, { children: [jsx("div", Object.assign({ className: "footer-component-content" }, { children: children }), void 0), hasSecondaryButton && (jsx(Button, Object.assign({ disabled: isSecondaryDisabled, onClick: onSecondaryClick, className: "spacing-left-sm", pattern: ButtonPattern.secondary }, { children: secondaryLabel || t('BACK') }), void 0)), hasPrimaryButton && (jsx(Button, Object.assign({ disabled: isPrimaryDisabled, className: "spacing-left-sm", onClick: onPrimaryClick }, { children: primaryLabel || t('CONTINUE') }), void 0))] }), void 0));
};

var css_248z$n = ".grid-item-element {\n  grid-row: var(--grid-row-span-sm);\n  grid-column: var(--grid-column-span-sm);\n}\n@media (min-width: 1024px) {\n  .grid-item-element {\n    grid-row: var(--grid-row-span-lg);\n    grid-column: var(--grid-column-span-lg);\n  }\n}\n.grid-item-element.justify-self-center {\n  justify-self: center;\n}\n.grid-item-element.align-self-center {\n  align-self: center;\n}\n.grid-item-element.justify-self-end {\n  justify-self: end;\n}\n.grid-item-element.align-self-end {\n  align-self: end;\n}\n.grid-item-element.justify-self-start {\n  justify-self: start;\n}\n.grid-item-element.align-self-start {\n  align-self: start;\n}\n.grid-item-element.justify-self-stretch {\n  justify-self: stretch;\n}\n.grid-item-element.align-self-stretch {\n  align-self: stretch;\n}";
styleInject(css_248z$n);

const GridItem = ({ children, colSpanSm, rowSpanSm, colSpanLg, rowSpanLg, justifySelf, alignSelf, className, dataTestSelector, }) => {
    const gridItemVariables = useMemo(() => {
        const largeScreenColSpan = colSpanLg !== null && colSpanLg !== void 0 ? colSpanLg : colSpanSm;
        const largeScreenRowSpan = rowSpanLg !== null && rowSpanLg !== void 0 ? rowSpanLg : rowSpanSm;
        return {
            '--grid-column-span-sm': colSpanSm ? `span ${colSpanSm}` : undefined,
            '--grid-column-span-lg': largeScreenColSpan
                ? `span ${largeScreenColSpan}`
                : undefined,
            '--grid-row-span-sm': rowSpanSm ? `span ${rowSpanSm}` : undefined,
            '--grid-row-span-lg': largeScreenRowSpan
                ? `span ${largeScreenRowSpan}`
                : undefined,
        };
    }, [colSpanLg, colSpanSm, rowSpanLg, rowSpanSm]);
    return (jsx("div", Object.assign({ "data-test-selector": dataTestSelector, style: gridItemVariables, className: classNames('grid-item-element', {
            [`justify-self-${justifySelf}`]: justifySelf,
            [`align-self-${alignSelf}`]: alignSelf,
        }, className) }, { children: children }), void 0));
};

var GridFlow;
(function (GridFlow) {
    GridFlow["row"] = "row";
    GridFlow["column"] = "column";
})(GridFlow || (GridFlow = {}));
var GridPlace;
(function (GridPlace) {
    GridPlace["start"] = "start";
    GridPlace["end"] = "end";
    GridPlace["center"] = "center";
    GridPlace["stretch"] = "stretch";
})(GridPlace || (GridPlace = {}));

var css_248z$m = ".grid-element {\n  display: grid;\n  grid-template-rows: var(--grid-template-rows-sm);\n  grid-template-columns: var(--grid-template-columns-sm);\n  width: 100%;\n  height: 100%;\n}\n@media (min-width: 1024px) {\n  .grid-element {\n    grid-template-rows: var(--grid-template-rows-lg);\n    grid-template-columns: var(--grid-template-columns-lg);\n  }\n}\n.grid-element.grid-row-flow {\n  grid-auto-flow: row;\n}\n.grid-element.grid-column-flow {\n  grid-auto-flow: column;\n}";
styleInject(css_248z$m);

const Grid = ({ children, className, dataTestSelector, gridTemplateColumnsSm = 'initial', gridTemplateRowsSm = 'initial', gridTemplateColumnsLg, gridTemplateRowsLg, gridFlow = GridFlow.row, }) => {
    const gridVariables = useMemo(() => {
        return {
            '--grid-template-columns-sm': gridTemplateColumnsSm,
            '--grid-template-columns-lg': gridTemplateColumnsLg !== null && gridTemplateColumnsLg !== void 0 ? gridTemplateColumnsLg : gridTemplateColumnsSm,
            '--grid-template-rows-sm': gridTemplateRowsSm,
            '--grid-template-rows-lg': gridTemplateRowsLg !== null && gridTemplateRowsLg !== void 0 ? gridTemplateRowsLg : gridTemplateRowsSm,
        };
    }, [
        gridTemplateColumnsLg,
        gridTemplateColumnsSm,
        gridTemplateRowsLg,
        gridTemplateRowsSm,
    ]);
    return (jsx("div", Object.assign({ style: gridVariables, "data-test-selector": dataTestSelector, className: classNames('grid-element', {
            'grid-row-flow': gridFlow === GridFlow.row,
            'grid-column-flow': gridFlow === GridFlow.column,
        }, className) }, { children: children }), void 0));
};
Grid.Item = GridItem;

var css_248z$l = ".header-component {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: var(--header-height);\n  padding: var(--spacing-md);\n  color: var(--header-font-color);\n  background-color: var(--header-background-color);\n  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);\n}\n.header-component .header-element {\n  width: auto;\n  height: 100%;\n}";
styleInject(css_248z$l);

const Header = ({ dataTestSelector, logo, title, children, className, }) => {
    return (jsxs("header", Object.assign({ className: classNames('header-component', className), "data-test-selector": dataTestSelector }, { children: [logo && (jsx("img", { alt: "logo", src: logo, className: "header-element spacing-right-lg" }, void 0)), title && (jsx(Text, Object.assign({ size: TextSize.xlg, weight: TextWeight.light, className: "header-element spacing-right-lg" }, { children: title }), void 0)), children] }), void 0));
};

var css_248z$k = ".loading-view-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n}\n.loading-view-container .circular-icon {\n  fill: var(--primary-color);\n}";
styleInject(css_248z$k);

const LoadingView = ({ className, dataTestSelector, title, description, }) => (jsx(View, Object.assign({ className: className, dataTestSelector: dataTestSelector }, { children: jsx("div", Object.assign({ className: "loading-view-container" }, { children: jsx(Loader, { title: title, description: description }, void 0) }), void 0) }), void 0));

var css_248z$j = ".section-component {\n  border-bottom: 1px solid var(--gray-color-1);\n}\n.section-component:last-of-type {\n  border-bottom: none;\n}\n.section-component.section-component-type-narrow {\n  padding: var(--spacing-xlg) 72px;\n}\n@media (min-width: 1024px) {\n  .section-component.section-component-type-narrow {\n    padding: var(--spacing-xlg) 96px;\n  }\n}\n.section-component.section-component-type-wide {\n  padding: var(--spacing-xlg) var(--spacing-xxlg);\n}";
styleInject(css_248z$j);

var SectionType;
(function (SectionType) {
    SectionType["wide"] = "wide";
    SectionType["narrow"] = "narrow";
})(SectionType || (SectionType = {}));
const Section = ({ children, type = SectionType.narrow, className, dataTestSelector, }) => (jsx("section", Object.assign({ "data-test-selector": dataTestSelector, className: classNames('section-component', `section-component-type-${type}`, className) }, { children: children }), void 0));

const TableBody = ({ children }) => {
    return (jsx(Fragment, { children: Children.map(children, (child, index) => {
            return isValidElement(child)
                ? cloneElement(child, Object.assign(Object.assign({}, child.props), { isBodyRow: true, isFirstRow: !index }))
                : child;
        }) }, void 0));
};

const TableContext = createContext({
    config: undefined,
});
const useTableContext = () => {
    return useContext(TableContext);
};
const TableContextProvider = ({ config, children, }) => {
    const contextValue = useMemo(() => ({
        config,
    }), [config]);
    return (jsx(TableContext.Provider, Object.assign({ value: contextValue }, { children: children }), void 0));
};

var css_248z$i = ".table-cell {\n  position: relative;\n  z-index: 1;\n  padding: var(--spacing-md) var(--spacing-sm);\n  margin-top: 8px;\n}\n.table-cell.table-cell-header {\n  z-index: 2;\n  padding: var(--spacing-lg) var(--spacing-sm);\n  margin-top: 0;\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  background-color: var(--body-background-color);\n}\n.table-cell.table-cell-footer {\n  z-index: 2;\n  padding-top: calc(var(--spacing-md) + var(--spacing-lg));\n  padding-bottom: calc(var(--spacing-md) + 8px);\n  margin-top: 0;\n  background-color: var(--body-background-color);\n}\n.table-cell.table-cell-first-row-cell {\n  margin-top: 0;\n}\n.table-cell.table-cell-sticky.table-cell-header {\n  position: sticky;\n  top: 0;\n}\n.table-cell.table-cell-sticky.table-cell-footer {\n  position: sticky;\n  bottom: 0;\n}\n.table-cell:not(.table-cell.table-cell-header, .table-cell.table-cell-footer)::before {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: -1;\n  display: block;\n  width: 100%;\n  height: 100%;\n  content: \"\";\n  background-color: var(--white-color);\n}\n.table-cell.table-cell-first:not(.table-cell.table-cell-header)::before {\n  border-top-left-radius: var(--spacing-s);\n  border-bottom-left-radius: var(--spacing-s);\n}\n.table-cell.table-cell-last:not(.table-cell.table-cell-header)::before {\n  border-top-right-radius: var(--spacing-s);\n  border-bottom-right-radius: var(--spacing-s);\n}\n.table-cell.table-cell-footer::before {\n  position: absolute;\n  bottom: 8px;\n  left: 0;\n  z-index: -1;\n  display: block;\n  width: 100%;\n  height: calc(100% - var(--spacing-lg) - 8px);\n  content: \"\";\n  background-color: var(--white-color);\n}\n.table-cell.table-cell-footer::after {\n  position: absolute;\n  top: 8px;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: 1px;\n  content: \"\";\n  background-color: var(--gray-color-1);\n}";
styleInject(css_248z$i);

const TableCell = ({ children, className, isLastElement, isFirstElement, isHeaderCell, isFooterCell, isFirstRowElement, colSpan, sticky, index, justify, align, }) => {
    const { config } = useTableContext();
    const justifyContent = useMemo(() => {
        return justify || (config === null || config === void 0 ? void 0 : config.columns[index].justify) || (config === null || config === void 0 ? void 0 : config.justify);
    }, [config, index, justify]);
    const alignItems = useMemo(() => {
        return align || (config === null || config === void 0 ? void 0 : config.columns[index].align) || (config === null || config === void 0 ? void 0 : config.align);
    }, [align, config, index]);
    return (jsx(Flex, Object.assign({ style: { gridColumn: colSpan && `span ${colSpan}` }, justifyContent: justifyContent, alignItems: alignItems, className: classNames('table-cell', {
            'table-cell-first': isFirstElement,
            'table-cell-last': isLastElement,
            'table-cell-header': isHeaderCell,
            'table-cell-footer': isFooterCell,
            'table-cell-sticky': sticky,
            'table-cell-first-row-cell': isFirstRowElement,
        }, className) }, { children: jsx(Box, Object.assign({ sizeSm: "auto" }, { children: children }), void 0) }), void 0));
};

const TableRow = ({ children, sticky, isHeaderRow, isFooterRow, isFirstRow, }) => {
    const childrenCount = Children.count(children);
    return (jsx(Fragment, { children: Children.map(children, (child, index) => {
            return isValidElement(child)
                ? cloneElement(child, Object.assign(Object.assign({}, child.props), { isFirstRowElement: isFirstRow, isLastElement: childrenCount === index + 1, isFirstElement: !index, isHeaderCell: isHeaderRow, isFooterCell: isFooterRow, sticky: sticky, index: index }))
                : child;
        }) }, void 0));
};

const TableFooter = ({ children, sticky, }) => {
    return (jsx(TableRow, Object.assign({ sticky: sticky, isFooterRow: true }, { children: children }), void 0));
};

const TableHeader = ({ children, sticky, }) => {
    return (jsx(TableRow, Object.assign({ sticky: sticky, isHeaderRow: true }, { children: children }), void 0));
};

var css_248z$h = ".table-wrapper {\n  display: flex;\n  max-height: 100%;\n  overflow: hidden;\n}\n.table-wrapper .table-container {\n  position: relative;\n  flex: 1;\n  overflow: auto;\n  background-color: var(--body-background-color);\n  border-radius: 6px;\n}\n.table-wrapper .table-element {\n  display: grid;\n  grid-template-columns: var(--column-template-sm);\n  align-items: stretch;\n  justify-items: stretch;\n  border-radius: 6px;\n}\n@media (min-width: 1024px) {\n  .table-wrapper .table-element {\n    grid-template-columns: var(--column-template-lg);\n  }\n}";
styleInject(css_248z$h);

const Table = (_a) => {
    var { className, children } = _a, contextData = __rest(_a, ["className", "children"]);
    const { config } = contextData;
    const columnTemplateCssVariables = useMemo(() => {
        var _a;
        if (!config)
            return undefined;
        const columnTemplateSm = config.columns.map((column) => column.sizeSm).join(' ') || 'initial';
        return {
            '--column-template-sm': columnTemplateSm,
            '--column-template-lg': (_a = config.columns
                .map((column) => column.sizeLg || column.sizeSm)
                .join(' ')) !== null && _a !== void 0 ? _a : columnTemplateSm,
        };
    }, [config]);
    return (jsx("div", Object.assign({ className: classNames('table-wrapper', className) }, { children: jsx("div", Object.assign({ className: "table-container" }, { children: jsx("div", Object.assign({ style: columnTemplateCssVariables, className: classNames('table-element', {
                    [`align-${config === null || config === void 0 ? void 0 : config.align}`]: config === null || config === void 0 ? void 0 : config.align,
                    [`justify-${config === null || config === void 0 ? void 0 : config.justify}`]: config === null || config === void 0 ? void 0 : config.justify,
                }) }, { children: jsx(TableContextProvider, Object.assign({}, contextData, { children: children }), void 0) }), void 0) }), void 0) }), void 0));
};
Table.Header = TableHeader;
Table.Body = TableBody;
Table.Footer = TableFooter;
Table.Row = TableRow;
Table.Cell = TableCell;

var css_248z$g = ".test-environment-bar-component {\n  height: var(--test-environment-bar-height);\n  line-height: var(--test-environment-bar-height);\n  color: var(--white-color);\n  text-align: center;\n  background-color: var(--test-environment-bar-color);\n}";
styleInject(css_248z$g);

const TestEnvironmentBar = ({ dataTestSelector, className, }) => {
    const { t } = useTranslation('TestEnvironmentBar');
    return (jsx("div", Object.assign({ className: classNames('test-environment-bar-component', className), "data-test-selector": dataTestSelector }, { children: t('TRAINING_ENVIRONMENT') }), void 0));
};

var css_248z$f = ".confirm-modal-wrapper .confirm-modal {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  text-align: center;\n}\n.confirm-modal-wrapper .confirm-modal .confirm-modal-button-container {\n  display: flex;\n  align-self: flex-end;\n  justify-content: space-between;\n  width: 100%;\n}\n.confirm-modal-wrapper .confirm-modal .confirm-modal-button-container > .button-component {\n  flex: 1;\n  max-width: -moz-max-content;\n  max-width: max-content;\n}";
styleInject(css_248z$f);

const ConfirmModal = ({ primaryButtonLabel, secondaryButtonLabel, header, size = BasicModalSize.md, description, dataTestSelector, className, onSecondaryClick, onPrimaryClick, }) => {
    const [t] = useTranslation('ConfirmModal');
    return (jsx(BasicModal, Object.assign({ size: size, dataTestSelector: dataTestSelector, className: classNames('confirm-modal-wrapper', className) }, { children: jsxs("div", Object.assign({ className: "confirm-modal" }, { children: [jsx(Text, Object.assign({ dataTestSelector: 'header', className: "spacing-bottom-lg spacing-top-sm", size: TextSize.xlg }, { children: header }), void 0), jsx(Text, Object.assign({ dataTestSelector: 'description', className: "spacing-bottom-xxlg" }, { children: description }), void 0), jsxs("div", Object.assign({ className: "confirm-modal-button-container" }, { children: [jsx(Button, Object.assign({ dataTestSelector: 'secondary', onClick: onSecondaryClick, pattern: ButtonPattern.secondary, className: "spacing-right-xs" }, { children: secondaryButtonLabel || t('CANCEL') }), void 0), jsx(Button, Object.assign({ dataTestSelector: 'primary', onClick: onPrimaryClick, className: "spacing-left-xs" }, { children: primaryButtonLabel || t('CONFIRM') }), void 0)] }), void 0)] }), void 0) }), void 0));
};

var css_248z$e = ".connection-modal-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding-top: var(--spacing-lg);\n}\n.connection-modal-content-wrapper .connection-modal-description {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding-top: var(--spacing-xlg);\n  text-align: center;\n  white-space: pre-wra;\n}\n.connection-modal-content-wrapper .connection-modal-icon {\n  fill: var(--black-color);\n}";
styleInject(css_248z$e);

const ConnectionModal = ({ className, dataTestSelector, description, }) => {
    const [t] = useTranslation('ConnectionModal');
    return (jsx(BasicModal, { children: jsxs("div", Object.assign({ "data-test-selector": dataTestSelector, className: classNames('connection-modal-content-wrapper', 'spacing-bottom-lg', className) }, { children: [jsx(Circular, { type: CircularType.error, icon: IconTypes.connectionLost, iconClassName: "connection-modal-icon" }, void 0), jsx("div", Object.assign({ className: "connection-modal-description" }, { children: description || (jsxs(Fragment, { children: [jsx(Text, { children: t('WAKE_UP_YOUR_CONNECTION') }, void 0), jsx(Text, { children: `(${t('NETWORK_UNREACHABLE')})` }, void 0)] }, void 0)) }), void 0)] }), void 0) }, void 0));
};

var css_248z$d = ".inactivity-modal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: var(--spacing-md);\n}\n.inactivity-modal .inactivity-modal-circular {\n  position: relative;\n}\n.inactivity-modal .inactivity-modal-counter {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: var(--font-size-lg);\n  transform: translate(-50%, -50%);\n}";
styleInject(css_248z$d);

const InactivityModal = ({ className, dataTestSelector, description, buttonDescription, countdownFrom, countdownTick = 1000, isConfirmButton = true, onConfirmButtonClick, onCountdownEnd, }) => {
    const [t] = useTranslation('InactivityModal');
    const circleTimeout = useRef();
    const [counter, setCounter] = useState(countdownFrom);
    useEffect(() => {
        let counter = countdownFrom;
        circleTimeout.current = window.setInterval(() => {
            counter--;
            setCounter(counter);
        }, countdownTick);
        return () => {
            window.clearInterval(circleTimeout.current);
        };
    }, [countdownFrom, setCounter, countdownTick]);
    useEffect(() => {
        if (counter <= 0) {
            window.clearInterval(circleTimeout.current);
            onCountdownEnd === null || onCountdownEnd === void 0 ? void 0 : onCountdownEnd();
        }
    }, [counter, onCountdownEnd]);
    return (jsx(BasicModal, Object.assign({ size: BasicModalSize.sm, className: className, dataTestSelector: dataTestSelector }, { children: jsxs("div", Object.assign({ className: "inactivity-modal" }, { children: [jsxs("div", Object.assign({ className: "inactivity-modal-circular" }, { children: [jsx(Text, Object.assign({ dataTestSelector: "inactivity-counter", className: "inactivity-modal-counter" }, { children: counter }), void 0), jsx(Circular, { type: CircularType.warning, circleSegment: (counter / countdownFrom) * 100 }, void 0)] }), void 0), jsx(Text, Object.assign({ dataTestSelector: "inactivity-description", className: "spacing-top-lg" }, { children: description || t('ARE_YOU_THERE') }), void 0), isConfirmButton && (jsx(Button, Object.assign({ dataTestSelector: "inactivity-confirm-button", className: "spacing-top-lg", onClick: onConfirmButtonClick }, { children: buttonDescription || t('YES') }), void 0))] }), void 0) }), void 0));
};

var css_248z$c = ".logs-modal-container {\n  display: flex;\n  flex-direction: column;\n  width: 85vw;\n  max-height: 90dvh;\n}\n.logs-modal-container .logs-modal-header {\n  text-align: center;\n}\n.logs-modal-container .logs-content-wrapper {\n  flex: 1;\n  margin: var(--spacing-lg) 0;\n  overflow: auto;\n}\n.logs-modal-container .logs-content-wrapper .single-log-wrapper:not(:last-of-type) {\n  margin-bottom: var(--spacing-lg);\n}\n.logs-modal-container .logs-content-wrapper .log-message {\n  margin: var(--spacing-xs) 0;\n  overflow-wrap: break-word;\n}\n.logs-modal-container .logs-content-wrapper .log-details {\n  width: 99%;\n  padding: var(--spacing-sm);\n  margin: 0;\n  word-break: break-all;\n  white-space: pre-wrap;\n  background-color: var(--gray-color-3);\n  border-radius: 4px;\n}\n.logs-modal-container .logs-content-wrapper .no-logs-info {\n  text-align: center;\n}\n.logs-modal-container .logs-buttons-wrapper {\n  display: flex;\n  justify-content: space-between;\n}\n.logs-modal-container .logs-cancel-button {\n  margin-left: auto;\n}";
styleInject(css_248z$c);

var SortType;
(function (SortType) {
    SortType["byLatest"] = "byLatest";
    SortType["byOldest"] = "byOldest";
})(SortType || (SortType = {}));
const LogsModal = ({ className, dataTestSelector, header, isExportButton, exportFileName = 'logs', logs, sortType, onCancelClick, }) => {
    const [t] = useTranslation('LogsModal');
    const sortByLatest = useCallback((data) => {
        return data.sort((a, b) => {
            return b.date && a.date
                ? new Date(b.date).getTime() - new Date(a.date).getTime()
                : 0;
        });
    }, []);
    const sortByOldest = useCallback((data) => {
        return data.sort((a, b) => {
            return b.date && a.date
                ? new Date(a.date).getTime() - new Date(b.date).getTime()
                : 0;
        });
    }, []);
    const sortedLogsByLatest = useMemo(() => {
        if (!logs)
            return [];
        switch (sortType) {
            case SortType.byLatest:
                return sortByLatest(logs);
            case SortType.byOldest:
                return sortByOldest(logs);
            default:
                return logs;
        }
    }, [logs, sortType, sortByLatest, sortByOldest]);
    const handleExportLogs = useCallback(() => {
        const jsonData = `text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(sortedLogsByLatest, undefined, 2))}`;
        const anchor = document.createElement('a');
        anchor.href = `data:${jsonData}`;
        anchor.download = `${exportFileName}.json`;
        anchor.click();
    }, [sortedLogsByLatest, exportFileName]);
    return (jsx(BasicModal, Object.assign({ dataTestSelector: dataTestSelector }, { children: jsxs("div", Object.assign({ className: classNames('logs-modal-container', className) }, { children: [jsx(Text, Object.assign({ dataTestSelector: "logs-modal-header", className: "logs-modal-header", size: TextSize.xlg }, { children: header || t('LOG_MODAL_HEADER') }), void 0), jsx("div", Object.assign({ className: "logs-content-wrapper" }, { children: jsx("div", { children: Array.isArray(sortedLogsByLatest) && sortedLogsByLatest.length ? (sortedLogsByLatest.map(({ date, message, details }, index) => (jsxs("div", Object.assign({ className: "single-log-wrapper" }, { children: [jsx(Text, Object.assign({ "data-test-selector": "logs-modal-date", size: TextSize.xs, weight: TextWeight.bold }, { children: date }), void 0), jsx(Text, Object.assign({ "data-test-selector": "logs-modal-message", size: TextSize.xs, className: "log-message" }, { children: message }), void 0), isDefined(details) && (jsx("pre", Object.assign({ "data-test-selector": "logs-modal-details", className: "log-details" }, { children: JSON.stringify(details, null, 2).replace(/^{\n|}$/g, '') }), void 0))] }), `log-${index}`)))) : (jsx(Text, Object.assign({ className: "no-logs-info" }, { children: t('NO_LOGS') }), void 0)) }, void 0) }), void 0), jsxs("div", Object.assign({ className: "logs-buttons-wrapper" }, { children: [isExportButton && (jsx(Button, Object.assign({ dataTestSelector: "export-button", onClick: handleExportLogs, pattern: ButtonPattern.secondary, disabled: !sortedLogsByLatest.length }, { children: t('EXPORT') }), void 0)), jsx(Button, Object.assign({ dataTestSelector: "logs-modal-cancel-button", onClick: onCancelClick, className: "logs-cancel-button" }, { children: t('CANCEL') }), void 0)] }), void 0)] }), void 0) }), void 0));
};

var css_248z$b = ".magic-button {\n  position: absolute;\n  cursor: default;\n  background: transparent;\n  border: none;\n  outline: none;\n  opacity: 1;\n}";
styleInject(css_248z$b);

var MagicButtonVerticalPosition;
(function (MagicButtonVerticalPosition) {
    MagicButtonVerticalPosition["top"] = "top";
    MagicButtonVerticalPosition["bottom"] = "bottom";
})(MagicButtonVerticalPosition || (MagicButtonVerticalPosition = {}));
var MagicButtonHorizontalPosition;
(function (MagicButtonHorizontalPosition) {
    MagicButtonHorizontalPosition["left"] = "left";
    MagicButtonHorizontalPosition["right"] = "right";
})(MagicButtonHorizontalPosition || (MagicButtonHorizontalPosition = {}));
/**
 * Invisible button to provide possibility for some actions, that should be hidden from guest
 */
const MagicButton = ({ pressTimeout = 1000, width, height, positionVertical, positionHorizontal, className, dataTestSelector, onLongPress, onClick, onDoubleClick, }) => {
    const timeout = useRef();
    const buttonRef = useRef(null);
    useEffect(() => {
        var _a;
        const parentElement = (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        const parentElementPositioning = parentElement && getComputedStyle(parentElement).position;
        const isPositionSet = parentElementPositioning && parentElementPositioning !== 'static';
        if (parentElement && !isPositionSet) {
            parentElement.style.position = 'relative';
        }
    }, [buttonRef]);
    const clearLongPressTimeout = () => {
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = undefined;
        }
    };
    const handlePointerDown = () => {
        if (onLongPress) {
            timeout.current = window.setTimeout(() => onLongPress(), pressTimeout);
        }
    };
    return (jsx("button", { style: Object.assign(Object.assign({ width,
            height }, (positionVertical && { [positionVertical]: 0 })), (positionHorizontal && { [positionHorizontal]: 0 })), ref: buttonRef, onPointerDown: handlePointerDown, onPointerUp: clearLongPressTimeout, onPointerCancel: clearLongPressTimeout, onPointerOut: clearLongPressTimeout, onPointerLeave: clearLongPressTimeout, onClick: onClick, onDoubleClick: onDoubleClick, className: classNames('magic-button', className), "data-test-selector": dataTestSelector }, void 0));
};

var platform = {exports: {}};

/*!
 * Platform.js v1.3.6
 * Copyright 2014-2020 Benjamin Tan
 * Copyright 2011-2013 John-David Dalton
 * Available under MIT license
 */

(function (module, exports) {
(function() {

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used as a reference to the global object. */
  var root = (objectTypes[typeof window] && window) || this;

  /** Detect free variable `exports`. */
  var freeExports = exports;

  /** Detect free variable `module`. */
  var freeModule = module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
  var freeGlobal = freeExports && freeModule && typeof commonjsGlobal == 'object' && commonjsGlobal;
  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
    root = freeGlobal;
  }

  /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */
  var maxSafeInteger = Math.pow(2, 53) - 1;

  /** Regular expression to detect Opera. */
  var reOpera = /\bOpera/;

  /** Used for native method references. */
  var objectProto = Object.prototype;

  /** Used to check for own properties of an object. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to resolve the internal `[[Class]]` of values. */
  var toString = objectProto.toString;

  /*--------------------------------------------------------------------------*/

  /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */
  function capitalize(string) {
    string = String(string);
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */
  function cleanupOS(os, pattern, label) {
    // Platform tokens are defined at:
    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    var data = {
      '10.0': '10',
      '6.4':  '10 Technical Preview',
      '6.3':  '8.1',
      '6.2':  '8',
      '6.1':  'Server 2008 R2 / 7',
      '6.0':  'Server 2008 / Vista',
      '5.2':  'Server 2003 / XP 64-bit',
      '5.1':  'XP',
      '5.01': '2000 SP1',
      '5.0':  '2000',
      '4.0':  'NT',
      '4.90': 'ME'
    };
    // Detect Windows version from platform tokens.
    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) &&
        (data = data[/[\d.]+$/.exec(os)])) {
      os = 'Windows ' + data;
    }
    // Correct character case and cleanup string.
    os = String(os);

    if (pattern && label) {
      os = os.replace(RegExp(pattern, 'i'), label);
    }

    os = format(
      os.replace(/ ce$/i, ' CE')
        .replace(/\bhpw/i, 'web')
        .replace(/\bMacintosh\b/, 'Mac OS')
        .replace(/_PowerPC\b/i, ' OS')
        .replace(/\b(OS X) [^ \d]+/i, '$1')
        .replace(/\bMac (OS X)\b/, '$1')
        .replace(/\/(\d)/, ' $1')
        .replace(/_/g, '.')
        .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
        .replace(/\bx86\.64\b/gi, 'x86_64')
        .replace(/\b(Windows Phone) OS\b/, '$1')
        .replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1')
        .split(' on ')[0]
    );

    return os;
  }

  /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */
  function each(object, callback) {
    var index = -1,
        length = object ? object.length : 0;

    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
      while (++index < length) {
        callback(object[index], index, object);
      }
    } else {
      forOwn(object, callback);
    }
  }

  /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */
  function format(string) {
    string = trim(string);
    return /^(?:webOS|i(?:OS|P))/.test(string)
      ? string
      : capitalize(string);
  }

  /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */
  function forOwn(object, callback) {
    for (var key in object) {
      if (hasOwnProperty.call(object, key)) {
        callback(object[key], key, object);
      }
    }
  }

  /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */
  function getClassOf(value) {
    return value == null
      ? capitalize(value)
      : toString.call(value).slice(8, -1);
  }

  /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */
  function isHostType(object, property) {
    var type = object != null ? typeof object[property] : 'number';
    return !/^(?:boolean|number|string|undefined)$/.test(type) &&
      (type == 'object' ? !!object[property] : true);
  }

  /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */
  function qualify(string) {
    return String(string).replace(/([ -])(?!$)/g, '$1?');
  }

  /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */
  function reduce(array, callback) {
    var accumulator = null;
    each(array, function(value, index) {
      accumulator = callback(accumulator, value, index, array);
    });
    return accumulator;
  }

  /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */
  function trim(string) {
    return String(string).replace(/^ +| +$/g, '');
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */
  function parse(ua) {

    /** The environment context object. */
    var context = root;

    /** Used to flag when a custom context is provided. */
    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';

    // Juggle arguments.
    if (isCustomContext) {
      context = ua;
      ua = null;
    }

    /** Browser navigator object. */
    var nav = context.navigator || {};

    /** Browser user agent string. */
    var userAgent = nav.userAgent || '';

    ua || (ua = userAgent);

    /** Used to detect if browser is like Chrome. */
    var likeChrome = isCustomContext
      ? !!nav.likeChrome
      : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());

    /** Internal `[[Class]]` value shortcuts. */
    var objectClass = 'Object',
        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
        enviroClass = isCustomContext ? objectClass : 'Environment',
        javaClass = (isCustomContext && context.java) ? 'JavaPackage' : getClassOf(context.java),
        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';

    /** Detect Java environments. */
    var java = /\bJava/.test(javaClass) && context.java;

    /** Detect Rhino. */
    var rhino = java && getClassOf(context.environment) == enviroClass;

    /** A character to represent alpha. */
    var alpha = java ? 'a' : '\u03b1';

    /** A character to represent beta. */
    var beta = java ? 'b' : '\u03b2';

    /** Browser document object. */
    var doc = context.document || {};

    /**
     * Detect Opera browser (Presto-based).
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */
    var opera = context.operamini || context.opera;

    /** Opera `[[Class]]`. */
    var operaClass = reOpera.test(operaClass = (isCustomContext && opera) ? opera['[[Class]]'] : getClassOf(opera))
      ? operaClass
      : (opera = null);

    /*------------------------------------------------------------------------*/

    /** Temporary variable used over the script's lifetime. */
    var data;

    /** The CPU architecture. */
    var arch = ua;

    /** Platform description array. */
    var description = [];

    /** Platform alpha/beta indicator. */
    var prerelease = null;

    /** A flag to indicate that environment features should be used to resolve the platform. */
    var useFeatures = ua == userAgent;

    /** The browser/environment version. */
    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();

    /** A flag to indicate if the OS ends with "/ Version" */
    var isSpecialCasedOS;

    /* Detectable layout engines (order is important). */
    var layout = getLayout([
      { 'label': 'EdgeHTML', 'pattern': 'Edge' },
      'Trident',
      { 'label': 'WebKit', 'pattern': 'AppleWebKit' },
      'iCab',
      'Presto',
      'NetFront',
      'Tasman',
      'KHTML',
      'Gecko'
    ]);

    /* Detectable browser names (order is important). */
    var name = getName([
      'Adobe AIR',
      'Arora',
      'Avant Browser',
      'Breach',
      'Camino',
      'Electron',
      'Epiphany',
      'Fennec',
      'Flock',
      'Galeon',
      'GreenBrowser',
      'iCab',
      'Iceweasel',
      'K-Meleon',
      'Konqueror',
      'Lunascape',
      'Maxthon',
      { 'label': 'Microsoft Edge', 'pattern': '(?:Edge|Edg|EdgA|EdgiOS)' },
      'Midori',
      'Nook Browser',
      'PaleMoon',
      'PhantomJS',
      'Raven',
      'Rekonq',
      'RockMelt',
      { 'label': 'Samsung Internet', 'pattern': 'SamsungBrowser' },
      'SeaMonkey',
      { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Sleipnir',
      'SlimBrowser',
      { 'label': 'SRWare Iron', 'pattern': 'Iron' },
      'Sunrise',
      'Swiftfox',
      'Vivaldi',
      'Waterfox',
      'WebPositive',
      { 'label': 'Yandex Browser', 'pattern': 'YaBrowser' },
      { 'label': 'UC Browser', 'pattern': 'UCBrowser' },
      'Opera Mini',
      { 'label': 'Opera Mini', 'pattern': 'OPiOS' },
      'Opera',
      { 'label': 'Opera', 'pattern': 'OPR' },
      'Chromium',
      'Chrome',
      { 'label': 'Chrome', 'pattern': '(?:HeadlessChrome)' },
      { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' },
      { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' },
      { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' },
      { 'label': 'IE', 'pattern': 'IEMobile' },
      { 'label': 'IE', 'pattern': 'MSIE' },
      'Safari'
    ]);

    /* Detectable products (order is important). */
    var product = getProduct([
      { 'label': 'BlackBerry', 'pattern': 'BB10' },
      'BlackBerry',
      { 'label': 'Galaxy S', 'pattern': 'GT-I9000' },
      { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' },
      { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' },
      { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' },
      { 'label': 'Galaxy S5', 'pattern': 'SM-G900' },
      { 'label': 'Galaxy S6', 'pattern': 'SM-G920' },
      { 'label': 'Galaxy S6 Edge', 'pattern': 'SM-G925' },
      { 'label': 'Galaxy S7', 'pattern': 'SM-G930' },
      { 'label': 'Galaxy S7 Edge', 'pattern': 'SM-G935' },
      'Google TV',
      'Lumia',
      'iPad',
      'iPod',
      'iPhone',
      'Kindle',
      { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Nexus',
      'Nook',
      'PlayBook',
      'PlayStation Vita',
      'PlayStation',
      'TouchPad',
      'Transformer',
      { 'label': 'Wii U', 'pattern': 'WiiU' },
      'Wii',
      'Xbox One',
      { 'label': 'Xbox 360', 'pattern': 'Xbox' },
      'Xoom'
    ]);

    /* Detectable manufacturers. */
    var manufacturer = getManufacturer({
      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
      'Alcatel': {},
      'Archos': {},
      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
      'Asus': { 'Transformer': 1 },
      'Barnes & Noble': { 'Nook': 1 },
      'BlackBerry': { 'PlayBook': 1 },
      'Google': { 'Google TV': 1, 'Nexus': 1 },
      'HP': { 'TouchPad': 1 },
      'HTC': {},
      'Huawei': {},
      'Lenovo': {},
      'LG': {},
      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
      'Motorola': { 'Xoom': 1 },
      'Nintendo': { 'Wii U': 1,  'Wii': 1 },
      'Nokia': { 'Lumia': 1 },
      'Oppo': {},
      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
      'Sony': { 'PlayStation': 1, 'PlayStation Vita': 1 },
      'Xiaomi': { 'Mi': 1, 'Redmi': 1 }
    });

    /* Detectable operating systems (order is important). */
    var os = getOS([
      'Windows Phone',
      'KaiOS',
      'Android',
      'CentOS',
      { 'label': 'Chrome OS', 'pattern': 'CrOS' },
      'Debian',
      { 'label': 'DragonFly BSD', 'pattern': 'DragonFly' },
      'Fedora',
      'FreeBSD',
      'Gentoo',
      'Haiku',
      'Kubuntu',
      'Linux Mint',
      'OpenBSD',
      'Red Hat',
      'SuSE',
      'Ubuntu',
      'Xubuntu',
      'Cygwin',
      'Symbian OS',
      'hpwOS',
      'webOS ',
      'webOS',
      'Tablet OS',
      'Tizen',
      'Linux',
      'Mac OS X',
      'Macintosh',
      'Mac',
      'Windows 98;',
      'Windows '
    ]);

    /*------------------------------------------------------------------------*/

    /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */
    function getLayout(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */
    function getManufacturer(guesses) {
      return reduce(guesses, function(result, value, key) {
        // Lookup the manufacturer by product or scan the UA for the manufacturer.
        return result || (
          value[product] ||
          value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] ||
          RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)
        ) && key;
      });
    }

    /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */
    function getName(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */
    function getOS(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua)
            )) {
          result = cleanupOS(result, pattern, guess.label || guess);
        }
        return result;
      });
    }

    /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */
    function getProduct(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) ||
              RegExp('\\b' + pattern + ' *\\w+-[\\w]*', 'i').exec(ua) ||
              RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua)
            )) {
          // Split by forward slash and append product version if needed.
          if ((result = String((guess.label && !RegExp(pattern, 'i').test(guess.label)) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
            result[0] += ' ' + result[1];
          }
          // Correct character case and cleanup string.
          guess = guess.label || guess;
          result = format(result[0]
            .replace(RegExp(pattern, 'i'), guess)
            .replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ')
            .replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
        }
        return result;
      });
    }

    /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */
    function getVersion(patterns) {
      return reduce(patterns, function(result, pattern) {
        return result || (RegExp(pattern +
          '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
      });
    }

    /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */
    function toStringPlatform() {
      return this.description || '';
    }

    /*------------------------------------------------------------------------*/

    // Convert layout to an array so we can add extra details.
    layout && (layout = [layout]);

    // Detect Android products.
    // Browsers on Android devices typically provide their product IDS after "Android;"
    // up to "Build" or ") AppleWebKit".
    // Example:
    // "Mozilla/5.0 (Linux; Android 8.1.0; Moto G (5) Plus) AppleWebKit/537.36
    // (KHTML, like Gecko) Chrome/70.0.3538.80 Mobile Safari/537.36"
    if (/\bAndroid\b/.test(os) && !product &&
        (data = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(ua))) {
      product = trim(data[1])
        // Replace any language codes (eg. "en-US").
        .replace(/^[a-z]{2}-[a-z]{2};\s*/i, '')
        || null;
    }
    // Detect product names that contain their manufacturer's name.
    if (manufacturer && !product) {
      product = getProduct([manufacturer]);
    } else if (manufacturer && product) {
      product = product
        .replace(RegExp('^(' + qualify(manufacturer) + ')[-_.\\s]', 'i'), manufacturer + ' ')
        .replace(RegExp('^(' + qualify(manufacturer) + ')[-_.]?(\\w)', 'i'), manufacturer + ' $2');
    }
    // Clean up Google TV.
    if ((data = /\bGoogle TV\b/.exec(product))) {
      product = data[0];
    }
    // Detect simulators.
    if (/\bSimulator\b/i.test(ua)) {
      product = (product ? product + ' ' : '') + 'Simulator';
    }
    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
      description.push('running in Turbo/Uncompressed mode');
    }
    // Detect IE Mobile 11.
    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
      data = parse(ua.replace(/like iPhone OS/, ''));
      manufacturer = data.manufacturer;
      product = data.product;
    }
    // Detect iOS.
    else if (/^iP/.test(product)) {
      name || (name = 'Safari');
      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua))
        ? ' ' + data[1].replace(/_/g, '.')
        : '');
    }
    // Detect Kubuntu.
    else if (name == 'Konqueror' && /^Linux\b/i.test(os)) {
      os = 'Kubuntu';
    }
    // Detect Android browsers.
    else if ((manufacturer && manufacturer != 'Google' &&
        ((/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua)) || /\bVita\b/.test(product))) ||
        (/\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua))) {
      name = 'Android Browser';
      os = /\bAndroid\b/.test(os) ? os : 'Android';
    }
    // Detect Silk desktop/accelerated modes.
    else if (name == 'Silk') {
      if (!/\bMobi/i.test(ua)) {
        os = 'Android';
        description.unshift('desktop mode');
      }
      if (/Accelerated *= *true/i.test(ua)) {
        description.unshift('accelerated');
      }
    }
    // Detect UC Browser speed mode.
    else if (name == 'UC Browser' && /\bUCWEB\b/.test(ua)) {
      description.push('speed mode');
    }
    // Detect PaleMoon identifying as Firefox.
    else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
      description.push('identifying as Firefox ' + data[1]);
    }
    // Detect Firefox OS and products running Firefox.
    else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
      os || (os = 'Firefox OS');
      product || (product = data[1]);
    }
    // Detect false positives for Firefox/Safari.
    else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
      // Escape the `/` for Firefox 1.
      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
        // Clear name of false positives.
        name = null;
      }
      // Reassign a generic name.
      if ((data = product || manufacturer || os) &&
          (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
      }
    }
    // Add Chrome version to description for Electron.
    else if (name == 'Electron' && (data = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) {
      description.push('Chromium ' + data);
    }
    // Detect non-Opera (Presto-based) versions (order is important).
    if (!version) {
      version = getVersion([
        '(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)',
        'Version',
        qualify(name),
        '(?:Firefox|Minefield|NetFront)'
      ]);
    }
    // Detect stubborn layout engines.
    if ((data =
          layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' ||
          /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') ||
          /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' ||
          !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') ||
          layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront'
        )) {
      layout = [data];
    }
    // Detect Windows Phone 7 desktop mode.
    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
      name += ' Mobile';
      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
      description.unshift('desktop mode');
    }
    // Detect Windows Phone 8.x desktop mode.
    else if (/\bWPDesktop\b/i.test(ua)) {
      name = 'IE Mobile';
      os = 'Windows Phone 8.x';
      description.unshift('desktop mode');
      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
    }
    // Detect IE 11 identifying as other browsers.
    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
      if (name) {
        description.push('identifying as ' + name + (version ? ' ' + version : ''));
      }
      name = 'IE';
      version = data[1];
    }
    // Leverage environment features.
    if (useFeatures) {
      // Detect server-side environments.
      // Rhino has a global function while others have a global object.
      if (isHostType(context, 'global')) {
        if (java) {
          data = java.lang.System;
          arch = data.getProperty('os.arch');
          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
        }
        if (rhino) {
          try {
            version = context.require('ringo/engine').version.join('.');
            name = 'RingoJS';
          } catch(e) {
            if ((data = context.system) && data.global.system == context.system) {
              name = 'Narwhal';
              os || (os = data[0].os || null);
            }
          }
          if (!name) {
            name = 'Rhino';
          }
        }
        else if (
          typeof context.process == 'object' && !context.process.browser &&
          (data = context.process)
        ) {
          if (typeof data.versions == 'object') {
            if (typeof data.versions.electron == 'string') {
              description.push('Node ' + data.versions.node);
              name = 'Electron';
              version = data.versions.electron;
            } else if (typeof data.versions.nw == 'string') {
              description.push('Chromium ' + version, 'Node ' + data.versions.node);
              name = 'NW.js';
              version = data.versions.nw;
            }
          }
          if (!name) {
            name = 'Node.js';
            arch = data.arch;
            os = data.platform;
            version = /[\d.]+/.exec(data.version);
            version = version ? version[0] : null;
          }
        }
      }
      // Detect Adobe AIR.
      else if (getClassOf((data = context.runtime)) == airRuntimeClass) {
        name = 'Adobe AIR';
        os = data.flash.system.Capabilities.os;
      }
      // Detect PhantomJS.
      else if (getClassOf((data = context.phantom)) == phantomClass) {
        name = 'PhantomJS';
        version = (data = data.version || null) && (data.major + '.' + data.minor + '.' + data.patch);
      }
      // Detect IE compatibility modes.
      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
        // We're in compatibility mode when the Trident version + 4 doesn't
        // equal the document mode.
        version = [version, doc.documentMode];
        if ((data = +data[1] + 4) != version[1]) {
          description.push('IE ' + version[1] + ' mode');
          layout && (layout[1] = '');
          version[1] = data;
        }
        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
      }
      // Detect IE 11 masking as other browsers.
      else if (typeof doc.documentMode == 'number' && /^(?:Chrome|Firefox)\b/.test(name)) {
        description.push('masking as ' + name + ' ' + version);
        name = 'IE';
        version = '11.0';
        layout = ['Trident'];
        os = 'Windows';
      }
      os = os && format(os);
    }
    // Detect prerelease phases.
    if (version && (data =
          /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) ||
          /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) ||
          /\bMinefield\b/i.test(ua) && 'a'
        )) {
      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
      version = version.replace(RegExp(data + '\\+?$'), '') +
        (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
    }
    // Detect Firefox Mobile.
    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS|KaiOS)\b/.test(os)) {
      name = 'Firefox Mobile';
    }
    // Obscure Maxthon's unreliable version.
    else if (name == 'Maxthon' && version) {
      version = version.replace(/\.[\d.]+/, '.x');
    }
    // Detect Xbox 360 and Xbox One.
    else if (/\bXbox\b/i.test(product)) {
      if (product == 'Xbox 360') {
        os = null;
      }
      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
        description.unshift('mobile mode');
      }
    }
    // Add mobile postfix.
    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) &&
        (os == 'Windows CE' || /Mobi/i.test(ua))) {
      name += ' Mobile';
    }
    // Detect IE platform preview.
    else if (name == 'IE' && useFeatures) {
      try {
        if (context.external === null) {
          description.unshift('platform preview');
        }
      } catch(e) {
        description.unshift('embedded');
      }
    }
    // Detect BlackBerry OS version.
    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data =
          (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] ||
          version
        )) {
      data = [data, /BB10/.test(ua)];
      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
      version = null;
    }
    // Detect Opera identifying/masking itself as another browser.
    // http://www.opera.com/support/kb/view/843/
    else if (this != forOwn && product != 'Wii' && (
          (useFeatures && opera) ||
          (/Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua)) ||
          (name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os)) ||
          (name == 'IE' && (
            (os && !/^Win/.test(os) && version > 5.5) ||
            /\bWindows XP\b/.test(os) && version > 8 ||
            version == 8 && !/\bTrident\b/.test(ua)
          ))
        ) && !reOpera.test((data = parse.call(forOwn, ua.replace(reOpera, '') + ';'))) && data.name) {
      // When "identifying", the UA contains both Opera and the other browser's name.
      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
      if (reOpera.test(name)) {
        if (/\bIE\b/.test(data) && os == 'Mac OS') {
          os = null;
        }
        data = 'identify' + data;
      }
      // When "masking", the UA contains only the other browser's name.
      else {
        data = 'mask' + data;
        if (operaClass) {
          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
        } else {
          name = 'Opera';
        }
        if (/\bIE\b/.test(data)) {
          os = null;
        }
        if (!useFeatures) {
          version = null;
        }
      }
      layout = ['Presto'];
      description.push(data);
    }
    // Detect WebKit Nightly and approximate Chrome/Safari versions.
    if ((data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
      // Correct build number for numeric comparison.
      // (e.g. "532.5" becomes "532.05")
      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
      // Nightly builds are postfixed with a "+".
      if (name == 'Safari' && data[1].slice(-1) == '+') {
        name = 'WebKit Nightly';
        prerelease = 'alpha';
        version = data[1].slice(0, -1);
      }
      // Clear incorrect browser versions.
      else if (version == data[1] ||
          version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
        version = null;
      }
      // Use the full Chrome version when available.
      data[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(ua) || 0)[1];
      // Detect Blink layout engine.
      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
        layout = ['Blink'];
      }
      // Detect JavaScriptCore.
      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
      if (!useFeatures || (!likeChrome && !data[1])) {
        layout && (layout[1] = 'like Safari');
        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : data < 602 ? 9 : data < 604 ? 10 : data < 606 ? 11 : data < 608 ? 12 : '12');
      } else {
        layout && (layout[1] = 'like Chrome');
        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
      }
      // Add the postfix of ".x" or "+" for approximate versions.
      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
      // Obscure version for some Safari 1-2 releases.
      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
        version = data;
      } else if (name == 'Chrome' && /\bHeadlessChrome/i.test(ua)) {
        description.unshift('headless');
      }
    }
    // Detect Opera desktop modes.
    if (name == 'Opera' &&  (data = /\bzbov|zvav$/.exec(os))) {
      name += ' ';
      description.unshift('desktop mode');
      if (data == 'zvav') {
        name += 'Mini';
        version = null;
      } else {
        name += 'Mobile';
      }
      os = os.replace(RegExp(' *' + data + '$'), '');
    }
    // Detect Chrome desktop mode.
    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
      description.unshift('desktop mode');
      name = 'Chrome Mobile';
      version = null;

      if (/\bOS X\b/.test(os)) {
        manufacturer = 'Apple';
        os = 'iOS 4.3+';
      } else {
        os = null;
      }
    }
    // Newer versions of SRWare Iron uses the Chrome tag to indicate its version number.
    else if (/\bSRWare Iron\b/.test(name) && !version) {
      version = getVersion('Chrome');
    }
    // Strip incorrect OS versions.
    if (version && version.indexOf((data = /[\d.]+$/.exec(os))) == 0 &&
        ua.indexOf('/' + data + '-') > -1) {
      os = trim(os.replace(data, ''));
    }
    // Ensure OS does not include the browser name.
    if (os && os.indexOf(name) != -1 && !RegExp(name + ' OS').test(os)) {
      os = os.replace(RegExp(' *' + qualify(name) + ' *'), '');
    }
    // Add layout engine.
    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (
        /Browser|Lunascape|Maxthon/.test(name) ||
        name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) ||
        /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(name) && layout[1])) {
      // Don't add layout details to description if they are falsey.
      (data = layout[layout.length - 1]) && description.push(data);
    }
    // Combine contextual information.
    if (description.length) {
      description = ['(' + description.join('; ') + ')'];
    }
    // Append manufacturer to description.
    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
      description.push('on ' + manufacturer);
    }
    // Append product to description.
    if (product) {
      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
    }
    // Parse the OS into an object.
    if (os) {
      data = / ([\d.+]+)$/.exec(os);
      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
      os = {
        'architecture': 32,
        'family': (data && !isSpecialCasedOS) ? os.replace(data[0], '') : os,
        'version': data ? data[1] : null,
        'toString': function() {
          var version = this.version;
          return this.family + ((version && !isSpecialCasedOS) ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
        }
      };
    }
    // Add browser/OS architecture.
    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
      if (os) {
        os.architecture = 64;
        os.family = os.family.replace(RegExp(' *' + data), '');
      }
      if (
          name && (/\bWOW64\b/i.test(ua) ||
          (useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)))
      ) {
        description.unshift('32-bit');
      }
    }
    // Chrome 39 and above on OS X is always 64-bit.
    else if (
        os && /^OS X/.test(os.family) &&
        name == 'Chrome' && parseFloat(version) >= 39
    ) {
      os.architecture = 64;
    }

    ua || (ua = null);

    /*------------------------------------------------------------------------*/

    /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */
    var platform = {};

    /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.description = ua;

    /**
     * The name of the browser's layout engine.
     *
     * The list of common layout engines include:
     * "Blink", "EdgeHTML", "Gecko", "Trident" and "WebKit"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.layout = layout && layout[0];

    /**
     * The name of the product's manufacturer.
     *
     * The list of manufacturers include:
     * "Apple", "Archos", "Amazon", "Asus", "Barnes & Noble", "BlackBerry",
     * "Google", "HP", "HTC", "LG", "Microsoft", "Motorola", "Nintendo",
     * "Nokia", "Samsung" and "Sony"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.manufacturer = manufacturer;

    /**
     * The name of the browser/environment.
     *
     * The list of common browser names include:
     * "Chrome", "Electron", "Firefox", "Firefox for iOS", "IE",
     * "Microsoft Edge", "PhantomJS", "Safari", "SeaMonkey", "Silk",
     * "Opera Mini" and "Opera"
     *
     * Mobile versions of some browsers have "Mobile" appended to their name:
     * eg. "Chrome Mobile", "Firefox Mobile", "IE Mobile" and "Opera Mobile"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.name = name;

    /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.prerelease = prerelease;

    /**
     * The name of the product hosting the browser.
     *
     * The list of common products include:
     *
     * "BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle",
     * "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.product = product;

    /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.ua = ua;

    /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.version = name && version;

    /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */
    platform.os = os || {

      /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */
      'architecture': null,

      /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
       * "SuSE", "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */
      'family': null,

      /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */
      'version': null,

      /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */
      'toString': function() { return 'null'; }
    };

    platform.parse = parse;
    platform.toString = toStringPlatform;

    if (platform.version) {
      description.unshift(version);
    }
    if (platform.name) {
      description.unshift(name);
    }
    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
      description.push(product ? '(' + os + ')' : 'on ' + os);
    }
    if (description.length) {
      platform.description = description.join(' ');
    }
    return platform;
  }

  /*--------------------------------------------------------------------------*/

  // Export platform.
  var platform = parse();

  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
  if (freeExports && freeModule) {
    // Export for CommonJS support.
    forOwn(platform, function(value, key) {
      freeExports[key] = value;
    });
  }
  else {
    // Export to the global object.
    root.platform = platform;
  }
}.call(commonjsGlobal));
}(platform, platform.exports));

var css_248z$a = ".link-component {\n  display: inline;\n}\n.link-component .link-component-link {\n  text-decoration: underline;\n  cursor: pointer;\n}";
styleInject(css_248z$a);

var LinkTarget;
(function (LinkTarget) {
    LinkTarget["Blank"] = "_blank";
    LinkTarget["Self"] = "_self";
    LinkTarget["Parent"] = "_parent";
    LinkTarget["Top"] = "_top";
})(LinkTarget || (LinkTarget = {}));
const Link = ({ target = LinkTarget.Blank, href, id, dataTestSelector, className, children, size = TextSize.sm, weight, onClick, }) => {
    const onClickLink = (e) => {
        if (!href) {
            e.preventDefault();
            e.stopPropagation();
            if (onClick) {
                onClick();
            }
        }
    };
    return (jsx(Text, Object.assign({ id: id, size: size, weight: weight, "data-test-selector": dataTestSelector, className: classNames('link-component', className) }, { children: jsx("a", Object.assign({ className: "link-component-link", href: href, target: target, onClick: onClickLink }, { children: children }), void 0) }), void 0));
};

var css_248z$9 = ".service-modal-container .service-modal-links {\n  color: var(--primary-color);\n}";
styleInject(css_248z$9);

const ServiceModal = ({ dataTestSelector, className, errorLogs, authLogs, children, userName, propertyName, errorLogsEnabled, authLogsEnabled, systemInfoForKpeEnabled, exportErrorLogsFileName, exportAuthLogsFileName, isSaveButtonDisabled, onCancelClick, onDebugModeClick, onLogoutClick, onSaveClick, }) => {
    const [t] = useTranslation('ServiceModal');
    const [areAuthLogsModalOpened, setAuthLogsModalOpen] = useState(false);
    const [areErrorLogsModalOpened, setErrorLogsModalOpen] = useState(false);
    const osVersion = useMemo(() => {
        return (platform.exports.os === null || platform.exports.os === void 0 ? void 0 : platform.exports.os.family) && (platform.exports.os === null || platform.exports.os === void 0 ? void 0 : platform.exports.os.version)
            ? `${platform.exports.os === null || platform.exports.os === void 0 ? void 0 : platform.exports.os.family} (${platform.exports.os === null || platform.exports.os === void 0 ? void 0 : platform.exports.os.version})`
            : '-';
    }, []);
    const [kpeVersion, setKpeVersion] = useState('');
    const toggleErrorLogsModal = () => {
        setErrorLogsModalOpen(!areErrorLogsModalOpened);
    };
    const toggleAuthLogsModal = () => {
        setAuthLogsModalOpen(!areAuthLogsModalOpened);
    };
    const getKpeVersion = () => {
        var _a;
        const callbackName = 'kp_VersionAPI_requestMainVersion_callback';
        window[callbackName] = setKpeVersion;
        (_a = window.kp_VersionAPI_requestMainVersion) === null || _a === void 0 ? void 0 : _a.call(window, callbackName);
    };
    const clearData = useCallback(() => {
        var _a, _b, _c;
        (_a = window.kp_Browser_clearCache) === null || _a === void 0 ? void 0 : _a.call(window);
        alert('Cache Cleared!');
        (_b = window.kp_Browser_clearCookies) === null || _b === void 0 ? void 0 : _b.call(window);
        alert('Cookies Cleared!');
        (_c = window.kp_Browser_clearLocalStorage) === null || _c === void 0 ? void 0 : _c.call(window);
    }, []);
    useEffect(() => {
        getKpeVersion();
    }, []);
    return (jsxs(Fragment, { children: [areErrorLogsModalOpened && (jsx(LogsModal, { dataTestSelector: "error-logs-service-modal", logs: errorLogs, sortType: SortType.byLatest, isExportButton: !kpeVersion, exportFileName: exportErrorLogsFileName, onCancelClick: toggleErrorLogsModal }, void 0)), areAuthLogsModalOpened && (jsx(LogsModal, { dataTestSelector: "auth-logs-service-modal", logs: authLogs, sortType: SortType.byLatest, isExportButton: !kpeVersion, exportFileName: exportAuthLogsFileName, onCancelClick: toggleAuthLogsModal }, void 0)), !areAuthLogsModalOpened && !areErrorLogsModalOpened && (jsxs(BasicModal, Object.assign({ dataTestSelector: dataTestSelector, size: BasicModalSize.lg, className: classNames('service-modal-container', className) }, { children: [jsx(Text, Object.assign({ className: "spacing-auto spacing-bottom-xlg", size: TextSize.xlg }, { children: t('HEADER') }), void 0), (userName || propertyName) && (jsxs(Flex, { children: [userName && (jsxs(Box, Object.assign({ "data-test-selector": "user-name-container" }, { children: [jsx(Text, Object.assign({ weight: TextWeight.light, size: TextSize.xs, hint: true }, { children: t('USER_NAME') }), void 0), jsx(Text, Object.assign({ className: "spacing-top-xs" }, { children: userName }), void 0)] }), void 0)), propertyName && (jsxs(Box, Object.assign({ "data-test-selector": "property-name-container" }, { children: [jsx(Text, Object.assign({ weight: TextWeight.light, size: TextSize.xs, hint: true }, { children: t('PROPERTY_NAME') }), void 0), jsx(Text, Object.assign({ className: "spacing-top-xs" }, { children: propertyName }), void 0)] }), void 0))] }, void 0)), children, systemInfoForKpeEnabled && kpeVersion && (jsxs(Fragment, { children: [jsx(Separator, {}, void 0), jsxs(Box, { children: [jsxs(Box, Object.assign({ className: "spacing-bottom-lg" }, { children: [jsx(Text, Object.assign({ size: TextSize.md }, { children: t('KPE_VERSION', { version: kpeVersion }) }), void 0), jsx(Text, Object.assign({ size: TextSize.md }, { children: t('OS_VERSION', { version: osVersion }) }), void 0)] }), void 0), jsx(Link, Object.assign({ size: TextSize.md, onClick: clearData, className: "service-modal-links" }, { children: t('CLEAR_DATA') }), void 0)] }, void 0)] }, void 0)), jsx(Separator, {}, void 0), (errorLogsEnabled || authLogsEnabled) && (jsxs(Flex, Object.assign({ direction: FlexDirection.column, className: "spacing-bottom-xlg gap-lg" }, { children: [errorLogsEnabled && (jsx(Link, Object.assign({ size: TextSize.md, dataTestSelector: "service-modal-show-error-logs-button", onClick: toggleErrorLogsModal, className: "service-modal-links" }, { children: t('SHOW_ERROR_LOGS') }), void 0)), authLogsEnabled && (jsx(Link, Object.assign({ size: TextSize.md, className: "service-modal-links spacing-bottom-lg", dataTestSelector: "service-modal-show-auth-logs-button", onClick: toggleAuthLogsModal }, { children: t('SHOW_AUTH_LOGS') }), void 0))] }), void 0)), jsxs(Flex, Object.assign({ justifyContent: JustifyContent.spaceBetween }, { children: [jsx(Button, Object.assign({ dataTestSelector: "service-modal-cancel-button", onClick: onCancelClick, pattern: ButtonPattern.secondary }, { children: t('CANCEL') }), void 0), jsxs(Flex, Object.assign({ className: "gap-sm" }, { children: [jsx(Button, Object.assign({ dataTestSelector: "service-modal-logout-button", pattern: ButtonPattern.secondary, onClick: onLogoutClick }, { children: t('LOGOUT') }), void 0), jsx(Button, Object.assign({ dataTestSelector: "service-modal-debug-button", pattern: ButtonPattern.secondary, onClick: onDebugModeClick }, { children: t('DEBUG_MODE') }), void 0), jsx(Button, Object.assign({ dataTestSelector: "service-modal-save-button", onClick: onSaveClick, disabled: isSaveButtonDisabled }, { children: t('SAVE') }), void 0)] }), void 0)] }), void 0)] }), void 0))] }, void 0));
};

var css_248z$8 = ".badge-component {\n  padding: 0 var(--spacing-xs);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  color: var(--black-color);\n  text-transform: uppercase;\n  background-color: #e6fafe;\n  border: 1px solid var(--black-color);\n  border-radius: 2px;\n}";
styleInject(css_248z$8);

const Badge = ({ dataTestSelector, className, children, }) => {
    return (jsx("span", Object.assign({ "data-test-selector": dataTestSelector, className: classNames('badge-component', className) }, { children: children }), void 0));
};

var css_248z$7 = ".external-html-content-wrapper {\n  word-break: break-word;\n}";
styleInject(css_248z$7);

const ExternalHTMLContent = ({ className, dataTestSelector, content, onLinkClick, }) => {
    const sanitizedContent = useMemo(() => {
        return getSafeExternalContent(content);
    }, [content]);
    const handleLinkClick = useCallback((event) => {
        const isAnchor = 'tagName' in event.target &&
            event.target.tagName === 'A';
        if (isAnchor) {
            event.preventDefault();
            const target = event.target;
            onLinkClick === null || onLinkClick === void 0 ? void 0 : onLinkClick(target.href);
        }
    }, [onLinkClick]);
    return sanitizedContent ? (jsx("div", { "data-test-selector": dataTestSelector, className: classNames('external-html-content-wrapper', className), onClick: handleLinkClick, dangerouslySetInnerHTML: {
            __html: sanitizedContent,
        } }, void 0)) : null;
};

const FormHeader = ({ dataTestSelector, className, title, titleWeight = TextWeight.light, hint, }) => {
    return (jsxs("div", Object.assign({ "data-test-selector": dataTestSelector, className: className }, { children: [title && (jsx(Text, Object.assign({ dataTestSelector: "form-header-title", size: TextSize.xlg, weight: titleWeight }, { children: title }), void 0)), hint && (jsx(Text, Object.assign({ dataTestSelector: "form-header-hint", className: classNames({
                    'spacing-top-sm': title,
                }), hint: true }, { children: hint }), void 0))] }), void 0));
};

var img$c = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 23.0.6%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 66 44' style='enable-background:new 0 0 66 44%3b' xml:space='preserve' class='flag-china'%3e%3cstyle type='text/css'%3e .flag-china-st0%7bclip-path:url(%23SVGID_2_)%3b%7d .flag-china-st1%7bfill:%23DE2910%3b%7d .flag-china-st2%7bfill:%23FFDE00%3b%7d%3c/style%3e%3cg%3e %3cdefs%3e %3cpath id='SVGID_1_' d='M64.8%2c0H1.1C0.5%2c0%2c0%2c0.5%2c0%2c1.2v13.5v14.6v0.1v13.4C0%2c43.5%2c0.5%2c44%2c1.1%2c44h63.8c0.6%2c0%2c1.1-0.5%2c1.1-1.2V29.4 v-0.1V14.7V1.2C66%2c0.5%2c65.5%2c0%2c64.8%2c0z'/%3e %3c/defs%3e %3cclipPath id='SVGID_2_'%3e %3cuse xlink:href='%23SVGID_1_' style='overflow:visible%3b'/%3e %3c/clipPath%3e %3cg class='flag-china-st0'%3e %3crect id='_x36_' x='0' class='flag-china-st1' width='66' height='44'/%3e %3cg%3e %3cpolygon class='flag-china-st2' points='12.5%2c9 11%2c4.4 9.5%2c9 4.7%2c9 8.6%2c11.8 7.1%2c16.3 11%2c13.5 14.9%2c16.3 13.4%2c11.8 17.3%2c9 '/%3e %3cpolygon class='flag-china-st2' points='21.7%2c5.2 22.5%2c6.5 22.6%2c5 24.2%2c4.6 22.7%2c4 22.9%2c2.4 21.8%2c3.6 20.3%2c3 21.2%2c4.3 20.1%2c5.5 '/%3e %3cpolygon class='flag-china-st2' points='25.8%2c9.4 26%2c11 26.8%2c9.6 28.3%2c9.8 27.2%2c8.7 28%2c7.3 26.5%2c8 25.4%2c6.8 25.7%2c8.4 24.2%2c9.1 '/%3e %3cpolygon class='flag-china-st2' points='27.2%2c15.6 28.5%2c14.6 26.9%2c14.7 26.3%2c13.2 25.9%2c14.7 24.3%2c14.8 25.6%2c15.7 25.2%2c17.2 26.4%2c16.2 27.8%2c17.1 '/%3e %3cpolygon class='flag-china-st2' points='22.7%2c19.3 22.8%2c17.7 21.8%2c19 20.3%2c18.4 21.2%2c19.8 20.2%2c21 21.7%2c20.6 22.6%2c21.9 22.7%2c20.3 24.2%2c19.9 '/%3e %3c/g%3e %3c/g%3e%3c/g%3e%3c/svg%3e";

var img$b = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 23.0.6%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 66 44' style='enable-background:new 0 0 66 44%3b' xml:space='preserve' class='flag-duch'%3e%3cstyle type='text/css'%3e .flag-dutch-st0%7bfill:%23FF4B55%3b%7d .flag-dutch-st1%7bfill:%2341479B%3b%7d .flag-dutch-st2%7bfill:%23F5F5F5%3b%7d%3c/style%3e%3cg%3e %3cpath class='flag-dutch-st0' d='M66%2c14.7H0V1.2C0%2c0.5%2c0.5%2c0%2c1.1%2c0h63.7C65.5%2c0%2c66%2c0.5%2c66%2c1.2L66%2c14.7L66%2c14.7z'/%3e %3cpath class='flag-dutch-st1' d='M64.9%2c44H1.1C0.5%2c44%2c0%2c43.5%2c0%2c42.8V29.3h66v13.5C66%2c43.5%2c65.5%2c44%2c64.9%2c44z'/%3e %3crect y='14.7' class='flag-dutch-st2' width='66' height='14.7'/%3e%3c/g%3e%3c/svg%3e";

var img$a = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 23.0.6%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 66 44' style='enable-background:new 0 0 66 44%3b' xml:space='preserve' class='flag-france'%3e%3cstyle type='text/css'%3e .flag-france-st0%7bfill:%2341479B%3b%7d .flag-france-st1%7bfill:%23F5F5F5%3b%7d .flag-france-st2%7bfill:%23FF4B55%3b%7d%3c/style%3e%3cg%3e %3cpath class='flag-france-st0' d='M22%2c44H1.1C0.5%2c44%2c0%2c43.5%2c0%2c42.8V1.2C0%2c0.5%2c0.5%2c0%2c1.1%2c0H22V44z'/%3e %3crect x='22' y='0' class='flag-france-st1' width='22' height='44'/%3e %3cpath class='flag-france-st2' d='M64.9%2c44H44V0h20.9C65.5%2c0%2c66%2c0.5%2c66%2c1.2v41.7C66%2c43.5%2c65.5%2c44%2c64.9%2c44z'/%3e%3c/g%3e%3c/svg%3e";

var img$9 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 23.0.6%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 66 44' style='enable-background:new 0 0 66 44%3b' xml:space='preserve' class='flag-germany'%3e%3cstyle type='text/css'%3e .flag-germany-st0%7bfill:%23464655%3b%7d .flag-germany-st1%7bfill:%23FFE15A%3b%7d .flag-germany-st2%7bfill:%23FF4B55%3b%7d%3c/style%3e%3cg%3e %3cpath class='flag-germany-st0' d='M66%2c14.7H0V1.2C0%2c0.5%2c0.5%2c0%2c1.1%2c0h63.7C65.5%2c0%2c66%2c0.5%2c66%2c1.2L66%2c14.7L66%2c14.7z'/%3e %3cpath class='flag-germany-st1' d='M64.9%2c44H1.1C0.5%2c44%2c0%2c43.5%2c0%2c42.8V29.3h66v13.5C66%2c43.5%2c65.5%2c44%2c64.9%2c44z'/%3e %3crect y='14.7' class='flag-germany-st2' width='66' height='14.7'/%3e%3c/g%3e%3c/svg%3e";

var img$8 = "data:image/svg+xml,%3csvg width='66' height='44' viewBox='0 0 66 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_2319_4410)'%3e%3cpath d='M0 0H66V44H0V0Z' fill='%23EE1C25'/%3e%3cpath d='M36.1486 9.18102C35.8488 9.277 35.5752 9.4408 35.349 9.65971C35.1228 9.87862 34.9502 10.1467 34.8445 10.4432C34.7388 10.7397 34.7028 11.0566 34.7395 11.3692C34.7761 11.6818 34.8844 11.9818 35.0558 12.2458C35.3194 12.6517 35.4909 13.1106 35.5581 13.59C35.6253 14.0693 35.5866 14.5576 35.4447 15.0205C35.3029 15.4833 35.0613 15.9094 34.7371 16.2688C34.4128 16.6282 34.0137 16.9122 33.5679 17.1007C33.1287 17.2865 32.7435 17.58 32.4479 17.9541C32.1523 18.3283 31.9558 18.7709 31.8768 19.2412C31.7977 19.7114 31.8385 20.194 31.9955 20.6442C32.1524 21.0945 32.4204 21.4979 32.7747 21.817C31.7092 21.0589 30.9821 19.9146 30.7482 18.6281C30.5144 17.3415 30.7924 16.0145 31.523 14.93C31.4947 14.9057 31.4675 14.8801 31.4417 14.8532C30.6941 15.9544 30.4043 17.3033 30.6336 18.6144C30.8629 19.9255 31.5934 21.0959 32.6703 21.878C31.1599 21.2731 29.9249 20.1334 29.2008 18.6764C28.4767 17.2193 28.3141 15.5468 28.744 13.9775C29.1739 12.4083 30.1662 11.0521 31.5318 10.1675C32.8974 9.28289 34.5407 8.93176 36.1486 9.18102' fill='white'/%3e%3cpath d='M33.1452 13.2806L31.1238 14.1622L33.2773 14.6371L31.8142 12.9871L32.028 15.182' fill='%23EE1C25'/%3e%3cpath d='M46.1638 21.0335C45.9799 20.7781 45.7396 20.5685 45.4616 20.4211C45.1835 20.2736 44.8752 20.1923 44.5606 20.1834C44.246 20.1745 43.9335 20.2383 43.6476 20.3698C43.3616 20.5013 43.1097 20.697 42.9116 20.9416C42.607 21.3179 42.2236 21.6228 41.7884 21.8349C41.3533 22.047 40.877 22.1611 40.393 22.1693C39.909 22.1774 39.4292 22.0794 38.9872 21.8821C38.5452 21.6848 38.1519 21.393 37.8348 21.0273C37.5225 20.667 37.1244 20.3914 36.6773 20.2259C36.2301 20.0604 35.7485 20.0104 35.2768 20.0805C34.8052 20.1507 34.3589 20.3387 33.9792 20.6271C33.5995 20.9156 33.2986 21.2952 33.1045 21.7308C33.4963 20.4831 34.36 19.4378 35.5113 18.8177C36.6626 18.1976 38.0105 18.0518 39.2675 18.4114C39.2819 18.3769 39.2979 18.3432 39.3155 18.3103C38.0373 17.9397 36.665 18.0811 35.4889 18.7045C34.3129 19.3278 33.4254 20.3844 33.0143 21.6504C33.123 20.0269 33.8254 18.5 34.9874 17.3609C36.1494 16.2218 37.6898 15.5501 39.315 15.4738C40.9401 15.3976 42.5364 15.9221 43.7995 16.9475C45.0626 17.9728 45.9042 19.4273 46.1638 21.0335' fill='white'/%3e%3cpath d='M41.3377 19.4436L39.8746 17.7936L40.0884 19.9885L41.2055 18.0871L39.1841 18.9687' fill='%23EE1C25'/%3e%3cpath d='M22.9186 30.5192C23.2175 30.6178 23.5351 30.6461 23.8467 30.602C24.1583 30.5578 24.4556 30.4424 24.7153 30.2647C24.9751 30.0869 25.1904 29.8517 25.3444 29.5772C25.4985 29.3027 25.5872 28.9964 25.6037 28.682C25.629 28.1985 25.76 27.7265 25.9873 27.2991C26.2147 26.8718 26.533 26.4994 26.9197 26.2083C27.3064 25.9173 27.7523 25.7145 28.2258 25.6143C28.6993 25.5142 29.189 25.5191 29.6605 25.6286C30.1249 25.7365 30.609 25.7255 31.068 25.5966C31.527 25.4676 31.9461 25.2249 32.2864 24.891C32.6267 24.557 32.8773 24.1426 33.0149 23.686C33.1526 23.2294 33.1728 22.7455 33.0738 22.279C33.4902 23.5187 33.4059 24.8721 32.839 26.0505C32.2721 27.2289 31.2673 28.1391 30.039 28.5871C30.0476 28.6234 30.0545 28.6601 30.0596 28.697C31.3115 28.2455 32.3387 27.3245 32.9237 26.1289C33.5087 24.9333 33.6056 23.5569 33.1941 22.291C34.0604 23.6684 34.3897 25.3165 34.1192 26.9211C33.8486 28.5257 32.9973 29.9746 31.7273 30.9915C30.4573 32.0085 28.8576 32.5224 27.2331 32.4353C25.6085 32.3482 24.0728 31.6661 22.9186 30.5192' fill='white'/%3e%3cpath d='M27.7576 28.9688L29.9112 29.4437L28.4481 27.7937L28.6619 29.9886L29.779 28.0872' fill='%23EE1C25'/%3e%3cpath d='M37.9875 34.2215C38.1736 33.9676 38.2986 33.6743 38.353 33.3642C38.4073 33.0542 38.3894 32.7358 38.3006 32.4338C38.2119 32.1318 38.0547 31.8543 37.8413 31.623C37.6279 31.3916 37.364 31.2125 37.0701 31.0997C36.6182 30.9262 36.2098 30.6558 35.8737 30.3075C35.5375 29.9592 35.2818 29.5414 35.1245 29.0836C34.9673 28.6258 34.9122 28.1391 34.9633 27.6577C35.0144 27.1763 35.1703 26.712 35.4202 26.2974C35.6663 25.889 35.8055 25.4251 35.8247 24.9487C35.8439 24.4722 35.7426 23.9986 35.5302 23.5717C35.3178 23.1448 35.0011 22.7784 34.6095 22.5064C34.2179 22.2344 33.764 22.0656 33.2898 22.0156C34.5973 22.0027 35.8582 22.501 36.8036 23.4044C37.749 24.3078 38.304 25.5448 38.3504 26.8516C38.3876 26.8546 38.4247 26.8594 38.4614 26.866C38.4189 25.5356 37.8605 24.274 36.9044 23.3481C35.9482 22.4222 34.6693 21.9046 33.3383 21.9049C34.9158 21.5066 36.5848 21.7026 38.0271 22.4558C39.4693 23.2089 40.584 24.4665 41.1586 25.9887C41.7332 27.511 41.7276 29.1914 41.1427 30.7097C40.5579 32.228 39.4348 33.4781 37.9875 34.2215' fill='white'/%3e%3cpath d='M38.0075 29.1394L39.1247 27.2381L37.1033 28.1197L39.2568 28.5946L37.7938 26.9445' fill='%23EE1C25'/%3e%3cpath d='M21.7815 15.0442C21.7801 15.3589 21.8514 15.6698 21.9897 15.9525C22.128 16.2353 22.3296 16.4823 22.5789 16.6745C22.8282 16.8667 23.1185 16.9988 23.4271 17.0605C23.7358 17.1222 24.0545 17.112 24.3585 17.0305C24.8261 16.9053 25.3155 16.884 25.7922 16.9682C26.2688 17.0525 26.7213 17.2401 27.1176 17.5181C27.514 17.796 27.8446 18.1574 28.0862 18.5768C28.3278 18.9963 28.4746 19.4636 28.5161 19.9459C28.557 20.421 28.7171 20.878 28.9816 21.2748C29.2461 21.6715 29.6064 21.9952 30.0292 22.2157C30.452 22.4362 30.9235 22.5465 31.4002 22.5364C31.877 22.5262 32.3434 22.396 32.7564 22.1577C31.7062 22.9368 30.3932 23.2747 29.0974 23.0995C27.8015 22.9243 26.6254 22.2498 25.8197 21.2199C25.7879 21.2393 25.7551 21.2572 25.7215 21.2735C26.5378 22.3248 27.7311 23.0172 29.0489 23.2043C30.3667 23.3913 31.7056 23.0584 32.7822 22.2758C31.7401 23.5253 30.2746 24.3477 28.6651 24.5861C27.0556 24.8245 25.4147 24.4624 24.0551 23.5686C22.6955 22.6748 21.7123 21.312 21.293 19.7399C20.8737 18.1678 21.0476 16.4963 21.7815 15.0442' fill='white'/%3e%3cpath d='M24.7522 19.1675L24.966 21.3624L26.0832 19.4611L24.0618 20.3426L26.2153 20.8176' fill='%23EE1C25'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_2319_4410'%3e%3crect width='66' height='44' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

var img$7 = "data:image/svg+xml,%3csvg width='66' height='44' viewBox='0 0 66 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M22 44H1.13798C0.509565 44 0 43.4815 0 42.8421V1.15795C0 0.518505 0.509565 0 1.13798 0H22V44Z' fill='%23009246'/%3e%3cpath d='M44 0H22V44H44V0Z' fill='%23F5F5F5'/%3e%3cpath d='M64.862 44H44V0H64.862C65.4904 0 66 0.518507 66 1.15795V42.8422C66 43.4818 65.4904 44 64.862 44Z' fill='%23FF4B55'/%3e%3c/svg%3e";

var img$6 = "data:image/svg+xml,%3csvg width='66' height='44' viewBox='0 0 66 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M64.8619 44H1.13798C0.509565 44 0 43.4815 0 42.8421V1.15795C0 0.518504 0.509565 0 1.13798 0H64.862C65.4904 0 66 0.518504 66 1.15795V42.8421C65.9999 43.4816 65.4903 44 64.8619 44Z' fill='%23F5F5F5'/%3e%3cpath d='M33 34C39.6274 34 45 28.6274 45 22C45 15.3726 39.6274 10 33 10C26.3726 10 21 15.3726 21 22C21 28.6274 26.3726 34 33 34Z' fill='%23FF4B55'/%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3csvg width='66' height='44' viewBox='0 0 66 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M64.8619 44H1.13798C0.509565 44 0 43.4815 0 42.8421V1.15795C0 0.518504 0.509565 0 1.13798 0H64.862C65.4904 0 66 0.518504 66 1.15795V42.8421C65.9999 43.4816 65.4903 44 64.8619 44Z' fill='%23F5F5F5'/%3e%3cpath d='M39.3828 12.4291C34.0961 8.90637 26.9556 10.3466 23.4335 15.6216C21.6668 18.2546 22.3849 21.8323 25.0281 23.5937C27.6693 25.3552 31.2371 24.6398 32.9994 21.9976C34.7616 19.3555 38.3318 18.6491 40.9729 20.4012C43.6184 22.1627 44.3299 25.7404 42.5652 28.3734C46.0896 23.0894 44.665 15.952 39.3828 12.4291Z' fill='%23FF4B55'/%3e%3cpath d='M23.4333 15.6218C21.6666 18.2547 22.3848 21.8325 25.0279 23.5939C27.6691 25.3553 31.237 24.64 32.9992 21.9978C34.7614 19.3557 38.3316 18.6492 40.9727 20.4014C43.6182 22.1628 44.3297 25.7405 42.565 28.3735C39.0452 33.6668 31.907 35.089 26.6203 31.5661C21.3384 28.0435 19.9089 20.9061 23.4333 15.6218Z' fill='%2341479B'/%3e%3cpath d='M45.1719 8.21049L47.2501 11.3221C47.4246 11.5835 47.354 11.9365 47.0921 12.1112L46.5651 12.4627C46.3022 12.6381 45.9463 12.5676 45.7708 12.3052L43.69 9.19438C43.5149 8.93269 43.586 8.57908 43.8485 8.4044L44.3781 8.05221C44.6412 7.87728 44.9967 7.94816 45.1719 8.21049Z' fill='%23464655'/%3e%3cpath d='M48.3784 13.008L50.4633 16.1177C50.6393 16.3803 50.5674 16.7356 50.303 16.9096L49.7737 17.2581C49.5111 17.4311 49.1576 17.36 48.9827 17.0993L46.899 13.9928C46.7235 13.7313 46.794 13.3774 47.0567 13.2025L47.5847 12.8508C47.8474 12.6759 48.2028 12.7462 48.3784 13.008Z' fill='%23464655'/%3e%3cpath d='M47.3973 6.73123L52.6888 14.6417C52.864 14.9035 52.7929 15.2573 52.5301 15.4318L51.9984 15.7848C51.7356 15.9595 51.3804 15.8886 51.2051 15.6268L45.9118 7.71679C45.7364 7.45484 45.8077 7.10084 46.0708 6.92643L46.6041 6.57282C46.8671 6.39866 47.2221 6.46941 47.3973 6.73123Z' fill='%23464655'/%3e%3cpath d='M49.6163 5.25432L51.699 8.37201C51.8745 8.6346 51.8025 8.98912 51.5382 9.16302L51.0086 9.51159C50.7458 9.68459 50.3921 9.61346 50.2174 9.35228L48.1332 6.23872C47.9578 5.9769 48.029 5.62303 48.2918 5.44849L48.823 5.09578C49.0857 4.92111 49.4411 4.99198 49.6163 5.25432Z' fill='%23464655'/%3e%3cpath d='M52.8245 10.0619L54.904 13.1732C55.079 13.4347 55.0081 13.788 54.7459 13.9626L54.2178 14.3143C53.9548 14.4895 53.5989 14.4187 53.4237 14.1564L51.3442 11.0452C51.1694 10.7836 51.2402 10.4304 51.5023 10.2557L52.0305 9.90404C52.2933 9.72885 52.6492 9.79947 52.8245 10.0619Z' fill='%23464655'/%3e%3cpath d='M17.0228 26.9035L22.3136 34.8055C22.4889 35.0671 22.4181 35.4209 22.1553 35.5956L21.6255 35.948C21.3626 36.1228 21.0074 36.0522 20.8319 35.7902L15.541 27.8883C15.3658 27.6266 15.4366 27.2729 15.6994 27.0982L16.2292 26.7457C16.492 26.5709 16.8474 26.6417 17.0228 26.9035Z' fill='%23464655'/%3e%3cpath d='M14.8014 28.3816L16.8786 31.4853C17.0537 31.7469 16.9831 32.1 16.7209 32.2749L16.1939 32.6263C15.9312 32.8015 15.5756 32.7312 15.4 32.4692L13.3203 29.3662C13.1448 29.1046 13.2156 28.7507 13.4784 28.5759L14.0079 28.2237C14.2706 28.049 14.626 28.1196 14.8014 28.3816Z' fill='%23464655'/%3e%3cpath d='M18.0115 33.1808L20.0911 36.2924C20.2661 36.554 20.1952 36.9073 19.9327 37.0819L19.4042 37.4338C19.1413 37.6089 18.7858 37.5383 18.6103 37.2762L16.5294 34.1652C16.3543 33.9035 16.4253 33.5499 16.6878 33.3752L17.2176 33.0228C17.4807 32.8477 17.8362 32.9186 18.0115 33.1808Z' fill='%23464655'/%3e%3cpath d='M12.58 29.8591L17.8675 37.7615C18.0426 38.023 17.9717 38.3765 17.7095 38.5513L17.1811 38.9032C16.9183 39.0783 16.5628 39.0078 16.3873 38.7457L11.0967 30.8444C10.9213 30.5826 10.9925 30.2287 11.2553 30.0541L11.7869 29.7011C12.0495 29.5266 12.4047 29.5973 12.58 29.8591Z' fill='%23464655'/%3e%3cpath d='M15.5418 16.1183L20.8319 8.20989C21.0073 7.94781 21.3626 7.87706 21.6256 8.05186L22.1553 8.40418C22.418 8.57886 22.4887 8.9326 22.3136 9.19429L17.0215 17.0983C16.8465 17.3595 16.4926 17.4305 16.2299 17.2572L15.7023 16.9093C15.4381 16.7353 15.3663 16.3806 15.5418 16.1183Z' fill='%23464655'/%3e%3cpath d='M13.3195 14.6422L18.6105 6.73228C18.7858 6.4702 19.1415 6.39946 19.4044 6.57452L19.9328 6.92645C20.1951 7.10113 20.2659 7.45435 20.0909 7.71604L14.8013 15.6264C14.626 15.8885 14.2706 15.9593 14.0077 15.7844L13.4778 15.4321C13.2153 15.2575 13.1444 14.9039 13.3195 14.6422Z' fill='%23464655'/%3e%3cpath d='M11.0958 13.1732L16.3874 5.25532C16.5627 4.99311 16.9185 4.92224 17.1814 5.0973L17.7098 5.44923C17.9721 5.62391 18.0429 5.97687 17.8682 6.23856L12.5799 14.1576C12.4048 14.4198 12.0493 14.4908 11.7864 14.3161L11.2547 13.9631C10.992 13.7886 10.921 13.435 11.0958 13.1732Z' fill='%23464655'/%3e%3cpath d='M43.6909 34.8054L45.7706 31.7024C45.9462 31.4405 46.3018 31.3701 46.5645 31.5453L47.0915 31.8969C47.3537 32.0717 47.4242 32.4249 47.2492 32.6865L45.172 35.7901C44.9966 36.052 44.6413 36.1228 44.3784 35.948L43.8489 35.5958C43.5862 35.421 43.5154 35.0672 43.6909 34.8054Z' fill='%23464655'/%3e%3cpath d='M46.8986 30.0224L48.9817 26.9041C49.1569 26.642 49.5123 26.571 49.7752 26.7457L50.3061 27.0981C50.569 27.2728 50.64 27.6269 50.4646 27.8887L48.3771 31.0022C48.202 31.2633 47.848 31.3341 47.5853 31.1606L47.0589 30.813C46.7951 30.6389 46.7233 30.2846 46.8986 30.0224Z' fill='%23464655'/%3e%3cpath d='M45.9117 36.2912L47.9927 33.1801C48.168 32.9182 48.5232 32.8473 48.7862 33.0219L49.318 33.3753C49.5807 33.5498 49.6518 33.9033 49.4768 34.1653L47.3971 37.2766C47.222 37.5386 46.867 37.6096 46.6039 37.4352L46.0706 37.0816C45.8078 36.9072 45.7365 36.5532 45.9117 36.2912Z' fill='%23464655'/%3e%3cpath d='M49.1227 31.4841L51.2048 28.3803C51.3803 28.1188 51.7352 28.0484 51.9979 28.2228L52.5295 28.5757C52.7925 28.7504 52.8635 29.1045 52.6877 29.3664L50.6057 32.4702C50.4303 32.7317 50.0754 32.8022 49.8128 32.6277L49.281 32.2748C49.0178 32.1004 48.9469 31.7461 49.1227 31.4841Z' fill='%23464655'/%3e%3cpath d='M48.1337 37.7608L50.217 34.6551C50.392 34.3945 50.7454 34.3235 51.008 34.4963L51.5375 34.8449C51.8018 35.0189 51.8738 35.3738 51.6981 35.6364L49.6163 38.7462C49.4411 39.0081 49.0858 39.0787 48.823 38.9043L48.2918 38.5516C48.0288 38.3768 47.9579 38.0226 48.1337 37.7608Z' fill='%23464655'/%3e%3cpath d='M51.3455 32.9696L53.4237 29.8601C53.599 29.5979 53.9548 29.5271 54.2177 29.7023L54.7455 30.0537C55.0079 30.2285 55.0786 30.5821 54.9033 30.8436L52.8234 33.9489C52.6485 34.2102 52.2942 34.2811 52.0315 34.1076L51.5053 33.7603C51.2418 33.5863 51.1701 33.2319 51.3455 32.9696Z' fill='%23464655'/%3e%3c/svg%3e";

var img$4 = "data:image/svg+xml,%3csvg width='66' height='44' viewBox='0 0 66 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M0 22.0038L66 22.0038V42.2634C66 43.2224 65.4904 44 64.862 44L1.13799 44C0.509567 44 0 43.2224 0 42.2634V22.0038Z' fill='%23D80027'/%3e%3cpath d='M1.13799 0L64.862 0C65.4904 0 66 0.777893 66 1.73722V22.0038L0 22.0038V1.73722C0 0.777695 0.509567 0 1.13799 0Z' fill='%23F5F5F5'/%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 23.0.6%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 66 44' style='enable-background:new 0 0 66 44%3b' xml:space='preserve' class='flag-spain'%3e%3cstyle type='text/css'%3e .flag-spain-st0%7bfill:%23C8414B%3b%7d .flag-spain-st1%7bfill:%23FFD250%3b%7d .flag-spain-st2%7bfill:%23F5F5F5%3b%7d .flag-spain-st3%7bfill:%23FAB446%3b%7d .flag-spain-st4%7bfill:%23FFB441%3b%7d .flag-spain-st5%7bfill:%235064AA%3b%7d .flag-spain-st6%7bfill:%23FFA0D2%3b%7d%3c/style%3e%3cg%3e %3cpath class='flag-spain-st0' d='M1.1%2c44h63.7c0.6%2c0%2c1.1-0.5%2c1.1-1.2V1.2C66%2c0.5%2c65.5%2c0%2c64.9%2c0H1.1C0.5%2c0%2c0%2c0.5%2c0%2c1.2v41.7 C0%2c43.5%2c0.5%2c44%2c1.1%2c44z'/%3e %3crect y='9.3' class='flag-spain-st1' width='66' height='25.5'/%3e %3cpath class='flag-spain-st0' d='M27.9%2c22l1-4.4c0.1-0.4-0.2-0.8-0.6-0.8h-0.7c-0.4%2c0-0.7%2c0.4-0.6%2c0.8L27.9%2c22z'/%3e %3crect x='26.7' y='19.7' class='flag-spain-st2' width='2.3' height='9.8'/%3e %3crect x='26.2' y='18.5' class='flag-spain-st3' width='3.4' height='1.2'/%3e %3cg%3e %3crect x='23.9' y='22' class='flag-spain-st0' width='5.7' height='1.2'/%3e %3cpolygon class='flag-spain-st0' points='29.6%2c26.6 26.2%2c25.5 26.2%2c24.3 29.6%2c25.5 '/%3e %3cpath class='flag-spain-st0' d='M10.8%2c22l1-4.4c0.1-0.4-0.2-0.8-0.6-0.8h-0.7c-0.4%2c0-0.7%2c0.4-0.6%2c0.8L10.8%2c22z'/%3e %3c/g%3e %3cpath class='flag-spain-st2' d='M14.8%2c18.5c-0.6%2c0-1.1%2c0.5-1.1%2c1.2v7.5c0%2c1.4%2c1.3%2c4.1%2c5.7%2c4.1s5.7-2.6%2c5.7-4.1v-7.5c0-0.6-0.5-1.2-1.1-1.2 H14.8z'/%3e %3cg%3e %3cpath class='flag-spain-st0' d='M19.3%2c24.3h-5.7v-4.6c0-0.6%2c0.5-1.2%2c1.1-1.2h4.6V24.3z'/%3e %3cpath class='flag-spain-st0' d='M19.3%2c24.3H25v2.9c0%2c1.6-1.3%2c2.9-2.8%2c2.9l0%2c0c-1.6%2c0-2.8-1.3-2.8-2.9V24.3z'/%3e %3c/g%3e %3cpath class='flag-spain-st3' d='M13.7%2c24.3h5.7v2.9c0%2c1.6-1.3%2c2.9-2.8%2c2.9l0%2c0c-1.6%2c0-2.8-1.3-2.8-2.9V24.3z'/%3e %3cg%3e %3cpath class='flag-spain-st0' d='M18.2%2c29.5v-5.2h-1.1V30C17.5%2c30%2c17.9%2c29.8%2c18.2%2c29.5z'/%3e %3cpath class='flag-spain-st0' d='M15.9%2c30v-5.7h-1.1v5.2C15.1%2c29.8%2c15.5%2c30%2c15.9%2c30z'/%3e %3c/g%3e %3crect x='14.8' y='22' class='flag-spain-st4' width='3.4' height='1.2'/%3e %3cg%3e %3crect x='14.8' y='19.7' class='flag-spain-st3' width='3.4' height='1.2'/%3e %3crect x='15.4' y='20.4' class='flag-spain-st3' width='2.3' height='2.1'/%3e %3c/g%3e %3crect x='9.7' y='19.7' class='flag-spain-st2' width='2.3' height='9.8'/%3e %3cg%3e %3crect x='9.1' y='28.9' class='flag-spain-st3' width='3.4' height='1.2'/%3e %3crect x='9.1' y='18.5' class='flag-spain-st3' width='3.4' height='1.2'/%3e %3c/g%3e %3crect x='8.5' y='30.1' class='flag-spain-st5' width='4.6' height='1.2'/%3e %3crect x='26.7' y='28.9' class='flag-spain-st3' width='3.4' height='1.2'/%3e %3crect x='25.6' y='30.1' class='flag-spain-st5' width='4.6' height='1.2'/%3e %3crect x='15.9' y='17.4' class='flag-spain-st3' width='6.8' height='1.2'/%3e %3crect x='18.8' y='13.9' class='flag-spain-st4' width='1.1' height='3.5'/%3e %3cg%3e %3cpath class='flag-spain-st2' d='M18.2%2c15.6c-0.9%2c0-1.7-0.8-1.7-1.7c0-1%2c0.8-1.7%2c1.7-1.7c0.9%2c0%2c1.7%2c0.8%2c1.7%2c1.7C19.9%2c14.9%2c19.1%2c15.6%2c18.2%2c15.6 z M18.2%2c13.3c-0.3%2c0-0.6%2c0.3-0.6%2c0.6c0%2c0.3%2c0.3%2c0.6%2c0.6%2c0.6c0.3%2c0%2c0.6-0.3%2c0.6-0.6C18.8%2c13.6%2c18.5%2c13.3%2c18.2%2c13.3z'/%3e %3cpath class='flag-spain-st2' d='M20.5%2c15.6c-0.9%2c0-1.7-0.8-1.7-1.7c0-1%2c0.8-1.7%2c1.7-1.7c0.9%2c0%2c1.7%2c0.8%2c1.7%2c1.7S21.4%2c15.6%2c20.5%2c15.6z M20.5%2c13.3c-0.3%2c0-0.6%2c0.3-0.6%2c0.6c0%2c0.3%2c0.3%2c0.6%2c0.6%2c0.6c0.3%2c0%2c0.6-0.3%2c0.6-0.6C21.1%2c13.6%2c20.8%2c13.3%2c20.5%2c13.3z'/%3e %3cpath class='flag-spain-st2' d='M22.8%2c16.8c-0.9%2c0-1.7-0.8-1.7-1.7c0-1%2c0.8-1.7%2c1.7-1.7c0.9%2c0%2c1.7%2c0.8%2c1.7%2c1.7S23.7%2c16.8%2c22.8%2c16.8z M22.8%2c14.5c-0.3%2c0-0.6%2c0.3-0.6%2c0.6c0%2c0.3%2c0.3%2c0.6%2c0.6%2c0.6c0.3%2c0%2c0.6-0.3%2c0.6-0.6C23.3%2c14.7%2c23.1%2c14.5%2c22.8%2c14.5z'/%3e %3cpath class='flag-spain-st2' d='M15.9%2c16.8c-0.9%2c0-1.7-0.8-1.7-1.7c0-1%2c0.8-1.7%2c1.7-1.7c0.9%2c0%2c1.7%2c0.8%2c1.7%2c1.7C17.6%2c16%2c16.9%2c16.8%2c15.9%2c16.8z M15.9%2c14.5c-0.3%2c0-0.6%2c0.3-0.6%2c0.6c0%2c0.3%2c0.3%2c0.6%2c0.6%2c0.6c0.3%2c0%2c0.6-0.3%2c0.6-0.6C16.5%2c14.7%2c16.2%2c14.5%2c15.9%2c14.5z'/%3e %3c/g%3e %3cpath class='flag-spain-st3' d='M22.8%2c26.6v0.6c0%2c0.3-0.3%2c0.6-0.6%2c0.6c-0.3%2c0-0.6-0.3-0.6-0.6v-0.6H22.8 M23.9%2c25.5h-3.4v1.7 c0%2c1%2c0.8%2c1.7%2c1.7%2c1.7c0.9%2c0%2c1.7-0.8%2c1.7-1.7L23.9%2c25.5L23.9%2c25.5z'/%3e %3cpath class='flag-spain-st6' d='M22.2%2c23.2L22.2%2c23.2c-0.6%2c0-1.1-0.5-1.1-1.2v-1.2c0-0.6%2c0.5-1.2%2c1.1-1.2l0%2c0c0.6%2c0%2c1.1%2c0.5%2c1.1%2c1.2V22 C23.3%2c22.6%2c22.8%2c23.2%2c22.2%2c23.2z'/%3e %3cellipse class='flag-spain-st5' cx='19.3' cy='24.3' rx='1.7' ry='1.7'/%3e %3crect x='18.8' y='11.6' class='flag-spain-st3' width='1.1' height='3.5'/%3e %3cpath class='flag-spain-st0' d='M15.9%2c17.4l-1.1-1.2l0.7-0.7c1-1%2c2.4-1.6%2c3.9-1.6l0%2c0c1.5%2c0%2c2.9%2c0.6%2c3.9%2c1.6l0.7%2c0.7l-1.1%2c1.2H15.9z'/%3e %3cg%3e %3cellipse class='flag-spain-st1' cx='19.3' cy='16.2' rx='0.6' ry='0.6'/%3e %3cellipse class='flag-spain-st1' cx='17.1' cy='16.2' rx='0.6' ry='0.6'/%3e %3cellipse class='flag-spain-st1' cx='21.6' cy='16.2' rx='0.6' ry='0.6'/%3e %3c/g%3e %3cg%3e %3crect x='9.1' y='22' class='flag-spain-st0' width='5.7' height='1.2'/%3e %3cpolygon class='flag-spain-st0' points='9.1%2c26.6 12.5%2c25.5 12.5%2c24.3 9.1%2c25.5 '/%3e %3c/g%3e%3c/g%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3csvg width='66' height='44' viewBox='0 0 66 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M64.8569 44H1.14309C0.503505 44 0 43.4738 0 42.837V1.17679C0 0.526066 0.517114 0.0137939 1.14309 0.0137939H64.8433C65.4829 0.0137939 65.9864 0.539911 65.9864 1.17679V42.837C66 43.4738 65.4829 44 64.8569 44Z' fill='%23F5F5F5'/%3e%3cpath d='M64.8569 44H1.14309C0.503505 44 0 43.4739 0 42.837V37.0636H66V42.837C66 43.4739 65.4829 44 64.8569 44Z' fill='%23FF4B55'/%3e%3cpath d='M1.14309 0H64.8433C65.4829 0 65.9864 0.526117 65.9864 1.163V6.93644H0V1.17684C0 0.526117 0.517114 0 1.14309 0Z' fill='%23FF4B55'/%3e%3cpath d='M66 13.9005H0V30.1132H66V13.9005Z' fill='%2341479B'/%3e%3c/svg%3e";

var img$1 = "data:image/svg+xml,%3csvg width='66' height='44' viewBox='0 0 66 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M64.8619 44H1.13798C0.509565 44 0 43.4815 0 42.8421V1.15795C0 0.518504 0.509565 0 1.13798 0H64.862C65.4904 0 66 0.518504 66 1.15795V42.8421C65.9999 43.4816 65.4903 44 64.8619 44Z' fill='%23FF4B55'/%3e%3cpath d='M34.9478 17.8882L36.7955 20.3488L39.6806 19.3657C39.842 19.3107 39.9792 19.4965 39.8825 19.6391L38.1546 22.1883L39.9647 24.6778C40.0659 24.817 39.9348 25.0073 39.7718 24.9578L36.8562 24.0727L35.0897 26.5944C34.9909 26.7354 34.7727 26.6673 34.7686 26.4941L34.6945 23.3979L31.7928 22.4669C31.6306 22.4149 31.6267 22.1825 31.7872 22.125L34.657 21.0965L34.6301 17.9994C34.6285 17.8261 34.8444 17.7507 34.9478 17.8882Z' fill='%23F5F5F5'/%3e%3cpath d='M24.73 31.6056C19.523 31.6056 15.2989 27.3055 15.2989 21.9999C15.2989 16.704 19.523 12.3943 24.73 12.3943C26.6673 12.3943 28.454 13.0009 29.9427 14.0275C30.1708 14.1847 30.431 13.8797 30.24 13.6777C28.0149 11.3225 24.8654 9.88583 21.3737 10.0071C15.3745 10.2155 10.4081 15.1119 10.0249 21.2102C9.58578 28.1952 15.0188 34 21.7831 34C25.1152 34 28.1097 32.5819 30.2483 30.3146C30.4373 30.1143 30.1764 29.8139 29.9506 29.9697C28.4602 30.9983 26.6707 31.6056 24.73 31.6056Z' fill='%23F5F5F5'/%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 23.0.6%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 66 44' style='enable-background:new 0 0 66 44%3b' xml:space='preserve' class='flag-uk'%3e%3cstyle type='text/css'%3e .flag-uk-st0%7bfill:%2341479B%3b%7d .flag-uk-st1%7bfill:%23F5F5F5%3b%7d .flag-uk-st2%7bfill:%23FF4B55%3b%7d%3c/style%3e%3cg%3e %3cpath class='flag-uk-st0' d='M64.9%2c44H1.1C0.5%2c44%2c0%2c43.5%2c0%2c42.8V1.2C0%2c0.5%2c0.5%2c0%2c1.1%2c0h63.7C65.5%2c0%2c66%2c0.5%2c66%2c1.2v41.7 C66%2c43.5%2c65.5%2c44%2c64.9%2c44z'/%3e %3cpath class='flag-uk-st1' d='M66%2c1.2C66%2c0.5%2c65.5%2c0%2c64.9%2c0h-5.1L38.7%2c14.1V0H27.3v14.1L6.2%2c0H1.1C0.5%2c0%2c0%2c0.5%2c0%2c1.2v3l18.1%2c12.1H0v11.6 h18.1L0%2c39.8v3C0%2c43.5%2c0.5%2c44%2c1.1%2c44h5.1l21.1-14.1V44h11.4V29.9L59.8%2c44h5.1c0.6%2c0%2c1.1-0.5%2c1.1-1.2v-3L47.9%2c27.8H66V16.2H47.9 L66%2c4.2V1.2z'/%3e %3cg%3e %3cpolygon class='flag-uk-st2' points='66%2c18.5 36.4%2c18.5 36.4%2c0 29.6%2c0 29.6%2c18.5 0%2c18.5 0%2c25.5 29.6%2c25.5 29.6%2c44 36.4%2c44 36.4%2c25.5 66%2c25.5 '/%3e %3cpath class='flag-uk-st2' d='M23.1%2c27.8L0%2c43c0.1%2c0.6%2c0.5%2c1%2c1.1%2c1h1.6l24.5-16.2L23.1%2c27.8L23.1%2c27.8z'/%3e %3cpath class='flag-uk-st2' d='M44.7%2c27.8h-4.2L65%2c44c0.6-0.1%2c1-0.5%2c1-1.1v-1L44.7%2c27.8z'/%3e %3cpath class='flag-uk-st2' d='M0%2c2.4l20.9%2c13.8H25L0.7%2c0.1C0.3%2c0.3%2c0%2c0.7%2c0%2c1.2V2.4z'/%3e %3cpath class='flag-uk-st2' d='M42.9%2c16.2L66%2c1c-0.1-0.5-0.5-1-1.1-1h-1.6L38.7%2c16.2H42.9z'/%3e %3c/g%3e%3c/g%3e%3c/svg%3e";

const flags = {
    [Languages.nl]: img$b,
    [Languages.fr]: img$a,
    [Languages.de]: img$9,
    [Languages.es]: img$3,
    [Languages.en]: img,
    [Languages.zhHans]: img$c,
    [Languages.zhHant]: img$8,
    [Languages.ko]: img$5,
    [Languages.pl]: img$4,
    [Languages.ja]: img$6,
    [Languages.tr]: img$1,
    [Languages.th]: img$2,
    [Languages.it]: img$7,
};

var css_248z$6 = ".language-flag-component .icon-svg-element {\n  overflow: hidden;\n  border-radius: 3%;\n}";
styleInject(css_248z$6);

const LanguageFlag = ({ value, className, dataTestSelector, onClick, }) => {
    const flagImg = useMemo(() => {
        return flags[value.toLowerCase()];
    }, [value]);
    if (!flagImg)
        return null;
    return (jsx("div", Object.assign({ "data-test-selector": dataTestSelector, className: classNames(className, 'language-flag-component'), onClick: onClick }, { children: jsx(ReactSVG, { src: flagImg, className: classNames('icon-svg-element') }, void 0) }), void 0));
};

var css_248z$5 = ".language-button-group-wrapper .language-option {\n  max-width: 66px;\n  height: 44px;\n  overflow: hidden;\n  cursor: pointer;\n}\n.language-button-group-wrapper .language-option-selected {\n  opacity: 0.5;\n}\n.language-button-group-wrapper .language-button-group-title {\n  color: var(--gray-color-1);\n}";
styleInject(css_248z$5);

const LanguageButtonGroup = ({ className, dataTestSelector, currentLanguageCode, languageOptions, onLanguageSelect, }) => {
    const { t } = useTranslation('LanguageButtonGroup');
    const [selectedLanguage, setSelectedLanguage] = useState(currentLanguageCode);
    useEffect(() => {
        if (currentLanguageCode !== selectedLanguage) {
            setSelectedLanguage(currentLanguageCode);
        }
    }, [currentLanguageCode]);
    useEffect(() => {
        if (currentLanguageCode !== selectedLanguage) {
            onLanguageSelect === null || onLanguageSelect === void 0 ? void 0 : onLanguageSelect(selectedLanguage);
        }
    }, [selectedLanguage]);
    return (jsxs(Box, Object.assign({ className: classNames('language-button-group-wrapper', className), dataTestSelector: dataTestSelector }, { children: [jsxs(Text, Object.assign({ size: TextSize.xs, className: "spacing-bottom-sm language-button-group-title" }, { children: [t('TITLE'), ":"] }), void 0), jsx(Flex, Object.assign({ className: "gap-sm", wrapped: true }, { children: languageOptions.map((option) => (jsx(LanguageFlag, { dataTestSelector: `language-option-${option}`, onClick: () => setSelectedLanguage(option), value: option, className: classNames('language-option', {
                        'language-option-selected': option === selectedLanguage,
                    }) }, `language-option-${option}`))) }), void 0)] }), void 0));
};

var css_248z$4 = ".language-option-label {\n  display: flex;\n  gap: var(--spacing-lg);\n  align-items: center;\n}\n.language-option-label .language-option-flag {\n  width: 34px;\n}";
styleInject(css_248z$4);

const LanguageOption = ({ onClick, dataTestSelector, value, title, isChecked, }) => {
    const onRadioClick = useCallback(() => {
        onClick(value);
    }, [onClick, value]);
    return (jsx(RadioButton, { dataTestSelector: dataTestSelector, name: "language-radio-selector", checked: isChecked, onChange: onRadioClick, label: jsxs("div", Object.assign({ className: "padding-left-md language-option-label" }, { children: [jsx(LanguageFlag, { className: "language-option-flag", value: value }, void 0), jsx(Text, Object.assign({ size: TextSize.sm }, { children: title }), void 0)] }), void 0) }, void 0));
};

var css_248z$3 = ".language-selector .language-selector-wrapper {\n  display: flex;\n  gap: var(--spacing-xs);\n  align-items: center;\n  cursor: pointer;\n}\n.language-selector .language-selector-dropdown-flag {\n  width: 32px;\n  background-color: currentColor;\n  border: 1px solid currentColor;\n  border-radius: 2px;\n}\n.language-selector .language-selector-dropdown-icon {\n  width: 24px;\n  height: 24px;\n}\n.language-selector .language-selector-title {\n  align-self: center;\n}\n.language-selector .language-selector-body {\n  margin: var(--spacing-lg) 0;\n  overflow: auto;\n}\n.language-selector .language-selector-buttons {\n  display: flex;\n  justify-content: space-between;\n}";
styleInject(css_248z$3);

const LanguageSelector = ({ className, dataTestSelector, currentLanguageCode, languageOptions, onLanguageSelect, }) => {
    const { t } = useTranslation('LanguageSelector');
    const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState(currentLanguageCode);
    const [confirmedLanguage, setConfirmedLanguage] = useState(currentLanguageCode);
    const handleDropdownClick = () => {
        setIsLanguageModalOpen(true);
    };
    const handleCancelModal = () => {
        setSelectedLanguage(confirmedLanguage);
        setIsLanguageModalOpen(false);
    };
    const handleSelectClick = () => {
        if (selectedLanguage && selectedLanguage !== confirmedLanguage) {
            onLanguageSelect === null || onLanguageSelect === void 0 ? void 0 : onLanguageSelect(selectedLanguage);
            setConfirmedLanguage(selectedLanguage);
        }
        setIsLanguageModalOpen(false);
    };
    const handleOptionClick = (lng) => {
        setSelectedLanguage(lng);
    };
    useEffect(() => {
        setSelectedLanguage(currentLanguageCode);
        setConfirmedLanguage(currentLanguageCode);
    }, [currentLanguageCode]);
    return (jsxs("div", Object.assign({ "data-test-selector": dataTestSelector, className: classNames(className, 'language-selector') }, { children: [jsxs("div", Object.assign({ "data-test-selector": "language-selector-dropdown", className: "language-selector-wrapper", onClick: handleDropdownClick }, { children: [jsx(LanguageFlag, { dataTestSelector: "language-selector-dropdown-flag", value: confirmedLanguage, className: "language-selector-dropdown-flag" }, void 0), jsx(Icon, { dataTestSelector: "language-selector-dropdown-icon", type: IconTypes.arrow, className: "language-selector-dropdown-icon" }, void 0)] }), void 0), isLanguageModalOpen && (jsxs(BasicModal, Object.assign({ dataTestSelector: "language-selector-modal", size: BasicModalSize.lg, onOverlayClick: handleCancelModal }, { children: [jsx(Text, Object.assign({ size: TextSize.lg, className: "language-selector-title" }, { children: t('TITLE') }), void 0), jsx("div", Object.assign({ className: "language-selector-body" }, { children: languageOptions.map((option) => (jsx(LanguageOption, { dataTestSelector: `language-option-${option.value}`, onClick: handleOptionClick, value: option.value, title: option.title, isChecked: option.value === selectedLanguage }, `language-option-${option.value}`))) }), void 0), jsxs("div", Object.assign({ className: "language-selector-buttons" }, { children: [jsx(Button, Object.assign({ dataTestSelector: "language-selector-cancel-button", pattern: ButtonPattern.secondary, onClick: handleCancelModal }, { children: t('CANCEL') }), void 0), jsx(Button, Object.assign({ dataTestSelector: "language-selector-submit-button", onClick: handleSelectClick }, { children: t('SELECT') }), void 0)] }), void 0)] }), void 0))] }), void 0));
};

var css_248z$2 = ".large-button-component {\n  width: 240px;\n  height: 106px;\n  padding: var(--spacing-md) var(--spacing-xlg);\n}\n.large-button-component .button-component-icon {\n  min-width: 44px;\n  height: 44px;\n  min-height: 44px;\n}\n.large-button-component .button-text-content {\n  margin: auto;\n  white-space: normal;\n}\n.large-button-component.large-button-component-with-icon-top {\n  flex-direction: column;\n  justify-content: space-around;\n  width: 228px;\n  height: 118px;\n}\n.large-button-component.large-button-component-with-icon-top .button-component-icon {\n  margin: var(--spacing-xs) 0;\n}";
styleInject(css_248z$2);

var LargeButtonIconPosition;
(function (LargeButtonIconPosition) {
    LargeButtonIconPosition["top"] = "top";
    LargeButtonIconPosition["left"] = "left";
})(LargeButtonIconPosition || (LargeButtonIconPosition = {}));
const LargeButton = (_a) => {
    var { className, iconPosition = LargeButtonIconPosition.left } = _a, restProps = __rest(_a, ["className", "iconPosition"]);
    return (jsx(Button, Object.assign({}, restProps, { className: classNames('large-button-component', `large-button-component-with-icon-${iconPosition}`, className) }), void 0));
};

var css_248z$1 = ".text-group-component {\n  display: flex;\n  flex-wrap: wrap;\n  word-break: break-word;\n}\n.text-group-component.text-group-direction-row {\n  flex-direction: row;\n}\n.text-group-component.text-group-direction-column {\n  flex-direction: column;\n}";
styleInject(css_248z$1);

var TextGroupDirection;
(function (TextGroupDirection) {
    TextGroupDirection["row"] = "row";
    TextGroupDirection["column"] = "column";
})(TextGroupDirection || (TextGroupDirection = {}));
const TextGroup = ({ direction = TextGroupDirection.row, size, label, value, dataTestSelector, className, }) => {
    return (jsxs("div", Object.assign({ "data-test-selector": dataTestSelector, className: classNames('text-group-component', `text-group-direction-${direction}`, className) }, { children: [jsxs(Text, Object.assign({ weight: TextWeight.light, className: "spacing-right-xs", size: size }, { children: [label, ":"] }), void 0), jsx(Text, Object.assign({ size: size }, { children: value }), void 0)] }), void 0));
};

var css_248z = ".validation-header-component {\n  display: flex;\n  align-items: center;\n}\n.validation-header-component .validation-header-component-icon {\n  width: 16px;\n  margin-right: var(--spacing-sm);\n}\n.validation-header-component .validation-header-component-valid {\n  fill: var(--success-state-color);\n}\n.validation-header-component .validation-header-component-invalid {\n  fill: var(--error-state-color);\n}";
styleInject(css_248z);

const ValidationHeader = ({ isValid, title, titleWeight = TextWeight.light, titleSize = TextSize.lg, className, dataTestSelector, }) => {
    return (jsxs("div", Object.assign({ "data-test-selector": dataTestSelector, className: classNames('validation-header-component', className) }, { children: [jsx(Icon, { className: classNames(isValid
                    ? 'validation-header-component-valid'
                    : 'validation-header-component-invalid', 'validation-header-component-icon'), type: isValid ? IconTypes.checkFilled : IconTypes.cancelFilled }, void 0), jsx(Text, Object.assign({ size: titleSize, weight: titleWeight }, { children: title }), void 0)] }), void 0));
};

var Color;
(function (Color) {
    Color["primary"] = "--primary-color";
    Color["white"] = "--white-color";
    Color["black"] = "--black-color";
    Color["gray1"] = "--gray-color-1";
    Color["gray2"] = "--gray-color-2";
    Color["gray3"] = "--gray-color-3";
    Color["success"] = "--success-state-color";
    Color["successDark"] = "--success-dark-state-color";
    Color["error"] = "--error-state-color";
    Color["warning"] = "--warning-state-color";
    Color["active"] = "--active-state-color";
})(Color || (Color = {}));

initI18nTranslations();

export { MagicButtonVerticalPosition as $, AlignItems as A, Body as B, Checkbox as C, DATE_PICKER_DATE_FORMAT as D, ErrorView as E, Field as F, Grid as G, Header as H, ConfirmModal as I, JustifyContent as J, ConnectionModal as K, LoadingView as L, DateTimePickerModal as M, ErrorModal as N, InactivityModal as O, LoadingModal as P, ConsoleSimulator as Q, RadioButton as R, SelectField as S, TIME_PICKER_TIME_FORMAT as T, ConsoleState as U, ValidationMessage as V, LogsModal as W, SortType as X, MagicButton as Y, MagicButtonHorizontalPosition as Z, _defineProperty$1 as _, CheckboxButtonLabelPosition as a, ServiceModal as a0, Badge as a1, Button as a2, ButtonIconPosition as a3, ButtonPattern as a4, Circular as a5, CircularType as a6, ExternalHTMLContent as a7, FormHeader as a8, Icon as a9, IconTypes as aa, LanguageButtonGroup as ab, LanguageSelector as ac, LargeButton as ad, LargeButtonIconPosition as ae, Link as af, LinkTarget as ag, Loader as ah, LoaderSizes as ai, Text as aj, TextSize as ak, TextWeight as al, TextGroup as am, TextGroupDirection as an, ValidationHeader as ao, Color as ap, TimeFormats as aq, ImageMimeTypes as ar, convertImageTo as as, KioskComponentsConfigurator as at, ThemeType as au, LogReporter as av, PDFCreator as aw, DatePickerField as b, commonjsGlobal as c, DATE_TIME_PICKER_DATE_FORMAT as d, DateTimePickerField as e, FieldMode as f, RadioButtonLabelPosition as g, SelectFieldType as h, SignatureField as i, TimePickerField as j, Box as k, lib as l, ExpandPanel as m, Flex as n, FlexDirection as o, Footer as p, GridFlow as q, GridPlace as r, Section as s, SectionType as t, Separator as u, Table as v, TestEnvironmentBar as w, View as x, BasicModal as y, BasicModalSize as z };
//# sourceMappingURL=index-4d8edbcd.js.map
